export const cities = [
  { city: 'Bucureşti Sector 1', zip: '11055041' },
  { city: 'Bucureşti Sector 2', zip: '11055044' },
  { city: 'Bucureşti Sector 3', zip: '11055044' },
  { city: 'Bucureşti Sector 4', zip: '11055042' },
  { city: 'Bucureşti Sector 5', zip: '11055043' },
  { city: 'Bucureşti Sector 6', zip: '11055039' },
  { city: 'Bărăbanţ (Alba)', zip: '510001' },
  { city: 'Miceşti (Alba)', zip: '510002' },
  { city: 'Alba Iulia (Alba)', zip: '510002' },
  { city: 'Oarda (Alba)', zip: '510003' },
  { city: 'Pâclişa (Alba)', zip: '510004' },
  { city: 'Abrud (Alba)', zip: '515100' },
  { city: 'Abrud-Sat (Alba)', zip: '515101' },
  { city: 'Gura Cornei (Alba)', zip: '515102' },
  { city: 'Soharu (Alba)', zip: '515103' },
  { city: 'Aiud (Alba)', zip: '515200' },
  { city: 'Aiudul de Sus (Alba)', zip: '515201' },
  { city: 'Ciumbrud (Alba)', zip: '515202' },
  { city: 'Gâmbaş (Alba)', zip: '515203' },
  { city: 'Gârbova de Jos (Alba)', zip: '515204' },
  { city: 'Gârbova de Sus (Alba)', zip: '515205' },
  { city: 'Gârboviţa (Alba)', zip: '515206' },
  { city: 'Măgina (Alba)', zip: '515207' },
  { city: 'Păgida (Alba)', zip: '515208' },
  { city: 'Sâncrai (Alba)', zip: '515209' },
  { city: 'Ţifra (Alba)', zip: '515210' },
  { city: 'Baia de Arieş (Alba)', zip: '515300' },
  { city: 'Brăzeşti (Alba)', zip: '515301' },
  { city: 'Cioara de Sus (Alba)', zip: '515302' },
  { city: 'Muncelu (Alba)', zip: '515303' },
  { city: 'Sartăş (Alba)', zip: '515304' },
  { city: 'Simuleşti (Alba)', zip: '515305' },
  { city: 'Blaj (Alba)', zip: '515400' },
  { city: 'Deleni-Obârşie (Alba)', zip: '515401' },
  { city: 'Fliteşti (Alba)', zip: '515402' },
  { city: 'Izvoarele (Blaj) (Alba)', zip: '515403' },
  { city: 'Mănărade (Alba)', zip: '515404' },
  { city: 'Petrisat (Alba)', zip: '515405' },
  { city: 'Spătac (Alba)', zip: '515406' },
  { city: 'Tiur (Alba)', zip: '515407' },
  { city: 'Veza (Alba)', zip: '515408' },
  { city: 'Câmpeni (Alba)', zip: '515500' },
  { city: 'Bonceşti (Alba)', zip: '515501' },
  { city: 'Borleşti (Alba)', zip: '515502' },
  { city: 'Boteşti (Câmpeni) (Alba)', zip: '515503' },
  { city: 'Certege (Alba)', zip: '515504' },
  { city: 'Coasta Vâscului (Alba)', zip: '515505' },
  { city: 'Dănduţ (Alba)', zip: '515506' },
  { city: 'Dealu Bistrii (Alba)', zip: '515507' },
  { city: 'Dealu Capsei (Alba)', zip: '515508' },
  { city: 'Dric (Alba)', zip: '515509' },
  { city: 'Faţa Abrudului (Alba)', zip: '515510' },
  { city: 'Floreşti (Câmpeni) (Alba)', zip: '515511' },
  { city: 'Furduieşti (Câmpeni) (Alba)', zip: '515512' },
  { city: 'Mihoeşti (Alba)', zip: '515513' },
  { city: 'Motorăşti (Alba)', zip: '515514' },
  { city: 'Peste Valea Bistrii (Alba)', zip: '515515' },
  { city: 'Poduri (Alba)', zip: '515516' },
  { city: 'Sorliţa (Alba)', zip: '515517' },
  { city: 'Tomuşeşti (Alba)', zip: '515518' },
  { city: 'Valea Bistrii (Alba)', zip: '515519' },
  { city: 'Valea Caselor (Alba)', zip: '515520' },
  { city: 'Vârşi (Alba)', zip: '515521' },
  { city: 'Cugir (Alba)', zip: '515600' },
  { city: 'Bocşitura (Alba)', zip: '515601' },
  { city: 'Bucuru (Alba)', zip: '515602' },
  { city: 'Călene (Alba)', zip: '515603' },
  { city: 'Feţeni (Alba)', zip: '515604' },
  { city: 'Goaşele (Alba)', zip: '515605' },
  { city: 'Mugeşti (Alba)', zip: '515606' },
  { city: 'Vinerea (Alba)', zip: '515607' },
  { city: 'Ocna Mureş (Alba)', zip: '515700' },
  { city: 'Cisteiu de Mureş (Alba)', zip: '515701' },
  { city: 'Micoşlaca (Alba)', zip: '515702' },
  { city: 'Războieni-Cetate (Alba)', zip: '515703' },
  { city: 'Uioara de Jos (Alba)', zip: '515704' },
  { city: 'Uioara de Sus (Alba)', zip: '515705' },
  { city: 'Sebeş (Alba)', zip: '515800' },
  { city: 'Lancrăm (Alba)', zip: '515801' },
  { city: 'Răhău (Alba)', zip: '515802' },
  { city: 'Petreşti (Alba)', zip: '515850' },
  { city: 'Teiuş (Alba)', zip: '515900' },
  { city: 'Beldiu (Alba)', zip: '515901' },
  { city: 'Căpud (Alba)', zip: '515902' },
  { city: 'Coşlariu Nou (Alba)', zip: '515903' },
  { city: 'Peţelca (Alba)', zip: '515904' },
  { city: 'Zlatna (Alba)', zip: '516100' },
  { city: 'Boteşti (Zlatna) (Alba)', zip: '516101' },
  { city: 'Budeni (Alba)', zip: '516102' },
  { city: 'Dealu Roatei (Alba)', zip: '516103' },
  { city: 'Dobrot (Alba)', zip: '516104' },
  { city: 'Dumbrava (Zlatna) (Alba)', zip: '516105' },
  { city: 'Feneş (Alba)', zip: '516106' },
  { city: 'Galaţi (Alba)', zip: '516107' },
  { city: 'Izvoru Ampoiului (Alba)', zip: '516108' },
  { city: 'Pătrângeni (Alba)', zip: '516109' },
  { city: 'Pârău Gruiului (Alba)', zip: '516110' },
  { city: 'Pirita (Alba)', zip: '516111' },
  { city: 'Podu lui Paul (Alba)', zip: '516112' },
  { city: 'Runc (Zlatna) (Alba)', zip: '516113' },
  { city: 'Ruşi (Alba)', zip: '516114' },
  { city: 'Suseni (Alba)', zip: '516115' },
  { city: 'Trâmpoiele (Alba)', zip: '516116' },
  { city: 'Valea Mică (Alba)', zip: '516117' },
  { city: 'Vâltori (Zlatna) (Alba)', zip: '516118' },
  { city: 'Albac (Alba)', zip: '517005' },
  { city: 'Bărăşti (Alba)', zip: '517006' },
  { city: 'Budăieşti (Alba)', zip: '517007' },
  { city: 'Cioneşti (Alba)', zip: '517008' },
  { city: 'Costeşti (Albac) (Alba)', zip: '517009' },
  { city: 'Dealu Lămăşoi (Alba)', zip: '517011' },
  { city: 'Deve (Alba)', zip: '517012' },
  { city: 'După Pleşe (Alba)', zip: '517013' },
  { city: 'Faţa (Alba)', zip: '517014' },
  { city: 'Pleşeşti (Alba)', zip: '517016' },
  { city: 'Potionci (Alba)', zip: '517017' },
  { city: 'Rogoz (Alba)', zip: '517018' },
  { city: 'Roşeşti (Alba)', zip: '517019' },
  { city: 'Ruseşti (Alba)', zip: '517021' },
  { city: 'Sohodol (Albac) (Alba)', zip: '517022' },
  { city: 'Tamboreşti (Alba)', zip: '517023' },
  { city: 'Almaşu Mare (Alba)', zip: '517030' },
  { city: 'Almaşu de Mijloc (Alba)', zip: '517031' },
  { city: 'Brădet (Alba)', zip: '517032' },
  { city: 'Cheile Cibului (Alba)', zip: '517033' },
  { city: 'Cib (Alba)', zip: '517034' },
  { city: 'Glod (Alba)', zip: '517036' },
  { city: 'Haneş Mină (Alba)', zip: '517037' },
  { city: 'Nădăştia (Alba)', zip: '517038' },
  { city: 'Arieşeni (Alba)', zip: '517040' },
  { city: 'Avrămeşti (Arieşeni) (Alba)', zip: '517041' },
  { city: 'Bubeşti (Alba)', zip: '517042' },
  { city: 'Casa de Piatră (Alba)', zip: '517043' },
  { city: 'Cobleş (Alba)', zip: '517044' },
  { city: 'Dealu Bajului (Alba)', zip: '517046' },
  { city: 'Faţa Cristesei (Alba)', zip: '517047' },
  { city: 'Faţa Lăpuşului (Alba)', zip: '517048' },
  { city: 'Galbena (Alba)', zip: '517049' },
  { city: 'Hodobana (Alba)', zip: '517051' },
  { city: 'Izlaz (Alba)', zip: '517052' },
  { city: 'Pănteşti (Alba)', zip: '517053' },
  { city: 'Pătrăhăiţeşti (Alba)', zip: '517054' },
  { city: 'Poieniţa (Arieşeni) (Alba)', zip: '517056' },
  { city: 'Raviceşti (Alba)', zip: '517057' },
  { city: 'Sturu (Alba)', zip: '517058' },
  { city: 'Ştei-Arieşeni (Alba)', zip: '517059' },
  { city: 'Vanvuceşti (Alba)', zip: '517061' },
  { city: 'Avram Iancu (Alba)', zip: '517065' },
  { city: 'Achimeţeşti (Alba)', zip: '517066' },
  { city: 'Avrămeşti (Avram Iancu) (Alba)', zip: '517067' },
  { city: 'Bădăi (Alba)', zip: '517068' },
  { city: 'Boldeşti (Alba)', zip: '517069' },
  { city: 'Călugăreşti (Alba)', zip: '517071' },
  { city: 'Căsoaia (Alba)', zip: '517072' },
  { city: 'Cândeşti (Alba)', zip: '517073' },
  { city: 'Cârăşti (Alba)', zip: '517074' },
  { city: 'Cârţuleşti (Alba)', zip: '517076' },
  { city: 'Coceşti (Alba)', zip: '517077' },
  { city: 'Cocoşeşti (Alba)', zip: '517078' },
  { city: 'Coroieşti (Alba)', zip: '517079' },
  { city: 'Dealu Crişului (Alba)', zip: '517081' },
  { city: 'Doleşti (Alba)', zip: '517082' },
  { city: 'Dumăceşti (Alba)', zip: '517083' },
  { city: 'Gojeieşti (Alba)', zip: '517084' },
  { city: 'Helereşti (Alba)', zip: '517086' },
  { city: 'Inceşti (Avram Iancu) (Alba)', zip: '517087' },
  { city: 'Jojei (Alba)', zip: '517088' },
  { city: 'Mărteşti (Alba)', zip: '517089' },
  { city: 'Orgeşti (Alba)', zip: '517091' },
  { city: 'Pătruţeşti (Alba)', zip: '517092' },
  { city: 'Plai (Avram Iancu) (Alba)', zip: '517093' },
  { city: 'Puşeleşti (Alba)', zip: '517094' },
  { city: 'Şoiceşti (Alba)', zip: '517096' },
  { city: 'Şterteşti (Alba)', zip: '517097' },
  { city: 'Târsa (Alba)', zip: '517098' },
  { city: 'Târsa-Plai (Alba)', zip: '517099' },
  { city: 'Valea Maciului (Alba)', zip: '517101' },
  { city: 'Valea Uţului (Alba)', zip: '517102' },
  { city: 'Verdeşti (Alba)', zip: '517103' },
  { city: 'Vidrişoara (Alba)', zip: '517104' },
  { city: 'Berghin (Alba)', zip: '517110' },
  { city: 'Ghirbom (Alba)', zip: '517111' },
  { city: 'Henig (Alba)', zip: '517112' },
  { city: 'Straja (Alba)', zip: '517113' },
  { city: 'Bistra (Alba)', zip: '517115' },
  { city: 'Aroneşti (Alba)', zip: '517116' },
  { city: 'Băleşti (Alba)', zip: '517117' },
  { city: 'Băleşti-Cătun (Alba)', zip: '517118' },
  { city: 'Bârleşti (Bistra) (Alba)', zip: '517119' },
  { city: 'Cheleteni (Alba)', zip: '517121' },
  { city: 'Ciuldeşti (Alba)', zip: '517122' },
  { city: 'Creţeşti (Alba)', zip: '517123' },
  { city: 'Dâmbureni (Alba)', zip: '517124' },
  { city: 'Dealu Muntelui (Alba)', zip: '517126' },
  { city: 'Durăşti (Alba)', zip: '517127' },
  { city: 'Găneşti (Alba)', zip: '517128' },
  { city: 'Gârde (Alba)', zip: '517129' },
  { city: 'Hodişeşti (Alba)', zip: '517131' },
  { city: 'Hudriceşti (Alba)', zip: '517132' },
  { city: 'Lipaia (Alba)', zip: '517133' },
  { city: 'Lunca Largă (Bistra) (Alba)', zip: '517134' },
  { city: 'Lunca Merilor (Alba)', zip: '517136' },
  { city: 'Mihăieşti (Alba)', zip: '517137' },
  { city: 'Nămaş (Alba)', zip: '517138' },
  { city: 'Novăceşti (Alba)', zip: '517139' },
  { city: 'Perjeşti (Alba)', zip: '517141' },
  { city: 'Poiana (Bistra) (Alba)', zip: '517142' },
  { city: 'Poiu (Alba)', zip: '517143' },
  { city: 'Rătitiş (Alba)', zip: '517144' },
  { city: 'Runcuri (Alba)', zip: '517146' },
  { city: 'Sălăgeşti (Alba)', zip: '517147' },
  { city: 'Ştefanca (Alba)', zip: '517148' },
  { city: 'Tolăceşti (Alba)', zip: '517149' },
  { city: 'Tomnatec (Alba)', zip: '517151' },
  { city: 'Trişoreşti (Alba)', zip: '517152' },
  { city: 'Ţărăneşti (Alba)', zip: '517153' },
  { city: 'Vârşi-Rontu (Alba)', zip: '517154' },
  { city: 'Vârşii Mari (Alba)', zip: '517156' },
  { city: 'Vârşii Mici (Alba)', zip: '517157' },
  { city: 'Blandiana (Alba)', zip: '517160' },
  { city: 'Acmariu (Alba)', zip: '517161' },
  { city: 'Ibru (Alba)', zip: '517162' },
  { city: 'Poieni (Blandiana) (Alba)', zip: '517163' },
  { city: 'Răcătău (Alba)', zip: '517164' },
  { city: 'Bucium (Alba)', zip: '517165' },
  { city: 'Angheleşti (Alba)', zip: '517166' },
  { city: 'Bisericani (Alba)', zip: '517167' },
  { city: 'Bucium-Sat (Alba)', zip: '517168' },
  { city: 'Cerbu (Alba)', zip: '517169' },
  { city: 'Ciuculeşti (Alba)', zip: '517171' },
  { city: 'Coleşeni (Alba)', zip: '517172' },
  { city: 'Dogăreşti (Alba)', zip: '517173' },
  { city: 'Fereşti (Alba)', zip: '517174' },
  { city: 'Floreşti (Bucium) (Alba)', zip: '517176' },
  { city: 'Gura Izbitei (Alba)', zip: '517177' },
  { city: 'Heleşti (Alba)', zip: '517178' },
  { city: 'Izbicioara (Alba)', zip: '517179' },
  { city: 'Izbita (Alba)', zip: '517181' },
  { city: 'Jurcuieşti (Alba)', zip: '517182' },
  { city: 'Lupuleşti (Alba)', zip: '517183' },
  { city: 'Măgura (Bucium) (Alba)', zip: '517184' },
  { city: 'Muntari (Alba)', zip: '517186' },
  { city: 'Petreni (Alba)', zip: '517187' },
  { city: 'Poiana (Bucium) (Alba)', zip: '517188' },
  { city: 'Poieni (Bucium) (Alba)', zip: '517189' },
  { city: 'Stâlnişoara (Alba)', zip: '517191' },
  { city: 'Valea Abruzel (Alba)', zip: '517192' },
  { city: 'Valea Albă (Alba)', zip: '517193' },
  { city: 'Valea Cerbului (Alba)', zip: '517194' },
  { city: 'Valea Negrilesii (Alba)', zip: '517196' },
  { city: 'Valea Poienii (Bucium) (Alba)', zip: '517197' },
  { city: 'Valea Şesii (Bucium) (Alba)', zip: '517198' },
  { city: 'Văleni (Bucium) (Alba)', zip: '517199' },
  { city: 'Vâlcea (Alba)', zip: '517201' },
  { city: 'Câlnic (Alba)', zip: '517205' },
  { city: 'Cut (Alba)', zip: '517206' },
  { city: 'Deal (Alba)', zip: '517207' },
  { city: 'Cenade (Alba)', zip: '517210' },
  { city: 'Capu Dealului (Alba)', zip: '517211' },
  { city: 'Gorgan (Alba)', zip: '517212' },
  { city: 'Cergău (Alba)', zip: '517215' },
  { city: 'Cergău Mare (Alba)', zip: '517216' },
  { city: 'Cergău Mic (Alba)', zip: '517217' },
  { city: 'Lupu (Alba)', zip: '517218' },
  { city: 'Ceru-Băcăinţi (Alba)', zip: '517220' },
  { city: 'Bolovăneşti (Alba)', zip: '517221' },
  { city: 'Bulbuc (Alba)', zip: '517222' },
  { city: 'Cucuta (Alba)', zip: '517223' },
  { city: 'Curpeni (Alba)', zip: '517224' },
  { city: 'Dumbrăviţa (Alba)', zip: '517226' },
  { city: 'Fântânele (Alba)', zip: '517227' },
  { city: 'Groşi (Alba)', zip: '517228' },
  { city: 'Valea Mare (Alba)', zip: '517229' },
  { city: 'Viezuri (Alba)', zip: '517231' },
  { city: 'Cetatea de Baltă (Alba)', zip: '517235' },
  { city: 'Crăciunelu de Sus (Alba)', zip: '517236' },
  { city: 'Sântămărie (Alba)', zip: '517237' },
  { city: 'Tătârlaua (Alba)', zip: '517238' },
  { city: 'Ciugud (Alba)', zip: '517240' },
  { city: 'Drâmbar (Alba)', zip: '517241' },
  { city: 'Limba (Alba)', zip: '517242' },
  { city: 'Hăpria (Alba)', zip: '517243' },
  { city: 'Şeuşa (Alba)', zip: '517244' },
  { city: 'Teleac (Alba)', zip: '517246' },
  { city: 'Ciuruleasa (Alba)', zip: '517250' },
  { city: 'Bidigeşti (Alba)', zip: '517251' },
  { city: 'Bodreşti (Alba)', zip: '517252' },
  { city: 'Bogleşti (Alba)', zip: '517253' },
  { city: 'Buninginea (Alba)', zip: '517254' },
  { city: 'Gheduleşti (Alba)', zip: '517256' },
  { city: 'Mătişeşti (Ciuruleasa) (Alba)', zip: '517257' },
  { city: 'Morăreşti (Ciuruleasa) (Alba)', zip: '517258' },
  { city: 'Vulcan (Alba)', zip: '517259' },
  { city: 'Crăciunelu de Jos (Alba)', zip: '517260' },
  { city: 'Bucerdea Grânoasă (Alba)', zip: '517261' },
  { city: 'Cornu (Alba)', zip: '517262' },
  { city: 'Pădure (Alba)', zip: '517263' },
  { city: 'Pânca (Alba)', zip: '517264' },
  { city: 'Cricău (Alba)', zip: '517265' },
  { city: 'Craiva (Alba)', zip: '517266' },
  { city: 'Tibru (Alba)', zip: '517267' },
  { city: 'Daia Română (Alba)', zip: '517270' },
  { city: 'Doştat (Alba)', zip: '517275' },
  { city: 'Boz (Alba)', zip: '517276' },
  { city: 'Dealu Doştatului (Alba)', zip: '517277' },
  { city: 'Fărău (Alba)', zip: '517280' },
  { city: 'Heria (Alba)', zip: '517281' },
  { city: 'Medveş (Alba)', zip: '517282' },
  { city: 'Sânbenedic (Alba)', zip: '517283' },
  { city: 'Şilea (Alba)', zip: '517284' },
  { city: 'Galda de Jos (Alba)', zip: '517285' },
  { city: 'Benic (Alba)', zip: '517286' },
  { city: 'Cetea (Alba)', zip: '517287' },
  { city: 'Galda de Sus (Alba)', zip: '517288' },
  { city: 'Lupşeni (Alba)', zip: '517289' },
  { city: 'Măgura (Galda de Jos) (Alba)', zip: '517291' },
  { city: 'Mesentea (Alba)', zip: '517292' },
  { city: 'Oiejdea (Alba)', zip: '517293' },
  { city: 'Poiana Galdei (Alba)', zip: '517294' },
  { city: 'Răicani (Alba)', zip: '517296' },
  { city: 'Zăgriş (Alba)', zip: '517297' },
  { city: 'Gârbova (Alba)', zip: '517305' },
  { city: 'Cărpiniş (Gârbova) (Alba)', zip: '517306' },
  { city: 'Reciu (Alba)', zip: '517307' },
  { city: 'Gârda de Sus (Alba)', zip: '517310' },
  { city: 'Biharia (Alba)', zip: '517311' },
  { city: 'Dealu Frumos (Gârda de Sus) (Alba)', zip: '517312' },
  { city: 'Dealu Ordâncuşii (Alba)', zip: '517313' },
  { city: 'Dobreşti (Alba)', zip: '517314' },
  { city: 'Gârda Seacă (Alba)', zip: '517316' },
  { city: 'Gheţari (Alba)', zip: '517317' },
  { city: 'Hănăşeşti (Gârda de Sus) (Alba)', zip: '517318' },
  { city: 'Huzăreşti (Alba)', zip: '517319' },
  { city: 'Izvoarele (Gârda de Sus) (Alba)', zip: '517321' },
  { city: 'Munună (Alba)', zip: '517322' },
  { city: 'Ocoale (Alba)', zip: '517323' },
  { city: 'Plai (Gârda de Sus) (Alba)', zip: '517324' },
  { city: 'Plişti (Alba)', zip: '517326' },
  { city: 'Scoarţa (Alba)', zip: '517327' },
  { city: 'Snide (Alba)', zip: '517328' },
  { city: 'Suceşti (Alba)', zip: '517329' },
  { city: 'Hopârta (Alba)', zip: '517335' },
  { city: 'Silivaş (Alba)', zip: '517336' },
  { city: 'Şpălnaca (Alba)', zip: '517337' },
  { city: 'Turdaş (Alba)', zip: '517338' },
  { city: 'Vama Seacă (Alba)', zip: '517339' },
  { city: 'Horea (Alba)', zip: '517340' },
  { city: 'Baba (Alba)', zip: '517341' },
  { city: 'Buteşti (Horea) (Alba)', zip: '517342' },
  { city: 'Dârleşti (Alba)', zip: '517343' },
  { city: 'Fericet (Alba)', zip: '517344' },
  { city: 'Giurgiuţ (Alba)', zip: '517346' },
  { city: 'Mănceşti (Alba)', zip: '517347' },
  { city: 'Mătişeşti (Horea) (Alba)', zip: '517348' },
  { city: 'Niculeşti (Alba)', zip: '517349' },
  { city: 'Pătruşeşti (Alba)', zip: '517351' },
  { city: 'Petreasa (Alba)', zip: '517352' },
  { city: 'Preluca (Alba)', zip: '517353' },
  { city: 'Teiu (Alba)', zip: '517354' },
  { city: 'Trifeşti (Horea) (Alba)', zip: '517356' },
  { city: 'Zânzeşti (Alba)', zip: '517357' },
  { city: 'Ighiu (Alba)', zip: '517360' },
  { city: 'Bucerdea Vinoasă (Alba)', zip: '517361' },
  { city: 'Ighiel (Alba)', zip: '517362' },
  { city: 'Şard (Alba)', zip: '517363' },
  { city: 'Ţelna (Alba)', zip: '517364' },
  { city: 'Întregalde (Alba)', zip: '517365' },
  { city: 'Dealu Geoagiului (Alba)', zip: '517366' },
  { city: 'Ghioncani (Alba)', zip: '517367' },
  { city: 'Ilieşti (Alba)', zip: '517368' },
  { city: 'Ivăniş (Alba)', zip: '517369' },
  { city: 'Mărineşti (Alba)', zip: '517371' },
  { city: 'Modoleşti (Întregalde) (Alba)', zip: '517372' },
  { city: 'Necrileşti (Alba)', zip: '517373' },
  { city: 'Popeşti (Alba)', zip: '517374' },
  { city: 'Sfârcea (Alba)', zip: '517376' },
  { city: 'Tecşeşti (Alba)', zip: '517377' },
  { city: 'Jidvei (Alba)', zip: '517385' },
  { city: 'Bălcaciu (Alba)', zip: '517386' },
  { city: 'Căpâlna de Jos (Alba)', zip: '517387' },
  { city: 'Feisa (Alba)', zip: '517388' },
  { city: 'Veseuş (Alba)', zip: '517389' },
  { city: 'Livezile (Alba)', zip: '517390' },
  { city: 'Izvoarele (Livezile) (Alba)', zip: '517391' },
  { city: 'Poiana Aiudului (Alba)', zip: '517392' },
  { city: 'Vălişoara (Alba)', zip: '517393' },
  { city: 'Lopadea Nouă (Alba)', zip: '517395' },
  { city: 'Asinip (Alba)', zip: '517396' },
  { city: 'Băgău (Alba)', zip: '517397' },
  { city: 'Beţa (Alba)', zip: '517398' },
  { city: 'Cicârd (Alba)', zip: '517399' },
  { city: 'Ciuguzel (Alba)', zip: '517401' },
  { city: 'Ocnişoara (Alba)', zip: '517402' },
  { city: 'Odverem (Alba)', zip: '517403' },
  { city: 'Lunca Mureşului (Alba)', zip: '517405' },
  { city: 'Gura Arieşului (Alba)', zip: '517406' },
  { city: 'Lupşa (Alba)', zip: '517410' },
  { city: 'Bârdeşti (Alba)', zip: '517411' },
  { city: 'Bârzan (Alba)', zip: '517412' },
  { city: 'Curmătură (Alba)', zip: '517413' },
  { city: 'După Deal (Lupşa) (Alba)', zip: '517414' },
  { city: 'Geamăna (Alba)', zip: '517416' },
  { city: 'Hădărău (Alba)', zip: '517417' },
  { city: 'Holobani (Alba)', zip: '517418' },
  { city: 'Lazuri (Lupşa) (Alba)', zip: '517419' },
  { city: 'Lunca (Lupşa) (Alba)', zip: '517421' },
  { city: 'Mănăstire (Alba)', zip: '517422' },
  { city: 'Mărgaia (Alba)', zip: '517423' },
  { city: 'Muşca (Alba)', zip: '517424' },
  { city: 'Pârâu-Cărbunări (Alba)', zip: '517426' },
  { city: 'Piţiga (Alba)', zip: '517427' },
  { city: 'Poşogani (Alba)', zip: '517428' },
  { city: 'Şasa (Alba)', zip: '517429' },
  { city: 'Trifeşti (Lupşa) (Alba)', zip: '517431' },
  { city: 'Valea Holhorii (Alba)', zip: '517432' },
  { city: 'Valea Lupşii (Alba)', zip: '517433' },
  { city: 'Valea Şesii (Lupşa) (Alba)', zip: '517434' },
  { city: 'Văi (Alba)', zip: '517436' },
  { city: 'Vinţa (Alba)', zip: '517437' },
  { city: 'Meteş (Alba)', zip: '517445' },
  { city: 'Ampoiţa (Alba)', zip: '517446' },
  { city: 'Isca (Alba)', zip: '517447' },
  { city: 'Lunca Ampoiţei (Alba)', zip: '517448' },
  { city: 'Lunca Meteşului (Alba)', zip: '517449' },
  { city: 'Pădurea (Alba)', zip: '517451' },
  { city: 'Poiana Ampoiului (Alba)', zip: '517452' },
  { city: 'Poiana Ursului (Alba)', zip: '517453' },
  { city: 'Presaca Ampoiului (Alba)', zip: '517454' },
  { city: 'Remetea (Alba)', zip: '517456' },
  { city: 'Tăuţi (Alba)', zip: '517457' },
  { city: 'Văleni (Meteş) (Alba)', zip: '517458' },
  { city: 'Mihalţ (Alba)', zip: '517465' },
  { city: 'Cistei (Alba)', zip: '517466' },
  { city: 'Obreja (Alba)', zip: '517467' },
  { city: 'Zărieş (Alba)', zip: '517468' },
  { city: 'Mirăslău (Alba)', zip: '517470' },
  { city: 'Cicău (Alba)', zip: '517471' },
  { city: 'Decea (Alba)', zip: '517472' },
  { city: 'Lopadea Veche (Alba)', zip: '517473' },
  { city: 'Ormeniş (Alba)', zip: '517474' },
  { city: 'Rachiş (Alba)', zip: '517476' },
  { city: 'Mogoş (Alba)', zip: '517480' },
  { city: 'Bărbeşti (Alba)', zip: '517481' },
  { city: 'Bârleşti (Mogoş) (Alba)', zip: '517482' },
  { city: 'Bârleşti-Cătun (Alba)', zip: '517483' },
  { city: 'Bârzogani (Alba)', zip: '517484' },
  { city: 'Boceşti (Alba)', zip: '517486' },
  { city: 'Bogdăneşti (Mogoş) (Alba)', zip: '517487' },
  { city: 'Buteşti (Mogoş) (Alba)', zip: '517488' },
  { city: 'Cojocani (Alba)', zip: '517489' },
  { city: 'Cristeşti (Alba)', zip: '517491' },
  { city: 'Mămăligani (Alba)', zip: '517492' },
  { city: 'Negreşti (Alba)', zip: '517493' },
  { city: 'Onceşti (Alba)', zip: '517494' },
  { city: 'Poienile-Mogoş (Alba)', zip: '517496' },
  { city: 'Tomeşti (Alba)', zip: '517497' },
  { city: 'Valea Barnii (Alba)', zip: '517498' },
  { city: 'Valea Bârluţeşti (Alba)', zip: '517499' },
  { city: 'Valea Coceşti (Alba)', zip: '517501' },
  { city: 'Valea Giogeşti (Alba)', zip: '517502' },
  { city: 'Valea Mlacii (Alba)', zip: '517503' },
  { city: 'Valea Ţupilor (Alba)', zip: '517504' },
  { city: 'Noşlac (Alba)', zip: '517515' },
  { city: 'Căptălan (Alba)', zip: '517516' },
  { city: 'Copand (Alba)', zip: '517517' },
  { city: 'Găbud (Alba)', zip: '517518' },
  { city: 'Stâna de Mureş (Alba)', zip: '517519' },
  { city: 'Valea Ciuciului (Alba)', zip: '517521' },
  { city: 'Ocoliş (Alba)', zip: '517525' },
  { city: 'Lunca Largă (Ocoliş) (Alba)', zip: '517526' },
  { city: 'Runc (Ocoliş) (Alba)', zip: '517527' },
  { city: 'Vidolm (Alba)', zip: '517528' },
  { city: 'Ohaba (Alba)', zip: '517530' },
  { city: 'Colibi (Alba)', zip: '517531' },
  { city: 'Măghierat (Alba)', zip: '517532' },
  { city: 'Secăşel (Alba)', zip: '517533' },
  { city: 'Pianu (Alba)', zip: '517535' },
  { city: 'Pianu de Jos (Alba)', zip: '517536' },
  { city: 'Pianu de Sus (Alba)', zip: '517537' },
  { city: 'Plaiuri (Alba)', zip: '517538' },
  { city: 'Purcăreţi (Alba)', zip: '517539' },
  { city: 'Strungari (Alba)', zip: '517541' },
  { city: 'Poiana Vadului (Alba)', zip: '517545' },
  { city: 'Costeşti (Poiana Vadului) (Alba)', zip: '517546' },
  { city: 'Duduieni (Alba)', zip: '517547' },
  { city: 'Făgetu de Jos (Alba)', zip: '517548' },
  { city: 'Făgetu de Sus (Alba)', zip: '517549' },
  { city: 'Hănăşeşti (Poiana Vadului) (Alba)', zip: '517551' },
  { city: 'Lupăieşti (Alba)', zip: '517552' },
  { city: 'Morcăneşti (Alba)', zip: '517553' },
  { city: 'Păşteşti (Alba)', zip: '517554' },
  { city: 'Petelei (Alba)', zip: '517556' },
  { city: 'Stăneşti (Alba)', zip: '517557' },
  { city: 'Ponor (Alba)', zip: '517565' },
  { city: 'După Deal (Ponor) (Alba)', zip: '517566' },
  { city: 'Geogel (Alba)', zip: '517567' },
  { city: 'Măcăreşti (Alba)', zip: '517568' },
  { city: 'Vale în Jos (Alba)', zip: '517569' },
  { city: 'Valea Bucurului (Alba)', zip: '517571' },
  { city: 'Poşaga (Alba)', zip: '517575' },
  { city: 'Corţeşti (Alba)', zip: '517576' },
  { city: 'Inceşti (Poşaga) (Alba)', zip: '517577' },
  { city: 'Lunca (Poşaga) (Alba)', zip: '517578' },
  { city: 'Orăşti (Alba)', zip: '517579' },
  { city: 'Poşaga de Jos (Alba)', zip: '517581' },
  { city: 'Poşaga de Sus (Alba)', zip: '517582' },
  { city: 'Săgagea (Alba)', zip: '517583' },
  { city: 'Rădeşti (Alba)', zip: '517585' },
  { city: 'Leorinţ (Alba)', zip: '517586' },
  { city: 'Meşcreac (Alba)', zip: '517587' },
  { city: 'Şoimuş (Alba)', zip: '517588' },
  { city: 'Râmeţ (Alba)', zip: '517590' },
  { city: 'Boţani (Alba)', zip: '517591' },
  { city: 'Brădeşti (Alba)', zip: '517592' },
  { city: 'Cheia (Alba)', zip: '517593' },
  { city: 'Cotorăşti (Alba)', zip: '517594' },
  { city: 'Floreşti (Râmeţ) (Alba)', zip: '517596' },
  { city: 'Olteni (Alba)', zip: '517597' },
  { city: 'Valea Făgetului (Alba)', zip: '517598' },
  { city: 'Valea Inzelului (Alba)', zip: '517599' },
  { city: 'Valea Mănăstirii (Alba)', zip: '517601' },
  { city: 'Valea Poienii (Râmeţ) (Alba)', zip: '517602' },
  { city: 'Valea Uzei (Alba)', zip: '517603' },
  { city: 'Vlădeşti (Alba)', zip: '517604' },
  { city: 'Rimetea (Alba)', zip: '517610' },
  { city: 'Colţeşti (Alba)', zip: '517611' },
  { city: 'Roşia Montană (Alba)', zip: '517615' },
  { city: 'Bălmoşeşti (Alba)', zip: '517616' },
  { city: 'Blideşti (Alba)', zip: '517617' },
  { city: 'Bunta (Alba)', zip: '517618' },
  { city: 'Cărpiniş (Roşia Montană) (Alba)', zip: '517619' },
  { city: 'Coasta Henţii (Alba)', zip: '517621' },
  { city: 'Corna (Alba)', zip: '517622' },
  { city: 'Curături (Alba)', zip: '517623' },
  { city: 'Dăroaia (Alba)', zip: '517624' },
  { city: 'Gârda-Bărbuleşti (Alba)', zip: '517626' },
  { city: 'Gura Roşiei (Alba)', zip: '517627' },
  { city: 'Iacobeşti (Alba)', zip: '517628' },
  { city: 'Ignăţeşti (Alba)', zip: '517629' },
  { city: 'Şoal (Alba)', zip: '517631' },
  { city: 'Ţarina (Alba)', zip: '517632' },
  { city: 'Vârtop (Alba)', zip: '517633' },
  { city: 'Roşia de Secaş (Alba)', zip: '517640' },
  { city: 'Tău (Alba)', zip: '517641' },
  { city: 'Ungurei (Alba)', zip: '517642' },
  { city: 'Sălciua (Alba)', zip: '517645' },
  { city: 'Dealu Caselor (Alba)', zip: '517646' },
  { city: 'Dumeşti (Alba)', zip: '517647' },
  { city: 'Sălciua de Jos (Alba)', zip: '517648' },
  { city: 'Sălciua de Sus (Alba)', zip: '517649' },
  { city: 'Sub Piatră (Alba)', zip: '517651' },
  { city: 'Valea Largă (Alba)', zip: '517652' },
  { city: 'Săliştea (Alba)', zip: '517655' },
  { city: 'Mărgineni (Alba)', zip: '517656' },
  { city: 'Săliştea-Deal (Alba)', zip: '517657' },
  { city: 'Tărtăria (Alba)', zip: '517658' },
  { city: 'Săsciori (Alba)', zip: '517660' },
  { city: 'Căpâlna (Alba)', zip: '517661' },
  { city: 'Dumbrava (Săsciori) (Alba)', zip: '517662' },
  { city: 'Laz (Săsciori) (Alba)', zip: '517663' },
  { city: 'Loman (Alba)', zip: '517664' },
  { city: 'Pleşi (Alba)', zip: '517666' },
  { city: 'Răchita (Alba)', zip: '517667' },
  { city: 'Sebeşel (Alba)', zip: '517668' },
  { city: 'Tonea (Alba)', zip: '517669' },
  { city: 'Sâncel (Alba)', zip: '517670' },
  { city: 'Iclod (Alba)', zip: '517671' },
  { city: 'Pănade (Alba)', zip: '517672' },
  { city: 'Sântimbru (Alba)', zip: '517675' },
  { city: 'Coşlariu (Alba)', zip: '517676' },
  { city: 'Dumitra (Alba)', zip: '517677' },
  { city: 'Galtiu (Alba)', zip: '517678' },
  { city: 'Totoi (Alba)', zip: '517679' },
  { city: 'Scărişoara (Alba)', zip: '517680' },
  { city: 'Bârleşti (Scărişoara) (Alba)', zip: '517681' },
  { city: 'Boteşti (Scărişoara) (Alba)', zip: '517682' },
  { city: 'Faţa-Lăzeşti (Alba)', zip: '517683' },
  { city: 'Floreşti (Scărişoara) (Alba)', zip: '517684' },
  { city: 'Lăzeşti (Scărişoara) (Alba)', zip: '517686' },
  { city: 'Lespezea (Alba)', zip: '517687' },
  { city: 'Maţei (Alba)', zip: '517688' },
  { city: 'Negeşti (Alba)', zip: '517689' },
  { city: 'Prelucă (Alba)', zip: '517691' },
  { city: 'Runc (Scărişoara) (Alba)', zip: '517692' },
  { city: 'Sfoartea (Alba)', zip: '517693' },
  { city: 'Ştiuleţi (Alba)', zip: '517694' },
  { city: 'Trânceşti (Alba)', zip: '517696' },
  { city: 'Sohodol (Alba)', zip: '517700' },
  { city: 'Băzeşti (Alba)', zip: '517701' },
  { city: 'Bilăneşti (Alba)', zip: '517702' },
  { city: 'Bobăreşti (Sohodol) (Alba)', zip: '517703' },
  { city: 'Brădeana (Alba)', zip: '517704' },
  { city: 'Burzoneşti (Alba)', zip: '517706' },
  { city: 'Deonceşti (Alba)', zip: '517707' },
  { city: 'Dilimani (Alba)', zip: '517708' },
  { city: 'Furduieşti (Sohodol) (Alba)', zip: '517709' },
  { city: 'Gura Sohodol (Alba)', zip: '517711' },
  { city: 'Hoancă (Sohodol) (Alba)', zip: '517712' },
  { city: 'Joldişeşti (Alba)', zip: '517713' },
  { city: 'Lazuri (Sohodol) (Alba)', zip: '517714' },
  { city: 'Leheşti (Alba)', zip: '517716' },
  { city: 'Lumineşti (Alba)', zip: '517717' },
  { city: 'Medreşti (Alba)', zip: '517718' },
  { city: 'Morăreşti (Sohodol) (Alba)', zip: '517719' },
  { city: 'Muneşti (Alba)', zip: '517721' },
  { city: 'Năpăieşti (Alba)', zip: '517722' },
  { city: 'Nelegeşti (Alba)', zip: '517723' },
  { city: 'Nicoreşti (Alba)', zip: '517724' },
  { city: 'Peleş (Alba)', zip: '517726' },
  { city: 'Poiana (Sohodol) (Alba)', zip: '517727' },
  { city: 'Robeşti (Alba)', zip: '517728' },
  { city: 'Sebişeşti (Alba)', zip: '517729' },
  { city: 'Sicoieşti (Alba)', zip: '517731' },
  { city: 'Surdeşti (Alba)', zip: '517732' },
  { city: 'Şimoceşti (Alba)', zip: '517733' },
  { city: 'Ţoci (Alba)', zip: '517734' },
  { city: 'Valea Verde (Alba)', zip: '517736' },
  { city: 'Vlădoşeşti (Alba)', zip: '517737' },
  { city: 'Stremţ (Alba)', zip: '517745' },
  { city: 'Faţa Pietrii (Alba)', zip: '517746' },
  { city: 'Geoagiu de Sus (Alba)', zip: '517747' },
  { city: 'Geomal (Alba)', zip: '517748' },
  { city: 'Şibot (Alba)', zip: '517750' },
  { city: 'Balomiru de Câmp (Alba)', zip: '517751' },
  { city: 'Băcăinţi (Alba)', zip: '517752' },
  { city: 'Sărăcsău (Alba)', zip: '517753' },
  { city: 'Şona (Alba)', zip: '517755' },
  { city: 'Alecuş (Alba)', zip: '517756' },
  { city: 'Biia (Alba)', zip: '517757' },
  { city: 'Doptău (Alba)', zip: '517758' },
  { city: 'Lunca Târnavei (Alba)', zip: '517759' },
  { city: 'Sânmiclăuş (Alba)', zip: '517761' },
  { city: 'Valea Sasului (Alba)', zip: '517762' },
  { city: 'Şpring (Alba)', zip: '517765' },
  { city: 'Carpen (Alba)', zip: '517766' },
  { city: 'Carpenii de Sus (Alba)', zip: '517767' },
  { city: 'Cunţa (Alba)', zip: '517768' },
  { city: 'Draşov (Alba)', zip: '517769' },
  { city: 'Vingard (Alba)', zip: '517771' },
  { city: 'Şugag (Alba)', zip: '517775' },
  { city: 'Arţi (Alba)', zip: '517776' },
  { city: 'Bârsana (Alba)', zip: '517777' },
  { city: 'Dobra (Alba)', zip: '517778' },
  { city: 'Jidoştina (Alba)', zip: '517779' },
  { city: 'Mărtinie (Alba)', zip: '517781' },
  { city: 'Tău Bistra (Alba)', zip: '517782' },
  { city: 'Unirea (Alba)', zip: '517785' },
  { city: 'Ciugudu de Jos (Alba)', zip: '517786' },
  { city: 'Ciugudu de Sus (Alba)', zip: '517787' },
  { city: 'Dumbrava (Unirea) (Alba)', zip: '517788' },
  { city: 'Inoc (Alba)', zip: '517789' },
  { city: 'Măhăceni (Alba)', zip: '517791' },
  { city: 'Vadu Moţilor (Alba)', zip: '517795' },
  { city: 'Bodeşti (Alba)', zip: '517796' },
  { city: 'Burzeşti (Alba)', zip: '517797' },
  { city: 'Dealu Frumos (Vadu Moţilor) (Alba)', zip: '517798' },
  { city: 'Lăzeşti (Vadu Moţilor) (Alba)', zip: '517799' },
  { city: 'Necşeşti (Alba)', zip: '517801' },
  { city: 'Poduri-Briceşti (Alba)', zip: '517802' },
  { city: 'Popeştii de Jos (Alba)', zip: '517803' },
  { city: 'Popeştii de Sus (Alba)', zip: '517804' },
  { city: 'Tomuţeşti (Alba)', zip: '517806' },
  { city: 'Toţeşti (Alba)', zip: '517807' },
  { city: 'Vâltori (Vadu Moţilor) (Alba)', zip: '517808' },
  { city: 'Valea Lungă (Alba)', zip: '517815' },
  { city: 'Făget (Alba)', zip: '517816' },
  { city: 'Glogoveţ (Alba)', zip: '517817' },
  { city: 'Lodroman (Alba)', zip: '517818' },
  { city: 'Lunca (Valea Lungă) (Alba)', zip: '517819' },
  { city: 'Tăuni (Alba)', zip: '517821' },
  { city: 'Vidra (Alba)', zip: '517825' },
  { city: 'Băi (Alba)', zip: '517826' },
  { city: 'Bobăreşti (Vidra) (Alba)', zip: '517827' },
  { city: 'Bogdăneşti (Vidra) (Alba)', zip: '517828' },
  { city: 'Bordeştii Poieni (Alba)', zip: '517829' },
  { city: 'Culdeşti (Alba)', zip: '517831' },
  { city: 'Dealu Goieşti (Alba)', zip: '517832' },
  { city: 'Dos (Alba)', zip: '517833' },
  { city: 'Dosu Luncii (Alba)', zip: '517834' },
  { city: 'Dosu Văseşti (Alba)', zip: '517836' },
  { city: 'Drăgoieşti-Luncă (Alba)', zip: '517837' },
  { city: 'Ficăreşti (Alba)', zip: '517838' },
  { city: 'Gligoreşti (Alba)', zip: '517839' },
  { city: 'Goieşti (Alba)', zip: '517841' },
  { city: 'Haiduceşti (Alba)', zip: '517842' },
  { city: 'Hărăşti (Alba)', zip: '517843' },
  { city: 'Hoancă (Vidra) (Alba)', zip: '517844' },
  { city: 'Jefleşti (Alba)', zip: '517846' },
  { city: 'Lunca (Vidra) (Alba)', zip: '517847' },
  { city: 'Lunca Bisericii (Alba)', zip: '517848' },
  { city: 'Lunca Goieşti (Alba)', zip: '517849' },
  { city: 'Lunca Veseşti (Alba)', zip: '517851' },
  { city: 'Lunca de Jos (Alba)', zip: '517852' },
  { city: 'Modoleşti (Vidra) (Alba)', zip: '517853' },
  { city: 'Nemeşi (Alba)', zip: '517854' },
  { city: 'Oideşti (Alba)', zip: '517856' },
  { city: 'Pitărceşti (Alba)', zip: '517857' },
  { city: 'Pleşcuţa (Alba)', zip: '517858' },
  { city: 'Poieni (Vidra) (Alba)', zip: '517859' },
  { city: 'Ponorel (Alba)', zip: '517861' },
  { city: 'Puiuleţeşti (Alba)', zip: '517862' },
  { city: 'Runc (Vidra) (Alba)', zip: '517863' },
  { city: 'Segaj (Alba)', zip: '517864' },
  { city: 'Urdeş (Alba)', zip: '517866' },
  { city: 'Valea Morii (Alba)', zip: '517867' },
  { city: 'Văseşti (Alba)', zip: '517868' },
  { city: 'Vâlcăneasa (Alba)', zip: '517869' },
  { city: 'Vâlceşti (Alba)', zip: '517871' },
  { city: 'Vârtăneşti (Alba)', zip: '517872' },
  { city: 'Vinţu de Jos (Alba)', zip: '517875' },
  { city: 'Câmpu Goblii (Alba)', zip: '517876' },
  { city: 'Ciocaşu (Alba)', zip: '517877' },
  { city: 'Crişeni (Alba)', zip: '517878' },
  { city: 'Dealu Ferului (Alba)', zip: '517879' },
  { city: 'Gura Cuţului (Alba)', zip: '517881' },
  { city: 'Haţegana (Alba)', zip: '517882' },
  { city: 'Inuri (Alba)', zip: '517883' },
  { city: 'Laz (Vinţu de Jos) (Alba)', zip: '517884' },
  { city: 'Mătăcina (Alba)', zip: '517886' },
  { city: 'Mereteu (Alba)', zip: '517887' },
  { city: 'Pârău lui Mihai (Alba)', zip: '517888' },
  { city: 'Poieniţa (Vinţu de Jos) (Alba)', zip: '517889' },
  { city: 'Stăuini (Alba)', zip: '517891' },
  { city: 'Valea Goblii (Alba)', zip: '517892' },
  { city: 'Valea Vinţului (Alba)', zip: '517893' },
  { city: 'Valea lui Mihai (Alba)', zip: '517894' },
  { city: 'Vurpăr (Alba)', zip: '517896' },
  { city: 'Arad (Arad)', zip: '310001' },
  { city: 'Chişineu-Criş (Arad)', zip: '315100' },
  { city: 'Nădab (Arad)', zip: '315101' },
  { city: 'Curtici (Arad)', zip: '315200' },
  { city: 'Dorobanţi (Arad)', zip: '315201' },
  { city: 'Ineu (Arad)', zip: '315300' },
  { city: 'Mocrea (Arad)', zip: '315301' },
  { city: 'Lipova (Arad)', zip: '315400' },
  { city: 'Radna (Arad)', zip: '315401' },
  { city: 'Şoimoş (Arad)', zip: '315402' },
  { city: 'Nădlac (Arad)', zip: '315500' },
  { city: 'Pâncota (Arad)', zip: '315600' },
  { city: 'Măderat (Arad)', zip: '315601' },
  { city: 'Sebiş (Arad)', zip: '315700' },
  { city: 'Donceni (Arad)', zip: '315701' },
  { city: 'Prunişor (Arad)', zip: '315702' },
  { city: 'Sălăjeni (Arad)', zip: '315703' },
  { city: 'Almaş (Arad)', zip: '317005' },
  { city: 'Cil (Arad)', zip: '317006' },
  { city: 'Joia Mare (Arad)', zip: '317007' },
  { city: 'Rădeşti (Arad)', zip: '317008' },
  { city: 'Apateu (Arad)', zip: '317010' },
  { city: 'Berechiu (Arad)', zip: '317011' },
  { city: 'Moţiori (Arad)', zip: '317012' },
  { city: 'Archiş (Arad)', zip: '317015' },
  { city: 'Bârzeşti (Arad)', zip: '317016' },
  { city: 'Groşeni (Arad)', zip: '317017' },
  { city: 'Nermiş (Arad)', zip: '317018' },
  { city: 'Bata (Arad)', zip: '317020' },
  { city: 'Bacău de Mijloc (Arad)', zip: '317021' },
  { city: 'Bulci (Arad)', zip: '317022' },
  { city: 'Ţela (Arad)', zip: '317023' },
  { city: 'Bârsa (Arad)', zip: '317025' },
  { city: 'Aldeşti (Arad)', zip: '317026' },
  { city: 'Hodiş (Arad)', zip: '317027' },
  { city: 'Voivodeni (Arad)', zip: '317028' },
  { city: 'Bârzava (Arad)', zip: '317030' },
  { city: 'Bătuţa (Arad)', zip: '317031' },
  { city: 'Căpruţa (Arad)', zip: '317032' },
  { city: 'Dumbrăviţa (Arad)', zip: '317033' },
  { city: 'Groşii Noi (Arad)', zip: '317034' },
  { city: 'Lalaşinţ (Arad)', zip: '317036' },
  { city: 'Monoroştia (Arad)', zip: '317037' },
  { city: 'Slatina de Mureş (Arad)', zip: '317038' },
  { city: 'Beliu (Arad)', zip: '317040' },
  { city: 'Beneşti (Arad)', zip: '317041' },
  { city: 'Bochia (Arad)', zip: '317042' },
  { city: 'Secaci (Arad)', zip: '317043' },
  { city: 'Tăgădău (Arad)', zip: '317044' },
  { city: 'Vasile Goldiş (Arad)', zip: '317046' },
  { city: 'Birchiş (Arad)', zip: '317050' },
  { city: 'Căpălnaş (Arad)', zip: '317051' },
  { city: 'Ostrov (Arad)', zip: '317052' },
  { city: 'Virismort (Arad)', zip: '317053' },
  { city: 'Bocsig (Arad)', zip: '317055' },
  { city: 'Mânerău (Arad)', zip: '317056' },
  { city: 'Răpsig (Arad)', zip: '317057' },
  { city: 'Brazii (Arad)', zip: '317060' },
  { city: 'Buceava-Şoimuş (Arad)', zip: '317061' },
  { city: 'Iacobini (Arad)', zip: '317062' },
  { city: 'Mădrigeşti (Arad)', zip: '317063' },
  { city: 'Secaş (Arad)', zip: '317064' },
  { city: 'Buteni (Arad)', zip: '317065' },
  { city: 'Berindia (Arad)', zip: '317066' },
  { city: 'Cuied (Arad)', zip: '317067' },
  { city: 'Păulian (Arad)', zip: '317068' },
  { city: 'Cărand (Arad)', zip: '317070' },
  { city: 'Seliştea (Arad)', zip: '317071' },
  { city: 'Cermei (Arad)', zip: '317075' },
  { city: 'Avram Iancu (Cermei) (Arad)', zip: '317076' },
  { city: 'Şomoşcheş (Arad)', zip: '317077' },
  { city: 'Chisindia (Arad)', zip: '317080' },
  { city: 'Păiuşeni (Arad)', zip: '317081' },
  { city: 'Văsoaia (Arad)', zip: '317082' },
  { city: 'Conop (Arad)', zip: '317085' },
  { city: 'Belotinţ (Arad)', zip: '317086' },
  { city: 'Chelmac (Arad)', zip: '317087' },
  { city: 'Milova (Arad)', zip: '317088' },
  { city: 'Odvoş (Arad)', zip: '317089' },
  { city: 'Covăsinţ (Arad)', zip: '317090' },
  { city: 'Craiva (Arad)', zip: '317095' },
  { city: 'Chişlaca (Arad)', zip: '317096' },
  { city: 'Ciunteşti (Arad)', zip: '317097' },
  { city: 'Coroi (Arad)', zip: '317098' },
  { city: 'Mărăuş (Arad)', zip: '317099' },
  { city: 'Rogoz de Beliu (Arad)', zip: '317101' },
  { city: 'Stoineşti (Arad)', zip: '317102' },
  { city: 'Susag (Arad)', zip: '317103' },
  { city: 'Şiad (Arad)', zip: '317104' },
  { city: 'Tălmaci (Arad)', zip: '317106' },
  { city: 'Dezna (Arad)', zip: '317110' },
  { city: 'Buhani (Arad)', zip: '317111' },
  { city: 'Laz (Arad)', zip: '317112' },
  { city: 'Neagra (Arad)', zip: '317113' },
  { city: 'Slatina de Criş (Arad)', zip: '317114' },
  { city: 'Dieci (Arad)', zip: '317115' },
  { city: 'Cociuba (Arad)', zip: '317116' },
  { city: 'Crocna (Arad)', zip: '317117' },
  { city: 'Revetiş (Arad)', zip: '317118' },
  { city: 'Roşia (Arad)', zip: '317119' },
  { city: 'Fântânele (Arad)', zip: '317120' },
  { city: 'Aluniş (Arad)', zip: '317121' },
  { city: 'Frumuşeni (Arad)', zip: '317122' },
  { city: 'Tisa Nouă (Arad)', zip: '317123' },
  { city: 'Felnac (Arad)', zip: '317125' },
  { city: 'Bodrogu Nou (Arad)', zip: '317126' },
  { city: 'Călugăreni (Arad)', zip: '317127' },
  { city: 'Zădăreni (Arad)', zip: '317130' },
  { city: 'Ghioroc (Arad)', zip: '317135' },
  { city: 'Cuvin (Arad)', zip: '317136' },
  { city: 'Miniş (Arad)', zip: '317137' },
  { city: 'Grăniceri (Arad)', zip: '317140' },
  { city: 'Şiclău (Arad)', zip: '317141' },
  { city: 'Gurahonţ (Arad)', zip: '317145' },
  { city: 'Bonţeşti (Arad)', zip: '317146' },
  { city: 'Dulcele (Arad)', zip: '317147' },
  { city: 'Feniş (Arad)', zip: '317148' },
  { city: 'Honţişor (Arad)', zip: '317149' },
  { city: 'Iosaş (Arad)', zip: '317151' },
  { city: 'Musteşti (Arad)', zip: '317152' },
  { city: 'Pescari (Arad)', zip: '317153' },
  { city: 'Valea Mare (Gurahonţ) (Arad)', zip: '317154' },
  { city: 'Zimbru (Arad)', zip: '317156' },
  { city: 'Hălmagiu (Arad)', zip: '317160' },
  { city: 'Băneşti (Arad)', zip: '317161' },
  { city: 'Bodeşti (Arad)', zip: '317162' },
  { city: 'Brusturi (Arad)', zip: '317163' },
  { city: 'Cristeşti (Arad)', zip: '317164' },
  { city: 'Ioneşti (Arad)', zip: '317166' },
  { city: 'Leasa (Arad)', zip: '317167' },
  { city: 'Leştioara (Arad)', zip: '317168' },
  { city: 'Poienari (Arad)', zip: '317169' },
  { city: 'Tisa (Arad)', zip: '317171' },
  { city: 'Ţărmure (Arad)', zip: '317172' },
  { city: 'Hălmăgel (Arad)', zip: '317180' },
  { city: 'Luncşoara (Arad)', zip: '317181' },
  { city: 'Sârbi (Arad)', zip: '317182' },
  { city: 'Târnăviţa (Arad)', zip: '317183' },
  { city: 'Ţoheşti (Arad)', zip: '317184' },
  { city: 'Hăşmaş (Arad)', zip: '317185' },
  { city: 'Agrişu Mic (Arad)', zip: '317186' },
  { city: 'Botfei (Arad)', zip: '317187' },
  { city: 'Clit (Arad)', zip: '317188' },
  { city: 'Comăneşti (Arad)', zip: '317189' },
  { city: 'Urvişu de Beliu (Arad)', zip: '317191' },
  { city: 'Igneşti (Arad)', zip: '317195' },
  { city: 'Minead (Arad)', zip: '317196' },
  { city: 'Nădălbeşti (Arad)', zip: '317197' },
  { city: 'Susani (Arad)', zip: '317198' },
  { city: 'Iratoşu (Arad)', zip: '317200' },
  { city: 'Variaşu Mare (Arad)', zip: '317201' },
  { city: 'Variaşu Mic (Arad)', zip: '317202' },
  { city: 'Livada (Arad)', zip: '317205' },
  { city: 'Sânleani (Arad)', zip: '317206' },
  { city: 'Macea (Arad)', zip: '317210' },
  { city: 'Sânmartin (Arad)', zip: '317211' },
  { city: 'Mişca (Arad)', zip: '317215' },
  { city: 'Satu Nou (Arad)', zip: '317216' },
  { city: 'Vânători (Arad)', zip: '317217' },
  { city: 'Zerindu Mic (Arad)', zip: '317218' },
  { city: 'Moneasa (Arad)', zip: '317220' },
  { city: 'Rănuşa (Arad)', zip: '317221' },
  { city: 'Olari (Arad)', zip: '317225' },
  { city: 'Sintea Mică (Arad)', zip: '317226' },
  { city: 'Păuliş (Arad)', zip: '317230' },
  { city: 'Baraţca (Arad)', zip: '317231' },
  { city: 'Cladova (Arad)', zip: '317232' },
  { city: 'Sâmbăteni (Arad)', zip: '317233' },
  { city: 'Pecica (Arad)', zip: '317235' },
  { city: 'Bodrogu Vechi (Arad)', zip: '317236' },
  { city: 'Sederhat (Arad)', zip: '317237' },
  { city: 'Turnu (Arad)', zip: '317238' },
  { city: 'Peregu Mare (Arad)', zip: '317240' },
  { city: 'Peregu Mic (Arad)', zip: '317241' },
  { city: 'Petriş (Arad)', zip: '317245' },
  { city: 'Corbeşti (Arad)', zip: '317246' },
  { city: 'Ilteu (Arad)', zip: '317247' },
  { city: 'Obârşia (Arad)', zip: '317248' },
  { city: 'Roşia Nouă (Arad)', zip: '317249' },
  { city: 'Selişte (Arad)', zip: '317251' },
  { city: 'Pilu (Arad)', zip: '317255' },
  { city: 'Vărşand (Arad)', zip: '317256' },
  { city: 'Pleşcuţa (Arad)', zip: '317260' },
  { city: 'Aciuţa (Arad)', zip: '317261' },
  { city: 'Budeşti (Arad)', zip: '317262' },
  { city: 'Dumbrava (Arad)', zip: '317263' },
  { city: 'Gura Văii (Arad)', zip: '317264' },
  { city: 'Rostoci (Arad)', zip: '317266' },
  { city: 'Tălagiu (Arad)', zip: '317267' },
  { city: 'Săvârşin (Arad)', zip: '317270' },
  { city: 'Căprioara (Arad)', zip: '317271' },
  { city: 'Cuiaş (Arad)', zip: '317272' },
  { city: 'Hălăliş (Arad)', zip: '317273' },
  { city: 'Pârneşti (Arad)', zip: '317274' },
  { city: 'Temeşeşti (Arad)', zip: '317276' },
  { city: 'Toc (Arad)', zip: '317277' },
  { city: 'Troaş (Arad)', zip: '317278' },
  { city: 'Valea Mare (Săvârşin) (Arad)', zip: '317279' },
  { city: 'Sântana (Arad)', zip: '317280' },
  { city: 'Caporal Alexa (Arad)', zip: '317281' },
  { city: 'Secusigiu (Arad)', zip: '317285' },
  { city: 'Munar (Arad)', zip: '317286' },
  { city: 'Satu Mare (Arad)', zip: '317287' },
  { city: 'Sânpetru German (Arad)', zip: '317288' },
  { city: 'Seleuş (Arad)', zip: '317290' },
  { city: 'Iermata (Arad)', zip: '317291' },
  { city: 'Moroda (Arad)', zip: '317292' },
  { city: 'Semlac (Arad)', zip: '317295' },
  { city: 'Sintea Mare (Arad)', zip: '317300' },
  { city: 'Adea (Arad)', zip: '317301' },
  { city: 'Ţipar (Arad)', zip: '317302' },
  { city: 'Socodor (Arad)', zip: '317305' },
  { city: 'Şagu (Arad)', zip: '317310' },
  { city: 'Cruceni (Arad)', zip: '317311' },
  { city: 'Firiteaz (Arad)', zip: '317312' },
  { city: 'Fiscut (Arad)', zip: '317313' },
  { city: 'Hunedoara Timişană (Arad)', zip: '317314' },
  { city: 'Şeitin (Arad)', zip: '317315' },
  { city: 'Şepreuş (Arad)', zip: '317320' },
  { city: 'Şicula (Arad)', zip: '317325' },
  { city: 'Chereluş (Arad)', zip: '317326' },
  { city: 'Gurba (Arad)', zip: '317327' },
  { city: 'Şilindia (Arad)', zip: '317330' },
  { city: 'Camna (Arad)', zip: '317331' },
  { city: 'Iercoşeni (Arad)', zip: '317332' },
  { city: 'Luguzău (Arad)', zip: '317333' },
  { city: 'Satu Mic (Arad)', zip: '317334' },
  { city: 'Şimand (Arad)', zip: '317335' },
  { city: 'Şiria (Arad)', zip: '317340' },
  { city: 'Galşa (Arad)', zip: '317341' },
  { city: 'Mâsca (Arad)', zip: '317342' },
  { city: 'Şiştarovăţ (Arad)', zip: '317345' },
  { city: 'Cuveşdia (Arad)', zip: '317346' },
  { city: 'Labaşinţ (Arad)', zip: '317347' },
  { city: 'Varniţa (Arad)', zip: '317348' },
  { city: 'Şofronea (Arad)', zip: '317350' },
  { city: 'Sânpaul (Arad)', zip: '317351' },
  { city: 'Tauţ (Arad)', zip: '317355' },
  { city: 'Minişel (Arad)', zip: '317356' },
  { city: 'Minişu de Sus (Arad)', zip: '317357' },
  { city: 'Nadăş (Arad)', zip: '317358' },
  { city: 'Târnova (Arad)', zip: '317360' },
  { city: 'Arăneag (Arad)', zip: '317361' },
  { city: 'Chier (Arad)', zip: '317362' },
  { city: 'Drauţ (Arad)', zip: '317363' },
  { city: 'Dud (Arad)', zip: '317364' },
  { city: 'Agrişu Mare (Arad)', zip: '317365' },
  { city: 'Ususău (Arad)', zip: '317375' },
  { city: 'Bruznic (Arad)', zip: '317376' },
  { city: 'Dorgoş (Arad)', zip: '317377' },
  { city: 'Pătârş (Arad)', zip: '317378' },
  { city: 'Zăbalţ (Arad)', zip: '317379' },
  { city: 'Vărădia de Mureş (Arad)', zip: '317380' },
  { city: 'Baia (Arad)', zip: '317381' },
  { city: 'Juliţa (Arad)', zip: '317382' },
  { city: 'Lupeşti (Arad)', zip: '317383' },
  { city: 'Nicolae Bălcescu (Arad)', zip: '317384' },
  { city: 'Stejar (Arad)', zip: '317386' },
  { city: 'Vârfurile (Arad)', zip: '317390' },
  { city: 'Avram Iancu (Vârfurile) (Arad)', zip: '317391' },
  { city: 'Groşi (Arad)', zip: '317392' },
  { city: 'Lazuri (Arad)', zip: '317393' },
  { city: 'Măgulicea (Arad)', zip: '317394' },
  { city: 'Mermeşti (Arad)', zip: '317396' },
  { city: 'Poiana (Arad)', zip: '317397' },
  { city: 'Vidra (Arad)', zip: '317398' },
  { city: 'Vinga (Arad)', zip: '317400' },
  { city: 'Mailat (Arad)', zip: '317401' },
  { city: 'Mănăştur (Arad)', zip: '317402' },
  { city: 'Vladimirescu (Arad)', zip: '317405' },
  { city: 'Cicir (Arad)', zip: '317406' },
  { city: 'Horia (Arad)', zip: '317407' },
  { city: 'Mândruloc (Arad)', zip: '317408' },
  { city: 'Zăbrani (Arad)', zip: '317410' },
  { city: 'Chesinţ (Arad)', zip: '317411' },
  { city: 'Neudorf (Arad)', zip: '317412' },
  { city: 'Zărand (Arad)', zip: '317415' },
  { city: 'Cintei (Arad)', zip: '317416' },
  { city: 'Zerind (Arad)', zip: '317420' },
  { city: 'Iermata Neagră (Arad)', zip: '317421' },
  { city: 'Zimandu Nou (Arad)', zip: '317425' },
  { city: 'Andrei Şaguna (Arad)', zip: '317426' },
  { city: 'Zimandcuz (Arad)', zip: '317427' },
  { city: 'Piteşti (Argeş)', zip: '110001' },
  { city: 'Câmpulung (Argeş)', zip: '115100' },
  { city: 'Valea Rumâneştilor (Argeş)', zip: '115101' },
  { city: 'Costeşti (Argeş)', zip: '115200' },
  { city: 'Broşteni (Costeşti) (Argeş)', zip: '115201' },
  { city: 'Lăceni (Argeş)', zip: '115202' },
  { city: 'Pârvu Roşu (Argeş)', zip: '115203' },
  { city: 'Podu Broşteni (Argeş)', zip: '115204' },
  { city: 'Smei (Argeş)', zip: '115205' },
  { city: 'Stârci (Argeş)', zip: '115206' },
  { city: 'Curtea de Argeş (Argeş)', zip: '115300' },
  { city: 'Noapteş (Argeş)', zip: '115301' },
  { city: 'Mioveni (Argeş)', zip: '115400' },
  { city: 'Clucereasa (Argeş)', zip: '115401' },
  { city: 'Colibaşi (Argeş)', zip: '115402' },
  { city: 'Făgetu (Argeş)', zip: '115403' },
  { city: 'Racoviţa (Argeş)', zip: '115404' },
  { city: 'Topoloveni (Argeş)', zip: '115500' },
  { city: 'Boţârcani (Argeş)', zip: '115501' },
  { city: 'Crinteşti (Argeş)', zip: '115502' },
  { city: 'Gorăneşti (Argeş)', zip: '115503' },
  { city: 'Ţigăneşti (Argeş)', zip: '115504' },
  { city: 'Albeştii de Argeş (Argeş)', zip: '117005' },
  { city: 'Albeştii Ungureni (Argeş)', zip: '117006' },
  { city: 'Brăteşti (Argeş)', zip: '117007' },
  { city: 'Doblea (Argeş)', zip: '117008' },
  { city: 'Dobrotu (Argeş)', zip: '117009' },
  { city: 'Albeştii Pământeni (Argeş)', zip: '117010' },
  { city: 'Dumireşti (Argeş)', zip: '117011' },
  { city: 'Florieni (Argeş)', zip: '117012' },
  { city: 'Albeştii de Muscel (Argeş)', zip: '117025' },
  { city: 'Albeşti (Argeş)', zip: '117026' },
  { city: 'Bughea de Sus (Argeş)', zip: '117027' },
  { city: 'Cândeşti (Argeş)', zip: '117028' },
  { city: 'Albota (Argeş)', zip: '117030' },
  { city: 'Cerbu (Argeş)', zip: '117031' },
  { city: 'Frăteşti (Argeş)', zip: '117032' },
  { city: 'Gura Văii (Argeş)', zip: '117033' },
  { city: 'Mareş (Argeş)', zip: '117034' },
  { city: 'Aninoasa (Argeş)', zip: '117035' },
  { city: 'Broşteni (Aninoasa) (Argeş)', zip: '117036' },
  { city: 'Slănic (Argeş)', zip: '117037' },
  { city: 'Valea Siliştii (Argeş)', zip: '117038' },
  { city: 'Arefu (Argeş)', zip: '117040' },
  { city: 'Căpăţânenii Pământeni (Argeş)', zip: '117041' },
  { city: 'Căpăţânenii Ungureni (Argeş)', zip: '117042' },
  { city: 'Bascov (Argeş)', zip: '117045' },
  { city: 'Brăileni (Argeş)', zip: '117046' },
  { city: 'Glâmbocu (Argeş)', zip: '117047' },
  { city: 'Mica (Argeş)', zip: '117048' },
  { city: 'Prislopu Mic (Argeş)', zip: '117049' },
  { city: 'Schiau (Argeş)', zip: '117051' },
  { city: 'Uiasca (Argeş)', zip: '117052' },
  { city: 'Valea Ursului (Argeş)', zip: '117053' },
  { city: 'Băbana (Argeş)', zip: '117055' },
  { city: 'Băjăneşti (Argeş)', zip: '117056' },
  { city: 'Ciobăneşti (Argeş)', zip: '117057' },
  { city: 'Cotmeniţa (Argeş)', zip: '117058' },
  { city: 'Groşi (Argeş)', zip: '117059' },
  { city: 'Lupueni (Argeş)', zip: '117061' },
  { city: 'Slătioarele (Argeş)', zip: '117062' },
  { city: 'Băiculeşti (Argeş)', zip: '117065' },
  { city: 'Alunişu (Băiculeşti) (Argeş)', zip: '117066' },
  { city: 'Anghineşti (Argeş)', zip: '117067' },
  { city: 'Argeşani (Argeş)', zip: '117068' },
  { city: 'Măniceşti (Argeş)', zip: '117069' },
  { city: 'Stejari (Argeş)', zip: '117071' },
  { city: 'Tutana (Argeş)', zip: '117072' },
  { city: 'Valea Brazilor (Argeş)', zip: '117073' },
  { city: 'Valea lui Enache (Argeş)', zip: '117074' },
  { city: 'Zigoneni (Argeş)', zip: '117076' },
  { city: 'Bălileşti (Argeş)', zip: '117080' },
  { city: 'Băjeşti (Argeş)', zip: '117081' },
  { city: 'Goleşti (Bălileşti) (Argeş)', zip: '117082' },
  { city: 'Poieniţa (Argeş)', zip: '117083' },
  { city: 'Priboaia (Argeş)', zip: '117084' },
  { city: 'Ulita (Argeş)', zip: '117086' },
  { city: 'Valea Mare-Bratia (Argeş)', zip: '117087' },
  { city: 'Bârla (Argeş)', zip: '117090' },
  { city: 'Afrimeşti (Argeş)', zip: '117091' },
  { city: 'Bădeşti (Bârla) (Argeş)', zip: '117092' },
  { city: 'Brabeţi (Argeş)', zip: '117093' },
  { city: 'Cioceşti (Argeş)', zip: '117094' },
  { city: 'Malu (Bârla) (Argeş)', zip: '117096' },
  { city: 'Mândra (Argeş)', zip: '117097' },
  { city: 'Mozăcenii-Vale (Argeş)', zip: '117098' },
  { city: 'Podişoru (Argeş)', zip: '117099' },
  { city: 'Şelăreasca (Argeş)', zip: '117101' },
  { city: 'Urlueni (Argeş)', zip: '117102' },
  { city: 'Zuvelcaţi (Argeş)', zip: '117103' },
  { city: 'Beleţi-Negreşti (Argeş)', zip: '117110' },
  { city: 'Beleţi (Argeş)', zip: '117111' },
  { city: 'Lenţea (Argeş)', zip: '117112' },
  { city: 'Negreşti (Argeş)', zip: '117113' },
  { city: 'Zgripceşti (Argeş)', zip: '117114' },
  { city: 'Berevoeşti (Argeş)', zip: '117115' },
  { city: 'Bratia (Berevoeşti) (Argeş)', zip: '117116' },
  { city: 'Gămăceşti (Argeş)', zip: '117117' },
  { city: 'Oţelu (Argeş)', zip: '117118' },
  { city: 'Bogaţi (Argeş)', zip: '117120' },
  { city: 'Bârloi (Argeş)', zip: '117121' },
  { city: 'Bujoi (Argeş)', zip: '117122' },
  { city: 'Chiţeşti (Argeş)', zip: '117123' },
  { city: 'Dumbrava (Argeş)', zip: '117124' },
  { city: 'Glâmbocel (Argeş)', zip: '117126' },
  { city: 'Glâmbocelu (Argeş)', zip: '117127' },
  { city: 'Suseni (Bogaţi) (Argeş)', zip: '117128' },
  { city: 'Boteni (Argeş)', zip: '117130' },
  { city: 'Balabani (Argeş)', zip: '117131' },
  { city: 'Lunca (Argeş)', zip: '117132' },
  { city: 'Muşcel (Argeş)', zip: '117133' },
  { city: 'Boţeşti (Argeş)', zip: '117135' },
  { city: 'Moşteni-Greci (Argeş)', zip: '117136' },
  { city: 'Bradu (Argeş)', zip: '117140' },
  { city: 'Geamăna (Argeş)', zip: '117141' },
  { city: 'Brăduleţ (Argeş)', zip: '117145' },
  { city: 'Alunişu (Brăduleţ) (Argeş)', zip: '117146' },
  { city: 'Brădetu (Argeş)', zip: '117147' },
  { city: 'Cosaci (Argeş)', zip: '117148' },
  { city: 'Galeşu (Argeş)', zip: '117149' },
  { city: 'Piatra (Brăduleţ) (Argeş)', zip: '117151' },
  { city: 'Slămneşti (Argeş)', zip: '117152' },
  { city: 'Uleni (Argeş)', zip: '117153' },
  { city: 'Ungureni (Brăduleţ) (Argeş)', zip: '117154' },
  { city: 'Budeasa (Argeş)', zip: '117155' },
  { city: 'Budeasa Mare (Argeş)', zip: '117156' },
  { city: 'Budeasa Mică (Argeş)', zip: '117157' },
  { city: 'Caloteşti (Argeş)', zip: '117158' },
  { city: 'Gălăşeşti (Budeasa) (Argeş)', zip: '117159' },
  { city: 'Rogojina (Argeş)', zip: '117161' },
  { city: 'Valea Mărului (Argeş)', zip: '117162' },
  { city: 'Bughea de Jos (Argeş)', zip: '117165' },
  { city: 'Buzoeşti (Argeş)', zip: '117170' },
  { city: 'Bujoreni (Argeş)', zip: '117171' },
  { city: 'Cornăţel (Argeş)', zip: '117172' },
  { city: 'Curteanca (Argeş)', zip: '117173' },
  { city: 'Ioneşti (Argeş)', zip: '117174' },
  { city: 'Podeni (Argeş)', zip: '117176' },
  { city: 'Redea (Argeş)', zip: '117177' },
  { city: 'Şerboeni (Argeş)', zip: '117178' },
  { city: 'Tomşanca (Argeş)', zip: '117179' },
  { city: 'Vlăduţa (Argeş)', zip: '117181' },
  { city: 'Vulpeşti (Argeş)', zip: '117182' },
  { city: 'Căldăraru (Argeş)', zip: '117190' },
  { city: 'Burdea (Argeş)', zip: '117191' },
  { city: 'Strâmbeni (Căldăraru) (Argeş)', zip: '117192' },
  { city: 'Călineşti (Argeş)', zip: '117195' },
  { city: 'Cârstieni (Argeş)', zip: '117196' },
  { city: 'Ciocăneşti (Argeş)', zip: '117197' },
  { city: 'Glodu (Călineşti) (Argeş)', zip: '117198' },
  { city: 'Gorganu (Argeş)', zip: '117199' },
  { city: 'Radu Negru (Argeş)', zip: '117201' },
  { city: 'Râncăciov (Argeş)', zip: '117202' },
  { city: 'Udeni-Zăvoi (Argeş)', zip: '117203' },
  { city: 'Urlucea (Argeş)', zip: '117204' },
  { city: 'Valea Corbului (Argeş)', zip: '117206' },
  { city: 'Văleni-Podgoria (Argeş)', zip: '117207' },
  { city: 'Vrăneşti (Argeş)', zip: '117210' },
  { city: 'Căteasca (Argeş)', zip: '117220' },
  { city: 'Catanele (Argeş)', zip: '117221' },
  { city: 'Cireşu (Argeş)', zip: '117222' },
  { city: 'Coşeri (Argeş)', zip: '117223' },
  { city: 'Gruiu (Căteasca) (Argeş)', zip: '117224' },
  { city: 'Recea (Căteasca) (Argeş)', zip: '117226' },
  { city: 'Siliştea (Argeş)', zip: '117227' },
  { city: 'Cepari (Argeş)', zip: '117230' },
  { city: 'Cărpeniş (Argeş)', zip: '117231' },
  { city: 'Ceparii Pământeni (Argeş)', zip: '117232' },
  { city: 'Ceparii Ungureni (Argeş)', zip: '117233' },
  { city: 'Morăşti (Argeş)', zip: '117234' },
  { city: 'Şendruleşti (Argeş)', zip: '117236' },
  { city: 'Urluieşti (Argeş)', zip: '117237' },
  { city: 'Valea Măgurei (Argeş)', zip: '117238' },
  { city: 'Zamfireşti (Cepari) (Argeş)', zip: '117239' },
  { city: 'Cetăţeni (Argeş)', zip: '117240' },
  { city: 'Lăicăi (Argeş)', zip: '117241' },
  { city: 'Valea Cetăţuia (Argeş)', zip: '117242' },
  { city: 'Cicăneşti (Argeş)', zip: '117245' },
  { city: 'Bărăşti (Argeş)', zip: '117246' },
  { city: 'Mioarele (Cicăneşti) (Argeş)', zip: '117247' },
  { city: 'Urecheşti (Argeş)', zip: '117248' },
  { city: 'Ciofrângeni (Argeş)', zip: '117250' },
  { city: 'Burluşi (Argeş)', zip: '117251' },
  { city: 'Lacurile (Argeş)', zip: '117252' },
  { city: 'Piatra (Ciofrângeni) (Argeş)', zip: '117253' },
  { city: 'Schitu-Matei (Argeş)', zip: '117254' },
  { city: 'Ciomăgeşti (Argeş)', zip: '117255' },
  { city: 'Beculeşti (Argeş)', zip: '117256' },
  { city: 'Bratia (Ciomăgeşti) (Argeş)', zip: '117257' },
  { city: 'Cungrea (Argeş)', zip: '117258' },
  { city: 'Dogari (Argeş)', zip: '117259' },
  { city: 'Fedeleşoiu (Argeş)', zip: '117261' },
  { city: 'Giuclani (Argeş)', zip: '117262' },
  { city: 'Păuneşti (Argeş)', zip: '117263' },
  { city: 'Răduţeşti (Argeş)', zip: '117264' },
  { city: 'Cocu (Argeş)', zip: '117265' },
  { city: 'Bărbăteşti (Argeş)', zip: '117266' },
  { city: 'Crucişoara (Argeş)', zip: '117267' },
  { city: 'Făcăleţeşti (Argeş)', zip: '117268' },
  { city: 'Greabănu (Argeş)', zip: '117269' },
  { city: 'Popeşti (Cocu) (Argeş)', zip: '117271' },
  { city: 'Răchiţele de Jos (Argeş)', zip: '117272' },
  { city: 'Răchiţele de Sus (Argeş)', zip: '117273' },
  { city: 'Corbeni (Argeş)', zip: '117275' },
  { city: 'Berindeşti (Argeş)', zip: '117276' },
  { city: 'Bucşeneşti (Argeş)', zip: '117277' },
  { city: 'Oeştii Pământeni (Argeş)', zip: '117278' },
  { city: 'Oeştii Ungureni (Argeş)', zip: '117279' },
  { city: 'Poienari (Corbeni) (Argeş)', zip: '117281' },
  { city: 'Rotunda (Argeş)', zip: '117282' },
  { city: 'Turburea (Argeş)', zip: '117283' },
  { city: 'Corbi (Argeş)', zip: '117285' },
  { city: 'Corbşori (Argeş)', zip: '117286' },
  { city: 'Jgheaburi (Argeş)', zip: '117287' },
  { city: 'Poduri (Argeş)', zip: '117288' },
  { city: 'Poienărei (Argeş)', zip: '117289' },
  { city: 'Stăneşti (Argeş)', zip: '117291' },
  { city: 'Coşeşti (Argeş)', zip: '117295' },
  { city: 'Jupâneşti (Argeş)', zip: '117296' },
  { city: 'Lăpuşani (Argeş)', zip: '117297' },
  { city: 'Leiceşti (Argeş)', zip: '117298' },
  { city: 'Păcioiu (Argeş)', zip: '117299' },
  { city: 'Petreşti (Argeş)', zip: '117301' },
  { city: 'Priseaca (Argeş)', zip: '117302' },
  { city: 'Cotmeana (Argeş)', zip: '117305' },
  { city: 'Bascovele (Argeş)', zip: '117306' },
  { city: 'Buneşti (Cotmeana) (Argeş)', zip: '117307' },
  { city: 'Dealu Pădurii (Argeş)', zip: '117308' },
  { city: 'Drăgoleşti (Argeş)', zip: '117309' },
  { city: 'Costeşti (Cotmeana) (Argeş)', zip: '117310' },
  { city: 'Linteşti (Argeş)', zip: '117311' },
  { city: 'Negeşti (Argeş)', zip: '117312' },
  { city: 'Pieleşti (Argeş)', zip: '117313' },
  { city: 'Sănduleşti (Argeş)', zip: '117314' },
  { city: 'Spiridoni (Argeş)', zip: '117316' },
  { city: 'Ursoaia (Argeş)', zip: '117317' },
  { city: 'Vârloveni (Argeş)', zip: '117318' },
  { city: 'Zamfireşti (Cotmeana) (Argeş)', zip: '117319' },
  { city: 'Cuca (Argeş)', zip: '117330' },
  { city: 'Bălţata (Argeş)', zip: '117331' },
  { city: 'Bărbălani (Argeş)', zip: '117332' },
  { city: 'Cârceşti (Argeş)', zip: '117333' },
  { city: 'Cotu (Cuca) (Argeş)', zip: '117334' },
  { city: 'Crivăţu (Argeş)', zip: '117336' },
  { city: 'Lăunele de Sus (Argeş)', zip: '117337' },
  { city: 'Măcăi (Argeş)', zip: '117338' },
  { city: 'Măneşti (Argeş)', zip: '117339' },
  { city: 'Sineşti (Argeş)', zip: '117341' },
  { city: 'Stănicei (Argeş)', zip: '117342' },
  { city: 'Teodoreşti (Argeş)', zip: '117343' },
  { city: 'Valea Cucii (Argeş)', zip: '117344' },
  { city: 'Vonigeasa (Argeş)', zip: '117346' },
  { city: 'Davideşti (Argeş)', zip: '117350' },
  { city: 'Conţeşti (Argeş)', zip: '117351' },
  { city: 'Voroveni (Argeş)', zip: '117352' },
  { city: 'Dâmbovicioara (Argeş)', zip: '117355' },
  { city: 'Ciocanu (Argeş)', zip: '117356' },
  { city: 'Podu Dâmboviţei (Argeş)', zip: '117357' },
  { city: 'Dârmăneşti (Argeş)', zip: '117360' },
  { city: 'Negreni (Argeş)', zip: '117361' },
  { city: 'Piscani (Argeş)', zip: '117362' },
  { city: 'Valea Nandrii (Argeş)', zip: '117363' },
  { city: 'Valea Rizii (Argeş)', zip: '117364' },
  { city: 'Dobreşti (Argeş)', zip: '117365' },
  { city: 'Fureşti (Argeş)', zip: '117366' },
  { city: 'Domneşti (Argeş)', zip: '117370' },
  { city: 'Dragoslavele (Argeş)', zip: '117375' },
  { city: 'Valea Hotarului (Argeş)', zip: '117376' },
  { city: 'Drăganu (Argeş)', zip: '117380' },
  { city: 'Băceşti (Argeş)', zip: '117381' },
  { city: 'Drăganu-Olteni (Argeş)', zip: '117382' },
  { city: 'Dumbrăveşti (Argeş)', zip: '117383' },
  { city: 'Prislopu Mare (Argeş)', zip: '117384' },
  { city: 'Godeni (Argeş)', zip: '117385' },
  { city: 'Bordeieni (Argeş)', zip: '117386' },
  { city: 'Capu Piscului (Godeni) (Argeş)', zip: '117387' },
  { city: 'Coteşti (Argeş)', zip: '117388' },
  { city: 'Malu (Godeni) (Argeş)', zip: '117389' },
  { city: 'Hârseşti (Argeş)', zip: '117390' },
  { city: 'Ciobani (Argeş)', zip: '117391' },
  { city: 'Martalogi (Argeş)', zip: '117392' },
  { city: 'Hârtieşti (Argeş)', zip: '117395' },
  { city: 'Bârzeşti (Argeş)', zip: '117396' },
  { city: 'Dealu (Argeş)', zip: '117397' },
  { city: 'Huluba (Argeş)', zip: '117398' },
  { city: 'Lespezi (Argeş)', zip: '117399' },
  { city: 'Lucieni (Argeş)', zip: '117401' },
  { city: 'Vultureşti (Argeş)', zip: '117402' },
  { city: 'Izvoru (Argeş)', zip: '117405' },
  { city: 'Leordeni (Argeş)', zip: '117410' },
  { city: 'Baloteasca (Argeş)', zip: '117411' },
  { city: 'Băila (Argeş)', zip: '117412' },
  { city: 'Bântău (Argeş)', zip: '117413' },
  { city: 'Budişteni (Argeş)', zip: '117414' },
  { city: 'Cârciumăreşti (Argeş)', zip: '117416' },
  { city: 'Ciolceşti (Argeş)', zip: '117417' },
  { city: 'Ciulniţa (Argeş)', zip: '117418' },
  { city: 'Cotu Malului (Argeş)', zip: '117419' },
  { city: 'Glâmbocata (Argeş)', zip: '117421' },
  { city: 'Glâmbocata-Deal (Argeş)', zip: '117422' },
  { city: 'Glodu (Leordeni) (Argeş)', zip: '117423' },
  { city: 'Moara Mocanului (Argeş)', zip: '117424' },
  { city: 'Schitu Scoiceşti (Argeş)', zip: '117426' },
  { city: 'Lereşti (Argeş)', zip: '117430' },
  { city: 'Pojorâta (Argeş)', zip: '117431' },
  { city: 'Voineşti (Argeş)', zip: '117432' },
  { city: 'Lunca Corbului (Argeş)', zip: '117435' },
  { city: 'Bumbueni (Argeş)', zip: '117436' },
  { city: 'Catane (Argeş)', zip: '117437' },
  { city: 'Cieşti (Argeş)', zip: '117438' },
  { city: 'Lăngeşti (Argeş)', zip: '117439' },
  { city: 'Mârghia de Jos (Argeş)', zip: '117441' },
  { city: 'Mârghia de Sus (Argeş)', zip: '117442' },
  { city: 'Pădureţi (Argeş)', zip: '117443' },
  { city: 'Silişteni (Argeş)', zip: '117444' },
  { city: 'Mălureni (Argeş)', zip: '117445' },
  { city: 'Buneşti (Mălureni) (Argeş)', zip: '117446' },
  { city: 'Păuleasca (Mălureni) (Argeş)', zip: '117447' },
  { city: 'Topliţa (Argeş)', zip: '117448' },
  { city: 'Zărneşti (Argeş)', zip: '117449' },
  { city: 'Mărăcineni (Argeş)', zip: '117450' },
  { city: 'Argeşelu (Argeş)', zip: '117451' },
  { city: 'Merişani (Argeş)', zip: '117455' },
  { city: 'Borleşti (Argeş)', zip: '117456' },
  { city: 'Brăteasca (Argeş)', zip: '117457' },
  { city: 'Capu Piscului (Merişani) (Argeş)', zip: '117458' },
  { city: 'Crâmpotani (Argeş)', zip: '117459' },
  { city: 'Dobrogostea (Argeş)', zip: '117461' },
  { city: 'Malu Vânăt (Argeş)', zip: '117462' },
  { city: 'Vărzaru (Argeş)', zip: '117463' },
  { city: 'Vâlcelele (Argeş)', zip: '117464' },
  { city: 'Miceşti (Argeş)', zip: '117465' },
  { city: 'Brânzari (Argeş)', zip: '117466' },
  { city: 'Păuleasca (Miceşti) (Argeş)', zip: '117467' },
  { city: 'Purcăreni (Miceşti) (Argeş)', zip: '117468' },
  { city: 'Mihăeşti (Argeş)', zip: '117470' },
  { city: 'Drăghici (Argeş)', zip: '117471' },
  { city: 'Furnicoşi (Argeş)', zip: '117472' },
  { city: 'Rudeni (Mihăeşti) (Argeş)', zip: '117473' },
  { city: 'Valea Bradului (Argeş)', zip: '117474' },
  { city: 'Valea Popii (Mihăeşti) (Argeş)', zip: '117476' },
  { city: 'Văcarea (Argeş)', zip: '117477' },
  { city: 'Mioarele (Argeş)', zip: '117480' },
  { city: 'Aluniş (Argeş)', zip: '117481' },
  { city: 'Chilii (Argeş)', zip: '117482' },
  { city: 'Coceneşti (Argeş)', zip: '117483' },
  { city: 'Măţău (Argeş)', zip: '117484' },
  { city: 'Suslăneşti (Argeş)', zip: '117486' },
  { city: 'Miroşi (Argeş)', zip: '117490' },
  { city: 'Surduleşti (Argeş)', zip: '117491' },
  { city: 'Morăreşti (Argeş)', zip: '117495' },
  { city: 'Dealu Obejdeanului (Argeş)', zip: '117496' },
  { city: 'Deduleşti (Argeş)', zip: '117497' },
  { city: 'Luminile (Argeş)', zip: '117498' },
  { city: 'Măncioiu (Argeş)', zip: '117499' },
  { city: 'Săpunari (Argeş)', zip: '117501' },
  { city: 'Moşoaia (Argeş)', zip: '117505' },
  { city: 'Bătrâni (Argeş)', zip: '117506' },
  { city: 'Ciocănăi (Argeş)', zip: '117507' },
  { city: 'Dealu Viilor (Moşoaia) (Argeş)', zip: '117508' },
  { city: 'Hinţeşti (Argeş)', zip: '117509' },
  { city: 'Lăzăreşti (Moşoaia) (Argeş)', zip: '117511' },
  { city: 'Smeura (Argeş)', zip: '117512' },
  { city: 'Mozăceni (Argeş)', zip: '117515' },
  { city: 'Babaroaga (Argeş)', zip: '117516' },
  { city: 'Zidurile (Argeş)', zip: '117517' },
  { city: 'Muşăteşti (Argeş)', zip: '117520' },
  { city: 'Bolovăneşti (Argeş)', zip: '117521' },
  { city: 'Costeşti-Vâlsan (Argeş)', zip: '117522' },
  { city: 'Prosia (Argeş)', zip: '117523' },
  { city: 'Robaia (Argeş)', zip: '117524' },
  { city: 'Stroeşti (Argeş)', zip: '117526' },
  { city: 'Valea Faurului (Argeş)', zip: '117527' },
  { city: 'Valea Muscelului (Argeş)', zip: '117528' },
  { city: 'Valea lui Maş (Argeş)', zip: '117529' },
  { city: 'Vâlsăneşti (Argeş)', zip: '117531' },
  { city: 'Negraşi (Argeş)', zip: '117535' },
  { city: 'Bârlogu (Argeş)', zip: '117536' },
  { city: 'Buta (Argeş)', zip: '117537' },
  { city: 'Mozacu (Argeş)', zip: '117538' },
  { city: 'Nucşoara (Argeş)', zip: '117540' },
  { city: 'Gruiu (Nucşoara) (Argeş)', zip: '117541' },
  { city: 'Sboghiţeşti (Argeş)', zip: '117542' },
  { city: 'Slatina (Argeş)', zip: '117543' },
  { city: 'Oarja (Argeş)', zip: '117545' },
  { city: 'Ceauşeşti (Argeş)', zip: '117546' },
  { city: 'Pietroşani (Argeş)', zip: '117550' },
  { city: 'Bădeşti (Pietroşani) (Argeş)', zip: '117551' },
  { city: 'Găneşti (Argeş)', zip: '117552' },
  { city: 'Retevoieşti (Argeş)', zip: '117553' },
  { city: 'Vărzăroaia (Argeş)', zip: '117554' },
  { city: 'Poiana Lacului (Argeş)', zip: '117555' },
  { city: 'Cătunaşi (Argeş)', zip: '117556' },
  { city: 'Cepari (Poiana Lacului) (Argeş)', zip: '117557' },
  { city: 'Dealu Oraşului (Argeş)', zip: '117558' },
  { city: 'Dealu Viilor (Poiana Lacului) (Argeş)', zip: '117559' },
  { city: 'Dinculeşti (Argeş)', zip: '117561' },
  { city: 'Găleţeanu (Argeş)', zip: '117562' },
  { city: 'Gărdineşti (Argeş)', zip: '117563' },
  { city: 'Gâlceşti (Argeş)', zip: '117564' },
  { city: 'Metofu (Argeş)', zip: '117566' },
  { city: 'Păduroiu din Deal (Argeş)', zip: '117567' },
  { city: 'Păduroiu din Vale (Argeş)', zip: '117568' },
  { city: 'Sămara (Argeş)', zip: '117569' },
  { city: 'Poienarii de Argeş (Argeş)', zip: '117575' },
  { city: 'Ceaureşti (Argeş)', zip: '117576' },
  { city: 'Ioaniceşti (Argeş)', zip: '117577' },
  { city: 'Poienari (Poienarii de Argeş) (Argeş)', zip: '117578' },
  { city: 'Tomuleşti (Argeş)', zip: '117579' },
  { city: 'Poienarii de Muscel (Argeş)', zip: '117580' },
  { city: 'Groşani (Argeş)', zip: '117581' },
  { city: 'Jugur (Argeş)', zip: '117582' },
  { city: 'Poienari (Poienarii de Muscel) (Argeş)', zip: '117583' },
  { city: 'Şerbăneşti (Poienarii de Muscel) (Argeş)', zip: '117584' },
  { city: 'Valea Îndărăt (Argeş)', zip: '117586' },
  { city: 'Popeşti (Argeş)', zip: '117590' },
  { city: 'Adunaţi (Argeş)', zip: '117591' },
  { city: 'Bucov (Argeş)', zip: '117592' },
  { city: 'Palanga (Argeş)', zip: '117593' },
  { city: 'Purcăreni (Popeşti) (Argeş)', zip: '117594' },
  { city: 'Râca (Argeş)', zip: '117596' },
  { city: 'Slobozia (Popeşti) (Argeş)', zip: '117597' },
  { city: 'Priboieni (Argeş)', zip: '117600' },
  { city: 'Albotele (Argeş)', zip: '117601' },
  { city: 'Paraschiveşti (Argeş)', zip: '117602' },
  { city: 'Pitoi (Argeş)', zip: '117603' },
  { city: 'Sămăila (Argeş)', zip: '117604' },
  { city: 'Valea Mare (Argeş)', zip: '117606' },
  { city: 'Valea Nenii (Argeş)', zip: '117607' },
  { city: 'Valea Popii (Priboieni) (Argeş)', zip: '117608' },
  { city: 'Răteşti (Argeş)', zip: '117610' },
  { city: 'Ciupa-Mănciulescu (Argeş)', zip: '117611' },
  { city: 'Furdueşti (Argeş)', zip: '117612' },
  { city: 'Mavrodolu (Argeş)', zip: '117613' },
  { city: 'Nejlovelu (Argeş)', zip: '117614' },
  { city: 'Pătuleni (Argeş)', zip: '117616' },
  { city: 'Tigveni (Răteşti) (Argeş)', zip: '117617' },
  { city: 'Recea (Argeş)', zip: '117620' },
  { city: 'Deagu de Jos (Argeş)', zip: '117621' },
  { city: 'Deagu de Sus (Argeş)', zip: '117622' },
  { city: 'Goleasca (Argeş)', zip: '117623' },
  { city: 'Orodel (Argeş)', zip: '117624' },
  { city: 'Rociu (Argeş)', zip: '117625' },
  { city: 'Gliganu de Jos (Argeş)', zip: '117626' },
  { city: 'Gliganu de Sus (Argeş)', zip: '117627' },
  { city: 'Şerbăneşti (Rociu) (Argeş)', zip: '117628' },
  { city: 'Rucăr (Argeş)', zip: '117630' },
  { city: 'Sătic (Argeş)', zip: '117631' },
  { city: 'Sălătrucu (Argeş)', zip: '117635' },
  { city: 'Văleni (Argeş)', zip: '117636' },
  { city: 'Săpata (Argeş)', zip: '117640' },
  { city: 'Bănăreşti (Argeş)', zip: '117641' },
  { city: 'Dealu Bradului (Argeş)', zip: '117642' },
  { city: 'Drăghiceşti (Argeş)', zip: '117643' },
  { city: 'Găinuşa (Argeş)', zip: '117644' },
  { city: 'Lipia (Argeş)', zip: '117646' },
  { city: 'Mârţeşti (Argeş)', zip: '117647' },
  { city: 'Popeşti (Săpata) (Argeş)', zip: '117648' },
  { city: 'Turceşti (Argeş)', zip: '117649' },
  { city: 'Schitu Goleşti (Argeş)', zip: '117650' },
  { city: 'Burneşti (Argeş)', zip: '117651' },
  { city: 'Costiţă (Argeş)', zip: '117652' },
  { city: 'Lăzăreşti (Schitu Goleşti) (Argeş)', zip: '117653' },
  { city: 'Loturi (Argeş)', zip: '117654' },
  { city: 'Valea Pechii (Argeş)', zip: '117656' },
  { city: 'Slobozia (Argeş)', zip: '117660' },
  { city: 'Nigrişoara (Argeş)', zip: '117661' },
  { city: 'Stâlpeni (Argeş)', zip: '117665' },
  { city: 'Dealu Frumos (Argeş)', zip: '117666' },
  { city: 'Livezeni (Argeş)', zip: '117667' },
  { city: 'Ogrezea (Argeş)', zip: '117668' },
  { city: 'Opreşti (Argeş)', zip: '117669' },
  { city: 'Piţigaia (Argeş)', zip: '117671' },
  { city: 'Rădeşti (Argeş)', zip: '117672' },
  { city: 'Stoeneşti (Argeş)', zip: '117675' },
  { city: 'Bădeni (Argeş)', zip: '117676' },
  { city: 'Coteneşti (Argeş)', zip: '117677' },
  { city: 'Lunca Gârtii (Argeş)', zip: '117678' },
  { city: 'Piatra (Stoeneşti) (Argeş)', zip: '117679' },
  { city: 'Slobozia (Stoeneşti) (Argeş)', zip: '117681' },
  { city: 'Valea Bădenilor (Argeş)', zip: '117682' },
  { city: 'Stolnici (Argeş)', zip: '117685' },
  { city: 'Cochineşti (Argeş)', zip: '117686' },
  { city: 'Cotmeana (Stolnici) (Argeş)', zip: '117687' },
  { city: 'Fâlfani (Argeş)', zip: '117688' },
  { city: 'Izbăşeşti (Argeş)', zip: '117689' },
  { city: 'Vlăşcuţa (Argeş)', zip: '117691' },
  { city: 'Suseni (Argeş)', zip: '117695' },
  { city: 'Burdeşti (Argeş)', zip: '117696' },
  { city: 'Cerşani (Argeş)', zip: '117697' },
  { city: 'Chiriţeşti (Suseni) (Argeş)', zip: '117698' },
  { city: 'Gălăşeşti (Suseni) (Argeş)', zip: '117699' },
  { city: 'Odăeni (Argeş)', zip: '117701' },
  { city: 'Pădureni (Argeş)', zip: '117702' },
  { city: 'Strâmbeni (Suseni) (Argeş)', zip: '117703' },
  { city: 'Ştefăneşti (Suseni) (Argeş)', zip: '117704' },
  { city: 'Ţuţuleşti (Argeş)', zip: '117706' },
  { city: 'Ştefan cel Mare (Argeş)', zip: '117710' },
  { city: 'Glavacioc (Argeş)', zip: '117711' },
  { city: 'Ştefăneşti (Argeş)', zip: '117715' },
  { city: 'Enculeşti (Argeş)', zip: '117716' },
  { city: 'Goleşti (Ştefăneşti) (Argeş)', zip: '117717' },
  { city: 'Izvorani (Argeş)', zip: '117718' },
  { city: 'Ştefăneştii Noi (Argeş)', zip: '117719' },
  { city: 'Valea Mare-Podgoria (Argeş)', zip: '117721' },
  { city: 'Viişoara (Argeş)', zip: '117722' },
  { city: 'Zăvoi (Argeş)', zip: '117723' },
  { city: 'Şuici (Argeş)', zip: '117725' },
  { city: 'Ianculeşti (Argeş)', zip: '117726' },
  { city: 'Paltenu (Argeş)', zip: '117727' },
  { city: 'Păuleni (Argeş)', zip: '117728' },
  { city: 'Rudeni (Şuici) (Argeş)', zip: '117729' },
  { city: 'Valea Calului (Argeş)', zip: '117731' },
  { city: 'Teiu (Argeş)', zip: '117735' },
  { city: 'Leşile (Argeş)', zip: '117736' },
  { city: 'Tigveni (Argeş)', zip: '117740' },
  { city: 'Bădislava (Argeş)', zip: '117741' },
  { city: 'Bălileşti (Tigveni) (Argeş)', zip: '117742' },
  { city: 'Bălteni (Argeş)', zip: '117743' },
  { city: 'Bârseştii de Jos (Argeş)', zip: '117744' },
  { city: 'Bârseştii de Sus (Argeş)', zip: '117746' },
  { city: 'Blaju (Argeş)', zip: '117747' },
  { city: 'Vlădeşti (Tigveni) (Argeş)', zip: '117748' },
  { city: 'Ţiţeşti (Argeş)', zip: '117750' },
  { city: 'Bucşeneşti-Lotaşi (Argeş)', zip: '117751' },
  { city: 'Cişmea (Argeş)', zip: '117752' },
  { city: 'Valea Mănăstirii (Argeş)', zip: '117753' },
  { city: 'Valea Stânii (Argeş)', zip: '117754' },
  { city: 'Uda (Argeş)', zip: '117755' },
  { city: 'Băduleşti (Argeş)', zip: '117756' },
  { city: 'Bărăneşti (Argeş)', zip: '117757' },
  { city: 'Braniştea (Argeş)', zip: '117758' },
  { city: 'Chiriţeşti (Uda) (Argeş)', zip: '117759' },
  { city: 'Cotu (Uda) (Argeş)', zip: '117761' },
  { city: 'Dealu Bisericii (Argeş)', zip: '117762' },
  { city: 'Dealu Tolcesii (Argeş)', zip: '117763' },
  { city: 'Diconeşti (Argeş)', zip: '117764' },
  { city: 'Gorani (Argeş)', zip: '117766' },
  { city: 'Greabăn (Argeş)', zip: '117767' },
  { city: 'Lunguleşti (Argeş)', zip: '117768' },
  { city: 'Miercani (Argeş)', zip: '117769' },
  { city: 'Râjleţu-Govora (Argeş)', zip: '117771' },
  { city: 'Romana (Argeş)', zip: '117772' },
  { city: 'Săliştea (Argeş)', zip: '117773' },
  { city: 'Ungheni (Argeş)', zip: '117780' },
  { city: 'Colţu (Argeş)', zip: '117781' },
  { city: 'Găujani (Argeş)', zip: '117782' },
  { city: 'Goia (Argeş)', zip: '117783' },
  { city: 'Humele (Argeş)', zip: '117784' },
  { city: 'Satu Nou (Argeş)', zip: '117786' },
  { city: 'Valea Danului (Argeş)', zip: '117790' },
  { city: 'Băniceşti (Argeş)', zip: '117791' },
  { city: 'Bolculeşti (Argeş)', zip: '117792' },
  { city: 'Borobăneşti (Argeş)', zip: '117793' },
  { city: 'Verneşti (Argeş)', zip: '117794' },
  { city: 'Valea Iaşului (Argeş)', zip: '117795' },
  { city: 'Bădila (Argeş)', zip: '117796' },
  { city: 'Bărbălăteşti (Argeş)', zip: '117797' },
  { city: 'Borovineşti (Argeş)', zip: '117798' },
  { city: 'Cerbureni (Argeş)', zip: '117799' },
  { city: 'Mustăţeşti (Argeş)', zip: '117801' },
  { city: 'Ruginoasa (Argeş)', zip: '117802' },
  { city: 'Ungureni (Valea Iaşului) (Argeş)', zip: '117803' },
  { city: 'Valea Uleiului (Argeş)', zip: '117804' },
  { city: 'Valea Mare-Pravăţ (Argeş)', zip: '117805' },
  { city: 'Bilceşti (Argeş)', zip: '117806' },
  { city: 'Colnic (Argeş)', zip: '117807' },
  { city: 'Fântânea (Argeş)', zip: '117808' },
  { city: 'Gura Pravăţ (Argeş)', zip: '117809' },
  { city: 'Nămăeşti (Argeş)', zip: '117811' },
  { city: 'Pietroasa (Argeş)', zip: '117812' },
  { city: 'Şelari (Argeş)', zip: '117813' },
  { city: 'Vedea (Argeş)', zip: '117815' },
  { city: 'Bădicea (Argeş)', zip: '117816' },
  { city: 'Blejani (Argeş)', zip: '117817' },
  { city: 'Bureţeşti (Argeş)', zip: '117818' },
  { city: 'Chiriţeşti (Vedea) (Argeş)', zip: '117819' },
  { city: 'Chiţani (Argeş)', zip: '117821' },
  { city: 'Ciureşti (Argeş)', zip: '117822' },
  { city: 'Dincani (Argeş)', zip: '117823' },
  { city: 'Fata (Argeş)', zip: '117824' },
  { city: 'Frătici (Argeş)', zip: '117826' },
  { city: 'Izvoru de Jos (Argeş)', zip: '117827' },
  { city: 'Izvoru de Sus (Argeş)', zip: '117828' },
  { city: 'Lungani (Argeş)', zip: '117829' },
  { city: 'Mogoşeşti (Argeş)', zip: '117831' },
  { city: 'Prodani (Argeş)', zip: '117832' },
  { city: 'Răţoi (Argeş)', zip: '117833' },
  { city: 'Vaţa (Argeş)', zip: '117834' },
  { city: 'Vârşeşti (Argeş)', zip: '117836' },
  { city: 'Veţişoara (Argeş)', zip: '117837' },
  { city: 'Vlădeşti (Argeş)', zip: '117840' },
  { city: 'Coteasca (Argeş)', zip: '117841' },
  { city: 'Drăghescu (Argeş)', zip: '117842' },
  { city: 'Putina (Argeş)', zip: '117843' },
  { city: 'Bacău (Bacău)', zip: '600001' },
  { city: 'Borzeşti (Bacău)', zip: '601001' },
  { city: 'Slobozia (Oneşti) (Bacău)', zip: '601002' },
  { city: 'Oneşti (Bacău)', zip: '601003' },
  { city: 'Buhuşi (Bacău)', zip: '605100' },
  { city: 'Marginea (Buhuşi) (Bacău)', zip: '605101' },
  { city: 'Runcu (Bacău)', zip: '605102' },
  { city: 'Comăneşti (Bacău)', zip: '605200' },
  { city: 'Podei (Bacău)', zip: '605201' },
  { city: 'Vermeşti (Bacău)', zip: '605202' },
  { city: 'Dărmăneşti (Bacău)', zip: '605300' },
  { city: 'Dărmăneasca (Bacău)', zip: '605301' },
  { city: 'Lapoş (Bacău)', zip: '605302' },
  { city: 'Păgubeni (Bacău)', zip: '605303' },
  { city: 'Plopu (Dărmăneşti) (Bacău)', zip: '605304' },
  { city: 'Sălătruc (Bacău)', zip: '605305' },
  { city: 'Moineşti (Bacău)', zip: '605400' },
  { city: 'Găzărie (Bacău)', zip: '605401' },
  { city: 'Slănic-Moldova (Bacău)', zip: '605500' },
  { city: 'Cerdac (Bacău)', zip: '605501' },
  { city: 'Cireşoaia (Bacău)', zip: '605502' },
  { city: 'Târgu Ocna (Bacău)', zip: '605600' },
  { city: 'Poieni (Târgu Ocna) (Bacău)', zip: '605601' },
  { city: 'Vâlcele (Târgu Ocna) (Bacău)', zip: '605602' },
  { city: 'Agăş (Bacău)', zip: '607005' },
  { city: 'Beleghet (Bacău)', zip: '607006' },
  { city: 'Coşnea (Bacău)', zip: '607007' },
  { city: 'Cotumba (Bacău)', zip: '607008' },
  { city: 'Diaconeşti (Bacău)', zip: '607009' },
  { city: 'Goioasa (Bacău)', zip: '607011' },
  { city: 'Preluci (Bacău)', zip: '607012' },
  { city: 'Sulţa (Bacău)', zip: '607013' },
  { city: 'Ardeoani (Bacău)', zip: '607015' },
  { city: 'Leontineşti (Bacău)', zip: '607016' },
  { city: 'Asău (Bacău)', zip: '607020' },
  { city: 'Apa Asău (Bacău)', zip: '607021' },
  { city: 'Ciobănuş (Bacău)', zip: '607022' },
  { city: 'Lunca Asău (Bacău)', zip: '607023' },
  { city: 'Păltiniş (Bacău)', zip: '607024' },
  { city: 'Straja (Bacău)', zip: '607026' },
  { city: 'Balcani (Bacău)', zip: '607030' },
  { city: 'Frumoasa (Bacău)', zip: '607031' },
  { city: 'Ludaşi (Bacău)', zip: '607032' },
  { city: 'Schitu Frumoasa (Bacău)', zip: '607033' },
  { city: 'Bârsăneşti (Bacău)', zip: '607035' },
  { city: 'Albele (Bacău)', zip: '607036' },
  { city: 'Brăteşti (Bacău)', zip: '607037' },
  { city: 'Caraclău (Bacău)', zip: '607038' },
  { city: 'Bereşti-Bistriţa (Bacău)', zip: '607040' },
  { city: 'Brad (Bereşti-Bistriţa) (Bacău)', zip: '607041' },
  { city: 'Ciumaşi (Bacău)', zip: '607042' },
  { city: 'Climeşti (Bacău)', zip: '607043' },
  { city: 'Dumbrava (Iteşti) (Bacău)', zip: '607044' },
  { city: 'Făgeţel (Bacău)', zip: '607046' },
  { city: 'Iteşti (Bacău)', zip: '607047' },
  { city: 'Pădureni (Bereşti-Bistriţa) (Bacău)', zip: '607048' },
  { city: 'Bereşti-Tazlău (Bacău)', zip: '607050' },
  { city: 'Boşoteni (Bacău)', zip: '607051' },
  { city: 'Enăcheşti (Bacău)', zip: '607052' },
  { city: 'Prisaca (Bacău)', zip: '607053' },
  { city: 'Româneşti (Bacău)', zip: '607054' },
  { city: 'Tescani (Bacău)', zip: '607056' },
  { city: 'Turluianu (Bacău)', zip: '607057' },
  { city: 'Berzunţi (Bacău)', zip: '607060' },
  { city: 'Buda (Berzunţi) (Bacău)', zip: '607061' },
  { city: 'Dragomir (Bacău)', zip: '607062' },
  { city: 'Blăgeşti (Bacău)', zip: '607065' },
  { city: 'Buda (Blăgeşti) (Bacău)', zip: '607066' },
  { city: 'Poiana Negustorului (Bacău)', zip: '607067' },
  { city: 'Ţârdenii Mari (Bacău)', zip: '607068' },
  { city: 'Valea lui Ion (Bacău)', zip: '607069' },
  { city: 'Bogdăneşti (Bacău)', zip: '607070' },
  { city: 'Filipeşti (Bogdăneşti) (Bacău)', zip: '607071' },
  { city: 'Brusturoasa (Bacău)', zip: '607075' },
  { city: 'Buruieniş (Bacău)', zip: '607076' },
  { city: 'Buruienişu de Sus (Bacău)', zip: '607077' },
  { city: 'Camenca (Bacău)', zip: '607078' },
  { city: 'Cuchiniş (Bacău)', zip: '607079' },
  { city: 'Hângăneşti (Bacău)', zip: '607081' },
  { city: 'Buhoci (Bacău)', zip: '607085' },
  { city: 'Bijghir (Bacău)', zip: '607086' },
  { city: 'Buhocel (Bacău)', zip: '607087' },
  { city: 'Coteni (Bacău)', zip: '607088' },
  { city: 'Dospineşti (Bacău)', zip: '607089' },
  { city: 'Caşin (Bacău)', zip: '607090' },
  { city: 'Curiţa (Bacău)', zip: '607091' },
  { city: 'Căiuţi (Bacău)', zip: '607095' },
  { city: 'Blidari (Bacău)', zip: '607096' },
  { city: 'Boiştea (Bacău)', zip: '607097' },
  { city: 'Floreşti (Căiuţi) (Bacău)', zip: '607098' },
  { city: 'Heltiu (Bacău)', zip: '607099' },
  { city: 'Mărceşti (Bacău)', zip: '607101' },
  { city: 'Popeni (Bacău)', zip: '607102' },
  { city: 'Pralea (Bacău)', zip: '607103' },
  { city: 'Vrânceni (Bacău)', zip: '607104' },
  { city: 'Cleja (Bacău)', zip: '607105' },
  { city: 'Somuşca (Bacău)', zip: '607106' },
  { city: 'Valea Mică (Cleja) (Bacău)', zip: '607107' },
  { city: 'Coloneşti (Bacău)', zip: '607110' },
  { city: 'Călini (Bacău)', zip: '607111' },
  { city: 'Poiana (Coloneşti) (Bacău)', zip: '607112' },
  { city: 'Satu Nou (Coloneşti) (Bacău)', zip: '607113' },
  { city: 'Spria (Bacău)', zip: '607114' },
  { city: 'Valea Mare (Coloneşti) (Bacău)', zip: '607116' },
  { city: 'Zăpodia (Coloneşti) (Bacău)', zip: '607117' },
  { city: 'Corbasca (Bacău)', zip: '607120' },
  { city: 'Băcioiu (Bacău)', zip: '607121' },
  { city: 'Marvila (Bacău)', zip: '607122' },
  { city: 'Pogleţ (Bacău)', zip: '607123' },
  { city: 'Rogoaza (Bacău)', zip: '607124' },
  { city: 'Scărişoara (Bacău)', zip: '607126' },
  { city: 'Vâlcele (Corbasca) (Bacău)', zip: '607127' },
  { city: 'Coţofăneşti (Bacău)', zip: '607130' },
  { city: 'Bâlca (Bacău)', zip: '607131' },
  { city: 'Boiştea de Jos (Bacău)', zip: '607132' },
  { city: 'Borşani (Bacău)', zip: '607133' },
  { city: 'Tămăşoaia (Bacău)', zip: '607134' },
  { city: 'Dămieneşti (Bacău)', zip: '607135' },
  { city: 'Călugăreni (Bacău)', zip: '607136' },
  { city: 'Drăgeşti (Dămieneşti) (Bacău)', zip: '607137' },
  { city: 'Pădureni (Dămieneşti) (Bacău)', zip: '607138' },
  { city: 'Dealu Morii (Bacău)', zip: '607140' },
  { city: 'Banca (Bacău)', zip: '607141' },
  { city: 'Bălăneşti (Dealu Morii) (Bacău)', zip: '607142' },
  { city: 'Blaga (Bacău)', zip: '607143' },
  { city: 'Boboş (Bacău)', zip: '607144' },
  { city: 'Bodeasa (Bacău)', zip: '607146' },
  { city: 'Bostăneşti (Bacău)', zip: '607147' },
  { city: 'Calapodeşti (Bacău)', zip: '607148' },
  { city: 'Căuia (Bacău)', zip: '607149' },
  { city: 'Dorofei (Bacău)', zip: '607151' },
  { city: 'Ghionoaia (Bacău)', zip: '607152' },
  { city: 'Grădeşti (Bacău)', zip: '607153' },
  { city: 'Neguleşti (Bacău)', zip: '607154' },
  { city: 'Tăvădăreşti (Bacău)', zip: '607156' },
  { city: 'Dofteana (Bacău)', zip: '607160' },
  { city: 'Bogata (Bacău)', zip: '607161' },
  { city: 'Cucuieţi (Dofteana) (Bacău)', zip: '607162' },
  { city: 'Hăghiac (Dofteana) (Bacău)', zip: '607163' },
  { city: 'Larga (Bacău)', zip: '607164' },
  { city: 'Seaca (Bacău)', zip: '607166' },
  { city: 'Ştefan Vodă (Bacău)', zip: '607167' },
  { city: 'Faraoani (Bacău)', zip: '607170' },
  { city: 'Filipeni (Bacău)', zip: '607175' },
  { city: 'Bălaia (Bacău)', zip: '607176' },
  { city: 'Brad (Filipeni) (Bacău)', zip: '607177' },
  { city: 'Frunteşti (Bacău)', zip: '607178' },
  { city: 'Mărăşti (Bacău)', zip: '607179' },
  { city: 'Pădureni (Filipeni) (Bacău)', zip: '607181' },
  { city: 'Slobozia (Filipeni) (Bacău)', zip: '607182' },
  { city: 'Valea Boţului (Bacău)', zip: '607183' },
  { city: 'Filipeşti (Bacău)', zip: '607185' },
  { city: 'Boanţa (Bacău)', zip: '607186' },
  { city: 'Cârligi (Bacău)', zip: '607187' },
  { city: 'Corneşti (Bacău)', zip: '607188' },
  { city: 'Cotu Grosului (Bacău)', zip: '607189' },
  { city: 'Galbeni (Filipeşti) (Bacău)', zip: '607191' },
  { city: 'Hârleşti (Bacău)', zip: '607192' },
  { city: 'Onişcani (Bacău)', zip: '607193' },
  { city: 'Găiceana (Bacău)', zip: '607195' },
  { city: 'Arini (Bacău)', zip: '607196' },
  { city: 'Huţu (Bacău)', zip: '607197' },
  { city: 'Popeşti (Bacău)', zip: '607198' },
  { city: 'Gârleni (Bacău)', zip: '607200' },
  { city: 'Gârlenii de Sus (Bacău)', zip: '607201' },
  { city: 'Lespezi (Bacău)', zip: '607202' },
  { city: 'Şurina (Bacău)', zip: '607203' },
  { city: 'Ghimeş-Făget (Bacău)', zip: '607205' },
  { city: 'Bolovăniş (Bacău)', zip: '607206' },
  { city: 'Făget (Bacău)', zip: '607207' },
  { city: 'Făgetu de Sus (Bacău)', zip: '607208' },
  { city: 'Ghimeş (Bacău)', zip: '607209' },
  { city: 'Răchitiş (Bacău)', zip: '607211' },
  { city: 'Tărhăuşi (Bacău)', zip: '607212' },
  { city: 'Glăvăneşti (Bacău)', zip: '607215' },
  { city: 'Frumuşelu (Bacău)', zip: '607216' },
  { city: 'Muncelu (Bacău)', zip: '607217' },
  { city: 'Putredeni (Bacău)', zip: '607218' },
  { city: 'Răzeşu (Bacău)', zip: '607219' },
  { city: 'Gura Văii (Bacău)', zip: '607220' },
  { city: 'Capăta (Bacău)', zip: '607221' },
  { city: 'Dumbrava (Gura Văii) (Bacău)', zip: '607222' },
  { city: 'Motoceşti (Bacău)', zip: '607223' },
  { city: 'Păltinata (Bacău)', zip: '607224' },
  { city: 'Temelia (Bacău)', zip: '607226' },
  { city: 'Helegiu (Bacău)', zip: '607230' },
  { city: 'Brătila (Bacău)', zip: '607231' },
  { city: 'Deleni (Bacău)', zip: '607232' },
  { city: 'Drăgugeşti (Bacău)', zip: '607233' },
  { city: 'Hemeiuş (Bacău)', zip: '607235' },
  { city: 'Fântânele (Hemeiuş) (Bacău)', zip: '607236' },
  { city: 'Lilieci (Bacău)', zip: '607237' },
  { city: 'Horgeşti (Bacău)', zip: '607240' },
  { city: 'Bazga (Bacău)', zip: '607241' },
  { city: 'Galeri (Bacău)', zip: '607242' },
  { city: 'Mărăscu (Bacău)', zip: '607243' },
  { city: 'Răcătău de Jos (Bacău)', zip: '607244' },
  { city: 'Răcătău-Răzeşi (Bacău)', zip: '607246' },
  { city: 'Recea (Bacău)', zip: '607247' },
  { city: 'Sohodor (Bacău)', zip: '607248' },
  { city: 'Huruieşti (Bacău)', zip: '607250' },
  { city: 'Căpoteşti (Bacău)', zip: '607251' },
  { city: 'Floreşti (Huruieşti) (Bacău)', zip: '607252' },
  { city: 'Fundoaia (Bacău)', zip: '607253' },
  { city: 'Ocheni (Bacău)', zip: '607254' },
  { city: 'Perchiu (Bacău)', zip: '607256' },
  { city: 'Prădaiş (Bacău)', zip: '607257' },
  { city: 'Izvoru Berheciului (Bacău)', zip: '607260' },
  { city: 'Antoheşti (Bacău)', zip: '607261' },
  { city: 'Băimac (Bacău)', zip: '607262' },
  { city: 'Făghieni (Bacău)', zip: '607263' },
  { city: 'Obârşia (Bacău)', zip: '607264' },
  { city: 'Oţeleşti (Bacău)', zip: '607266' },
  { city: 'Pădureni (Izvoru Berheciului) (Bacău)', zip: '607267' },
  { city: 'Letea Veche (Bacău)', zip: '607270' },
  { city: 'Holt (Bacău)', zip: '607271' },
  { city: 'Radomireşti (Bacău)', zip: '607272' },
  { city: 'Ruşi-Ciutea (Bacău)', zip: '607273' },
  { city: 'Siretu (Letea Veche) (Bacău)', zip: '607274' },
  { city: 'Lipova (Bacău)', zip: '607275' },
  { city: 'Mâlosu (Bacău)', zip: '607276' },
  { city: 'Satu Nou (Lipova) (Bacău)', zip: '607277' },
  { city: 'Valea Caselor (Bacău)', zip: '607278' },
  { city: 'Valea Hogei (Bacău)', zip: '607279' },
  { city: 'Valea Mărului (Bacău)', zip: '607281' },
  { city: 'Valea Moşneagului (Bacău)', zip: '607282' },
  { city: 'Livezi (Bacău)', zip: '607285' },
  { city: 'Bălăneasa (Bacău)', zip: '607286' },
  { city: 'Orăşa (Bacău)', zip: '607287' },
  { city: 'Poiana (Livezi) (Bacău)', zip: '607288' },
  { city: 'Prăjoaia (Bacău)', zip: '607289' },
  { city: 'Scăriga (Bacău)', zip: '607291' },
  { city: 'Luizi-Călugăra (Bacău)', zip: '607295' },
  { city: 'Osebiţi (Bacău)', zip: '607296' },
  { city: 'Măgireşti (Bacău)', zip: '607300' },
  { city: 'Prăjeşti (Măgireşti) (Bacău)', zip: '607301' },
  { city: 'Stăneşti (Bacău)', zip: '607302' },
  { city: 'Şesuri (Bacău)', zip: '607303' },
  { city: 'Valea Arinilor (Bacău)', zip: '607304' },
  { city: 'Măgura (Bacău)', zip: '607305' },
  { city: 'Crihan (Bacău)', zip: '607306' },
  { city: 'Dealu Mare (Bacău)', zip: '607307' },
  { city: 'Sohodol (Bacău)', zip: '607308' },
  { city: 'Mănăstirea Caşin (Bacău)', zip: '607310' },
  { city: 'Lupeşti (Bacău)', zip: '607311' },
  { city: 'Pârvuleşti (Bacău)', zip: '607312' },
  { city: 'Scutaru (Bacău)', zip: '607313' },
  { city: 'Mărgineni (Bacău)', zip: '607315' },
  { city: 'Baraţi (Bacău)', zip: '607316' },
  { city: 'Luncani (Bacău)', zip: '607317' },
  { city: 'Pădureni (Mărgineni) (Bacău)', zip: '607318' },
  { city: 'Podiş (Bacău)', zip: '607319' },
  { city: 'Poiana (Mărgineni) (Bacău)', zip: '607321' },
  { city: 'Trebeş (Bacău)', zip: '607322' },
  { city: 'Valea Budului (Bacău)', zip: '607323' },
  { city: 'Motoşeni (Bacău)', zip: '607325' },
  { city: 'Bâcleşti (Bacău)', zip: '607326' },
  { city: 'Chetreni (Bacău)', zip: '607327' },
  { city: 'Chicerea (Bacău)', zip: '607328' },
  { city: 'Cociu (Bacău)', zip: '607329' },
  { city: 'Cornăţelu (Bacău)', zip: '607331' },
  { city: 'Fântânele (Motoşeni) (Bacău)', zip: '607332' },
  { city: 'Fundătura (Bacău)', zip: '607333' },
  { city: 'Gura Crăieşti (Bacău)', zip: '607334' },
  { city: 'Poiana (Motoşeni) (Bacău)', zip: '607336' },
  { city: 'Praja (Bacău)', zip: '607337' },
  { city: 'Rotăria (Bacău)', zip: '607338' },
  { city: 'Şendreşti (Bacău)', zip: '607339' },
  { city: 'Ţepoaia (Bacău)', zip: '607341' },
  { city: 'Negri (Bacău)', zip: '607345' },
  { city: 'Brad (Negri) (Bacău)', zip: '607346' },
  { city: 'Călineşti (Bacău)', zip: '607347' },
  { city: 'Mâgla (Bacău)', zip: '607348' },
  { city: 'Poiana (Negri) (Bacău)', zip: '607349' },
  { city: 'Ursoaia (Bacău)', zip: '607351' },
  { city: 'Nicolae Bălcescu (Bacău)', zip: '607355' },
  { city: 'Bălţata (Bacău)', zip: '607356' },
  { city: 'Buchila (Bacău)', zip: '607357' },
  { city: 'Galbeni (Nicolae Bălcescu) (Bacău)', zip: '607358' },
  { city: 'Lărguţa (Bacău)', zip: '607359' },
  { city: 'Sărata (Nicolae Bălcescu) (Bacău)', zip: '607361' },
  { city: 'Valea Seacă (Nicolae Bălcescu) (Bacău)', zip: '607362' },
  { city: 'Oituz (Bacău)', zip: '607365' },
  { city: 'Călcâi (Bacău)', zip: '607366' },
  { city: 'Ferestrău-Oituz (Bacău)', zip: '607367' },
  { city: 'Hârja (Bacău)', zip: '607368' },
  { city: 'Marginea (Oituz) (Bacău)', zip: '607369' },
  { city: 'Poiana Sărată (Bacău)', zip: '607371' },
  { city: 'Onceşti (Bacău)', zip: '607375' },
  { city: 'Bărboasa (Bacău)', zip: '607376' },
  { city: 'Dealu Perjului (Bacău)', zip: '607377' },
  { city: 'Onceştii Vechi (Bacău)', zip: '607378' },
  { city: 'Satu Nou (Onceşti) (Bacău)', zip: '607379' },
  { city: 'Tarniţa (Bacău)', zip: '607381' },
  { city: 'Taula (Bacău)', zip: '607382' },
  { city: 'Orbeni (Bacău)', zip: '607385' },
  { city: 'Scurta (Bacău)', zip: '607386' },
  { city: 'Palanca (Bacău)', zip: '607390' },
  { city: 'Cădăreşti (Bacău)', zip: '607391' },
  { city: 'Ciugheş (Bacău)', zip: '607392' },
  { city: 'Pajiştea (Bacău)', zip: '607393' },
  { city: 'Popoiu (Bacău)', zip: '607394' },
  { city: 'Parava (Bacău)', zip: '607395' },
  { city: 'Drăguşani (Bacău)', zip: '607396' },
  { city: 'Rădoaia (Bacău)', zip: '607397' },
  { city: 'Teiuş (Bacău)', zip: '607398' },
  { city: 'Parincea (Bacău)', zip: '607400' },
  { city: 'Barna (Bacău)', zip: '607401' },
  { city: 'Mileştii de Jos (Bacău)', zip: '607402' },
  { city: 'Mileştii de Sus (Bacău)', zip: '607403' },
  { city: 'Năneşti (Bacău)', zip: '607404' },
  { city: 'Năstăseni (Bacău)', zip: '607406' },
  { city: 'Poieni (Parincea) (Bacău)', zip: '607407' },
  { city: 'Satu Nou (Parincea) (Bacău)', zip: '607408' },
  { city: 'Văleni (Parincea) (Bacău)', zip: '607409' },
  { city: 'Vladnic (Bacău)', zip: '607411' },
  { city: 'Pânceşti (Bacău)', zip: '607415' },
  { city: 'Chilia Benei (Bacău)', zip: '607416' },
  { city: 'Dieneţ (Bacău)', zip: '607417' },
  { city: 'Fulgeriş (Bacău)', zip: '607418' },
  { city: 'Fundu Văii (Bacău)', zip: '607419' },
  { city: 'Motoc (Bacău)', zip: '607421' },
  { city: 'Petreşti (Bacău)', zip: '607422' },
  { city: 'Soci (Bacău)', zip: '607423' },
  { city: 'Pârgăreşti (Bacău)', zip: '607425' },
  { city: 'Bahna (Bacău)', zip: '607426' },
  { city: 'Nicoreşti (Bacău)', zip: '607427' },
  { city: 'Pârâu Boghii (Bacău)', zip: '607428' },
  { city: 'Satu Nou (Pârgăreşti) (Bacău)', zip: '607429' },
  { city: 'Pârjol (Bacău)', zip: '607430' },
  { city: 'Băhnăşeni (Bacău)', zip: '607431' },
  { city: 'Bărneşti (Bacău)', zip: '607432' },
  { city: 'Băsăşti (Bacău)', zip: '607433' },
  { city: 'Câmpeni (Bacău)', zip: '607434' },
  { city: 'Hăineala (Bacău)', zip: '607436' },
  { city: 'Pustiana (Bacău)', zip: '607437' },
  { city: 'Tărâţa (Bacău)', zip: '607438' },
  { city: 'Hemieni (Bacău)', zip: '607439' },
  { city: 'Plopana (Bacău)', zip: '607440' },
  { city: 'Budeşti (Bacău)', zip: '607441' },
  { city: 'Dorneni (Plopana) (Bacău)', zip: '607442' },
  { city: 'Fundu Tutovei (Bacău)', zip: '607443' },
  { city: 'Iţcani (Bacău)', zip: '607444' },
  { city: 'Rusenii Răzeşi (Bacău)', zip: '607446' },
  { city: 'Rusenii de Sus (Bacău)', zip: '607447' },
  { city: 'Străminoasa (Bacău)', zip: '607448' },
  { city: 'Ţâgâra (Bacău)', zip: '607449' },
  { city: 'Podu Turcului (Bacău)', zip: '607450' },
  { city: 'Bălăneşti (Podu Turcului) (Bacău)', zip: '607451' },
  { city: 'Căbeşti (Bacău)', zip: '607452' },
  { city: 'Fichiteşti (Bacău)', zip: '607453' },
  { city: 'Giurgioana (Bacău)', zip: '607454' },
  { city: 'Hanţa (Bacău)', zip: '607456' },
  { city: 'Lehancea (Bacău)', zip: '607457' },
  { city: 'Plopu (Podu Turcului) (Bacău)', zip: '607458' },
  { city: 'Răcuşana (Bacău)', zip: '607459' },
  { city: 'Sârbi (Bacău)', zip: '607461' },
  { city: 'Poduri (Bacău)', zip: '607465' },
  { city: 'Bucşeşti (Bacău)', zip: '607466' },
  { city: 'Cernu (Bacău)', zip: '607467' },
  { city: 'Cornet (Bacău)', zip: '607468' },
  { city: 'Negreni (Bacău)', zip: '607469' },
  { city: 'Prohozeşti (Bacău)', zip: '607471' },
  { city: 'Valea Şoşii (Bacău)', zip: '607472' },
  { city: 'Racova (Bacău)', zip: '607475' },
  { city: 'Gura Văii (Racova) (Bacău)', zip: '607476' },
  { city: 'Hălmăcioaia (Bacău)', zip: '607477' },
  { city: 'Ilieşi (Bacău)', zip: '607478' },
  { city: 'Răcăciuni (Bacău)', zip: '607480' },
  { city: 'Ciucani (Bacău)', zip: '607481' },
  { city: 'Fundu Răcăciuni (Bacău)', zip: '607482' },
  { city: 'Gâşteni (Bacău)', zip: '607483' },
  { city: 'Gheorghe Doja (Bacău)', zip: '607484' },
  { city: 'Răstoaca (Bacău)', zip: '607486' },
  { city: 'Răchitoasa (Bacău)', zip: '607490' },
  { city: 'Barcana (Bacău)', zip: '607491' },
  { city: 'Bucşa (Bacău)', zip: '607492' },
  { city: 'Buda (Răchitoasa) (Bacău)', zip: '607493' },
  { city: 'Burdusaci (Bacău)', zip: '607494' },
  { city: 'Dănăila (Bacău)', zip: '607496' },
  { city: 'Dumbrava (Răchitoasa) (Bacău)', zip: '607497' },
  { city: 'Farcaşa (Bacău)', zip: '607498' },
  { city: 'Fundătura Răchitoasa (Bacău)', zip: '607499' },
  { city: 'Hăghiac (Răchitoasa) (Bacău)', zip: '607501' },
  { city: 'Magazia (Bacău)', zip: '607502' },
  { city: 'Moviliţa (Bacău)', zip: '607503' },
  { city: 'Oprişeşti (Bacău)', zip: '607504' },
  { city: 'Putini (Bacău)', zip: '607506' },
  { city: 'Tochilea (Bacău)', zip: '607507' },
  { city: 'Roşiori (Bacău)', zip: '607510' },
  { city: 'Misihăneşti (Bacău)', zip: '607511' },
  { city: 'Neguşeni (Bacău)', zip: '607512' },
  { city: 'Poieni (Roşiori) (Bacău)', zip: '607513' },
  { city: 'Valea Mare (Roşiori) (Bacău)', zip: '607514' },
  { city: 'Valea Mică (Roşiori) (Bacău)', zip: '607516' },
  { city: 'Sascut (Bacău)', zip: '607520' },
  { city: 'Bereşti (Bacău)', zip: '607521' },
  { city: 'Conţeşti (Bacău)', zip: '607522' },
  { city: 'Pănceşti (Sascut) (Bacău)', zip: '607523' },
  { city: 'Sascut-Sat (Bacău)', zip: '607524' },
  { city: 'Schineni (Sascut) (Bacău)', zip: '607526' },
  { city: 'Valea Nacului (Bacău)', zip: '607527' },
  { city: 'Sănduleni (Bacău)', zip: '607530' },
  { city: 'Bârzuleşti (Bacău)', zip: '607531' },
  { city: 'Coman (Bacău)', zip: '607532' },
  { city: 'Mateieşti (Bacău)', zip: '607533' },
  { city: 'Stufu (Bacău)', zip: '607534' },
  { city: 'Tisa (Bacău)', zip: '607536' },
  { city: 'Verşeşti (Bacău)', zip: '607537' },
  { city: 'Săuceşti (Bacău)', zip: '607540' },
  { city: 'Bogdan Vodă (Bacău)', zip: '607541' },
  { city: 'Costei (Bacău)', zip: '607542' },
  { city: 'Schineni (Săuceşti) (Bacău)', zip: '607543' },
  { city: 'Siretu (Săuceşti) (Bacău)', zip: '607544' },
  { city: 'Şerbeşti (Bacău)', zip: '607546' },
  { city: 'Scorţeni (Bacău)', zip: '607550' },
  { city: 'Bogdăneşti (Scorţeni) (Bacău)', zip: '607551' },
  { city: 'Floreşti (Scorţeni) (Bacău)', zip: '607552' },
  { city: 'Grigoreni (Bacău)', zip: '607553' },
  { city: 'Stejaru (Bacău)', zip: '607554' },
  { city: 'Şerpeni (Bacău)', zip: '607556' },
  { city: 'Secuieni (Bacău)', zip: '607560' },
  { city: 'Băluşa (Bacău)', zip: '607561' },
  { city: 'Berbinceni (Bacău)', zip: '607562' },
  { city: 'Chiticeni (Bacău)', zip: '607563' },
  { city: 'Ciutureşti (Bacău)', zip: '607564' },
  { city: 'Fundeni (Bacău)', zip: '607566' },
  { city: 'Glodişoarele (Bacău)', zip: '607567' },
  { city: 'Odobeşti (Bacău)', zip: '607568' },
  { city: 'Tisa-Silvestri (Bacău)', zip: '607569' },
  { city: 'Valea Fânaţului (Bacău)', zip: '607571' },
  { city: 'Văleni (Secuieni) (Bacău)', zip: '607572' },
  { city: 'Solonţ (Bacău)', zip: '607580' },
  { city: 'Cucuieţi (Solonţ) (Bacău)', zip: '607581' },
  { city: 'Sărata (Solonţ) (Bacău)', zip: '607582' },
  { city: 'Stănişeşti (Bacău)', zip: '607585' },
  { city: 'Baloteşti (Bacău)', zip: '607586' },
  { city: 'Belciuneasa (Bacău)', zip: '607587' },
  { city: 'Beneşti (Bacău)', zip: '607588' },
  { city: 'Crăieşti (Bacău)', zip: '607589' },
  { city: 'Gorgheşti (Bacău)', zip: '607591' },
  { city: 'Slobozia (Stănişeşti) (Bacău)', zip: '607592' },
  { city: 'Slobozia Nouă (Bacău)', zip: '607593' },
  { city: 'Văleni (Stănişeşti) (Bacău)', zip: '607594' },
  { city: 'Strugari (Bacău)', zip: '607595' },
  { city: 'Cetăţuia (Bacău)', zip: '607596' },
  { city: 'Iaz (Bacău)', zip: '607597' },
  { city: 'Nadişa (Bacău)', zip: '607598' },
  { city: 'Petricica (Bacău)', zip: '607599' },
  { city: 'Răchitişu (Bacău)', zip: '607601' },
  { city: 'Ştefan cel Mare (Bacău)', zip: '607605' },
  { city: 'Bogdana (Bacău)', zip: '607606' },
  { city: 'Buciumi (Bacău)', zip: '607607' },
  { city: 'Gutinaş (Bacău)', zip: '607608' },
  { city: 'Negoieşti (Bacău)', zip: '607609' },
  { city: 'Răcăuţi (Bacău)', zip: '607611' },
  { city: 'Rădeana (Bacău)', zip: '607612' },
  { city: 'Viişoara (Ştefan cel Mare) (Bacău)', zip: '607613' },
  { city: 'Tamaşi (Bacău)', zip: '607615' },
  { city: 'Chetriş (Bacău)', zip: '607616' },
  { city: 'Furnicari (Bacău)', zip: '607617' },
  { city: 'Gioseni (Bacău)', zip: '607618' },
  { city: 'Tătărăşti (Bacău)', zip: '607620' },
  { city: 'Cornii de Jos (Bacău)', zip: '607621' },
  { city: 'Cornii de Sus (Bacău)', zip: '607622' },
  { city: 'Drăgeşti (Tătărăşti) (Bacău)', zip: '607623' },
  { city: 'Gherdana (Bacău)', zip: '607624' },
  { city: 'Giurgeni (Bacău)', zip: '607626' },
  { city: 'Ungureni (Tătărăşti) (Bacău)', zip: '607627' },
  { city: 'Târgu Trotuş (Bacău)', zip: '607630' },
  { city: 'Tuta (Bacău)', zip: '607631' },
  { city: 'Viişoara (Târgu Trotuş) (Bacău)', zip: '607632' },
  { city: 'Traian (Bacău)', zip: '607635' },
  { city: 'Bogdăneşti (Traian) (Bacău)', zip: '607636' },
  { city: 'Hertioana de Jos (Bacău)', zip: '607637' },
  { city: 'Hertioana-Răzeşi (Bacău)', zip: '607638' },
  { city: 'Prăjeşti (Bacău)', zip: '607639' },
  { city: 'Zăpodia (Traian) (Bacău)', zip: '607641' },
  { city: 'Ungureni (Bacău)', zip: '607645' },
  { city: 'Bărtăşeşti (Bacău)', zip: '607646' },
  { city: 'Bibireşti (Bacău)', zip: '607647' },
  { city: 'Bota (Bacău)', zip: '607648' },
  { city: 'Boteşti (Bacău)', zip: '607649' },
  { city: 'Gârla Anei (Bacău)', zip: '607651' },
  { city: 'Viforeni (Bacău)', zip: '607652' },
  { city: 'Zlătari (Bacău)', zip: '607653' },
  { city: 'Urecheşti (Bacău)', zip: '607655' },
  { city: 'Cornăţel (Bacău)', zip: '607656' },
  { city: 'Lunca Dochiei (Bacău)', zip: '607657' },
  { city: 'Satu Nou (Urecheşti) (Bacău)', zip: '607658' },
  { city: 'Slobozia (Urecheşti) (Bacău)', zip: '607659' },
  { city: 'Valea Seacă (Bacău)', zip: '607660' },
  { city: 'Cucova (Bacău)', zip: '607661' },
  { city: 'Vultureni (Bacău)', zip: '607665' },
  { city: 'Bosia (Bacău)', zip: '607666' },
  { city: 'Dădeşti (Bacău)', zip: '607667' },
  { city: 'Dorneni (Vultureni) (Bacău)', zip: '607668' },
  { city: 'Ghilăveşti (Bacău)', zip: '607669' },
  { city: 'Godineştii de Jos (Bacău)', zip: '607671' },
  { city: 'Godineştii de Sus (Bacău)', zip: '607672' },
  { city: 'Lichitişeni (Bacău)', zip: '607673' },
  { city: 'Medeleni (Bacău)', zip: '607674' },
  { city: 'Nazărioaia (Bacău)', zip: '607676' },
  { city: 'Reprivăţ (Bacău)', zip: '607677' },
  { city: 'Tomozia (Bacău)', zip: '607678' },
  { city: 'Ţigăneşti (Bacău)', zip: '607679' },
  { city: 'Valea Lupului (Bacău)', zip: '607681' },
  { city: 'Valea Merilor (Bacău)', zip: '607682' },
  { city: 'Valea Salciei (Bacău)', zip: '607683' },
  { city: 'Zemeş (Bacău)', zip: '607690' },
  { city: 'Bolătău (Bacău)', zip: '607691' },
  { city: 'Oradea (Bihor)', zip: '410001' },
  { city: 'Aleşd (Bihor)', zip: '415100' },
  { city: 'Pădurea Neagră (Bihor)', zip: '415101' },
  { city: 'Peştiş (Bihor)', zip: '415102' },
  { city: 'Tinăud (Bihor)', zip: '415103' },
  { city: 'Beiuş (Bihor)', zip: '415200' },
  { city: 'Delani (Bihor)', zip: '415201' },
  { city: 'Marghita (Bihor)', zip: '415300' },
  { city: 'Cheţ (Bihor)', zip: '415301' },
  { city: 'Ghenetea (Bihor)', zip: '415302' },
  { city: 'Nucet (Bihor)', zip: '415400' },
  { city: 'Băiţa (Bihor)', zip: '415401' },
  { city: 'Băiţa-Plai (Bihor)', zip: '415402' },
  { city: 'Salonta (Bihor)', zip: '415500' },
  { city: 'Ştei (Bihor)', zip: '415600' },
  { city: 'Valea lui Mihai (Bihor)', zip: '415700' },
  { city: 'Vaşcău (Bihor)', zip: '415800' },
  { city: 'Câmp (Bihor)', zip: '415801' },
  { city: 'Câmp-Moţi (Bihor)', zip: '415802' },
  { city: 'Coleşti (Bihor)', zip: '415803' },
  { city: 'Vărzarii de Jos (Bihor)', zip: '415804' },
  { city: 'Vărzarii de Sus (Bihor)', zip: '415805' },
  { city: 'Abram (Bihor)', zip: '417005' },
  { city: 'Cohani (Bihor)', zip: '417006' },
  { city: 'Dijir (Bihor)', zip: '417007' },
  { city: 'Iteu (Bihor)', zip: '417008' },
  { city: 'Iteu Nou (Bihor)', zip: '417009' },
  { city: 'Margine (Bihor)', zip: '417011' },
  { city: 'Satu Barbă (Bihor)', zip: '417012' },
  { city: 'Suiug (Bihor)', zip: '417013' },
  { city: 'Abrămuţ (Bihor)', zip: '417015' },
  { city: 'Crestur (Bihor)', zip: '417016' },
  { city: 'Făncica (Bihor)', zip: '417017' },
  { city: 'Petreu (Bihor)', zip: '417018' },
  { city: 'Aştileu (Bihor)', zip: '417020' },
  { city: 'Călăţea (Bihor)', zip: '417021' },
  { city: 'Chistag (Bihor)', zip: '417022' },
  { city: 'Peştere (Bihor)', zip: '417023' },
  { city: 'Auşeu (Bihor)', zip: '417025' },
  { city: 'Cacuciu Vechi (Bihor)', zip: '417026' },
  { city: 'Codrişoru (Bihor)', zip: '417027' },
  { city: 'Gheghie (Bihor)', zip: '417028' },
  { city: 'Groşi (Bihor)', zip: '417029' },
  { city: 'Luncşoara (Bihor)', zip: '417031' },
  { city: 'Avram Iancu (Bihor)', zip: '417035' },
  { city: 'Ant (Bihor)', zip: '417036' },
  { city: 'Tămaşda (Bihor)', zip: '417037' },
  { city: 'Balc (Bihor)', zip: '417040' },
  { city: 'Almaşu Mare (Bihor)', zip: '417041' },
  { city: 'Almaşu Mic (Balc) (Bihor)', zip: '417042' },
  { city: 'Ghida (Bihor)', zip: '417043' },
  { city: 'Săldăbagiu de Barcău (Bihor)', zip: '417044' },
  { city: 'Batăr (Bihor)', zip: '417045' },
  { city: 'Arpăşel (Bihor)', zip: '417046' },
  { city: 'Talpoş (Bihor)', zip: '417047' },
  { city: 'Tăut (Bihor)', zip: '417048' },
  { city: 'Biharia (Bihor)', zip: '417050' },
  { city: 'Cauaceu (Bihor)', zip: '417051' },
  { city: 'Niuved (Bihor)', zip: '417052' },
  { city: 'Parhida (Bihor)', zip: '417053' },
  { city: 'Satu Nou (Bihor)', zip: '417054' },
  { city: 'Tămăşeu (Bihor)', zip: '417056' },
  { city: 'Boianu Mare (Bihor)', zip: '417060' },
  { city: 'Corboaia (Bihor)', zip: '417061' },
  { city: 'Huta (Bihor)', zip: '417062' },
  { city: 'Păgaia (Bihor)', zip: '417063' },
  { city: 'Rugea (Bihor)', zip: '417064' },
  { city: 'Borod (Bihor)', zip: '417065' },
  { city: 'Borozel (Bihor)', zip: '417066' },
  { city: 'Cetea (Bihor)', zip: '417067' },
  { city: 'Corniţel (Bihor)', zip: '417068' },
  { city: 'Şerani (Bihor)', zip: '417069' },
  { city: 'Valea Mare de Criş (Bihor)', zip: '417071' },
  { city: 'Borş (Bihor)', zip: '417075' },
  { city: 'Santăul Mare (Bihor)', zip: '417076' },
  { city: 'Santăul Mic (Bihor)', zip: '417077' },
  { city: 'Sântion (Bihor)', zip: '417078' },
  { city: 'Bratca (Bihor)', zip: '417080' },
  { city: 'Beznea (Bihor)', zip: '417081' },
  { city: 'Damiş (Bihor)', zip: '417082' },
  { city: 'Lorău (Bihor)', zip: '417083' },
  { city: 'Ponoară (Bihor)', zip: '417084' },
  { city: 'Valea Crişului (Bihor)', zip: '417086' },
  { city: 'Brusturi (Bihor)', zip: '417090' },
  { city: 'Cuieşd (Bihor)', zip: '417091' },
  { city: 'Loranta (Bihor)', zip: '417092' },
  { city: 'Orvişele (Bihor)', zip: '417093' },
  { city: 'Păuleşti (Bihor)', zip: '417094' },
  { city: 'Picleu (Bihor)', zip: '417096' },
  { city: 'Ţigăneştii de Criş (Bihor)', zip: '417097' },
  { city: 'Varasău (Bihor)', zip: '417098' },
  { city: 'Budureasa (Bihor)', zip: '417100' },
  { city: 'Burda (Bihor)', zip: '417101' },
  { city: 'Saca (Bihor)', zip: '417102' },
  { city: 'Sălişte de Beiuş (Bihor)', zip: '417103' },
  { city: 'Teleac (Bihor)', zip: '417104' },
  { city: 'Buduslău (Bihor)', zip: '417105' },
  { city: 'Albiş (Bihor)', zip: '417106' },
  { city: 'Bulz (Bihor)', zip: '417110' },
  { city: 'Baraj Leşu (Bihor)', zip: '417111' },
  { city: 'Munteni (Bihor)', zip: '417112' },
  { city: 'Remeţi (Bihor)', zip: '417113' },
  { city: 'Valea Iadului (Bihor)', zip: '417114' },
  { city: 'Bunteşti (Bihor)', zip: '417115' },
  { city: 'Brădet (Bihor)', zip: '417116' },
  { city: 'Dumbrăvani (Bihor)', zip: '417117' },
  { city: 'Ferice (Bihor)', zip: '417118' },
  { city: 'Leleşti (Bihor)', zip: '417119' },
  { city: 'Poienii de Jos (Bihor)', zip: '417121' },
  { city: 'Poienii de Sus (Bihor)', zip: '417122' },
  { city: 'Săud (Bihor)', zip: '417123' },
  { city: 'Stânceşti (Bihor)', zip: '417124' },
  { city: 'Căbeşti (Bihor)', zip: '417125' },
  { city: 'Goila (Bihor)', zip: '417126' },
  { city: 'Gurbeşti (Căbeşti) (Bihor)', zip: '417127' },
  { city: 'Josani (Căbeşti) (Bihor)', zip: '417128' },
  { city: 'Sohodol (Bihor)', zip: '417129' },
  { city: 'Căpâlna (Bihor)', zip: '417130' },
  { city: 'Ginta (Bihor)', zip: '417131' },
  { city: 'Rohani (Bihor)', zip: '417132' },
  { city: 'Săldăbagiu Mic (Bihor)', zip: '417133' },
  { city: 'Suplacu de Tinca (Bihor)', zip: '417134' },
  { city: 'Cărpinet (Bihor)', zip: '417135' },
  { city: 'Călugări (Bihor)', zip: '417136' },
  { city: 'Izbuc (Bihor)', zip: '417137' },
  { city: 'Leheceni (Bihor)', zip: '417138' },
  { city: 'Câmpani (Bihor)', zip: '417140' },
  { city: 'Fânaţe (Bihor)', zip: '417141' },
  { city: 'Hârseşti (Bihor)', zip: '417142' },
  { city: 'Sighiştel (Bihor)', zip: '417143' },
  { city: 'Valea de Sus (Bihor)', zip: '417144' },
  { city: 'Cefa (Bihor)', zip: '417145' },
  { city: 'Ateaş (Bihor)', zip: '417146' },
  { city: 'Berechiu (Bihor)', zip: '417147' },
  { city: 'Bicaci (Bihor)', zip: '417148' },
  { city: 'Gepiu (Bihor)', zip: '417149' },
  { city: 'Inand (Bihor)', zip: '417151' },
  { city: 'Roit (Bihor)', zip: '417152' },
  { city: 'Sânnicolau Român (Bihor)', zip: '417153' },
  { city: 'Ceica (Bihor)', zip: '417155' },
  { city: 'Bucium (Bihor)', zip: '417156' },
  { city: 'Ceişoara (Bihor)', zip: '417157' },
  { city: 'Corbeşti (Bihor)', zip: '417158' },
  { city: 'Cotiglet (Bihor)', zip: '417159' },
  { city: 'Duşeşti (Bihor)', zip: '417161' },
  { city: 'Inceşti (Bihor)', zip: '417162' },
  { city: 'Cetariu (Bihor)', zip: '417165' },
  { city: 'Paleu (Bihor)', zip: '417166' },
  { city: 'Săldăbagiu de Munte (Bihor)', zip: '417167' },
  { city: 'Şişterea (Bihor)', zip: '417168' },
  { city: 'Şuşturogi (Bihor)', zip: '417169' },
  { city: 'Tăutelec (Bihor)', zip: '417171' },
  { city: 'Uileacu de Munte (Bihor)', zip: '417172' },
  { city: 'Cherechiu (Bihor)', zip: '417175' },
  { city: 'Cheşereu (Bihor)', zip: '417176' },
  { city: 'Târguşor (Bihor)', zip: '417177' },
  { city: 'Chişlaz (Bihor)', zip: '417180' },
  { city: 'Chiraleu (Bihor)', zip: '417181' },
  { city: 'Hăuceşti (Bihor)', zip: '417182' },
  { city: 'Mişca (Bihor)', zip: '417183' },
  { city: 'Pocluşa de Barcău (Bihor)', zip: '417184' },
  { city: 'Sărsig (Bihor)', zip: '417186' },
  { city: 'Sânlazăr (Bihor)', zip: '417187' },
  { city: 'Ciuhoi (Bihor)', zip: '417190' },
  { city: 'Cenaloş (Bihor)', zip: '417191' },
  { city: 'Sâniob (Bihor)', zip: '417192' },
  { city: 'Sfârnaş (Bihor)', zip: '417193' },
  { city: 'Ciumeghiu (Bihor)', zip: '417195' },
  { city: 'Boiu (Bihor)', zip: '417196' },
  { city: 'Ghiorac (Bihor)', zip: '417197' },
  { city: 'Cociuba Mare (Bihor)', zip: '417200' },
  { city: 'Cărăsău (Bihor)', zip: '417201' },
  { city: 'Cheşa (Bihor)', zip: '417202' },
  { city: 'Petid (Bihor)', zip: '417203' },
  { city: 'Copăcel (Bihor)', zip: '417205' },
  { city: 'Bucuroaia (Bihor)', zip: '417206' },
  { city: 'Chijic (Bihor)', zip: '417207' },
  { city: 'Poiana Tăşad (Bihor)', zip: '417208' },
  { city: 'Sărand (Bihor)', zip: '417209' },
  { city: 'Surduc (Bihor)', zip: '417211' },
  { city: 'Criştioru de Jos (Bihor)', zip: '417215' },
  { city: 'Bâlc (Bihor)', zip: '417216' },
  { city: 'Criştioru de Sus (Bihor)', zip: '417217' },
  { city: 'Poiana (Criştioru de Jos) (Bihor)', zip: '417218' },
  { city: 'Sălişte de Vaşcău (Bihor)', zip: '417219' },
  { city: 'Curăţele (Bihor)', zip: '417220' },
  { city: 'Beiuşele (Bihor)', zip: '417221' },
  { city: 'Cresuia (Bihor)', zip: '417222' },
  { city: 'Nimăieşti (Bihor)', zip: '417223' },
  { city: 'Pociovelişte (Bihor)', zip: '417224' },
  { city: 'Curtuişeni (Bihor)', zip: '417225' },
  { city: 'Văşad (Bihor)', zip: '417226' },
  { city: 'Derna (Bihor)', zip: '417230' },
  { city: 'Dernişoara (Bihor)', zip: '417231' },
  { city: 'Sacalasău (Bihor)', zip: '417232' },
  { city: 'Sacalasău Nou (Bihor)', zip: '417233' },
  { city: 'Tria (Bihor)', zip: '417234' },
  { city: 'Diosig (Bihor)', zip: '417235' },
  { city: 'Ianca (Bihor)', zip: '417236' },
  { city: 'Mihai Bravu (Bihor)', zip: '417237' },
  { city: 'Roşiori (Bihor)', zip: '417238' },
  { city: 'Vaida (Bihor)', zip: '417239' },
  { city: 'Dobreşti (Bihor)', zip: '417240' },
  { city: 'Cornişeşti (Bihor)', zip: '417241' },
  { city: 'Crânceşti (Bihor)', zip: '417242' },
  { city: 'Hidişel (Bihor)', zip: '417243' },
  { city: 'Luncasprie (Bihor)', zip: '417244' },
  { city: 'Răcaş (Bihor)', zip: '417246' },
  { city: 'Topa de Jos (Bihor)', zip: '417247' },
  { city: 'Topa de Sus (Bihor)', zip: '417248' },
  { city: 'Drăgăneşti (Bihor)', zip: '417250' },
  { city: 'Belejeni (Bihor)', zip: '417251' },
  { city: 'Grădinari (Bihor)', zip: '417252' },
  { city: 'Livada Beiuşului (Bihor)', zip: '417253' },
  { city: 'Mizieş (Bihor)', zip: '417254' },
  { city: 'Păcăleşti (Bihor)', zip: '417255' },
  { city: 'Păntăşeşti (Bihor)', zip: '417256' },
  { city: 'Şebiş (Bihor)', zip: '417257' },
  { city: 'Talpe (Bihor)', zip: '417258' },
  { city: 'Ţigăneştii de Beiuş (Bihor)', zip: '417259' },
  { city: 'Drăgeşti (Bihor)', zip: '417260' },
  { city: 'Dicăneşti (Bihor)', zip: '417261' },
  { city: 'Stracoş (Bihor)', zip: '417262' },
  { city: 'Tăşad (Bihor)', zip: '417263' },
  { city: 'Topeşti (Bihor)', zip: '417264' },
  { city: 'Finiş (Bihor)', zip: '417265' },
  { city: 'Brusturi (Finiş) (Bihor)', zip: '417266' },
  { city: 'Fiziş (Bihor)', zip: '417267' },
  { city: 'Ioaniş (Bihor)', zip: '417268' },
  { city: 'Şuncuiş (Bihor)', zip: '417269' },
  { city: 'Girişu de Criş (Bihor)', zip: '417270' },
  { city: 'Cheresig (Bihor)', zip: '417271' },
  { city: 'Tărian (Bihor)', zip: '417272' },
  { city: 'Toboliu (Bihor)', zip: '417273' },
  { city: 'Hidişelu de Sus (Bihor)', zip: '417275' },
  { city: 'Hidişelu de Jos (Bihor)', zip: '417276' },
  { city: 'Mierlău (Bihor)', zip: '417277' },
  { city: 'Sântelec (Bihor)', zip: '417278' },
  { city: 'Şumugiu (Bihor)', zip: '417279' },
  { city: 'Holod (Bihor)', zip: '417280' },
  { city: 'Dumbrava (Bihor)', zip: '417281' },
  { city: 'Dumbrăviţa (Bihor)', zip: '417282' },
  { city: 'Forosig (Bihor)', zip: '417283' },
  { city: 'Hodiş (Bihor)', zip: '417284' },
  { city: 'Lupoaia (Bihor)', zip: '417286' },
  { city: 'Valea Mare de Codru (Bihor)', zip: '417287' },
  { city: 'Vintere (Bihor)', zip: '417288' },
  { city: 'Husasău de Tinca (Bihor)', zip: '417290' },
  { city: 'Fonău (Bihor)', zip: '417291' },
  { city: 'Miersig (Bihor)', zip: '417292' },
  { city: 'Oşand (Bihor)', zip: '417293' },
  { city: 'Sititelec (Bihor)', zip: '417294' },
  { city: 'Ineu (Bihor)', zip: '417295' },
  { city: 'Botean (Bihor)', zip: '417296' },
  { city: 'Husasău de Criş (Bihor)', zip: '417297' },
  { city: 'Lazuri de Beiuş (Bihor)', zip: '417300' },
  { city: 'Băleni (Bihor)', zip: '417301' },
  { city: 'Cusuiuş (Bihor)', zip: '417302' },
  { city: 'Hinchiriş (Bihor)', zip: '417303' },
  { city: 'Lăzăreni (Bihor)', zip: '417305' },
  { city: 'Bicăcel (Bihor)', zip: '417306' },
  { city: 'Calea Mare (Bihor)', zip: '417307' },
  { city: 'Cărăndeni (Bihor)', zip: '417308' },
  { city: 'Cărănzel (Bihor)', zip: '417309' },
  { city: 'Gepiş (Bihor)', zip: '417311' },
  { city: 'Gruilung (Bihor)', zip: '417312' },
  { city: 'Miheleu (Bihor)', zip: '417313' },
  { city: 'Lugaşu de Jos (Bihor)', zip: '417315' },
  { city: 'Lugaşu de Sus (Bihor)', zip: '417316' },
  { city: 'Urvind (Bihor)', zip: '417317' },
  { city: 'Lunca (Bihor)', zip: '417320' },
  { city: 'Briheni (Bihor)', zip: '417321' },
  { city: 'Hotărel (Bihor)', zip: '417322' },
  { city: 'Sârbeşti (Bihor)', zip: '417323' },
  { city: 'Seghişte (Bihor)', zip: '417324' },
  { city: 'Şuştiu (Bihor)', zip: '417326' },
  { city: 'Mădăras (Bihor)', zip: '417330' },
  { city: 'Homorog (Bihor)', zip: '417331' },
  { city: 'Ianoşda (Bihor)', zip: '417332' },
  { city: 'Marţihaz (Bihor)', zip: '417333' },
  { city: 'Măgeşti (Bihor)', zip: '417335' },
  { city: 'Butani (Bihor)', zip: '417336' },
  { city: 'Cacuciu Nou (Bihor)', zip: '417337' },
  { city: 'Dobricioneşti (Bihor)', zip: '417338' },
  { city: 'Gălăşeni (Bihor)', zip: '417339' },
  { city: 'Josani (Măgeşti) (Bihor)', zip: '417341' },
  { city: 'Ortiteag (Bihor)', zip: '417342' },
  { city: 'Nojorid (Bihor)', zip: '417345' },
  { city: 'Apateu (Bihor)', zip: '417346' },
  { city: 'Chişirid (Bihor)', zip: '417347' },
  { city: 'Leş (Bihor)', zip: '417348' },
  { city: 'Livada de Bihor (Bihor)', zip: '417349' },
  { city: 'Păuşa (Bihor)', zip: '417351' },
  { city: 'Şauaieu (Bihor)', zip: '417352' },
  { city: 'Olcea (Bihor)', zip: '417355' },
  { city: 'Călacea (Bihor)', zip: '417356' },
  { city: 'Hodişel (Bihor)', zip: '417357' },
  { city: 'Ucuriş (Bihor)', zip: '417358' },
  { city: 'Oşorhei (Bihor)', zip: '417360' },
  { city: 'Alparea (Bihor)', zip: '417361' },
  { city: 'Cheriu (Bihor)', zip: '417362' },
  { city: 'Felcheriu (Bihor)', zip: '417363' },
  { city: 'Fughiu (Bihor)', zip: '417364' },
  { city: 'Pietroasa (Bihor)', zip: '417365' },
  { city: 'Chişcău (Bihor)', zip: '417366' },
  { city: 'Cociuba Mică (Bihor)', zip: '417367' },
  { city: 'Giuleşti (Bihor)', zip: '417368' },
  { city: 'Gurani (Bihor)', zip: '417369' },
  { city: 'Măgura (Bihor)', zip: '417371' },
  { city: 'Moţeşti (Bihor)', zip: '417372' },
  { city: 'Pocola (Bihor)', zip: '417375' },
  { city: 'Feneriş (Bihor)', zip: '417376' },
  { city: 'Petrani (Bihor)', zip: '417377' },
  { city: 'Poietari (Bihor)', zip: '417378' },
  { city: 'Sânmartin de Beiuş (Bihor)', zip: '417379' },
  { city: 'Pomezeu (Bihor)', zip: '417380' },
  { city: 'Câmpani de Pomezeu (Bihor)', zip: '417381' },
  { city: 'Coşdeni (Bihor)', zip: '417382' },
  { city: 'Hidiş (Bihor)', zip: '417383' },
  { city: 'Lacu Sărat (Bihor)', zip: '417384' },
  { city: 'Sitani (Bihor)', zip: '417386' },
  { city: 'Spinuş de Pomezeu (Bihor)', zip: '417387' },
  { city: 'Vălani de Pomezeu (Bihor)', zip: '417388' },
  { city: 'Popeşti (Bihor)', zip: '417390' },
  { city: 'Bistra (Bihor)', zip: '417391' },
  { city: 'Budoi (Bihor)', zip: '417392' },
  { city: 'Cuzap (Bihor)', zip: '417393' },
  { city: 'Varviz (Bihor)', zip: '417394' },
  { city: 'Vărzari (Bihor)', zip: '417396' },
  { city: 'Voivozi (Popeşti) (Bihor)', zip: '417397' },
  { city: 'Răbăgani (Bihor)', zip: '417400' },
  { city: 'Albeşti (Bihor)', zip: '417401' },
  { city: 'Brăteşti (Bihor)', zip: '417402' },
  { city: 'Sălişte de Pomezeu (Bihor)', zip: '417403' },
  { city: 'Săucani (Bihor)', zip: '417404' },
  { city: 'Vărăşeni (Bihor)', zip: '417406' },
  { city: 'Remetea (Bihor)', zip: '417410' },
  { city: 'Drăgoteni (Bihor)', zip: '417411' },
  { city: 'Meziad (Bihor)', zip: '417412' },
  { city: 'Petreasa (Bihor)', zip: '417413' },
  { city: 'Şoimuş (Bihor)', zip: '417414' },
  { city: 'Rieni (Bihor)', zip: '417415' },
  { city: 'Cucuceni (Bihor)', zip: '417416' },
  { city: 'Ghighişeni (Bihor)', zip: '417417' },
  { city: 'Petrileni (Bihor)', zip: '417418' },
  { city: 'Sudrigiu (Bihor)', zip: '417419' },
  { city: 'Valea de Jos (Bihor)', zip: '417421' },
  { city: 'Roşia (Bihor)', zip: '417425' },
  { city: 'Lazuri (Bihor)', zip: '417426' },
  { city: 'Săcădat (Bihor)', zip: '417430' },
  { city: 'Borşa (Bihor)', zip: '417431' },
  { city: 'Săbolciu (Bihor)', zip: '417432' },
  { city: 'Săcueni (Bihor)', zip: '417435' },
  { city: 'Cadea (Bihor)', zip: '417436' },
  { city: 'Ciocaia (Bihor)', zip: '417437' },
  { city: 'Cubulcut (Bihor)', zip: '417438' },
  { city: 'Olosig (Bihor)', zip: '417439' },
  { city: 'Sânnicolau de Munte (Bihor)', zip: '417441' },
  { city: 'Sălacea (Bihor)', zip: '417445' },
  { city: 'Otomani (Bihor)', zip: '417446' },
  { city: 'Sălard (Bihor)', zip: '417450' },
  { city: 'Hodoş (Bihor)', zip: '417451' },
  { city: 'Sântimreu (Bihor)', zip: '417452' },
  { city: 'Sâmbăta (Bihor)', zip: '417455' },
  { city: 'Copăceni (Bihor)', zip: '417456' },
  { city: 'Ogeşti (Bihor)', zip: '417457' },
  { city: 'Rogoz (Bihor)', zip: '417458' },
  { city: 'Rotăreşti (Bihor)', zip: '417459' },
  { city: 'Zăvoiu (Bihor)', zip: '417461' },
  { city: 'Sânmartin (Bihor)', zip: '417495' },
  { city: 'Băile 1 Mai (Bihor)', zip: '417496' },
  { city: 'Betfia (Bihor)', zip: '417497' },
  { city: 'Cihei (Bihor)', zip: '417498' },
  { city: 'Cordău (Bihor)', zip: '417499' },
  { city: 'Băile Felix (Bihor)', zip: '417500' },
  { city: 'Haieu (Bihor)', zip: '417501' },
  { city: 'Rontău (Bihor)', zip: '417502' },
  { city: 'Sântandrei (Bihor)', zip: '417515' },
  { city: 'Palota (Bihor)', zip: '417516' },
  { city: 'Sârbi (Bihor)', zip: '417520' },
  { city: 'Almaşu Mic (Sârbi) (Bihor)', zip: '417521' },
  { city: 'Burzuc (Bihor)', zip: '417522' },
  { city: 'Chioag (Bihor)', zip: '417523' },
  { city: 'Fegernic (Bihor)', zip: '417524' },
  { city: 'Fegernicu Nou (Bihor)', zip: '417526' },
  { city: 'Sarcău (Bihor)', zip: '417527' },
  { city: 'Spinuş (Bihor)', zip: '417530' },
  { city: 'Ciuleşti (Bihor)', zip: '417531' },
  { city: 'Gurbeşti (Spinuş) (Bihor)', zip: '417532' },
  { city: 'Nădar (Bihor)', zip: '417533' },
  { city: 'Sălişte (Bihor)', zip: '417534' },
  { city: 'Suplacu de Barcău (Bihor)', zip: '417535' },
  { city: 'Borumlaca (Bihor)', zip: '417536' },
  { city: 'Dolea (Bihor)', zip: '417537' },
  { city: 'Foglaş (Bihor)', zip: '417538' },
  { city: 'Valea Cerului (Bihor)', zip: '417539' },
  { city: 'Vâlcelele (Bihor)', zip: '417541' },
  { city: 'Şimian (Bihor)', zip: '417545' },
  { city: 'Şilindru (Bihor)', zip: '417546' },
  { city: 'Voivozi (Şimian) (Bihor)', zip: '417547' },
  { city: 'Şinteu (Bihor)', zip: '417550' },
  { city: 'Huta Voivozi (Bihor)', zip: '417551' },
  { city: 'Socet (Bihor)', zip: '417552' },
  { city: 'Valea Târnei (Bihor)', zip: '417553' },
  { city: 'Şoimi (Bihor)', zip: '417555' },
  { city: 'Borz (Bihor)', zip: '417556' },
  { city: 'Codru (Bihor)', zip: '417557' },
  { city: 'Dumbrăviţa de Codru (Bihor)', zip: '417558' },
  { city: 'Pocluşa de Beiuş (Bihor)', zip: '417559' },
  { city: 'Sânnicolau de Beiuş (Bihor)', zip: '417561' },
  { city: 'Ursad (Bihor)', zip: '417562' },
  { city: 'Urviş de Beiuş (Bihor)', zip: '417563' },
  { city: 'Şuncuiuş (Bihor)', zip: '417565' },
  { city: 'Bălnaca (Bihor)', zip: '417566' },
  { city: 'Bălnaca-Groşi (Bihor)', zip: '417567' },
  { city: 'Zece Hotare (Bihor)', zip: '417568' },
  { city: 'Tarcea (Bihor)', zip: '417570' },
  { city: 'Adoni (Bihor)', zip: '417571' },
  { city: 'Galoşpetreu (Bihor)', zip: '417572' },
  { city: 'Tărcaia (Bihor)', zip: '417575' },
  { city: 'Mierag (Bihor)', zip: '417576' },
  { city: 'Tărcăiţa (Bihor)', zip: '417577' },
  { city: 'Totoreni (Bihor)', zip: '417578' },
  { city: 'Tăuteu (Bihor)', zip: '417580' },
  { city: 'Bogei (Bihor)', zip: '417581' },
  { city: 'Chiribiş (Bihor)', zip: '417582' },
  { city: 'Ciutelec (Bihor)', zip: '417583' },
  { city: 'Poiana (Tăuteu) (Bihor)', zip: '417584' },
  { city: 'Tileagd (Bihor)', zip: '417585' },
  { city: 'Bălaia (Bihor)', zip: '417586' },
  { city: 'Călătani (Bihor)', zip: '417587' },
  { city: 'Poşoloaca (Bihor)', zip: '417588' },
  { city: 'Tilecuş (Bihor)', zip: '417589' },
  { city: 'Uileacu de Criş (Bihor)', zip: '417591' },
  { city: 'Tinca (Bihor)', zip: '417595' },
  { city: 'Belfir (Bihor)', zip: '417596' },
  { city: 'Girişu Negru (Bihor)', zip: '417597' },
  { city: 'Gurbediu (Bihor)', zip: '417598' },
  { city: 'Râpa (Bihor)', zip: '417599' },
  { city: 'Tulca (Bihor)', zip: '417600' },
  { city: 'Căuaşd (Bihor)', zip: '417601' },
  { city: 'Ţeţchea (Bihor)', zip: '417605' },
  { city: 'Hotar (Bihor)', zip: '417606' },
  { city: 'Subpiatră (Bihor)', zip: '417607' },
  { city: 'Telechiu (Bihor)', zip: '417608' },
  { city: 'Uileacu de Beiuş (Bihor)', zip: '417610' },
  { city: 'Forău (Bihor)', zip: '417611' },
  { city: 'Prisaca (Bihor)', zip: '417612' },
  { city: 'Vălanii de Beiuş (Bihor)', zip: '417613' },
  { city: 'Vadu Crişului (Bihor)', zip: '417615' },
  { city: 'Birtin (Bihor)', zip: '417616' },
  { city: 'Tomnatic (Bihor)', zip: '417617' },
  { city: 'Topa de Criş (Bihor)', zip: '417618' },
  { city: 'Vârciorog (Bihor)', zip: '417620' },
  { city: 'Fâşca (Bihor)', zip: '417621' },
  { city: 'Surducel (Bihor)', zip: '417622' },
  { city: 'Şerghiş (Bihor)', zip: '417623' },
  { city: 'Viişoara (Bihor)', zip: '417625' },
  { city: 'Izvoarele (Bihor)', zip: '417626' },
  { city: 'Pădureni (Bihor)', zip: '417627' },
  { city: 'Reghea (Bihor)', zip: '417628' },
  { city: 'Ghinda (Bistriţa-Năsăud)', zip: '420001' },
  { city: 'Sărata (Bistriţa-Năsăud)', zip: '420002' },
  { city: 'Sigmir (Bistriţa-Năsăud)', zip: '420003' },
  { city: 'Slătiniţa (Bistriţa-Năsăud)', zip: '420004' },
  { city: 'Unirea (Bistriţa-Năsăud)', zip: '420005' },
  { city: 'Viişoara (Bistriţa-Năsăud)', zip: '420006' },
  { city: 'Bistriţa (Bistriţa-Năsăud)', zip: '420008' },
  { city: 'Beclean (Bistriţa-Năsăud)', zip: '425100' },
  { city: 'Coldău (Bistriţa-Năsăud)', zip: '425101' },
  { city: 'Figa (Bistriţa-Năsăud)', zip: '425102' },
  { city: 'Rusu de Jos (Bistriţa-Năsăud)', zip: '425103' },
  { city: 'Năsăud (Bistriţa-Năsăud)', zip: '425200' },
  { city: 'Liviu Rebreanu (Bistriţa-Năsăud)', zip: '425201' },
  { city: 'Luşca (Bistriţa-Năsăud)', zip: '425202' },
  { city: 'Sângeorz-Băi (Bistriţa-Năsăud)', zip: '425300' },
  { city: 'Cormaia (Bistriţa-Năsăud)', zip: '425301' },
  { city: 'Valea Borcutului (Bistriţa-Năsăud)', zip: '425302' },
  { city: 'Bistriţa Bârgăului (Bistriţa-Năsăud)', zip: '427005' },
  { city: 'Bistriţa Bârgăului Fabrici (Bistriţa-Năsăud)', zip: '427006' },
  { city: 'Colibiţa (Bistriţa-Năsăud)', zip: '427007' },
  { city: 'Braniştea (Bistriţa-Năsăud)', zip: '427010' },
  { city: 'Cireşoaia (Bistriţa-Năsăud)', zip: '427011' },
  { city: 'Măluţ (Bistriţa-Năsăud)', zip: '427012' },
  { city: 'Budacu de Jos (Bistriţa-Năsăud)', zip: '427015' },
  { city: 'Buduş (Bistriţa-Năsăud)', zip: '427016' },
  { city: 'Jelna (Bistriţa-Năsăud)', zip: '427017' },
  { city: 'Monariu (Bistriţa-Năsăud)', zip: '427018' },
  { city: 'Simioneşti (Bistriţa-Năsăud)', zip: '427019' },
  { city: 'Budeşti (Bistriţa-Năsăud)', zip: '427020' },
  { city: 'Budeşti-Fânaţe (Bistriţa-Năsăud)', zip: '427021' },
  { city: 'Ţagu (Bistriţa-Năsăud)', zip: '427022' },
  { city: 'Ţăgşoru (Bistriţa-Năsăud)', zip: '427023' },
  { city: 'Căianu Mic (Bistriţa-Năsăud)', zip: '427025' },
  { city: 'Căianu Mare (Bistriţa-Năsăud)', zip: '427026' },
  { city: 'Ciceu-Poieni (Bistriţa-Năsăud)', zip: '427027' },
  { city: 'Dobric (Bistriţa-Năsăud)', zip: '427028' },
  { city: 'Dobricel (Bistriţa-Năsăud)', zip: '427029' },
  { city: 'Dumbrăviţa (Bistriţa-Năsăud)', zip: '427031' },
  { city: 'Cetate (Bistriţa-Năsăud)', zip: '427035' },
  { city: 'Budacu de Sus (Bistriţa-Năsăud)', zip: '427036' },
  { city: 'Dumitriţa (Bistriţa-Năsăud)', zip: '427037' },
  { city: 'Orheiu Bistriţei (Bistriţa-Năsăud)', zip: '427038' },
  { city: 'Petriş (Bistriţa-Năsăud)', zip: '427039' },
  { city: 'Ragla (Bistriţa-Năsăud)', zip: '427041' },
  { city: 'Satu Nou (Bistriţa-Năsăud)', zip: '427042' },
  { city: 'Chiochiş (Bistriţa-Năsăud)', zip: '427045' },
  { city: 'Apatiu (Bistriţa-Năsăud)', zip: '427046' },
  { city: 'Bozieş (Bistriţa-Năsăud)', zip: '427047' },
  { city: 'Buza Cătun (Bistriţa-Năsăud)', zip: '427048' },
  { city: 'Cheţiu (Bistriţa-Năsăud)', zip: '427049' },
  { city: 'Jimbor (Bistriţa-Năsăud)', zip: '427051' },
  { city: 'Manic (Bistriţa-Năsăud)', zip: '427052' },
  { city: 'Sânnicoară (Bistriţa-Năsăud)', zip: '427053' },
  { city: 'Strugureni (Bistriţa-Năsăud)', zip: '427054' },
  { city: 'Ţentea (Bistriţa-Năsăud)', zip: '427056' },
  { city: 'Chiuza (Bistriţa-Năsăud)', zip: '427060' },
  { city: 'Mireş (Bistriţa-Năsăud)', zip: '427061' },
  { city: 'Piatra (Bistriţa-Năsăud)', zip: '427062' },
  { city: 'Săsarm (Bistriţa-Năsăud)', zip: '427063' },
  { city: 'Ciceu-Giurgeşti (Bistriţa-Năsăud)', zip: '427065' },
  { city: 'Breaza (Bistriţa-Năsăud)', zip: '427066' },
  { city: 'Dumbrăveni (Bistriţa-Năsăud)', zip: '427067' },
  { city: 'Negrileşti (Bistriţa-Năsăud)', zip: '427068' },
  { city: 'Purcărete (Bistriţa-Năsăud)', zip: '427069' },
  { city: 'Coşbuc (Bistriţa-Năsăud)', zip: '427070' },
  { city: 'Bichigiu (Bistriţa-Năsăud)', zip: '427071' },
  { city: 'Dumitra (Bistriţa-Năsăud)', zip: '427075' },
  { city: 'Cepari (Bistriţa-Năsăud)', zip: '427076' },
  { city: 'Tărpiu (Bistriţa-Năsăud)', zip: '427077' },
  { city: 'Feldru (Bistriţa-Năsăud)', zip: '427080' },
  { city: 'Nepos (Bistriţa-Năsăud)', zip: '427081' },
  { city: 'Galaţii Bistriţei (Bistriţa-Năsăud)', zip: '427085' },
  { city: 'Albeştii Bistriţei (Bistriţa-Năsăud)', zip: '427086' },
  { city: 'Dipşa (Bistriţa-Năsăud)', zip: '427087' },
  { city: 'Herina (Bistriţa-Năsăud)', zip: '427088' },
  { city: 'Tonciu (Bistriţa-Năsăud)', zip: '427089' },
  { city: 'Ilva Mare (Bistriţa-Năsăud)', zip: '427090' },
  { city: 'Ivăneasa (Bistriţa-Năsăud)', zip: '427091' },
  { city: 'Ilva Mică (Bistriţa-Năsăud)', zip: '427095' },
  { city: 'Josenii Bârgăului (Bistriţa-Năsăud)', zip: '427100' },
  { city: 'Mijlocenii Bârgăului (Bistriţa-Năsăud)', zip: '427101' },
  { city: 'Rusu Bârgăului (Bistriţa-Năsăud)', zip: '427102' },
  { city: 'Strâmba (Bistriţa-Năsăud)', zip: '427103' },
  { city: 'Lechinţa (Bistriţa-Năsăud)', zip: '427105' },
  { city: 'Bungard (Bistriţa-Năsăud)', zip: '427106' },
  { city: 'Chiraleş (Bistriţa-Năsăud)', zip: '427107' },
  { city: 'Sângeorzu Nou (Bistriţa-Năsăud)', zip: '427108' },
  { city: 'Sâniacob (Bistriţa-Năsăud)', zip: '427109' },
  { city: 'Ţigău (Bistriţa-Năsăud)', zip: '427111' },
  { city: 'Vermeş (Bistriţa-Năsăud)', zip: '427112' },
  { city: 'Leşu (Bistriţa-Năsăud)', zip: '427115' },
  { city: 'Lunca Leşului (Bistriţa-Năsăud)', zip: '427116' },
  { city: 'Livezile (Bistriţa-Năsăud)', zip: '427120' },
  { city: 'Cuşma (Bistriţa-Năsăud)', zip: '427121' },
  { city: 'Dorolea (Bistriţa-Năsăud)', zip: '427122' },
  { city: 'Dumbrava (Livezile) (Bistriţa-Năsăud)', zip: '427123' },
  { city: 'Valea Poenii (Bistriţa-Năsăud)', zip: '427124' },
  { city: 'Lunca Ilvei (Bistriţa-Năsăud)', zip: '427125' },
  { city: 'Maieru (Bistriţa-Năsăud)', zip: '427130' },
  { city: 'Anieş (Bistriţa-Năsăud)', zip: '427131' },
  { city: 'Matei (Bistriţa-Năsăud)', zip: '427135' },
  { city: 'Bidiu (Bistriţa-Năsăud)', zip: '427136' },
  { city: 'Corvineşti (Bistriţa-Năsăud)', zip: '427137' },
  { city: 'Enciu (Bistriţa-Năsăud)', zip: '427138' },
  { city: 'Fântânele (Bistriţa-Năsăud)', zip: '427139' },
  { city: 'Moruţ (Bistriţa-Năsăud)', zip: '427141' },
  { city: 'Măgura Ilvei (Bistriţa-Năsăud)', zip: '427145' },
  { city: 'Arşiţa (Bistriţa-Năsăud)', zip: '427146' },
  { city: 'Poiana Ilvei (Bistriţa-Năsăud)', zip: '427147' },
  { city: 'Mărişelu (Bistriţa-Năsăud)', zip: '427150' },
  { city: 'Bârla (Bistriţa-Năsăud)', zip: '427151' },
  { city: 'Domneşti (Bistriţa-Năsăud)', zip: '427152' },
  { city: 'Jeica (Bistriţa-Năsăud)', zip: '427153' },
  { city: 'Măgurele (Bistriţa-Năsăud)', zip: '427154' },
  { city: 'Neţeni (Bistriţa-Năsăud)', zip: '427156' },
  { city: 'Sântioana (Bistriţa-Năsăud)', zip: '427157' },
  { city: 'Miceştii de Câmpie (Bistriţa-Năsăud)', zip: '427160' },
  { city: 'Fântâniţa (Bistriţa-Năsăud)', zip: '427161' },
  { city: 'Visuia (Bistriţa-Năsăud)', zip: '427162' },
  { city: 'Milaş (Bistriţa-Năsăud)', zip: '427165' },
  { city: 'Comlod (Bistriţa-Năsăud)', zip: '427166' },
  { city: 'După Deal (Bistriţa-Năsăud)', zip: '427167' },
  { city: 'Ghemeş (Bistriţa-Năsăud)', zip: '427168' },
  { city: 'Hirean (Bistriţa-Năsăud)', zip: '427169' },
  { city: 'Orosfaia (Bistriţa-Năsăud)', zip: '427171' },
  { city: 'Monor (Bistriţa-Năsăud)', zip: '427175' },
  { city: 'Gledin (Bistriţa-Năsăud)', zip: '427176' },
  { city: 'Nimigea (Bistriţa-Năsăud)', zip: '427180' },
  { city: 'Floreşti (Bistriţa-Năsăud)', zip: '427181' },
  { city: 'Mintiu (Bistriţa-Năsăud)', zip: '427182' },
  { city: 'Mititei (Bistriţa-Năsăud)', zip: '427183' },
  { city: 'Mocod (Bistriţa-Năsăud)', zip: '427184' },
  { city: 'Mogoşeni (Bistriţa-Năsăud)', zip: '427186' },
  { city: 'Nimigea de Sus (Bistriţa-Năsăud)', zip: '427187' },
  { city: 'Tăure (Bistriţa-Năsăud)', zip: '427188' },
  { city: 'Nimigea de Jos (Bistriţa-Năsăud)', zip: '427190' },
  { city: 'Nuşeni (Bistriţa-Năsăud)', zip: '427200' },
  { city: 'Beudiu (Bistriţa-Năsăud)', zip: '427201' },
  { city: 'Dumbrava (Nuşeni) (Bistriţa-Năsăud)', zip: '427202' },
  { city: 'Feleac (Bistriţa-Năsăud)', zip: '427203' },
  { city: 'Malin (Bistriţa-Năsăud)', zip: '427204' },
  { city: 'Rusu de Sus (Bistriţa-Năsăud)', zip: '427206' },
  { city: 'Viţa (Bistriţa-Năsăud)', zip: '427207' },
  { city: 'Parva (Bistriţa-Năsăud)', zip: '427210' },
  { city: 'Petru Rareş (Bistriţa-Năsăud)', zip: '427215' },
  { city: 'Baţa (Bistriţa-Năsăud)', zip: '427216' },
  { city: 'Ciceu-Corabia (Bistriţa-Năsăud)', zip: '427217' },
  { city: 'Ciceu-Mihăieşti (Bistriţa-Năsăud)', zip: '427218' },
  { city: 'Leleşti (Bistriţa-Năsăud)', zip: '427219' },
  { city: 'Reteag (Bistriţa-Năsăud)', zip: '427220' },
  { city: 'Prundu Bârgăului (Bistriţa-Năsăud)', zip: '427230' },
  { city: 'Susenii Bârgăului (Bistriţa-Năsăud)', zip: '427231' },
  { city: 'Rebra (Bistriţa-Năsăud)', zip: '427235' },
  { city: 'Rebrişoara (Bistriţa-Năsăud)', zip: '427240' },
  { city: 'Gersa I (Bistriţa-Năsăud)', zip: '427241' },
  { city: 'Gersa II (Bistriţa-Năsăud)', zip: '427242' },
  { city: 'Poderei (Bistriţa-Năsăud)', zip: '427243' },
  { city: 'Rodna (Bistriţa-Năsăud)', zip: '427245' },
  { city: 'Valea Vinului (Bistriţa-Năsăud)', zip: '427246' },
  { city: 'Romuli (Bistriţa-Năsăud)', zip: '427250' },
  { city: 'Dealu Ştefăniţei (Bistriţa-Năsăud)', zip: '427251' },
  { city: 'Salva (Bistriţa-Năsăud)', zip: '427255' },
  { city: 'Runcu Salvei (Bistriţa-Năsăud)', zip: '427256' },
  { city: 'Sânmihaiu de Câmpie (Bistriţa-Năsăud)', zip: '427260' },
  { city: 'Brăteni (Bistriţa-Năsăud)', zip: '427261' },
  { city: 'La Curte (Bistriţa-Năsăud)', zip: '427262' },
  { city: 'Sălcuţa (Bistriţa-Năsăud)', zip: '427263' },
  { city: 'Stupini (Bistriţa-Năsăud)', zip: '427264' },
  { city: 'Zoreni (Bistriţa-Năsăud)', zip: '427266' },
  { city: 'Silivaşu de Câmpie (Bistriţa-Năsăud)', zip: '427270' },
  { city: 'Draga (Bistriţa-Năsăud)', zip: '427271' },
  { city: 'Fânaţele Silivaşului (Bistriţa-Năsăud)', zip: '427272' },
  { city: 'Porumbenii (Bistriţa-Năsăud)', zip: '427273' },
  { city: 'Spermezeu (Bistriţa-Năsăud)', zip: '427275' },
  { city: 'Hălmăsău (Bistriţa-Năsăud)', zip: '427276' },
  { city: 'Lunca Borlesei (Bistriţa-Năsăud)', zip: '427277' },
  { city: 'Păltineasa (Bistriţa-Năsăud)', zip: '427278' },
  { city: 'Sita (Bistriţa-Năsăud)', zip: '427279' },
  { city: 'Şesuri Spermezeu-Vale (Bistriţa-Năsăud)', zip: '427281' },
  { city: 'Şanţ (Bistriţa-Năsăud)', zip: '427285' },
  { city: 'Valea Mare (Şanţ) (Bistriţa-Năsăud)', zip: '427286' },
  { city: 'Şieu (Bistriţa-Năsăud)', zip: '427290' },
  { city: 'Ardan (Bistriţa-Năsăud)', zip: '427291' },
  { city: 'Posmuş (Bistriţa-Năsăud)', zip: '427292' },
  { city: 'Şoimuş (Bistriţa-Năsăud)', zip: '427293' },
  { city: 'Şieu-Măgheruş (Bistriţa-Năsăud)', zip: '427295' },
  { city: 'Arcalia (Bistriţa-Năsăud)', zip: '427296' },
  { city: 'Chintelnic (Bistriţa-Năsăud)', zip: '427297' },
  { city: 'Crainimăt (Bistriţa-Năsăud)', zip: '427298' },
  { city: 'Podirei (Bistriţa-Năsăud)', zip: '427299' },
  { city: 'Sărăţel (Bistriţa-Năsăud)', zip: '427301' },
  { city: 'Valea Măgheruşului (Bistriţa-Năsăud)', zip: '427302' },
  { city: 'Şieu-Odorhei (Bistriţa-Năsăud)', zip: '427305' },
  { city: 'Agrişu de Jos (Bistriţa-Năsăud)', zip: '427306' },
  { city: 'Agrişu de Sus (Bistriţa-Năsăud)', zip: '427307' },
  { city: 'Bretea (Bistriţa-Năsăud)', zip: '427308' },
  { city: 'Coasta (Bistriţa-Năsăud)', zip: '427309' },
  { city: 'Cristur-Şieu (Bistriţa-Năsăud)', zip: '427311' },
  { city: 'Şirioara (Bistriţa-Năsăud)', zip: '427312' },
  { city: 'Şieuţ (Bistriţa-Năsăud)', zip: '427315' },
  { city: 'Lunca (Bistriţa-Năsăud)', zip: '427316' },
  { city: 'Ruştior (Bistriţa-Năsăud)', zip: '427317' },
  { city: 'Sebiş (Bistriţa-Năsăud)', zip: '427318' },
  { city: 'Şintereag (Bistriţa-Năsăud)', zip: '427320' },
  { city: 'Blăjenii de Jos (Bistriţa-Năsăud)', zip: '427321' },
  { city: 'Blăjenii de Sus (Bistriţa-Năsăud)', zip: '427322' },
  { city: 'Caila (Bistriţa-Năsăud)', zip: '427323' },
  { city: 'Cociu (Bistriţa-Năsăud)', zip: '427324' },
  { city: 'Şieu-Sfântu (Bistriţa-Năsăud)', zip: '427326' },
  { city: 'Şintereag-Gară (Bistriţa-Năsăud)', zip: '427327' },
  { city: 'Târlişua (Bistriţa-Năsăud)', zip: '427330' },
  { city: 'Agrieş (Bistriţa-Năsăud)', zip: '427331' },
  { city: 'Agrieşel (Bistriţa-Năsăud)', zip: '427332' },
  { city: 'Borleasa (Bistriţa-Năsăud)', zip: '427333' },
  { city: 'Cireaşi (Bistriţa-Năsăud)', zip: '427334' },
  { city: 'Lunca Sătească (Bistriţa-Năsăud)', zip: '427336' },
  { city: 'Molişet (Bistriţa-Năsăud)', zip: '427337' },
  { city: 'Oarzina (Bistriţa-Năsăud)', zip: '427338' },
  { city: 'Răcăteşu (Bistriţa-Năsăud)', zip: '427339' },
  { city: 'Şendroaia (Bistriţa-Năsăud)', zip: '427341' },
  { city: 'Teaca (Bistriţa-Năsăud)', zip: '427345' },
  { city: 'Archiud (Bistriţa-Năsăud)', zip: '427346' },
  { city: 'Budurleni (Bistriţa-Năsăud)', zip: '427347' },
  { city: 'Ocniţa (Bistriţa-Năsăud)', zip: '427348' },
  { city: 'Pinticu (Bistriţa-Năsăud)', zip: '427349' },
  { city: 'Viile Tecii (Bistriţa-Năsăud)', zip: '427351' },
  { city: 'Telciu (Bistriţa-Năsăud)', zip: '427355' },
  { city: 'Fiad (Bistriţa-Năsăud)', zip: '427356' },
  { city: 'Telcişor (Bistriţa-Năsăud)', zip: '427357' },
  { city: 'Tiha Bârgăului (Bistriţa-Năsăud)', zip: '427360' },
  { city: 'Ciosa (Bistriţa-Năsăud)', zip: '427361' },
  { city: 'Mureşenii Bârgăului (Bistriţa-Năsăud)', zip: '427362' },
  { city: 'Piatra Fântânele (Bistriţa-Năsăud)', zip: '427363' },
  { city: 'Tureac (Bistriţa-Năsăud)', zip: '427364' },
  { city: 'Uriu (Bistriţa-Năsăud)', zip: '427365' },
  { city: 'Cristeştii Ciceului (Bistriţa-Năsăud)', zip: '427366' },
  { city: 'Hăşmaşu Ciceului (Bistriţa-Năsăud)', zip: '427367' },
  { city: 'Ilişua (Bistriţa-Năsăud)', zip: '427368' },
  { city: 'Urmeniş (Bistriţa-Năsăud)', zip: '427370' },
  { city: 'Câmp (Bistriţa-Năsăud)', zip: '427371' },
  { city: 'Coşeriu (Bistriţa-Năsăud)', zip: '427372' },
  { city: 'Delureni (Bistriţa-Năsăud)', zip: '427373' },
  { city: 'Fânaţe (Bistriţa-Năsăud)', zip: '427374' },
  { city: 'Podenii (Bistriţa-Năsăud)', zip: '427376' },
  { city: 'Scoabe (Bistriţa-Năsăud)', zip: '427377' },
  { city: 'Şopteriu (Bistriţa-Năsăud)', zip: '427378' },
  { city: 'Valea (Bistriţa-Năsăud)', zip: '427379' },
  { city: 'Valea Mare (Urmeniş) (Bistriţa-Năsăud)', zip: '427381' },
  { city: 'Zagra (Bistriţa-Năsăud)', zip: '427385' },
  { city: 'Alunişul (Bistriţa-Năsăud)', zip: '427386' },
  { city: 'Perişor (Bistriţa-Năsăud)', zip: '427387' },
  { city: 'Poienile Zagrei (Bistriţa-Năsăud)', zip: '427388' },
  { city: 'Suplai (Bistriţa-Năsăud)', zip: '427389' },
  { city: 'Botoşani (Botoşani)', zip: '710001' },
  { city: 'Darabani (Botoşani)', zip: '715100' },
  { city: 'Bajura (Botoşani)', zip: '715101' },
  { city: 'Eşanca (Botoşani)', zip: '715102' },
  { city: 'Lişmăniţa (Botoşani)', zip: '715103' },
  { city: 'Dorohoi (Botoşani)', zip: '715200' },
  { city: 'Dealu Mare (Botoşani)', zip: '715201' },
  { city: 'Loturi Enescu (Botoşani)', zip: '715202' },
  { city: 'Progresul (Botoşani)', zip: '715203' },
  { city: 'Săveni (Botoşani)', zip: '715300' },
  { city: 'Bodeasa (Botoşani)', zip: '715301' },
  { city: 'Bozieni (Botoşani)', zip: '715302' },
  { city: 'Chişcăreni (Botoşani)', zip: '715303' },
  { city: 'Petricani (Botoşani)', zip: '715304' },
  { city: 'Sat Nou (Botoşani)', zip: '715305' },
  { city: 'Albeşti (Botoşani)', zip: '717005' },
  { city: 'Buimăceni (Botoşani)', zip: '717006' },
  { city: 'Coştiugeni (Botoşani)', zip: '717007' },
  { city: 'Jijia (Botoşani)', zip: '717008' },
  { city: 'Măşcăteni (Botoşani)', zip: '717009' },
  { city: 'Tudor Vladimirescu (Albeşti) (Botoşani)', zip: '717011' },
  { city: 'Avrămeni (Botoşani)', zip: '717015' },
  { city: 'Adăşeni (Botoşani)', zip: '717016' },
  { city: 'Aurel Vlaicu (Botoşani)', zip: '717017' },
  { city: 'Dimitrie Cantemir (Botoşani)', zip: '717018' },
  { city: 'Ichimeni (Botoşani)', zip: '717019' },
  { city: 'Panaitoaia (Botoşani)', zip: '717021' },
  { city: 'Timuş (Botoşani)', zip: '717022' },
  { city: 'Tudor Vladimirescu (Avrămeni) (Botoşani)', zip: '717023' },
  { city: 'Zoiţani (Botoşani)', zip: '717024' },
  { city: 'Băluşeni (Botoşani)', zip: '717025' },
  { city: 'Băluşenii Noi (Botoşani)', zip: '717026' },
  { city: 'Buzeni (Botoşani)', zip: '717027' },
  { city: 'Coşuleni (Botoşani)', zip: '717028' },
  { city: 'Draxini (Botoşani)', zip: '717029' },
  { city: 'Zăiceşti (Botoşani)', zip: '717031' },
  { city: 'Brăeşti (Botoşani)', zip: '717035' },
  { city: 'Poiana (Brăeşti) (Botoşani)', zip: '717036' },
  { city: 'Popeni (Brăeşti) (Botoşani)', zip: '717037' },
  { city: 'Vâlcelele (Botoşani)', zip: '717038' },
  { city: 'Broscăuţi (Botoşani)', zip: '717040' },
  { city: 'Slobozia (Broscăuţi) (Botoşani)', zip: '717041' },
  { city: 'Bucecea (Botoşani)', zip: '717045' },
  { city: 'Bohoghina (Botoşani)', zip: '717046' },
  { city: 'Călineşti (Bucecea) (Botoşani)', zip: '717047' },
  { city: 'Călăraşi (Botoşani)', zip: '717050' },
  { city: 'Libertatea (Botoşani)', zip: '717051' },
  { city: 'Pleşani (Botoşani)', zip: '717052' },
  { city: 'Conceşti (Botoşani)', zip: '717055' },
  { city: 'Movileni (Botoşani)', zip: '717056' },
  { city: 'Copălău (Botoşani)', zip: '717060' },
  { city: 'Buda (Botoşani)', zip: '717061' },
  { city: 'Cerbu (Botoşani)', zip: '717062' },
  { city: 'Coşula (Botoşani)', zip: '717063' },
  { city: 'Cotu (Botoşani)', zip: '717064' },
  { city: 'Pădureni (Coşula) (Botoşani)', zip: '717066' },
  { city: 'Şupitca (Botoşani)', zip: '717067' },
  { city: 'Cordăreni (Botoşani)', zip: '717070' },
  { city: 'Griviţa (Botoşani)', zip: '717071' },
  { city: 'Slobozia (Cordăreni) (Botoşani)', zip: '717072' },
  { city: 'Corlăteni (Botoşani)', zip: '717075' },
  { city: 'Carasa (Botoşani)', zip: '717076' },
  { city: 'Dimăcheni (Botoşani)', zip: '717077' },
  { city: 'Mateieni (Botoşani)', zip: '717078' },
  { city: 'Podeni (Botoşani)', zip: '717079' },
  { city: 'Recia-Verbia (Botoşani)', zip: '717081' },
  { city: 'Vlădeni (Corlăteni) (Botoşani)', zip: '717082' },
  { city: 'Corni (Botoşani)', zip: '717085' },
  { city: 'Balta Arsă (Botoşani)', zip: '717086' },
  { city: 'Mesteacăn (Botoşani)', zip: '717087' },
  { city: 'Sarafineşti (Botoşani)', zip: '717088' },
  { city: 'Coţuşca (Botoşani)', zip: '717090' },
  { city: 'Avram Iancu (Botoşani)', zip: '717091' },
  { city: 'Cotu Miculinţi (Botoşani)', zip: '717092' },
  { city: 'Crasnaleuca (Botoşani)', zip: '717093' },
  { city: 'Ghireni (Botoşani)', zip: '717094' },
  { city: 'Mihail Kogălniceanu (Botoşani)', zip: '717096' },
  { city: 'Nichiteni (Botoşani)', zip: '717097' },
  { city: 'Nicolae Bălcescu (Coţuşca) (Botoşani)', zip: '717098' },
  { city: 'Puţureni (Botoşani)', zip: '717099' },
  { city: 'Cristeşti (Botoşani)', zip: '717100' },
  { city: 'Oneaga (Botoşani)', zip: '717101' },
  { city: 'Schit-Orăşeni (Botoşani)', zip: '717102' },
  { city: 'Unguroaia (Botoşani)', zip: '717103' },
  { city: 'Dămileni (Botoşani)', zip: '717104' },
  { city: 'Cristineşti (Botoşani)', zip: '717105' },
  { city: 'Baranca (Cristineşti) (Botoşani)', zip: '717106' },
  { city: 'Dragalina (Cristineşti) (Botoşani)', zip: '717107' },
  { city: 'Fundu Herţii (Botoşani)', zip: '717108' },
  { city: 'Poiana (Cristineşti) (Botoşani)', zip: '717109' },
  { city: 'Curteşti (Botoşani)', zip: '717110' },
  { city: 'Agafton (Botoşani)', zip: '717111' },
  { city: 'Băiceni (Botoşani)', zip: '717112' },
  { city: 'Hudum (Botoşani)', zip: '717113' },
  { city: 'Mănăstirea Doamnei (Botoşani)', zip: '717114' },
  { city: 'Orăşeni-Deal (Botoşani)', zip: '717116' },
  { city: 'Orăşeni-Vale (Botoşani)', zip: '717117' },
  { city: 'Dângeni (Botoşani)', zip: '717120' },
  { city: 'Hulub (Botoşani)', zip: '717121' },
  { city: 'Iacobeni (Botoşani)', zip: '717122' },
  { city: 'Strahotin (Botoşani)', zip: '717123' },
  { city: 'Dersca (Botoşani)', zip: '717125' },
  { city: 'Lozna (Botoşani)', zip: '717126' },
  { city: 'Străteni (Botoşani)', zip: '717127' },
  { city: 'Dobârceni (Botoşani)', zip: '717130' },
  { city: 'Bivolari (Botoşani)', zip: '717131' },
  { city: 'Brăteni (Botoşani)', zip: '717132' },
  { city: 'Cişmăneşti (Botoşani)', zip: '717133' },
  { city: 'Livada (Botoşani)', zip: '717134' },
  { city: 'Murguţa (Botoşani)', zip: '717136' },
  { city: 'Drăguşeni (Botoşani)', zip: '717140' },
  { city: 'Podriga (Botoşani)', zip: '717141' },
  { city: 'Sarata-Drăguşeni (Botoşani)', zip: '717142' },
  { city: 'Durneşti (Botoşani)', zip: '717145' },
  { city: 'Băbiceni (Botoşani)', zip: '717146' },
  { city: 'Bârsăneşti (Botoşani)', zip: '717147' },
  { city: 'Broşteni (Botoşani)', zip: '717148' },
  { city: 'Cucuteni (Botoşani)', zip: '717149' },
  { city: 'Guranda (Botoşani)', zip: '717151' },
  { city: 'Flămânzi (Botoşani)', zip: '717155' },
  { city: 'Chiţoveni (Botoşani)', zip: '717156' },
  { city: 'Nicolae Bălcescu (Flămânzi) (Botoşani)', zip: '717157' },
  { city: 'Poiana (Flămânzi) (Botoşani)', zip: '717158' },
  { city: 'Prisăcani (Botoşani)', zip: '717159' },
  { city: 'Frumuşica (Botoşani)', zip: '717160' },
  { city: 'Boscoteni (Botoşani)', zip: '717161' },
  { city: 'Rădeni (Botoşani)', zip: '717162' },
  { city: 'Storeşti (Botoşani)', zip: '717163' },
  { city: 'Şendreni (Botoşani)', zip: '717164' },
  { city: 'Vlădeni-Deal (Botoşani)', zip: '717166' },
  { city: 'George Enescu (Botoşani)', zip: '717170' },
  { city: 'Arborea (Botoşani)', zip: '717171' },
  { city: 'Dumeni (Botoşani)', zip: '717172' },
  { city: 'Popeni (George Enescu) (Botoşani)', zip: '717173' },
  { city: 'Stânca (George Enescu) (Botoşani)', zip: '717174' },
  { city: 'Gorbăneşti (Botoşani)', zip: '717175' },
  { city: 'Bătrâneşti (Botoşani)', zip: '717176' },
  { city: 'George Coşbuc (Botoşani)', zip: '717177' },
  { city: 'Mihai Eminescu (Gorbăneşti) (Botoşani)', zip: '717178' },
  { city: 'Silişcani (Botoşani)', zip: '717179' },
  { city: 'Socrujeni (Botoşani)', zip: '717181' },
  { city: 'Vânători (Botoşani)', zip: '717182' },
  { city: 'Viforeni (Botoşani)', zip: '717183' },
  { city: 'Havârna (Botoşani)', zip: '717185' },
  { city: 'Balinţi (Botoşani)', zip: '717186' },
  { city: 'Galbeni (Botoşani)', zip: '717187' },
  { city: 'Gârbeni (Botoşani)', zip: '717188' },
  { city: 'Niculcea (Botoşani)', zip: '717189' },
  { city: 'Tătărăşeni (Botoşani)', zip: '717191' },
  { city: 'Hăneşti (Botoşani)', zip: '717195' },
  { city: 'Borolea (Botoşani)', zip: '717196' },
  { city: 'Moara Jorii (Botoşani)', zip: '717197' },
  { city: 'Sarata-Basarab (Botoşani)', zip: '717198' },
  { city: 'Slobozia Hăneşti (Botoşani)', zip: '717199' },
  { city: 'Hilişeu-Horia (Botoşani)', zip: '717200' },
  { city: 'Corjăuţi (Botoşani)', zip: '717201' },
  { city: 'Hilişeu-Cloşca (Botoşani)', zip: '717202' },
  { city: 'Hilişeu-Crişan (Botoşani)', zip: '717203' },
  { city: 'Iezer (Botoşani)', zip: '717204' },
  { city: 'Hlipiceni (Botoşani)', zip: '717205' },
  { city: 'Dragalina (Hlipiceni) (Botoşani)', zip: '717206' },
  { city: 'Victoria (Hlipiceni) (Botoşani)', zip: '717207' },
  { city: 'Başeu (Botoşani)', zip: '717209' },
  { city: 'Hudeşti (Botoşani)', zip: '717210' },
  { city: 'Alba (Botoşani)', zip: '717211' },
  { city: 'Baranca (Hudeşti) (Botoşani)', zip: '717212' },
  { city: 'Mlenăuţi (Botoşani)', zip: '717213' },
  { city: 'Vatra (Botoşani)', zip: '717214' },
  { city: 'Ibăneşti (Botoşani)', zip: '717215' },
  { city: 'Dumbrăviţa (Botoşani)', zip: '717216' },
  { city: 'Leorda (Botoşani)', zip: '717220' },
  { city: 'Belcea (Botoşani)', zip: '717221' },
  { city: 'Costineşti (Botoşani)', zip: '717222' },
  { city: 'Dolina (Botoşani)', zip: '717223' },
  { city: 'Mitoc (Leorda) (Botoşani)', zip: '717224' },
  { city: 'Lunca (Botoşani)', zip: '717225' },
  { city: 'Stroieşti (Botoşani)', zip: '717226' },
  { city: 'Zlătunoaia (Botoşani)', zip: '717227' },
  { city: 'Manoleasa (Botoşani)', zip: '717230' },
  { city: 'Bold (Botoşani)', zip: '717231' },
  { city: 'Flondora (Botoşani)', zip: '717232' },
  { city: 'Iorga (Botoşani)', zip: '717233' },
  { city: 'Liveni (Botoşani)', zip: '717234' },
  { city: 'Loturi (Botoşani)', zip: '717236' },
  { city: 'Manoleasa-Prut (Botoşani)', zip: '717237' },
  { city: 'Sadoveni (Botoşani)', zip: '717238' },
  { city: 'Şerpeniţa (Botoşani)', zip: '717239' },
  { city: 'Zahoreni (Botoşani)', zip: '717241' },
  { city: 'Mihai Eminescu (Botoşani)', zip: '717245' },
  { city: 'Baisa (Botoşani)', zip: '717246' },
  { city: 'Cătămăreşti (Botoşani)', zip: '717247' },
  { city: 'Cătămăreşti-Deal (Botoşani)', zip: '717248' },
  { city: 'Cerviceşti (Botoşani)', zip: '717249' },
  { city: 'Cerviceşti-Deal (Botoşani)', zip: '717251' },
  { city: 'Cucorăni (Botoşani)', zip: '717252' },
  { city: 'Ipoteşti (Botoşani)', zip: '717253' },
  { city: 'Manoleşti (Botoşani)', zip: '717254' },
  { city: 'Stânceşti (Botoşani)', zip: '717256' },
  { city: 'Mihăileni (Botoşani)', zip: '717260' },
  { city: 'Călineşti (Cândeşti) (Botoşani)', zip: '717261' },
  { city: 'Cândeşti (Botoşani)', zip: '717262' },
  { city: 'Pârâu Negru (Botoşani)', zip: '717263' },
  { city: 'Rogojeşti (Botoşani)', zip: '717264' },
  { city: 'Talpa (Botoşani)', zip: '717266' },
  { city: 'Viţcani (Botoşani)', zip: '717267' },
  { city: 'Mihălăşeni (Botoşani)', zip: '717270' },
  { city: 'Caraiman (Botoşani)', zip: '717271' },
  { city: 'Năstase (Botoşani)', zip: '717272' },
  { city: 'Negreşti (Botoşani)', zip: '717273' },
  { city: 'Păun (Botoşani)', zip: '717274' },
  { city: 'Sarata (Botoşani)', zip: '717276' },
  { city: 'Slobozia Silişcani (Botoşani)', zip: '717277' },
  { city: 'Mileanca (Botoşani)', zip: '717280' },
  { city: 'Codreni (Botoşani)', zip: '717281' },
  { city: 'Scutari (Botoşani)', zip: '717282' },
  { city: 'Seliştea (Botoşani)', zip: '717283' },
  { city: 'Mitoc (Botoşani)', zip: '717285' },
  { city: 'Horia (Botoşani)', zip: '717286' },
  { city: 'Nicşeni (Botoşani)', zip: '717290' },
  { city: 'Dacia (Botoşani)', zip: '717291' },
  { city: 'Dorobanţi (Botoşani)', zip: '717292' },
  { city: 'Păltiniş (Botoşani)', zip: '717295' },
  { city: 'Cuzlău (Botoşani)', zip: '717296' },
  { city: 'Horodiştea (Botoşani)', zip: '717297' },
  { city: 'Slobozia (Păltiniş) (Botoşani)', zip: '717298' },
  { city: 'Pomârla (Botoşani)', zip: '717300' },
  { city: 'Hulubeşti (Botoşani)', zip: '717301' },
  { city: 'Racovăţ (Botoşani)', zip: '717302' },
  { city: 'Prăjeni (Botoşani)', zip: '717305' },
  { city: 'Câmpeni (Botoşani)', zip: '717306' },
  { city: 'Lupăria (Botoşani)', zip: '717307' },
  { city: 'Miletin (Botoşani)', zip: '717308' },
  { city: 'Răchiţi (Botoşani)', zip: '717310' },
  { city: 'Cişmea (Botoşani)', zip: '717311' },
  { city: 'Costeşti (Botoşani)', zip: '717312' },
  { city: 'Roşiori (Botoşani)', zip: '717313' },
  { city: 'Rădăuţi-Prut (Botoşani)', zip: '717315' },
  { city: 'Miorcani (Botoşani)', zip: '717316' },
  { city: 'Rediu (Rădăuţi-Prut) (Botoşani)', zip: '717317' },
  { city: 'Răuseni (Botoşani)', zip: '717320' },
  { city: 'Doina (Botoşani)', zip: '717321' },
  { city: 'Pogorăşti (Botoşani)', zip: '717322' },
  { city: 'Rediu (Răuseni) (Botoşani)', zip: '717323' },
  { city: 'Stolniceni (Botoşani)', zip: '717324' },
  { city: 'Ripiceni (Botoşani)', zip: '717325' },
  { city: 'Cinghiniia (Botoşani)', zip: '717326' },
  { city: 'Lehneşti (Botoşani)', zip: '717327' },
  { city: 'Movila Ruptă (Botoşani)', zip: '717328' },
  { city: 'Popoaia (Botoşani)', zip: '717329' },
  { city: 'Râşca (Botoşani)', zip: '717331' },
  { city: 'Ripicenii Vechi (Botoşani)', zip: '717332' },
  { city: 'Roma (Botoşani)', zip: '717335' },
  { city: 'Cotârgaci (Botoşani)', zip: '717336' },
  { city: 'Româneşti (Botoşani)', zip: '717340' },
  { city: 'Dămideni (Botoşani)', zip: '717341' },
  { city: 'Româneşti-Vale (Botoşani)', zip: '717342' },
  { city: 'Sărata (Botoşani)', zip: '717343' },
  { city: 'Santa Mare (Botoşani)', zip: '717345' },
  { city: 'Bădărăi (Botoşani)', zip: '717346' },
  { city: 'Berza (Botoşani)', zip: '717347' },
  { city: 'Bogdăneşti (Botoşani)', zip: '717348' },
  { city: 'Durneşti (Santa Mare) (Botoşani)', zip: '717349' },
  { city: 'Ilişeni (Botoşani)', zip: '717351' },
  { city: 'Rânghileşti (Botoşani)', zip: '717352' },
  { city: 'Rânghileşti-Deal (Botoşani)', zip: '717353' },
  { city: 'Stăuceni (Botoşani)', zip: '717355' },
  { city: 'Siliştea (Botoşani)', zip: '717356' },
  { city: 'Tocileni (Botoşani)', zip: '717357' },
  { city: 'Victoria (Stăuceni) (Botoşani)', zip: '717358' },
  { city: 'Suharău (Botoşani)', zip: '717360' },
  { city: 'Izvoare (Botoşani)', zip: '717361' },
  { city: 'Lişna (Botoşani)', zip: '717362' },
  { city: 'Oroftiana (Botoşani)', zip: '717363' },
  { city: 'Plevna (Botoşani)', zip: '717364' },
  { city: 'Smârdan (Botoşani)', zip: '717366' },
  { city: 'Suliţa (Botoşani)', zip: '717370' },
  { city: 'Blândeşti (Botoşani)', zip: '717371' },
  { city: 'Cerchejeni (Botoşani)', zip: '717372' },
  { city: 'Cheliş (Botoşani)', zip: '717373' },
  { city: 'Dracşani (Botoşani)', zip: '717374' },
  { city: 'Şoldăneşti (Botoşani)', zip: '717376' },
  { city: 'Şendriceni (Botoşani)', zip: '717380' },
  { city: 'Horlăceni (Botoşani)', zip: '717381' },
  { city: 'Pădureni (Şendriceni) (Botoşani)', zip: '717382' },
  { city: 'Ştefăneşti (Botoşani)', zip: '717385' },
  { city: 'Bădiuţi (Botoşani)', zip: '717386' },
  { city: 'Bobuleşti (Botoşani)', zip: '717387' },
  { city: 'Stânca (Ştefăneşti) (Botoşani)', zip: '717388' },
  { city: 'Ştefăneşti-Sat (Botoşani)', zip: '717389' },
  { city: 'Ştiubieni (Botoşani)', zip: '717390' },
  { city: 'Ibăneasa (Botoşani)', zip: '717391' },
  { city: 'Negreni (Botoşani)', zip: '717392' },
  { city: 'Todireni (Botoşani)', zip: '717395' },
  { city: 'Cerneşti (Botoşani)', zip: '717396' },
  { city: 'Floreşti (Botoşani)', zip: '717397' },
  { city: 'Gârbeşti (Botoşani)', zip: '717398' },
  { city: 'Iureşti (Botoşani)', zip: '717399' },
  { city: 'Truşeşti (Botoşani)', zip: '717400' },
  { city: 'Buhăceni (Botoşani)', zip: '717401' },
  { city: 'Ciritei (Botoşani)', zip: '717402' },
  { city: 'Drislea (Botoşani)', zip: '717403' },
  { city: 'Ionăşeni (Truşeşti) (Botoşani)', zip: '717404' },
  { city: 'Păsăteni (Botoşani)', zip: '717406' },
  { city: 'Tudora (Botoşani)', zip: '717410' },
  { city: 'Ungureni (Botoşani)', zip: '717415' },
  { city: 'Borzeşti (Botoşani)', zip: '717416' },
  { city: 'Călugăreni (Botoşani)', zip: '717417' },
  { city: 'Călugărenii Noi (Botoşani)', zip: '717418' },
  { city: 'Durneşti (Ungureni) (Botoşani)', zip: '717419' },
  { city: 'Mândreşti (Ungureni) (Botoşani)', zip: '717421' },
  { city: 'Mihai Viteazu (Botoşani)', zip: '717422' },
  { city: 'Plopenii Mari (Botoşani)', zip: '717423' },
  { city: 'Plopenii Mici (Botoşani)', zip: '717424' },
  { city: 'Tăuteşti (Botoşani)', zip: '717426' },
  { city: 'Vicoleni (Botoşani)', zip: '717427' },
  { city: 'Unţeni (Botoşani)', zip: '717435' },
  { city: 'Burla (Botoşani)', zip: '717436' },
  { city: 'Burleşti (Botoşani)', zip: '717437' },
  { city: 'Mânăstireni (Botoşani)', zip: '717438' },
  { city: 'Soroceni (Botoşani)', zip: '717439' },
  { city: 'Valea Grajdului (Botoşani)', zip: '717441' },
  { city: 'Vultureni (Botoşani)', zip: '717442' },
  { city: 'Văculeşti (Botoşani)', zip: '717445' },
  { city: 'Gorovei (Botoşani)', zip: '717446' },
  { city: 'Sauceniţa (Botoşani)', zip: '717447' },
  { city: 'Dobrinăuţi-Hapăi (Botoşani)', zip: '717449' },
  { city: 'Vârfu Câmpului (Botoşani)', zip: '717450' },
  { city: 'Ionăşeni (Vârfu Câmpului) (Botoşani)', zip: '717451' },
  { city: 'Lunca (Vârfu Câmpului) (Botoşani)', zip: '717452' },
  { city: 'Maghera (Botoşani)', zip: '717453' },
  { city: 'Pustoaia (Botoşani)', zip: '717454' },
  { city: 'Viişoara (Botoşani)', zip: '717455' },
  { city: 'Cuza Vodă (Botoşani)', zip: '717456' },
  { city: 'Viişoara Mică (Botoşani)', zip: '717457' },
  { city: 'Vlădeni (Botoşani)', zip: '717460' },
  { city: 'Brehuieşti (Botoşani)', zip: '717461' },
  { city: 'Hrişcani (Botoşani)', zip: '717462' },
  { city: 'Huţani (Botoşani)', zip: '717463' },
  { city: 'Mândreşti (Vlădeni) (Botoşani)', zip: '717464' },
  { city: 'Vlăsineşti (Botoşani)', zip: '717465' },
  { city: 'Miron Costin (Botoşani)', zip: '717466' },
  { city: 'Sârbi (Botoşani)', zip: '717467' },
  { city: 'Vorniceni (Botoşani)', zip: '717470' },
  { city: 'Davidoaia (Botoşani)', zip: '717471' },
  { city: 'Dealu Crucii (Botoşani)', zip: '717472' },
  { city: 'Vorona (Botoşani)', zip: '717475' },
  { city: 'Icuşeni (Botoşani)', zip: '717476' },
  { city: 'Joldeşti (Botoşani)', zip: '717477' },
  { city: 'Poiana (Vorona) (Botoşani)', zip: '717478' },
  { city: 'Vorona Mare (Botoşani)', zip: '717479' },
  { city: 'Vorona-Teodoru (Botoşani)', zip: '717481' },
  { city: 'Brăila (Brăila)', zip: '810001' },
  { city: 'Făurei (Brăila)', zip: '815100' },
  { city: 'Ianca (Brăila)', zip: '815200' },
  { city: 'Berleşti (Brăila)', zip: '815201' },
  { city: 'Gara Ianca (Brăila)', zip: '815202' },
  { city: 'Oprişeneşti (Brăila)', zip: '815203' },
  { city: 'Perişoru (Brăila)', zip: '815204' },
  { city: 'Plopu (Brăila)', zip: '815205' },
  { city: 'Târlele Filiu (Brăila)', zip: '815206' },
  { city: 'Însurăţei (Brăila)', zip: '815300' },
  { city: 'Lacu Rezii (Brăila)', zip: '815301' },
  { city: 'Măru Roşu (Brăila)', zip: '815302' },
  { city: 'Valea Călmăţuiului (Brăila)', zip: '815303' },
  { city: 'Bărăganul (Brăila)', zip: '817005' },
  { city: 'Berteştii de Jos (Brăila)', zip: '817010' },
  { city: 'Berteştii de Sus (Brăila)', zip: '817011' },
  { city: 'Gura Călmăţui (Brăila)', zip: '817012' },
  { city: 'Gura Gârluţei (Brăila)', zip: '817013' },
  { city: 'Nicoleşti (Brăila)', zip: '817014' },
  { city: 'Spiru Haret (Brăila)', zip: '817016' },
  { city: 'Bordei Verde (Brăila)', zip: '817020' },
  { city: 'Constantin Gabrielescu (Brăila)', zip: '817021' },
  { city: 'Filiu (Brăila)', zip: '817022' },
  { city: 'Lişcoteanca (Brăila)', zip: '817023' },
  { city: 'Chiscani (Brăila)', zip: '817025' },
  { city: 'Lacu Sărat (Brăila)', zip: '817026' },
  { city: 'Vărsătura (Brăila)', zip: '817027' },
  { city: 'Ciocile (Brăila)', zip: '817030' },
  { city: 'Chichineţu (Brăila)', zip: '817031' },
  { city: 'Chioibăşeşti (Brăila)', zip: '817032' },
  { city: 'Odăieni (Brăila)', zip: '817033' },
  { city: 'Cireşu (Brăila)', zip: '817035' },
  { city: 'Batogu (Brăila)', zip: '817036' },
  { city: 'Ioneşti (Brăila)', zip: '817037' },
  { city: 'Scărlăteşti (Brăila)', zip: '817038' },
  { city: 'Vultureni (Brăila)', zip: '817039' },
  { city: 'Dudeşti (Brăila)', zip: '817040' },
  { city: 'Bumbăcari (Brăila)', zip: '817041' },
  { city: 'Tătaru (Brăila)', zip: '817042' },
  { city: 'Frecăţei (Brăila)', zip: '817045' },
  { city: 'Agaua (Brăila)', zip: '817046' },
  { city: 'Cistia (Brăila)', zip: '817047' },
  { city: 'Salcia (Brăila)', zip: '817048' },
  { city: 'Stoieneşti (Brăila)', zip: '817049' },
  { city: 'Titcov (Brăila)', zip: '817051' },
  { city: 'Galbenu (Brăila)', zip: '817055' },
  { city: 'Drogu (Brăila)', zip: '817056' },
  { city: 'Pântecani (Brăila)', zip: '817057' },
  { city: 'Sătuc (Brăila)', zip: '817058' },
  { city: 'Zamfireşti (Brăila)', zip: '817059' },
  { city: 'Gemenele (Brăila)', zip: '817060' },
  { city: 'Găvani (Brăila)', zip: '817061' },
  { city: 'Grădiştea (Brăila)', zip: '817065' },
  { city: 'Ibrianu (Brăila)', zip: '817066' },
  { city: 'Maraloiu (Brăila)', zip: '817067' },
  { city: 'Gropeni (Brăila)', zip: '817070' },
  { city: 'Jirlău (Brăila)', zip: '817075' },
  { city: 'Brădeanca (Brăila)', zip: '817076' },
  { city: 'Măraşu (Brăila)', zip: '817080' },
  { city: 'Băndoiu (Brăila)', zip: '817081' },
  { city: 'Măgureni (Brăila)', zip: '817082' },
  { city: 'Nedelcu (Brăila)', zip: '817083' },
  { city: 'Plopi (Brăila)', zip: '817084' },
  { city: 'Ţăcău (Brăila)', zip: '817086' },
  { city: 'Măxineni (Brăila)', zip: '817090' },
  { city: 'Corbu Nou (Brăila)', zip: '817091' },
  { city: 'Corbu Vechi (Brăila)', zip: '817092' },
  { city: 'Latinu (Brăila)', zip: '817093' },
  { city: 'Voineşti (Brăila)', zip: '817094' },
  { city: 'Mircea Vodă (Brăila)', zip: '817095' },
  { city: 'Deduleşti (Brăila)', zip: '817096' },
  { city: 'Movila Miresii (Brăila)', zip: '817100' },
  { city: 'Esna (Brăila)', zip: '817101' },
  { city: 'Ţepeş Vodă (Brăila)', zip: '817102' },
  { city: 'Racoviţa (Brăila)', zip: '817105' },
  { city: 'Corbeni (Brăila)', zip: '817106' },
  { city: 'Custura (Brăila)', zip: '817107' },
  { city: 'Râmnicelu (Brăila)', zip: '817110' },
  { city: 'Boarca (Brăila)', zip: '817111' },
  { city: 'Constantineşti (Brăila)', zip: '817112' },
  { city: 'Mihail Kogălniceanu (Râmnicelu) (Brăila)', zip: '817113' },
  { city: 'Romanu (Brăila)', zip: '817115' },
  { city: 'Oancea (Brăila)', zip: '817116' },
  { city: 'Roşiori (Brăila)', zip: '817120' },
  { city: 'Colţea (Brăila)', zip: '817121' },
  { city: 'Florica (Brăila)', zip: '817122' },
  { city: 'Pribeagu (Brăila)', zip: '817123' },
  { city: 'Salcia Tudor (Brăila)', zip: '817125' },
  { city: 'Ariciu (Brăila)', zip: '817126' },
  { city: 'Cuza Vodă (Salcia Tudor) (Brăila)', zip: '817127' },
  { city: 'Gulianca (Brăila)', zip: '817128' },
  { city: 'Olăneasca (Brăila)', zip: '817129' },
  { city: 'Scorţaru Nou (Brăila)', zip: '817130' },
  { city: 'Deşiraţi (Brăila)', zip: '817131' },
  { city: 'Gurguieţi (Brăila)', zip: '817132' },
  { city: 'Nicolae Bălcescu (Brăila)', zip: '817133' },
  { city: 'Pitulaţi (Brăila)', zip: '817134' },
  { city: 'Sihleanu (Brăila)', zip: '817136' },
  { city: 'Siliştea (Brăila)', zip: '817140' },
  { city: 'Cotu Lung (Brăila)', zip: '817141' },
  { city: 'Cotu Mihalea (Brăila)', zip: '817142' },
  { city: 'Mărtăceşti (Brăila)', zip: '817143' },
  { city: 'Muchea (Brăila)', zip: '817144' },
  { city: 'Vameşu (Brăila)', zip: '817146' },
  { city: 'Stăncuţa (Brăila)', zip: '817150' },
  { city: 'Cuza Vodă (Stăncuţa) (Brăila)', zip: '817151' },
  { city: 'Polizeşti (Brăila)', zip: '817152' },
  { city: 'Stanca (Brăila)', zip: '817153' },
  { city: 'Surdila-Găiseanca (Brăila)', zip: '817155' },
  { city: 'Filipeşti (Brăila)', zip: '817156' },
  { city: 'Surdila-Greci (Brăila)', zip: '817160' },
  { city: 'Brateşu Vechi (Brăila)', zip: '817161' },
  { city: 'Făurei-Sat (Brăila)', zip: '817162' },
  { city: 'Horia (Brăila)', zip: '817163' },
  { city: 'Şuţeşti (Brăila)', zip: '817165' },
  { city: 'Mihail Kogălniceanu (Şuţeşti) (Brăila)', zip: '817166' },
  { city: 'Tichileşti (Brăila)', zip: '817170' },
  { city: 'Albina (Brăila)', zip: '817171' },
  { city: 'Traian (Brăila)', zip: '817175' },
  { city: 'Căldăruşa (Brăila)', zip: '817176' },
  { city: 'Silistraru (Brăila)', zip: '817177' },
  { city: 'Urleasca (Brăila)', zip: '817178' },
  { city: 'Tudor Vladimirescu (Brăila)', zip: '817180' },
  { city: 'Cazasu (Brăila)', zip: '817181' },
  { city: 'Comăneasca (Brăila)', zip: '817182' },
  { city: 'Scorţaru Vechi (Brăila)', zip: '817183' },
  { city: 'Tufeşti (Brăila)', zip: '817185' },
  { city: 'Ulmu (Brăila)', zip: '817190' },
  { city: 'Jugureanu (Brăila)', zip: '817191' },
  { city: 'Unirea (Brăila)', zip: '817195' },
  { city: 'Moroteşti (Brăila)', zip: '817196' },
  { city: 'Valea Cânepii (Brăila)', zip: '817197' },
  { city: 'Vădeni (Brăila)', zip: '817200' },
  { city: 'Baldovineşti (Brăila)', zip: '817201' },
  { city: 'Pietroiu (Brăila)', zip: '817202' },
  { city: 'Victoria (Brăila)', zip: '817205' },
  { city: 'Mihai Bravu (Brăila)', zip: '817206' },
  { city: 'Vişani (Brăila)', zip: '817210' },
  { city: 'Câineni-Băi (Brăila)', zip: '817211' },
  { city: 'Plăsoiu (Brăila)', zip: '817212' },
  { city: 'Viziru (Brăila)', zip: '817215' },
  { city: 'Lanurile (Brăila)', zip: '817216' },
  { city: 'Zăvoaia (Brăila)', zip: '817220' },
  { city: 'Dudescu (Brăila)', zip: '817221' },
  { city: 'Poiana Braşov (Braşov)', zip: '500001' },
  { city: 'Braşov (Braşov)', zip: '500002' },
  { city: 'Codlea (Braşov)', zip: '505100' },
  { city: 'Făgăraş (Braşov)', zip: '505200' },
  { city: 'Predeal (Braşov)', zip: '505300' },
  { city: 'Pârâul Rece (Braşov)', zip: '505301' },
  { city: 'Timişu de Jos (Braşov)', zip: '505302' },
  { city: 'Timişu de Sus (Braşov)', zip: '505303' },
  { city: 'Râşnov (Braşov)', zip: '505400' },
  { city: 'Râşnov Romacril (Braşov)', zip: '505401' },
  { city: 'Rupea (Braşov)', zip: '505500' },
  { city: 'Fişer (Braşov)', zip: '505501' },
  { city: 'Săcele (Braşov)', zip: '505600' },
  { city: 'Victoria (Braşov)', zip: '505700' },
  { city: 'Zărneşti (Braşov)', zip: '505800' },
  { city: 'Tohanu Nou (Braşov)', zip: '505801' },
  { city: 'Apaţa (Braşov)', zip: '507005' },
  { city: 'Beclean (Braşov)', zip: '507010' },
  { city: 'Boholţ (Braşov)', zip: '507011' },
  { city: 'Calbor (Braşov)', zip: '507012' },
  { city: 'Hurez (Braşov)', zip: '507013' },
  { city: 'Luţa (Braşov)', zip: '507014' },
  { city: 'Bod (Braşov)', zip: '507015' },
  { city: 'Colonia Bod (Braşov)', zip: '507020' },
  { city: 'Bran (Braşov)', zip: '507025' },
  { city: 'Predeluţ (Braşov)', zip: '507026' },
  { city: 'Sohodol (Braşov)', zip: '507027' },
  { city: 'Şimon (Braşov)', zip: '507028' },
  { city: 'Budila (Braşov)', zip: '507030' },
  { city: 'Buneşti (Braşov)', zip: '507035' },
  { city: 'Criţ (Braşov)', zip: '507036' },
  { city: 'Meşendorf (Braşov)', zip: '507037' },
  { city: 'Roadeş (Braşov)', zip: '507038' },
  { city: 'Viscri (Braşov)', zip: '507039' },
  { city: 'Caţa (Braşov)', zip: '507040' },
  { city: 'Beia (Braşov)', zip: '507041' },
  { city: 'Drăuşeni (Braşov)', zip: '507042' },
  { city: 'Ioneşti (Braşov)', zip: '507043' },
  { city: 'Paloş (Braşov)', zip: '507044' },
  { city: 'Cincu (Braşov)', zip: '507045' },
  { city: 'Toarcla (Braşov)', zip: '507046' },
  { city: 'Comana (Braşov)', zip: '507050' },
  { city: 'Comana de Jos (Braşov)', zip: '507051' },
  { city: 'Comana de Sus (Braşov)', zip: '507052' },
  { city: 'Crihalma (Braşov)', zip: '507053' },
  { city: 'Ticuşu Nou (Braşov)', zip: '507054' },
  { city: 'Cristian (Braşov)', zip: '507055' },
  { city: 'Dumbrăviţa (Braşov)', zip: '507060' },
  { city: 'Vlădeni (Braşov)', zip: '507061' },
  { city: 'Feldioara (Braşov)', zip: '507065' },
  { city: 'Colonia Reconstrucţia (Braşov)', zip: '507066' },
  { city: 'Rotbav (Braşov)', zip: '507067' },
  { city: 'Fundata (Braşov)', zip: '507070' },
  { city: 'Fundăţica (Braşov)', zip: '507071' },
  { city: 'Şirnea (Braşov)', zip: '507072' },
  { city: 'Ghimbav (Braşov)', zip: '507075' },
  { city: 'Hălchiu (Braşov)', zip: '507080' },
  { city: 'Crizbav (Braşov)', zip: '507081' },
  { city: 'Cutuş (Braşov)', zip: '507082' },
  { city: 'Satu Nou (Braşov)', zip: '507083' },
  { city: 'Hărman (Braşov)', zip: '507085' },
  { city: 'Podu Oltului (Braşov)', zip: '507086' },
  { city: 'Hârseni (Braşov)', zip: '507090' },
  { city: 'Copăcel (Braşov)', zip: '507091' },
  { city: 'Măliniş (Braşov)', zip: '507092' },
  { city: 'Mărgineni (Braşov)', zip: '507093' },
  { city: 'Sebeş (Braşov)', zip: '507094' },
  { city: 'Hoghiz (Braşov)', zip: '507095' },
  { city: 'Bogata Olteană (Braşov)', zip: '507096' },
  { city: 'Cuciulata (Braşov)', zip: '507097' },
  { city: 'Dopca (Braşov)', zip: '507098' },
  { city: 'Fântâna (Braşov)', zip: '507099' },
  { city: 'Lupşa (Braşov)', zip: '507101' },
  { city: 'Homorod (Braşov)', zip: '507105' },
  { city: 'Jimbor (Braşov)', zip: '507106' },
  { city: 'Mercheaşa (Braşov)', zip: '507107' },
  { city: 'Jibert (Braşov)', zip: '507110' },
  { city: 'Dacia (Braşov)', zip: '507111' },
  { city: 'Grânari (Braşov)', zip: '507112' },
  { city: 'Lovnic (Braşov)', zip: '507113' },
  { city: 'Văleni (Braşov)', zip: '507114' },
  { city: 'Lisa (Braşov)', zip: '507115' },
  { city: 'Breaza (Braşov)', zip: '507116' },
  { city: 'Pojorta (Braşov)', zip: '507117' },
  { city: 'Măieruş (Braşov)', zip: '507120' },
  { city: 'Arini (Braşov)', zip: '507121' },
  { city: 'Mândra (Braşov)', zip: '507125' },
  { city: 'Ileni (Braşov)', zip: '507126' },
  { city: 'Râuşor (Braşov)', zip: '507127' },
  { city: 'Şona (Braşov)', zip: '507128' },
  { city: 'Toderiţa (Braşov)', zip: '507129' },
  { city: 'Moieciu (Braşov)', zip: '507130' },
  { city: 'Cheia (Braşov)', zip: '507131' },
  { city: 'Drumul Carului (Braşov)', zip: '507132' },
  { city: 'Măgura (Braşov)', zip: '507133' },
  { city: 'Moieciu de Sus (Braşov)', zip: '507134' },
  { city: 'Moieciu de Jos (Braşov)', zip: '507135' },
  { city: 'Peştera (Braşov)', zip: '507136' },
  { city: 'Ormeniş (Braşov)', zip: '507150' },
  { city: 'Augustin (Braşov)', zip: '507151' },
  { city: 'Părău (Braşov)', zip: '507155' },
  { city: 'Grid (Braşov)', zip: '507156' },
  { city: 'Veneţia de Jos (Braşov)', zip: '507157' },
  { city: 'Veneţia de Sus (Braşov)', zip: '507158' },
  { city: 'Poiana Mărului (Braşov)', zip: '507160' },
  { city: 'Prejmer (Braşov)', zip: '507165' },
  { city: 'Stupinii Prejmerului (Braşov)', zip: '507166' },
  { city: 'Lunca Calnicului (Braşov)', zip: '507170' },
  { city: 'Racoş (Braşov)', zip: '507175' },
  { city: 'Mateiaş (Braşov)', zip: '507176' },
  { city: 'Recea (Braşov)', zip: '507180' },
  { city: 'Berivoi (Braşov)', zip: '507181' },
  { city: 'Dejani (Braşov)', zip: '507182' },
  { city: 'Gura Văii (Braşov)', zip: '507183' },
  { city: 'Iaşi (Braşov)', zip: '507184' },
  { city: 'Săsciori (Braşov)', zip: '507186' },
  { city: 'Săvăstreni (Braşov)', zip: '507187' },
  { city: 'Sânpetru (Braşov)', zip: '507190' },
  { city: 'Şercaia (Braşov)', zip: '507195' },
  { city: 'Hălmeag (Braşov)', zip: '507196' },
  { city: 'Vad (Braşov)', zip: '507197' },
  { city: 'Şinca (Braşov)', zip: '507200' },
  { city: 'Bucium (Braşov)', zip: '507201' },
  { city: 'Ohaba (Braşov)', zip: '507202' },
  { city: 'Perşani (Braşov)', zip: '507203' },
  { city: 'Şercăiţa (Braşov)', zip: '507204' },
  { city: 'Şinca Veche (Braşov)', zip: '507206' },
  { city: 'Vâlcea (Braşov)', zip: '507207' },
  { city: 'Şinca Nouă (Braşov)', zip: '507210' },
  { city: 'Paltin (Braşov)', zip: '507211' },
  { city: 'Şoarş (Braşov)', zip: '507215' },
  { city: 'Bărcut (Braşov)', zip: '507216' },
  { city: 'Felmer (Braşov)', zip: '507217' },
  { city: 'Rodbav (Braşov)', zip: '507218' },
  { city: 'Seliştat (Braşov)', zip: '507219' },
  { city: 'Tărlungeni (Braşov)', zip: '507220' },
  { city: 'Cărpiniş (Braşov)', zip: '507221' },
  { city: 'Purcăreni (Braşov)', zip: '507222' },
  { city: 'Zizin (Braşov)', zip: '507223' },
  { city: 'Teliu (Braşov)', zip: '507225' },
  { city: 'Ticuşu (Braşov)', zip: '507230' },
  { city: 'Cobor (Braşov)', zip: '507231' },
  { city: 'Ticuşu Vechi (Braşov)', zip: '507232' },
  { city: 'Ucea (Braşov)', zip: '507235' },
  { city: 'Corbi (Braşov)', zip: '507236' },
  { city: 'Feldioara (Ucea) (Braşov)', zip: '507237' },
  { city: 'Ucea de Jos (Braşov)', zip: '507238' },
  { city: 'Ucea de Sus (Braşov)', zip: '507239' },
  { city: 'Ungra (Braşov)', zip: '507240' },
  { city: 'Dăişoara (Braşov)', zip: '507241' },
  { city: 'Vama Buzăului (Braşov)', zip: '507245' },
  { city: 'Acriş (Braşov)', zip: '507246' },
  { city: 'Buzăiel (Braşov)', zip: '507247' },
  { city: 'Dălghiu (Braşov)', zip: '507248' },
  { city: 'Viştea (Braşov)', zip: '507250' },
  { city: 'Drăguş (Braşov)', zip: '507251' },
  { city: 'Olteţ (Braşov)', zip: '507252' },
  { city: 'Rucăr (Braşov)', zip: '507253' },
  { city: 'Viştea de Jos (Braşov)', zip: '507254' },
  { city: 'Viştea de Sus (Braşov)', zip: '507256' },
  { city: 'Viştişoara (Braşov)', zip: '507257' },
  { city: 'Voila (Braşov)', zip: '507260' },
  { city: 'Cincşor (Braşov)', zip: '507261' },
  { city: 'Dridif (Braşov)', zip: '507262' },
  { city: 'Ludişor (Braşov)', zip: '507263' },
  { city: 'Sâmbăta de Jos (Braşov)', zip: '507264' },
  { city: 'Sâmbăta de Sus (Braşov)', zip: '507266' },
  { city: 'Staţiunea Climaterică Sâmbăta (Braşov)', zip: '507267' },
  { city: 'Voivodeni (Braşov)', zip: '507268' },
  { city: 'Vulcan (Braşov)', zip: '507270' },
  { city: 'Colonia 1 Mai (Braşov)', zip: '507271' },
  { city: 'Holbav (Braşov)', zip: '507272' },
  { city: 'Buzău (Buzău)', zip: '120001' },
  { city: 'Nehoiu (Buzău)', zip: '125100' },
  { city: 'Bâsca Rozilei (Buzău)', zip: '125101' },
  { city: 'Chirleşti (Buzău)', zip: '125102' },
  { city: 'Curmătura (Buzău)', zip: '125103' },
  { city: 'Lunca Priporului (Buzău)', zip: '125104' },
  { city: 'Mlăjet (Buzău)', zip: '125105' },
  { city: 'Nehoiaşu (Buzău)', zip: '125106' },
  { city: 'Păltineni (Buzău)', zip: '125107' },
  { city: 'Stănila (Buzău)', zip: '125108' },
  { city: 'Vineţisu (Buzău)', zip: '125109' },
  { city: 'Pogoanele (Buzău)', zip: '125200' },
  { city: 'Căldărăşti (Buzău)', zip: '125201' },
  { city: 'Râmnicu Sărat (Buzău)', zip: '125300' },
  { city: 'Amaru (Buzău)', zip: '127005' },
  { city: 'Câmpeni (Buzău)', zip: '127006' },
  { city: 'Dulbanu (Buzău)', zip: '127007' },
  { city: 'Lacu Sinaia (Buzău)', zip: '127008' },
  { city: 'Lunca (Amaru) (Buzău)', zip: '127009' },
  { city: 'Scorţeanca (Buzău)', zip: '127011' },
  { city: 'Balta Albă (Buzău)', zip: '127015' },
  { city: 'Amara (Buzău)', zip: '127016' },
  { city: 'Băile (Buzău)', zip: '127017' },
  { city: 'Stăvărăşti (Buzău)', zip: '127018' },
  { city: 'Bălăceanu (Buzău)', zip: '127020' },
  { city: 'Beceni (Buzău)', zip: '127025' },
  { city: 'Arbănaşi (Buzău)', zip: '127026' },
  { city: 'Cărpiniştea (Buzău)', zip: '127027' },
  { city: 'Dogari (Buzău)', zip: '127028' },
  { city: 'Floreşti (Buzău)', zip: '127029' },
  { city: 'Gura Dimienii (Buzău)', zip: '127031' },
  { city: 'Izvoru Dulce (Beceni) (Buzău)', zip: '127032' },
  { city: 'Mărgăriţi (Buzău)', zip: '127033' },
  { city: 'Valea Părului (Buzău)', zip: '127034' },
  { city: 'Berca (Buzău)', zip: '127035' },
  { city: 'Băceni (Buzău)', zip: '127036' },
  { city: 'Cojanu (Buzău)', zip: '127037' },
  { city: 'Joseni (Buzău)', zip: '127038' },
  { city: 'Mânăstirea Răteşti (Buzău)', zip: '127039' },
  { city: 'Pâclele (Buzău)', zip: '127041' },
  { city: 'Pleşcoi (Buzău)', zip: '127042' },
  { city: 'Pleşeşti (Berca) (Buzău)', zip: '127043' },
  { city: 'Răteşti (Buzău)', zip: '127044' },
  { city: 'Sătuc (Buzău)', zip: '127046' },
  { city: 'Tâţârligu (Buzău)', zip: '127047' },
  { city: 'Valea Nucului (Buzău)', zip: '127048' },
  { city: 'Viforâta (Buzău)', zip: '127049' },
  { city: 'Bisoca (Buzău)', zip: '127055' },
  { city: 'Băltăgari (Buzău)', zip: '127056' },
  { city: 'Lacurile (Buzău)', zip: '127057' },
  { city: 'Lopătăreasa (Buzău)', zip: '127058' },
  { city: 'Pleşi (Buzău)', zip: '127059' },
  { city: 'Recea (Buzău)', zip: '127061' },
  { city: 'Sările (Buzău)', zip: '127062' },
  { city: 'Şindrila (Buzău)', zip: '127063' },
  { city: 'Blăjani (Buzău)', zip: '127065' },
  { city: 'Soreşti (Buzău)', zip: '127066' },
  { city: 'Boldu (Buzău)', zip: '127070' },
  { city: 'Bozioru (Buzău)', zip: '127075' },
  { city: 'Buduile (Buzău)', zip: '127076' },
  { city: 'Fişici (Buzău)', zip: '127077' },
  { city: 'Găvanele (Buzău)', zip: '127078' },
  { city: 'Gresia (Buzău)', zip: '127079' },
  { city: 'Izvoarele (Buzău)', zip: '127081' },
  { city: 'Nucu (Buzău)', zip: '127082' },
  { city: 'Scăeni (Buzău)', zip: '127083' },
  { city: 'Ulmet (Buzău)', zip: '127084' },
  { city: 'Văvălucile (Buzău)', zip: '127086' },
  { city: 'Brădeanu (Buzău)', zip: '127090' },
  { city: 'Mitropolia (Buzău)', zip: '127091' },
  { city: 'Smârdan (Buzău)', zip: '127092' },
  { city: 'Brăeşti (Buzău)', zip: '127095' },
  { city: 'Brătileşti (Buzău)', zip: '127096' },
  { city: 'Goideşti (Buzău)', zip: '127097' },
  { city: 'Ivăneţu (Buzău)', zip: '127098' },
  { city: 'Pârscovelu (Buzău)', zip: '127099' },
  { city: 'Pinu (Buzău)', zip: '127101' },
  { city: 'Ruginoasa (Buzău)', zip: '127102' },
  { city: 'Breaza (Buzău)', zip: '127105' },
  { city: 'Bădeni (Buzău)', zip: '127106' },
  { city: 'Greceanca (Buzău)', zip: '127107' },
  { city: 'Văleanca-Vilăneşti (Buzău)', zip: '127108' },
  { city: 'Vispeşti (Buzău)', zip: '127109' },
  { city: 'Buda (Buzău)', zip: '127110' },
  { city: 'Alexandru Odobescu (Buzău)', zip: '127111' },
  { city: 'Dănuleşti (Buzău)', zip: '127112' },
  { city: 'Muceşti-Dănuleşti (Buzău)', zip: '127113' },
  { city: 'Spidele (Buzău)', zip: '127114' },
  { city: 'Toropăleşti (Buzău)', zip: '127116' },
  { city: 'Valea Largă (Buzău)', zip: '127117' },
  { city: 'C.A. Rosetti (Buzău)', zip: '127120' },
  { city: 'Bălteni (Buzău)', zip: '127121' },
  { city: 'Bâlhacu (Buzău)', zip: '127122' },
  { city: 'Cotu Ciorii (Buzău)', zip: '127123' },
  { city: 'Lunca (C.A. Rosetti) (Buzău)', zip: '127124' },
  { city: 'Vizireni (Buzău)', zip: '127126' },
  { city: 'Calvini (Buzău)', zip: '127130' },
  { city: 'Bâscenii de Jos (Buzău)', zip: '127131' },
  { city: 'Bâscenii de Sus (Buzău)', zip: '127132' },
  { city: 'Frăsinet (Buzău)', zip: '127133' },
  { city: 'Olari (Buzău)', zip: '127134' },
  { city: 'Căneşti (Buzău)', zip: '127135' },
  { city: 'Gonţeşti (Buzău)', zip: '127136' },
  { city: 'Negoşina (Buzău)', zip: '127137' },
  { city: 'Păcurile (Buzău)', zip: '127138' },
  { city: 'Şuchea (Buzău)', zip: '127139' },
  { city: 'Valea Verzei (Buzău)', zip: '127141' },
  { city: 'Cătina (Buzău)', zip: '127145' },
  { city: 'Corbu (Cătina) (Buzău)', zip: '127146' },
  { city: 'Slobozia (Buzău)', zip: '127147' },
  { city: 'Valea Cătinei (Buzău)', zip: '127148' },
  { city: 'Zeletin (Buzău)', zip: '127149' },
  { city: 'Cernăteşti (Buzău)', zip: '127150' },
  { city: 'Aldeni (Buzău)', zip: '127151' },
  { city: 'Băeşti (Buzău)', zip: '127152' },
  { city: 'Căldăruşa (Buzău)', zip: '127153' },
  { city: 'Fulga (Buzău)', zip: '127154' },
  { city: 'Manasia (Buzău)', zip: '127156' },
  { city: 'Vlădeni (Buzău)', zip: '127157' },
  { city: 'Zărneştii de Slănic (Buzău)', zip: '127158' },
  { city: 'Chiliile (Buzău)', zip: '127160' },
  { city: 'Budeşti (Buzău)', zip: '127161' },
  { city: 'Creveleşti (Buzău)', zip: '127162' },
  { city: 'Ghiocari (Buzău)', zip: '127163' },
  { city: 'Glodu-Petcari (Buzău)', zip: '127164' },
  { city: 'Poiana Pletari (Buzău)', zip: '127166' },
  { city: 'Trestioara (Chiliile) (Buzău)', zip: '127167' },
  { city: 'Chiojdu (Buzău)', zip: '127170' },
  { city: 'Bâsca Chiojdului (Buzău)', zip: '127171' },
  { city: 'Cătiaşu (Buzău)', zip: '127172' },
  { city: 'Lera (Buzău)', zip: '127173' },
  { city: 'Plescioara (Buzău)', zip: '127174' },
  { city: 'Poeniţele (Buzău)', zip: '127176' },
  { city: 'Cilibia (Buzău)', zip: '127180' },
  { city: 'Gara Cilibia (Buzău)', zip: '127181' },
  { city: 'Mânzu (Buzău)', zip: '127182' },
  { city: 'Movila Oii (Buzău)', zip: '127183' },
  { city: 'Poşta (Cilibia) (Buzău)', zip: '127184' },
  { city: 'Cislău (Buzău)', zip: '127185' },
  { city: 'Bărăşti (Buzău)', zip: '127186' },
  { city: 'Buda Crăciuneşti (Buzău)', zip: '127187' },
  { city: 'Gura Bâscei (Buzău)', zip: '127188' },
  { city: 'Scărişoara (Buzău)', zip: '127189' },
  { city: 'Cochirleanca (Buzău)', zip: '127190' },
  { city: 'Boboc (Buzău)', zip: '127191' },
  { city: 'Gara Bobocu (Buzău)', zip: '127192' },
  { city: 'Roşioru (Buzău)', zip: '127193' },
  { city: 'Târlele (Buzău)', zip: '127194' },
  { city: 'Colţi (Buzău)', zip: '127195' },
  { city: 'Aluniş (Buzău)', zip: '127196' },
  { city: 'Colţii de Jos (Buzău)', zip: '127197' },
  { city: 'Muscelu Cărămăneşti (Buzău)', zip: '127198' },
  { city: 'Costeşti (Buzău)', zip: '127200' },
  { city: 'Budişteni (Buzău)', zip: '127201' },
  { city: 'Gomoeşti (Buzău)', zip: '127202' },
  { city: 'Groşani (Buzău)', zip: '127203' },
  { city: 'Pietrosu (Buzău)', zip: '127204' },
  { city: 'Spătaru (Buzău)', zip: '127206' },
  { city: 'Cozieni (Buzău)', zip: '127210' },
  { city: 'Anini (Buzău)', zip: '127211' },
  { city: 'Bălăneşti (Buzău)', zip: '127212' },
  { city: 'Berceşti (Buzău)', zip: '127213' },
  { city: 'Ciocăneşti (Buzău)', zip: '127214' },
  { city: 'Cocârceni (Buzău)', zip: '127216' },
  { city: 'Colţeni (Buzău)', zip: '127217' },
  { city: 'Faţa lui Nan (Buzău)', zip: '127218' },
  { city: 'Glodurile (Buzău)', zip: '127219' },
  { city: 'Izvoru (Cozieni) (Buzău)', zip: '127221' },
  { city: 'Lungeşti (Buzău)', zip: '127222' },
  { city: 'Nistoreşti (Buzău)', zip: '127223' },
  { city: 'Pietraru (Buzău)', zip: '127224' },
  { city: 'Punga (Buzău)', zip: '127226' },
  { city: 'Teişu (Buzău)', zip: '127227' },
  { city: 'Trestia (Buzău)', zip: '127228' },
  { city: 'Tulburea (Buzău)', zip: '127229' },
  { city: 'Valea Banului (Buzău)', zip: '127231' },
  { city: 'Valea Roatei (Buzău)', zip: '127232' },
  { city: 'Zăpodia (Buzău)', zip: '127233' },
  { city: 'Gălbinaşi (Buzău)', zip: '127240' },
  { city: 'Bentu (Buzău)', zip: '127241' },
  { city: 'Tăbărăşti (Buzău)', zip: '127242' },
  { city: 'Gherăseni (Buzău)', zip: '127245' },
  { city: 'Sudiţi (Gherăseni) (Buzău)', zip: '127246' },
  { city: 'Ghergheasa (Buzău)', zip: '127250' },
  { city: 'Sălcioara (Buzău)', zip: '127251' },
  { city: 'Glodeanu Sărat (Buzău)', zip: '127255' },
  { city: 'Căldăruşeanca (Buzău)', zip: '127256' },
  { city: 'Ileana (Buzău)', zip: '127257' },
  { city: 'Pitulicea (Buzău)', zip: '127258' },
  { city: 'Glodeanu-Siliştea (Buzău)', zip: '127260' },
  { city: 'Casota (Buzău)', zip: '127261' },
  { city: 'Cârligu Mare (Buzău)', zip: '127262' },
  { city: 'Cârligu Mic (Buzău)', zip: '127263' },
  { city: 'Corbu (Glodeanu-Siliştea) (Buzău)', zip: '127264' },
  { city: 'Cotorca (Buzău)', zip: '127266' },
  { city: 'Satu Nou (Glodeanu-Siliştea) (Buzău)', zip: '127267' },
  { city: 'Văcăreasca (Buzău)', zip: '127268' },
  { city: 'Grebănu (Buzău)', zip: '127270' },
  { city: 'Homeşti (Buzău)', zip: '127271' },
  { city: 'Livada (Buzău)', zip: '127272' },
  { city: 'Livada Mică (Buzău)', zip: '127273' },
  { city: 'Plevna (Buzău)', zip: '127274' },
  { city: 'Zăplazi (Buzău)', zip: '127276' },
  { city: 'Gura Teghii (Buzău)', zip: '127280' },
  { city: 'Furtuneşti (Buzău)', zip: '127281' },
  { city: 'Nemertea (Buzău)', zip: '127282' },
  { city: 'Păltiniş (Buzău)', zip: '127283' },
  { city: 'Secuiu (Buzău)', zip: '127284' },
  { city: 'Vadu Oii (Buzău)', zip: '127286' },
  { city: 'Varlaam (Buzău)', zip: '127287' },
  { city: 'Largu (Buzău)', zip: '127290' },
  { city: 'Scărlăteşti (Buzău)', zip: '127291' },
  { city: 'Lopătari (Buzău)', zip: '127295' },
  { city: 'Brebu (Buzău)', zip: '127296' },
  { city: 'Fundata (Buzău)', zip: '127297' },
  { city: 'Luncile (Buzău)', zip: '127298' },
  { city: 'Pestriţu (Buzău)', zip: '127299' },
  { city: 'Plaiu Nucului (Buzău)', zip: '127301' },
  { city: 'Ploştina (Buzău)', zip: '127302' },
  { city: 'Potecu (Buzău)', zip: '127303' },
  { city: 'Săreni (Buzău)', zip: '127304' },
  { city: 'Terca (Buzău)', zip: '127306' },
  { city: 'Vârteju (Buzău)', zip: '127307' },
  { city: 'Luciu (Buzău)', zip: '127315' },
  { city: 'Caragele (Buzău)', zip: '127316' },
  { city: 'Măgura (Buzău)', zip: '127320' },
  { city: 'Ciuta (Buzău)', zip: '127321' },
  { city: 'Unguriu (Buzău)', zip: '127322' },
  { city: 'Ojasca (Buzău)', zip: '127323' },
  { city: 'Mărăcineni (Buzău)', zip: '127325' },
  { city: 'Căpăţâneşti (Buzău)', zip: '127326' },
  { city: 'Potoceni (Buzău)', zip: '127327' },
  { city: 'Mărgăriteşti (Buzău)', zip: '127330' },
  { city: 'Câmpulungeanca (Buzău)', zip: '127331' },
  { city: 'Fântânele (Mărgăriteşti) (Buzău)', zip: '127332' },
  { city: 'Mânzăleşti (Buzău)', zip: '127335' },
  { city: 'Beşlii (Buzău)', zip: '127336' },
  { city: 'Buştea (Buzău)', zip: '127337' },
  { city: 'Cireşu (Buzău)', zip: '127338' },
  { city: 'Ghizdita (Buzău)', zip: '127339' },
  { city: 'Gura Bădicului (Buzău)', zip: '127341' },
  { city: 'Jghiab (Buzău)', zip: '127342' },
  { city: 'Plavăţu (Buzău)', zip: '127343' },
  { city: 'Poiana Vâlcului (Buzău)', zip: '127344' },
  { city: 'Satu Vechi (Buzău)', zip: '127346' },
  { city: 'Trestioara (Mânzăleşti) (Buzău)', zip: '127347' },
  { city: 'Valea Cotoarei (Buzău)', zip: '127348' },
  { city: 'Valea Ursului (Buzău)', zip: '127349' },
  { city: 'Merei (Buzău)', zip: '127355' },
  { city: 'Ciobănoaia (Buzău)', zip: '127356' },
  { city: 'Dealu Viei (Buzău)', zip: '127357' },
  { city: 'Dobrileşti (Buzău)', zip: '127358' },
  { city: 'Gura Sărăţii (Buzău)', zip: '127359' },
  { city: 'Izvoru Dulce (Merei) (Buzău)', zip: '127361' },
  { city: 'Lipia (Buzău)', zip: '127362' },
  { city: 'Nenciuleşti (Buzău)', zip: '127363' },
  { city: 'Ogrăzile (Buzău)', zip: '127364' },
  { city: 'Sărata-Monteoru (Buzău)', zip: '127366' },
  { city: 'Valea Puţului Merei (Buzău)', zip: '127367' },
  { city: 'Mihăileşti (Buzău)', zip: '127375' },
  { city: 'Colţăneni (Buzău)', zip: '127376' },
  { city: 'Florica (Buzău)', zip: '127377' },
  { city: 'Mărgineanu (Buzău)', zip: '127378' },
  { city: 'Satu Nou (Mihăileşti) (Buzău)', zip: '127379' },
  { city: 'Movila Banului (Buzău)', zip: '127380' },
  { city: 'Cioranca (Buzău)', zip: '127381' },
  { city: 'Limpeziş (Buzău)', zip: '127382' },
  { city: 'Murgeşti (Buzău)', zip: '127385' },
  { city: 'Batogu (Buzău)', zip: '127386' },
  { city: 'Valea Ratei (Buzău)', zip: '127387' },
  { city: 'Năeni (Buzău)', zip: '127390' },
  { city: 'Fântânele (Năeni) (Buzău)', zip: '127391' },
  { city: 'Finţeşti (Buzău)', zip: '127392' },
  { city: 'Proşca (Buzău)', zip: '127393' },
  { city: 'Vârf (Buzău)', zip: '127394' },
  { city: 'Odăile (Buzău)', zip: '127395' },
  { city: 'Capu Satului (Buzău)', zip: '127396' },
  { city: 'Corneanu (Buzău)', zip: '127397' },
  { city: 'Gorâni (Buzău)', zip: '127398' },
  { city: 'Lacu (Buzău)', zip: '127399' },
  { city: 'Piatra Albă (Buzău)', zip: '127401' },
  { city: 'Posobeşti (Buzău)', zip: '127402' },
  { city: 'Scoroşeşti (Buzău)', zip: '127403' },
  { city: 'Valea Fântânei (Buzău)', zip: '127404' },
  { city: 'Valea Ştefanului (Buzău)', zip: '127406' },
  { city: 'Padina (Buzău)', zip: '127410' },
  { city: 'Tătuleşti (Buzău)', zip: '127411' },
  { city: 'Pardoşi (Buzău)', zip: '127415' },
  { city: 'Chiperu (Buzău)', zip: '127416' },
  { city: 'Costomiru (Buzău)', zip: '127417' },
  { city: 'Valea Şchiopului (Buzău)', zip: '127418' },
  { city: 'Valea lui Lalu (Buzău)', zip: '127419' },
  { city: 'Pănătău (Buzău)', zip: '127420' },
  { city: 'Begu (Buzău)', zip: '127421' },
  { city: 'Lacu cu Anini (Buzău)', zip: '127422' },
  { city: 'Măguricea (Buzău)', zip: '127423' },
  { city: 'Plăişor (Buzău)', zip: '127424' },
  { city: 'Râpile (Buzău)', zip: '127426' },
  { city: 'Sibiciu de Jos (Buzău)', zip: '127427' },
  { city: 'Tega (Buzău)', zip: '127428' },
  { city: 'Zahareşti (Buzău)', zip: '127429' },
  { city: 'Pătârlagele (Buzău)', zip: '127430' },
  { city: 'Calea Chiojdului (Buzău)', zip: '127431' },
  { city: 'Crâng (Buzău)', zip: '127432' },
  { city: 'Fundăturile (Buzău)', zip: '127433' },
  { city: 'Gornet (Buzău)', zip: '127434' },
  { city: 'Lunca (Pătârlagele) (Buzău)', zip: '127436' },
  { city: 'Mănăstirea (Buzău)', zip: '127437' },
  { city: 'Mărunţişu (Buzău)', zip: '127438' },
  { city: 'Muşcel (Buzău)', zip: '127439' },
  { city: 'Poienile (Buzău)', zip: '127441' },
  { city: 'Sibiciu de Sus (Buzău)', zip: '127442' },
  { city: 'Stroeşti (Buzău)', zip: '127443' },
  { city: 'Valea Lupului (Buzău)', zip: '127444' },
  { city: 'Valea Sibiciului (Buzău)', zip: '127446' },
  { city: 'Valea Viei (Buzău)', zip: '127447' },
  { city: 'Pârscov (Buzău)', zip: '127450' },
  { city: 'Bădila (Buzău)', zip: '127451' },
  { city: 'Curcăneşti (Buzău)', zip: '127452' },
  { city: 'Lunca Frumoasă (Buzău)', zip: '127453' },
  { city: 'Oleşeşti (Buzău)', zip: '127454' },
  { city: 'Pârjoleşti (Buzău)', zip: '127456' },
  { city: 'Robeşti (Buzău)', zip: '127457' },
  { city: 'Runcu (Buzău)', zip: '127458' },
  { city: 'Târcov (Buzău)', zip: '127459' },
  { city: 'Tocileni (Buzău)', zip: '127461' },
  { city: 'Trestieni (Buzău)', zip: '127462' },
  { city: 'Valea Purcarului (Buzău)', zip: '127463' },
  { city: 'Pietroasele (Buzău)', zip: '127470' },
  { city: 'Câlţeşti (Buzău)', zip: '127471' },
  { city: 'Clondiru de Sus (Buzău)', zip: '127472' },
  { city: 'Dara (Buzău)', zip: '127473' },
  { city: 'Pietroasa Mică (Buzău)', zip: '127474' },
  { city: 'Şarânga (Buzău)', zip: '127476' },
  { city: 'Podgoria (Buzău)', zip: '127480' },
  { city: 'Coţatcu (Buzău)', zip: '127481' },
  { city: 'Oratia (Buzău)', zip: '127482' },
  { city: 'Pleşeşti (Podgoria) (Buzău)', zip: '127483' },
  { city: 'Tăbăcari (Buzău)', zip: '127484' },
  { city: 'Poşta Câlnău (Buzău)', zip: '127485' },
  { city: 'Aliceni (Buzău)', zip: '127486' },
  { city: 'Coconari (Buzău)', zip: '127487' },
  { city: 'Potârnicheşti (Buzău)', zip: '127488' },
  { city: 'Sudiţi (Poşta Câlnău) (Buzău)', zip: '127489' },
  { city: 'Zilişteanca (Buzău)', zip: '127491' },
  { city: 'Puieşti (Buzău)', zip: '127495' },
  { city: 'Dăscăleşti (Buzău)', zip: '127496' },
  { city: 'Lunca (Puieşti) (Buzău)', zip: '127497' },
  { city: 'Măcrina (Buzău)', zip: '127498' },
  { city: 'Nicoleşti (Buzău)', zip: '127499' },
  { city: 'Plopi (Buzău)', zip: '127501' },
  { city: 'Puieştii de Jos (Buzău)', zip: '127502' },
  { city: 'Puieştii de Sus (Buzău)', zip: '127503' },
  { city: 'Racoviţeni (Buzău)', zip: '127505' },
  { city: 'Budrea (Buzău)', zip: '127506' },
  { city: 'Petrişoru (Buzău)', zip: '127507' },
  { city: 'Râmnicelu (Buzău)', zip: '127510' },
  { city: 'Colibaşi (Buzău)', zip: '127511' },
  { city: 'Fotin (Buzău)', zip: '127512' },
  { city: 'Ştiubei (Buzău)', zip: '127513' },
  { city: 'Robeasca (Buzău)', zip: '127515' },
  { city: 'Moşeşti (Buzău)', zip: '127516' },
  { city: 'Ruşeţu (Buzău)', zip: '127520' },
  { city: 'Sergent Ionel Ştefan (Buzău)', zip: '127521' },
  { city: 'Săgeata (Buzău)', zip: '127525' },
  { city: 'Baniţa (Buzău)', zip: '127526' },
  { city: 'Beilic (Buzău)', zip: '127527' },
  { city: 'Borduşani (Buzău)', zip: '127528' },
  { city: 'Dâmbroca (Buzău)', zip: '127529' },
  { city: 'Găvăneşti (Buzău)', zip: '127531' },
  { city: 'Moviliţa (Buzău)', zip: '127532' },
  { city: 'Săhăteni (Buzău)', zip: '127535' },
  { city: 'Găgeni (Buzău)', zip: '127536' },
  { city: 'Istriţa de Jos (Buzău)', zip: '127537' },
  { city: 'Vintileanca (Buzău)', zip: '127538' },
  { city: 'Săpoca (Buzău)', zip: '127540' },
  { city: 'Măteşti (Buzău)', zip: '127541' },
  { city: 'Săruleşti (Buzău)', zip: '127545' },
  { city: 'Cărătnău de Jos (Buzău)', zip: '127546' },
  { city: 'Cărătnău de Sus (Buzău)', zip: '127547' },
  { city: 'Goicelu (Buzău)', zip: '127548' },
  { city: 'Sările-Cătun (Buzău)', zip: '127549' },
  { city: 'Valea Largă-Săruleşti (Buzău)', zip: '127551' },
  { city: 'Valea Stânei (Buzău)', zip: '127552' },
  { city: 'Scorţoasa (Buzău)', zip: '127555' },
  { city: 'Balta Tocila (Buzău)', zip: '127556' },
  { city: 'Beciu (Buzău)', zip: '127557' },
  { city: 'Dâlma (Buzău)', zip: '127558' },
  { city: 'Deleni (Buzău)', zip: '127559' },
  { city: 'Golu Grabicina (Buzău)', zip: '127561' },
  { city: 'Grabicina de Jos (Buzău)', zip: '127562' },
  { city: 'Grabicina de Sus (Buzău)', zip: '127563' },
  { city: 'Gura Văii (Buzău)', zip: '127564' },
  { city: 'Plopeasa (Buzău)', zip: '127566' },
  { city: 'Policiori (Buzău)', zip: '127567' },
  { city: 'Scutelnici (Buzău)', zip: '127575' },
  { city: 'Arcanu (Buzău)', zip: '127576' },
  { city: 'Brăgăreasa (Buzău)', zip: '127577' },
  { city: 'Lipănescu (Buzău)', zip: '127578' },
  { city: 'Siriu (Buzău)', zip: '127580' },
  { city: 'Caşoca (Buzău)', zip: '127581' },
  { city: 'Colţu Pietrii (Buzău)', zip: '127582' },
  { city: 'Gura Siriului (Buzău)', zip: '127583' },
  { city: 'Muşceluşa (Buzău)', zip: '127584' },
  { city: 'Lunca Jariştei (Buzău)', zip: '127585' },
  { city: 'Smeeni (Buzău)', zip: '127595' },
  { city: 'Albeşti (Buzău)', zip: '127596' },
  { city: 'Bălaia (Buzău)', zip: '127597' },
  { city: 'Călţuna (Buzău)', zip: '127598' },
  { city: 'Moisica (Buzău)', zip: '127599' },
  { city: 'Udaţi-Lucieni (Buzău)', zip: '127601' },
  { city: 'Udaţi-Mânzu (Buzău)', zip: '127602' },
  { city: 'Stâlpu (Buzău)', zip: '127605' },
  { city: 'Tisău (Buzău)', zip: '127610' },
  { city: 'Bărbunceşti (Buzău)', zip: '127611' },
  { city: 'Grăjdana (Buzău)', zip: '127612' },
  { city: 'Haleş (Buzău)', zip: '127613' },
  { city: 'Izvoranu (Buzău)', zip: '127614' },
  { city: 'Izvoru (Tisău) (Buzău)', zip: '127616' },
  { city: 'Leiculeşti (Buzău)', zip: '127617' },
  { city: 'Pădurenii (Buzău)', zip: '127618' },
  { city: 'Salcia (Buzău)', zip: '127619' },
  { city: 'Strezeni (Buzău)', zip: '127621' },
  { city: 'Valea Sălciilor (Buzău)', zip: '127622' },
  { city: 'Topliceni (Buzău)', zip: '127630' },
  { city: 'Băbeni (Buzău)', zip: '127631' },
  { city: 'Ceairu (Buzău)', zip: '127632' },
  { city: 'Deduleşti (Buzău)', zip: '127633' },
  { city: 'Gura Făgetului (Buzău)', zip: '127634' },
  { city: 'Poşta (Topliceni) (Buzău)', zip: '127636' },
  { city: 'Răduceşti (Buzău)', zip: '127637' },
  { city: 'Ţinteşti (Buzău)', zip: '127640' },
  { city: 'Maxenu (Buzău)', zip: '127641' },
  { city: 'Odaia Banului (Buzău)', zip: '127642' },
  { city: 'Pogonele (Buzău)', zip: '127643' },
  { city: 'Ulmeni (Buzău)', zip: '127645' },
  { city: 'Băltăreţi (Buzău)', zip: '127646' },
  { city: 'Clondiru (Buzău)', zip: '127647' },
  { city: 'Sărata (Buzău)', zip: '127648' },
  { city: 'Vâlcele (Buzău)', zip: '127649' },
  { city: 'Vadu Paşii (Buzău)', zip: '127650' },
  { city: 'Băjani (Buzău)', zip: '127651' },
  { city: 'Focşănei (Buzău)', zip: '127652' },
  { city: 'Gura Câlnăului (Buzău)', zip: '127653' },
  { city: 'Scurteşti (Buzău)', zip: '127654' },
  { city: 'Stănceşti (Buzău)', zip: '127656' },
  { city: 'Valea Râmnicului (Buzău)', zip: '127660' },
  { city: 'Oreavul (Buzău)', zip: '127661' },
  { city: 'Rubla (Buzău)', zip: '127662' },
  { city: 'Valea Salciei (Buzău)', zip: '127665' },
  { city: 'Modreni (Buzău)', zip: '127666' },
  { city: 'Valea Salciei-Cătun (Buzău)', zip: '127667' },
  { city: 'Vâlcelele (Buzău)', zip: '127670' },
  { city: 'Verneşti (Buzău)', zip: '127675' },
  { city: 'Brădeanca (Buzău)', zip: '127676' },
  { city: 'Cândeşti (Buzău)', zip: '127677' },
  { city: 'Cârlomăneşti (Buzău)', zip: '127678' },
  { city: 'Mierea (Buzău)', zip: '127679' },
  { city: 'Nenciu (Buzău)', zip: '127681' },
  { city: 'Nişcov (Buzău)', zip: '127682' },
  { city: 'Săsenii Noi (Buzău)', zip: '127683' },
  { city: 'Săsenii Vechi (Buzău)', zip: '127684' },
  { city: 'Săsenii pe Vale (Buzău)', zip: '127686' },
  { city: 'Zoreşti (Buzău)', zip: '127687' },
  { city: 'Vintilă Vodă (Buzău)', zip: '127695' },
  { city: 'Bodineşti (Buzău)', zip: '127696' },
  { city: 'Coca-Antimireşti (Buzău)', zip: '127697' },
  { city: 'Coca-Niculeşti (Buzău)', zip: '127698' },
  { city: 'Niculeşti (Buzău)', zip: '127699' },
  { city: 'Petrăcheşti (Buzău)', zip: '127701' },
  { city: 'Podu Muncii (Buzău)', zip: '127702' },
  { city: 'Sârbeşti (Buzău)', zip: '127703' },
  { city: 'Smeeşti (Buzău)', zip: '127704' },
  { city: 'Vipereşti (Buzău)', zip: '127705' },
  { city: 'Muscel (Buzău)', zip: '127706' },
  { city: 'Pălici (Buzău)', zip: '127707' },
  { city: 'Ruşavăţ (Buzău)', zip: '127708' },
  { city: 'Tronari (Buzău)', zip: '127709' },
  { city: 'Ursoaia (Buzău)', zip: '127711' },
  { city: 'Zărneşti (Buzău)', zip: '127715' },
  { city: 'Comisoaia (Buzău)', zip: '127716' },
  { city: 'Fundeni (Buzău)', zip: '127717' },
  { city: 'Pruneni (Buzău)', zip: '127718' },
  { city: 'Vadu Soreşti (Buzău)', zip: '127719' },
  { city: 'Ziduri (Buzău)', zip: '127720' },
  { city: 'Costieni (Buzău)', zip: '127721' },
  { city: 'Cuculeasa (Buzău)', zip: '127722' },
  { city: 'Heliade Rădulescu (Buzău)', zip: '127723' },
  { city: 'Lanurile (Buzău)', zip: '127724' },
  { city: 'Zoiţa (Buzău)', zip: '127726' },
  { city: 'Câlnic (Caraş-Severin)', zip: '320001' },
  { city: 'Cuptoare (Reşiţa) (Caraş-Severin)', zip: '320002' },
  { city: 'Doman (Caraş-Severin)', zip: '320003' },
  { city: 'Moniom (Caraş-Severin)', zip: '320004' },
  { city: 'Secu (Caraş-Severin)', zip: '320005' },
  { city: 'Ţerova (Caraş-Severin)', zip: '320006' },
  { city: 'Reşiţa (Caraş-Severin)', zip: '320011' },
  { city: 'Anina (Caraş-Severin)', zip: '325100' },
  { city: 'Steierdorf (Caraş-Severin)', zip: '325150' },
  { city: 'Băile Herculane (Caraş-Severin)', zip: '325200' },
  { city: 'Pecinişca (Caraş-Severin)', zip: '325201' },
  { city: 'Bocşa (Caraş-Severin)', zip: '325300' },
  { city: 'Caransebeş (Caraş-Severin)', zip: '325400' },
  { city: 'Jupa (Caraş-Severin)', zip: '325401' },
  { city: 'Moldova Nouă (Caraş-Severin)', zip: '325500' },
  { city: 'Măceşti (Caraş-Severin)', zip: '325501' },
  { city: 'Moldoviţa (Caraş-Severin)', zip: '325502' },
  { city: 'Moldova Veche (Caraş-Severin)', zip: '325550' },
  { city: 'Oraviţa (Caraş-Severin)', zip: '325600' },
  { city: 'Agadici (Caraş-Severin)', zip: '325601' },
  { city: 'Brădişoru de Jos (Caraş-Severin)', zip: '325602' },
  { city: 'Broşteni (Caraş-Severin)', zip: '325603' },
  { city: 'Ciclova Montană (Caraş-Severin)', zip: '325604' },
  { city: 'Marila (Caraş-Severin)', zip: '325605' },
  { city: 'Răchitova (Caraş-Severin)', zip: '325606' },
  { city: 'Oţelu Roşu (Caraş-Severin)', zip: '325700' },
  { city: 'Cireşa (Caraş-Severin)', zip: '325701' },
  { city: 'Mal (Caraş-Severin)', zip: '325702' },
  { city: 'Armeniş (Caraş-Severin)', zip: '327005' },
  { city: 'Feneş (Caraş-Severin)', zip: '327006' },
  { city: 'Plopu (Caraş-Severin)', zip: '327007' },
  { city: 'Sat Bătrân (Caraş-Severin)', zip: '327008' },
  { city: 'Sub Margine (Caraş-Severin)', zip: '327009' },
  { city: 'Bănia (Caraş-Severin)', zip: '327010' },
  { city: 'Gârbovăţ (Caraş-Severin)', zip: '327011' },
  { city: 'Băuţar (Caraş-Severin)', zip: '327015' },
  { city: 'Bucova (Caraş-Severin)', zip: '327016' },
  { city: 'Cornişoru (Caraş-Severin)', zip: '327017' },
  { city: 'Preveciori (Caraş-Severin)', zip: '327018' },
  { city: 'Berlişte (Caraş-Severin)', zip: '327020' },
  { city: 'Iam (Caraş-Severin)', zip: '327021' },
  { city: 'Milcoveni (Caraş-Severin)', zip: '327022' },
  { city: 'Rusova Nouă (Caraş-Severin)', zip: '327023' },
  { city: 'Rusova Veche (Caraş-Severin)', zip: '327024' },
  { city: 'Berzasca (Caraş-Severin)', zip: '327025' },
  { city: 'Bigăr (Caraş-Severin)', zip: '327026' },
  { city: 'Cozla (Caraş-Severin)', zip: '327027' },
  { city: 'Drencova (Caraş-Severin)', zip: '327028' },
  { city: 'Liubcova (Caraş-Severin)', zip: '327029' },
  { city: 'Berzovia (Caraş-Severin)', zip: '327030' },
  { city: 'Fizeş (Caraş-Severin)', zip: '327031' },
  { city: 'Gherteniş (Caraş-Severin)', zip: '327032' },
  { city: 'Bolvaşniţa (Caraş-Severin)', zip: '327035' },
  { city: 'Vârciorova (Caraş-Severin)', zip: '327036' },
  { city: 'Bozovici (Caraş-Severin)', zip: '327040' },
  { city: 'Poneasca (Caraş-Severin)', zip: '327041' },
  { city: 'Prilipeţ (Caraş-Severin)', zip: '327042' },
  { city: 'Valea Minişului (Caraş-Severin)', zip: '327043' },
  { city: 'Brebu (Caraş-Severin)', zip: '327045' },
  { city: 'Apadia (Caraş-Severin)', zip: '327046' },
  { city: 'Valeadeni (Caraş-Severin)', zip: '327047' },
  { city: 'Brebu Nou (Caraş-Severin)', zip: '327050' },
  { city: 'Gărâna (Caraş-Severin)', zip: '327051' },
  { city: 'Buchin (Caraş-Severin)', zip: '327055' },
  { city: 'Lindenfeld (Caraş-Severin)', zip: '327056' },
  { city: 'Poiana (Caraş-Severin)', zip: '327057' },
  { city: 'Prisian (Caraş-Severin)', zip: '327058' },
  { city: 'Valea Timişului (Caraş-Severin)', zip: '327059' },
  { city: 'Bucoşniţa (Caraş-Severin)', zip: '327060' },
  { city: 'Goleţ (Caraş-Severin)', zip: '327061' },
  { city: 'Petroşniţa (Caraş-Severin)', zip: '327062' },
  { city: 'Vălişoara (Caraş-Severin)', zip: '327063' },
  { city: 'Caraşova (Caraş-Severin)', zip: '327065' },
  { city: 'Iabalcea (Caraş-Severin)', zip: '327066' },
  { city: 'Nermed (Caraş-Severin)', zip: '327067' },
  { city: 'Cărbunari (Caraş-Severin)', zip: '327070' },
  { city: 'Ştinăpari (Caraş-Severin)', zip: '327071' },
  { city: 'Ciclova Română (Caraş-Severin)', zip: '327075' },
  { city: 'Ilidia (Caraş-Severin)', zip: '327076' },
  { city: 'Socolari (Caraş-Severin)', zip: '327077' },
  { city: 'Ciuchici (Caraş-Severin)', zip: '327080' },
  { city: 'Macovişte (Ciuchici) (Caraş-Severin)', zip: '327081' },
  { city: 'Nicolinţ (Caraş-Severin)', zip: '327082' },
  { city: 'Petrilova (Caraş-Severin)', zip: '327083' },
  { city: 'Ciudanoviţa (Caraş-Severin)', zip: '327085' },
  { city: 'Jitin (Caraş-Severin)', zip: '327086' },
  { city: 'Constantin Daicoviciu (Caraş-Severin)', zip: '327090' },
  { city: 'Căvăran (Caraş-Severin)', zip: '327091' },
  { city: 'Maciova (Caraş-Severin)', zip: '327092' },
  { city: 'Mâtnicu Mare (Caraş-Severin)', zip: '327093' },
  { city: 'Peştere (Caraş-Severin)', zip: '327094' },
  { city: 'Prisaca (Caraş-Severin)', zip: '327096' },
  { city: 'Zăgujeni (Caraş-Severin)', zip: '327097' },
  { city: 'Copăcele (Caraş-Severin)', zip: '327100' },
  { city: 'Ohaba-Mâtnic (Caraş-Severin)', zip: '327101' },
  { city: 'Ruginosu (Caraş-Severin)', zip: '327102' },
  { city: 'Zorile (Caraş-Severin)', zip: '327103' },
  { city: 'Cornea (Caraş-Severin)', zip: '327105' },
  { city: 'Cruşovăţ (Caraş-Severin)', zip: '327106' },
  { city: 'Cuptoare (Cornea) (Caraş-Severin)', zip: '327107' },
  { city: 'Macovişte (Cornea) (Caraş-Severin)', zip: '327108' },
  { city: 'Cornereva (Caraş-Severin)', zip: '327110' },
  { city: 'Arsuri (Caraş-Severin)', zip: '327111' },
  { city: 'Bogâltin (Caraş-Severin)', zip: '327112' },
  { city: 'Bojia (Caraş-Severin)', zip: '327113' },
  { city: 'Borugi (Caraş-Severin)', zip: '327114' },
  { city: 'Camena (Caraş-Severin)', zip: '327116' },
  { city: 'Cireşel (Caraş-Severin)', zip: '327117' },
  { city: 'Costiş (Caraş-Severin)', zip: '327118' },
  { city: 'Cozia (Caraş-Severin)', zip: '327119' },
  { city: 'Cracu Mare (Caraş-Severin)', zip: '327121' },
  { city: 'Cracu Teiului (Caraş-Severin)', zip: '327122' },
  { city: 'Dobraia (Caraş-Severin)', zip: '327123' },
  { city: 'Dolina (Caraş-Severin)', zip: '327124' },
  { city: 'Gruni (Caraş-Severin)', zip: '327126' },
  { city: 'Hora Mare (Caraş-Severin)', zip: '327127' },
  { city: 'Hora Mică (Caraş-Severin)', zip: '327128' },
  { city: 'Ineleţ (Caraş-Severin)', zip: '327129' },
  { city: 'Izvor (Caraş-Severin)', zip: '327131' },
  { city: 'Lunca Florii (Caraş-Severin)', zip: '327132' },
  { city: 'Lunca Zaicii (Caraş-Severin)', zip: '327133' },
  { city: 'Mesteacăn (Caraş-Severin)', zip: '327134' },
  { city: 'Negiudin (Caraş-Severin)', zip: '327136' },
  { city: 'Obiţa (Caraş-Severin)', zip: '327137' },
  { city: 'Pogara (Caraş-Severin)', zip: '327138' },
  { city: 'Pogara de Sus (Caraş-Severin)', zip: '327139' },
  { city: 'Poiana Lungă (Caraş-Severin)', zip: '327141' },
  { city: 'Prisacina (Caraş-Severin)', zip: '327142' },
  { city: 'Prislop (Cornereva) (Caraş-Severin)', zip: '327143' },
  { city: 'Ruştin (Caraş-Severin)', zip: '327144' },
  { city: 'Scărişoara (Caraş-Severin)', zip: '327146' },
  { city: 'Strugasca (Caraş-Severin)', zip: '327147' },
  { city: 'Studena (Caraş-Severin)', zip: '327148' },
  { city: 'Sub Crâng (Caraş-Severin)', zip: '327149' },
  { city: 'Sub Plai (Caraş-Severin)', zip: '327151' },
  { city: 'Topla (Caraş-Severin)', zip: '327152' },
  { city: 'Ţaţu (Caraş-Severin)', zip: '327153' },
  { city: 'Zănogi (Caraş-Severin)', zip: '327154' },
  { city: 'Zbegu (Caraş-Severin)', zip: '327156' },
  { city: 'Zmogotin (Caraş-Severin)', zip: '327157' },
  { city: 'Zoina (Caraş-Severin)', zip: '327158' },
  { city: 'Coronini (Caraş-Severin)', zip: '327160' },
  { city: 'Sfânta Elena (Caraş-Severin)', zip: '327161' },
  { city: 'Dalboşeţ (Caraş-Severin)', zip: '327165' },
  { city: 'Bârz (Caraş-Severin)', zip: '327166' },
  { city: 'Boina (Caraş-Severin)', zip: '327167' },
  { city: 'Boiniţa (Caraş-Severin)', zip: '327168' },
  { city: 'Prislop (Dalboşeţ) (Caraş-Severin)', zip: '327169' },
  { city: 'Reşiţa Mică (Caraş-Severin)', zip: '327171' },
  { city: 'Şopotu Vechi (Caraş-Severin)', zip: '327172' },
  { city: 'Doclin (Caraş-Severin)', zip: '327175' },
  { city: 'Biniş (Caraş-Severin)', zip: '327176' },
  { city: 'Tirol (Caraş-Severin)', zip: '327177' },
  { city: 'Dognecea (Caraş-Severin)', zip: '327180' },
  { city: 'Calina (Caraş-Severin)', zip: '327181' },
  { city: 'Domaşnea (Caraş-Severin)', zip: '327185' },
  { city: 'Cănicea (Caraş-Severin)', zip: '327186' },
  { city: 'Eftimie Murgu (Caraş-Severin)', zip: '327190' },
  { city: 'Ezeriş (Caraş-Severin)', zip: '327195' },
  { city: 'Soceni (Caraş-Severin)', zip: '327196' },
  { city: 'Fârliug (Caraş-Severin)', zip: '327200' },
  { city: 'Dezeşti (Caraş-Severin)', zip: '327201' },
  { city: 'Duleu (Caraş-Severin)', zip: '327202' },
  { city: 'Remetea-Pogănici (Caraş-Severin)', zip: '327203' },
  { city: 'Scăiuş (Caraş-Severin)', zip: '327204' },
  { city: 'Valea Mare (Caraş-Severin)', zip: '327206' },
  { city: 'Forotic (Caraş-Severin)', zip: '327210' },
  { city: 'Brezon (Caraş-Severin)', zip: '327211' },
  { city: 'Comorâşte (Caraş-Severin)', zip: '327212' },
  { city: 'Surducu Mare (Caraş-Severin)', zip: '327213' },
  { city: 'Gârnic (Caraş-Severin)', zip: '327215' },
  { city: 'Padina Matei (Caraş-Severin)', zip: '327216' },
  { city: 'Glimboca (Caraş-Severin)', zip: '327220' },
  { city: 'Goruia (Caraş-Severin)', zip: '327225' },
  { city: 'Gârlişte (Caraş-Severin)', zip: '327226' },
  { city: 'Giurgiova (Caraş-Severin)', zip: '327227' },
  { city: 'Grădinari (Caraş-Severin)', zip: '327230' },
  { city: 'Greoni (Caraş-Severin)', zip: '327231' },
  { city: 'Iablaniţa (Caraş-Severin)', zip: '327235' },
  { city: 'Globu Craiovei (Caraş-Severin)', zip: '327236' },
  { city: 'Petnic (Caraş-Severin)', zip: '327237' },
  { city: 'Lăpuşnicel (Caraş-Severin)', zip: '327240' },
  { city: 'Pârvova (Caraş-Severin)', zip: '327241' },
  { city: 'Şumiţa (Caraş-Severin)', zip: '327242' },
  { city: 'Lăpuşnicu Mare (Caraş-Severin)', zip: '327245' },
  { city: 'Moceriş (Caraş-Severin)', zip: '327246' },
  { city: 'Luncaviţa (Caraş-Severin)', zip: '327250' },
  { city: 'Verendin (Caraş-Severin)', zip: '327251' },
  { city: 'Lupac (Caraş-Severin)', zip: '327255' },
  { city: 'Clocotici (Caraş-Severin)', zip: '327256' },
  { city: 'Rafnic (Caraş-Severin)', zip: '327257' },
  { city: 'Vodnic (Caraş-Severin)', zip: '327258' },
  { city: 'Marga (Caraş-Severin)', zip: '327260' },
  { city: 'Vama Marga (Caraş-Severin)', zip: '327261' },
  { city: 'Măureni (Caraş-Severin)', zip: '327265' },
  { city: 'Şoşdea (Caraş-Severin)', zip: '327266' },
  { city: 'Mehadia (Caraş-Severin)', zip: '327270' },
  { city: 'Globurău (Caraş-Severin)', zip: '327271' },
  { city: 'Plugova (Caraş-Severin)', zip: '327272' },
  { city: 'Valea Bolvaşniţa (Caraş-Severin)', zip: '327273' },
  { city: 'Mehadica (Caraş-Severin)', zip: '327275' },
  { city: 'Naidăş (Caraş-Severin)', zip: '327280' },
  { city: 'Lescoviţa (Caraş-Severin)', zip: '327281' },
  { city: 'Obreja (Caraş-Severin)', zip: '327285' },
  { city: 'Ciuta (Caraş-Severin)', zip: '327286' },
  { city: 'Iaz (Caraş-Severin)', zip: '327287' },
  { city: 'Var (Caraş-Severin)', zip: '327288' },
  { city: 'Ocna de Fier (Caraş-Severin)', zip: '327290' },
  { city: 'Păltiniş (Caraş-Severin)', zip: '327295' },
  { city: 'Cornuţel (Caraş-Severin)', zip: '327296' },
  { city: 'Delineşti (Caraş-Severin)', zip: '327297' },
  { city: 'Ohabiţa (Caraş-Severin)', zip: '327298' },
  { city: 'Rugi (Caraş-Severin)', zip: '327299' },
  { city: 'Pojejena (Caraş-Severin)', zip: '327300' },
  { city: 'Belobreşca (Caraş-Severin)', zip: '327301' },
  { city: 'Divici (Caraş-Severin)', zip: '327302' },
  { city: 'Radimna (Caraş-Severin)', zip: '327303' },
  { city: 'Şuşca (Caraş-Severin)', zip: '327304' },
  { city: 'Prigor (Caraş-Severin)', zip: '327305' },
  { city: 'Borlovenii Noi (Caraş-Severin)', zip: '327306' },
  { city: 'Borlovenii Vechi (Caraş-Severin)', zip: '327307' },
  { city: 'Pătaş (Caraş-Severin)', zip: '327308' },
  { city: 'Putna (Caraş-Severin)', zip: '327309' },
  { city: 'Ramna (Caraş-Severin)', zip: '327310' },
  { city: 'Bărbosu (Caraş-Severin)', zip: '327311' },
  { city: 'Valeapai (Caraş-Severin)', zip: '327312' },
  { city: 'Răcăşdia (Caraş-Severin)', zip: '327315' },
  { city: 'Vrăniuţ (Caraş-Severin)', zip: '327316' },
  { city: 'Rusca Montană (Caraş-Severin)', zip: '327320' },
  { city: 'Ruschiţa (Caraş-Severin)', zip: '327321' },
  { city: 'Sacu (Caraş-Severin)', zip: '327325' },
  { city: 'Sălbăgelu Nou (Caraş-Severin)', zip: '327326' },
  { city: 'Tincova (Caraş-Severin)', zip: '327327' },
  { city: 'Sasca Montană (Caraş-Severin)', zip: '327330' },
  { city: 'Bogodinţ (Caraş-Severin)', zip: '327331' },
  { city: 'Potoc (Caraş-Severin)', zip: '327332' },
  { city: 'Sasca Română (Caraş-Severin)', zip: '327333' },
  { city: 'Slatina-Nera (Caraş-Severin)', zip: '327334' },
  { city: 'Sicheviţa (Caraş-Severin)', zip: '327335' },
  { city: 'Brestelnic (Caraş-Severin)', zip: '327336' },
  { city: 'Cameniţa (Caraş-Severin)', zip: '327337' },
  { city: 'Cârşie (Caraş-Severin)', zip: '327338' },
  { city: 'Cracu Almăj (Caraş-Severin)', zip: '327339' },
  { city: 'Cruşoviţa (Caraş-Severin)', zip: '327341' },
  { city: 'Curmătura (Caraş-Severin)', zip: '327342' },
  { city: 'Frăsiniş (Caraş-Severin)', zip: '327343' },
  { city: 'Gornea (Caraş-Severin)', zip: '327344' },
  { city: 'Liborajdea (Caraş-Severin)', zip: '327346' },
  { city: 'Lucacevăţ (Caraş-Severin)', zip: '327347' },
  { city: 'Martinovăţ (Caraş-Severin)', zip: '327348' },
  { city: 'Ogaşu Podului (Caraş-Severin)', zip: '327349' },
  { city: 'Streneac (Caraş-Severin)', zip: '327351' },
  { city: 'Valea Oreviţa (Caraş-Severin)', zip: '327352' },
  { city: 'Valea Ravensca (Caraş-Severin)', zip: '327353' },
  { city: 'Valea Sicheviţei (Caraş-Severin)', zip: '327354' },
  { city: 'Zănou (Caraş-Severin)', zip: '327356' },
  { city: 'Zăsloane (Caraş-Severin)', zip: '327357' },
  { city: 'Slatina-Timiş (Caraş-Severin)', zip: '327360' },
  { city: 'Ilova (Caraş-Severin)', zip: '327361' },
  { city: 'Sadova Nouă (Caraş-Severin)', zip: '327362' },
  { city: 'Sadova Veche (Caraş-Severin)', zip: '327363' },
  { city: 'Socol (Caraş-Severin)', zip: '327365' },
  { city: 'Baziaş (Caraş-Severin)', zip: '327366' },
  { city: 'Câmpia (Caraş-Severin)', zip: '327367' },
  { city: 'Pârneaura (Caraş-Severin)', zip: '327368' },
  { city: 'Şopotu Nou (Caraş-Severin)', zip: '327370' },
  { city: 'Cârşa Roşie (Caraş-Severin)', zip: '327371' },
  { city: 'Driştie (Caraş-Severin)', zip: '327372' },
  { city: 'Poienile Boinei (Caraş-Severin)', zip: '327373' },
  { city: 'Ravensca (Caraş-Severin)', zip: '327374' },
  { city: 'Răchita (Caraş-Severin)', zip: '327376' },
  { city: 'Stăncilova (Caraş-Severin)', zip: '327377' },
  { city: 'Urcu (Caraş-Severin)', zip: '327378' },
  { city: 'Valea Răchitei (Caraş-Severin)', zip: '327379' },
  { city: 'Valea Roşie (Caraş-Severin)', zip: '327381' },
  { city: 'Târnova (Caraş-Severin)', zip: '327385' },
  { city: 'Bratova (Caraş-Severin)', zip: '327386' },
  { city: 'Teregova (Caraş-Severin)', zip: '327390' },
  { city: 'Rusca (Caraş-Severin)', zip: '327391' },
  { city: 'Ticvaniu Mare (Caraş-Severin)', zip: '327395' },
  { city: 'Cârnecea (Caraş-Severin)', zip: '327396' },
  { city: 'Secăşeni (Caraş-Severin)', zip: '327397' },
  { city: 'Ticvaniu Mic (Caraş-Severin)', zip: '327398' },
  { city: 'Topleţ (Caraş-Severin)', zip: '327400' },
  { city: 'Bârza (Caraş-Severin)', zip: '327401' },
  { city: 'Turnu Ruieni (Caraş-Severin)', zip: '327405' },
  { city: 'Borlova (Caraş-Severin)', zip: '327406' },
  { city: 'Cicleni (Caraş-Severin)', zip: '327407' },
  { city: 'Dalci (Caraş-Severin)', zip: '327408' },
  { city: 'Zerveşti (Caraş-Severin)', zip: '327409' },
  { city: 'Zlagna (Caraş-Severin)', zip: '327411' },
  { city: 'Văliug (Caraş-Severin)', zip: '327415' },
  { city: 'Vărădia (Caraş-Severin)', zip: '327420' },
  { city: 'Mercina (Caraş-Severin)', zip: '327421' },
  { city: 'Vermeş (Caraş-Severin)', zip: '327425' },
  { city: 'Ersig (Caraş-Severin)', zip: '327426' },
  { city: 'Izgar (Caraş-Severin)', zip: '327427' },
  { city: 'Vrani (Caraş-Severin)', zip: '327430' },
  { city: 'Ciortea (Caraş-Severin)', zip: '327431' },
  { city: 'Iertof (Caraş-Severin)', zip: '327432' },
  { city: 'Zăvoi (Caraş-Severin)', zip: '327435' },
  { city: '45527 (Caraş-Severin)', zip: '327436' },
  { city: 'Măgura (Caraş-Severin)', zip: '327437' },
  { city: 'Măru (Caraş-Severin)', zip: '327438' },
  { city: 'Poiana Mărului (Caraş-Severin)', zip: '327439' },
  { city: 'Valea Bistrei (Caraş-Severin)', zip: '327441' },
  { city: 'Voislova (Caraş-Severin)', zip: '327442' },
  { city: 'Zlatiţa (Caraş-Severin)', zip: '327445' },
  { city: 'Zorlenţu Mare (Caraş-Severin)', zip: '327450' },
  { city: 'Zorlencior (Caraş-Severin)', zip: '327451' },
  { city: 'Cluj-Napoca (Cluj)', zip: '400001' },
  { city: 'Turda (Cluj)', zip: '401001' },
  { city: 'Câmpia Turzii (Cluj)', zip: '405100' },
  { city: 'Dej (Cluj)', zip: '405200' },
  { city: 'Ocna Dejului (Cluj)', zip: '405201' },
  { city: 'Peştera (Cluj)', zip: '405202' },
  { city: 'Pintic (Cluj)', zip: '405203' },
  { city: 'Şomcutu Mic (Cluj)', zip: '405204' },
  { city: 'Gherla (Cluj)', zip: '405300' },
  { city: 'Băiţa (Cluj)', zip: '405301' },
  { city: 'Hăşdate (Gherla) (Cluj)', zip: '405302' },
  { city: 'Silivaş (Cluj)', zip: '405303' },
  { city: 'Huedin (Cluj)', zip: '405400' },
  { city: 'Bicălatu (Cluj)', zip: '405401' },
  { city: 'Aghireşu (Cluj)', zip: '407005' },
  { city: 'Arghişu (Cluj)', zip: '407006' },
  { city: 'Băgara (Cluj)', zip: '407007' },
  { city: 'Dâncu (Cluj)', zip: '407008' },
  { city: 'Dorolţu (Cluj)', zip: '407009' },
  { city: 'Aghireşu-Fabrici (Cluj)', zip: '407010' },
  { city: 'Inucu (Cluj)', zip: '407011' },
  { city: 'Leghia (Cluj)', zip: '407012' },
  { city: 'Macău (Cluj)', zip: '407013' },
  { city: 'Ticu (Cluj)', zip: '407014' },
  { city: 'Ticu-Colonie (Cluj)', zip: '407016' },
  { city: 'Aiton (Cluj)', zip: '407025' },
  { city: 'Rediu (Cluj)', zip: '407026' },
  { city: 'Aluniş (Cluj)', zip: '407030' },
  { city: 'Corneni (Cluj)', zip: '407031' },
  { city: 'Ghirolt (Cluj)', zip: '407032' },
  { city: 'Pruneni (Cluj)', zip: '407033' },
  { city: 'Vale (Cluj)', zip: '407034' },
  { city: 'Apahida (Cluj)', zip: '407035' },
  { city: 'Bodrog (Cluj)', zip: '407036' },
  { city: 'Câmpeneşti (Cluj)', zip: '407037' },
  { city: 'Corpadea (Cluj)', zip: '407038' },
  { city: 'Dezmir (Cluj)', zip: '407039' },
  { city: 'Pata (Cluj)', zip: '407041' },
  { city: 'Sânnicoară (Cluj)', zip: '407042' },
  { city: 'Sub Coastă (Cluj)', zip: '407043' },
  { city: 'Aşchileu (Cluj)', zip: '407045' },
  { city: 'Aşchileu Mare (Cluj)', zip: '407046' },
  { city: 'Aşchileu Mic (Cluj)', zip: '407047' },
  { city: 'Cristorel (Cluj)', zip: '407048' },
  { city: 'Dorna (Cluj)', zip: '407049' },
  { city: 'Fodora (Cluj)', zip: '407051' },
  { city: 'Baciu (Cluj)', zip: '407055' },
  { city: 'Coruşu (Cluj)', zip: '407056' },
  { city: 'Mera (Cluj)', zip: '407057' },
  { city: 'Popeşti (Cluj)', zip: '407058' },
  { city: 'Rădaia (Cluj)', zip: '407059' },
  { city: 'Săliştea Nouă (Cluj)', zip: '407061' },
  { city: 'Suceagu (Cluj)', zip: '407062' },
  { city: 'Băişoara (Cluj)', zip: '407065' },
  { city: 'Frăsinet (Cluj)', zip: '407066' },
  { city: 'Moara de Pădure (Cluj)', zip: '407067' },
  { city: 'Muntele Băişorii (Cluj)', zip: '407068' },
  { city: 'Muntele Bocului (Cluj)', zip: '407069' },
  { city: 'Muntele Cacovei (Cluj)', zip: '407071' },
  { city: 'Muntele Filii (Cluj)', zip: '407072' },
  { city: 'Muntele Săcelului (Cluj)', zip: '407073' },
  { city: 'Săcel (Cluj)', zip: '407074' },
  { city: 'Beliş (Cluj)', zip: '407075' },
  { city: 'Bălceşti (Beliş) (Cluj)', zip: '407076' },
  { city: 'Dealu Botii (Cluj)', zip: '407077' },
  { city: 'Giurcuţa de Jos (Cluj)', zip: '407078' },
  { city: 'Giurcuţa de Sus (Cluj)', zip: '407079' },
  { city: 'Poiana Horea (Cluj)', zip: '407081' },
  { city: 'Smida (Cluj)', zip: '407082' },
  { city: 'Bobâlna (Cluj)', zip: '407085' },
  { city: 'Antăş (Cluj)', zip: '407086' },
  { city: 'Băbdiu (Cluj)', zip: '407087' },
  { city: 'Blidăreşti (Cluj)', zip: '407088' },
  { city: 'Cremenea (Cluj)', zip: '407089' },
  { city: 'Maia (Cluj)', zip: '407091' },
  { city: 'Oşorhel (Cluj)', zip: '407092' },
  { city: 'Pruni (Cluj)', zip: '407093' },
  { city: 'Răzbuneni (Cluj)', zip: '407094' },
  { city: 'Suarăş (Cluj)', zip: '407096' },
  { city: 'Vâlcelele (Cluj)', zip: '407097' },
  { city: 'Bonţida (Cluj)', zip: '407105' },
  { city: 'Coasta (Cluj)', zip: '407106' },
  { city: 'Răscruci (Cluj)', zip: '407107' },
  { city: 'Tăuşeni (Cluj)', zip: '407108' },
  { city: 'Borşa (Cluj)', zip: '407110' },
  { city: 'Borşa-Cătun (Cluj)', zip: '407111' },
  { city: 'Borşa-Crestaia (Cluj)', zip: '407112' },
  { city: 'Ciumăfaia (Cluj)', zip: '407113' },
  { city: 'Giula (Cluj)', zip: '407114' },
  { city: 'Buza (Cluj)', zip: '407115' },
  { city: 'Rotunda (Cluj)', zip: '407116' },
  { city: 'Căianu (Cluj)', zip: '407120' },
  { city: 'Bărăi (Cluj)', zip: '407121' },
  { city: 'Căianu Mic (Cluj)', zip: '407122' },
  { city: 'Căianu-Vamă (Cluj)', zip: '407123' },
  { city: 'Vaida-Cămăraş (Cluj)', zip: '407124' },
  { city: 'Văleni (Căianu) (Cluj)', zip: '407126' },
  { city: 'Călăraşi (Cluj)', zip: '407130' },
  { city: 'Bogata (Cluj)', zip: '407131' },
  { city: 'Călăraşi-Gară (Cluj)', zip: '407132' },
  { city: 'Călăţele (Cluj)', zip: '407135' },
  { city: 'Călata (Cluj)', zip: '407136' },
  { city: 'Dealu Negru (Cluj)', zip: '407137' },
  { city: 'Finciu (Cluj)', zip: '407138' },
  { city: 'Văleni (Călăţele) (Cluj)', zip: '407139' },
  { city: 'Cămăraşu (Cluj)', zip: '407140' },
  { city: 'Năoiu (Cluj)', zip: '407141' },
  { city: 'Sâmboleni (Cluj)', zip: '407142' },
  { city: 'Căpuşu Mare (Cluj)', zip: '407145' },
  { city: 'Agârbiciu (Cluj)', zip: '407146' },
  { city: 'Bălceşti (Căpuşu Mare) (Cluj)', zip: '407147' },
  { city: 'Căpuşu Mic (Cluj)', zip: '407148' },
  { city: 'Dângău Mare (Cluj)', zip: '407149' },
  { city: 'Dângău Mic (Cluj)', zip: '407151' },
  { city: 'Dumbrava (Cluj)', zip: '407152' },
  { city: 'Păniceni (Cluj)', zip: '407153' },
  { city: 'Straja (Căpuşu Mare) (Cluj)', zip: '407154' },
  { city: 'Căşeiu (Cluj)', zip: '407155' },
  { city: 'Comorâţa (Cluj)', zip: '407156' },
  { city: 'Coplean (Cluj)', zip: '407157' },
  { city: 'Custura (Cluj)', zip: '407158' },
  { city: 'Gârbău Dejului (Cluj)', zip: '407159' },
  { city: 'Guga (Cluj)', zip: '407161' },
  { city: 'Leurda (Cluj)', zip: '407162' },
  { city: 'Rugăşeşti (Cluj)', zip: '407163' },
  { city: 'Sălătruc (Cluj)', zip: '407164' },
  { city: 'Urişor (Cluj)', zip: '407166' },
  { city: 'Cătina (Cluj)', zip: '407170' },
  { city: 'Copru (Cluj)', zip: '407171' },
  { city: 'Feldioara (Cluj)', zip: '407172' },
  { city: 'Hagău (Cluj)', zip: '407173' },
  { city: 'Hodaie (Cluj)', zip: '407174' },
  { city: 'Valea Caldă (Cluj)', zip: '407176' },
  { city: 'Câţcău (Cluj)', zip: '407180' },
  { city: 'Muncel (Cluj)', zip: '407181' },
  { city: 'Sălişca (Cluj)', zip: '407182' },
  { city: 'Ceanu Mare (Cluj)', zip: '407185' },
  { city: 'Andici (Cluj)', zip: '407186' },
  { city: 'Boian (Cluj)', zip: '407187' },
  { city: 'Bolduţ (Cluj)', zip: '407188' },
  { city: 'Ciurgău (Cluj)', zip: '407189' },
  { city: 'Dosu Napului (Cluj)', zip: '407191' },
  { city: 'Fânaţe (Cluj)', zip: '407192' },
  { city: 'Hodăi-Boian (Cluj)', zip: '407193' },
  { city: 'Iacobeni (Cluj)', zip: '407194' },
  { city: 'Morţeşti (Cluj)', zip: '407196' },
  { city: 'Stârcu (Cluj)', zip: '407197' },
  { city: 'Strucut (Cluj)', zip: '407198' },
  { city: 'Valea lui Cati (Cluj)', zip: '407199' },
  { city: 'Chinteni (Cluj)', zip: '407205' },
  { city: 'Deuşu (Cluj)', zip: '407206' },
  { city: 'Feiurdeni (Cluj)', zip: '407207' },
  { city: 'Măcicaşu (Cluj)', zip: '407208' },
  { city: 'Pădureni (Chinteni) (Cluj)', zip: '407209' },
  { city: 'Satu Lung (Cluj)', zip: '407211' },
  { city: 'Săliştea Veche (Cluj)', zip: '407212' },
  { city: 'Sânmărtin (Chinteni) (Cluj)', zip: '407213' },
  { city: 'Vechea (Cluj)', zip: '407214' },
  { city: 'Chiuieşti (Cluj)', zip: '407215' },
  { city: 'Dosu Bricii (Cluj)', zip: '407216' },
  { city: 'Huta (Cluj)', zip: '407217' },
  { city: 'Măgoaja (Cluj)', zip: '407218' },
  { city: 'Strâmbu (Cluj)', zip: '407219' },
  { city: 'Valea Căşeielului (Cluj)', zip: '407221' },
  { city: 'Valea lui Opriş (Cluj)', zip: '407222' },
  { city: 'Ciucea (Cluj)', zip: '407225' },
  { city: 'Vânători (Cluj)', zip: '407226' },
  { city: 'Ciurila (Cluj)', zip: '407230' },
  { city: 'Filea de Jos (Cluj)', zip: '407231' },
  { city: 'Filea de Sus (Cluj)', zip: '407232' },
  { city: 'Pădureni (Ciurila) (Cluj)', zip: '407233' },
  { city: 'Pruniş (Cluj)', zip: '407234' },
  { city: 'Sălicea (Cluj)', zip: '407236' },
  { city: 'Sălişte (Cluj)', zip: '407237' },
  { city: 'Şutu (Cluj)', zip: '407238' },
  { city: 'Cojocna (Cluj)', zip: '407240' },
  { city: 'Boj-Cătun (Cluj)', zip: '407241' },
  { city: 'Boju (Cluj)', zip: '407242' },
  { city: 'Cara (Cluj)', zip: '407243' },
  { city: 'Huci (Cluj)', zip: '407244' },
  { city: 'Iuriu de Câmpie (Cluj)', zip: '407246' },
  { city: 'Morişti (Cluj)', zip: '407247' },
  { city: 'Straja (Cojocna) (Cluj)', zip: '407248' },
  { city: 'Corneşti (Cluj)', zip: '407250' },
  { city: 'Bârlea (Cluj)', zip: '407251' },
  { city: 'Igriţia (Cluj)', zip: '407252' },
  { city: 'Lujerdiu (Cluj)', zip: '407253' },
  { city: 'Morău (Cluj)', zip: '407254' },
  { city: 'Stoiana (Cluj)', zip: '407256' },
  { city: 'Tiocu de Jos (Cluj)', zip: '407257' },
  { city: 'Tiocu de Sus (Cluj)', zip: '407258' },
  { city: 'Tioltiur (Cluj)', zip: '407259' },
  { city: 'Cuzdrioara (Cluj)', zip: '407260' },
  { city: 'Mănăşturel (Cluj)', zip: '407261' },
  { city: 'Valea Gârboului (Cluj)', zip: '407262' },
  { city: 'Dăbâca (Cluj)', zip: '407265' },
  { city: 'Luna de Jos (Cluj)', zip: '407266' },
  { city: 'Pâglişa (Cluj)', zip: '407267' },
  { city: 'Feleacu (Cluj)', zip: '407270' },
  { city: 'Casele Miceşti (Cluj)', zip: '407271' },
  { city: 'Gheorghieni (Cluj)', zip: '407272' },
  { city: 'Sărădiş (Cluj)', zip: '407273' },
  { city: 'Vâlcele (Cluj)', zip: '407274' },
  { city: 'Fizeşu Gherlii (Cluj)', zip: '407275' },
  { city: 'Bonţ (Cluj)', zip: '407276' },
  { city: 'Lunca Bonţului (Cluj)', zip: '407277' },
  { city: 'Nicula (Cluj)', zip: '407278' },
  { city: 'Săcălaia (Cluj)', zip: '407279' },
  { city: 'Floreşti (Cluj)', zip: '407280' },
  { city: 'Luna de Sus (Cluj)', zip: '407281' },
  { city: 'Tăuţi (Cluj)', zip: '407282' },
  { city: 'Frata (Cluj)', zip: '407285' },
  { city: 'Berchieşu (Cluj)', zip: '407286' },
  { city: 'Oaş (Cluj)', zip: '407287' },
  { city: 'Olariu (Cluj)', zip: '407288' },
  { city: 'Pădurea Iacobeni (Cluj)', zip: '407289' },
  { city: 'Poiana Frăţii (Cluj)', zip: '407291' },
  { city: 'Răzoare (Cluj)', zip: '407292' },
  { city: 'Soporu de Câmpie (Cluj)', zip: '407293' },
  { city: 'Gârbău (Cluj)', zip: '407295' },
  { city: 'Corneşti (Gârbău) (Cluj)', zip: '407296' },
  { city: 'Nădăşelu (Cluj)', zip: '407297' },
  { city: 'Turea (Cluj)', zip: '407298' },
  { city: 'Viştea (Cluj)', zip: '407299' },
  { city: 'Geaca (Cluj)', zip: '407300' },
  { city: 'Chiriş (Cluj)', zip: '407301' },
  { city: 'Lacu (Cluj)', zip: '407302' },
  { city: 'Legii (Cluj)', zip: '407303' },
  { city: 'Puini (Cluj)', zip: '407304' },
  { city: 'Sucutard (Cluj)', zip: '407306' },
  { city: 'Gilău (Cluj)', zip: '407310' },
  { city: 'Someşu Cald (Cluj)', zip: '407311' },
  { city: 'Someşu Rece (Cluj)', zip: '407312' },
  { city: 'Iara (Cluj)', zip: '407315' },
  { city: 'Agriş (Cluj)', zip: '407316' },
  { city: 'Borzeşti (Cluj)', zip: '407317' },
  { city: 'Buru (Cluj)', zip: '407318' },
  { city: 'Cacova Ierii (Cluj)', zip: '407319' },
  { city: 'Făgetu Ierii (Cluj)', zip: '407321' },
  { city: 'Lungeşti (Cluj)', zip: '407322' },
  { city: 'Maşca (Cluj)', zip: '407323' },
  { city: 'Măgura Ierii (Cluj)', zip: '407324' },
  { city: 'Ocolişel (Cluj)', zip: '407326' },
  { city: 'Surduc (Cluj)', zip: '407327' },
  { city: 'Valea Agrişului (Cluj)', zip: '407328' },
  { city: 'Valea Vadului (Cluj)', zip: '407329' },
  { city: 'Iclod (Cluj)', zip: '407335' },
  { city: 'Fundătura (Cluj)', zip: '407336' },
  { city: 'Iclozel (Cluj)', zip: '407337' },
  { city: 'Livada (Iclod) (Cluj)', zip: '407338' },
  { city: 'Orman (Cluj)', zip: '407339' },
  { city: 'Izvoru Crişului (Cluj)', zip: '407340' },
  { city: 'Nadăşu (Cluj)', zip: '407341' },
  { city: 'Nearşova (Cluj)', zip: '407342' },
  { city: 'Şaula (Cluj)', zip: '407343' },
  { city: 'Jichişu de Jos (Cluj)', zip: '407345' },
  { city: 'Codor (Cluj)', zip: '407346' },
  { city: 'Jichişu de Sus (Cluj)', zip: '407347' },
  { city: 'Şigău (Cluj)', zip: '407348' },
  { city: 'Tărpiu (Cluj)', zip: '407349' },
  { city: 'Jucu (Cluj)', zip: '407350' },
  { city: 'Gădălin (Cluj)', zip: '407351' },
  { city: 'Juc-Herghelie (Cluj)', zip: '407352' },
  { city: 'Jucu de Mijloc (Cluj)', zip: '407353' },
  { city: 'Jucu de Sus (Cluj)', zip: '407354' },
  { city: 'Vişea (Cluj)', zip: '407356' },
  { city: 'Luna (Cluj)', zip: '407360' },
  { city: 'Gligoreşti (Cluj)', zip: '407361' },
  { city: 'Luncani (Cluj)', zip: '407362' },
  { city: 'Măguri-Răcătău (Cluj)', zip: '407365' },
  { city: 'Măguri (Cluj)', zip: '407366' },
  { city: 'Muntele Rece (Cluj)', zip: '407367' },
  { city: 'Mănăstireni (Cluj)', zip: '407370' },
  { city: 'Ardeova (Cluj)', zip: '407371' },
  { city: 'Bedeciu (Cluj)', zip: '407372' },
  { city: 'Bica (Cluj)', zip: '407373' },
  { city: 'Dretea (Cluj)', zip: '407374' },
  { city: 'Mănăşturu Românesc (Cluj)', zip: '407376' },
  { city: 'Mărgău (Cluj)', zip: '407380' },
  { city: 'Bociu (Cluj)', zip: '407381' },
  { city: 'Buteni (Cluj)', zip: '407382' },
  { city: 'Ciuleni (Cluj)', zip: '407383' },
  { city: 'Răchiţele (Cluj)', zip: '407384' },
  { city: 'Scrind-Frăsinet (Cluj)', zip: '407386' },
  { city: 'Mărişel (Cluj)', zip: '407390' },
  { city: 'Tarniţa (Cluj)', zip: '407391' },
  { city: 'Mica (Cluj)', zip: '407395' },
  { city: 'Dâmbu Mare (Cluj)', zip: '407396' },
  { city: 'Mănăstirea (Cluj)', zip: '407397' },
  { city: 'Nireş (Cluj)', zip: '407398' },
  { city: 'Sânmărghita (Cluj)', zip: '407399' },
  { city: 'Valea Cireşoii (Cluj)', zip: '407401' },
  { city: 'Valea Luncii (Cluj)', zip: '407402' },
  { city: 'Mihai Viteazu (Cluj)', zip: '407405' },
  { city: 'Cheia (Cluj)', zip: '407406' },
  { city: 'Corneşti (Mihai Viteazu) (Cluj)', zip: '407407' },
  { city: 'Mintiu Gherlii (Cluj)', zip: '407410' },
  { city: 'Buneşti (Cluj)', zip: '407411' },
  { city: 'Nima (Cluj)', zip: '407412' },
  { city: 'Pădurenii (Mintiu Gherlii) (Cluj)', zip: '407413' },
  { city: 'Petreşti (Cluj)', zip: '407414' },
  { city: 'Salatiu (Cluj)', zip: '407416' },
  { city: 'Mociu (Cluj)', zip: '407420' },
  { city: 'Boteni (Cluj)', zip: '407421' },
  { city: 'Chesău (Cluj)', zip: '407422' },
  { city: 'Crişeni (Cluj)', zip: '407423' },
  { city: 'Falca (Cluj)', zip: '407424' },
  { city: 'Ghirişu Român (Cluj)', zip: '407426' },
  { city: 'Roşieni (Cluj)', zip: '407427' },
  { city: 'Turmaşi (Cluj)', zip: '407428' },
  { city: 'Zorenii de Vale (Cluj)', zip: '407429' },
  { city: 'Moldoveneşti (Cluj)', zip: '407430' },
  { city: 'Bădeni (Cluj)', zip: '407431' },
  { city: 'Pietroasa (Cluj)', zip: '407432' },
  { city: 'Plăieşti (Cluj)', zip: '407433' },
  { city: 'Podeni (Cluj)', zip: '407434' },
  { city: 'Stejeriş (Cluj)', zip: '407436' },
  { city: 'Negreni (Cluj)', zip: '407440' },
  { city: 'Bucea (Cluj)', zip: '407441' },
  { city: 'Prelucele (Cluj)', zip: '407442' },
  { city: 'Panticeu (Cluj)', zip: '407445' },
  { city: 'Cătălina (Cluj)', zip: '407446' },
  { city: 'Cubleşu Someşan (Cluj)', zip: '407447' },
  { city: 'Dârja (Cluj)', zip: '407448' },
  { city: 'Sărata (Cluj)', zip: '407449' },
  { city: 'Pălatca (Cluj)', zip: '407450' },
  { city: 'Băgaciu (Cluj)', zip: '407451' },
  { city: 'Mureşenii de Câmpie (Cluj)', zip: '407452' },
  { city: 'Petea (Cluj)', zip: '407453' },
  { city: 'Sava (Cluj)', zip: '407454' },
  { city: 'Petreştii de Jos (Cluj)', zip: '407455' },
  { city: 'Crăeşti (Cluj)', zip: '407456' },
  { city: 'Deleni (Cluj)', zip: '407457' },
  { city: 'Livada (Petreştii de Jos) (Cluj)', zip: '407458' },
  { city: 'Petreştii de Mijloc (Cluj)', zip: '407459' },
  { city: 'Petreştii de Sus (Cluj)', zip: '407461' },
  { city: 'Plaiuri (Cluj)', zip: '407462' },
  { city: 'Ploscoş (Cluj)', zip: '407465' },
  { city: 'Crairât (Cluj)', zip: '407466' },
  { city: 'Lobodaş (Cluj)', zip: '407467' },
  { city: 'Valea Florilor (Cluj)', zip: '407468' },
  { city: 'Poieni (Cluj)', zip: '407470' },
  { city: 'Bologa (Cluj)', zip: '407471' },
  { city: 'Cerbeşti (Cluj)', zip: '407472' },
  { city: 'Hodişu (Cluj)', zip: '407473' },
  { city: 'Lunca Vişagului (Cluj)', zip: '407474' },
  { city: 'Morlaca (Cluj)', zip: '407476' },
  { city: 'Tranişu (Cluj)', zip: '407477' },
  { city: 'Valea Drăganului (Cluj)', zip: '407478' },
  { city: 'Recea-Cristur (Cluj)', zip: '407480' },
  { city: 'Căprioara (Cluj)', zip: '407481' },
  { city: 'Ciubanca (Cluj)', zip: '407482' },
  { city: 'Ciubăncuţa (Cluj)', zip: '407483' },
  { city: 'Elciu (Cluj)', zip: '407484' },
  { city: 'Escu (Cluj)', zip: '407486' },
  { city: 'Jurca (Cluj)', zip: '407487' },
  { city: 'Osoi (Cluj)', zip: '407488' },
  { city: 'Pustuţa (Cluj)', zip: '407489' },
  { city: 'Râşca (Cluj)', zip: '407490' },
  { city: 'Dealu Mare (Cluj)', zip: '407491' },
  { city: 'Lăpuşteşti (Cluj)', zip: '407492' },
  { city: 'Mărceşti (Cluj)', zip: '407493' },
  { city: 'Săcuieu (Cluj)', zip: '407495' },
  { city: 'Rogojel (Cluj)', zip: '407496' },
  { city: 'Vişagu (Cluj)', zip: '407497' },
  { city: 'Sănduleşti (Cluj)', zip: '407500' },
  { city: 'Copăceni (Cluj)', zip: '407501' },
  { city: 'Săvădisla (Cluj)', zip: '407505' },
  { city: 'Finişel (Cluj)', zip: '407506' },
  { city: 'Hăşdate (Săvădisla) (Cluj)', zip: '407507' },
  { city: 'Lita (Cluj)', zip: '407508' },
  { city: 'Liteni (Cluj)', zip: '407509' },
  { city: 'Stolna (Cluj)', zip: '407511' },
  { city: 'Vălişoara (Cluj)', zip: '407512' },
  { city: 'Vlaha (Cluj)', zip: '407513' },
  { city: 'Sâncraiu (Cluj)', zip: '407515' },
  { city: 'Alunişu (Cluj)', zip: '407516' },
  { city: 'Brăişoru (Cluj)', zip: '407517' },
  { city: 'Domoşu (Cluj)', zip: '407518' },
  { city: 'Horlacea (Cluj)', zip: '407519' },
  { city: 'Sânmărtin (Cluj)', zip: '407520' },
  { city: 'Ceaba (Cluj)', zip: '407521' },
  { city: 'Cutca (Cluj)', zip: '407522' },
  { city: 'Diviciorii Mari (Cluj)', zip: '407523' },
  { city: 'Diviciorii Mici (Cluj)', zip: '407524' },
  { city: 'Măhal (Cluj)', zip: '407526' },
  { city: 'Sâmboieni (Cluj)', zip: '407527' },
  { city: 'Târguşor (Cluj)', zip: '407528' },
  { city: 'Sânpaul (Cluj)', zip: '407530' },
  { city: 'Berindu (Cluj)', zip: '407531' },
  { city: 'Mihăieşti (Cluj)', zip: '407532' },
  { city: 'Sumurducu (Cluj)', zip: '407533' },
  { city: 'Şardu (Cluj)', zip: '407534' },
  { city: 'Topa Mică (Cluj)', zip: '407536' },
  { city: 'Sic (Cluj)', zip: '407540' },
  { city: 'Suatu (Cluj)', zip: '407545' },
  { city: 'Aruncuta (Cluj)', zip: '407546' },
  { city: 'Dâmburile (Cluj)', zip: '407547' },
  { city: 'Tritenii de Jos (Cluj)', zip: '407550' },
  { city: 'Clapa (Cluj)', zip: '407551' },
  { city: 'Colonia (Cluj)', zip: '407552' },
  { city: 'Pădurenii (Tritenii de Jos) (Cluj)', zip: '407553' },
  { city: 'Tritenii de Sus (Cluj)', zip: '407554' },
  { city: 'Tritenii-Hotar (Cluj)', zip: '407556' },
  { city: 'Tureni (Cluj)', zip: '407560' },
  { city: 'Ceanu Mic (Cluj)', zip: '407561' },
  { city: 'Comşeşti (Cluj)', zip: '407562' },
  { city: 'Mărtineşti (Cluj)', zip: '407563' },
  { city: 'Miceşti (Cluj)', zip: '407564' },
  { city: 'Ţaga (Cluj)', zip: '407565' },
  { city: 'Năsal (Cluj)', zip: '407566' },
  { city: 'Sântejude (Cluj)', zip: '407567' },
  { city: 'Sântejude-Vale (Cluj)', zip: '407568' },
  { city: 'Sântioana (Cluj)', zip: '407569' },
  { city: 'Unguraş (Cluj)', zip: '407570' },
  { city: 'Batin (Cluj)', zip: '407571' },
  { city: 'Daroţ (Cluj)', zip: '407572' },
  { city: 'Sicfa (Cluj)', zip: '407573' },
  { city: 'Valea Unguraşului (Cluj)', zip: '407574' },
  { city: 'Vad (Cluj)', zip: '407575' },
  { city: 'Bogata de Jos (Cluj)', zip: '407576' },
  { city: 'Bogata de Sus (Cluj)', zip: '407577' },
  { city: 'Calna (Cluj)', zip: '407578' },
  { city: 'Cetan (Cluj)', zip: '407579' },
  { city: 'Curtuiuşu Dejului (Cluj)', zip: '407581' },
  { city: 'Valea Groşilor (Cluj)', zip: '407582' },
  { city: 'Valea Ierii (Cluj)', zip: '407585' },
  { city: 'Cerc (Cluj)', zip: '407586' },
  { city: 'Plopi (Cluj)', zip: '407587' },
  { city: 'Viişoara (Cluj)', zip: '407590' },
  { city: 'Urca (Cluj)', zip: '407591' },
  { city: 'Vultureni (Cluj)', zip: '407595' },
  { city: 'Băbuţiu (Cluj)', zip: '407596' },
  { city: 'Bădeşti (Cluj)', zip: '407597' },
  { city: 'Chidea (Cluj)', zip: '407598' },
  { city: 'Făureni (Cluj)', zip: '407599' },
  { city: 'Şoimeni (Cluj)', zip: '407601' },
  { city: 'Mamaia (Constanţa)', zip: '900001' },
  { city: 'Palazu Mare (Constanţa)', zip: '900002' },
  { city: 'Constanţa (Constanţa)', zip: '900003' },
  { city: 'Murfatlar (Constanţa)', zip: '905100' },
  { city: 'Siminoc (Constanţa)', zip: '905101' },
  { city: 'Cernavodă (Constanţa)', zip: '905200' },
  { city: 'Eforie (Constanţa)', zip: '905300' },
  { city: 'Eforie Nord (Constanţa)', zip: '905350' },
  { city: 'Eforie Sud (Constanţa)', zip: '905360' },
  { city: 'Hârşova (Constanţa)', zip: '905400' },
  { city: 'Vadu Oii (Constanţa)', zip: '905401' },
  { city: 'Mangalia (Constanţa)', zip: '905500' },
  { city: 'Aurora (Constanţa)', zip: '905501' },
  { city: 'Jupiter (Constanţa)', zip: '905502' },
  { city: 'Olimp (Constanţa)', zip: '905503' },
  { city: 'Venus (Constanţa)', zip: '905504' },
  { city: 'Neptun (Constanţa)', zip: '905550' },
  { city: 'Saturn (Constanţa)', zip: '905560' },
  { city: 'Medgidia (Constanţa)', zip: '905600' },
  { city: 'Remus Opreanu (Constanţa)', zip: '905601' },
  { city: 'Valea Dacilor (Constanţa)', zip: '905602' },
  { city: 'Năvodari (Constanţa)', zip: '905700' },
  { city: 'Mamaia-Sat (Constanţa)', zip: '905701' },
  { city: 'Negru Vodă (Constanţa)', zip: '905800' },
  { city: 'Darabani (Constanţa)', zip: '905801' },
  { city: 'Grăniceru (Constanţa)', zip: '905802' },
  { city: 'Vâlcelele (Constanţa)', zip: '905803' },
  { city: 'Ovidiu (Constanţa)', zip: '905900' },
  { city: 'Poiana (Constanţa)', zip: '905901' },
  { city: 'Culmea (Constanţa)', zip: '905902' },
  { city: 'Techirghiol (Constanţa)', zip: '906100' },
  { city: '45527 (Constanţa)', zip: '907005' },
  { city: 'Dulceşti (Constanţa)', zip: '907006' },
  { city: 'Moşneni (Constanţa)', zip: '907007' },
  { city: 'Adamclisi (Constanţa)', zip: '907010' },
  { city: 'Abrud (Constanţa)', zip: '907011' },
  { city: 'Haţeg (Constanţa)', zip: '907012' },
  { city: 'Urluia (Constanţa)', zip: '907013' },
  { city: 'Zorile (Constanţa)', zip: '907014' },
  { city: 'Agigea (Constanţa)', zip: '907015' },
  { city: 'Lazu (Constanţa)', zip: '907016' },
  { city: 'Sanatoriul Agigea (Constanţa)', zip: '907017' },
  { city: 'Staţiunea Zoologică Marină Agigea (Constanţa)', zip: '907018' },
  { city: 'Albeşti (Constanţa)', zip: '907020' },
  { city: 'Arsa (Constanţa)', zip: '907021' },
  { city: 'Coroana (Constanţa)', zip: '907022' },
  { city: 'Cotu Văii (Constanţa)', zip: '907023' },
  { city: 'Vârtop (Constanţa)', zip: '907024' },
  { city: 'Aliman (Constanţa)', zip: '907025' },
  { city: 'Dunăreni (Constanţa)', zip: '907026' },
  { city: 'Floriile (Constanţa)', zip: '907027' },
  { city: 'Vlahii (Constanţa)', zip: '907028' },
  { city: 'Amzacea (Constanţa)', zip: '907030' },
  { city: 'Casicea (Constanţa)', zip: '907031' },
  { city: 'General Scărişoreanu (Constanţa)', zip: '907032' },
  { city: 'Băneasa (Constanţa)', zip: '907035' },
  { city: 'Făurei (Constanţa)', zip: '907036' },
  { city: 'Negureni (Constanţa)', zip: '907037' },
  { city: 'Tudor Vladimirescu (Constanţa)', zip: '907038' },
  { city: 'Castelu (Constanţa)', zip: '907040' },
  { city: 'Cuza Vodă (Constanţa)', zip: '907041' },
  { city: 'Nisipari (Constanţa)', zip: '907042' },
  { city: 'Cerchezu (Constanţa)', zip: '907045' },
  { city: 'Căscioarele (Constanţa)', zip: '907046' },
  { city: 'Măgura (Constanţa)', zip: '907047' },
  { city: 'Viroaga (Constanţa)', zip: '907048' },
  { city: 'Chirnogeni (Constanţa)', zip: '907050' },
  { city: 'Credinţa (Constanţa)', zip: '907051' },
  { city: 'Plopeni (Constanţa)', zip: '907052' },
  { city: 'Ciobanu (Constanţa)', zip: '907055' },
  { city: 'Mioriţa (Constanţa)', zip: '907056' },
  { city: 'Ciocârlia (Constanţa)', zip: '907060' },
  { city: 'Ciocârlia de Sus (Constanţa)', zip: '907061' },
  { city: 'Cobadin (Constanţa)', zip: '907065' },
  { city: 'Conacu (Constanţa)', zip: '907066' },
  { city: 'Curcani (Constanţa)', zip: '907067' },
  { city: 'Negreşti (Constanţa)', zip: '907068' },
  { city: 'Viişoara (Constanţa)', zip: '907069' },
  { city: 'Cogealac (Constanţa)', zip: '907070' },
  { city: 'Fântânele (Constanţa)', zip: '907071' },
  { city: 'Gura Dobrogei (Constanţa)', zip: '907072' },
  { city: 'Râmnicu de Jos (Constanţa)', zip: '907073' },
  { city: 'Râmnicu de Sus (Constanţa)', zip: '907074' },
  { city: 'Tariverde (Constanţa)', zip: '907076' },
  { city: 'Comana (Constanţa)', zip: '907080' },
  { city: 'Pelinu (Constanţa)', zip: '907081' },
  { city: 'Tătaru (Constanţa)', zip: '907082' },
  { city: 'Corbu (Constanţa)', zip: '907085' },
  { city: 'Luminiţa (Constanţa)', zip: '907086' },
  { city: 'Vadu (Constanţa)', zip: '907087' },
  { city: 'Costineşti (Constanţa)', zip: '907090' },
  { city: 'Schitu (Constanţa)', zip: '907091' },
  { city: 'Crucea (Constanţa)', zip: '907095' },
  { city: 'Băltăgeşti (Constanţa)', zip: '907096' },
  { city: 'Crişan (Constanţa)', zip: '907097' },
  { city: 'Gălbiori (Constanţa)', zip: '907098' },
  { city: 'Şiriu (Constanţa)', zip: '907099' },
  { city: 'Stupina (Constanţa)', zip: '907101' },
  { city: 'Cumpăna (Constanţa)', zip: '907105' },
  { city: 'Straja (Constanţa)', zip: '907106' },
  { city: 'Deleni (Constanţa)', zip: '907110' },
  { city: 'Petroşani (Constanţa)', zip: '907111' },
  { city: 'Pietreni (Constanţa)', zip: '907112' },
  { city: 'Şipotele (Constanţa)', zip: '907113' },
  { city: 'Dobromir (Constanţa)', zip: '907115' },
  { city: 'Cetatea (Constanţa)', zip: '907116' },
  { city: 'Dobromiru din Deal (Constanţa)', zip: '907117' },
  { city: 'Lespezi (Constanţa)', zip: '907118' },
  { city: 'Pădureni (Constanţa)', zip: '907119' },
  { city: 'Văleni (Constanţa)', zip: '907121' },
  { city: 'Dumbrăveni (Constanţa)', zip: '907125' },
  { city: 'Furnica (Constanţa)', zip: '907126' },
  { city: 'Gârliciu (Constanţa)', zip: '907130' },
  { city: 'Ghindăreşti (Constanţa)', zip: '907135' },
  { city: 'Horia (Constanţa)', zip: '907140' },
  { city: 'Cloşca (Constanţa)', zip: '907141' },
  { city: 'Tichileşti (Constanţa)', zip: '907142' },
  { city: 'Independenţa (Constanţa)', zip: '907145' },
  { city: 'Fântâna Mare (Constanţa)', zip: '907146' },
  { city: 'Movila Verde (Constanţa)', zip: '907147' },
  { city: 'Olteni (Constanţa)', zip: '907148' },
  { city: 'Tufani (Constanţa)', zip: '907149' },
  { city: 'Ion Corvin (Constanţa)', zip: '907150' },
  { city: 'Brebeni (Constanţa)', zip: '907151' },
  { city: 'Crângu (Constanţa)', zip: '907152' },
  { city: 'Rariştea (Constanţa)', zip: '907153' },
  { city: 'Viile (Constanţa)', zip: '907154' },
  { city: 'Istria (Constanţa)', zip: '907155' },
  { city: 'Nuntaşi (Constanţa)', zip: '907156' },
  { city: 'Limanu (Constanţa)', zip: '907160' },
  { city: '2 Mai (Constanţa)', zip: '907161' },
  { city: 'Hagieni (Constanţa)', zip: '907162' },
  { city: 'Vama Veche (Constanţa)', zip: '907163' },
  { city: 'Lipniţa (Constanţa)', zip: '907165' },
  { city: 'Canlia (Constanţa)', zip: '907166' },
  { city: 'Carvăn (Constanţa)', zip: '907167' },
  { city: 'Coslugea (Constanţa)', zip: '907168' },
  { city: 'Cuiugiuc (Constanţa)', zip: '907169' },
  { city: 'Goruni (Constanţa)', zip: '907171' },
  { city: 'Izvoarele (Constanţa)', zip: '907172' },
  { city: 'Lumina (Constanţa)', zip: '907175' },
  { city: 'Oituz (Constanţa)', zip: '907176' },
  { city: 'Sibioara (Constanţa)', zip: '907177' },
  { city: 'Mereni (Constanţa)', zip: '907180' },
  { city: 'Bărăganu (Constanţa)', zip: '907181' },
  { city: 'Ciobăniţa (Constanţa)', zip: '907182' },
  { city: 'Lanurile (Constanţa)', zip: '907183' },
  { city: 'Miriştea (Constanţa)', zip: '907184' },
  { city: 'Osmancea (Constanţa)', zip: '907186' },
  { city: 'Mihai Viteazu (Constanţa)', zip: '907190' },
  { city: 'Sinoie (Constanţa)', zip: '907191' },
  { city: 'Mihail Kogălniceanu (Constanţa)', zip: '907195' },
  { city: 'Palazu Mic (Constanţa)', zip: '907196' },
  { city: 'Piatra (Constanţa)', zip: '907197' },
  { city: 'Mircea Vodă (Constanţa)', zip: '907200' },
  { city: 'Făclia (Constanţa)', zip: '907201' },
  { city: 'Gherghina (Constanţa)', zip: '907202' },
  { city: 'Saligny (Constanţa)', zip: '907203' },
  { city: 'Satu Nou (Mircea Vodă) (Constanţa)', zip: '907204' },
  { city: 'Ştefan cel Mare (Constanţa)', zip: '907206' },
  { city: 'Ţibrinu (Constanţa)', zip: '907207' },
  { city: 'Nicolae Bălcescu (Constanţa)', zip: '907210' },
  { city: 'Dorobanţu (Constanţa)', zip: '907211' },
  { city: 'Oltina (Constanţa)', zip: '907215' },
  { city: 'Răzoarele (Constanţa)', zip: '907216' },
  { city: 'Satu Nou (Oltina) (Constanţa)', zip: '907217' },
  { city: 'Strunga (Constanţa)', zip: '907218' },
  { city: 'Ostrov (Constanţa)', zip: '907220' },
  { city: 'Almălău (Constanţa)', zip: '907221' },
  { city: 'Bugeac (Constanţa)', zip: '907222' },
  { city: 'Esechioi (Constanţa)', zip: '907223' },
  { city: 'Galiţa (Constanţa)', zip: '907224' },
  { city: 'Gârliţa (Constanţa)', zip: '907226' },
  { city: 'Pantelimon (Constanţa)', zip: '907230' },
  { city: 'Călugăreni (Constanţa)', zip: '907231' },
  { city: 'Nistoreşti (Constanţa)', zip: '907232' },
  { city: 'Pantelimon de Jos (Constanţa)', zip: '907233' },
  { city: 'Runcu (Constanţa)', zip: '907234' },
  { city: 'Pecineaga (Constanţa)', zip: '907235' },
  { city: 'Vânători (Constanţa)', zip: '907236' },
  { city: 'Peştera (Constanţa)', zip: '907240' },
  { city: 'Ivrinezu Mare (Constanţa)', zip: '907241' },
  { city: 'Ivrinezu Mic (Constanţa)', zip: '907242' },
  { city: 'Izvoru Mare (Constanţa)', zip: '907243' },
  { city: 'Veteranu (Constanţa)', zip: '907244' },
  { city: 'Poarta Albă (Constanţa)', zip: '907245' },
  { city: 'Nazarcea (Constanţa)', zip: '907246' },
  { city: 'Rasova (Constanţa)', zip: '907250' },
  { city: 'Cochirleni (Constanţa)', zip: '907251' },
  { city: 'Saraiu (Constanţa)', zip: '907255' },
  { city: 'Dulgheru (Constanţa)', zip: '907256' },
  { city: 'Stejaru (Constanţa)', zip: '907257' },
  { city: 'Săcele (Constanţa)', zip: '907260' },
  { city: 'Traian (Constanţa)', zip: '907261' },
  { city: 'Seimeni (Constanţa)', zip: '907265' },
  { city: 'Dunărea (Constanţa)', zip: '907266' },
  { city: 'Seimenii Mici (Constanţa)', zip: '907267' },
  { city: 'Siliştea (Constanţa)', zip: '907270' },
  { city: 'Ţepeş Vodă (Constanţa)', zip: '907271' },
  { city: 'Târguşor (Constanţa)', zip: '907275' },
  { city: 'Casian (Constanţa)', zip: '907276' },
  { city: 'Cheia (Constanţa)', zip: '907277' },
  { city: 'Grădina (Constanţa)', zip: '907278' },
  { city: 'Mireasa (Constanţa)', zip: '907279' },
  { city: 'Topalu (Constanţa)', zip: '907280' },
  { city: 'Capidava (Constanţa)', zip: '907281' },
  { city: 'Topraisar (Constanţa)', zip: '907285' },
  { city: 'Biruinţa (Constanţa)', zip: '907286' },
  { city: 'Moviliţa (Constanţa)', zip: '907287' },
  { city: 'Potârnichea (Constanţa)', zip: '907288' },
  { city: 'Tortoman (Constanţa)', zip: '907290' },
  { city: 'Dropia (Constanţa)', zip: '907291' },
  { city: 'Tuzla (Constanţa)', zip: '907295' },
  { city: 'Valu lui Traian (Constanţa)', zip: '907300' },
  { city: 'Vulturu (Constanţa)', zip: '907305' },
  { city: 'Chilieni (Covasna)', zip: '520001' },
  { city: 'Coşeni (Covasna)', zip: '520002' },
  { city: 'Sfântu Gheorghe (Covasna)', zip: '520003' },
  { city: 'Baraolt (Covasna)', zip: '525100' },
  { city: 'Biborţeni (Covasna)', zip: '525101' },
  { city: 'Bodoş (Covasna)', zip: '525102' },
  { city: 'Căpeni (Covasna)', zip: '525103' },
  { city: 'Micloşoara (Covasna)', zip: '525104' },
  { city: 'Racoşul de Sus (Covasna)', zip: '525105' },
  { city: 'Covasna (Covasna)', zip: '525200' },
  { city: 'Chiuruş (Covasna)', zip: '525201' },
  { city: 'Întorsura Buzăului (Covasna)', zip: '525300' },
  { city: 'Brădet (Covasna)', zip: '525301' },
  { city: 'Floroaia (Covasna)', zip: '525302' },
  { city: 'Scrădoasa (Covasna)', zip: '525303' },
  { city: 'Târgu Secuiesc (Covasna)', zip: '525400' },
  { city: 'Lunga (Covasna)', zip: '525401' },
  { city: 'Aita Mare (Covasna)', zip: '527005' },
  { city: 'Aita Medie (Covasna)', zip: '527006' },
  { city: 'Barcani (Covasna)', zip: '527010' },
  { city: 'Lădăuţi (Covasna)', zip: '527011' },
  { city: 'Sărămaş (Covasna)', zip: '527012' },
  { city: 'Băţani (Covasna)', zip: '527015' },
  { city: 'Aita Seacă (Covasna)', zip: '527016' },
  { city: 'Băţanii Mici (Covasna)', zip: '527017' },
  { city: 'Herculian (Covasna)', zip: '527018' },
  { city: 'Ozunca-Băi (Covasna)', zip: '527019' },
  { city: 'Băţanii Mari (Covasna)', zip: '527020' },
  { city: 'Belin (Covasna)', zip: '527030' },
  { city: 'Belin-Vale (Covasna)', zip: '527031' },
  { city: 'Bodoc (Covasna)', zip: '527035' },
  { city: 'Olteni (Covasna)', zip: '527036' },
  { city: 'Zălan (Covasna)', zip: '527037' },
  { city: 'Boroşneu Mare (Covasna)', zip: '527040' },
  { city: 'Boroşneu Mic (Covasna)', zip: '527041' },
  { city: 'Dobolii de Sus (Covasna)', zip: '527042' },
  { city: 'Leţ (Covasna)', zip: '527043' },
  { city: 'Ţufalău (Covasna)', zip: '527044' },
  { city: 'Valea Mică (Covasna)', zip: '527046' },
  { city: 'Brateş (Covasna)', zip: '527050' },
  { city: 'Pachia (Covasna)', zip: '527051' },
  { city: 'Telechia (Covasna)', zip: '527052' },
  { city: 'Brăduţ (Covasna)', zip: '527055' },
  { city: 'Doboşeni (Covasna)', zip: '527056' },
  { city: 'Filia (Covasna)', zip: '527057' },
  { city: 'Tălişoara (Covasna)', zip: '527058' },
  { city: 'Breţcu (Covasna)', zip: '527060' },
  { city: 'Mărtănuş (Covasna)', zip: '527061' },
  { city: 'Oituz (Covasna)', zip: '527062' },
  { city: 'Catalina (Covasna)', zip: '527065' },
  { city: 'Hătuica (Covasna)', zip: '527066' },
  { city: 'Imeni (Covasna)', zip: '527067' },
  { city: 'Mărcuşa (Covasna)', zip: '527068' },
  { city: 'Mărtineni (Covasna)', zip: '527069' },
  { city: 'Cernat (Covasna)', zip: '527070' },
  { city: 'Albiş (Covasna)', zip: '527071' },
  { city: 'Icafalău (Covasna)', zip: '527072' },
  { city: 'Chichiş (Covasna)', zip: '527075' },
  { city: 'Băcel (Covasna)', zip: '527076' },
  { city: 'Comandău (Covasna)', zip: '527080' },
  { city: 'Dobârlău (Covasna)', zip: '527085' },
  { city: 'Lunca Mărcuşului (Covasna)', zip: '527086' },
  { city: 'Mărcuş (Covasna)', zip: '527087' },
  { city: 'Valea Dobârlăului (Covasna)', zip: '527088' },
  { city: 'Ghelinţa (Covasna)', zip: '527090' },
  { city: 'Harale (Covasna)', zip: '527091' },
  { city: 'Ghidfalău (Covasna)', zip: '527095' },
  { city: 'Angheluş (Covasna)', zip: '527096' },
  { city: 'Fotoş (Covasna)', zip: '527097' },
  { city: 'Zoltan (Covasna)', zip: '527098' },
  { city: 'Hăghig (Covasna)', zip: '527100' },
  { city: 'Iarăş (Covasna)', zip: '527101' },
  { city: 'Ilieni (Covasna)', zip: '527105' },
  { city: 'Dobolii de Jos (Covasna)', zip: '527106' },
  { city: 'Sâncraiu (Covasna)', zip: '527107' },
  { city: 'Lemnia (Covasna)', zip: '527110' },
  { city: 'Lutoasa (Covasna)', zip: '527111' },
  { city: 'Mereni (Covasna)', zip: '527112' },
  { city: 'Micfalău (Covasna)', zip: '527115' },
  { city: 'Bixad (Covasna)', zip: '527116' },
  { city: 'Malnaş (Covasna)', zip: '527117' },
  { city: 'Malnaş-Băi (Covasna)', zip: '527118' },
  { city: 'Valea Zălanului (Covasna)', zip: '527119' },
  { city: 'Moacşa (Covasna)', zip: '527120' },
  { city: 'Dalnic (Covasna)', zip: '527121' },
  { city: 'Pădureni (Covasna)', zip: '527122' },
  { city: 'Ojdula (Covasna)', zip: '527125' },
  { city: 'Hilib (Covasna)', zip: '527126' },
  { city: 'Ozun (Covasna)', zip: '527130' },
  { city: 'Bicfalău (Covasna)', zip: '527131' },
  { city: 'Lisnău (Covasna)', zip: '527132' },
  { city: 'Lisnău-Vale (Covasna)', zip: '527133' },
  { city: 'Lunca Ozunului (Covasna)', zip: '527134' },
  { city: 'Măgheruş (Covasna)', zip: '527136' },
  { city: 'Sântionlunca (Covasna)', zip: '527137' },
  { city: 'Poian (Covasna)', zip: '527140' },
  { city: 'Belani (Covasna)', zip: '527141' },
  { city: 'Cărpinenii (Covasna)', zip: '527142' },
  { city: 'Estelnic (Covasna)', zip: '527143' },
  { city: 'Valea Scurtă (Covasna)', zip: '527144' },
  { city: 'Reci (Covasna)', zip: '527145' },
  { city: 'Aninoasa (Covasna)', zip: '527146' },
  { city: 'Bita (Covasna)', zip: '527147' },
  { city: 'Saciova (Covasna)', zip: '527148' },
  { city: 'Sânzieni (Covasna)', zip: '527150' },
  { city: 'Caşinu Mic (Covasna)', zip: '527151' },
  { city: 'Petriceni (Covasna)', zip: '527152' },
  { city: 'Valea Seacă (Covasna)', zip: '527153' },
  { city: 'Sita Buzăului (Covasna)', zip: '527155' },
  { city: 'Crasna (Covasna)', zip: '527156' },
  { city: 'Merişor (Covasna)', zip: '527157' },
  { city: 'Zăbrătău (Covasna)', zip: '527158' },
  { city: 'Turia (Covasna)', zip: '527160' },
  { city: 'Alungeni (Covasna)', zip: '527161' },
  { city: 'Valea Crişului (Covasna)', zip: '527165' },
  { city: 'Arcuş (Covasna)', zip: '527166' },
  { city: 'Calnic (Covasna)', zip: '527167' },
  { city: 'Valea Mare (Covasna)', zip: '527170' },
  { city: 'Vâlcele (Covasna)', zip: '527175' },
  { city: 'Araci (Covasna)', zip: '527176' },
  { city: 'Ariuşd (Covasna)', zip: '527177' },
  { city: 'Hetea (Covasna)', zip: '527178' },
  { city: 'Vârghiş (Covasna)', zip: '527180' },
  { city: 'Zagon (Covasna)', zip: '527185' },
  { city: 'Păpăuţi (Covasna)', zip: '527186' },
  { city: 'Zăbala (Covasna)', zip: '527190' },
  { city: 'Peteni (Covasna)', zip: '527191' },
  { city: 'Surcea (Covasna)', zip: '527192' },
  { city: 'Tamaşfalău (Covasna)', zip: '527193' },
  { city: 'Priseaca (Dâmboviţa)', zip: '130001' },
  { city: 'Târgovişte (Dâmboviţa)', zip: '130002' },
  { city: 'Fieni (Dâmboviţa)', zip: '135100' },
  { city: 'Berevoeşti (Dâmboviţa)', zip: '135101' },
  { city: 'Costeşti (Dâmboviţa)', zip: '135102' },
  { city: 'Găeşti (Dâmboviţa)', zip: '135200' },
  { city: 'Moreni (Dâmboviţa)', zip: '135300' },
  { city: 'Pucioasa (Dâmboviţa)', zip: '135400' },
  { city: 'Bela (Dâmboviţa)', zip: '135401' },
  { city: 'Diaconeşti (Dâmboviţa)', zip: '135402' },
  { city: 'Glodeni (Pucioasa) (Dâmboviţa)', zip: '135403' },
  { city: 'Malurile (Dâmboviţa)', zip: '135404' },
  { city: 'Miculeşti (Dâmboviţa)', zip: '135405' },
  { city: 'Pucioasa-Sat (Dâmboviţa)', zip: '135406' },
  { city: 'Titu (Dâmboviţa)', zip: '135500' },
  { city: 'Fusea (Dâmboviţa)', zip: '135501' },
  { city: 'Hagioaica (Dâmboviţa)', zip: '135502' },
  { city: 'Mereni (Titu) (Dâmboviţa)', zip: '135503' },
  { city: 'Plopu (Dâmboviţa)', zip: '135504' },
  { city: 'Sălcuţa (Dâmboviţa)', zip: '135505' },
  { city: 'Aninoasa (Dâmboviţa)', zip: '137005' },
  { city: 'Săteni (Dâmboviţa)', zip: '137006' },
  { city: 'Viforâta (Dâmboviţa)', zip: '137007' },
  { city: 'Băleni (Dâmboviţa)', zip: '137010' },
  { city: 'Băleni-Sârbi (Dâmboviţa)', zip: '137011' },
  { city: 'Băleni-Români (Dâmboviţa)', zip: '137015' },
  { city: 'Bărbuleţu (Dâmboviţa)', zip: '137020' },
  { city: 'Aluniş (Dâmboviţa)', zip: '137021' },
  { city: 'Cetăţuia (Dâmboviţa)', zip: '137022' },
  { city: 'După Deal (Dâmboviţa)', zip: '137023' },
  { city: 'Gura Bărbuleţului (Dâmboviţa)', zip: '137024' },
  { city: 'Râu Alb (Dâmboviţa)', zip: '137025' },
  { city: 'Pietrari (Dâmboviţa)', zip: '137026' },
  { city: 'Râu Alb de Jos (Dâmboviţa)', zip: '137027' },
  { city: 'Râu Alb de Sus (Dâmboviţa)', zip: '137028' },
  { city: 'Şipot (Dâmboviţa)', zip: '137029' },
  { city: 'Valea (Dâmboviţa)', zip: '137031' },
  { city: 'Bezdead (Dâmboviţa)', zip: '137035' },
  { city: 'Broşteni (Bezdead) (Dâmboviţa)', zip: '137036' },
  { city: 'Costişata (Dâmboviţa)', zip: '137037' },
  { city: 'Măgura (Bezdead) (Dâmboviţa)', zip: '137038' },
  { city: 'Tunari (Dâmboviţa)', zip: '137039' },
  { city: 'Valea Morii (Dâmboviţa)', zip: '137041' },
  { city: 'Bilciureşti (Dâmboviţa)', zip: '137045' },
  { city: 'Suseni-Socetu (Dâmboviţa)', zip: '137046' },
  { city: 'Braniştea (Dâmboviţa)', zip: '137050' },
  { city: 'Dâmbovicioara (Dâmboviţa)', zip: '137051' },
  { city: 'Săveşti (Dâmboviţa)', zip: '137052' },
  { city: 'Brăneşti (Dâmboviţa)', zip: '137055' },
  { city: 'Priboiu (Brăneşti) (Dâmboviţa)', zip: '137056' },
  { city: 'Brezoaele (Dâmboviţa)', zip: '137060' },
  { city: 'Brezoaia (Dâmboviţa)', zip: '137061' },
  { city: 'Buciumeni (Dâmboviţa)', zip: '137065' },
  { city: 'Dealu Mare (Dâmboviţa)', zip: '137066' },
  { city: 'Valea Leurzii (Dâmboviţa)', zip: '137067' },
  { city: 'Bucşani (Dâmboviţa)', zip: '137070' },
  { city: 'Hăbeni (Dâmboviţa)', zip: '137071' },
  { city: 'Racoviţa (Dâmboviţa)', zip: '137072' },
  { city: 'Răţoaia (Dâmboviţa)', zip: '137073' },
  { city: 'Butimanu (Dâmboviţa)', zip: '137075' },
  { city: 'Bărbuceanu (Dâmboviţa)', zip: '137076' },
  { city: 'Lucianca (Dâmboviţa)', zip: '137077' },
  { city: 'Ungureni (Butimanu) (Dâmboviţa)', zip: '137078' },
  { city: 'Cândeşti (Dâmboviţa)', zip: '137080' },
  { city: 'Aninoşani (Dâmboviţa)', zip: '137081' },
  { city: 'Cândeşti-Deal (Dâmboviţa)', zip: '137082' },
  { city: 'Cândeşti-Vale (Dâmboviţa)', zip: '137083' },
  { city: 'Dragodăneşti (Dâmboviţa)', zip: '137084' },
  { city: 'Valea Mare (Cândeşti) (Dâmboviţa)', zip: '137086' },
  { city: 'Ciocăneşti (Dâmboviţa)', zip: '137090' },
  { city: 'Creţu (Dâmboviţa)', zip: '137091' },
  { city: 'Decindea (Dâmboviţa)', zip: '137092' },
  { city: 'Urziceanca (Dâmboviţa)', zip: '137093' },
  { city: 'Vizureşti (Dâmboviţa)', zip: '137094' },
  { city: 'Cobia (Dâmboviţa)', zip: '137095' },
  { city: 'Blidari (Dâmboviţa)', zip: '137096' },
  { city: 'Călugăreni (Cobia) (Dâmboviţa)', zip: '137097' },
  { city: 'Căpşuna (Dâmboviţa)', zip: '137098' },
  { city: 'Cobiuţa (Dâmboviţa)', zip: '137099' },
  { city: 'Crăciuneşti (Dâmboviţa)', zip: '137101' },
  { city: 'Frasin-Deal (Dâmboviţa)', zip: '137102' },
  { city: 'Frasin-Vale (Dâmboviţa)', zip: '137103' },
  { city: 'Gherghiţeşti (Dâmboviţa)', zip: '137104' },
  { city: 'Mănăstirea (Dâmboviţa)', zip: '137106' },
  { city: 'Mislea (Dâmboviţa)', zip: '137107' },
  { city: 'Cojasca (Dâmboviţa)', zip: '137115' },
  { city: 'Fântânele (Dâmboviţa)', zip: '137116' },
  { city: 'Iazu (Dâmboviţa)', zip: '137117' },
  { city: 'Comişani (Dâmboviţa)', zip: '137120' },
  { city: 'Lazuri (Dâmboviţa)', zip: '137121' },
  { city: 'Conţeşti (Dâmboviţa)', zip: '137125' },
  { city: 'Bălteni (Dâmboviţa)', zip: '137126' },
  { city: 'Boteni (Dâmboviţa)', zip: '137127' },
  { city: 'Călugăreni (Conţeşti) (Dâmboviţa)', zip: '137128' },
  { city: 'Crângaşi (Dâmboviţa)', zip: '137129' },
  { city: 'Gămăneşti (Dâmboviţa)', zip: '137131' },
  { city: 'Heleşteu (Dâmboviţa)', zip: '137132' },
  { city: 'Mereni (Conţeşti) (Dâmboviţa)', zip: '137133' },
  { city: 'Corbii Mari (Dâmboviţa)', zip: '137135' },
  { city: 'Bărăceni (Dâmboviţa)', zip: '137136' },
  { city: 'Grozăveşti (Dâmboviţa)', zip: '137137' },
  { city: 'Moara din Groapă (Dâmboviţa)', zip: '137138' },
  { city: 'Petreşti (Corbii Mari) (Dâmboviţa)', zip: '137139' },
  { city: 'Podu Corbencii (Dâmboviţa)', zip: '137141' },
  { city: 'Satu Nou (Dâmboviţa)', zip: '137142' },
  { city: 'Ungureni (Corbii Mari) (Dâmboviţa)', zip: '137143' },
  { city: 'Vadu Stanchii (Dâmboviţa)', zip: '137144' },
  { city: 'Cornăţelu (Dâmboviţa)', zip: '137145' },
  { city: 'Alunişu (Dâmboviţa)', zip: '137146' },
  { city: 'Bolovani (Dâmboviţa)', zip: '137147' },
  { city: 'Corni (Dâmboviţa)', zip: '137148' },
  { city: 'Slobozia (Dâmboviţa)', zip: '137149' },
  { city: 'Corneşti (Dâmboviţa)', zip: '137150' },
  { city: 'Bujoreanca (Dâmboviţa)', zip: '137151' },
  { city: 'Cătunu (Corneşti) (Dâmboviţa)', zip: '137152' },
  { city: 'Cristeasca (Dâmboviţa)', zip: '137153' },
  { city: 'Crivăţu (Dâmboviţa)', zip: '137154' },
  { city: 'Frasinu (Dâmboviţa)', zip: '137156' },
  { city: 'Hodărăşti (Dâmboviţa)', zip: '137157' },
  { city: 'Ibrianu (Dâmboviţa)', zip: '137158' },
  { city: 'Postârnacu (Dâmboviţa)', zip: '137159' },
  { city: 'Ungureni (Corneşti) (Dâmboviţa)', zip: '137161' },
  { city: 'Costeştii din Vale (Dâmboviţa)', zip: '137165' },
  { city: 'Mărunţişu (Dâmboviţa)', zip: '137166' },
  { city: 'Tomşani (Dâmboviţa)', zip: '137167' },
  { city: 'Crângurile (Dâmboviţa)', zip: '137170' },
  { city: 'Băduleşti (Dâmboviţa)', zip: '137171' },
  { city: 'Crângurile de Jos (Dâmboviţa)', zip: '137172' },
  { city: 'Crângurile de Sus (Dâmboviţa)', zip: '137173' },
  { city: 'Pătroaia-Deal (Dâmboviţa)', zip: '137174' },
  { city: 'Pătroaia-Vale (Dâmboviţa)', zip: '137176' },
  { city: 'Potlogeni-Vale (Dâmboviţa)', zip: '137177' },
  { city: 'Răţeşti (Dâmboviţa)', zip: '137178' },
  { city: 'Voia (Dâmboviţa)', zip: '137179' },
  { city: 'Crevedia (Dâmboviţa)', zip: '137180' },
  { city: 'Cocani (Dâmboviţa)', zip: '137181' },
  { city: 'Dârza (Dâmboviţa)', zip: '137182' },
  { city: 'Mânăstirea (Dâmboviţa)', zip: '137183' },
  { city: 'Samurcaşi (Dâmboviţa)', zip: '137184' },
  { city: 'Dărmăneşti (Dâmboviţa)', zip: '137185' },
  { city: 'Mărginenii de Sus (Dâmboviţa)', zip: '137186' },
  { city: 'Vlădeni (Dâmboviţa)', zip: '137187' },
  { city: 'Dobra (Dâmboviţa)', zip: '137190' },
  { city: 'Mărceşti (Dâmboviţa)', zip: '137191' },
  { city: 'Doiceşti (Dâmboviţa)', zip: '137195' },
  { city: 'Dragodana (Dâmboviţa)', zip: '137200' },
  { city: 'Boboci (Dâmboviţa)', zip: '137201' },
  { city: 'Burduca (Dâmboviţa)', zip: '137202' },
  { city: 'Cuparu (Dâmboviţa)', zip: '137203' },
  { city: 'Pădureni (Dâmboviţa)', zip: '137204' },
  { city: 'Picior de Munte (Dâmboviţa)', zip: '137206' },
  { city: 'Străoşti (Dâmboviţa)', zip: '137207' },
  { city: 'Dragomireşti (Dâmboviţa)', zip: '137210' },
  { city: 'Decindeni (Dâmboviţa)', zip: '137211' },
  { city: 'Geangoeşti (Dâmboviţa)', zip: '137212' },
  { city: 'Mogoşeşti (Dâmboviţa)', zip: '137213' },
  { city: 'Râncăciov (Dâmboviţa)', zip: '137214' },
  { city: 'Ungureni (Dragomireşti) (Dâmboviţa)', zip: '137216' },
  { city: 'Finta (Dâmboviţa)', zip: '137220' },
  { city: 'Bechineşti (Dâmboviţa)', zip: '137221' },
  { city: 'Finta Mare (Dâmboviţa)', zip: '137222' },
  { city: 'Finta Veche (Dâmboviţa)', zip: '137223' },
  { city: 'Gheboaia (Dâmboviţa)', zip: '137224' },
  { city: 'Glodeni (Dâmboviţa)', zip: '137225' },
  { city: 'Guşoiu (Dâmboviţa)', zip: '137226' },
  { city: 'Lăculeţe (Dâmboviţa)', zip: '137227' },
  { city: 'Livezile (Glodeni) (Dâmboviţa)', zip: '137228' },
  { city: 'Malu Mierii (Dâmboviţa)', zip: '137229' },
  { city: 'Schela (Dâmboviţa)', zip: '137231' },
  { city: 'Gura Foii (Dâmboviţa)', zip: '137235' },
  { city: 'Bumbuia (Dâmboviţa)', zip: '137236' },
  { city: 'Catanele (Dâmboviţa)', zip: '137237' },
  { city: 'Făgetu (Dâmboviţa)', zip: '137238' },
  { city: 'Gura Ocniţei (Dâmboviţa)', zip: '137240' },
  { city: 'Adânca (Dâmboviţa)', zip: '137241' },
  { city: 'Ochiuri (Dâmboviţa)', zip: '137242' },
  { city: 'Săcueni (Dâmboviţa)', zip: '137243' },
  { city: 'Gura Şuţii (Dâmboviţa)', zip: '137245' },
  { city: 'Sperieţeni (Dâmboviţa)', zip: '137246' },
  { city: 'Hulubeşti (Dâmboviţa)', zip: '137250' },
  { city: 'Butoiu de Jos (Dâmboviţa)', zip: '137251' },
  { city: 'Butoiu de Sus (Dâmboviţa)', zip: '137252' },
  { city: 'Măgura (Hulubeşti) (Dâmboviţa)', zip: '137253' },
  { city: 'Valea Dadei (Dâmboviţa)', zip: '137254' },
  { city: 'I. L. Caragiale (Dâmboviţa)', zip: '137255' },
  { city: 'Ghirdoveni (Dâmboviţa)', zip: '137256' },
  { city: 'Mija (Dâmboviţa)', zip: '137257' },
  { city: 'Iedera (Dâmboviţa)', zip: '137260' },
  { city: 'Colibaşi (Dâmboviţa)', zip: '137261' },
  { city: 'Cricovu Dulce (Dâmboviţa)', zip: '137262' },
  { city: 'Iedera de Jos (Dâmboviţa)', zip: '137263' },
  { city: 'Iedera de Sus (Dâmboviţa)', zip: '137264' },
  { city: 'Lucieni (Dâmboviţa)', zip: '137265' },
  { city: 'Olteni (Lucieni) (Dâmboviţa)', zip: '137266' },
  { city: 'Raciu (Dâmboviţa)', zip: '137267' },
  { city: 'Siliştea (Raciu) (Dâmboviţa)', zip: '137268' },
  { city: 'Şuţa Seacă (Dâmboviţa)', zip: '137269' },
  { city: 'Ludeşti (Dâmboviţa)', zip: '137270' },
  { city: 'Miloşari (Dâmboviţa)', zip: '137271' },
  { city: 'Potocelu (Dâmboviţa)', zip: '137272' },
  { city: 'Scheiu de Jos (Dâmboviţa)', zip: '137273' },
  { city: 'Scheiu de Sus (Dâmboviţa)', zip: '137274' },
  { city: 'Teleşti (Dâmboviţa)', zip: '137276' },
  { city: 'Lunguleţu (Dâmboviţa)', zip: '137280' },
  { city: 'Oreasca (Dâmboviţa)', zip: '137281' },
  { city: 'Serdanu (Dâmboviţa)', zip: '137282' },
  { city: 'Malu cu Flori (Dâmboviţa)', zip: '137285' },
  { city: 'Capu Coastei (Dâmboviţa)', zip: '137286' },
  { city: 'Copăceni (Dâmboviţa)', zip: '137287' },
  { city: 'Micloşanii Mari (Dâmboviţa)', zip: '137288' },
  { city: 'Micloşanii Mici (Dâmboviţa)', zip: '137289' },
  { city: 'Măneşti (Dâmboviţa)', zip: '137290' },
  { city: 'Drăgăeşti-Pământeni (Dâmboviţa)', zip: '137291' },
  { city: 'Drăgăeşti-Ungureni (Dâmboviţa)', zip: '137292' },
  { city: 'Mătăsaru (Dâmboviţa)', zip: '137295' },
  { city: 'Creţuleşti (Dâmboviţa)', zip: '137296' },
  { city: 'Odaia Turcului (Dâmboviţa)', zip: '137297' },
  { city: 'Poroinica (Dâmboviţa)', zip: '137298' },
  { city: 'Puţu cu Salcie (Dâmboviţa)', zip: '137299' },
  { city: 'Sălcioara (Mătăsaru) (Dâmboviţa)', zip: '137301' },
  { city: 'Teţcoiu (Dâmboviţa)', zip: '137302' },
  { city: 'Mogoşani (Dâmboviţa)', zip: '137305' },
  { city: 'Chirca (Dâmboviţa)', zip: '137306' },
  { city: 'Cojocaru (Dâmboviţa)', zip: '137307' },
  { city: 'Merii (Dâmboviţa)', zip: '137308' },
  { city: 'Zăvoiu (Dâmboviţa)', zip: '137309' },
  { city: 'Moroeni (Dâmboviţa)', zip: '137310' },
  { city: 'Dobreşti (Dâmboviţa)', zip: '137311' },
  { city: 'Glod (Dâmboviţa)', zip: '137312' },
  { city: 'Lunca (Moroeni) (Dâmboviţa)', zip: '137313' },
  { city: 'Muşcel (Dâmboviţa)', zip: '137314' },
  { city: 'Pucheni (Moroeni) (Dâmboviţa)', zip: '137316' },
  { city: 'Morteni (Dâmboviţa)', zip: '137320' },
  { city: 'Neajlovu (Dâmboviţa)', zip: '137321' },
  { city: 'Moţăieni (Dâmboviţa)', zip: '137325' },
  { city: 'Cucuteni (Dâmboviţa)', zip: '137326' },
  { city: 'Niculeşti (Dâmboviţa)', zip: '137330' },
  { city: 'Ciocănari (Dâmboviţa)', zip: '137331' },
  { city: 'Movila (Niculeşti) (Dâmboviţa)', zip: '137332' },
  { city: 'Nucet (Dâmboviţa)', zip: '137335' },
  { city: 'Cazaci (Dâmboviţa)', zip: '137336' },
  { city: 'Ilfoveni (Dâmboviţa)', zip: '137337' },
  { city: 'Ocniţa (Dâmboviţa)', zip: '137340' },
  { city: 'Odobeşti (Dâmboviţa)', zip: '137345' },
  { city: 'Brâncoveanu (Dâmboviţa)', zip: '137346' },
  { city: 'Crovu (Dâmboviţa)', zip: '137347' },
  { city: 'Miuleşti (Dâmboviţa)', zip: '137348' },
  { city: 'Zidurile (Dâmboviţa)', zip: '137349' },
  { city: 'Petreşti (Dâmboviţa)', zip: '137350' },
  { city: 'Coada Izvorului (Dâmboviţa)', zip: '137351' },
  { city: 'Ghergheşti (Dâmboviţa)', zip: '137352' },
  { city: 'Greci (Dâmboviţa)', zip: '137353' },
  { city: 'Ioneşti (Dâmboviţa)', zip: '137354' },
  { city: 'Potlogeni-Deal (Dâmboviţa)', zip: '137356' },
  { city: 'Puntea de Greci (Dâmboviţa)', zip: '137357' },
  { city: 'Pietroşiţa (Dâmboviţa)', zip: '137360' },
  { city: 'Dealu Frumos (Dâmboviţa)', zip: '137361' },
  { city: 'Poiana (Dâmboviţa)', zip: '137365' },
  { city: 'Poieniţa (Dâmboviţa)', zip: '137366' },
  { city: 'Potlogi (Dâmboviţa)', zip: '137370' },
  { city: 'Pitaru (Dâmboviţa)', zip: '137371' },
  { city: 'Podu Cristinii (Dâmboviţa)', zip: '137372' },
  { city: 'Româneşti (Dâmboviţa)', zip: '137373' },
  { city: 'Vlăsceni (Dâmboviţa)', zip: '137374' },
  { city: 'Produleşti (Dâmboviţa)', zip: '137375' },
  { city: 'Broşteni (Produleşti) (Dâmboviţa)', zip: '137376' },
  { city: 'Costeştii din Deal (Dâmboviţa)', zip: '137377' },
  { city: 'Pucheni (Dâmboviţa)', zip: '137380' },
  { city: 'Brădăţel (Dâmboviţa)', zip: '137381' },
  { city: 'Meişoare (Dâmboviţa)', zip: '137382' },
  { city: 'Valea Largă (Dâmboviţa)', zip: '137383' },
  { city: 'Vârfureni (Dâmboviţa)', zip: '137384' },
  { city: 'Răcari (Dâmboviţa)', zip: '137385' },
  { city: 'Bălăneşti (Dâmboviţa)', zip: '137386' },
  { city: 'Colacu (Dâmboviţa)', zip: '137387' },
  { city: 'Ghergani (Dâmboviţa)', zip: '137388' },
  { city: 'Ghimpaţi (Dâmboviţa)', zip: '137389' },
  { city: 'Mavrodin (Dâmboviţa)', zip: '137391' },
  { city: 'Săbieşti (Dâmboviţa)', zip: '137392' },
  { city: 'Stăneşti (Dâmboviţa)', zip: '137393' },
  { city: 'Răzvad (Dâmboviţa)', zip: '137395' },
  { city: 'Gorgota (Dâmboviţa)', zip: '137396' },
  { city: 'Valea Voievozilor (Dâmboviţa)', zip: '137397' },
  { city: 'Runcu (Dâmboviţa)', zip: '137400' },
  { city: 'Bădeni (Dâmboviţa)', zip: '137401' },
  { city: 'Brebu (Dâmboviţa)', zip: '137402' },
  { city: 'Ferestre (Dâmboviţa)', zip: '137403' },
  { city: 'Piatra (Dâmboviţa)', zip: '137404' },
  { city: 'Siliştea (Runcu) (Dâmboviţa)', zip: '137406' },
  { city: 'Sălcioara (Dâmboviţa)', zip: '137410' },
  { city: 'Băneşti (Dâmboviţa)', zip: '137411' },
  { city: 'Cătunu (Sălcioara) (Dâmboviţa)', zip: '137412' },
  { city: 'Cuza Vodă (Dâmboviţa)', zip: '137413' },
  { city: 'Ghineşti (Dâmboviţa)', zip: '137414' },
  { city: 'Mircea Vodă (Dâmboviţa)', zip: '137416' },
  { city: 'Moara Nouă (Dâmboviţa)', zip: '137417' },
  { city: 'Movila (Sălcioara) (Dâmboviţa)', zip: '137418' },
  { city: 'Podu Rizii (Dâmboviţa)', zip: '137419' },
  { city: 'Slobozia Moară (Dâmboviţa)', zip: '137420' },
  { city: 'Şelaru (Dâmboviţa)', zip: '137425' },
  { city: 'Fierbinţi (Dâmboviţa)', zip: '137426' },
  { city: 'Glogoveanu (Dâmboviţa)', zip: '137427' },
  { city: 'Şotânga (Dâmboviţa)', zip: '137430' },
  { city: 'Teiş (Dâmboviţa)', zip: '137431' },
  { city: 'Tărtăşeşti (Dâmboviţa)', zip: '137435' },
  { city: 'Bâldana (Dâmboviţa)', zip: '137436' },
  { city: 'Gulia (Dâmboviţa)', zip: '137437' },
  { city: 'Tătărani (Dâmboviţa)', zip: '137440' },
  { city: 'Căprioru (Dâmboviţa)', zip: '137441' },
  { city: 'Gheboieni (Dâmboviţa)', zip: '137442' },
  { city: 'Priboiu (Tătărani) (Dâmboviţa)', zip: '137443' },
  { city: 'Ulieşti (Dâmboviţa)', zip: '137445' },
  { city: 'Croitori (Dâmboviţa)', zip: '137446' },
  { city: 'Hanu lui Pală (Dâmboviţa)', zip: '137447' },
  { city: 'Jugureni (Dâmboviţa)', zip: '137448' },
  { city: 'Mânăstioara (Dâmboviţa)', zip: '137449' },
  { city: 'Olteni (Ulieşti) (Dâmboviţa)', zip: '137451' },
  { city: 'Ragu (Dâmboviţa)', zip: '137452' },
  { city: 'Stavropolia (Dâmboviţa)', zip: '137453' },
  { city: 'Ulmi (Dâmboviţa)', zip: '137455' },
  { city: 'Colanu (Dâmboviţa)', zip: '137456' },
  { city: 'Dimoiu (Dâmboviţa)', zip: '137457' },
  { city: 'Dumbrava (Dâmboviţa)', zip: '137458' },
  { city: 'Matraca (Dâmboviţa)', zip: '137459' },
  { city: 'Nisipurile (Dâmboviţa)', zip: '137461' },
  { city: 'Udreşti (Dâmboviţa)', zip: '137462' },
  { city: 'Viişoara (Dâmboviţa)', zip: '137463' },
  { city: 'Valea Lungă (Dâmboviţa)', zip: '137465' },
  { city: 'Băceşti (Dâmboviţa)', zip: '137466' },
  { city: 'Izvoru (Valea Lungă) (Dâmboviţa)', zip: '137467' },
  { city: 'Moşia Mică (Dâmboviţa)', zip: '137468' },
  { city: 'Şerbăneasa (Dâmboviţa)', zip: '137469' },
  { city: 'Ştubeie Tisa (Dâmboviţa)', zip: '137471' },
  { city: 'Valea Lungă-Gorgota (Dâmboviţa)', zip: '137472' },
  { city: 'Valea Lungă-Ogrea (Dâmboviţa)', zip: '137473' },
  { city: 'Valea Mare (Valea Lungă) (Dâmboviţa)', zip: '137474' },
  { city: 'Valea Lungă-Cricov (Dâmboviţa)', zip: '137475' },
  { city: 'Valea lui Dan (Dâmboviţa)', zip: '137476' },
  { city: 'Valea Mare (Dâmboviţa)', zip: '137485' },
  { city: 'Feţeni (Dâmboviţa)', zip: '137486' },
  { city: 'Gârleni (Dâmboviţa)', zip: '137487' },
  { city: 'Livezile (Valea Mare) (Dâmboviţa)', zip: '137488' },
  { city: 'Saru (Dâmboviţa)', zip: '137489' },
  { city: 'Stratoneşti (Dâmboviţa)', zip: '137491' },
  { city: 'Valea Caselor (Dâmboviţa)', zip: '137492' },
  { city: 'Văcăreşti (Dâmboviţa)', zip: '137495' },
  { city: 'Brăteştii de Jos (Dâmboviţa)', zip: '137496' },
  { city: 'Bungetu (Dâmboviţa)', zip: '137497' },
  { city: 'Perşinari (Dâmboviţa)', zip: '137498' },
  { city: 'Văleni-Dâmboviţa (Dâmboviţa)', zip: '137500' },
  { city: 'Mesteacăn (Dâmboviţa)', zip: '137501' },
  { city: 'Vârfuri (Dâmboviţa)', zip: '137505' },
  { city: 'Cârlăneşti (Dâmboviţa)', zip: '137506' },
  { city: 'Cojoiu (Dâmboviţa)', zip: '137507' },
  { city: 'Merişoru (Dâmboviţa)', zip: '137508' },
  { city: 'Stăteşti (Dâmboviţa)', zip: '137509' },
  { city: 'Şuviţa (Dâmboviţa)', zip: '137511' },
  { city: 'Ulmetu (Dâmboviţa)', zip: '137512' },
  { city: 'Vişina (Dâmboviţa)', zip: '137515' },
  { city: 'Broşteni (Vişina) (Dâmboviţa)', zip: '137516' },
  { city: 'Izvoru (Vişina) (Dâmboviţa)', zip: '137517' },
  { city: 'Răscăeţi (Dâmboviţa)', zip: '137518' },
  { city: 'Vultureanca (Dâmboviţa)', zip: '137519' },
  { city: 'Vişineşti (Dâmboviţa)', zip: '137520' },
  { city: 'Dospineşti (Dâmboviţa)', zip: '137521' },
  { city: 'Sultanu (Dâmboviţa)', zip: '137522' },
  { city: 'Urseiu (Dâmboviţa)', zip: '137523' },
  { city: 'Voineşti (Dâmboviţa)', zip: '137525' },
  { city: 'Gemenea-Brătuleşti (Dâmboviţa)', zip: '137526' },
  { city: 'Izvoarele (Dâmboviţa)', zip: '137527' },
  { city: 'Lunca (Voineşti) (Dâmboviţa)', zip: '137528' },
  { city: 'Manga (Dâmboviţa)', zip: '137529' },
  { city: 'Mânjina (Dâmboviţa)', zip: '137531' },
  { city: 'Onceşti (Dâmboviţa)', zip: '137532' },
  { city: 'Suduleni (Dâmboviţa)', zip: '137533' },
  { city: 'Vulcana-Băi (Dâmboviţa)', zip: '137535' },
  { city: 'Nicolaeşti (Dâmboviţa)', zip: '137536' },
  { city: 'Vulcana de Sus (Dâmboviţa)', zip: '137537' },
  { city: 'Vulcana-Pandele (Dâmboviţa)', zip: '137540' },
  { city: 'Gura Vulcanei (Dâmboviţa)', zip: '137541' },
  { city: 'Lăculeţe-Gară (Dâmboviţa)', zip: '137542' },
  { city: 'Toculeşti (Dâmboviţa)', zip: '137543' },
  { city: 'Făcăi (Dolj)', zip: '200001' },
  { city: 'Mofleni (Dolj)', zip: '200002' },
  { city: 'Popoveni (Dolj)', zip: '200003' },
  { city: 'Şimnicu de Jos (Dolj)', zip: '200004' },
  { city: 'Craiova (Dolj)', zip: '200008' },
  { city: 'Băileşti (Dolj)', zip: '205100' },
  { city: 'Balasan (Dolj)', zip: '205101' },
  { city: 'Calafat (Dolj)', zip: '205200' },
  { city: 'Basarabi (Dolj)', zip: '205201' },
  { city: 'Ciupercenii Vechi (Dolj)', zip: '205202' },
  { city: 'Golenţi (Dolj)', zip: '205203' },
  { city: 'Filiaşi (Dolj)', zip: '205300' },
  { city: 'Almăjel (Dolj)', zip: '205301' },
  { city: 'Bâlta (Dolj)', zip: '205302' },
  { city: 'Branişte (Filiaşi) (Dolj)', zip: '205303' },
  { city: 'Fratoştiţa (Dolj)', zip: '205304' },
  { city: 'Răcarii de Sus (Dolj)', zip: '205305' },
  { city: 'Uscăci (Dolj)', zip: '205306' },
  { city: 'Segarcea (Dolj)', zip: '205400' },
  { city: 'Afumaţi (Dolj)', zip: '207005' },
  { city: 'Boureni (Dolj)', zip: '207006' },
  { city: 'Covei (Dolj)', zip: '207007' },
  { city: 'Almăj (Dolj)', zip: '207010' },
  { city: 'Beharca (Dolj)', zip: '207011' },
  { city: 'Bogea (Dolj)', zip: '207012' },
  { city: 'Coţofenii din Faţă (Dolj)', zip: '207013' },
  { city: 'Moşneni (Dolj)', zip: '207014' },
  { city: 'Şitoaia (Dolj)', zip: '207016' },
  { city: 'Amărăştii de Jos (Dolj)', zip: '207020' },
  { city: 'Ocolna (Dolj)', zip: '207021' },
  { city: 'Prapor (Dolj)', zip: '207022' },
  { city: 'Amărăştii de Sus (Dolj)', zip: '207025' },
  { city: 'Dobroteşti (Dolj)', zip: '207026' },
  { city: 'Nisipuri (Dolj)', zip: '207027' },
  { city: 'Zvorsca (Dolj)', zip: '207028' },
  { city: 'Apele Vii (Dolj)', zip: '207030' },
  { city: 'Argetoaia (Dolj)', zip: '207035' },
  { city: 'Băranu (Dolj)', zip: '207036' },
  { city: 'Berbeşu (Dolj)', zip: '207037' },
  { city: 'Iordăcheşti (Dolj)', zip: '207038' },
  { city: 'Leordoasa (Dolj)', zip: '207039' },
  { city: 'Malumnic (Dolj)', zip: '207041' },
  { city: 'Novac (Dolj)', zip: '207042' },
  { city: 'Piria (Dolj)', zip: '207043' },
  { city: 'Poiana Fântânii (Dolj)', zip: '207044' },
  { city: 'Salcia (Dolj)', zip: '207046' },
  { city: 'Teascu din Deal (Dolj)', zip: '207047' },
  { city: 'Ursoaia (Dolj)', zip: '207048' },
  { city: 'Bârca (Dolj)', zip: '207055' },
  { city: 'Bechet (Dolj)', zip: '207060' },
  { city: 'Bistreţ (Dolj)', zip: '207065' },
  { city: 'Bistreţu Nou (Dolj)', zip: '207066' },
  { city: 'Brânduşa (Dolj)', zip: '207067' },
  { city: 'Plosca (Dolj)', zip: '207068' },
  { city: 'Botoşeşti-Paia (Dolj)', zip: '207070' },
  { city: 'Brabova (Dolj)', zip: '207075' },
  { city: 'Caraiman (Dolj)', zip: '207076' },
  { city: 'Mosna (Dolj)', zip: '207077' },
  { city: 'Răchita de Jos (Dolj)', zip: '207078' },
  { city: 'Urdiniţa (Dolj)', zip: '207079' },
  { city: 'Voita (Dolj)', zip: '207081' },
  { city: 'Braloştiţa (Dolj)', zip: '207085' },
  { city: 'Ciocanele (Dolj)', zip: '207086' },
  { city: 'Racoviţa (Dolj)', zip: '207087' },
  { city: 'Schitu (Dolj)', zip: '207088' },
  { city: 'Sfircea (Dolj)', zip: '207089' },
  { city: 'Valea Fântânilor (Dolj)', zip: '207091' },
  { city: 'Bratovoeşti (Dolj)', zip: '207095' },
  { city: 'Bădoşi (Dolj)', zip: '207096' },
  { city: 'Georocu Mare (Dolj)', zip: '207097' },
  { city: 'Prunet (Dolj)', zip: '207098' },
  { city: 'Rojişte (Dolj)', zip: '207099' },
  { city: 'Tâmbureşti (Dolj)', zip: '207101' },
  { city: 'Brădeşti (Dolj)', zip: '207105' },
  { city: 'Brădeştii Bătrâni (Dolj)', zip: '207106' },
  { city: 'Meteu (Dolj)', zip: '207107' },
  { city: 'Piscani (Dolj)', zip: '207108' },
  { city: 'Răcarii de Jos (Dolj)', zip: '207109' },
  { city: 'Tatomireşti (Dolj)', zip: '207111' },
  { city: 'Breasta (Dolj)', zip: '207115' },
  { city: 'Cotu (Dolj)', zip: '207116' },
  { city: 'Crovna (Dolj)', zip: '207117' },
  { city: 'Făget (Dolj)', zip: '207118' },
  { city: 'Obedin (Dolj)', zip: '207119' },
  { city: 'Roşieni (Dolj)', zip: '207121' },
  { city: 'Valea Lungului (Dolj)', zip: '207122' },
  { city: 'Bucovăţ (Dolj)', zip: '207125' },
  { city: 'Cârligei (Dolj)', zip: '207126' },
  { city: 'Italieni (Dolj)', zip: '207127' },
  { city: 'Leamna de Jos (Dolj)', zip: '207128' },
  { city: 'Leamna de Sus (Dolj)', zip: '207129' },
  { city: 'Palilula (Dolj)', zip: '207131' },
  { city: 'Sărbătoarea (Dolj)', zip: '207132' },
  { city: 'Bulzeşti (Dolj)', zip: '207135' },
  { city: 'Frăţila (Dolj)', zip: '207136' },
  { city: 'Gura Racului (Dolj)', zip: '207137' },
  { city: 'Înfrăţirea (Dolj)', zip: '207138' },
  { city: 'Piscu Lung (Dolj)', zip: '207139' },
  { city: 'Poienile (Dolj)', zip: '207141' },
  { city: 'Prejoi (Dolj)', zip: '207142' },
  { city: 'Sălişte (Dolj)', zip: '207143' },
  { city: 'Seculeşti (Dolj)', zip: '207144' },
  { city: 'Stoiceşti (Dolj)', zip: '207146' },
  { city: 'Calopăr (Dolj)', zip: '207150' },
  { city: 'Bâzdâna (Dolj)', zip: '207151' },
  { city: 'Belcinu (Dolj)', zip: '207152' },
  { city: 'Panaghia (Dolj)', zip: '207153' },
  { city: 'Sălcuţa (Calopăr) (Dolj)', zip: '207154' },
  { city: 'Caraula (Dolj)', zip: '207155' },
  { city: 'Carpen (Dolj)', zip: '207160' },
  { city: 'Cleanov (Dolj)', zip: '207161' },
  { city: 'Gebleşti (Dolj)', zip: '207162' },
  { city: 'Castranova (Dolj)', zip: '207165' },
  { city: 'Puţuri (Dolj)', zip: '207166' },
  { city: 'Călăraşi (Dolj)', zip: '207170' },
  { city: 'Sărata (Dolj)', zip: '207171' },
  { city: 'Celaru (Dolj)', zip: '207175' },
  { city: 'Ghizdăveşti (Dolj)', zip: '207176' },
  { city: 'Marotinu de Jos (Dolj)', zip: '207177' },
  { city: 'Marotinu de Sus (Dolj)', zip: '207178' },
  { city: 'Soreni (Dolj)', zip: '207179' },
  { city: 'Cerăt (Dolj)', zip: '207180' },
  { city: 'Malaica (Dolj)', zip: '207181' },
  { city: 'Cernăteşti (Dolj)', zip: '207185' },
  { city: 'Corniţa (Dolj)', zip: '207186' },
  { city: 'Rasnicu Bătrân (Dolj)', zip: '207187' },
  { city: 'Rasnicu Oghian (Dolj)', zip: '207188' },
  { city: 'Ţiu (Dolj)', zip: '207189' },
  { city: 'Cetate (Dolj)', zip: '207190' },
  { city: 'Moreni (Dolj)', zip: '207191' },
  { city: 'Cioroiaşi (Dolj)', zip: '207195' },
  { city: 'Cetăţuia (Cioroiaşi) (Dolj)', zip: '207196' },
  { city: 'Cioroiu Nou (Dolj)', zip: '207197' },
  { city: 'Ciupercenii Noi (Dolj)', zip: '207200' },
  { city: 'Smârdan (Dolj)', zip: '207201' },
  { city: 'Coşoveni (Dolj)', zip: '207205' },
  { city: 'Cârcea (Dolj)', zip: '207206' },
  { city: 'Coţofenii din Dos (Dolj)', zip: '207210' },
  { city: 'Mihăiţa (Dolj)', zip: '207211' },
  { city: 'Potmelţu (Dolj)', zip: '207212' },
  { city: 'Daneţi (Dolj)', zip: '207215' },
  { city: 'Brabeţi (Dolj)', zip: '207216' },
  { city: 'Branişte (Daneţi) (Dolj)', zip: '207217' },
  { city: 'Locusteni (Dolj)', zip: '207218' },
  { city: 'Dăbuleni (Dolj)', zip: '207220' },
  { city: 'Chiaşu (Dolj)', zip: '207221' },
  { city: 'Desa (Dolj)', zip: '207225' },
  { city: 'Dioşti (Dolj)', zip: '207230' },
  { city: 'Ciocăneşti (Dolj)', zip: '207231' },
  { city: 'Radomir (Dolj)', zip: '207232' },
  { city: 'Dobreşti (Dolj)', zip: '207235' },
  { city: 'Căciulăteşti (Dolj)', zip: '207236' },
  { city: 'Georocel (Dolj)', zip: '207237' },
  { city: 'Murta (Dolj)', zip: '207238' },
  { city: 'Toceni (Dolj)', zip: '207239' },
  { city: 'Drăgoteşti (Dolj)', zip: '207240' },
  { city: 'Beneşti (Dolj)', zip: '207241' },
  { city: 'Bobeanu (Dolj)', zip: '207242' },
  { city: 'Buzduc (Dolj)', zip: '207243' },
  { city: 'Popânzăleşti (Dolj)', zip: '207244' },
  { city: 'Viişoara (Dolj)', zip: '207246' },
  { city: 'Drănic (Dolj)', zip: '207250' },
  { city: 'Booveni (Dolj)', zip: '207251' },
  { city: 'Foişor (Dolj)', zip: '207252' },
  { city: 'Padea (Dolj)', zip: '207253' },
  { city: 'Fărcaş (Dolj)', zip: '207255' },
  { city: 'Amărăşti (Dolj)', zip: '207256' },
  { city: 'Golumbelu (Dolj)', zip: '207257' },
  { city: 'Golumbu (Dolj)', zip: '207258' },
  { city: 'Mofleşti (Dolj)', zip: '207259' },
  { city: 'Nistoi (Dolj)', zip: '207261' },
  { city: 'Plopu-Amărăşti (Dolj)', zip: '207262' },
  { city: 'Puţinei (Dolj)', zip: '207263' },
  { city: 'Soceni (Dolj)', zip: '207264' },
  { city: 'Tălpaş (Dolj)', zip: '207266' },
  { city: 'Galicea Mare (Dolj)', zip: '207270' },
  { city: 'Gângiova (Dolj)', zip: '207275' },
  { city: 'Comoşteni (Dolj)', zip: '207276' },
  { city: 'Gherceşti (Dolj)', zip: '207280' },
  { city: 'Gârleşti (Dolj)', zip: '207281' },
  { city: 'Luncşoru (Dolj)', zip: '207282' },
  { city: 'Ungureni (Dolj)', zip: '207283' },
  { city: 'Ungurenii Mici (Dolj)', zip: '207284' },
  { city: 'Gighera (Dolj)', zip: '207285' },
  { city: 'Nedeia (Dolj)', zip: '207286' },
  { city: 'Zăval (Dolj)', zip: '207287' },
  { city: 'Giubega (Dolj)', zip: '207290' },
  { city: 'Galiciuica (Dolj)', zip: '207291' },
  { city: 'Giurgiţa (Dolj)', zip: '207295' },
  { city: 'Curmătura (Dolj)', zip: '207296' },
  { city: 'Filaret (Dolj)', zip: '207297' },
  { city: 'Gogoşu (Dolj)', zip: '207300' },
  { city: 'Gogoşiţa (Dolj)', zip: '207301' },
  { city: 'Ştefănel (Dolj)', zip: '207302' },
  { city: 'Goicea (Dolj)', zip: '207305' },
  { city: 'Cârna (Dolj)', zip: '207306' },
  { city: 'Goieşti (Dolj)', zip: '207310' },
  { city: 'Adâncata (Dolj)', zip: '207311' },
  { city: 'Fântâni (Dolj)', zip: '207312' },
  { city: 'Gruiţa (Dolj)', zip: '207313' },
  { city: 'Mălăeşti (Dolj)', zip: '207314' },
  { city: 'Mogoşeşti (Dolj)', zip: '207316' },
  { city: 'Muereni (Dolj)', zip: '207317' },
  { city: 'Pioreşti (Dolj)', zip: '207318' },
  { city: 'Pometeşti (Dolj)', zip: '207319' },
  { city: 'Popeasa (Dolj)', zip: '207321' },
  { city: 'Ţandăra (Dolj)', zip: '207322' },
  { city: 'Vladimir (Dolj)', zip: '207323' },
  { city: 'Zlătari (Dolj)', zip: '207324' },
  { city: 'Greceşti (Dolj)', zip: '207330' },
  { city: 'Bărboi (Dolj)', zip: '207331' },
  { city: 'Busu (Dolj)', zip: '207332' },
  { city: 'Busuleţu (Dolj)', zip: '207333' },
  { city: 'Grădiştea (Dolj)', zip: '207334' },
  { city: 'Gropanele (Dolj)', zip: '207336' },
  { city: 'Işalniţa (Dolj)', zip: '207340' },
  { city: 'Izvoare (Dolj)', zip: '207345' },
  { city: 'Corlate (Dolj)', zip: '207346' },
  { city: 'Domnu Tudor (Dolj)', zip: '207347' },
  { city: 'Leu (Dolj)', zip: '207350' },
  { city: 'Zănoaga (Dolj)', zip: '207351' },
  { city: 'Lipovu (Dolj)', zip: '207355' },
  { city: 'Lipovu de Sus (Dolj)', zip: '207356' },
  { city: 'Maglavit (Dolj)', zip: '207360' },
  { city: 'Hunia (Dolj)', zip: '207361' },
  { city: 'Malu Mare (Dolj)', zip: '207365' },
  { city: 'Ghindeni (Dolj)', zip: '207366' },
  { city: 'Preajba (Dolj)', zip: '207367' },
  { city: 'Măceşu de Jos (Dolj)', zip: '207370' },
  { city: 'Săpata (Dolj)', zip: '207371' },
  { city: 'Măceşu de Sus (Dolj)', zip: '207375' },
  { city: 'Mârşani (Dolj)', zip: '207380' },
  { city: 'Melineşti (Dolj)', zip: '207385' },
  { city: 'Bodăieşti (Dolj)', zip: '207386' },
  { city: 'Bodăieştii de Sus (Dolj)', zip: '207387' },
  { city: 'Godeni (Dolj)', zip: '207388' },
  { city: 'Muieruşu (Dolj)', zip: '207389' },
  { city: 'Negoieşti (Dolj)', zip: '207391' },
  { city: 'Odoleni (Dolj)', zip: '207392' },
  { city: 'Ohaba (Dolj)', zip: '207393' },
  { city: 'Ploştina (Dolj)', zip: '207394' },
  { city: 'Popeşti (Dolj)', zip: '207396' },
  { city: 'Spineni (Dolj)', zip: '207397' },
  { city: 'Valea Mare (Dolj)', zip: '207398' },
  { city: 'Valea Muierii de Jos (Dolj)', zip: '207399' },
  { city: 'Mischii (Dolj)', zip: '207405' },
  { city: 'Călineşti (Dolj)', zip: '207406' },
  { city: 'Gogoşeşti (Dolj)', zip: '207407' },
  { city: 'Mlecăneşti (Dolj)', zip: '207408' },
  { city: 'Motoci (Dolj)', zip: '207409' },
  { city: 'Urecheşti (Dolj)', zip: '207411' },
  { city: 'Moţăţei (Dolj)', zip: '207415' },
  { city: 'Dobridor (Dolj)', zip: '207416' },
  { city: 'Moţăţei-Gară (Dolj)', zip: '207417' },
  { city: 'Murgaşi (Dolj)', zip: '207420' },
  { city: 'Balota de Jos (Dolj)', zip: '207421' },
  { city: 'Balota de Sus (Dolj)', zip: '207422' },
  { city: 'Buşteni (Dolj)', zip: '207423' },
  { city: 'Gaia (Dolj)', zip: '207424' },
  { city: 'Picăturile (Dolj)', zip: '207426' },
  { city: 'Rupturile (Dolj)', zip: '207427' },
  { city: 'Veleşti (Dolj)', zip: '207428' },
  { city: 'Negoi (Dolj)', zip: '207430' },
  { city: 'Catane (Dolj)', zip: '207431' },
  { city: 'Catanele Noi (Dolj)', zip: '207432' },
  { city: 'Orodel (Dolj)', zip: '207435' },
  { city: 'Bechet (Orodel) (Dolj)', zip: '207436' },
  { city: 'Călugărei (Dolj)', zip: '207437' },
  { city: 'Cornu (Dolj)', zip: '207438' },
  { city: 'Teiu (Dolj)', zip: '207439' },
  { city: 'Ostroveni (Dolj)', zip: '207440' },
  { city: 'Lişteava (Dolj)', zip: '207441' },
  { city: 'Perişor (Dolj)', zip: '207445' },
  { city: 'Mărăcinele (Dolj)', zip: '207446' },
  { city: 'Pieleşti (Dolj)', zip: '207450' },
  { city: 'Câmpeni (Dolj)', zip: '207451' },
  { city: 'Lânga (Dolj)', zip: '207452' },
  { city: 'Piscu Vechi (Dolj)', zip: '207455' },
  { city: 'Ghidici (Dolj)', zip: '207456' },
  { city: 'Pisculeţ (Dolj)', zip: '207457' },
  { city: 'Pleniţa (Dolj)', zip: '207460' },
  { city: 'Castrele Traiane (Dolj)', zip: '207461' },
  { city: 'Podari (Dolj)', zip: '207465' },
  { city: 'Balta Verde (Dolj)', zip: '207466' },
  { city: 'Branişte (Podari) (Dolj)', zip: '207467' },
  { city: 'Gura Văii (Dolj)', zip: '207468' },
  { city: 'Livezi (Dolj)', zip: '207469' },
  { city: 'Poiana Mare (Dolj)', zip: '207470' },
  { city: 'Tunarii Noi (Dolj)', zip: '207471' },
  { city: 'Tunarii Vechi (Dolj)', zip: '207472' },
  { city: 'Predeşti (Dolj)', zip: '207475' },
  { city: 'Bucicani (Dolj)', zip: '207476' },
  { city: 'Cârstovani (Dolj)', zip: '207477' },
  { city: 'Frasin (Dolj)', zip: '207478' },
  { city: 'Milovan (Dolj)', zip: '207479' },
  { city: 'Pleşoi (Dolj)', zip: '207481' },
  { city: 'Predeştii Mici (Dolj)', zip: '207482' },
  { city: 'Radovan (Dolj)', zip: '207485' },
  { city: 'Fântânele (Radovan) (Dolj)', zip: '207486' },
  { city: 'Întorsura (Dolj)', zip: '207487' },
  { city: 'Târnava (Dolj)', zip: '207488' },
  { city: 'Rast (Dolj)', zip: '207490' },
  { city: 'Robăneşti (Dolj)', zip: '207495' },
  { city: 'Bojoiu (Dolj)', zip: '207496' },
  { city: 'Golfin (Dolj)', zip: '207497' },
  { city: 'Lăcriţa Mare (Dolj)', zip: '207498' },
  { city: 'Lăcriţa Mică (Dolj)', zip: '207499' },
  { city: 'Robăneştii de Jos (Dolj)', zip: '207501' },
  { city: 'Robăneştii de Sus (Dolj)', zip: '207502' },
  { city: 'Sadova (Dolj)', zip: '207505' },
  { city: 'Piscu Sadovei (Dolj)', zip: '207506' },
  { city: 'Sălcuţa (Dolj)', zip: '207510' },
  { city: 'Mârza (Dolj)', zip: '207511' },
  { city: 'Plopşor (Dolj)', zip: '207512' },
  { city: 'Tencănău (Dolj)', zip: '207513' },
  { city: 'Scăeşti (Dolj)', zip: '207515' },
  { city: 'Valea lui Pătru (Dolj)', zip: '207516' },
  { city: 'Seaca de Câmp (Dolj)', zip: '207520' },
  { city: 'Piscu Nou (Dolj)', zip: '207521' },
  { city: 'Seaca de Pădure (Dolj)', zip: '207525' },
  { city: 'Răchita de Sus (Dolj)', zip: '207526' },
  { city: 'Veleni (Dolj)', zip: '207527' },
  { city: 'Secu (Dolj)', zip: '207530' },
  { city: 'Comănicea (Dolj)', zip: '207531' },
  { city: 'Smadovicioara de Secu (Dolj)', zip: '207532' },
  { city: 'Şumandra (Dolj)', zip: '207533' },
  { city: 'Siliştea Crucii (Dolj)', zip: '207535' },
  { city: 'Sopot (Dolj)', zip: '207540' },
  { city: 'Başcov (Dolj)', zip: '207541' },
  { city: 'Beloţ (Dolj)', zip: '207542' },
  { city: 'Cernat (Dolj)', zip: '207543' },
  { city: 'Pereni (Dolj)', zip: '207544' },
  { city: 'Pietroaia (Dolj)', zip: '207546' },
  { city: 'Sârsca (Dolj)', zip: '207547' },
  { city: 'Şimnicu de Sus (Dolj)', zip: '207550' },
  { city: 'Albeşti (Dolj)', zip: '207551' },
  { city: 'Cornetu (Dolj)', zip: '207552' },
  { city: 'Deleni (Dolj)', zip: '207553' },
  { city: 'Dudoviceşti (Dolj)', zip: '207554' },
  { city: 'Duţuleşti (Dolj)', zip: '207556' },
  { city: 'Floreşti (Dolj)', zip: '207557' },
  { city: 'Izvor (Dolj)', zip: '207558' },
  { city: 'Jieni (Dolj)', zip: '207559' },
  { city: 'Leşile (Dolj)', zip: '207561' },
  { city: 'Mileşti (Dolj)', zip: '207562' },
  { city: 'Româneşti (Dolj)', zip: '207563' },
  { city: 'Teasc (Dolj)', zip: '207570' },
  { city: 'Secui (Dolj)', zip: '207571' },
  { city: 'Terpeziţa (Dolj)', zip: '207575' },
  { city: 'Căciulatu (Dolj)', zip: '207576' },
  { city: 'Căruia (Dolj)', zip: '207577' },
  { city: 'Floran (Dolj)', zip: '207578' },
  { city: 'Lazu (Dolj)', zip: '207579' },
  { city: 'Teslui (Dolj)', zip: '207580' },
  { city: 'Coşereni (Dolj)', zip: '207581' },
  { city: 'Fântânele (Teslui) (Dolj)', zip: '207582' },
  { city: 'Preajba de Jos (Dolj)', zip: '207583' },
  { city: 'Preajba de Pădure (Dolj)', zip: '207584' },
  { city: 'Ţărţăl (Dolj)', zip: '207586' },
  { city: 'Urieni (Dolj)', zip: '207587' },
  { city: 'Viişoara-Moşneni (Dolj)', zip: '207588' },
  { city: 'Ţuglui (Dolj)', zip: '207590' },
  { city: 'Jiul (Dolj)', zip: '207591' },
  { city: 'Unirea (Dolj)', zip: '207595' },
  { city: 'Urzicuţa (Dolj)', zip: '207600' },
  { city: 'Urzica Mare (Dolj)', zip: '207601' },
  { city: 'Valea Stanciului (Dolj)', zip: '207605' },
  { city: 'Horezu-Poenari (Dolj)', zip: '207606' },
  { city: 'Vârtop (Dolj)', zip: '207610' },
  { city: 'Vârvoru de Jos (Dolj)', zip: '207615' },
  { city: 'Bujor (Dolj)', zip: '207616' },
  { city: 'Ciutura (Dolj)', zip: '207617' },
  { city: 'Criva (Dolj)', zip: '207618' },
  { city: 'Dobromira (Dolj)', zip: '207619' },
  { city: 'Drăgoaia (Dolj)', zip: '207621' },
  { city: 'Gabru (Dolj)', zip: '207622' },
  { city: 'Vârvor (Dolj)', zip: '207623' },
  { city: 'Vela (Dolj)', zip: '207625' },
  { city: 'Bucovicior (Dolj)', zip: '207626' },
  { city: 'Cetăţuia (Vela) (Dolj)', zip: '207627' },
  { city: 'Desnăţui (Dolj)', zip: '207628' },
  { city: 'Gubaucea (Dolj)', zip: '207629' },
  { city: 'Segleţ (Dolj)', zip: '207631' },
  { city: 'Suharu (Dolj)', zip: '207632' },
  { city: 'Ştiubei (Dolj)', zip: '207633' },
  { city: 'Verbiţa (Dolj)', zip: '207635' },
  { city: 'Verbicioara (Dolj)', zip: '207636' },
  { city: 'Galaţi (Galaţi)', zip: '800001' },
  { city: 'Bereşti (Galaţi)', zip: '805100' },
  { city: 'Târgu Bujor (Galaţi)', zip: '805200' },
  { city: 'Moscu (Galaţi)', zip: '805201' },
  { city: 'Umbrăreşti (Târgu Bujor) (Galaţi)', zip: '805202' },
  { city: 'Tecuci (Galaţi)', zip: '805300' },
  { city: 'Barcea (Galaţi)', zip: '807005' },
  { city: 'Podoleni (Galaţi)', zip: '807006' },
  { city: 'Bălăbăneşti (Galaţi)', zip: '807010' },
  { city: 'Bursucani (Galaţi)', zip: '807011' },
  { city: 'Cruceanu (Galaţi)', zip: '807012' },
  { city: 'Lungeşti (Galaţi)', zip: '807013' },
  { city: 'Rădeşti (Galaţi)', zip: '807014' },
  { city: 'Zimbru (Galaţi)', zip: '807016' },
  { city: 'Bălăşeşti (Galaţi)', zip: '807020' },
  { city: 'Ciureşti (Galaţi)', zip: '807021' },
  { city: 'Ciureştii Noi (Galaţi)', zip: '807022' },
  { city: 'Pupezeni (Galaţi)', zip: '807023' },
  { city: 'Băleni (Galaţi)', zip: '807025' },
  { city: 'Băneasa (Galaţi)', zip: '807030' },
  { city: 'Roşcani (Galaţi)', zip: '807031' },
  { city: 'Bereşti-Meria (Galaţi)', zip: '807035' },
  { city: 'Aldeşti (Galaţi)', zip: '807036' },
  { city: 'Balinteşti (Galaţi)', zip: '807037' },
  { city: 'Onciu (Galaţi)', zip: '807038' },
  { city: 'Pleşa (Galaţi)', zip: '807039' },
  { city: 'Prodăneşti (Galaţi)', zip: '807041' },
  { city: 'Puricani (Galaţi)', zip: '807042' },
  { city: 'Săseni (Galaţi)', zip: '807043' },
  { city: 'Slivna (Galaţi)', zip: '807044' },
  { city: 'Şipote (Galaţi)', zip: '807046' },
  { city: 'Braniştea (Galaţi)', zip: '807050' },
  { city: 'Lozova (Galaţi)', zip: '807051' },
  { city: 'Traian (Galaţi)', zip: '807052' },
  { city: 'Vasile Alecsandri (Galaţi)', zip: '807053' },
  { city: 'Brăhăşeşti (Galaţi)', zip: '807055' },
  { city: 'Corcioveni (Galaţi)', zip: '807056' },
  { city: 'Cosiţeni (Galaţi)', zip: '807057' },
  { city: 'Toflea (Galaţi)', zip: '807058' },
  { city: 'Buciumeni (Galaţi)', zip: '807060' },
  { city: 'Hănţeşti (Galaţi)', zip: '807061' },
  { city: 'Tecucelu Sec (Galaţi)', zip: '807062' },
  { city: 'Vizureşti (Galaţi)', zip: '807063' },
  { city: 'Cavadineşti (Galaţi)', zip: '807065' },
  { city: 'Comăneşti (Galaţi)', zip: '807066' },
  { city: 'Găneşti (Galaţi)', zip: '807067' },
  { city: 'Vădeni (Galaţi)', zip: '807068' },
  { city: 'Cerţeşti (Galaţi)', zip: '807070' },
  { city: 'Cârlomăneşti (Galaţi)', zip: '807071' },
  { city: 'Cotoroaia (Galaţi)', zip: '807072' },
  { city: 'Corni (Galaţi)', zip: '807075' },
  { city: 'Măcişeni (Galaţi)', zip: '807076' },
  { city: 'Urleşti (Galaţi)', zip: '807077' },
  { city: 'Corod (Galaţi)', zip: '807080' },
  { city: 'Blânzi (Galaţi)', zip: '807081' },
  { city: 'Brătuleşti (Galaţi)', zip: '807082' },
  { city: 'Cărăpceşti (Galaţi)', zip: '807083' },
  { city: 'Cosmeşti (Galaţi)', zip: '807085' },
  { city: 'Băltăreţi (Galaţi)', zip: '807086' },
  { city: 'Cosmeştii-Vale (Galaţi)', zip: '807087' },
  { city: 'Furcenii Noi (Galaţi)', zip: '807088' },
  { city: 'Furcenii Vechi (Galaţi)', zip: '807089' },
  { city: 'Satu Nou (Galaţi)', zip: '807091' },
  { city: 'Costache Negri (Galaţi)', zip: '807095' },
  { city: 'Cuca (Galaţi)', zip: '807100' },
  { city: 'Cudalbi (Galaţi)', zip: '807105' },
  { city: 'Drăgăneşti (Galaţi)', zip: '807110' },
  { city: 'Malu Alb (Galaţi)', zip: '807111' },
  { city: 'Drăguşeni (Galaţi)', zip: '807115' },
  { city: 'Adam (Galaţi)', zip: '807116' },
  { city: 'Căuieşti (Galaţi)', zip: '807117' },
  { city: 'Fundeanu (Galaţi)', zip: '807118' },
  { city: 'Ghingheşti (Galaţi)', zip: '807119' },
  { city: 'Nicopole (Galaţi)', zip: '807121' },
  { city: 'Ştieţeşti (Galaţi)', zip: '807122' },
  { city: 'Fârţăneşti (Galaţi)', zip: '807125' },
  { city: 'Viile (Galaţi)', zip: '807126' },
  { city: 'Folteşti (Galaţi)', zip: '807130' },
  { city: 'Stoicani (Galaţi)', zip: '807131' },
  { city: 'Frumuşiţa (Galaţi)', zip: '807135' },
  { city: 'Ijdileni (Galaţi)', zip: '807136' },
  { city: 'Tămăoani (Galaţi)', zip: '807137' },
  { city: 'Fundeni (Galaţi)', zip: '807140' },
  { city: 'Fundenii Noi (Galaţi)', zip: '807141' },
  { city: 'Hanu Conachi (Galaţi)', zip: '807142' },
  { city: 'Lungoci (Galaţi)', zip: '807143' },
  { city: 'Ghidigeni (Galaţi)', zip: '807145' },
  { city: 'Gara Ghidigeni (Galaţi)', zip: '807146' },
  { city: 'Gârbovăţ (Galaţi)', zip: '807147' },
  { city: 'Gefu (Galaţi)', zip: '807148' },
  { city: 'Gura Gârbovăţului (Galaţi)', zip: '807149' },
  { city: 'Slobozia Corni (Galaţi)', zip: '807151' },
  { city: 'Tălpigi (Galaţi)', zip: '807152' },
  { city: 'Tăplău (Galaţi)', zip: '807153' },
  { city: 'Gohor (Galaţi)', zip: '807155' },
  { city: 'Gara Berheci (Galaţi)', zip: '807156' },
  { city: 'Ireasca (Galaţi)', zip: '807157' },
  { city: 'Nărteşti (Galaţi)', zip: '807158' },
  { city: 'Poşta (Galaţi)', zip: '807159' },
  { city: 'Griviţa (Galaţi)', zip: '807160' },
  { city: 'Călmăţui (Galaţi)', zip: '807161' },
  { city: 'Independenţa (Galaţi)', zip: '807165' },
  { city: 'Iveşti (Galaţi)', zip: '807170' },
  { city: 'Buceşti (Galaţi)', zip: '807171' },
  { city: 'Jorăşti (Galaţi)', zip: '807175' },
  { city: 'Lunca (Galaţi)', zip: '807176' },
  { city: 'Zărneşti (Galaţi)', zip: '807177' },
  { city: 'Lieşti (Galaţi)', zip: '807180' },
  { city: 'Matca (Galaţi)', zip: '807185' },
  { city: 'Măstăcani (Galaţi)', zip: '807190' },
  { city: 'Chiraftei (Galaţi)', zip: '807191' },
  { city: 'Movileni (Galaţi)', zip: '807195' },
  { city: 'Munteni (Galaţi)', zip: '807200' },
  { city: 'Frunzeasca (Galaţi)', zip: '807201' },
  { city: 'Negrileşti (Galaţi)', zip: '807202' },
  { city: 'Slobozia Blăneasa (Galaţi)', zip: '807203' },
  { city: 'Ţigăneşti (Galaţi)', zip: '807204' },
  { city: 'Ungureni (Galaţi)', zip: '807206' },
  { city: 'Nămoloasa (Galaţi)', zip: '807210' },
  { city: 'Crângeni (Galaţi)', zip: '807211' },
  { city: 'Nămoloasa-Sat (Galaţi)', zip: '807212' },
  { city: 'Nicoreşti (Galaţi)', zip: '807215' },
  { city: 'Braniştea (Nicoreşti) (Galaţi)', zip: '807216' },
  { city: 'Coasta Lupei (Galaţi)', zip: '807217' },
  { city: 'Dobrineşti (Galaţi)', zip: '807218' },
  { city: 'Fântâni (Galaţi)', zip: '807219' },
  { city: 'Grozăveşti (Galaţi)', zip: '807221' },
  { city: 'Ionăşeşti (Galaţi)', zip: '807222' },
  { city: 'Mălureni (Galaţi)', zip: '807223' },
  { city: 'Piscu Corbului (Galaţi)', zip: '807224' },
  { city: 'Poiana (Galaţi)', zip: '807226' },
  { city: 'Sârbi (Galaţi)', zip: '807227' },
  { city: 'Vişina (Galaţi)', zip: '807228' },
  { city: 'Oancea (Galaţi)', zip: '807235' },
  { city: 'Slobozia Oancea (Galaţi)', zip: '807236' },
  { city: 'Pechea (Galaţi)', zip: '807240' },
  { city: 'Lupele (Galaţi)', zip: '807241' },
  { city: 'Piscu (Galaţi)', zip: '807245' },
  { city: 'Vameş (Galaţi)', zip: '807246' },
  { city: 'Priponeşti (Galaţi)', zip: '807250' },
  { city: 'Ciorăşti (Galaţi)', zip: '807251' },
  { city: 'Huştiu (Galaţi)', zip: '807252' },
  { city: 'Lieşti (Priponeşti) (Galaţi)', zip: '807253' },
  { city: 'Priponeştii de Jos (Galaţi)', zip: '807254' },
  { city: 'Rediu (Galaţi)', zip: '807255' },
  { city: 'Plevna (Galaţi)', zip: '807256' },
  { city: 'Suhurlui (Galaţi)', zip: '807257' },
  { city: 'Scânteieşti (Galaţi)', zip: '807260' },
  { city: 'Fântânele (Galaţi)', zip: '807261' },
  { city: 'Schela (Galaţi)', zip: '807265' },
  { city: 'Negrea (Galaţi)', zip: '807266' },
  { city: 'Slobozia Conachi (Galaţi)', zip: '807270' },
  { city: 'Cuza Vodă (Galaţi)', zip: '807271' },
  { city: 'Izvoarele (Galaţi)', zip: '807272' },
  { city: 'Smârdan (Galaţi)', zip: '807275' },
  { city: 'Cişmele (Galaţi)', zip: '807276' },
  { city: 'Mihail Kogălniceanu (Galaţi)', zip: '807277' },
  { city: 'Smulţi (Galaţi)', zip: '807280' },
  { city: 'Suceveni (Galaţi)', zip: '807285' },
  { city: 'Rogojeni (Galaţi)', zip: '807286' },
  { city: 'Şendreni (Galaţi)', zip: '807290' },
  { city: 'Movileni (Şendreni) (Galaţi)', zip: '807291' },
  { city: 'Şerbeştii Vechi (Galaţi)', zip: '807292' },
  { city: 'Tudor Vladimirescu (Galaţi)', zip: '807295' },
  { city: 'Tuluceşti (Galaţi)', zip: '807300' },
  { city: 'Şiviţa (Galaţi)', zip: '807301' },
  { city: 'Tătarca (Galaţi)', zip: '807302' },
  { city: 'Ţepu (Galaţi)', zip: '807305' },
  { city: 'Ţepu de Sus (Galaţi)', zip: '807306' },
  { city: 'Umbrăreşti (Galaţi)', zip: '807310' },
  { city: 'Condrea (Galaţi)', zip: '807311' },
  { city: 'Salcia (Galaţi)', zip: '807312' },
  { city: 'Siliştea (Galaţi)', zip: '807313' },
  { city: 'Torceşti (Galaţi)', zip: '807314' },
  { city: 'Umbrăreşti-Deal (Galaţi)', zip: '807316' },
  { city: 'Valea Mărului (Galaţi)', zip: '807320' },
  { city: 'Mândreşti (Galaţi)', zip: '807321' },
  { city: 'Vânători (Galaţi)', zip: '807325' },
  { city: 'Costi (Galaţi)', zip: '807326' },
  { city: 'Odaia Manolache (Galaţi)', zip: '807327' },
  { city: 'Vârlezi (Galaţi)', zip: '807330' },
  { city: 'Crăieşti (Galaţi)', zip: '807331' },
  { city: 'Vlădeşti (Galaţi)', zip: '807335' },
  { city: 'Brăneşti (Galaţi)', zip: '807336' },
  { city: 'Bârseşti (Gorj)', zip: '210001' },
  { city: 'Drăgoeni (Gorj)', zip: '210002' },
  { city: 'Iezureni (Gorj)', zip: '210003' },
  { city: 'Polata (Gorj)', zip: '210004' },
  { city: 'Preajba Mare (Gorj)', zip: '210005' },
  { city: 'Romaneşti (Gorj)', zip: '210006' },
  { city: 'Slobozia (Gorj)', zip: '210007' },
  { city: 'Ursaţi (Gorj)', zip: '210008' },
  { city: 'Târgu Jiu (Gorj)', zip: '210101' },
  { city: 'Bumbeşti-Jiu (Gorj)', zip: '215100' },
  { city: 'Curtişoara (Gorj)', zip: '215101' },
  { city: 'Lăzăreşti (Gorj)', zip: '215102' },
  { city: 'Pleşa (Gorj)', zip: '215103' },
  { city: 'Tetila (Gorj)', zip: '215104' },
  { city: 'Motru (Gorj)', zip: '215200' },
  { city: 'Dealu Pomilor (Gorj)', zip: '215201' },
  { city: 'Horăşti (Gorj)', zip: '215202' },
  { city: 'Însurăţei (Gorj)', zip: '215203' },
  { city: 'Leurda (Gorj)', zip: '215204' },
  { city: 'Lupoiţa (Gorj)', zip: '215205' },
  { city: 'Ploştina (Gorj)', zip: '215206' },
  { city: 'Râpa (Gorj)', zip: '215207' },
  { city: 'Roşiuţa (Gorj)', zip: '215208' },
  { city: 'Novaci (Gorj)', zip: '215300' },
  { city: 'Berceşti (Gorj)', zip: '215301' },
  { city: 'Hirişeşti (Gorj)', zip: '215302' },
  { city: 'Pociovaliştea (Gorj)', zip: '215303' },
  { city: 'Siteşti (Gorj)', zip: '215304' },
  { city: 'Rovinari (Gorj)', zip: '215400' },
  { city: 'Târgu Cărbuneşti (Gorj)', zip: '215500' },
  { city: 'Blahniţa de Jos (Gorj)', zip: '215501' },
  { city: 'Cărbuneşti-Sat (Gorj)', zip: '215502' },
  { city: 'Cojani (Gorj)', zip: '215503' },
  { city: 'Creţeşti (Gorj)', zip: '215504' },
  { city: 'Curteana (Gorj)', zip: '215505' },
  { city: 'Floreşteni (Gorj)', zip: '215506' },
  { city: 'Măceşu (Gorj)', zip: '215507' },
  { city: 'Pojogeni (Gorj)', zip: '215508' },
  { city: 'Rogojeni (Gorj)', zip: '215509' },
  { city: 'Ştefăneşti (Gorj)', zip: '215510' },
  { city: 'Ţicleni (Gorj)', zip: '215600' },
  { city: 'Albeni (Gorj)', zip: '217005' },
  { city: 'Bârzeiu de Gilort (Gorj)', zip: '217006' },
  { city: 'Bolboceşti (Gorj)', zip: '217007' },
  { city: 'Doseni (Gorj)', zip: '217008' },
  { city: 'Mirosloveni (Gorj)', zip: '217009' },
  { city: 'Pruneşti (Gorj)', zip: '217011' },
  { city: 'Alimpeşti (Gorj)', zip: '217015' },
  { city: 'Ciupercenii de Olteţ (Gorj)', zip: '217016' },
  { city: 'Corşoru (Gorj)', zip: '217017' },
  { city: 'Nistoreşti (Gorj)', zip: '217018' },
  { city: 'Sârbeşti (Gorj)', zip: '217019' },
  { city: 'Aninoasa (Gorj)', zip: '217020' },
  { city: 'Bobaia (Gorj)', zip: '217021' },
  { city: 'Costeşti (Gorj)', zip: '217022' },
  { city: 'Groşerea (Gorj)', zip: '217023' },
  { city: 'Sterpoaia (Gorj)', zip: '217024' },
  { city: 'Arcani (Gorj)', zip: '217025' },
  { city: 'Câmpofeni (Gorj)', zip: '217026' },
  { city: 'Sănăteşti (Gorj)', zip: '217027' },
  { city: 'Stroieşti (Gorj)', zip: '217028' },
  { city: 'Baia de Fier (Gorj)', zip: '217030' },
  { city: 'Cernădia (Gorj)', zip: '217031' },
  { city: 'Voiteştii din Vale (Gorj)', zip: '217035' },
  { city: 'Bălăneşti (Gorj)', zip: '217036' },
  { city: 'Blidari (Gorj)', zip: '217037' },
  { city: 'Cânepeşti (Gorj)', zip: '217038' },
  { city: 'Glodeni (Gorj)', zip: '217039' },
  { city: 'Ohaba (Gorj)', zip: '217041' },
  { city: 'Voiteştii din Deal (Gorj)', zip: '217042' },
  { city: 'Băleşti (Gorj)', zip: '217045' },
  { city: 'Ceauru (Gorj)', zip: '217046' },
  { city: 'Corneşti (Gorj)', zip: '217047' },
  { city: 'Găvăneşti (Gorj)', zip: '217048' },
  { city: 'Rasova (Gorj)', zip: '217049' },
  { city: 'Stolojani (Gorj)', zip: '217051' },
  { city: 'Tălpăşeşti (Gorj)', zip: '217052' },
  { city: 'Tămăşeşti (Gorj)', zip: '217053' },
  { city: 'Voinigeşti (Gorj)', zip: '217054' },
  { city: 'Bărbăteşti (Gorj)', zip: '217055' },
  { city: 'Musculeşti (Gorj)', zip: '217056' },
  { city: 'Petreşti (Gorj)', zip: '217057' },
  { city: 'Socu (Gorj)', zip: '217058' },
  { city: 'Bâlteni (Gorj)', zip: '217060' },
  { city: 'Cocoreni (Gorj)', zip: '217061' },
  { city: 'Moi (Gorj)', zip: '217062' },
  { city: 'Peşteana-Jiu (Gorj)', zip: '217063' },
  { city: 'Vlăduleni (Gorj)', zip: '217064' },
  { city: 'Bengeşti-Ciocadia (Gorj)', zip: '217065' },
  { city: 'Bălceşti (Gorj)', zip: '217066' },
  { city: 'Bengeşti (Gorj)', zip: '217067' },
  { city: 'Bircii (Gorj)', zip: '217068' },
  { city: 'Ciocadia (Gorj)', zip: '217069' },
  { city: 'Berleşti (Gorj)', zip: '217070' },
  { city: 'Bârzeiu (Gorj)', zip: '217071' },
  { city: 'Gâlceşti (Gorj)', zip: '217072' },
  { city: 'Lihuleşti (Gorj)', zip: '217073' },
  { city: 'Pârâu Viu (Gorj)', zip: '217074' },
  { city: 'Scrada (Gorj)', zip: '217076' },
  { city: 'Scurtu (Gorj)', zip: '217077' },
  { city: 'Bolboşi (Gorj)', zip: '217080' },
  { city: 'Bălăceşti (Gorj)', zip: '217081' },
  { city: 'Bolboasa (Gorj)', zip: '217082' },
  { city: 'Igirosu (Gorj)', zip: '217083' },
  { city: 'Miclosu (Gorj)', zip: '217084' },
  { city: 'Ohaba-Jiu (Gorj)', zip: '217086' },
  { city: 'Valea (Gorj)', zip: '217087' },
  { city: 'Borăscu (Gorj)', zip: '217090' },
  { city: 'Baniu (Gorj)', zip: '217091' },
  { city: 'Calapăru (Gorj)', zip: '217092' },
  { city: 'Gura-Menţi (Gorj)', zip: '217093' },
  { city: 'Menţii din Dos (Gorj)', zip: '217094' },
  { city: 'Miluta (Gorj)', zip: '217096' },
  { city: 'Scoruşu (Gorj)', zip: '217097' },
  { city: 'Brăneşti (Gorj)', zip: '217100' },
  { city: 'Bădeşti (Gorj)', zip: '217101' },
  { city: 'Brebenei (Gorj)', zip: '217102' },
  { city: 'Capu Dealului (Gorj)', zip: '217103' },
  { city: 'Gilortu (Gorj)', zip: '217104' },
  { city: 'Pârâu (Gorj)', zip: '217106' },
  { city: 'Bumbeşti-Piţic (Gorj)', zip: '217110' },
  { city: 'Cârligei (Gorj)', zip: '217111' },
  { city: 'Poienari (Gorj)', zip: '217112' },
  { city: 'Bustuchin (Gorj)', zip: '217115' },
  { city: 'Cionţi (Gorj)', zip: '217116' },
  { city: 'Motorgi (Gorj)', zip: '217117' },
  { city: 'Nămete (Gorj)', zip: '217118' },
  { city: 'Poiana-Seciuri (Gorj)', zip: '217119' },
  { city: 'Poieniţa (Gorj)', zip: '217121' },
  { city: 'Pojaru (Gorj)', zip: '217122' },
  { city: 'Valea Pojarului (Gorj)', zip: '217123' },
  { city: 'Căpreni (Gorj)', zip: '217125' },
  { city: 'Aluniş (Gorj)', zip: '217126' },
  { city: 'Brăteşti (Gorj)', zip: '217127' },
  { city: 'Bulbuceni (Gorj)', zip: '217128' },
  { city: 'Cetatea (Gorj)', zip: '217129' },
  { city: 'Cornetu (Gorj)', zip: '217131' },
  { city: 'Dealu Spirei (Gorj)', zip: '217132' },
  { city: 'Satu Nou (Gorj)', zip: '217133' },
  { city: 'Cătunele (Gorj)', zip: '217135' },
  { city: 'Dealu Viilor (Gorj)', zip: '217136' },
  { city: 'Lupoaia (Gorj)', zip: '217137' },
  { city: 'Steic (Gorj)', zip: '217138' },
  { city: 'Valea Mânăstirii (Gorj)', zip: '217139' },
  { city: 'Valea Perilor (Gorj)', zip: '217141' },
  { city: 'Câlnic (Gorj)', zip: '217145' },
  { city: 'Câlnicu de Sus (Gorj)', zip: '217146' },
  { city: 'Didileşti (Gorj)', zip: '217147' },
  { city: 'Găleşoaia (Gorj)', zip: '217148' },
  { city: 'Hodoreasca (Gorj)', zip: '217149' },
  { city: 'Pieptani (Gorj)', zip: '217151' },
  { city: 'Pinoasa (Gorj)', zip: '217152' },
  { city: 'Stejerei (Gorj)', zip: '217153' },
  { city: 'Vâlceaua (Gorj)', zip: '217154' },
  { city: 'Ciuperceni (Gorj)', zip: '217155' },
  { city: 'Boboieşti (Gorj)', zip: '217156' },
  { city: 'Peşteana-Vulcan (Gorj)', zip: '217157' },
  { city: 'Priporu (Gorj)', zip: '217158' },
  { city: 'Strâmba-Vulcan (Gorj)', zip: '217159' },
  { city: 'Vârtopu (Gorj)', zip: '217161' },
  { city: 'Zorzila (Gorj)', zip: '217162' },
  { city: 'Crasna (Gorj)', zip: '217165' },
  { city: 'Aninişu din Deal (Gorj)', zip: '217166' },
  { city: 'Aninişu din Vale (Gorj)', zip: '217167' },
  { city: 'Buzeşti (Gorj)', zip: '217168' },
  { city: 'Cărpiniş (Gorj)', zip: '217169' },
  { city: 'Crasna din Deal (Gorj)', zip: '217171' },
  { city: 'Drăgoieşti (Gorj)', zip: '217172' },
  { city: 'Dumbrăveni (Gorj)', zip: '217173' },
  { city: 'Radoşi (Gorj)', zip: '217174' },
  { city: 'Cruşeţ (Gorj)', zip: '217175' },
  { city: 'Bojinu (Gorj)', zip: '217176' },
  { city: 'Marineşti (Gorj)', zip: '217177' },
  { city: 'Măiag (Gorj)', zip: '217178' },
  { city: 'Mierea (Gorj)', zip: '217179' },
  { city: 'Miericeaua (Gorj)', zip: '217181' },
  { city: 'Slămneşti (Gorj)', zip: '217182' },
  { city: 'Slăvuţa (Gorj)', zip: '217183' },
  { city: 'Urda de Jos (Gorj)', zip: '217184' },
  { city: 'Văluţa (Gorj)', zip: '217186' },
  { city: 'Dănciuleşti (Gorj)', zip: '217190' },
  { city: 'Bibuleşti (Gorj)', zip: '217191' },
  { city: 'Hălăngeşti (Gorj)', zip: '217192' },
  { city: 'Obârşia (Gorj)', zip: '217193' },
  { city: 'Petrăchei (Gorj)', zip: '217194' },
  { city: 'Rădineşti (Gorj)', zip: '217196' },
  { city: 'Zăicoiu (Gorj)', zip: '217197' },
  { city: 'Dăneşti (Gorj)', zip: '217200' },
  { city: 'Barza (Gorj)', zip: '217201' },
  { city: 'Botorogi (Gorj)', zip: '217202' },
  { city: 'Brătuia (Gorj)', zip: '217203' },
  { city: 'Bucureasa (Gorj)', zip: '217204' },
  { city: 'Merfuleşti (Gorj)', zip: '217206' },
  { city: 'Şasa (Gorj)', zip: '217207' },
  { city: 'Trocani (Gorj)', zip: '217208' },
  { city: 'Ţârculeşti (Gorj)', zip: '217209' },
  { city: 'Ungureni (Gorj)', zip: '217211' },
  { city: 'Văcarea (Gorj)', zip: '217212' },
  { city: 'Drăgoteşti (Gorj)', zip: '217220' },
  { city: 'Corobăi (Gorj)', zip: '217221' },
  { city: 'Trestioara (Gorj)', zip: '217222' },
  { city: 'Drăguţeşti (Gorj)', zip: '217225' },
  { city: 'Cârbeşti (Gorj)', zip: '217226' },
  { city: 'Dâmbova (Gorj)', zip: '217227' },
  { city: 'Iaşi-Gorj (Gorj)', zip: '217228' },
  { city: 'Tâlveşti (Gorj)', zip: '217229' },
  { city: 'Urecheşti (Gorj)', zip: '217231' },
  { city: 'Fărcăşeşti (Gorj)', zip: '217235' },
  { city: 'Fărcăşeşti-Moşneni (Gorj)', zip: '217236' },
  { city: 'Peşteana de Jos (Gorj)', zip: '217237' },
  { city: 'Rogojel (Gorj)', zip: '217238' },
  { city: 'Roşia-Jiu (Gorj)', zip: '217239' },
  { city: 'Timişeni (Gorj)', zip: '217241' },
  { city: 'Valea cu Apă (Gorj)', zip: '217242' },
  { city: 'Glogova (Gorj)', zip: '217245' },
  { city: 'Cămuieşti (Gorj)', zip: '217246' },
  { city: 'Cleşneşti (Gorj)', zip: '217247' },
  { city: 'Iormăneşti (Gorj)', zip: '217248' },
  { city: 'Olteanu (Gorj)', zip: '217249' },
  { city: 'Godineşti (Gorj)', zip: '217250' },
  { city: 'Arjoci (Gorj)', zip: '217251' },
  { city: 'Câlceşti (Gorj)', zip: '217252' },
  { city: 'Chiliu (Gorj)', zip: '217253' },
  { city: 'Pârâu de Pripor (Gorj)', zip: '217254' },
  { city: 'Pârâu de Vale (Gorj)', zip: '217256' },
  { city: 'Rătez (Gorj)', zip: '217257' },
  { city: 'Hurezani (Gorj)', zip: '217260' },
  { city: 'Busuioci (Gorj)', zip: '217261' },
  { city: 'Pegeni (Gorj)', zip: '217262' },
  { city: 'Plopu (Gorj)', zip: '217263' },
  { city: 'Totea de Hurezani (Gorj)', zip: '217264' },
  { city: 'Ioneşti (Gorj)', zip: '217265' },
  { city: 'Gura Şuşiţei (Gorj)', zip: '217266' },
  { city: 'Ilieşti (Gorj)', zip: '217267' },
  { city: 'Picu (Gorj)', zip: '217268' },
  { city: 'Jupâneşti (Gorj)', zip: '217270' },
  { city: 'Boia (Gorj)', zip: '217271' },
  { city: 'Pârâu Boia (Gorj)', zip: '217272' },
  { city: 'Vidin (Gorj)', zip: '217273' },
  { city: 'Vierşani (Gorj)', zip: '217274' },
  { city: 'Leleşti (Gorj)', zip: '217275' },
  { city: 'Frăteşti (Gorj)', zip: '217276' },
  { city: 'Rasoviţa (Gorj)', zip: '217277' },
  { city: 'Licurici (Gorj)', zip: '217280' },
  { city: 'Frumuşei (Gorj)', zip: '217281' },
  { city: 'Negreni (Gorj)', zip: '217282' },
  { city: 'Totea (Gorj)', zip: '217283' },
  { city: 'Logreşti (Gorj)', zip: '217285' },
  { city: 'Colţeşti (Gorj)', zip: '217286' },
  { city: 'Frunza (Gorj)', zip: '217287' },
  { city: 'Logreşti-Moşteni (Gorj)', zip: '217288' },
  { city: 'Măru (Gorj)', zip: '217289' },
  { city: 'Popeşti (Gorj)', zip: '217291' },
  { city: 'Seaca (Gorj)', zip: '217292' },
  { city: 'Târgu Logreşti (Gorj)', zip: '217293' },
  { city: 'Mătăsari (Gorj)', zip: '217295' },
  { city: 'Brădet (Gorj)', zip: '217296' },
  { city: 'Brădeţel (Gorj)', zip: '217297' },
  { city: 'Croici (Gorj)', zip: '217298' },
  { city: 'Runcurel (Gorj)', zip: '217299' },
  { city: 'Muşeteşti (Gorj)', zip: '217300' },
  { city: 'Arşeni (Gorj)', zip: '217301' },
  { city: 'Bârcaciu (Gorj)', zip: '217302' },
  { city: 'Gămani (Gorj)', zip: '217303' },
  { city: 'Grui (Gorj)', zip: '217304' },
  { city: 'Stănceşti (Gorj)', zip: '217306' },
  { city: 'Stănceşti-Larga (Gorj)', zip: '217307' },
  { city: 'Negomir (Gorj)', zip: '217310' },
  { city: 'Artanu (Gorj)', zip: '217311' },
  { city: 'Bohorel (Gorj)', zip: '217312' },
  { city: 'Condeieşti (Gorj)', zip: '217313' },
  { city: 'Nucetu (Gorj)', zip: '217314' },
  { city: 'Orzu (Gorj)', zip: '217316' },
  { city: 'Paltinu (Gorj)', zip: '217317' },
  { city: 'Raci (Gorj)', zip: '217318' },
  { city: 'Ursoaia (Gorj)', zip: '217319' },
  { city: 'Valea Racilor (Gorj)', zip: '217321' },
  { city: 'Padeş (Gorj)', zip: '217325' },
  { city: 'Apa Neagră (Gorj)', zip: '217326' },
  { city: 'Călugăreni (Gorj)', zip: '217327' },
  { city: 'Cerna-Sat (Gorj)', zip: '217328' },
  { city: 'Cloşani (Gorj)', zip: '217329' },
  { city: 'Motru Sec (Gorj)', zip: '217331' },
  { city: 'Orzeşti (Gorj)', zip: '217332' },
  { city: 'Văieni (Gorj)', zip: '217333' },
  { city: 'Peştişani (Gorj)', zip: '217335' },
  { city: 'Boroşteni (Gorj)', zip: '217336' },
  { city: 'Brădiceni (Gorj)', zip: '217337' },
  { city: 'Frânceşti (Gorj)', zip: '217338' },
  { city: 'Gureni (Gorj)', zip: '217339' },
  { city: 'Hobiţa (Gorj)', zip: '217341' },
  { city: 'Seuca (Gorj)', zip: '217342' },
  { city: 'Plopşoru (Gorj)', zip: '217345' },
  { city: 'Broşteni (Gorj)', zip: '217346' },
  { city: 'Broştenii de Sus (Gorj)', zip: '217347' },
  { city: 'Ceplea (Gorj)', zip: '217348' },
  { city: 'Cursaru (Gorj)', zip: '217349' },
  { city: 'Deleni (Gorj)', zip: '217351' },
  { city: 'Izvoarele (Gorj)', zip: '217352' },
  { city: 'Olari (Gorj)', zip: '217353' },
  { city: 'Piscuri (Gorj)', zip: '217354' },
  { city: 'Sărdăneşti (Gorj)', zip: '217356' },
  { city: 'Văleni (Gorj)', zip: '217357' },
  { city: 'Polovragi (Gorj)', zip: '217365' },
  { city: 'Racoviţa (Gorj)', zip: '217366' },
  { city: 'Prigoria (Gorj)', zip: '217370' },
  { city: 'Bucşana (Gorj)', zip: '217371' },
  { city: 'Burlani (Gorj)', zip: '217372' },
  { city: 'Călugăreasa (Gorj)', zip: '217373' },
  { city: 'Dobrana (Gorj)', zip: '217374' },
  { city: 'Negoieşti (Gorj)', zip: '217376' },
  { city: 'Zorleşti (Gorj)', zip: '217377' },
  { city: 'Roşia de Amaradia (Gorj)', zip: '217380' },
  { city: 'Becheni (Gorj)', zip: '217381' },
  { city: 'Dealu Viei (Gorj)', zip: '217382' },
  { city: 'Ruget (Gorj)', zip: '217383' },
  { city: 'Seciurile (Gorj)', zip: '217384' },
  { city: 'Stejaru (Gorj)', zip: '217386' },
  { city: 'Şitoaia (Gorj)', zip: '217387' },
  { city: 'Runcu (Gorj)', zip: '217390' },
  { city: 'Bâlta (Gorj)', zip: '217391' },
  { city: 'Bâltişoara (Gorj)', zip: '217392' },
  { city: 'Dobriţa (Gorj)', zip: '217393' },
  { city: 'Răchiţi (Gorj)', zip: '217394' },
  { city: 'Suseni (Gorj)', zip: '217396' },
  { city: 'Valea Mare (Gorj)', zip: '217397' },
  { city: 'Samarineşti (Gorj)', zip: '217400' },
  { city: 'Băzăvani (Gorj)', zip: '217401' },
  { city: 'Boca (Gorj)', zip: '217402' },
  { city: 'Duculeşti (Gorj)', zip: '217403' },
  { city: 'Larga (Gorj)', zip: '217404' },
  { city: 'Ţirioi (Gorj)', zip: '217406' },
  { city: 'Valea Bisericii (Gorj)', zip: '217407' },
  { city: 'Valea Mică (Gorj)', zip: '217408' },
  { city: 'Valea Poienii (Gorj)', zip: '217409' },
  { city: 'Săcelu (Gorj)', zip: '217410' },
  { city: 'Blahniţa de Sus (Gorj)', zip: '217411' },
  { city: 'Hăieşti (Gorj)', zip: '217412' },
  { city: 'Jeriştea (Gorj)', zip: '217413' },
  { city: 'Maghereşti (Gorj)', zip: '217414' },
  { city: 'Săuleşti (Gorj)', zip: '217415' },
  { city: 'Bibeşti (Gorj)', zip: '217416' },
  { city: 'Dolceşti (Gorj)', zip: '217417' },
  { city: 'Purcaru (Gorj)', zip: '217418' },
  { city: 'Schela (Gorj)', zip: '217420' },
  { city: 'Arsuri (Gorj)', zip: '217421' },
  { city: 'Gornăcel (Gorj)', zip: '217422' },
  { city: 'Păjiştele (Gorj)', zip: '217423' },
  { city: 'Sâmbotin (Gorj)', zip: '217424' },
  { city: 'Scoarţa (Gorj)', zip: '217425' },
  { city: 'Bobu (Gorj)', zip: '217426' },
  { city: 'Budieni (Gorj)', zip: '217427' },
  { city: 'Câmpu Mare (Gorj)', zip: '217428' },
  { city: 'Cerătu de Copăcioasa (Gorj)', zip: '217429' },
  { city: 'Colibaşi (Gorj)', zip: '217431' },
  { city: 'Copăcioasa (Gorj)', zip: '217432' },
  { city: 'Lazuri (Gorj)', zip: '217433' },
  { city: 'Lintea (Gorj)', zip: '217434' },
  { city: 'Mogoşani (Gorj)', zip: '217436' },
  { city: 'Pişteştii din Deal (Gorj)', zip: '217437' },
  { city: 'Slivileşti (Gorj)', zip: '217445' },
  { city: 'Cojmăneşti (Gorj)', zip: '217446' },
  { city: 'Miculeşti (Gorj)', zip: '217447' },
  { city: 'Strâmtu (Gorj)', zip: '217448' },
  { city: 'Sura (Gorj)', zip: '217449' },
  { city: 'Şiacu (Gorj)', zip: '217451' },
  { city: 'Ştiucani (Gorj)', zip: '217452' },
  { city: 'Tehomir (Gorj)', zip: '217453' },
  { city: 'Stăneşti (Gorj)', zip: '217455' },
  { city: 'Alexeni (Gorj)', zip: '217456' },
  { city: 'Bălani (Gorj)', zip: '217457' },
  { city: 'Căleşti (Gorj)', zip: '217458' },
  { city: 'Curpen (Gorj)', zip: '217459' },
  { city: 'Măzăroi (Gorj)', zip: '217461' },
  { city: 'Obreja (Gorj)', zip: '217462' },
  { city: 'Pârvuleşti (Gorj)', zip: '217463' },
  { city: 'Vaidei (Gorj)', zip: '217464' },
  { city: 'Vălari (Gorj)', zip: '217466' },
  { city: 'Stejari (Gorj)', zip: '217470' },
  { city: 'Baloşani (Gorj)', zip: '217471' },
  { city: 'Băceşti (Gorj)', zip: '217472' },
  { city: 'Dealu Leului (Gorj)', zip: '217473' },
  { city: 'Piscoiu (Gorj)', zip: '217474' },
  { city: 'Popeşti-Stejari (Gorj)', zip: '217476' },
  { city: 'Stoina (Gorj)', zip: '217480' },
  { city: 'Ciorari (Gorj)', zip: '217481' },
  { city: 'Mieluşei (Gorj)', zip: '217482' },
  { city: 'Păişani (Gorj)', zip: '217483' },
  { city: 'Toiaga (Gorj)', zip: '217484' },
  { city: 'Ulmet (Gorj)', zip: '217486' },
  { city: 'Urda de Sus (Gorj)', zip: '217487' },
  { city: 'Teleşti (Gorj)', zip: '217490' },
  { city: 'Buduhala (Gorj)', zip: '217491' },
  { city: 'Şomăneşti (Gorj)', zip: '217492' },
  { city: 'Tismana (Gorj)', zip: '217495' },
  { city: 'Celei (Gorj)', zip: '217496' },
  { city: 'Costeni (Gorj)', zip: '217497' },
  { city: 'Gornoviţa (Gorj)', zip: '217498' },
  { city: 'Isvarna (Gorj)', zip: '217499' },
  { city: 'Pocruia (Gorj)', zip: '217501' },
  { city: 'Racoţi (Gorj)', zip: '217502' },
  { city: 'Sohodol (Gorj)', zip: '217503' },
  { city: 'Topeşti (Gorj)', zip: '217504' },
  { city: 'Vâlcele (Gorj)', zip: '217506' },
  { city: 'Vânăta (Gorj)', zip: '217507' },
  { city: 'Turburea (Gorj)', zip: '217515' },
  { city: 'Cocorova (Gorj)', zip: '217516' },
  { city: 'Poiana (Gorj)', zip: '217517' },
  { city: 'Spahii (Gorj)', zip: '217518' },
  { city: 'Şipotu (Gorj)', zip: '217519' },
  { city: 'Turceni (Gorj)', zip: '217520' },
  { city: 'Gârbovu (Gorj)', zip: '217521' },
  { city: 'Jilţu (Gorj)', zip: '217522' },
  { city: 'Murgeşti (Gorj)', zip: '217523' },
  { city: 'Strâmba-Jiu (Gorj)', zip: '217524' },
  { city: 'Valea Viei (Gorj)', zip: '217526' },
  { city: 'Turcineşti (Gorj)', zip: '217530' },
  { city: 'Cartiu (Gorj)', zip: '217531' },
  { city: 'Horezu (Gorj)', zip: '217532' },
  { city: 'Rugi (Gorj)', zip: '217533' },
  { city: 'Ţânţăreni (Gorj)', zip: '217535' },
  { city: 'Arpadia (Gorj)', zip: '217536' },
  { city: 'Chiciora (Gorj)', zip: '217537' },
  { city: 'Floreşti (Gorj)', zip: '217538' },
  { city: 'Urdari (Gorj)', zip: '217540' },
  { city: 'Fântânele (Gorj)', zip: '217541' },
  { city: 'Hotăroasa (Gorj)', zip: '217542' },
  { city: 'Văgiuleşti (Gorj)', zip: '217545' },
  { city: 'Cârciu (Gorj)', zip: '217546' },
  { city: 'Covrigi (Gorj)', zip: '217547' },
  { city: 'Murgileşti (Gorj)', zip: '217548' },
  { city: 'Valea Motrului (Gorj)', zip: '217549' },
  { city: 'Vladimir (Gorj)', zip: '217550' },
  { city: 'Andreeşti (Gorj)', zip: '217551' },
  { city: 'Frasin (Gorj)', zip: '217552' },
  { city: 'Valea Deşului (Gorj)', zip: '217553' },
  { city: 'Ciba (Harghita)', zip: '530001' },
  { city: 'Harghita-Băi (Harghita)', zip: '530002' },
  { city: 'Jigodin-Băi (Harghita)', zip: '530003' },
  { city: 'Miercurea-Ciuc (Harghita)', zip: '530100' },
  { city: 'Băile Tuşnad (Harghita)', zip: '535100' },
  { city: 'Carpitus (Harghita)', zip: '535101' },
  { city: 'Bălan (Harghita)', zip: '535200' },
  { city: 'Borsec (Harghita)', zip: '535300' },
  { city: 'Cristuru Secuiesc (Harghita)', zip: '535400' },
  { city: 'Filiaş (Harghita)', zip: '535401' },
  { city: 'Gheorgheni (Harghita)', zip: '535500' },
  { city: 'Covacipeter (Harghita)', zip: '535501' },
  { city: 'Lacu Roşu (Harghita)', zip: '535502' },
  { city: 'Vargatac (Harghita)', zip: '535503' },
  { city: 'Visafolio (Harghita)', zip: '535504' },
  { city: 'Odorheiu Secuiesc (Harghita)', zip: '535600' },
  { city: 'Topliţa (Harghita)', zip: '535700' },
  { city: 'Călimănel (Harghita)', zip: '535701' },
  { city: 'Luncani (Harghita)', zip: '535702' },
  { city: 'Măgheruş (Harghita)', zip: '535703' },
  { city: 'Moglăneşti (Harghita)', zip: '535704' },
  { city: 'Secu (Harghita)', zip: '535705' },
  { city: 'Vale (Harghita)', zip: '535706' },
  { city: 'Vâgani (Harghita)', zip: '535707' },
  { city: 'Zencani (Harghita)', zip: '535708' },
  { city: 'Vlăhiţa (Harghita)', zip: '535800' },
  { city: 'Băile Homorod (Harghita)', zip: '535801' },
  { city: 'Minele Lueta (Harghita)', zip: '535802' },
  { city: 'Atid (Harghita)', zip: '537005' },
  { city: 'Crişeni (Harghita)', zip: '537006' },
  { city: 'Cuşmed (Harghita)', zip: '537007' },
  { city: 'Inlăceni (Harghita)', zip: '537008' },
  { city: 'Şiclod (Harghita)', zip: '537009' },
  { city: 'Avrămeşti (Harghita)', zip: '537010' },
  { city: 'Andreeni (Harghita)', zip: '537011' },
  { city: 'Cecheşti (Harghita)', zip: '537012' },
  { city: 'Firtănuş (Harghita)', zip: '537013' },
  { city: 'Goagiu (Harghita)', zip: '537014' },
  { city: 'Laz-Firtănuş (Harghita)', zip: '537016' },
  { city: 'Laz-Şoimuş (Harghita)', zip: '537017' },
  { city: 'Medişoru Mic (Harghita)', zip: '537018' },
  { city: 'Bilbor (Harghita)', zip: '537020' },
  { city: 'Răchitiş (Harghita)', zip: '537021' },
  { city: 'Brădeşti (Harghita)', zip: '537025' },
  { city: 'Satu Mare (Harghita)', zip: '537026' },
  { city: 'Târnoviţa (Harghita)', zip: '537027' },
  { city: 'Căpâlniţa (Harghita)', zip: '537030' },
  { city: 'Cârţa (Harghita)', zip: '537035' },
  { city: 'Ineu (Harghita)', zip: '537036' },
  { city: 'Tomeşti (Harghita)', zip: '537037' },
  { city: 'Ciucsângeorgiu (Harghita)', zip: '537040' },
  { city: 'Armăşeni (Harghita)', zip: '537041' },
  { city: 'Armăşenii Noi (Harghita)', zip: '537042' },
  { city: 'Bancu (Harghita)', zip: '537043' },
  { city: 'Ciobăniş (Harghita)', zip: '537044' },
  { city: 'Cotormani (Harghita)', zip: '537046' },
  { city: 'Eghersec (Harghita)', zip: '537047' },
  { city: 'Ghiurche (Harghita)', zip: '537048' },
  { city: 'Potiond (Harghita)', zip: '537049' },
  { city: 'Ciumani (Harghita)', zip: '537050' },
  { city: 'Corbu (Harghita)', zip: '537055' },
  { city: 'Capu Corbului (Harghita)', zip: '537056' },
  { city: 'Corund (Harghita)', zip: '537060' },
  { city: 'Atia (Harghita)', zip: '537061' },
  { city: 'Calonda (Harghita)', zip: '537062' },
  { city: 'Fântâna Brazilor (Harghita)', zip: '537063' },
  { city: 'Valea lui Pavel (Harghita)', zip: '537064' },
  { city: 'Cozmeni (Harghita)', zip: '537065' },
  { city: 'Lăzăreşti (Harghita)', zip: '537066' },
  { city: 'Dăneşti (Harghita)', zip: '537070' },
  { city: 'Mădăraş (Harghita)', zip: '537071' },
  { city: 'Dârjiu (Harghita)', zip: '537075' },
  { city: 'Mujna (Harghita)', zip: '537076' },
  { city: 'Dealu (Harghita)', zip: '537080' },
  { city: 'Fâncel (Harghita)', zip: '537081' },
  { city: 'Sâncrai (Harghita)', zip: '537082' },
  { city: 'Tămaşu (Harghita)', zip: '537083' },
  { city: 'Tibod (Harghita)', zip: '537084' },
  { city: 'Ulcani (Harghita)', zip: '537086' },
  { city: 'Valea Rotundă (Harghita)', zip: '537087' },
  { city: 'Ditrău (Harghita)', zip: '537090' },
  { city: 'Jolotca (Harghita)', zip: '537091' },
  { city: 'Ţengheler (Harghita)', zip: '537092' },
  { city: 'Feliceni (Harghita)', zip: '537095' },
  { city: 'Alexandriţa (Harghita)', zip: '537096' },
  { city: 'Arvăţeni (Harghita)', zip: '537097' },
  { city: 'Cireşeni (Harghita)', zip: '537098' },
  { city: 'Forţeni (Harghita)', zip: '537099' },
  { city: 'Hoghia (Harghita)', zip: '537101' },
  { city: 'Oţeni (Harghita)', zip: '537102' },
  { city: 'Poloniţa (Harghita)', zip: '537103' },
  { city: 'Tăureni (Harghita)', zip: '537104' },
  { city: 'Teleac (Harghita)', zip: '537106' },
  { city: 'Văleni (Harghita)', zip: '537107' },
  { city: 'Frumoasa (Harghita)', zip: '537115' },
  { city: 'Bârzava (Harghita)', zip: '537116' },
  { city: 'Făgeţel (Frumoasa) (Harghita)', zip: '537117' },
  { city: 'Nicoleşti (Frumoasa) (Harghita)', zip: '537118' },
  { city: 'Gălăuţaş (Harghita)', zip: '537120' },
  { city: 'Dealu Armanului (Harghita)', zip: '537121' },
  { city: 'Gălăuţaş-Pârău (Harghita)', zip: '537122' },
  { city: 'Nuţeni (Harghita)', zip: '537123' },
  { city: 'Plopiş (Harghita)', zip: '537124' },
  { city: 'Preluca (Harghita)', zip: '537126' },
  { city: 'Toleşeni (Harghita)', zip: '537127' },
  { city: 'Zăpodea (Harghita)', zip: '537128' },
  { city: 'Joseni (Harghita)', zip: '537130' },
  { city: 'Borzont (Harghita)', zip: '537131' },
  { city: 'Bucin (Joseni) (Harghita)', zip: '537132' },
  { city: 'Lăzarea (Harghita)', zip: '537135' },
  { city: 'Ghiduţ (Harghita)', zip: '537136' },
  { city: 'Lueta (Harghita)', zip: '537140' },
  { city: 'Băile Chirui (Harghita)', zip: '537141' },
  { city: 'Lunca de Jos (Harghita)', zip: '537145' },
  { city: 'Baraţcoş (Harghita)', zip: '537146' },
  { city: 'Poiana Fagului (Harghita)', zip: '537147' },
  { city: 'Puntea Lupului (Harghita)', zip: '537148' },
  { city: 'Valea Boroş (Harghita)', zip: '537149' },
  { city: 'Valea Capelei (Harghita)', zip: '537151' },
  { city: 'Valea Întunecoasă (Harghita)', zip: '537152' },
  { city: 'Valea Rece (Harghita)', zip: '537153' },
  { city: 'Valea lui Antaloc (Harghita)', zip: '537154' },
  { city: 'Lunca de Sus (Harghita)', zip: '537155' },
  { city: 'Comiat (Harghita)', zip: '537156' },
  { city: 'Izvorul Trotuşului (Harghita)', zip: '537157' },
  { city: 'Păltiniş-Ciuc (Harghita)', zip: '537158' },
  { city: 'Valea Gârbea (Harghita)', zip: '537159' },
  { city: 'Valea Ugra (Harghita)', zip: '537161' },
  { city: 'Lupeni (Harghita)', zip: '537165' },
  { city: 'Bisericani (Harghita)', zip: '537166' },
  { city: 'Bulgăreni (Harghita)', zip: '537167' },
  { city: 'Firtuşu (Harghita)', zip: '537168' },
  { city: 'Morăreni (Harghita)', zip: '537169' },
  { city: 'Păltiniş (Harghita)', zip: '537171' },
  { city: 'Păuleni (Harghita)', zip: '537172' },
  { city: 'Satu Mic (Harghita)', zip: '537173' },
  { city: 'Sâncel (Harghita)', zip: '537174' },
  { city: 'Mărtiniş (Harghita)', zip: '537175' },
  { city: 'Aldea (Harghita)', zip: '537176' },
  { city: 'Bădeni (Harghita)', zip: '537177' },
  { city: 'Călugăreni (Harghita)', zip: '537178' },
  { city: 'Chinuşu (Harghita)', zip: '537179' },
  { city: 'Comăneşti (Harghita)', zip: '537181' },
  { city: 'Ghipeş (Harghita)', zip: '537182' },
  { city: 'Locodeni (Harghita)', zip: '537183' },
  { city: 'Orăşeni (Harghita)', zip: '537184' },
  { city: 'Petreni (Harghita)', zip: '537186' },
  { city: 'Rareş (Harghita)', zip: '537187' },
  { city: 'Sânpaul (Harghita)', zip: '537188' },
  { city: 'Mereşti (Harghita)', zip: '537195' },
  { city: 'Mihăileni (Harghita)', zip: '537200' },
  { city: 'Livezi (Harghita)', zip: '537201' },
  { city: 'Nădejdea (Harghita)', zip: '537202' },
  { city: 'Văcăreşti (Harghita)', zip: '537203' },
  { city: 'Mugeni (Harghita)', zip: '537205' },
  { city: 'Aluniş (Harghita)', zip: '537206' },
  { city: 'Beta (Harghita)', zip: '537207' },
  { city: 'Beteşti (Harghita)', zip: '537208' },
  { city: 'Dejuţiu (Harghita)', zip: '537209' },
  { city: 'Dobeni (Harghita)', zip: '537211' },
  { city: 'Lutiţa (Harghita)', zip: '537212' },
  { city: 'Mătişeni (Harghita)', zip: '537213' },
  { city: 'Porumbenii Mari (Harghita)', zip: '537214' },
  { city: 'Porumbeni (Harghita)', zip: '537215' },
  { city: 'Porumbenii Mici (Harghita)', zip: '537216' },
  { city: 'Tăietura (Harghita)', zip: '537217' },
  { city: 'Ocland (Harghita)', zip: '537225' },
  { city: 'Crăciunel (Harghita)', zip: '537226' },
  { city: 'Satu Nou (Ocland) (Harghita)', zip: '537227' },
  { city: 'Păuleni-Ciuc (Harghita)', zip: '537230' },
  { city: 'Delniţa (Harghita)', zip: '537231' },
  { city: 'Şoimeni (Harghita)', zip: '537232' },
  { city: 'Plăieşii de Jos (Harghita)', zip: '537235' },
  { city: 'Casinu Nou (Harghita)', zip: '537236' },
  { city: 'Iacobeni (Harghita)', zip: '537237' },
  { city: 'Imper (Harghita)', zip: '537238' },
  { city: 'Plăieşii de Sus (Harghita)', zip: '537239' },
  { city: 'Praid (Harghita)', zip: '537240' },
  { city: 'Becaş (Harghita)', zip: '537241' },
  { city: 'Bucin (Praid) (Harghita)', zip: '537242' },
  { city: 'Ocna de Jos (Harghita)', zip: '537243' },
  { city: 'Ocna de Sus (Harghita)', zip: '537244' },
  { city: 'Şaşvereş (Harghita)', zip: '537246' },
  { city: 'Remetea (Harghita)', zip: '537250' },
  { city: 'Făgeţel (Remetea) (Harghita)', zip: '537251' },
  { city: 'Martonca (Harghita)', zip: '537252' },
  { city: 'Sineu (Harghita)', zip: '537253' },
  { city: 'Săcel (Harghita)', zip: '537255' },
  { city: 'Şoimuşu Mare (Harghita)', zip: '537256' },
  { city: 'Şoimuşu Mic (Harghita)', zip: '537257' },
  { city: 'Uilac (Harghita)', zip: '537258' },
  { city: 'Vidacut (Harghita)', zip: '537259' },
  { city: 'Sărmaş (Harghita)', zip: '537260' },
  { city: 'Fundoaia (Harghita)', zip: '537261' },
  { city: 'Hodoşa (Harghita)', zip: '537262' },
  { city: 'Platoneşti (Harghita)', zip: '537263' },
  { city: 'Runc (Harghita)', zip: '537264' },
  { city: 'Sâncrăieni (Harghita)', zip: '537265' },
  { city: 'Fitod (Harghita)', zip: '537266' },
  { city: 'Hosasău (Harghita)', zip: '537267' },
  { city: 'Leliceni (Harghita)', zip: '537268' },
  { city: 'Misentea (Harghita)', zip: '537269' },
  { city: 'Sântimbru (Harghita)', zip: '537271' },
  { city: 'Sântimbru-Băi (Harghita)', zip: '537272' },
  { city: 'Sândominic (Harghita)', zip: '537275' },
  { city: 'Sânmartin (Harghita)', zip: '537280' },
  { city: 'Ciucani (Harghita)', zip: '537281' },
  { city: 'Valea Uzului (Harghita)', zip: '537282' },
  { city: 'Sânsimion (Harghita)', zip: '537285' },
  { city: 'Cetăţuia (Harghita)', zip: '537286' },
  { city: 'Secuieni (Harghita)', zip: '537290' },
  { city: 'Bodogaia (Harghita)', zip: '537291' },
  { city: 'Eliseni (Harghita)', zip: '537292' },
  { city: 'Siculeni (Harghita)', zip: '537295' },
  { city: 'Ciaracio (Harghita)', zip: '537296' },
  { city: 'Ciceu (Harghita)', zip: '537297' },
  { city: 'Racu (Harghita)', zip: '537298' },
  { city: 'Gârciu (Racu) (Harghita)', zip: '537299' },
  { city: 'Subcetate (Harghita)', zip: '537300' },
  { city: 'Călnaci (Harghita)', zip: '537301' },
  { city: 'Duda (Harghita)', zip: '537302' },
  { city: 'Filpea (Harghita)', zip: '537303' },
  { city: 'Suseni (Harghita)', zip: '537305' },
  { city: 'Chileni (Harghita)', zip: '537306' },
  { city: 'Liban (Harghita)', zip: '537307' },
  { city: 'Senetea (Harghita)', zip: '537308' },
  { city: 'Valea Strâmbă (Harghita)', zip: '537309' },
  { city: 'Şimoneşti (Harghita)', zip: '537310' },
  { city: 'Benţid (Harghita)', zip: '537311' },
  { city: 'Cădaciu Mare (Harghita)', zip: '537312' },
  { city: 'Cădaciu Mic (Harghita)', zip: '537313' },
  { city: 'Ceheţel (Harghita)', zip: '537314' },
  { city: 'Chedia Mare (Harghita)', zip: '537316' },
  { city: 'Chedia Mică (Harghita)', zip: '537317' },
  { city: 'Cobăteşti (Harghita)', zip: '537318' },
  { city: 'Medişoru Mare (Harghita)', zip: '537319' },
  { city: 'Mihăileni (Şimoneşti) (Harghita)', zip: '537321' },
  { city: 'Nicoleni (Harghita)', zip: '537322' },
  { city: 'Rugăneşti (Harghita)', zip: '537323' },
  { city: 'Tărceşti (Harghita)', zip: '537324' },
  { city: 'Turdeni (Harghita)', zip: '537326' },
  { city: 'Tulgheş (Harghita)', zip: '537330' },
  { city: 'Hagota (Harghita)', zip: '537331' },
  { city: 'Pintic (Harghita)', zip: '537332' },
  { city: 'Recea (Harghita)', zip: '537333' },
  { city: 'Tuşnad (Harghita)', zip: '537335' },
  { city: 'Tuşnadu Nou (Harghita)', zip: '537336' },
  { city: 'Vrabia (Harghita)', zip: '537337' },
  { city: 'Ulieş (Harghita)', zip: '537340' },
  { city: 'Daia (Harghita)', zip: '537341' },
  { city: 'Iaşu (Harghita)', zip: '537342' },
  { city: 'Ighiu (Harghita)', zip: '537343' },
  { city: 'Nicoleşti (Ulieş) (Harghita)', zip: '537344' },
  { city: 'Obrăneşti (Harghita)', zip: '537346' },
  { city: 'Petecu (Harghita)', zip: '537347' },
  { city: 'Vasileni (Harghita)', zip: '537348' },
  { city: 'Vărşag (Harghita)', zip: '537350' },
  { city: 'Voşlăbeni (Harghita)', zip: '537355' },
  { city: 'Izvoru Mureşului (Harghita)', zip: '537356' },
  { city: 'Zetea (Harghita)', zip: '537360' },
  { city: 'Desag (Harghita)', zip: '537361' },
  { city: 'Izvoare (Harghita)', zip: '537362' },
  { city: 'Poiana Târnavei (Harghita)', zip: '537363' },
  { city: 'Sub Cetate (Harghita)', zip: '537364' },
  { city: 'Şicasău (Harghita)', zip: '537366' },
  { city: 'Archia (Hunedoara)', zip: '330001' },
  { city: 'Bârcea Mică (Hunedoara)', zip: '330002' },
  { city: 'Cristur (Hunedoara)', zip: '330003' },
  { city: 'Sântuhalm (Hunedoara)', zip: '330004' },
  { city: 'Deva (Hunedoara)', zip: '330005' },
  { city: 'Boş (Hunedoara)', zip: '331001' },
  { city: 'Groş (Hunedoara)', zip: '331002' },
  { city: 'Hăşdat (Hunedoara)', zip: '331003' },
  { city: 'Peştişu Mare (Hunedoara)', zip: '331004' },
  { city: 'Răcăştia (Hunedoara)', zip: '331005' },
  { city: 'Hunedoara (Hunedoara)', zip: '331006' },
  { city: 'Dâlja Mare (Hunedoara)', zip: '332001' },
  { city: 'Dâlja Mică (Hunedoara)', zip: '332002' },
  { city: 'Peştera (Petroşani) (Hunedoara)', zip: '332003' },
  { city: 'Slătinioara (Hunedoara)', zip: '332004' },
  { city: 'Petroşani (Hunedoara)', zip: '332005' },
  { city: 'Aninoasa (Hunedoara)', zip: '335100' },
  { city: 'Iscroni (Hunedoara)', zip: '335101' },
  { city: 'Brad (Hunedoara)', zip: '335200' },
  { city: 'Mesteacăn (Brad) (Hunedoara)', zip: '335201' },
  { city: 'Potingani (Hunedoara)', zip: '335202' },
  { city: 'Ruda-Brad (Hunedoara)', zip: '335203' },
  { city: 'Ţărăţel (Hunedoara)', zip: '335204' },
  { city: 'Valea Bradului (Hunedoara)', zip: '335205' },
  { city: 'Călan (Hunedoara)', zip: '335300' },
  { city: 'Batiz (Hunedoara)', zip: '335301' },
  { city: 'Călanu Mic (Hunedoara)', zip: '335302' },
  { city: 'Grid (Hunedoara)', zip: '335303' },
  { city: 'Nădăştia de Jos (Hunedoara)', zip: '335304' },
  { city: 'Nădăştia de Sus (Hunedoara)', zip: '335305' },
  { city: 'Ohaba Streiului (Hunedoara)', zip: '335306' },
  { city: 'Sâncrai (Hunedoara)', zip: '335307' },
  { city: 'Sântămăria de Piatră (Hunedoara)', zip: '335308' },
  { city: 'Strei (Hunedoara)', zip: '335309' },
  { city: 'Strei-Săcel (Hunedoara)', zip: '335310' },
  { city: 'Streisângeorgiu (Hunedoara)', zip: '335311' },
  { city: 'Valea Sângeorgiului (Hunedoara)', zip: '335312' },
  { city: 'Geoagiu (Hunedoara)', zip: '335400' },
  { city: 'Aurel Vlaicu (Hunedoara)', zip: '335401' },
  { city: 'Băcâia (Hunedoara)', zip: '335402' },
  { city: 'Bozeş (Hunedoara)', zip: '335403' },
  { city: 'Cigmău (Hunedoara)', zip: '335404' },
  { city: 'Gelmar (Hunedoara)', zip: '335405' },
  { city: 'Homorod (Hunedoara)', zip: '335406' },
  { city: 'Mermezeu-Văleni (Hunedoara)', zip: '335407' },
  { city: 'Renghet (Hunedoara)', zip: '335408' },
  { city: 'Văleni (Geoagiu) (Hunedoara)', zip: '335409' },
  { city: 'Geoagiu-Băi (Hunedoara)', zip: '335450' },
  { city: 'Haţeg (Hunedoara)', zip: '335500' },
  { city: 'Nălaţvad (Hunedoara)', zip: '335501' },
  { city: 'Silvaşu de Jos (Hunedoara)', zip: '335502' },
  { city: 'Silvaşu de Sus (Hunedoara)', zip: '335503' },
  { city: 'Lupeni (Hunedoara)', zip: '335600' },
  { city: 'Orăştie (Hunedoara)', zip: '335700' },
  { city: 'Petrila (Hunedoara)', zip: '335800' },
  { city: 'Cimpa (Hunedoara)', zip: '335801' },
  { city: 'Jieţ (Hunedoara)', zip: '335802' },
  { city: 'Răscoala (Hunedoara)', zip: '335803' },
  { city: 'Tirici (Hunedoara)', zip: '335804' },
  { city: 'Simeria (Hunedoara)', zip: '335900' },
  { city: 'Bârcea Mare (Hunedoara)', zip: '335901' },
  { city: 'Cărpiniş (Hunedoara)', zip: '335902' },
  { city: 'Sântandrei (Hunedoara)', zip: '335903' },
  { city: 'Simeria Veche (Hunedoara)', zip: '335904' },
  { city: 'Şăuleşti (Hunedoara)', zip: '335905' },
  { city: 'Uroi (Hunedoara)', zip: '335906' },
  { city: 'Uricani (Hunedoara)', zip: '336100' },
  { city: 'Câmpu lui Neag (Hunedoara)', zip: '336101' },
  { city: 'Valea de Brazi (Hunedoara)', zip: '336102' },
  { city: 'Vulcan (Hunedoara)', zip: '336200' },
  { city: 'Dealu Babii (Hunedoara)', zip: '336201' },
  { city: 'Jiu-Paroşeni (Hunedoara)', zip: '336250' },
  { city: 'Baia de Criş (Hunedoara)', zip: '337005' },
  { city: 'Baldovin (Hunedoara)', zip: '337006' },
  { city: 'Căraci (Hunedoara)', zip: '337007' },
  { city: 'Cărăstău (Hunedoara)', zip: '337008' },
  { city: 'Lunca (Baia de Criş) (Hunedoara)', zip: '337009' },
  { city: 'Rişca (Hunedoara)', zip: '337011' },
  { city: 'Rişculiţa (Hunedoara)', zip: '337012' },
  { city: 'Ţebea (Hunedoara)', zip: '337013' },
  { city: 'Văleni (Baia de Criş) (Hunedoara)', zip: '337014' },
  { city: 'Balşa (Hunedoara)', zip: '337015' },
  { city: 'Almaşu Mic de Munte (Hunedoara)', zip: '337016' },
  { city: 'Ardeu (Hunedoara)', zip: '337017' },
  { city: 'Buneşti (Hunedoara)', zip: '337018' },
  { city: 'Galbina (Hunedoara)', zip: '337019' },
  { city: 'Mada (Hunedoara)', zip: '337021' },
  { city: 'Oprişeşti (Hunedoara)', zip: '337022' },
  { city: 'Poiana (Hunedoara)', zip: '337023' },
  { city: 'Poieniţa (Hunedoara)', zip: '337024' },
  { city: 'Roşia (Hunedoara)', zip: '337026' },
  { city: 'Stăuini (Hunedoara)', zip: '337027' },
  { city: 'Techereu (Hunedoara)', zip: '337028' },
  { city: 'Vălişoara (Balşa) (Hunedoara)', zip: '337029' },
  { city: 'Voia (Hunedoara)', zip: '337031' },
  { city: 'Baru (Hunedoara)', zip: '337035' },
  { city: 'Livadia (Hunedoara)', zip: '337036' },
  { city: 'Petros (Hunedoara)', zip: '337037' },
  { city: 'Valea Lupului (Hunedoara)', zip: '337038' },
  { city: 'Băcia (Hunedoara)', zip: '337040' },
  { city: 'Petreni (Hunedoara)', zip: '337041' },
  { city: 'Tâmpa (Hunedoara)', zip: '337042' },
  { city: 'Totia (Hunedoara)', zip: '337043' },
  { city: 'Băiţa (Hunedoara)', zip: '337045' },
  { city: 'Barbura (Hunedoara)', zip: '337046' },
  { city: 'Căinelu de Sus (Hunedoara)', zip: '337047' },
  { city: 'Crăciuneşti (Hunedoara)', zip: '337048' },
  { city: 'Fizeş (Hunedoara)', zip: '337049' },
  { city: 'Hărţăgani (Hunedoara)', zip: '337051' },
  { city: 'Lunca (Băiţa) (Hunedoara)', zip: '337052' },
  { city: 'Ormindea (Hunedoara)', zip: '337053' },
  { city: 'Peştera (Băiţa) (Hunedoara)', zip: '337054' },
  { city: 'Sălişte (Hunedoara)', zip: '337056' },
  { city: 'Trestia (Hunedoara)', zip: '337057' },
  { city: 'Băniţa (Hunedoara)', zip: '337065' },
  { city: 'Crivadia (Hunedoara)', zip: '337066' },
  { city: 'Merişor (Băniţa) (Hunedoara)', zip: '337067' },
  { city: 'Bătrâna (Hunedoara)', zip: '337070' },
  { city: 'Faţa Roşie (Hunedoara)', zip: '337071' },
  { city: 'Piatra (Hunedoara)', zip: '337072' },
  { city: 'Răchiţaua (Hunedoara)', zip: '337073' },
  { city: 'Beriu (Hunedoara)', zip: '337075' },
  { city: 'Căstău (Hunedoara)', zip: '337076' },
  { city: 'Cucuiş (Hunedoara)', zip: '337077' },
  { city: 'Măgureni (Hunedoara)', zip: '337078' },
  { city: 'Orăştioara de Jos (Hunedoara)', zip: '337079' },
  { city: 'Poieni (Beriu) (Hunedoara)', zip: '337081' },
  { city: 'Sereca (Hunedoara)', zip: '337082' },
  { city: 'Sibişel (Beriu) (Hunedoara)', zip: '337083' },
  { city: 'Blăjeni (Hunedoara)', zip: '337085' },
  { city: 'Blăjeni-Vulcan (Hunedoara)', zip: '337086' },
  { city: 'Criş (Hunedoara)', zip: '337087' },
  { city: 'Dragu-Brad (Hunedoara)', zip: '337088' },
  { city: 'Groşuri (Hunedoara)', zip: '337089' },
  { city: 'Plai (Hunedoara)', zip: '337091' },
  { city: 'Reţ (Hunedoara)', zip: '337092' },
  { city: 'Sălătruc (Hunedoara)', zip: '337093' },
  { city: 'Boşorod (Hunedoara)', zip: '337095' },
  { city: 'Alun (Boşorod) (Hunedoara)', zip: '337096' },
  { city: 'Bobaia (Hunedoara)', zip: '337097' },
  { city: 'Chitid (Hunedoara)', zip: '337098' },
  { city: 'Cioclovina (Hunedoara)', zip: '337099' },
  { city: 'Luncani (Hunedoara)', zip: '337101' },
  { city: 'Prihodişte (Boşorod) (Hunedoara)', zip: '337102' },
  { city: 'Târsa (Hunedoara)', zip: '337103' },
  { city: 'Ursici (Hunedoara)', zip: '337104' },
  { city: 'Brănişca (Hunedoara)', zip: '337105' },
  { city: 'Bărăştii Iliei (Hunedoara)', zip: '337106' },
  { city: 'Boz (Hunedoara)', zip: '337107' },
  { city: 'Căbeşti (Hunedoara)', zip: '337108' },
  { city: 'Furcşoara (Hunedoara)', zip: '337109' },
  { city: 'Gialacuta (Hunedoara)', zip: '337111' },
  { city: 'Rovina (Brănişca) (Hunedoara)', zip: '337112' },
  { city: 'Târnava (Hunedoara)', zip: '337113' },
  { city: 'Târnăviţa (Hunedoara)', zip: '337114' },
  { city: 'Bretea Română (Hunedoara)', zip: '337115' },
  { city: 'Băţălar (Hunedoara)', zip: '337116' },
  { city: 'Bercu (Hunedoara)', zip: '337117' },
  { city: 'Bretea Streiului (Hunedoara)', zip: '337118' },
  { city: 'Covragiu (Hunedoara)', zip: '337119' },
  { city: 'Gânţaga (Hunedoara)', zip: '337121' },
  { city: 'Măceu (Hunedoara)', zip: '337122' },
  { city: 'Ocolişu Mare (Hunedoara)', zip: '337123' },
  { city: 'Plopi (Hunedoara)', zip: '337124' },
  { city: 'Ruşi (Hunedoara)', zip: '337126' },
  { city: 'Vâlcele (Hunedoara)', zip: '337127' },
  { city: 'Vâlcelele Bune (Hunedoara)', zip: '337128' },
  { city: 'Vâlceluţa (Hunedoara)', zip: '337129' },
  { city: 'Buceş (Hunedoara)', zip: '337135' },
  { city: 'Buceş-Vulcan (Hunedoara)', zip: '337136' },
  { city: 'Dupăpiatră (Hunedoara)', zip: '337137' },
  { city: 'Grohoţele (Hunedoara)', zip: '337138' },
  { city: 'Mihăileni (Hunedoara)', zip: '337139' },
  { city: 'Stănija (Hunedoara)', zip: '337141' },
  { city: 'Tarniţa (Hunedoara)', zip: '337142' },
  { city: 'Bucureşci (Hunedoara)', zip: '337145' },
  { city: 'Curechiu (Hunedoara)', zip: '337146' },
  { city: 'Merişor (Bucureşci) (Hunedoara)', zip: '337147' },
  { city: 'Rovina (Bucureşci) (Hunedoara)', zip: '337148' },
  { city: 'Şesuri (Hunedoara)', zip: '337149' },
  { city: 'Bulzeştii de Sus (Hunedoara)', zip: '337150' },
  { city: 'Bulzeştii de Jos (Hunedoara)', zip: '337151' },
  { city: 'Giurgeşti (Hunedoara)', zip: '337152' },
  { city: 'Grohot (Hunedoara)', zip: '337153' },
  { city: 'Păuleşti (Hunedoara)', zip: '337154' },
  { city: 'Ruseşti (Hunedoara)', zip: '337156' },
  { city: 'Stănculeşti (Hunedoara)', zip: '337157' },
  { city: 'Ticera (Hunedoara)', zip: '337158' },
  { city: 'Tomnatec (Hunedoara)', zip: '337159' },
  { city: 'Bunila (Hunedoara)', zip: '337160' },
  { city: 'Alun (Bunila) (Hunedoara)', zip: '337161' },
  { city: 'Cernişoara Florese (Hunedoara)', zip: '337162' },
  { city: 'Poieniţa Voinii (Hunedoara)', zip: '337163' },
  { city: 'Vadu Dobrii (Hunedoara)', zip: '337164' },
  { city: 'Burjuc (Hunedoara)', zip: '337165' },
  { city: 'Brădăţel (Hunedoara)', zip: '337166' },
  { city: 'Glodghileşti (Hunedoara)', zip: '337167' },
  { city: 'Petreşti (Hunedoara)', zip: '337168' },
  { city: 'Tătărăşti (Hunedoara)', zip: '337169' },
  { city: 'Tisa (Hunedoara)', zip: '337171' },
  { city: 'Cârjiţi (Hunedoara)', zip: '337175' },
  { city: 'Almaşu Sec (Hunedoara)', zip: '337176' },
  { city: 'Chergheş (Hunedoara)', zip: '337177' },
  { city: 'Cozia (Hunedoara)', zip: '337178' },
  { city: 'Popeşti (Hunedoara)', zip: '337179' },
  { city: 'Cerbăl (Hunedoara)', zip: '337180' },
  { city: 'Arănieş (Hunedoara)', zip: '337181' },
  { city: 'Feregi (Hunedoara)', zip: '337182' },
  { city: 'Merişoru de Munte (Hunedoara)', zip: '337183' },
  { city: 'Poiana Răchiţelii (Hunedoara)', zip: '337184' },
  { city: 'Poieniţa Tomii (Hunedoara)', zip: '337186' },
  { city: 'Socet (Hunedoara)', zip: '337187' },
  { city: 'Ulm (Hunedoara)', zip: '337188' },
  { city: 'Certeju de Sus (Hunedoara)', zip: '337190' },
  { city: 'Bocşa Mare (Hunedoara)', zip: '337191' },
  { city: 'Bocşa Mică (Hunedoara)', zip: '337192' },
  { city: 'Hondol (Hunedoara)', zip: '337193' },
  { city: 'Măgura-Topliţa (Hunedoara)', zip: '337194' },
  { city: 'Nojag (Hunedoara)', zip: '337196' },
  { city: 'Săcărâmb (Hunedoara)', zip: '337197' },
  { city: 'Topliţa Mureşului (Hunedoara)', zip: '337198' },
  { city: 'Vărmaga (Hunedoara)', zip: '337199' },
  { city: 'Crişcior (Hunedoara)', zip: '337200' },
  { city: 'Barza (Hunedoara)', zip: '337201' },
  { city: 'Valea Arsului (Hunedoara)', zip: '337202' },
  { city: 'Zdrapţi (Hunedoara)', zip: '337203' },
  { city: 'Densuş (Hunedoara)', zip: '337205' },
  { city: 'Criva (Hunedoara)', zip: '337206' },
  { city: 'Hăţăgel (Hunedoara)', zip: '337207' },
  { city: 'Peşteana (Hunedoara)', zip: '337208' },
  { city: 'Peşteniţa (Hunedoara)', zip: '337209' },
  { city: 'Poieni (Densuş) (Hunedoara)', zip: '337211' },
  { city: 'Ştei (Hunedoara)', zip: '337212' },
  { city: 'Dobra (Hunedoara)', zip: '337215' },
  { city: 'Abucea (Hunedoara)', zip: '337216' },
  { city: 'Bujoru (Hunedoara)', zip: '337217' },
  { city: 'Făgeţel (Hunedoara)', zip: '337218' },
  { city: 'Lăpuşnic (Hunedoara)', zip: '337219' },
  { city: 'Mihăieşti (Hunedoara)', zip: '337221' },
  { city: 'Panc (Hunedoara)', zip: '337222' },
  { city: 'Panc-Sălişte (Hunedoara)', zip: '337223' },
  { city: 'Răduleşti (Stânceşti) (Hunedoara)', zip: '337224' },
  { city: 'Roşcani (Hunedoara)', zip: '337226' },
  { city: 'Stânceşti (Hunedoara)', zip: '337227' },
  { city: 'Stânceşti-Ohaba (Hunedoara)', zip: '337228' },
  { city: 'Stretea (Hunedoara)', zip: '337229' },
  { city: 'General Berthelot (Hunedoara)', zip: '337235' },
  { city: 'Crăguiş (Hunedoara)', zip: '337236' },
  { city: 'Fărcădin (Hunedoara)', zip: '337237' },
  { city: 'Livezi (Hunedoara)', zip: '337238' },
  { city: 'Tuştea (Hunedoara)', zip: '337239' },
  { city: 'Ghelari (Hunedoara)', zip: '337240' },
  { city: 'Govăjdia (Hunedoara)', zip: '337241' },
  { city: 'Plop (Hunedoara)', zip: '337242' },
  { city: 'Ruda (Hunedoara)', zip: '337243' },
  { city: 'Gurasada (Hunedoara)', zip: '337245' },
  { city: 'Boiu de Jos (Hunedoara)', zip: '337246' },
  { city: 'Boiu de Sus (Hunedoara)', zip: '337247' },
  { city: 'Cărmăzăneşti (Hunedoara)', zip: '337248' },
  { city: 'Câmpuri de Sus (Hunedoara)', zip: '337249' },
  { city: 'Câmpuri-Surduc (Hunedoara)', zip: '337251' },
  { city: 'Dănuleşti (Hunedoara)', zip: '337252' },
  { city: 'Gothatea (Hunedoara)', zip: '337253' },
  { city: 'Runcşor (Hunedoara)', zip: '337254' },
  { city: 'Ulieş (Hunedoara)', zip: '337256' },
  { city: 'Vica (Hunedoara)', zip: '337257' },
  { city: 'Hărău (Hunedoara)', zip: '337265' },
  { city: 'Banpotoc (Hunedoara)', zip: '337266' },
  { city: 'Bârsău (Hunedoara)', zip: '337267' },
  { city: 'Chimindia (Hunedoara)', zip: '337268' },
  { city: 'Ilia (Hunedoara)', zip: '337270' },
  { city: 'Bacea (Hunedoara)', zip: '337271' },
  { city: 'Brâznic (Hunedoara)', zip: '337272' },
  { city: 'Bretea Mureşană (Hunedoara)', zip: '337273' },
  { city: 'Cuieş (Hunedoara)', zip: '337274' },
  { city: 'Dumbrăviţa (Hunedoara)', zip: '337276' },
  { city: 'Săcămaş (Hunedoara)', zip: '337277' },
  { city: 'Sârbi (Hunedoara)', zip: '337278' },
  { city: 'Valea Lungă (Hunedoara)', zip: '337279' },
  { city: 'Lăpugiu de Jos (Hunedoara)', zip: '337280' },
  { city: 'Baştea (Hunedoara)', zip: '337281' },
  { city: 'Coseşti (Hunedoara)', zip: '337282' },
  { city: 'Fintoag (Hunedoara)', zip: '337283' },
  { city: 'Grind (Hunedoara)', zip: '337284' },
  { city: 'Holdea (Hunedoara)', zip: '337286' },
  { city: 'Lăpugiu de Sus (Hunedoara)', zip: '337287' },
  { city: 'Lăsău (Hunedoara)', zip: '337288' },
  { city: 'Ohaba (Hunedoara)', zip: '337289' },
  { city: 'Teiu (Hunedoara)', zip: '337291' },
  { city: 'Lelese (Hunedoara)', zip: '337295' },
  { city: 'Cerişor (Hunedoara)', zip: '337296' },
  { city: 'Runcu Mare (Hunedoara)', zip: '337297' },
  { city: 'Sohodol (Hunedoara)', zip: '337298' },
  { city: 'Lunca Cernii de Jos (Hunedoara)', zip: '337300' },
  { city: 'Ciumiţa (Hunedoara)', zip: '337301' },
  { city: 'Fântâna (Hunedoara)', zip: '337302' },
  { city: 'Gura Bordului (Hunedoara)', zip: '337303' },
  { city: 'Lunca Cernii de Sus (Hunedoara)', zip: '337304' },
  { city: 'Meria (Hunedoara)', zip: '337306' },
  { city: 'Negoiu (Hunedoara)', zip: '337307' },
  { city: 'Valea Babii (Hunedoara)', zip: '337308' },
  { city: 'Luncoiu de Jos (Hunedoara)', zip: '337310' },
  { city: 'Dudeşti (Hunedoara)', zip: '337311' },
  { city: 'Luncoiu de Sus (Hunedoara)', zip: '337312' },
  { city: 'Podele (Hunedoara)', zip: '337313' },
  { city: 'Stejărel (Hunedoara)', zip: '337314' },
  { city: 'Mărtineşti (Hunedoara)', zip: '337315' },
  { city: 'Dâncu Mare (Hunedoara)', zip: '337316' },
  { city: 'Dâncu Mic (Hunedoara)', zip: '337317' },
  { city: 'Jeledinţi (Hunedoara)', zip: '337318' },
  { city: 'Măgura (Hunedoara)', zip: '337319' },
  { city: 'Tămăşasa (Hunedoara)', zip: '337321' },
  { city: 'Turmaş (Hunedoara)', zip: '337322' },
  { city: 'Orăştioara de Sus (Hunedoara)', zip: '337325' },
  { city: 'Bucium (Hunedoara)', zip: '337326' },
  { city: 'Costeşti (Hunedoara)', zip: '337327' },
  { city: 'Costeşti-Deal (Hunedoara)', zip: '337328' },
  { city: 'Grădiştea de Munte (Hunedoara)', zip: '337329' },
  { city: 'Ludeştii de Jos (Hunedoara)', zip: '337331' },
  { city: 'Ludeştii de Sus (Hunedoara)', zip: '337332' },
  { city: 'Ocolişu Mic (Hunedoara)', zip: '337333' },
  { city: 'Pestişu Mic (Hunedoara)', zip: '337335' },
  { city: 'Almaşu Mic (Hunedoara)', zip: '337336' },
  { city: 'Ciulpăz (Hunedoara)', zip: '337337' },
  { city: 'Cutin (Hunedoara)', zip: '337338' },
  { city: 'Dumbrava (Hunedoara)', zip: '337339' },
  { city: 'Josani (Hunedoara)', zip: '337341' },
  { city: 'Mănerău (Hunedoara)', zip: '337342' },
  { city: 'Nandru (Hunedoara)', zip: '337343' },
  { city: 'Valea Nandrului (Hunedoara)', zip: '337344' },
  { city: 'Pui (Hunedoara)', zip: '337345' },
  { city: 'Băieşti (Hunedoara)', zip: '337346' },
  { city: 'Federi (Hunedoara)', zip: '337347' },
  { city: 'Fizeşti (Hunedoara)', zip: '337348' },
  { city: 'Galaţi (Hunedoara)', zip: '337349' },
  { city: 'Hobiţa (Hunedoara)', zip: '337351' },
  { city: 'Ohaba-Ponor (Hunedoara)', zip: '337352' },
  { city: 'Ponor (Hunedoara)', zip: '337353' },
  { city: 'Râu Bărbat (Hunedoara)', zip: '337354' },
  { city: 'Ruşor (Hunedoara)', zip: '337356' },
  { city: 'Şerel (Hunedoara)', zip: '337357' },
  { city: 'Uric (Hunedoara)', zip: '337358' },
  { city: 'Rapoltu Mare (Hunedoara)', zip: '337365' },
  { city: 'Bobâlna (Hunedoara)', zip: '337366' },
  { city: 'Boiu (Hunedoara)', zip: '337367' },
  { city: 'Folt (Hunedoara)', zip: '337368' },
  { city: 'Rapolţel (Hunedoara)', zip: '337369' },
  { city: 'Răchitova (Hunedoara)', zip: '337370' },
  { city: 'Boiţa (Hunedoara)', zip: '337371' },
  { city: 'Ciula Mare (Hunedoara)', zip: '337372' },
  { city: 'Ciula Mică (Hunedoara)', zip: '337373' },
  { city: 'Goteşti (Hunedoara)', zip: '337374' },
  { city: 'Mesteacăn (Răchitova) (Hunedoara)', zip: '337376' },
  { city: 'Vălioara (Hunedoara)', zip: '337377' },
  { city: 'Râu de Mori (Hunedoara)', zip: '337380' },
  { city: 'Brazi (Hunedoara)', zip: '337381' },
  { city: 'Clopotiva (Hunedoara)', zip: '337382' },
  { city: 'Ohaba-Sibişel (Hunedoara)', zip: '337383' },
  { city: 'Ostrov (Hunedoara)', zip: '337384' },
  { city: 'Ostrovel (Hunedoara)', zip: '337386' },
  { city: 'Ostrovu Mic (Hunedoara)', zip: '337387' },
  { city: 'Sibişel (Râu de Mori) (Hunedoara)', zip: '337388' },
  { city: 'Suseni (Hunedoara)', zip: '337389' },
  { city: 'Unciuc (Hunedoara)', zip: '337391' },
  { city: 'Valea Dâljii (Hunedoara)', zip: '337392' },
  { city: 'Ribiţa (Hunedoara)', zip: '337400' },
  { city: 'Crişan (Hunedoara)', zip: '337401' },
  { city: 'Dumbrava de Jos (Hunedoara)', zip: '337402' },
  { city: 'Dumbrava de Sus (Hunedoara)', zip: '337403' },
  { city: 'Ribicioara (Hunedoara)', zip: '337404' },
  { city: 'Uibăreşti (Hunedoara)', zip: '337406' },
  { city: 'Romos (Hunedoara)', zip: '337410' },
  { city: 'Ciungu Mare (Hunedoara)', zip: '337411' },
  { city: 'Pişchinţi (Hunedoara)', zip: '337412' },
  { city: 'Romoşel (Hunedoara)', zip: '337413' },
  { city: 'Vaidei (Hunedoara)', zip: '337414' },
  { city: 'Sarmizegetusa (Hunedoara)', zip: '337415' },
  { city: 'Breazova (Hunedoara)', zip: '337416' },
  { city: 'Hobiţa-Grădişte (Hunedoara)', zip: '337417' },
  { city: 'Păucineşti (Hunedoara)', zip: '337418' },
  { city: 'Zeicani (Hunedoara)', zip: '337419' },
  { city: 'Sălaşu de Sus (Hunedoara)', zip: '337420' },
  { city: 'Coroieşti (Hunedoara)', zip: '337421' },
  { city: 'Mălăieşti (Hunedoara)', zip: '337422' },
  { city: 'Nucşoara (Hunedoara)', zip: '337423' },
  { city: 'Ohaba de sub Piatră (Hunedoara)', zip: '337424' },
  { city: 'Paroş (Hunedoara)', zip: '337426' },
  { city: 'Peştera (Sălaşu de Sus) (Hunedoara)', zip: '337427' },
  { city: 'Râu Alb (Hunedoara)', zip: '337428' },
  { city: 'Râu Mic (Hunedoara)', zip: '337429' },
  { city: 'Sălaşu de Jos (Hunedoara)', zip: '337431' },
  { city: 'Zăvoi (Hunedoara)', zip: '337432' },
  { city: 'Sântămăria-Orlea (Hunedoara)', zip: '337440' },
  { city: 'Balomir (Hunedoara)', zip: '337441' },
  { city: 'Bărăştii Haţegului (Hunedoara)', zip: '337442' },
  { city: 'Bucium-Orlea (Hunedoara)', zip: '337443' },
  { city: 'Ciopeia (Hunedoara)', zip: '337444' },
  { city: 'Săcel (Hunedoara)', zip: '337446' },
  { city: 'Sânpetru (Hunedoara)', zip: '337447' },
  { city: 'Subcetate (Hunedoara)', zip: '337448' },
  { city: 'Vadu (Hunedoara)', zip: '337449' },
  { city: 'Şoimuş (Hunedoara)', zip: '337450' },
  { city: 'Bălata (Hunedoara)', zip: '337451' },
  { city: 'Bejan (Hunedoara)', zip: '337452' },
  { city: 'Bejan-Târnăviţa (Hunedoara)', zip: '337453' },
  { city: 'Boholt (Hunedoara)', zip: '337454' },
  { city: 'Căinelu de Jos (Hunedoara)', zip: '337456' },
  { city: 'Chişcădaga (Hunedoara)', zip: '337457' },
  { city: 'Fornădia (Hunedoara)', zip: '337458' },
  { city: 'Păuliş (Hunedoara)', zip: '337459' },
  { city: 'Sulighete (Hunedoara)', zip: '337461' },
  { city: 'Teliucu Inferior (Hunedoara)', zip: '337465' },
  { city: 'Cinciş-Cerna (Hunedoara)', zip: '337466' },
  { city: 'Izvoarele (Hunedoara)', zip: '337467' },
  { city: 'Teliucu Superior (Hunedoara)', zip: '337468' },
  { city: 'Tomeşti (Hunedoara)', zip: '337470' },
  { city: 'Dobroţ (Hunedoara)', zip: '337471' },
  { city: 'Leauţ (Hunedoara)', zip: '337472' },
  { city: 'Livada (Hunedoara)', zip: '337473' },
  { city: 'Obârşa (Hunedoara)', zip: '337474' },
  { city: 'Şteia (Hunedoara)', zip: '337476' },
  { city: 'Tiuleşti (Hunedoara)', zip: '337477' },
  { city: 'Valea Mare de Criş (Hunedoara)', zip: '337478' },
  { city: 'Topliţa (Hunedoara)', zip: '337480' },
  { city: 'Curpenii Silvaşului (Hunedoara)', zip: '337481' },
  { city: 'Dăbâca (Hunedoara)', zip: '337482' },
  { city: 'Dealu Mic (Hunedoara)', zip: '337483' },
  { city: 'Goleş (Hunedoara)', zip: '337484' },
  { city: 'Hăşdău (Hunedoara)', zip: '337486' },
  { city: 'Mosoru (Hunedoara)', zip: '337487' },
  { city: 'Vălari (Hunedoara)', zip: '337488' },
  { city: 'Toteşti (Hunedoara)', zip: '337490' },
  { city: 'Cârneşti (Hunedoara)', zip: '337491' },
  { city: 'Copaci (Hunedoara)', zip: '337492' },
  { city: 'Păclişa (Hunedoara)', zip: '337493' },
  { city: 'Reea (Hunedoara)', zip: '337494' },
  { city: 'Turdaş (Hunedoara)', zip: '337495' },
  { city: 'Pricaz (Hunedoara)', zip: '337496' },
  { city: 'Râpaş (Hunedoara)', zip: '337497' },
  { city: 'Spini (Hunedoara)', zip: '337498' },
  { city: 'Vaţa de Jos (Hunedoara)', zip: '337500' },
  { city: 'Basarabasa (Hunedoara)', zip: '337501' },
  { city: 'Birtin (Hunedoara)', zip: '337502' },
  { city: 'Brotuna (Hunedoara)', zip: '337503' },
  { city: 'Căzăneşti (Hunedoara)', zip: '337504' },
  { city: 'Ciungani (Hunedoara)', zip: '337506' },
  { city: 'Ocişor (Hunedoara)', zip: '337507' },
  { city: 'Ociu (Hunedoara)', zip: '337508' },
  { city: 'Prăvăleni (Hunedoara)', zip: '337509' },
  { city: 'Prihodişte (Vaţa de Jos) (Hunedoara)', zip: '337511' },
  { city: 'Tătărăştii de Criş (Hunedoara)', zip: '337512' },
  { city: 'Târnava de Criş (Hunedoara)', zip: '337513' },
  { city: 'Vaţa de Sus (Hunedoara)', zip: '337514' },
  { city: 'Vălişoara (Hunedoara)', zip: '337520' },
  { city: 'Dealu Mare (Hunedoara)', zip: '337521' },
  { city: 'Săliştioara (Hunedoara)', zip: '337522' },
  { city: 'Stoieneasa (Hunedoara)', zip: '337523' },
  { city: 'Veţel (Hunedoara)', zip: '337525' },
  { city: 'Boia Bârzii (Hunedoara)', zip: '337526' },
  { city: 'Bretelin (Hunedoara)', zip: '337527' },
  { city: 'Căoi (Hunedoara)', zip: '337528' },
  { city: 'Herepeia (Hunedoara)', zip: '337529' },
  { city: 'Leşnic (Hunedoara)', zip: '337531' },
  { city: 'Mintia (Hunedoara)', zip: '337532' },
  { city: 'Muncelu Mare (Hunedoara)', zip: '337533' },
  { city: 'Muncelu Mic (Hunedoara)', zip: '337534' },
  { city: 'Runcu Mic (Hunedoara)', zip: '337536' },
  { city: 'Vorţa (Hunedoara)', zip: '337540' },
  { city: 'Certeju de Jos (Hunedoara)', zip: '337541' },
  { city: 'Coaja (Hunedoara)', zip: '337542' },
  { city: 'Dumeşti (Hunedoara)', zip: '337543' },
  { city: 'Luncşoara (Hunedoara)', zip: '337544' },
  { city: 'Valea Poienii (Hunedoara)', zip: '337546' },
  { city: 'Visca (Hunedoara)', zip: '337547' },
  { city: 'Zam (Hunedoara)', zip: '337550' },
  { city: 'Almaş-Sălişte (Hunedoara)', zip: '337551' },
  { city: 'Almăşel (Hunedoara)', zip: '337552' },
  { city: 'Brăşeu (Hunedoara)', zip: '337553' },
  { city: 'Cerbia (Hunedoara)', zip: '337554' },
  { city: 'Deleni (Hunedoara)', zip: '337556' },
  { city: 'Godineşti (Hunedoara)', zip: '337557' },
  { city: 'Micăneşti (Hunedoara)', zip: '337558' },
  { city: 'Pogăneşti (Hunedoara)', zip: '337559' },
  { city: 'Pojoga (Hunedoara)', zip: '337561' },
  { city: 'Sălciva (Hunedoara)', zip: '337562' },
  { city: 'Tămăşeşti (Hunedoara)', zip: '337563' },
  { city: 'Valea (Hunedoara)', zip: '337564' },
  { city: 'Bora (Ialomiţa)', zip: '920001' },
  { city: 'Slobozia Nouă (Ialomiţa)', zip: '920002' },
  { city: 'Slobozia (Ialomiţa)', zip: '920003' },
  { city: 'Feteşti (Ialomiţa)', zip: '925100' },
  { city: 'Buliga (Ialomiţa)', zip: '925101' },
  { city: 'Vlaşca (Ialomiţa)', zip: '925102' },
  { city: 'Feteşti-Gară (Ialomiţa)', zip: '925150' },
  { city: 'Ţăndărei (Ialomiţa)', zip: '925200' },
  { city: 'Urziceni (Ialomiţa)', zip: '925300' },
  { city: 'Adâncata (Ialomiţa)', zip: '927005' },
  { city: 'Patru Fraţi (Ialomiţa)', zip: '927006' },
  { city: 'Albeşti (Ialomiţa)', zip: '927010' },
  { city: 'Bataluri (Ialomiţa)', zip: '927011' },
  { city: 'Bueşti (Ialomiţa)', zip: '927012' },
  { city: 'Marsilieni (Ialomiţa)', zip: '927013' },
  { city: 'Alexeni (Ialomiţa)', zip: '927015' },
  { city: 'Amara (Ialomiţa)', zip: '927020' },
  { city: 'Amara Nouă (Ialomiţa)', zip: '927021' },
  { city: 'Andrăşeşti (Ialomiţa)', zip: '927025' },
  { city: 'Orboeşti (Ialomiţa)', zip: '927026' },
  { city: 'Armăşeşti (Ialomiţa)', zip: '927030' },
  { city: 'Bărbuleşti (Ialomiţa)', zip: '927031' },
  { city: 'Malu Roşu (Ialomiţa)', zip: '927032' },
  { city: 'Nenişori (Ialomiţa)', zip: '927033' },
  { city: 'Axintele (Ialomiţa)', zip: '927035' },
  { city: 'Bărbătescu (Ialomiţa)', zip: '927036' },
  { city: 'Horia (Ialomiţa)', zip: '927037' },
  { city: 'Balaciu (Ialomiţa)', zip: '927040' },
  { city: 'Copuzu (Ialomiţa)', zip: '927041' },
  { city: 'Crăsanii de Jos (Ialomiţa)', zip: '927042' },
  { city: 'Crăsanii de Sus (Ialomiţa)', zip: '927043' },
  { city: 'Sărăţeni (Ialomiţa)', zip: '927044' },
  { city: 'Bărcăneşti (Ialomiţa)', zip: '927045' },
  { city: 'Condeeşti (Ialomiţa)', zip: '927046' },
  { city: 'Borduşani (Ialomiţa)', zip: '927050' },
  { city: 'Cegani (Ialomiţa)', zip: '927051' },
  { city: 'Brazii (Ialomiţa)', zip: '927055' },
  { city: 'Maia (Ialomiţa)', zip: '927056' },
  { city: 'Movileanca (Ialomiţa)', zip: '927057' },
  { city: 'Răsimnicea (Ialomiţa)', zip: '927058' },
  { city: 'Bucu (Ialomiţa)', zip: '927060' },
  { city: 'Ograda (Ialomiţa)', zip: '927061' },
  { city: 'Căzăneşti (Ialomiţa)', zip: '927065' },
  { city: 'Ciocârlia (Ialomiţa)', zip: '927070' },
  { city: 'Cotorca (Ialomiţa)', zip: '927071' },
  { city: 'Ciochina (Ialomiţa)', zip: '927075' },
  { city: 'Borduşelu (Ialomiţa)', zip: '927076' },
  { city: 'Orezu (Ialomiţa)', zip: '927077' },
  { city: 'Piersica (Ialomiţa)', zip: '927078' },
  { city: 'Ciulniţa (Ialomiţa)', zip: '927080' },
  { city: 'Ion Ghica (Ialomiţa)', zip: '927081' },
  { city: 'Ivăneşti (Ialomiţa)', zip: '927082' },
  { city: 'Poiana (Ialomiţa)', zip: '927083' },
  { city: 'Cocora (Ialomiţa)', zip: '927085' },
  { city: 'Colelia (Ialomiţa)', zip: '927086' },
  { city: 'Cosâmbeşti (Ialomiţa)', zip: '927090' },
  { city: 'Gimbăşani (Ialomiţa)', zip: '927091' },
  { city: 'Mărculeşti (Ialomiţa)', zip: '927092' },
  { city: 'Coşereni (Ialomiţa)', zip: '927095' },
  { city: 'Borăneşti (Ialomiţa)', zip: '927096' },
  { city: 'Sinteşti (Ialomiţa)', zip: '927097' },
  { city: 'Drăgoeşti (Ialomiţa)', zip: '927100' },
  { city: 'Chiroiu-Pământeni (Ialomiţa)', zip: '927101' },
  { city: 'Chiroiu-Satu Nou (Ialomiţa)', zip: '927102' },
  { city: 'Chiroiu-Ungureni (Ialomiţa)', zip: '927103' },
  { city: 'Valea Bisericii (Ialomiţa)', zip: '927104' },
  { city: 'Dridu (Ialomiţa)', zip: '927105' },
  { city: 'Dridu-Snagov (Ialomiţa)', zip: '927106' },
  { city: 'Moldoveni (Ialomiţa)', zip: '927107' },
  { city: 'Făcăeni (Ialomiţa)', zip: '927110' },
  { city: 'Progresu (Ialomiţa)', zip: '927111' },
  { city: 'Fierbinţi-Târg (Ialomiţa)', zip: '927115' },
  { city: 'Fierbinţii de Jos (Ialomiţa)', zip: '927116' },
  { city: 'Fierbinţii de Sus (Ialomiţa)', zip: '927117' },
  { city: 'Grecii de Jos (Ialomiţa)', zip: '927118' },
  { city: 'Gârbovi (Ialomiţa)', zip: '927120' },
  { city: 'Gheorghe Doja (Ialomiţa)', zip: '927125' },
  { city: 'Gheorghe Lazăr (Ialomiţa)', zip: '927130' },
  { city: 'Giurgeni (Ialomiţa)', zip: '927135' },
  { city: 'Grindu (Ialomiţa)', zip: '927140' },
  { city: 'Griviţa (Ialomiţa)', zip: '927145' },
  { city: 'Smirna (Ialomiţa)', zip: '927146' },
  { city: 'Traian (Ialomiţa)', zip: '927147' },
  { city: 'Ion Roată (Ialomiţa)', zip: '927150' },
  { city: 'Broşteni (Ialomiţa)', zip: '927151' },
  { city: 'Jilavele (Ialomiţa)', zip: '927155' },
  { city: 'Slătioarele (Ialomiţa)', zip: '927156' },
  { city: 'Manasia (Ialomiţa)', zip: '927160' },
  { city: 'Mihail Kogălniceanu (Ialomiţa)', zip: '927165' },
  { city: 'Gura Ialomiţei (Ialomiţa)', zip: '927166' },
  { city: 'Hagieni (Ialomiţa)', zip: '927167' },
  { city: 'Luciu (Ialomiţa)', zip: '927168' },
  { city: 'Miloşeşti (Ialomiţa)', zip: '927170' },
  { city: 'Nicoleşti (Ialomiţa)', zip: '927171' },
  { city: 'Tovărăşia (Ialomiţa)', zip: '927172' },
  { city: 'Movila (Ialomiţa)', zip: '927175' },
  { city: 'Bărăganu (Ialomiţa)', zip: '927176' },
  { city: 'Moviliţa (Ialomiţa)', zip: '927180' },
  { city: 'Biţina-Pământeni (Ialomiţa)', zip: '927181' },
  { city: 'Biţina-Ungureni (Ialomiţa)', zip: '927182' },
  { city: 'Roşiori (Ialomiţa)', zip: '927183' },
  { city: 'Munteni-Buzău (Ialomiţa)', zip: '927185' },
  { city: 'Perieţi (Ialomiţa)', zip: '927190' },
  { city: 'Fundata (Ialomiţa)', zip: '927191' },
  { city: 'Misleanu (Ialomiţa)', zip: '927192' },
  { city: 'Păltinişu (Ialomiţa)', zip: '927193' },
  { city: 'Stejaru (Ialomiţa)', zip: '927194' },
  { city: 'Reviga (Ialomiţa)', zip: '927195' },
  { city: 'Crunţi (Ialomiţa)', zip: '927196' },
  { city: 'Mircea cel Bătrân (Ialomiţa)', zip: '927197' },
  { city: 'Rovine (Ialomiţa)', zip: '927198' },
  { city: 'Sălcioara (Ialomiţa)', zip: '927200' },
  { city: 'Raşi (Ialomiţa)', zip: '927201' },
  { city: 'Săveni (Ialomiţa)', zip: '927205' },
  { city: 'Frăţileşti (Ialomiţa)', zip: '927206' },
  { city: 'Lăcusteni (Ialomiţa)', zip: '927207' },
  { city: 'Platoneşti (Ialomiţa)', zip: '927208' },
  { city: 'Scânteia (Ialomiţa)', zip: '927210' },
  { city: 'Iazu (Ialomiţa)', zip: '927211' },
  { city: 'Sfântu Gheorghe (Ialomiţa)', zip: '927215' },
  { city: 'Butoiu (Ialomiţa)', zip: '927216' },
  { city: 'Malu (Ialomiţa)', zip: '927217' },
  { city: 'Sineşti (Ialomiţa)', zip: '927220' },
  { city: 'Boteni (Ialomiţa)', zip: '927221' },
  { city: 'Cătruneşti (Ialomiţa)', zip: '927222' },
  { city: 'Hagieşti (Ialomiţa)', zip: '927223' },
  { city: 'Lilieci (Ialomiţa)', zip: '927224' },
  { city: 'Livedea (Ialomiţa)', zip: '927226' },
  { city: 'Stelnica (Ialomiţa)', zip: '927230' },
  { city: 'Maltezi (Ialomiţa)', zip: '927231' },
  { city: 'Retezatu (Ialomiţa)', zip: '927232' },
  { city: 'Sudiţi (Ialomiţa)', zip: '927235' },
  { city: 'Gura Văii (Ialomiţa)', zip: '927236' },
  { city: 'Valea Ciorii (Ialomiţa)', zip: '927240' },
  { city: 'Bucşa (Ialomiţa)', zip: '927241' },
  { city: 'Dumitreşti (Ialomiţa)', zip: '927242' },
  { city: 'Murgeanca (Ialomiţa)', zip: '927243' },
  { city: 'Valea Măcrişului (Ialomiţa)', zip: '927245' },
  { city: 'Grindaşi (Ialomiţa)', zip: '927246' },
  { city: 'Vlădeni (Ialomiţa)', zip: '927250' },
  { city: 'Iaşi (Iaşi)', zip: '700001' },
  { city: 'Hârlău (Iaşi)', zip: '705100' },
  { city: 'Pârcovaci (Iaşi)', zip: '705101' },
  { city: 'Paşcani (Iaşi)', zip: '705200' },
  { city: 'Blăgeşti (Iaşi)', zip: '705201' },
  { city: 'Boşteni (Iaşi)', zip: '705202' },
  { city: 'Gâşteşti (Iaşi)', zip: '705203' },
  { city: 'Lunca (Paşcani) (Iaşi)', zip: '705204' },
  { city: 'Sodomeni (Iaşi)', zip: '705205' },
  { city: 'Târgu Frumos (Iaşi)', zip: '705300' },
  { city: 'Balş (Iaşi)', zip: '705301' },
  { city: 'Boureni (Balş) (Iaşi)', zip: '705302' },
  { city: 'Buznea (Iaşi)', zip: '705303' },
  { city: 'Coasta Măgurii (Iaşi)', zip: '705304' },
  { city: 'Costeşti (Iaşi)', zip: '705305' },
  { city: 'Dădeşti (Iaşi)', zip: '705306' },
  { city: 'Găneşti (Iaşi)', zip: '705307' },
  { city: 'Giurgeşti (Iaşi)', zip: '705308' },
  { city: 'Ion Neculce (Iaşi)', zip: '705309' },
  { city: 'Prigoreni (Iaşi)', zip: '705310' },
  { city: 'Războieni (Iaşi)', zip: '705311' },
  { city: 'Alexandru I. Cuza (Iaşi)', zip: '707005' },
  { city: 'Kogălniceni (Iaşi)', zip: '707006' },
  { city: 'Scheia (Iaşi)', zip: '707007' },
  { city: 'Volintireşti (Iaşi)', zip: '707008' },
  { city: 'Andrieşeni (Iaşi)', zip: '707010' },
  { city: 'Buhăeni (Iaşi)', zip: '707011' },
  { city: 'Drăgăneşti (Iaşi)', zip: '707012' },
  { city: 'Fântânele (Andrieşeni) (Iaşi)', zip: '707013' },
  { city: 'Glăvăneşti (Iaşi)', zip: '707014' },
  { city: 'Iepureni (Andrieşeni) (Iaşi)', zip: '707016' },
  { city: 'Spineni (Iaşi)', zip: '707017' },
  { city: 'Aroneanu (Iaşi)', zip: '707020' },
  { city: 'Dorobanţ (Iaşi)', zip: '707021' },
  { city: 'Rediu Aldei (Iaşi)', zip: '707022' },
  { city: 'Şorogari (Iaşi)', zip: '707023' },
  { city: 'Bălţaţi (Iaşi)', zip: '707025' },
  { city: 'Cotârgaci (Iaşi)', zip: '707026' },
  { city: 'Filiaşi (Iaşi)', zip: '707027' },
  { city: 'Mădârjeşti (Iaşi)', zip: '707028' },
  { city: 'Podişu (Iaşi)', zip: '707029' },
  { city: 'Sârca (Iaşi)', zip: '707031' },
  { city: 'Valea Oilor (Iaşi)', zip: '707032' },
  { city: 'Bârnova (Iaşi)', zip: '707035' },
  { city: 'Cercu (Iaşi)', zip: '707036' },
  { city: 'Păun (Iaşi)', zip: '707037' },
  { city: 'Pietrăria (Iaşi)', zip: '707038' },
  { city: 'Todirel (Iaşi)', zip: '707039' },
  { city: 'Vişan (Iaşi)', zip: '707041' },
  { city: 'Belceşti (Iaşi)', zip: '707045' },
  { city: 'Liteni (Iaşi)', zip: '707046' },
  { city: 'Munteni (Iaşi)', zip: '707047' },
  { city: 'Satu Nou (Belceşti) (Iaşi)', zip: '707048' },
  { city: 'Tansa (Belceşti) (Iaşi)', zip: '707049' },
  { city: 'Ulmi (Iaşi)', zip: '707051' },
  { city: 'Bivolari (Iaşi)', zip: '707055' },
  { city: 'Buruieneşti (Iaşi)', zip: '707056' },
  { city: 'Soloneţ (Iaşi)', zip: '707057' },
  { city: 'Tabăra (Iaşi)', zip: '707058' },
  { city: 'Traian (Iaşi)', zip: '707059' },
  { city: 'Brăeşti (Iaşi)', zip: '707060' },
  { city: 'Albeşti (Iaşi)', zip: '707061' },
  { city: 'Buda (Brăeşti) (Iaşi)', zip: '707062' },
  { city: 'Cristeşti (Brăeşti) (Iaşi)', zip: '707063' },
  { city: 'Rediu (Brăeşti) (Iaşi)', zip: '707064' },
  { city: 'Butea (Iaşi)', zip: '707065' },
  { city: 'Miclăuşeni (Iaşi)', zip: '707066' },
  { city: 'Cepleniţa (Iaşi)', zip: '707070' },
  { city: 'Buhalniţa (Iaşi)', zip: '707071' },
  { city: 'Poiana Mărului (Iaşi)', zip: '707072' },
  { city: 'Zlodica (Iaşi)', zip: '707073' },
  { city: 'Ciorteşti (Iaşi)', zip: '707075' },
  { city: 'Coropceni (Iaşi)', zip: '707076' },
  { city: 'Deleni (Ciorteşti) (Iaşi)', zip: '707077' },
  { city: 'Rotăria (Iaşi)', zip: '707078' },
  { city: 'Şerbeşti (Iaşi)', zip: '707079' },
  { city: 'Ciurea (Iaşi)', zip: '707080' },
  { city: 'Curături (Iaşi)', zip: '707081' },
  { city: 'Dumbrava (Ciurea) (Iaşi)', zip: '707082' },
  { city: 'Hlincea (Iaşi)', zip: '707083' },
  { city: 'Picioru Lupului (Iaşi)', zip: '707084' },
  { city: 'Lunca Cetăţuii (Iaşi)', zip: '707085' },
  { city: 'Slobozia (Ciurea) (Iaşi)', zip: '707086' },
  { city: 'Coarnele Caprei (Iaşi)', zip: '707100' },
  { city: 'Arama (Iaşi)', zip: '707101' },
  { city: 'Petroşica (Iaşi)', zip: '707102' },
  { city: 'Comarna (Iaşi)', zip: '707105' },
  { city: 'Curagău (Iaşi)', zip: '707106' },
  { city: 'Stânca (Comarna) (Iaşi)', zip: '707107' },
  { city: 'Osoi (Comarna) (Iaşi)', zip: '707110' },
  { city: 'Costuleni (Iaşi)', zip: '707115' },
  { city: 'Covasna (Iaşi)', zip: '707116' },
  { city: 'Cozia (Iaşi)', zip: '707117' },
  { city: 'Hiliţa (Iaşi)', zip: '707118' },
  { city: 'Cotnari (Iaşi)', zip: '707120' },
  { city: 'Bahluiu (Iaşi)', zip: '707121' },
  { city: 'Cârjoaia (Iaşi)', zip: '707122' },
  { city: 'Cireşeni (Iaşi)', zip: '707123' },
  { city: 'Făgăt (Iaşi)', zip: '707124' },
  { city: 'Hodora (Iaşi)', zip: '707126' },
  { city: 'Horodiştea (Iaşi)', zip: '707127' },
  { city: 'Iosupeni (Iaşi)', zip: '707128' },
  { city: 'Lupăria (Iaşi)', zip: '707129' },
  { city: 'Valea Racului (Iaşi)', zip: '707131' },
  { city: 'Zbereni (Iaşi)', zip: '707132' },
  { city: 'Cozmeşti (Iaşi)', zip: '707140' },
  { city: 'Podolenii de Jos (Iaşi)', zip: '707141' },
  { city: 'Podolenii de Sus (Iaşi)', zip: '707142' },
  { city: 'Cristeşti (Iaşi)', zip: '707145' },
  { city: 'Homiţa (Iaşi)', zip: '707146' },
  { city: 'Cucuteni (Iaşi)', zip: '707150' },
  { city: 'Băiceni (Cucuteni) (Iaşi)', zip: '707151' },
  { city: 'Bărbăteşti (Iaşi)', zip: '707152' },
  { city: 'Săcăreşti (Iaşi)', zip: '707153' },
  { city: 'Dagâţa (Iaşi)', zip: '707155' },
  { city: 'Băluşeşti (Iaşi)', zip: '707156' },
  { city: 'Boatca (Iaşi)', zip: '707157' },
  { city: 'Buzdug (Iaşi)', zip: '707158' },
  { city: 'Mănăstirea (Iaşi)', zip: '707159' },
  { city: 'Piscu Rusului (Iaşi)', zip: '707161' },
  { city: 'Poienile (Iaşi)', zip: '707162' },
  { city: 'Tarniţa (Iaşi)', zip: '707163' },
  { city: 'Zece Prăjini (Iaşi)', zip: '707164' },
  { city: 'Deleni (Iaşi)', zip: '707165' },
  { city: 'Feredeni (Iaşi)', zip: '707166' },
  { city: 'Leahu-Nacu (Iaşi)', zip: '707167' },
  { city: 'Maxut (Iaşi)', zip: '707168' },
  { city: 'Poiana (Deleni) (Iaşi)', zip: '707169' },
  { city: 'Slobozia (Deleni) (Iaşi)', zip: '707171' },
  { city: 'Dobrovăţ (Iaşi)', zip: '707175' },
  { city: 'Dolheşti (Iaşi)', zip: '707180' },
  { city: 'Brădiceşti (Iaşi)', zip: '707181' },
  { city: 'Pietriş (Iaşi)', zip: '707182' },
  { city: 'Dumeşti (Iaşi)', zip: '707185' },
  { city: 'Banu (Iaşi)', zip: '707186' },
  { city: 'Chilişoaia (Iaşi)', zip: '707187' },
  { city: 'Hoiseşti (Iaşi)', zip: '707188' },
  { city: 'Păuşeşti (Iaşi)', zip: '707189' },
  { city: 'Erbiceni (Iaşi)', zip: '707190' },
  { city: 'Bârleşti (Iaşi)', zip: '707191' },
  { city: 'Spinoasa (Iaşi)', zip: '707192' },
  { city: 'Sprânceana (Iaşi)', zip: '707193' },
  { city: 'Totoeşti (Iaşi)', zip: '707194' },
  { city: 'Focuri (Iaşi)', zip: '707195' },
  { city: 'Fântânele (Iaşi)', zip: '707196' },
  { city: 'Golăieşti (Iaşi)', zip: '707200' },
  { city: 'Bran (Iaşi)', zip: '707201' },
  { city: 'Cilibiu (Iaşi)', zip: '707202' },
  { city: 'Cotu lui Ivan (Iaşi)', zip: '707203' },
  { city: 'Grădinari (Iaşi)', zip: '707204' },
  { city: 'Medeleni (Iaşi)', zip: '707206' },
  { city: 'Petreşti (Iaşi)', zip: '707207' },
  { city: 'Podu Jijiei (Iaşi)', zip: '707208' },
  { city: 'Gorban (Iaşi)', zip: '707210' },
  { city: 'Gura Bohotin (Iaşi)', zip: '707211' },
  { city: 'Podu Hagiului (Iaşi)', zip: '707212' },
  { city: 'Scoposeni (Gorban) (Iaşi)', zip: '707213' },
  { city: 'Zberoaia (Iaşi)', zip: '707214' },
  { city: 'Grajduri (Iaşi)', zip: '707215' },
  { city: 'Cărbunari (Iaşi)', zip: '707216' },
  { city: 'Corcodel (Iaşi)', zip: '707217' },
  { city: 'Lunca (Grajduri) (Iaşi)', zip: '707218' },
  { city: 'Pădureni (Grajduri) (Iaşi)', zip: '707219' },
  { city: 'Poiana cu Cetate (Iaşi)', zip: '707221' },
  { city: 'Valea Satului (Iaşi)', zip: '707222' },
  { city: 'Gropniţa (Iaşi)', zip: '707225' },
  { city: 'Bulbucani (Iaşi)', zip: '707226' },
  { city: 'Forăşti (Iaşi)', zip: '707227' },
  { city: 'Mălăeşti (Iaşi)', zip: '707228' },
  { city: 'Săveni (Iaşi)', zip: '707229' },
  { city: 'Sângeri (Iaşi)', zip: '707231' },
  { city: 'Grozeşti (Iaşi)', zip: '707235' },
  { city: 'Colţu Cornii (Iaşi)', zip: '707236' },
  { city: 'Sălăgeni (Iaşi)', zip: '707237' },
  { city: 'Hălăuceşti (Iaşi)', zip: '707240' },
  { city: 'Luncaşi (Iaşi)', zip: '707241' },
  { city: 'Heleşteni (Iaşi)', zip: '707245' },
  { city: 'Hărmăneasa (Iaşi)', zip: '707246' },
  { city: 'Movileni (Heleşteni) (Iaşi)', zip: '707247' },
  { city: 'Oboroceni (Iaşi)', zip: '707248' },
  { city: 'Holboca (Iaşi)', zip: '707250' },
  { city: 'Cristeşti (Holboca) (Iaşi)', zip: '707251' },
  { city: 'Dancu (Iaşi)', zip: '707252' },
  { city: 'Orzeni (Iaşi)', zip: '707253' },
  { city: 'Rusenii Noi (Iaşi)', zip: '707254' },
  { city: 'Rusenii Vechi (Iaşi)', zip: '707256' },
  { city: 'Valea Lungă (Iaşi)', zip: '707257' },
  { city: 'Horleşti (Iaşi)', zip: '707260' },
  { city: 'Bogdăneşti (Iaşi)', zip: '707261' },
  { city: 'Scoposeni (Horleşti) (Iaşi)', zip: '707262' },
  { city: 'Ipatele (Iaşi)', zip: '707265' },
  { city: 'Alexeşti (Iaşi)', zip: '707266' },
  { city: 'Bâcu (Iaşi)', zip: '707267' },
  { city: 'Cuza Vodă (Ipatele) (Iaşi)', zip: '707268' },
  { city: 'Lespezi (Iaşi)', zip: '707270' },
  { city: 'Buda (Lespezi) (Iaşi)', zip: '707271' },
  { city: 'Bursuc-Deal (Iaşi)', zip: '707272' },
  { city: 'Bursuc-Vale (Iaşi)', zip: '707273' },
  { city: 'Dumbrava (Lespezi) (Iaşi)', zip: '707274' },
  { city: 'Heci (Iaşi)', zip: '707276' },
  { city: 'Leţcani (Iaşi)', zip: '707280' },
  { city: 'Bogonos (Iaşi)', zip: '707281' },
  { city: 'Cogeasca (Iaşi)', zip: '707282' },
  { city: 'Cucuteni (Leţcani) (Iaşi)', zip: '707283' },
  { city: 'Lungani (Iaşi)', zip: '707285' },
  { city: 'Crucea (Iaşi)', zip: '707286' },
  { city: 'Goeşti (Iaşi)', zip: '707287' },
  { city: 'Zmeu (Iaşi)', zip: '707288' },
  { city: 'Mădârjac (Iaşi)', zip: '707290' },
  { city: 'Bojila (Iaşi)', zip: '707291' },
  { city: 'Frumuşica (Iaşi)', zip: '707292' },
  { city: 'Mirceşti (Iaşi)', zip: '707295' },
  { city: 'Iugani (Iaşi)', zip: '707296' },
  { city: 'Izvoarele (Iaşi)', zip: '707297' },
  { city: 'Răchiteni (Iaşi)', zip: '707298' },
  { city: 'Ursăreşti (Iaşi)', zip: '707299' },
  { city: 'Mironeasa (Iaşi)', zip: '707300' },
  { city: 'Schitu Hadâmbului (Iaşi)', zip: '707301' },
  { city: 'Urşiţa (Iaşi)', zip: '707302' },
  { city: 'Miroslava (Iaşi)', zip: '707305' },
  { city: 'Balciu (Iaşi)', zip: '707306' },
  { city: 'Brătuleni (Iaşi)', zip: '707307' },
  { city: 'Ciurbeşti (Iaşi)', zip: '707308' },
  { city: 'Corneşti (Iaşi)', zip: '707309' },
  { city: 'Dancaş (Iaşi)', zip: '707311' },
  { city: 'Găureni (Iaşi)', zip: '707312' },
  { city: 'Horpaz (Iaşi)', zip: '707313' },
  { city: 'Proselnici (Iaşi)', zip: '707314' },
  { city: 'Uricani (Iaşi)', zip: '707316' },
  { city: 'Valea Adâncă (Iaşi)', zip: '707317' },
  { city: 'Valea Ursului (Iaşi)', zip: '707318' },
  { city: 'Voroveşti (Iaşi)', zip: '707319' },
  { city: 'Mirosloveşti (Iaşi)', zip: '707325' },
  { city: 'Ciohorăni (Iaşi)', zip: '707326' },
  { city: 'Miteşti (Iaşi)', zip: '707327' },
  { city: 'Soci (Iaşi)', zip: '707328' },
  { city: 'Verşeni (Iaşi)', zip: '707329' },
  { city: 'Mogoşeşti (Iaşi)', zip: '707330' },
  { city: 'Budeşti (Iaşi)', zip: '707331' },
  { city: 'Hadâmbu (Iaşi)', zip: '707332' },
  { city: 'Mânjeşti (Iaşi)', zip: '707333' },
  { city: 'Mogoşeşti-Siret (Iaşi)', zip: '707335' },
  { city: 'Muncelu de Sus (Iaşi)', zip: '707336' },
  { city: 'Tudor Vladimirescu (Iaşi)', zip: '707337' },
  { city: 'Moşna (Iaşi)', zip: '707340' },
  { city: 'Moţca (Iaşi)', zip: '707345' },
  { city: 'Boureni (Moţca) (Iaşi)', zip: '707346' },
  { city: 'Movileni (Iaşi)', zip: '707350' },
  { city: 'Iepureni (Movileni) (Iaşi)', zip: '707351' },
  { city: 'Larga-Jijia (Iaşi)', zip: '707352' },
  { city: 'Potângeni (Iaşi)', zip: '707353' },
  { city: 'Oţeleni (Iaşi)', zip: '707355' },
  { city: 'Hândreşti (Iaşi)', zip: '707356' },
  { city: 'Plugari (Iaşi)', zip: '707360' },
  { city: 'Borosoaia (Iaşi)', zip: '707361' },
  { city: 'Oneşti (Iaşi)', zip: '707362' },
  { city: 'Podu Iloaiei (Iaşi)', zip: '707365' },
  { city: 'Budăi (Iaşi)', zip: '707366' },
  { city: 'Cosiţeni (Iaşi)', zip: '707367' },
  { city: 'Holm (Iaşi)', zip: '707368' },
  { city: 'Scobâlţeni (Iaşi)', zip: '707369' },
  { city: 'Popeşti (Iaşi)', zip: '707370' },
  { city: 'Doroşcani (Iaşi)', zip: '707371' },
  { city: 'Hărpăşeşti (Iaşi)', zip: '707372' },
  { city: 'Obrijeni (Iaşi)', zip: '707373' },
  { city: 'Pădureni (Popeşti) (Iaşi)', zip: '707374' },
  { city: 'Vama (Iaşi)', zip: '707376' },
  { city: 'Popricani (Iaşi)', zip: '707380' },
  { city: 'Cârlig (Iaşi)', zip: '707381' },
  { city: 'Cotu Morii (Iaşi)', zip: '707382' },
  { city: 'Cuza Vodă (Popricani) (Iaşi)', zip: '707383' },
  { city: 'Moimeşti (Iaşi)', zip: '707384' },
  { city: 'Rediu Mitropoliei (Iaşi)', zip: '707386' },
  { city: 'Ţipileşti (Iaşi)', zip: '707387' },
  { city: 'Vânători (Popricani) (Iaşi)', zip: '707388' },
  { city: 'Vulturi (Iaşi)', zip: '707389' },
  { city: 'Prisăcani (Iaşi)', zip: '707390' },
  { city: 'Măcăreşti (Iaşi)', zip: '707391' },
  { city: 'Moreni (Iaşi)', zip: '707392' },
  { city: 'Probota (Iaşi)', zip: '707395' },
  { city: 'Bălteni (Iaşi)', zip: '707396' },
  { city: 'Perieni (Iaşi)', zip: '707397' },
  { city: 'Răducăneni (Iaşi)', zip: '707400' },
  { city: 'Bohotin (Iaşi)', zip: '707401' },
  { city: 'Isaiia (Iaşi)', zip: '707402' },
  { city: 'Roşu (Iaşi)', zip: '707403' },
  { city: 'Rediu (Iaşi)', zip: '707405' },
  { city: 'Breazu (Iaşi)', zip: '707406' },
  { city: 'Horleşti (Rediu) (Iaşi)', zip: '707407' },
  { city: 'Tăuteşti (Iaşi)', zip: '707408' },
  { city: 'Valea Lupului (Iaşi)', zip: '707410' },
  { city: 'Româneşti (Iaşi)', zip: '707415' },
  { city: 'Avântu (Iaşi)', zip: '707416' },
  { city: 'Ursoaia (Iaşi)', zip: '707417' },
  { city: 'Ruginoasa (Iaşi)', zip: '707420' },
  { city: 'Dumbrăviţa (Iaşi)', zip: '707421' },
  { city: 'Rediu (Ruginoasa) (Iaşi)', zip: '707422' },
  { city: 'Vascani (Iaşi)', zip: '707423' },
  { city: 'Scânteia (Iaşi)', zip: '707425' },
  { city: 'Bodeşti (Iaşi)', zip: '707426' },
  { city: 'Boroşeşti (Iaşi)', zip: '707427' },
  { city: 'Ciocârleşti (Iaşi)', zip: '707428' },
  { city: 'Lunca Rateş (Iaşi)', zip: '707429' },
  { city: 'Rediu (Scânteia) (Iaşi)', zip: '707431' },
  { city: 'Tufeştii de Sus (Iaşi)', zip: '707432' },
  { city: 'Schitu Duca (Iaşi)', zip: '707435' },
  { city: 'Blaga (Iaşi)', zip: '707436' },
  { city: 'Dumitreştii Gălăţii (Iaşi)', zip: '707437' },
  { city: 'Pocreaca (Iaşi)', zip: '707438' },
  { city: 'Poiana (Schitu Duca) (Iaşi)', zip: '707439' },
  { city: 'Poieni (Iaşi)', zip: '707441' },
  { city: 'Satu Nou (Iaşi)', zip: '707442' },
  { city: 'Slobozia (Schitu Duca) (Iaşi)', zip: '707443' },
  { city: 'Scobinţi (Iaşi)', zip: '707445' },
  { city: 'Bădeni (Iaşi)', zip: '707446' },
  { city: 'Feteşti (Iaşi)', zip: '707447' },
  { city: 'Sticlăria (Iaşi)', zip: '707448' },
  { city: 'Zagavia (Iaşi)', zip: '707449' },
  { city: 'Sineşti (Iaşi)', zip: '707450' },
  { city: 'Bocniţa (Iaşi)', zip: '707451' },
  { city: 'Osoi (Sineşti) (Iaşi)', zip: '707452' },
  { city: 'Storneşti (Iaşi)', zip: '707453' },
  { city: 'Sireţel (Iaşi)', zip: '707455' },
  { city: 'Berezlogi (Iaşi)', zip: '707456' },
  { city: 'Humosu (Iaşi)', zip: '707457' },
  { city: 'Satu Nou (Sireţel) (Iaşi)', zip: '707458' },
  { city: 'Slobozia (Sireţel) (Iaşi)', zip: '707459' },
  { city: 'Stolniceni-Prăjescu (Iaşi)', zip: '707460' },
  { city: 'Brăteşti (Iaşi)', zip: '707461' },
  { city: 'Cozmeşti (Stolniceni-Prăjescu) (Iaşi)', zip: '707462' },
  { city: 'Strunga (Iaşi)', zip: '707465' },
  { city: 'Brătuleşti (Iaşi)', zip: '707466' },
  { city: 'Criveşti (Strunga) (Iaşi)', zip: '707467' },
  { city: 'Cucova (Iaşi)', zip: '707468' },
  { city: 'Fărcăşeni (Iaşi)', zip: '707469' },
  { city: 'Fedeleşeni (Iaşi)', zip: '707471' },
  { city: 'Gura Văii (Iaşi)', zip: '707472' },
  { city: 'Hăbăşeşti (Iaşi)', zip: '707473' },
  { city: 'Şcheia (Iaşi)', zip: '707475' },
  { city: 'Căueşti (Iaşi)', zip: '707476' },
  { city: 'Cioca-Boca (Iaşi)', zip: '707477' },
  { city: 'Drăguşeni (Iaşi)', zip: '707478' },
  { city: 'Frenciugi (Iaşi)', zip: '707479' },
  { city: 'Poiana Şcheii (Iaşi)', zip: '707481' },
  { city: 'Satu Nou (Şcheia) (Iaşi)', zip: '707482' },
  { city: 'Şipote (Iaşi)', zip: '707485' },
  { city: 'Chişcăreni (Iaşi)', zip: '707486' },
  { city: 'Hălceni (Iaşi)', zip: '707487' },
  { city: 'Iazu Nou (Iaşi)', zip: '707488' },
  { city: 'Iazu Vechi (Iaşi)', zip: '707489' },
  { city: 'Mitoc (Iaşi)', zip: '707491' },
  { city: 'Tansa (Iaşi)', zip: '707495' },
  { city: 'Suhuleţ (Iaşi)', zip: '707496' },
  { city: 'Tătăruşi (Iaşi)', zip: '707500' },
  { city: 'Iorcani (Iaşi)', zip: '707501' },
  { city: 'Pietrosu (Iaşi)', zip: '707502' },
  { city: 'Uda (Iaşi)', zip: '707503' },
  { city: 'Vâlcica (Iaşi)', zip: '707504' },
  { city: 'Todireşti (Iaşi)', zip: '707505' },
  { city: 'Băiceni (Todireşti) (Iaşi)', zip: '707506' },
  { city: 'Boldeşti (Iaşi)', zip: '707507' },
  { city: 'Hărmăneştii Noi (Iaşi)', zip: '707508' },
  { city: 'Hărmăneştii Vechi (Iaşi)', zip: '707509' },
  { city: 'Hărmăneşti (Iaşi)', zip: '707510' },
  { city: 'Stroeşti (Iaşi)', zip: '707511' },
  { city: 'Tomeşti (Iaşi)', zip: '707515' },
  { city: 'Chicerea (Iaşi)', zip: '707516' },
  { city: 'Goruni (Iaşi)', zip: '707517' },
  { city: 'Vlădiceni (Iaşi)', zip: '707518' },
  { city: 'Trifeşti (Iaşi)', zip: '707520' },
  { city: 'Hermeziu (Iaşi)', zip: '707521' },
  { city: 'Rădeni (Iaşi)', zip: '707522' },
  { city: 'Roşcani (Iaşi)', zip: '707523' },
  { city: 'Vladomira (Iaşi)', zip: '707524' },
  { city: 'Zaboloteni (Iaşi)', zip: '707526' },
  { city: 'Ţibana (Iaşi)', zip: '707530' },
  { city: 'Alexeni (Iaşi)', zip: '707531' },
  { city: 'Domniţa (Iaşi)', zip: '707532' },
  { city: 'Gârbeşti (Iaşi)', zip: '707533' },
  { city: 'Moara Ciornei (Iaşi)', zip: '707534' },
  { city: 'Oproaia (Iaşi)', zip: '707536' },
  { city: 'Poiana Mănăstirii (Iaşi)', zip: '707537' },
  { city: 'Poiana de Sus (Iaşi)', zip: '707538' },
  { city: 'Runcu (Iaşi)', zip: '707539' },
  { city: 'Vadu Vejei (Iaşi)', zip: '707541' },
  { city: 'Ţibăneşti (Iaşi)', zip: '707545' },
  { city: 'Glodenii Gândului (Iaşi)', zip: '707546' },
  { city: 'Grieşti (Iaşi)', zip: '707547' },
  { city: 'Jigoreni (Iaşi)', zip: '707548' },
  { city: 'Răsboieni (Iaşi)', zip: '707549' },
  { city: 'Recea (Iaşi)', zip: '707551' },
  { city: 'Tungujei (Iaşi)', zip: '707552' },
  { city: 'Vălenii (Iaşi)', zip: '707553' },
  { city: 'Ţigănaşi (Iaşi)', zip: '707555' },
  { city: 'Cârniceni (Iaşi)', zip: '707556' },
  { city: 'Mihail Kogălniceanu (Iaşi)', zip: '707557' },
  { city: 'Stejarii (Iaşi)', zip: '707558' },
  { city: 'Ţuţora (Iaşi)', zip: '707560' },
  { city: 'Chipereşti (Iaşi)', zip: '707561' },
  { city: 'Oprişeni (Iaşi)', zip: '707562' },
  { city: 'Ungheni (Iaşi)', zip: '707565' },
  { city: 'Bosia (Iaşi)', zip: '707566' },
  { city: 'Coada Stâncii (Iaşi)', zip: '707567' },
  { city: 'Mânzăteşti (Iaşi)', zip: '707568' },
  { city: 'Valea Seacă (Iaşi)', zip: '707570' },
  { city: 'Conţeşti (Iaşi)', zip: '707571' },
  { city: 'Topile (Iaşi)', zip: '707572' },
  { city: 'Vânători (Iaşi)', zip: '707575' },
  { city: 'Criveşti (Vânători) (Iaşi)', zip: '707576' },
  { city: 'Gura Bâdiliţei (Iaşi)', zip: '707577' },
  { city: 'Hârtoape (Iaşi)', zip: '707578' },
  { city: 'Vlădnicuţ (Iaşi)', zip: '707579' },
  { city: 'Victoria (Iaşi)', zip: '707580' },
  { city: 'Frăsuleni (Iaşi)', zip: '707581' },
  { city: 'Icuşeni (Iaşi)', zip: '707582' },
  { city: 'Luceni (Iaşi)', zip: '707583' },
  { city: 'Sculeni (Iaşi)', zip: '707584' },
  { city: 'Stânca (Victoria) (Iaşi)', zip: '707586' },
  { city: 'Şendreni (Iaşi)', zip: '707587' },
  { city: 'Vlădeni (Iaşi)', zip: '707590' },
  { city: 'Alexandru cel Bun (Iaşi)', zip: '707591' },
  { city: 'Borşa (Iaşi)', zip: '707592' },
  { city: 'Broşteni (Iaşi)', zip: '707593' },
  { city: 'Iacobeni (Iaşi)', zip: '707594' },
  { city: 'Vâlcelele (Iaşi)', zip: '707596' },
  { city: 'Voineşti (Iaşi)', zip: '707600' },
  { city: 'Lungani (Voineşti) (Iaşi)', zip: '707601' },
  { city: 'Schitu Stavnic (Iaşi)', zip: '707602' },
  { city: 'Slobozia (Voineşti) (Iaşi)', zip: '707603' },
  { city: 'Vocoteşti (Iaşi)', zip: '707604' },
  { city: 'Blidari (Maramureş)', zip: '430001' },
  { city: 'Firiza (Maramureş)', zip: '430002' },
  { city: 'Valea Neagră (Maramureş)', zip: '430003' },
  { city: 'Baia Mare (Maramureş)', zip: '430011' },
  { city: 'Baia Sprie (Maramureş)', zip: '435100' },
  { city: 'Chiuzbaia (Maramureş)', zip: '435101' },
  { city: 'Satu Nou de Sus (Maramureş)', zip: '435102' },
  { city: 'Tăuţii de Sus (Maramureş)', zip: '435103' },
  { city: 'Borşa (Maramureş)', zip: '435200' },
  { city: 'Băile Borşa (Maramureş)', zip: '435250' },
  { city: 'Cavnic (Maramureş)', zip: '435300' },
  { city: 'Seini (Maramureş)', zip: '435400' },
  { city: 'Săbişa (Maramureş)', zip: '435401' },
  { city: 'Viile Apei (Maramureş)', zip: '435402' },
  { city: 'Sighetu Marmaţiei (Maramureş)', zip: '435500' },
  { city: 'Iapa (Maramureş)', zip: '435501' },
  { city: 'Lazu Baciului (Maramureş)', zip: '435502' },
  { city: 'Şugău (Maramureş)', zip: '435503' },
  { city: 'Valea Cufundoasă (Maramureş)', zip: '435504' },
  { city: 'Valea Hotarului (Maramureş)', zip: '435505' },
  { city: 'Târgu Lăpuş (Maramureş)', zip: '435600' },
  { city: 'Boiereni (Maramureş)', zip: '435601' },
  { city: 'Borcut (Maramureş)', zip: '435602' },
  { city: 'Cufoaia (Maramureş)', zip: '435603' },
  { city: 'Dămăcuşeni (Maramureş)', zip: '435604' },
  { city: 'Dobricu Lăpuşului (Maramureş)', zip: '435605' },
  { city: 'Dumbrava (Maramureş)', zip: '435606' },
  { city: 'Fântânele (Maramureş)', zip: '435607' },
  { city: 'Groape (Maramureş)', zip: '435608' },
  { city: 'Inău (Maramureş)', zip: '435609' },
  { city: 'Răzoare (Maramureş)', zip: '435610' },
  { city: 'Rogoz (Maramureş)', zip: '435611' },
  { city: 'Rohia (Maramureş)', zip: '435612' },
  { city: 'Stoiceni (Maramureş)', zip: '435613' },
  { city: 'Vişeu de Sus (Maramureş)', zip: '435700' },
  { city: 'Vişeu de Mijloc (Maramureş)', zip: '435701' },
  { city: 'Ardusat (Maramureş)', zip: '437005' },
  { city: 'Arieşu de Câmp (Maramureş)', zip: '437006' },
  { city: 'Colţirea (Maramureş)', zip: '437007' },
  { city: 'Ariniş (Maramureş)', zip: '437010' },
  { city: 'Rodina (Maramureş)', zip: '437011' },
  { city: 'Tămăşeşti (Maramureş)', zip: '437012' },
  { city: 'Asuaju de Sus (Maramureş)', zip: '437015' },
  { city: 'Asuaju de Jos (Maramureş)', zip: '437016' },
  { city: 'Băiţa de sub Codru (Maramureş)', zip: '437020' },
  { city: 'Urmeniş (Maramureş)', zip: '437021' },
  { city: 'Băiuţ (Maramureş)', zip: '437025' },
  { city: 'Poiana Botizii (Maramureş)', zip: '437026' },
  { city: 'Strâmbu-Băiuţ (Maramureş)', zip: '437027' },
  { city: 'Băseşti (Maramureş)', zip: '437030' },
  { city: 'Odeşti (Maramureş)', zip: '437031' },
  { city: 'Sălişte (Maramureş)', zip: '437032' },
  { city: 'Stremţ (Maramureş)', zip: '437033' },
  { city: 'Bârsana (Maramureş)', zip: '437035' },
  { city: 'Năneşti (Maramureş)', zip: '437036' },
  { city: 'Onceşti (Maramureş)', zip: '437037' },
  { city: 'Bicaz (Maramureş)', zip: '437040' },
  { city: 'Ciuta (Maramureş)', zip: '437041' },
  { city: 'Corni (Maramureş)', zip: '437042' },
  { city: 'Bistra (Maramureş)', zip: '437045' },
  { city: 'Crasna Vişeului (Maramureş)', zip: '437046' },
  { city: 'Valea Vişeului (Maramureş)', zip: '437047' },
  { city: 'Bocicoiu Mare (Maramureş)', zip: '437050' },
  { city: 'Crăciuneşti (Maramureş)', zip: '437051' },
  { city: 'Lunca la Tisa (Maramureş)', zip: '437052' },
  { city: 'Tisa (Maramureş)', zip: '437053' },
  { city: 'Bogdan Vodă (Maramureş)', zip: '437055' },
  { city: 'Bocicoel (Maramureş)', zip: '437056' },
  { city: 'Boiu Mare (Maramureş)', zip: '437060' },
  { city: 'Frâncenii Boiului (Maramureş)', zip: '437061' },
  { city: 'Prislop (Maramureş)', zip: '437062' },
  { city: 'Româneşti (Maramureş)', zip: '437063' },
  { city: 'Botiza (Maramureş)', zip: '437065' },
  { city: 'Budeşti (Maramureş)', zip: '437070' },
  { city: 'Sârbi (Budeşti) (Maramureş)', zip: '437071' },
  { city: 'Călineşti (Maramureş)', zip: '437075' },
  { city: 'Corneşti (Maramureş)', zip: '437076' },
  { city: 'Văleni (Maramureş)', zip: '437077' },
  { city: 'Câmpulung la Tisa (Maramureş)', zip: '437080' },
  { city: 'Cerneşti (Maramureş)', zip: '437085' },
  { city: 'Brebeni (Maramureş)', zip: '437086' },
  { city: 'Ciocotiş (Maramureş)', zip: '437087' },
  { city: 'Fânaţe (Maramureş)', zip: '437088' },
  { city: 'Izvoarele (Maramureş)', zip: '437089' },
  { city: 'Măgureni (Maramureş)', zip: '437091' },
  { city: 'Trestia (Maramureş)', zip: '437092' },
  { city: 'Cicârlău (Maramureş)', zip: '437095' },
  { city: 'Bârgău (Maramureş)', zip: '437096' },
  { city: 'Handalu Ilbei (Maramureş)', zip: '437097' },
  { city: 'Ilba (Maramureş)', zip: '437098' },
  { city: 'Copalnic-Mănăştur (Maramureş)', zip: '437100' },
  { city: 'Berinţa (Maramureş)', zip: '437101' },
  { city: 'Cărpiniş (Maramureş)', zip: '437102' },
  { city: 'Copalnic (Maramureş)', zip: '437103' },
  { city: 'Copalnic-Deal (Maramureş)', zip: '437104' },
  { city: 'Curtuiuşu Mic (Maramureş)', zip: '437106' },
  { city: 'Făureşti (Maramureş)', zip: '437107' },
  { city: 'Lăschia (Maramureş)', zip: '437108' },
  { city: 'Preluca Nouă (Maramureş)', zip: '437109' },
  { city: 'Preluca Veche (Maramureş)', zip: '437111' },
  { city: 'Ruşor (Maramureş)', zip: '437112' },
  { city: 'Vad (Maramureş)', zip: '437113' },
  { city: 'Vălenii Lăpuşului (Maramureş)', zip: '437125' },
  { city: 'Coroieni (Maramureş)', zip: '437126' },
  { city: 'Baba (Maramureş)', zip: '437127' },
  { city: 'Dealu Mare (Maramureş)', zip: '437128' },
  { city: 'Drăghia (Maramureş)', zip: '437129' },
  { city: 'Cupşeni (Maramureş)', zip: '437130' },
  { city: 'Costeni (Maramureş)', zip: '437131' },
  { city: 'Libotin (Maramureş)', zip: '437132' },
  { city: 'Ungureni (Maramureş)', zip: '437133' },
  { city: 'Deseşti (Maramureş)', zip: '437135' },
  { city: 'Hărniceşti (Maramureş)', zip: '437136' },
  { city: 'Mara (Maramureş)', zip: '437137' },
  { city: 'Dragomireşti (Maramureş)', zip: '437140' },
  { city: 'Dumbrăviţa (Maramureş)', zip: '437145' },
  { city: 'Cărbunari (Maramureş)', zip: '437146' },
  { city: 'Chechiş (Maramureş)', zip: '437147' },
  { city: 'Rus (Maramureş)', zip: '437148' },
  { city: 'Şindreşti (Maramureş)', zip: '437149' },
  { city: 'Unguraş (Maramureş)', zip: '437151' },
  { city: 'Fărcaşa (Maramureş)', zip: '437155' },
  { city: 'Buzeşti (Maramureş)', zip: '437156' },
  { city: 'Sârbi (Fărcaşa) (Maramureş)', zip: '437157' },
  { city: 'Tămaia (Maramureş)', zip: '437158' },
  { city: 'Giuleşti (Maramureş)', zip: '437160' },
  { city: 'Berbeşti (Maramureş)', zip: '437161' },
  { city: 'Fereşti (Maramureş)', zip: '437162' },
  { city: 'Mănăstirea (Maramureş)', zip: '437163' },
  { city: 'Groşi (Maramureş)', zip: '437165' },
  { city: 'Ocoliş (Maramureş)', zip: '437166' },
  { city: 'Satu Nou de Jos (Maramureş)', zip: '437167' },
  { city: 'Ieud (Maramureş)', zip: '437170' },
  { city: 'Lăpuş (Maramureş)', zip: '437175' },
  { city: 'Leordina (Maramureş)', zip: '437180' },
  { city: 'Mireşu Mare (Maramureş)', zip: '437185' },
  { city: 'Dăneştii Chioarului (Maramureş)', zip: '437186' },
  { city: 'Iadăra (Maramureş)', zip: '437187' },
  { city: 'Lucăceşti (Maramureş)', zip: '437188' },
  { city: 'Remeţi pe Someş (Maramureş)', zip: '437189' },
  { city: 'Stejera (Maramureş)', zip: '437191' },
  { city: 'Tulghieş (Maramureş)', zip: '437192' },
  { city: 'Moisei (Maramureş)', zip: '437195' },
  { city: 'Oarţa de Jos (Maramureş)', zip: '437200' },
  { city: 'Oarţa de Sus (Maramureş)', zip: '437201' },
  { city: 'Orţiţa (Maramureş)', zip: '437202' },
  { city: 'Ocna Şugatag (Maramureş)', zip: '437205' },
  { city: 'Breb (Maramureş)', zip: '437206' },
  { city: 'Hoteni (Maramureş)', zip: '437207' },
  { city: 'Sat-Şugatag (Maramureş)', zip: '437208' },
  { city: 'Petrova (Maramureş)', zip: '437210' },
  { city: 'Poienile Izei (Maramureş)', zip: '437215' },
  { city: 'Poienile de sub Munte (Maramureş)', zip: '437220' },
  { city: 'Recea (Maramureş)', zip: '437225' },
  { city: 'Bozânta Mică (Maramureş)', zip: '437226' },
  { city: 'Lăpuşel (Maramureş)', zip: '437227' },
  { city: 'Mocira (Maramureş)', zip: '437228' },
  { city: 'Săsar (Maramureş)', zip: '437229' },
  { city: 'Remetea Chioarului (Maramureş)', zip: '437230' },
  { city: 'Berchez (Maramureş)', zip: '437231' },
  { city: 'Berchezoaia (Maramureş)', zip: '437232' },
  { city: 'Posta (Maramureş)', zip: '437233' },
  { city: 'Remecioara (Maramureş)', zip: '437234' },
  { city: 'Remeţi (Maramureş)', zip: '437235' },
  { city: 'Piatra (Maramureş)', zip: '437236' },
  { city: 'Teceu Mic (Maramureş)', zip: '437237' },
  { city: 'Repedea (Maramureş)', zip: '437240' },
  { city: 'Rona de Jos (Maramureş)', zip: '437245' },
  { city: 'Rona de Sus (Maramureş)', zip: '437250' },
  { city: 'Coştiui (Maramureş)', zip: '437251' },
  { city: 'Rozavlea (Maramureş)', zip: '437255' },
  { city: 'Sâlţa (Maramureş)', zip: '437256' },
  { city: 'Ruscova (Maramureş)', zip: '437260' },
  { city: 'Sarasău (Maramureş)', zip: '437265' },
  { city: 'Satulung (Maramureş)', zip: '437270' },
  { city: 'Arieşu de Pădure (Maramureş)', zip: '437271' },
  { city: 'Fersig (Maramureş)', zip: '437272' },
  { city: 'Finteuşu Mic (Maramureş)', zip: '437273' },
  { city: 'Hideaga (Maramureş)', zip: '437274' },
  { city: 'Mogoşeşti (Maramureş)', zip: '437276' },
  { city: 'Pribileşti (Maramureş)', zip: '437277' },
  { city: 'Săcălăşeni (Maramureş)', zip: '437280' },
  { city: 'Cătălina (Maramureş)', zip: '437281' },
  { city: 'Coaş (Maramureş)', zip: '437282' },
  { city: 'Coltău (Maramureş)', zip: '437283' },
  { city: 'Coruia (Maramureş)', zip: '437284' },
  { city: 'Culcea (Maramureş)', zip: '437286' },
  { city: 'Întrerâuri (Maramureş)', zip: '437287' },
  { city: 'Săcel (Maramureş)', zip: '437290' },
  { city: 'Săliştea de Sus (Maramureş)', zip: '437295' },
  { city: 'Sălsig (Maramureş)', zip: '437300' },
  { city: 'Gârdani (Maramureş)', zip: '437301' },
  { city: 'Săpânţa (Maramureş)', zip: '437305' },
  { city: 'Strâmtura (Maramureş)', zip: '437310' },
  { city: 'Glod (Maramureş)', zip: '437311' },
  { city: 'Slătioara (Maramureş)', zip: '437312' },
  { city: 'Suciu de Sus (Maramureş)', zip: '437315' },
  { city: 'Groşii Ţibleşului (Maramureş)', zip: '437316' },
  { city: 'Larga (Maramureş)', zip: '437317' },
  { city: 'Suciu de Jos (Maramureş)', zip: '437318' },
  { city: 'Şieu (Maramureş)', zip: '437320' },
  { city: 'Şişeşti (Maramureş)', zip: '437325' },
  { city: 'Bontăieni (Maramureş)', zip: '437326' },
  { city: 'Cetăţele (Maramureş)', zip: '437327' },
  { city: 'Dăneşti (Maramureş)', zip: '437328' },
  { city: 'Negreia (Maramureş)', zip: '437329' },
  { city: 'Plopiş (Maramureş)', zip: '437331' },
  { city: 'Şurdeşti (Maramureş)', zip: '437332' },
  { city: 'Şomcuta Mare (Maramureş)', zip: '437335' },
  { city: 'Buciumi (Maramureş)', zip: '437336' },
  { city: 'Buteasa (Maramureş)', zip: '437337' },
  { city: 'Ciolt (Maramureş)', zip: '437338' },
  { city: 'Codru Butesii (Maramureş)', zip: '437339' },
  { city: 'Finteuşu Mare (Maramureş)', zip: '437341' },
  { city: 'Hovrila (Maramureş)', zip: '437342' },
  { city: 'Vălenii Şomcutei (Maramureş)', zip: '437343' },
  { city: 'Tăuţii-Măgherăuş (Maramureş)', zip: '437345' },
  { city: 'Băiţa (Maramureş)', zip: '437346' },
  { city: 'Bozânta Mare (Maramureş)', zip: '437347' },
  { city: 'Buşag (Maramureş)', zip: '437348' },
  { city: 'Merişor (Maramureş)', zip: '437349' },
  { city: 'Nistru (Maramureş)', zip: '437351' },
  { city: 'Ulmoasa (Maramureş)', zip: '437352' },
  { city: 'Ulmeni (Maramureş)', zip: '437355' },
  { city: 'Arduzel (Maramureş)', zip: '437356' },
  { city: 'Chelinţa (Maramureş)', zip: '437357' },
  { city: 'Mânău (Maramureş)', zip: '437358' },
  { city: 'Someş-Uileac (Maramureş)', zip: '437359' },
  { city: 'Tohat (Maramureş)', zip: '437361' },
  { city: 'Ţicău (Maramureş)', zip: '437362' },
  { city: 'Vicea (Maramureş)', zip: '437363' },
  { city: 'Vadu Izei (Maramureş)', zip: '437365' },
  { city: 'Valea Stejarului (Maramureş)', zip: '437366' },
  { city: 'Valea Chioarului (Maramureş)', zip: '437370' },
  { city: 'Curtuiuşu Mare (Maramureş)', zip: '437371' },
  { city: 'Duruşa (Maramureş)', zip: '437372' },
  { city: 'Fericea (Maramureş)', zip: '437373' },
  { city: 'Mesteacăn (Maramureş)', zip: '437374' },
  { city: 'Vărai (Maramureş)', zip: '437376' },
  { city: 'Vima Mică (Maramureş)', zip: '437380' },
  { city: 'Aspra (Maramureş)', zip: '437381' },
  { city: 'Dealu Corbului (Maramureş)', zip: '437382' },
  { city: 'Jugăstreni (Maramureş)', zip: '437383' },
  { city: 'Peteritea (Maramureş)', zip: '437384' },
  { city: 'Sălniţa (Maramureş)', zip: '437386' },
  { city: 'Vima Mare (Maramureş)', zip: '437387' },
  { city: 'Vişeu de Jos (Maramureş)', zip: '437390' },
  { city: 'Dudaşu Schelei (Mehedinţi)', zip: '220001' },
  { city: 'Gura Văii (Mehedinţi)', zip: '220002' },
  { city: 'Schela Cladovei (Mehedinţi)', zip: '220003' },
  { city: 'Drobeta-Turnu Severin (Mehedinţi)', zip: '220004' },
  { city: 'Baia de Aramă (Mehedinţi)', zip: '225100' },
  { city: 'Bratilovu (Mehedinţi)', zip: '225101' },
  { city: 'Brebina (Mehedinţi)', zip: '225102' },
  { city: 'Dealu Mare (Mehedinţi)', zip: '225103' },
  { city: 'Mărăşeşti (Mehedinţi)', zip: '225104' },
  { city: 'Negoeşti (Mehedinţi)', zip: '225105' },
  { city: 'Pistriţa (Mehedinţi)', zip: '225106' },
  { city: 'Stăneşti (Mehedinţi)', zip: '225107' },
  { city: 'Titerleşti (Mehedinţi)', zip: '225108' },
  { city: 'Orşova (Mehedinţi)', zip: '225200' },
  { city: 'Strehaia (Mehedinţi)', zip: '225300' },
  { city: 'Ciochiuţa (Mehedinţi)', zip: '225301' },
  { city: 'Comanda (Mehedinţi)', zip: '225302' },
  { city: 'Hurduceşti (Mehedinţi)', zip: '225303' },
  { city: 'Lunca Banului (Mehedinţi)', zip: '225304' },
  { city: 'Menţi (Mehedinţi)', zip: '225305' },
  { city: 'Motruleni (Mehedinţi)', zip: '225306' },
  { city: 'Slătinicu Mare (Mehedinţi)', zip: '225307' },
  { city: 'Slătinicu Mic (Mehedinţi)', zip: '225308' },
  { city: 'Stănceşti (Mehedinţi)', zip: '225309' },
  { city: 'Vânju Mare (Mehedinţi)', zip: '225400' },
  { city: 'Bucura (Mehedinţi)', zip: '225401' },
  { city: 'Nicolae Bălcescu (Mehedinţi)', zip: '225402' },
  { city: 'Oreviţa Mare (Mehedinţi)', zip: '225403' },
  { city: 'Traian (Mehedinţi)', zip: '225404' },
  { city: 'Porţile de Fier II (Mehedinţi)', zip: '227005' },
  { city: 'Bala (Mehedinţi)', zip: '227010' },
  { city: 'Bala de Sus (Mehedinţi)', zip: '227011' },
  { city: 'Brateşul (Mehedinţi)', zip: '227012' },
  { city: 'Brativoeşti (Mehedinţi)', zip: '227013' },
  { city: 'Câmpu Mare (Mehedinţi)', zip: '227014' },
  { city: 'Cârşu (Mehedinţi)', zip: '227016' },
  { city: 'Comăneşti (Mehedinţi)', zip: '227017' },
  { city: 'Crainici (Mehedinţi)', zip: '227018' },
  { city: 'Dâlma (Mehedinţi)', zip: '227019' },
  { city: 'Iupca (Mehedinţi)', zip: '227021' },
  { city: 'Molani (Mehedinţi)', zip: '227022' },
  { city: 'Rudina (Mehedinţi)', zip: '227023' },
  { city: 'Runcuşoru (Mehedinţi)', zip: '227024' },
  { city: 'Sărdăneşti (Mehedinţi)', zip: '227026' },
  { city: 'Vidimireşti (Mehedinţi)', zip: '227027' },
  { city: 'Balta (Mehedinţi)', zip: '227030' },
  { city: 'Coada Cornetului (Mehedinţi)', zip: '227031' },
  { city: 'Costeşti (Mehedinţi)', zip: '227032' },
  { city: 'Gornoviţa (Mehedinţi)', zip: '227033' },
  { city: 'Nevăţu (Mehedinţi)', zip: '227034' },
  { city: 'Prejna (Mehedinţi)', zip: '227036' },
  { city: 'Sfodea (Mehedinţi)', zip: '227037' },
  { city: 'Bălăciţa (Mehedinţi)', zip: '227040' },
  { city: 'Dobra (Mehedinţi)', zip: '227041' },
  { city: 'Gvardiniţa (Mehedinţi)', zip: '227042' },
  { city: 'Bâcleş (Mehedinţi)', zip: '227045' },
  { city: 'Corzu (Mehedinţi)', zip: '227046' },
  { city: 'Giura (Mehedinţi)', zip: '227047' },
  { city: 'Petra (Mehedinţi)', zip: '227048' },
  { city: 'Podu Grosului (Mehedinţi)', zip: '227049' },
  { city: 'Seliştiuţa (Mehedinţi)', zip: '227051' },
  { city: 'Smadoviţa (Mehedinţi)', zip: '227052' },
  { city: 'Bâlvăneşti (Mehedinţi)', zip: '227055' },
  { city: 'Bâlvăneştii de Jos (Mehedinţi)', zip: '227056' },
  { city: 'Călineştii de Jos (Mehedinţi)', zip: '227057' },
  { city: 'Călineştii de Sus (Mehedinţi)', zip: '227058' },
  { city: 'Pârlagele (Mehedinţi)', zip: '227059' },
  { city: 'Brezniţa-Motru (Mehedinţi)', zip: '227060' },
  { city: 'Cosovăţ (Mehedinţi)', zip: '227061' },
  { city: 'Deleni (Mehedinţi)', zip: '227062' },
  { city: 'Făuroaia (Mehedinţi)', zip: '227063' },
  { city: 'Plai (Mehedinţi)', zip: '227064' },
  { city: 'Tălăpanu (Mehedinţi)', zip: '227066' },
  { city: 'Valea Teiului (Mehedinţi)', zip: '227067' },
  { city: 'Brezniţa-Ocol (Mehedinţi)', zip: '227070' },
  { city: 'Jidoştiţa (Mehedinţi)', zip: '227071' },
  { city: 'Magheru (Mehedinţi)', zip: '227072' },
  { city: 'Şuşiţa (Brezniţa-Ocol) (Mehedinţi)', zip: '227073' },
  { city: 'Broşteni (Mehedinţi)', zip: '227075' },
  { city: 'Căpăţâneşti (Mehedinţi)', zip: '227076' },
  { city: 'Luncşoara (Mehedinţi)', zip: '227077' },
  { city: 'Lupşa de Jos (Mehedinţi)', zip: '227078' },
  { city: 'Lupşa de Sus (Mehedinţi)', zip: '227079' },
  { city: 'Meriş (Mehedinţi)', zip: '227081' },
  { city: 'Burila Mare (Mehedinţi)', zip: '227085' },
  { city: 'Crivina (Mehedinţi)', zip: '227086' },
  { city: 'Izvoru Frumos (Mehedinţi)', zip: '227087' },
  { city: 'Ţigănaşi (Mehedinţi)', zip: '227088' },
  { city: 'Vrancea (Mehedinţi)', zip: '227089' },
  { city: 'Butoieşti (Mehedinţi)', zip: '227090' },
  { city: 'Argineşti (Mehedinţi)', zip: '227091' },
  { city: 'Buiceşti (Mehedinţi)', zip: '227092' },
  { city: 'Gura Motrului (Mehedinţi)', zip: '227093' },
  { city: 'Jugastru (Mehedinţi)', zip: '227094' },
  { city: 'Pluta (Mehedinţi)', zip: '227096' },
  { city: 'Răduţeşti (Mehedinţi)', zip: '227097' },
  { city: 'Ţânţaru (Mehedinţi)', zip: '227098' },
  { city: 'Căzăneşti (Mehedinţi)', zip: '227100' },
  { city: 'Ercea (Mehedinţi)', zip: '227101' },
  { city: 'Gârbovăţu de Sus (Mehedinţi)', zip: '227102' },
  { city: 'Govodarva (Mehedinţi)', zip: '227103' },
  { city: 'Ilovu (Mehedinţi)', zip: '227104' },
  { city: 'Jigniţa (Mehedinţi)', zip: '227106' },
  { city: 'Păltinişu (Mehedinţi)', zip: '227107' },
  { city: 'Poiana (Mehedinţi)', zip: '227108' },
  { city: 'Roşia (Mehedinţi)', zip: '227109' },
  { city: 'Severineşti (Mehedinţi)', zip: '227111' },
  { city: 'Suharu (Mehedinţi)', zip: '227112' },
  { city: 'Valea Coşuştei (Mehedinţi)', zip: '227113' },
  { city: 'Cireşu (Mehedinţi)', zip: '227120' },
  { city: 'Bunoaica (Mehedinţi)', zip: '227121' },
  { city: 'Jupâneşti (Mehedinţi)', zip: '227122' },
  { city: 'Negruşa (Mehedinţi)', zip: '227123' },
  { city: 'Corcova (Mehedinţi)', zip: '227125' },
  { city: 'Breţa (Mehedinţi)', zip: '227126' },
  { city: 'Cernaia (Mehedinţi)', zip: '227127' },
  { city: 'Cordun (Mehedinţi)', zip: '227128' },
  { city: 'Croica (Mehedinţi)', zip: '227129' },
  { city: 'Gârbovăţu de Jos (Mehedinţi)', zip: '227131' },
  { city: 'Imoasa (Mehedinţi)', zip: '227132' },
  { city: 'Jirov (Mehedinţi)', zip: '227133' },
  { city: 'Măru Roşu (Mehedinţi)', zip: '227134' },
  { city: 'Pârvuleşti (Mehedinţi)', zip: '227136' },
  { city: 'Puşcaşu (Mehedinţi)', zip: '227137' },
  { city: 'Stejaru (Mehedinţi)', zip: '227138' },
  { city: 'Vlădăşeşti (Mehedinţi)', zip: '227139' },
  { city: 'Corlăţel (Mehedinţi)', zip: '227145' },
  { city: 'Valea Anilor (Mehedinţi)', zip: '227146' },
  { city: 'Cujmir (Mehedinţi)', zip: '227150' },
  { city: 'Aurora (Mehedinţi)', zip: '227151' },
  { city: 'Cujmiru Mic (Mehedinţi)', zip: '227152' },
  { city: 'Dârvari (Mehedinţi)', zip: '227155' },
  { city: 'Gemeni (Mehedinţi)', zip: '227156' },
  { city: 'Devesel (Mehedinţi)', zip: '227160' },
  { city: 'Batoţi (Mehedinţi)', zip: '227161' },
  { city: 'Bistreţu (Mehedinţi)', zip: '227162' },
  { city: 'Dunărea Mică (Mehedinţi)', zip: '227163' },
  { city: 'Scăpău (Mehedinţi)', zip: '227164' },
  { city: 'Tismana (Mehedinţi)', zip: '227166' },
  { city: 'Dubova (Mehedinţi)', zip: '227170' },
  { city: 'Baia Nouă (Mehedinţi)', zip: '227171' },
  { city: 'Eibenthal (Mehedinţi)', zip: '227172' },
  { city: 'Dumbrava (Mehedinţi)', zip: '227175' },
  { city: 'Albuleşti (Mehedinţi)', zip: '227176' },
  { city: 'Brâgleasa (Mehedinţi)', zip: '227177' },
  { city: 'Dumbrava de Jos (Mehedinţi)', zip: '227178' },
  { city: 'Dumbrava de Mijloc (Mehedinţi)', zip: '227179' },
  { city: 'Dumbrava de Sus (Mehedinţi)', zip: '227181' },
  { city: 'Golineasa (Mehedinţi)', zip: '227182' },
  { city: 'Higiu (Mehedinţi)', zip: '227183' },
  { city: 'Rocşoreni (Mehedinţi)', zip: '227184' },
  { city: 'Valea Marcului (Mehedinţi)', zip: '227186' },
  { city: 'Varodia (Mehedinţi)', zip: '227187' },
  { city: 'Vlădica (Mehedinţi)', zip: '227188' },
  { city: 'Eşelniţa (Mehedinţi)', zip: '227195' },
  { city: 'Floreşti (Mehedinţi)', zip: '227200' },
  { city: 'Copăcioasa (Mehedinţi)', zip: '227201' },
  { city: 'Gârdoaia (Mehedinţi)', zip: '227202' },
  { city: 'Livezi (Mehedinţi)', zip: '227203' },
  { city: 'Moşneni (Mehedinţi)', zip: '227204' },
  { city: 'Peşteana (Mehedinţi)', zip: '227206' },
  { city: 'Peştenuţa (Mehedinţi)', zip: '227207' },
  { city: 'Stroeşti (Mehedinţi)', zip: '227208' },
  { city: 'Zegujani (Mehedinţi)', zip: '227209' },
  { city: 'Gârla Mare (Mehedinţi)', zip: '227210' },
  { city: 'Vrata (Mehedinţi)', zip: '227211' },
  { city: 'Godeanu (Mehedinţi)', zip: '227215' },
  { city: 'Marga (Mehedinţi)', zip: '227216' },
  { city: 'Păuneşti (Mehedinţi)', zip: '227217' },
  { city: 'Şiroca (Mehedinţi)', zip: '227218' },
  { city: 'Gogoşu (Mehedinţi)', zip: '227220' },
  { city: 'Balta Verde (Mehedinţi)', zip: '227221' },
  { city: 'Burila Mică (Mehedinţi)', zip: '227222' },
  { city: 'Ostrovu Mare (Mehedinţi)', zip: '227223' },
  { city: 'Greci (Mehedinţi)', zip: '227225' },
  { city: 'Bâltanele (Greci) (Mehedinţi)', zip: '227226' },
  { city: 'Blidaru (Mehedinţi)', zip: '227227' },
  { city: 'Sălătruc (Mehedinţi)', zip: '227228' },
  { city: 'Valea Petrii (Mehedinţi)', zip: '227229' },
  { city: 'Vişina (Mehedinţi)', zip: '227231' },
  { city: 'Grozeşti (Mehedinţi)', zip: '227235' },
  { city: 'Cârceni (Mehedinţi)', zip: '227236' },
  { city: 'Păsărani (Mehedinţi)', zip: '227237' },
  { city: 'Şuşiţa (Grozeşti) (Mehedinţi)', zip: '227238' },
  { city: 'Gruia (Mehedinţi)', zip: '227240' },
  { city: 'Izvoarele (Mehedinţi)', zip: '227241' },
  { city: 'Poiana Gruii (Mehedinţi)', zip: '227242' },
  { city: 'Hinova (Mehedinţi)', zip: '227245' },
  { city: 'Bistriţa (Mehedinţi)', zip: '227246' },
  { city: 'Cârjei (Mehedinţi)', zip: '227247' },
  { city: 'Ostrovu Corbului (Mehedinţi)', zip: '227248' },
  { city: 'Husnicioara (Mehedinţi)', zip: '227250' },
  { city: 'Alunişul (Mehedinţi)', zip: '227251' },
  { city: 'Bădiţeşti (Mehedinţi)', zip: '227252' },
  { city: 'Borogea (Mehedinţi)', zip: '227253' },
  { city: 'Celnata (Mehedinţi)', zip: '227254' },
  { city: 'Dumbrăviţa (Mehedinţi)', zip: '227256' },
  { city: 'Marmanu (Mehedinţi)', zip: '227257' },
  { city: 'Oprăneşti (Mehedinţi)', zip: '227258' },
  { city: 'Peri (Mehedinţi)', zip: '227259' },
  { city: 'Priboieşti (Mehedinţi)', zip: '227261' },
  { city: 'Selişteni (Mehedinţi)', zip: '227262' },
  { city: 'Ilovăţ (Mehedinţi)', zip: '227270' },
  { city: 'Budăneşti (Mehedinţi)', zip: '227271' },
  { city: 'Cracu Lung (Mehedinţi)', zip: '227272' },
  { city: 'Dâlbociţa (Mehedinţi)', zip: '227273' },
  { city: 'Firizu (Mehedinţi)', zip: '227274' },
  { city: 'Racova (Mehedinţi)', zip: '227276' },
  { city: 'Iloviţa (Mehedinţi)', zip: '227280' },
  { city: 'Bahna (Mehedinţi)', zip: '227281' },
  { city: 'Moiseşti (Mehedinţi)', zip: '227282' },
  { city: 'Isverna (Mehedinţi)', zip: '227285' },
  { city: 'Buseşti (Mehedinţi)', zip: '227286' },
  { city: 'Cerna-Vârf (Mehedinţi)', zip: '227287' },
  { city: 'Drăgheşti (Mehedinţi)', zip: '227288' },
  { city: 'Giurgiani (Mehedinţi)', zip: '227289' },
  { city: 'Nadanova (Mehedinţi)', zip: '227291' },
  { city: 'Seliştea (Mehedinţi)', zip: '227292' },
  { city: 'Turtaba (Mehedinţi)', zip: '227293' },
  { city: 'Izvoru Bârzii (Mehedinţi)', zip: '227295' },
  { city: 'Baloteşti (Mehedinţi)', zip: '227296' },
  { city: 'Halânga (Mehedinţi)', zip: '227297' },
  { city: 'Puţinei (Mehedinţi)', zip: '227298' },
  { city: 'Răscoleşti (Mehedinţi)', zip: '227299' },
  { city: 'Schinteieşti (Mehedinţi)', zip: '227301' },
  { city: 'Schitu Topolniţei (Mehedinţi)', zip: '227302' },
  { city: 'Jiana (Mehedinţi)', zip: '227305' },
  { city: 'Cioroboreni (Mehedinţi)', zip: '227306' },
  { city: 'Dănceu (Mehedinţi)', zip: '227307' },
  { city: 'Jiana Mare (Mehedinţi)', zip: '227308' },
  { city: 'Jiana Veche (Mehedinţi)', zip: '227309' },
  { city: 'Livezile (Mehedinţi)', zip: '227310' },
  { city: 'Izvorălu de Jos (Mehedinţi)', zip: '227311' },
  { city: 'Izvoru Aneştilor (Mehedinţi)', zip: '227312' },
  { city: 'Petriş (Mehedinţi)', zip: '227313' },
  { city: 'Ştefan Odobleja (Mehedinţi)', zip: '227314' },
  { city: 'Malovăţ (Mehedinţi)', zip: '227315' },
  { city: '45527 (Mehedinţi)', zip: '227316' },
  { city: 'Bârda (Mehedinţi)', zip: '227317' },
  { city: 'Bobaiţa (Mehedinţi)', zip: '227318' },
  { city: 'Colibaşi (Mehedinţi)', zip: '227319' },
  { city: 'Lazu (Mehedinţi)', zip: '227321' },
  { city: 'Negreşti (Mehedinţi)', zip: '227322' },
  { city: 'Obârşia de Câmp (Mehedinţi)', zip: '227325' },
  { city: 'Izimşa (Mehedinţi)', zip: '227326' },
  { city: 'Obârşia-Cloşani (Mehedinţi)', zip: '227330' },
  { city: 'Godeanu (Obârşia-Cloşani) (Mehedinţi)', zip: '227331' },
  { city: 'Oprişor (Mehedinţi)', zip: '227335' },
  { city: 'Prisăceaua (Mehedinţi)', zip: '227336' },
  { city: 'Pădina (Mehedinţi)', zip: '227340' },
  { city: 'Biban (Mehedinţi)', zip: '227341' },
  { city: 'Iablaniţa (Mehedinţi)', zip: '227342' },
  { city: 'Olteanca (Mehedinţi)', zip: '227343' },
  { city: 'Pădina Mare (Mehedinţi)', zip: '227344' },
  { city: 'Pădina Mică (Mehedinţi)', zip: '227346' },
  { city: 'Slaşoma (Mehedinţi)', zip: '227347' },
  { city: 'Pătulele (Mehedinţi)', zip: '227350' },
  { city: 'Viaşu (Mehedinţi)', zip: '227351' },
  { city: 'Podeni (Mehedinţi)', zip: '227355' },
  { city: 'Gornenţi (Mehedinţi)', zip: '227356' },
  { city: 'Mălărişca (Mehedinţi)', zip: '227357' },
  { city: 'Ponoarele (Mehedinţi)', zip: '227360' },
  { city: 'Băluţa (Mehedinţi)', zip: '227361' },
  { city: 'Bârâiacu (Mehedinţi)', zip: '227362' },
  { city: 'Brânzeni (Mehedinţi)', zip: '227363' },
  { city: 'Buicani (Mehedinţi)', zip: '227364' },
  { city: 'Ceptureni (Mehedinţi)', zip: '227366' },
  { city: 'Cracu Muntelui (Mehedinţi)', zip: '227367' },
  { city: 'Delureni (Mehedinţi)', zip: '227368' },
  { city: 'Gărdăneasa (Mehedinţi)', zip: '227369' },
  { city: 'Gheorgheşti (Mehedinţi)', zip: '227371' },
  { city: 'Ludu (Mehedinţi)', zip: '227372' },
  { city: 'Proiteşti (Mehedinţi)', zip: '227373' },
  { city: 'Răiculeşti (Mehedinţi)', zip: '227374' },
  { city: 'Şipotu (Ponoarele) (Mehedinţi)', zip: '227376' },
  { city: 'Valea Ursului (Ponoarele) (Mehedinţi)', zip: '227377' },
  { city: 'Poroina Mare (Mehedinţi)', zip: '227380' },
  { city: 'Fântânile Negre (Mehedinţi)', zip: '227381' },
  { city: 'Stigniţa (Mehedinţi)', zip: '227382' },
  { city: 'Şipotu (Poroina Mare) (Mehedinţi)', zip: '227383' },
  { city: 'Pristol (Mehedinţi)', zip: '227385' },
  { city: 'Cozia (Mehedinţi)', zip: '227386' },
  { city: 'Prunişor (Mehedinţi)', zip: '227390' },
  { city: 'Arvăteşti (Mehedinţi)', zip: '227391' },
  { city: 'Balota (Mehedinţi)', zip: '227392' },
  { city: 'Bâltanele (Prunişor) (Mehedinţi)', zip: '227393' },
  { city: 'Cerveniţa (Mehedinţi)', zip: '227394' },
  { city: 'Dragoteşti (Mehedinţi)', zip: '227396' },
  { city: 'Fântâna Domnească (Mehedinţi)', zip: '227397' },
  { city: 'Gârniţa (Mehedinţi)', zip: '227398' },
  { city: 'Ghelmegioaia (Mehedinţi)', zip: '227399' },
  { city: 'Gutu (Mehedinţi)', zip: '227401' },
  { city: 'Igiroasa (Mehedinţi)', zip: '227402' },
  { city: 'Lumnic (Mehedinţi)', zip: '227403' },
  { city: 'Mijarca (Mehedinţi)', zip: '227404' },
  { city: 'Prunaru (Mehedinţi)', zip: '227406' },
  { city: 'Zegaia (Mehedinţi)', zip: '227407' },
  { city: 'Punghina (Mehedinţi)', zip: '227410' },
  { city: 'Cearângu (Mehedinţi)', zip: '227411' },
  { city: 'Drincea (Mehedinţi)', zip: '227412' },
  { city: 'Măgurele (Mehedinţi)', zip: '227413' },
  { city: 'Recea (Mehedinţi)', zip: '227414' },
  { city: 'Satu Nou (Mehedinţi)', zip: '227416' },
  { city: 'Rogova (Mehedinţi)', zip: '227420' },
  { city: 'Poroiniţa (Mehedinţi)', zip: '227421' },
  { city: 'Salcia (Mehedinţi)', zip: '227425' },
  { city: 'Stângăceaua (Mehedinţi)', zip: '227430' },
  { city: 'Bârlogeni (Mehedinţi)', zip: '227431' },
  { city: 'Breznicioara (Mehedinţi)', zip: '227432' },
  { city: 'Cerânganul (Mehedinţi)', zip: '227433' },
  { city: 'Faţa Motrului (Mehedinţi)', zip: '227434' },
  { city: 'Poşta Veche (Mehedinţi)', zip: '227436' },
  { city: 'Satu Mare (Mehedinţi)', zip: '227437' },
  { city: 'Târsa (Mehedinţi)', zip: '227438' },
  { city: 'Sviniţa (Mehedinţi)', zip: '227440' },
  { city: 'Şimian (Mehedinţi)', zip: '227445' },
  { city: 'Cerneţi (Mehedinţi)', zip: '227446' },
  { city: 'Dedoviţa Nouă (Mehedinţi)', zip: '227447' },
  { city: 'Dedoviţa Veche (Mehedinţi)', zip: '227448' },
  { city: 'Dudaşu (Mehedinţi)', zip: '227449' },
  { city: 'Ergheviţa (Mehedinţi)', zip: '227451' },
  { city: 'Poroina (Mehedinţi)', zip: '227452' },
  { city: 'Valea Copcii (Mehedinţi)', zip: '227453' },
  { city: 'Şişeşti (Mehedinţi)', zip: '227455' },
  { city: 'Cărămidaru (Mehedinţi)', zip: '227456' },
  { city: 'Ciovârnăşani (Mehedinţi)', zip: '227457' },
  { city: 'Cocorova (Mehedinţi)', zip: '227458' },
  { city: 'Crăgueşti (Mehedinţi)', zip: '227459' },
  { city: 'Noapteşa (Mehedinţi)', zip: '227461' },
  { city: 'Şovarna (Mehedinţi)', zip: '227465' },
  { city: 'Ohaba (Mehedinţi)', zip: '227466' },
  { city: 'Studina (Mehedinţi)', zip: '227467' },
  { city: 'Tâmna (Mehedinţi)', zip: '227470' },
  { city: 'Adunaţii Teiului (Mehedinţi)', zip: '227471' },
  { city: 'Boceni (Mehedinţi)', zip: '227472' },
  { city: 'Colareţ (Mehedinţi)', zip: '227473' },
  { city: 'Cremenea (Mehedinţi)', zip: '227474' },
  { city: 'Faţa Cremenii (Mehedinţi)', zip: '227476' },
  { city: 'Izvorălu (Mehedinţi)', zip: '227477' },
  { city: 'Manu (Mehedinţi)', zip: '227478' },
  { city: 'Pavăţ (Mehedinţi)', zip: '227479' },
  { city: 'Plopi (Mehedinţi)', zip: '227481' },
  { city: 'Valea Ursului (Tâmna) (Mehedinţi)', zip: '227482' },
  { city: 'Vânători (Mehedinţi)', zip: '227490' },
  { city: 'Braniştea (Mehedinţi)', zip: '227491' },
  { city: 'Goanţa (Mehedinţi)', zip: '227492' },
  { city: 'Roşiori (Mehedinţi)', zip: '227493' },
  { city: 'Vânjuleţ (Mehedinţi)', zip: '227495' },
  { city: 'Hotărani (Mehedinţi)', zip: '227496' },
  { city: 'Vlădaia (Mehedinţi)', zip: '227500' },
  { city: 'Almăjel (Mehedinţi)', zip: '227501' },
  { city: 'Scorila (Mehedinţi)', zip: '227502' },
  { city: 'Ştircoviţa (Mehedinţi)', zip: '227503' },
  { city: 'Voloiac (Mehedinţi)', zip: '227505' },
  { city: 'Cotoroaia (Mehedinţi)', zip: '227506' },
  { city: 'Lac (Mehedinţi)', zip: '227507' },
  { city: 'Ruptura (Mehedinţi)', zip: '227508' },
  { city: 'Sperleşti (Mehedinţi)', zip: '227509' },
  { city: 'Ţiţirigi (Mehedinţi)', zip: '227511' },
  { city: 'Valea Bună (Mehedinţi)', zip: '227512' },
  { city: 'Voloicel (Mehedinţi)', zip: '227513' },
  { city: 'Mureşeni (Mureş)', zip: '540001' },
  { city: 'Remetea (Mureş)', zip: '540002' },
  { city: 'Târgu Mureş (Mureş)', zip: '540003' },
  { city: 'Iernut (Mureş)', zip: '545100' },
  { city: 'Cipău (Mureş)', zip: '545101' },
  { city: 'Deag (Mureş)', zip: '545102' },
  { city: 'Lechinţa (Mureş)', zip: '545103' },
  { city: 'Oarba de Mureş (Mureş)', zip: '545104' },
  { city: 'Porumbac (Mureş)', zip: '545105' },
  { city: 'Racameţ (Mureş)', zip: '545106' },
  { city: 'Sălcud (Mureş)', zip: '545107' },
  { city: 'Sfântu Gheorghe (Mureş)', zip: '545108' },
  { city: 'Luduş (Mureş)', zip: '545200' },
  { city: 'Avrămeşti (Mureş)', zip: '545201' },
  { city: 'Cioarga (Mureş)', zip: '545202' },
  { city: 'Ciurgău (Mureş)', zip: '545203' },
  { city: 'Fundătura (Mureş)', zip: '545204' },
  { city: 'Gheja (Mureş)', zip: '545205' },
  { city: 'Roşiori (Mureş)', zip: '545206' },
  { city: 'Reghin (Mureş)', zip: '545300' },
  { city: 'Apalina (Mureş)', zip: '545301' },
  { city: 'Iernuţeni (Mureş)', zip: '545302' },
  { city: 'Sighişoara (Mureş)', zip: '545400' },
  { city: 'Angofa (Mureş)', zip: '545401' },
  { city: 'Aurel Vlaicu (Mureş)', zip: '545402' },
  { city: 'Hetiur (Mureş)', zip: '545403' },
  { city: 'Rora (Mureş)', zip: '545404' },
  { city: 'Şoromiclea (Mureş)', zip: '545405' },
  { city: 'Venchi (Mureş)', zip: '545406' },
  { city: 'Viilor (Mureş)', zip: '545407' },
  { city: 'Sovata (Mureş)', zip: '545500' },
  { city: 'Căpeţi (Mureş)', zip: '545501' },
  { city: 'Ilieşi (Mureş)', zip: '545502' },
  { city: 'Săcădat (Mureş)', zip: '545503' },
  { city: 'Sărăţeni (Mureş)', zip: '545504' },
  { city: 'Târnăveni (Mureş)', zip: '545600' },
  { city: 'Bobohalma (Mureş)', zip: '545601' },
  { city: 'Botorca (Mureş)', zip: '545602' },
  { city: 'Cuştelnic (Mureş)', zip: '545603' },
  { city: 'Acăţari (Mureş)', zip: '547005' },
  { city: 'Corbeşti (Mureş)', zip: '547006' },
  { city: 'Găieşti (Mureş)', zip: '547007' },
  { city: 'Gruişor (Mureş)', zip: '547008' },
  { city: 'Murgeşti (Mureş)', zip: '547009' },
  { city: 'Roteni (Mureş)', zip: '547011' },
  { city: 'Stejeriş (Mureş)', zip: '547012' },
  { city: 'Suveica (Mureş)', zip: '547013' },
  { city: 'Vălenii (Mureş)', zip: '547014' },
  { city: 'Adămuş (Mureş)', zip: '547015' },
  { city: 'Chinciuş (Mureş)', zip: '547016' },
  { city: 'Corneşti (Adămuş) (Mureş)', zip: '547017' },
  { city: 'Crăieşti (Adămuş) (Mureş)', zip: '547018' },
  { city: 'Dâmbău (Mureş)', zip: '547019' },
  { city: 'Herepea (Mureş)', zip: '547021' },
  { city: 'Albeşti (Mureş)', zip: '547025' },
  { city: 'Bârlibăşoaia (Mureş)', zip: '547026' },
  { city: 'Boiu (Mureş)', zip: '547027' },
  { city: 'Jacu (Mureş)', zip: '547028' },
  { city: 'Şapartoc (Mureş)', zip: '547029' },
  { city: 'Ţopa (Mureş)', zip: '547031' },
  { city: 'Valea Albeştiului (Mureş)', zip: '547032' },
  { city: 'Valea Dăii (Mureş)', zip: '547033' },
  { city: 'Valea Şapartocului (Mureş)', zip: '547034' },
  { city: 'Aluniş (Mureş)', zip: '547035' },
  { city: 'Fiţcău (Mureş)', zip: '547036' },
  { city: 'Lunca Mureşului (Mureş)', zip: '547037' },
  { city: 'Apold (Mureş)', zip: '547040' },
  { city: 'Daia (Apold) (Mureş)', zip: '547041' },
  { city: 'Şaeş (Mureş)', zip: '547042' },
  { city: 'Vulcan (Mureş)', zip: '547043' },
  { city: 'Aţintiş (Mureş)', zip: '547045' },
  { city: 'Botez (Mureş)', zip: '547046' },
  { city: 'Cecălaca (Mureş)', zip: '547047' },
  { city: 'Iştihaza (Mureş)', zip: '547048' },
  { city: 'Maldaoci (Mureş)', zip: '547049' },
  { city: 'Sâniacob (Mureş)', zip: '547051' },
  { city: 'Bahnea (Mureş)', zip: '547055' },
  { city: 'Bernadea (Mureş)', zip: '547056' },
  { city: 'Cund (Mureş)', zip: '547057' },
  { city: 'Daia (Bahnea) (Mureş)', zip: '547058' },
  { city: 'Gogan (Mureş)', zip: '547059' },
  { city: 'Idiciu (Mureş)', zip: '547061' },
  { city: 'Lepindea (Mureş)', zip: '547062' },
  { city: 'Band (Mureş)', zip: '547065' },
  { city: 'Drăculea Bandului (Mureş)', zip: '547066' },
  { city: 'Fânaţe (Band) (Mureş)', zip: '547067' },
  { city: 'Fânaţele Mădăraşului (Mureş)', zip: '547068' },
  { city: 'Iştan-Tău (Mureş)', zip: '547069' },
  { city: 'Mădăraş (Mureş)', zip: '547071' },
  { city: 'Mărăşeşti (Mureş)', zip: '547072' },
  { city: 'Negrenii de Câmpie (Mureş)', zip: '547073' },
  { city: 'Oroiu (Mureş)', zip: '547074' },
  { city: 'Petea (Mureş)', zip: '547076' },
  { city: 'Ţiptelnic (Mureş)', zip: '547077' },
  { city: 'Valea Mare (Mureş)', zip: '547078' },
  { city: 'Valea Rece (Mureş)', zip: '547079' },
  { city: 'Batoş (Mureş)', zip: '547085' },
  { city: 'Dedrad (Mureş)', zip: '547086' },
  { city: 'Goreni (Mureş)', zip: '547087' },
  { city: 'Uila (Mureş)', zip: '547088' },
  { city: 'Băgaciu (Mureş)', zip: '547090' },
  { city: 'Delenii (Mureş)', zip: '547091' },
  { city: 'Băla (Mureş)', zip: '547095' },
  { city: 'Ercea (Mureş)', zip: '547096' },
  { city: 'Bălăuşeri (Mureş)', zip: '547100' },
  { city: 'Agrişteu (Mureş)', zip: '547101' },
  { city: 'Chendu (Mureş)', zip: '547102' },
  { city: 'Dumitreni (Mureş)', zip: '547103' },
  { city: 'Filitelnic (Mureş)', zip: '547104' },
  { city: 'Senereuş (Mureş)', zip: '547106' },
  { city: 'Beica de Jos (Mureş)', zip: '547110' },
  { city: 'Beica de Sus (Mureş)', zip: '547111' },
  { city: 'Căcuciu (Mureş)', zip: '547112' },
  { city: 'Nadăşa (Mureş)', zip: '547113' },
  { city: 'Sânmihai de Pădure (Mureş)', zip: '547114' },
  { city: 'Şerbeni (Mureş)', zip: '547116' },
  { city: 'Bichiş (Mureş)', zip: '547120' },
  { city: 'Gâmbuţ (Mureş)', zip: '547121' },
  { city: 'Nandra (Mureş)', zip: '547122' },
  { city: 'Ozd (Mureş)', zip: '547123' },
  { city: 'Bogata (Mureş)', zip: '547125' },
  { city: 'Ranta (Mureş)', zip: '547126' },
  { city: 'Brâncoveneşti (Mureş)', zip: '547130' },
  { city: 'Idicel (Mureş)', zip: '547131' },
  { city: 'Idicel-Pădure (Mureş)', zip: '547132' },
  { city: 'Săcalu de Pădure (Mureş)', zip: '547133' },
  { city: 'Vălenii de Mureş (Mureş)', zip: '547134' },
  { city: 'Breaza (Mureş)', zip: '547135' },
  { city: 'Filpişu Mare (Mureş)', zip: '547136' },
  { city: 'Filpişu Mic (Mureş)', zip: '547137' },
  { city: 'Ceuaşu de Câmpie (Mureş)', zip: '547140' },
  { city: 'Bozed (Mureş)', zip: '547141' },
  { city: 'Câmpeniţa (Mureş)', zip: '547142' },
  { city: 'Culpiu (Mureş)', zip: '547143' },
  { city: 'Herghelia (Mureş)', zip: '547144' },
  { city: 'Porumbeni (Mureş)', zip: '547146' },
  { city: 'Săbed (Mureş)', zip: '547147' },
  { city: 'Voiniceni (Mureş)', zip: '547148' },
  { city: 'Cheţani (Mureş)', zip: '547150' },
  { city: 'Coasta Grindului (Mureş)', zip: '547151' },
  { city: 'Cordoş (Mureş)', zip: '547152' },
  { city: 'Giurgiş (Mureş)', zip: '547153' },
  { city: 'Grindeni (Mureş)', zip: '547154' },
  { city: 'Hădăreni (Mureş)', zip: '547156' },
  { city: 'Linţ (Mureş)', zip: '547157' },
  { city: 'Chiheru de Jos (Mureş)', zip: '547160' },
  { city: 'Chiheru de Sus (Mureş)', zip: '547161' },
  { city: 'Urisiu de Jos (Mureş)', zip: '547162' },
  { city: 'Urisiu de Sus (Mureş)', zip: '547163' },
  { city: 'Coroisânmărtin (Mureş)', zip: '547165' },
  { city: 'Coroi (Mureş)', zip: '547166' },
  { city: 'Odrihei (Mureş)', zip: '547167' },
  { city: 'Şoimuş (Mureş)', zip: '547168' },
  { city: 'Cozma (Mureş)', zip: '547170' },
  { city: 'Fânaţele Socolului (Mureş)', zip: '547171' },
  { city: 'Socolu de Câmpie (Mureş)', zip: '547172' },
  { city: 'Valea Sasului (Mureş)', zip: '547173' },
  { city: 'Valea Ungurului (Mureş)', zip: '547174' },
  { city: 'Crăciuneşti (Mureş)', zip: '547175' },
  { city: 'Budiu Mic (Mureş)', zip: '547176' },
  { city: 'Cinta (Mureş)', zip: '547177' },
  { city: 'Corneşti (Crăciuneşti) (Mureş)', zip: '547178' },
  { city: 'Tirimioara (Mureş)', zip: '547179' },
  { city: 'Crăieşti (Mureş)', zip: '547180' },
  { city: 'Lefaia (Mureş)', zip: '547181' },
  { city: 'Milăşel (Mureş)', zip: '547182' },
  { city: 'Nima Milăşelului (Mureş)', zip: '547183' },
  { city: 'Ciba (Mureş)', zip: '547184' },
  { city: 'Cristeşti (Mureş)', zip: '547185' },
  { city: 'Vălureni (Mureş)', zip: '547186' },
  { city: 'Foi (Mureş)', zip: '547187' },
  { city: 'Nicoleşti (Mureş)', zip: '547188' },
  { city: 'Cucerdea (Mureş)', zip: '547190' },
  { city: 'Bord (Mureş)', zip: '547191' },
  { city: 'Şeulia de Mureş (Mureş)', zip: '547192' },
  { city: 'Cuci (Mureş)', zip: '547195' },
  { city: 'Dătăşeni (Mureş)', zip: '547196' },
  { city: 'După Deal (Cuci) (Mureş)', zip: '547197' },
  { city: 'Orosia (Mureş)', zip: '547198' },
  { city: 'Petrilaca (Mureş)', zip: '547199' },
  { city: 'Daneş (Mureş)', zip: '547200' },
  { city: 'Criş (Mureş)', zip: '547201' },
  { city: 'Seleuş (Daneş) (Mureş)', zip: '547202' },
  { city: 'Stejărenii (Mureş)', zip: '547203' },
  { city: 'Deda (Mureş)', zip: '547205' },
  { city: 'Bistra Mureşului (Mureş)', zip: '547206' },
  { city: 'Filea (Mureş)', zip: '547207' },
  { city: 'Pietriş (Mureş)', zip: '547208' },
  { city: 'Eremitu (Mureş)', zip: '547210' },
  { city: 'Călugăreni (Mureş)', zip: '547211' },
  { city: 'Câmpu Cetăţii (Mureş)', zip: '547212' },
  { city: 'Dămieni (Mureş)', zip: '547213' },
  { city: 'Mătrici (Mureş)', zip: '547214' },
  { city: 'Ernei (Mureş)', zip: '547215' },
  { city: 'Căluşeri (Mureş)', zip: '547216' },
  { city: 'Dumbrăvioara (Mureş)', zip: '547217' },
  { city: 'Icland (Mureş)', zip: '547218' },
  { city: 'Săcăreni (Mureş)', zip: '547219' },
  { city: 'Sângeru de Pădure (Mureş)', zip: '547221' },
  { city: 'Fărăgău (Mureş)', zip: '547225' },
  { city: 'Fânaţe (Fărăgău) (Mureş)', zip: '547226' },
  { city: 'Hodaia (Mureş)', zip: '547227' },
  { city: 'Onuca (Mureş)', zip: '547228' },
  { city: 'Poarta (Mureş)', zip: '547229' },
  { city: 'Tonciu (Mureş)', zip: '547231' },
  { city: 'Fântânele (Mureş)', zip: '547235' },
  { city: 'Bordoşiu (Mureş)', zip: '547236' },
  { city: 'Călimăneşti (Mureş)', zip: '547237' },
  { city: 'Cibu (Mureş)', zip: '547238' },
  { city: 'Roua (Mureş)', zip: '547239' },
  { city: 'Viforoasa (Mureş)', zip: '547241' },
  { city: 'Sânvăsii (Mureş)', zip: '547244' },
  { city: 'Găleşti (Mureş)', zip: '547245' },
  { city: 'Adrianu Mare (Mureş)', zip: '547246' },
  { city: 'Adrianu Mic (Mureş)', zip: '547247' },
  { city: 'Bedeni (Mureş)', zip: '547248' },
  { city: 'Maiad (Mureş)', zip: '547249' },
  { city: 'Troiţa (Mureş)', zip: '547251' },
  { city: 'Găneşti (Mureş)', zip: '547255' },
  { city: 'Păucişoara (Mureş)', zip: '547256' },
  { city: 'Sub Pădure (Mureş)', zip: '547257' },
  { city: 'Seuca (Mureş)', zip: '547258' },
  { city: 'Gheorghe Doja (Mureş)', zip: '547260' },
  { city: 'Ilieni (Mureş)', zip: '547261' },
  { city: 'Leordeni (Mureş)', zip: '547262' },
  { city: 'Satu Nou (Gheorghe Doja) (Mureş)', zip: '547263' },
  { city: 'Tirimia (Mureş)', zip: '547264' },
  { city: 'Ghindari (Mureş)', zip: '547265' },
  { city: 'Abud (Mureş)', zip: '547266' },
  { city: 'Ceie (Mureş)', zip: '547267' },
  { city: 'Chibed (Mureş)', zip: '547268' },
  { city: 'Solocma (Mureş)', zip: '547269' },
  { city: 'Trei Sate (Mureş)', zip: '547271' },
  { city: 'Glodeni (Mureş)', zip: '547275' },
  { city: 'Merişor (Mureş)', zip: '547276' },
  { city: 'Moişa (Mureş)', zip: '547277' },
  { city: 'Păcureni (Mureş)', zip: '547278' },
  { city: 'Păingeni (Mureş)', zip: '547279' },
  { city: 'Gorneşti (Mureş)', zip: '547280' },
  { city: 'Iara de Mureş (Mureş)', zip: '547281' },
  { city: 'Ilioara (Mureş)', zip: '547282' },
  { city: 'Mura Mare (Mureş)', zip: '547283' },
  { city: 'Mura Mică (Mureş)', zip: '547284' },
  { city: 'Pădureni (Mureş)', zip: '547286' },
  { city: 'Periş (Mureş)', zip: '547287' },
  { city: 'Petrilaca de Mureş (Mureş)', zip: '547288' },
  { city: 'Teleac (Mureş)', zip: '547289' },
  { city: 'Grebenişu de Câmpie (Mureş)', zip: '547290' },
  { city: 'Leorinţa (Mureş)', zip: '547291' },
  { city: 'Valea Sânpetrului (Grebenişu de Câmpie) (Mureş)', zip: '547292' },
  { city: 'Gurghiu (Mureş)', zip: '547295' },
  { city: 'Adrian (Mureş)', zip: '547296' },
  { city: 'Caşva (Mureş)', zip: '547297' },
  { city: 'Comori (Mureş)', zip: '547298' },
  { city: 'Fundoaia (Mureş)', zip: '547299' },
  { city: 'Glăjărie (Mureş)', zip: '547301' },
  { city: 'Larga (Gurghiu) (Mureş)', zip: '547302' },
  { city: 'Orşova (Mureş)', zip: '547303' },
  { city: 'Orşova-Pădure (Mureş)', zip: '547304' },
  { city: 'Păuloaia (Mureş)', zip: '547306' },
  { city: 'Hodac (Mureş)', zip: '547310' },
  { city: 'Arşiţa (Mureş)', zip: '547311' },
  { city: 'Bicaşu (Mureş)', zip: '547312' },
  { city: 'Dubiştea de Pădure (Mureş)', zip: '547313' },
  { city: 'Mirigioaia (Mureş)', zip: '547314' },
  { city: 'Toaca (Mureş)', zip: '547316' },
  { city: 'Uricea (Mureş)', zip: '547317' },
  { city: 'Hodoşa (Mureş)', zip: '547320' },
  { city: 'Ihod (Mureş)', zip: '547321' },
  { city: 'Isla (Mureş)', zip: '547322' },
  { city: 'Sâmbriaş (Mureş)', zip: '547323' },
  { city: 'Ibăneşti (Mureş)', zip: '547325' },
  { city: 'Blidireasa (Mureş)', zip: '547326' },
  { city: 'Brădeţelu (Mureş)', zip: '547327' },
  { city: 'Dulcea (Mureş)', zip: '547328' },
  { city: 'Ibăneşti-Pădure (Mureş)', zip: '547329' },
  { city: 'Lăpuşna (Mureş)', zip: '547331' },
  { city: 'Pârâu Mare (Mureş)', zip: '547332' },
  { city: 'Tireu (Mureş)', zip: '547333' },
  { city: 'Tisieu (Mureş)', zip: '547334' },
  { city: 'Zimţi (Mureş)', zip: '547336' },
  { city: 'Iclănzel (Mureş)', zip: '547340' },
  { city: 'Căpuşu de Câmpie (Mureş)', zip: '547341' },
  { city: 'Chisăliţa (Mureş)', zip: '547342' },
  { city: 'După Deal (Iclănzel) (Mureş)', zip: '547343' },
  { city: 'Fânaţe (Iclănzel) (Mureş)', zip: '547344' },
  { city: 'Fânaţele Căpuşului (Mureş)', zip: '547346' },
  { city: 'Ghidaşteu (Mureş)', zip: '547347' },
  { city: 'Iclandu Mare (Mureş)', zip: '547348' },
  { city: 'Mădărăşeni (Mureş)', zip: '547349' },
  { city: 'Tăblăşeni (Mureş)', zip: '547351' },
  { city: 'Valea Iclandului (Mureş)', zip: '547352' },
  { city: 'Ideciu de Jos (Mureş)', zip: '547360' },
  { city: 'Deleni (Ideciu de Jos) (Mureş)', zip: '547361' },
  { city: 'Ideciu de Sus (Mureş)', zip: '547362' },
  { city: 'Livezeni (Mureş)', zip: '547365' },
  { city: 'Bozeni (Mureş)', zip: '547366' },
  { city: 'Corunca (Mureş)', zip: '547367' },
  { city: 'Ivăneşti (Mureş)', zip: '547368' },
  { city: 'Poieniţa (Mureş)', zip: '547369' },
  { city: 'Sânişor (Mureş)', zip: '547371' },
  { city: 'Lunca (Mureş)', zip: '547375' },
  { city: 'Băiţa (Mureş)', zip: '547376' },
  { city: 'Frunzeni (Mureş)', zip: '547377' },
  { city: 'Logig (Mureş)', zip: '547378' },
  { city: 'Sântu (Mureş)', zip: '547379' },
  { city: 'Lunca Bradului (Mureş)', zip: '547380' },
  { city: 'Neagra (Mureş)', zip: '547381' },
  { city: 'Sălard (Mureş)', zip: '547382' },
  { city: 'Măgherani (Mureş)', zip: '547385' },
  { city: 'Bâra (Mureş)', zip: '547386' },
  { city: 'Bereni (Mureş)', zip: '547387' },
  { city: 'Cându (Mureş)', zip: '547388' },
  { city: 'Drojdii (Mureş)', zip: '547389' },
  { city: 'Eremieni (Mureş)', zip: '547391' },
  { city: 'Maia (Mureş)', zip: '547392' },
  { city: 'Mărculeni (Mureş)', zip: '547393' },
  { city: 'Şilea Nirajului (Mureş)', zip: '547394' },
  { city: 'Torba (Mureş)', zip: '547396' },
  { city: 'Mica (Mureş)', zip: '547400' },
  { city: 'Abuş (Mureş)', zip: '547401' },
  { city: 'Căpâlna de Sus (Mureş)', zip: '547402' },
  { city: 'Ceuaş (Mureş)', zip: '547403' },
  { city: 'Deaj (Mureş)', zip: '547404' },
  { city: 'Hărănglab (Mureş)', zip: '547406' },
  { city: 'Şomoştelnic (Mureş)', zip: '547407' },
  { city: 'Miercurea Nirajului (Mureş)', zip: '547410' },
  { city: 'Beu (Mureş)', zip: '547411' },
  { city: 'Dumitreştii (Mureş)', zip: '547412' },
  { city: 'Lăureni (Mureş)', zip: '547413' },
  { city: 'Moşuni (Mureş)', zip: '547414' },
  { city: 'Şardu Nirajului (Mureş)', zip: '547416' },
  { city: 'Tâmpa (Mureş)', zip: '547417' },
  { city: 'Veţa (Mureş)', zip: '547418' },
  { city: 'Miheşu de Câmpie (Mureş)', zip: '547420' },
  { city: 'Bujor (Mureş)', zip: '547421' },
  { city: 'Cirhagău (Mureş)', zip: '547422' },
  { city: 'Groapa Rădăii (Mureş)', zip: '547423' },
  { city: 'Mogoaia (Mureş)', zip: '547424' },
  { city: 'Răzoare (Mureş)', zip: '547426' },
  { city: 'Şăuliţa (Mureş)', zip: '547427' },
  { city: 'Ştefanca (Mureş)', zip: '547428' },
  { city: 'Nadeş (Mureş)', zip: '547430' },
  { city: 'Măgheruş (Mureş)', zip: '547431' },
  { city: 'Pipea (Mureş)', zip: '547432' },
  { city: 'Ţigmandru (Mureş)', zip: '547433' },
  { city: 'Neaua (Mureş)', zip: '547435' },
  { city: 'Ghineşti (Mureş)', zip: '547436' },
  { city: 'Rigmani (Mureş)', zip: '547437' },
  { city: 'Sânsimion (Mureş)', zip: '547438' },
  { city: 'Vădaş (Mureş)', zip: '547439' },
  { city: 'Ogra (Mureş)', zip: '547440' },
  { city: 'Dileu Vechi (Mureş)', zip: '547441' },
  { city: 'Giuluş (Mureş)', zip: '547442' },
  { city: 'Lăscud (Mureş)', zip: '547443' },
  { city: 'Vaideiu (Mureş)', zip: '547444' },
  { city: 'Papiu Ilarian (Mureş)', zip: '547445' },
  { city: 'Dobra (Mureş)', zip: '547446' },
  { city: 'Merişoru (Mureş)', zip: '547447' },
  { city: 'Şandru (Mureş)', zip: '547448' },
  { city: 'Ursoaia (Mureş)', zip: '547449' },
  { city: 'Pănet (Mureş)', zip: '547450' },
  { city: 'Berghia (Mureş)', zip: '547451' },
  { city: 'Cuieşd (Mureş)', zip: '547452' },
  { city: 'Hărţău (Mureş)', zip: '547453' },
  { city: 'Sântioana de Mureş (Mureş)', zip: '547454' },
  { city: 'Păsăreni (Mureş)', zip: '547455' },
  { city: 'Bolintineni (Mureş)', zip: '547456' },
  { city: 'Gălăţeni (Mureş)', zip: '547457' },
  { city: 'Petelea (Mureş)', zip: '547460' },
  { city: 'Habic (Mureş)', zip: '547461' },
  { city: 'Pogăceaua (Mureş)', zip: '547465' },
  { city: 'Bologaia (Mureş)', zip: '547466' },
  { city: 'Ciulea (Mureş)', zip: '547467' },
  { city: 'Deleni (Pogăceaua) (Mureş)', zip: '547468' },
  { city: 'Fântâna Babii (Mureş)', zip: '547469' },
  { city: 'Pârâu Crucii (Pogăceaua) (Mureş)', zip: '547471' },
  { city: 'Scurta (Mureş)', zip: '547472' },
  { city: 'Sicele (Mureş)', zip: '547473' },
  { city: 'Valea Sânpetrului (Pogăceaua) (Mureş)', zip: '547474' },
  { city: 'Văleni (Mureş)', zip: '547476' },
  { city: 'Răstoliţa (Mureş)', zip: '547480' },
  { city: 'Andreneasa (Mureş)', zip: '547481' },
  { city: 'Borzia (Mureş)', zip: '547482' },
  { city: 'Gălăoaia (Mureş)', zip: '547483' },
  { city: 'Iod (Mureş)', zip: '547484' },
  { city: 'Râciu (Mureş)', zip: '547485' },
  { city: 'Căciulata (Mureş)', zip: '547486' },
  { city: 'Coasta Mare (Mureş)', zip: '547487' },
  { city: 'Cotorinau (Mureş)', zip: '547488' },
  { city: 'Cureţe (Mureş)', zip: '547489' },
  { city: 'Hagău (Mureş)', zip: '547491' },
  { city: 'Leniş (Mureş)', zip: '547492' },
  { city: 'Nima Râciului (Mureş)', zip: '547493' },
  { city: 'Obârşie (Mureş)', zip: '547494' },
  { city: 'Pârâu Crucii (Râciu) (Mureş)', zip: '547496' },
  { city: 'Sânmărtinu de Câmpie (Mureş)', zip: '547497' },
  { city: 'Ulieş (Mureş)', zip: '547498' },
  { city: 'Valea Sânmărtinului (Mureş)', zip: '547499' },
  { city: 'Valea Seacă (Mureş)', zip: '547501' },
  { city: 'Valea Ulieşului (Mureş)', zip: '547502' },
  { city: 'Ruşii-Munţi (Mureş)', zip: '547505' },
  { city: 'Maioreşti (Mureş)', zip: '547506' },
  { city: 'Morăreni (Mureş)', zip: '547507' },
  { city: 'Sebeş (Mureş)', zip: '547508' },
  { city: 'Saschiz (Mureş)', zip: '547510' },
  { city: 'Cloaşterf (Mureş)', zip: '547511' },
  { city: 'Mihai Viteazu (Mureş)', zip: '547512' },
  { city: 'Sărmaşu (Mureş)', zip: '547515' },
  { city: 'Balda (Mureş)', zip: '547516' },
  { city: 'Larga (Sărmaşu) (Mureş)', zip: '547517' },
  { city: 'Moruţ (Mureş)', zip: '547518' },
  { city: 'Sărmăşel (Mureş)', zip: '547519' },
  { city: 'Sărmăşel-Gară (Mureş)', zip: '547521' },
  { city: 'Titiana (Mureş)', zip: '547522' },
  { city: 'Vişinelu (Mureş)', zip: '547523' },
  { city: 'Sâncraiu de Mureş (Mureş)', zip: '547525' },
  { city: 'Nazna (Mureş)', zip: '547526' },
  { city: 'Sângeorgiu de Mureş (Mureş)', zip: '547530' },
  { city: 'Cotuş (Mureş)', zip: '547531' },
  { city: 'Tofalău (Mureş)', zip: '547532' },
  { city: 'Sângeorgiu de Pădure (Mureş)', zip: '547535' },
  { city: 'Bezid (Mureş)', zip: '547536' },
  { city: 'Bezidu Nou (Mureş)', zip: '547537' },
  { city: 'Loţu (Mureş)', zip: '547538' },
  { city: 'Sânger (Mureş)', zip: '547540' },
  { city: 'Bârza (Mureş)', zip: '547541' },
  { city: 'Cipăieni (Mureş)', zip: '547542' },
  { city: 'Dalu (Mureş)', zip: '547543' },
  { city: 'Pripoare (Mureş)', zip: '547544' },
  { city: 'Vălişoara (Mureş)', zip: '547546' },
  { city: 'Zăpodea (Mureş)', zip: '547547' },
  { city: 'Sânpaul (Mureş)', zip: '547550' },
  { city: 'Chirileu (Mureş)', zip: '547551' },
  { city: 'Dileu Nou (Mureş)', zip: '547552' },
  { city: 'Sânmărghita (Mureş)', zip: '547553' },
  { city: 'Valea Izvoarelor (Mureş)', zip: '547554' },
  { city: 'Sânpetru de Câmpie (Mureş)', zip: '547555' },
  { city: 'Bârlibaş (Mureş)', zip: '547556' },
  { city: 'Dâmbu (Mureş)', zip: '547557' },
  { city: 'Satu Nou (Sânpetru de Câmpie) (Mureş)', zip: '547558' },
  { city: 'Sângeorgiu de Câmpie (Mureş)', zip: '547559' },
  { city: 'Tuşinu (Mureş)', zip: '547561' },
  { city: 'Sântana de Mureş (Mureş)', zip: '547565' },
  { city: 'Bărdeşti (Mureş)', zip: '547566' },
  { city: 'Chinari (Mureş)', zip: '547567' },
  { city: 'Curteni (Mureş)', zip: '547568' },
  { city: 'Solovăstru (Mureş)', zip: '547570' },
  { city: 'Jabeniţa (Mureş)', zip: '547571' },
  { city: 'Stânceni (Mureş)', zip: '547575' },
  { city: 'Ciobotani (Mureş)', zip: '547576' },
  { city: 'Meştera (Mureş)', zip: '547577' },
  { city: 'Suplac (Mureş)', zip: '547580' },
  { city: 'Idrifaia (Mureş)', zip: '547581' },
  { city: 'Laslău Mare (Mureş)', zip: '547582' },
  { city: 'Laslău Mic (Mureş)', zip: '547583' },
  { city: 'Vaidacuta (Mureş)', zip: '547584' },
  { city: 'Suseni (Mureş)', zip: '547585' },
  { city: 'Luieriu (Mureş)', zip: '547586' },
  { city: 'Şăulia (Mureş)', zip: '547590' },
  { city: 'Leorinţa-Şăulia (Mureş)', zip: '547591' },
  { city: 'Măcicăşeşti (Mureş)', zip: '547592' },
  { city: 'Pădurea (Mureş)', zip: '547593' },
  { city: 'Şincai (Mureş)', zip: '547595' },
  { city: 'Lechincioara (Mureş)', zip: '547596' },
  { city: 'Pusta (Mureş)', zip: '547597' },
  { city: 'Şincai-Fânaţe (Mureş)', zip: '547598' },
  { city: 'Tăureni (Mureş)', zip: '547600' },
  { city: 'Fânaţe (Tăureni) (Mureş)', zip: '547601' },
  { city: 'Moara de Jos (Mureş)', zip: '547602' },
  { city: 'Ungheni (Mureş)', zip: '547605' },
  { city: 'Cerghid (Mureş)', zip: '547606' },
  { city: 'Cerghizel (Mureş)', zip: '547607' },
  { city: 'Moreşti (Mureş)', zip: '547608' },
  { city: 'Recea (Mureş)', zip: '547609' },
  { city: 'Şăuşa (Mureş)', zip: '547611' },
  { city: 'Vidrasău (Mureş)', zip: '547612' },
  { city: 'Valea Largă (Mureş)', zip: '547615' },
  { city: 'Grădini (Mureş)', zip: '547616' },
  { city: 'Mălăeşti (Mureş)', zip: '547617' },
  { city: 'Poduri (Mureş)', zip: '547618' },
  { city: 'Valea Frăţiei (Mureş)', zip: '547619' },
  { city: 'Valea Glodului (Mureş)', zip: '547621' },
  { city: 'Valea Pădurii (Mureş)', zip: '547622' },
  { city: 'Valea Şurii (Mureş)', zip: '547623' },
  { city: 'Valea Urieşului (Mureş)', zip: '547624' },
  { city: 'Vărgata (Mureş)', zip: '547625' },
  { city: 'Grâuşorul (Mureş)', zip: '547626' },
  { city: 'Mitreşti (Mureş)', zip: '547627' },
  { city: 'Vadu (Mureş)', zip: '547628' },
  { city: 'Valea (Mureş)', zip: '547629' },
  { city: 'Vătava (Mureş)', zip: '547630' },
  { city: 'Dumbrava (Mureş)', zip: '547631' },
  { city: 'Râpa de Jos (Mureş)', zip: '547632' },
  { city: 'Vânători (Mureş)', zip: '547635' },
  { city: 'Archita (Mureş)', zip: '547636' },
  { city: 'Feleag (Mureş)', zip: '547637' },
  { city: 'Mureni (Mureş)', zip: '547638' },
  { city: 'Şoard (Mureş)', zip: '547639' },
  { city: 'Veţca (Mureş)', zip: '547640' },
  { city: 'Jacodu (Mureş)', zip: '547641' },
  { city: 'Sălaşuri (Mureş)', zip: '547642' },
  { city: 'Viişoara (Mureş)', zip: '547645' },
  { city: 'Ormeniş (Mureş)', zip: '547646' },
  { city: 'Sântioana (Mureş)', zip: '547647' },
  { city: 'Voivodeni (Mureş)', zip: '547650' },
  { city: 'Toldal (Mureş)', zip: '547651' },
  { city: 'Zagăr (Mureş)', zip: '547655' },
  { city: 'Seleuş (Zagăr) (Mureş)', zip: '547656' },
  { city: 'Zau de Câmpie (Mureş)', zip: '547660' },
  { city: 'Bărboşi (Mureş)', zip: '547661' },
  { city: 'Botei (Mureş)', zip: '547662' },
  { city: 'Bujor-Hodaie (Mureş)', zip: '547663' },
  { city: 'Ciretea (Mureş)', zip: '547664' },
  { city: 'Gaura Sângerului (Mureş)', zip: '547666' },
  { city: 'Malea (Mureş)', zip: '547667' },
  { city: 'Ştefăneaca (Mureş)', zip: '547668' },
  { city: 'Tău (Mureş)', zip: '547669' },
  { city: 'Ciritei (Neamţ)', zip: '610001' },
  { city: 'Doamna (Neamţ)', zip: '610002' },
  { city: 'Văleni (Piatra-Neamţ) (Neamţ)', zip: '610003' },
  { city: 'Piatra-Neamţ (Neamţ)', zip: '610004' },
  { city: 'Roman (Neamţ)', zip: '611001' },
  { city: 'Bicaz (Neamţ)', zip: '615100' },
  { city: 'Capşa (Neamţ)', zip: '615101' },
  { city: 'Dodeni (Neamţ)', zip: '615102' },
  { city: 'Izvoru Alb (Neamţ)', zip: '615103' },
  { city: 'Izvoru Muntelui (Neamţ)', zip: '615104' },
  { city: 'Potoci (Neamţ)', zip: '615105' },
  { city: 'Secu (Neamţ)', zip: '615106' },
  { city: 'Târgu Neamţ (Neamţ)', zip: '615200' },
  { city: 'Blebea (Neamţ)', zip: '615201' },
  { city: 'Humuleşti (Neamţ)', zip: '615202' },
  { city: 'Humuleştii Noi (Neamţ)', zip: '615203' },
  { city: 'Agapia-Mânăstire (Neamţ)', zip: '617005' },
  { city: 'Agapia (Neamţ)', zip: '617010' },
  { city: 'Filioara (Neamţ)', zip: '617011' },
  { city: 'Săcăluşeşti (Neamţ)', zip: '617012' },
  { city: 'Văratec (Neamţ)', zip: '617013' },
  { city: 'Bahna (Neamţ)', zip: '617015' },
  { city: 'Arămeşti (Neamţ)', zip: '617016' },
  { city: 'Băhnişoara (Neamţ)', zip: '617017' },
  { city: 'Broşteni (Neamţ)', zip: '617018' },
  { city: 'Izvoare (Bahna) (Neamţ)', zip: '617019' },
  { city: 'Liliac (Neamţ)', zip: '617021' },
  { city: 'Ţuţcanii din Deal (Neamţ)', zip: '617022' },
  { city: 'Ţuţcanii din Vale (Neamţ)', zip: '617023' },
  { city: 'Bălţăteşti (Neamţ)', zip: '617025' },
  { city: 'Ghindăoani (Neamţ)', zip: '617026' },
  { city: 'Valea Arini (Neamţ)', zip: '617027' },
  { city: 'Valea Seacă (Neamţ)', zip: '617028' },
  { city: 'Bâra (Neamţ)', zip: '617030' },
  { city: 'Boghicea (Neamţ)', zip: '617031' },
  { city: 'Căuşeni (Neamţ)', zip: '617032' },
  { city: 'Negreşti (Bâra) (Neamţ)', zip: '617033' },
  { city: 'Nistria (Neamţ)', zip: '617034' },
  { city: 'Rediu (Bâra) (Neamţ)', zip: '617036' },
  { city: 'Slobozia (Boghicea) (Neamţ)', zip: '617037' },
  { city: 'Bârgăuani (Neamţ)', zip: '617040' },
  { city: 'Bahna Mare (Neamţ)', zip: '617041' },
  { city: 'Baratca (Neamţ)', zip: '617042' },
  { city: 'Bălăneşti (Neamţ)', zip: '617043' },
  { city: 'Breaza (Neamţ)', zip: '617044' },
  { city: 'Certieni (Neamţ)', zip: '617046' },
  { city: 'Chilia (Neamţ)', zip: '617047' },
  { city: 'Dârloaia (Neamţ)', zip: '617048' },
  { city: 'Ghelăieşti (Neamţ)', zip: '617049' },
  { city: 'Hârtop (Neamţ)', zip: '617051' },
  { city: 'Homiceni (Neamţ)', zip: '617052' },
  { city: 'Talpa (Neamţ)', zip: '617053' },
  { city: 'Vlădiceni (Neamţ)', zip: '617054' },
  { city: 'Bicaz-Chei (Neamţ)', zip: '617060' },
  { city: 'Bârnadu (Neamţ)', zip: '617061' },
  { city: 'Gherman (Neamţ)', zip: '617062' },
  { city: 'Ivaneş (Neamţ)', zip: '617063' },
  { city: 'Bicazu Ardelean (Neamţ)', zip: '617065' },
  { city: 'Telec (Neamţ)', zip: '617066' },
  { city: 'Ticoş (Neamţ)', zip: '617067' },
  { city: 'Bodeşti (Neamţ)', zip: '617070' },
  { city: 'Bodeştii de Jos (Neamţ)', zip: '617071' },
  { city: 'Corni (Neamţ)', zip: '617072' },
  { city: 'Oşlobeni (Neamţ)', zip: '617073' },
  { city: 'Borca (Neamţ)', zip: '617075' },
  { city: 'Lunca (Borca) (Neamţ)', zip: '617076' },
  { city: 'Mădei (Neamţ)', zip: '617077' },
  { city: 'Pârâul Cârjei (Neamţ)', zip: '617078' },
  { city: 'Pârâul Pântei (Neamţ)', zip: '617079' },
  { city: 'Sabasa (Neamţ)', zip: '617081' },
  { city: 'Soci (Borca) (Neamţ)', zip: '617082' },
  { city: 'Borleşti (Neamţ)', zip: '617085' },
  { city: 'Mastacăn (Borleşti) (Neamţ)', zip: '617086' },
  { city: 'Nechit (Neamţ)', zip: '617087' },
  { city: 'Ruseni (Borleşti) (Neamţ)', zip: '617088' },
  { city: 'Şovoaia (Neamţ)', zip: '617089' },
  { city: 'Boteşti (Neamţ)', zip: '617090' },
  { city: 'Barticeşti (Neamţ)', zip: '617091' },
  { city: 'David (Neamţ)', zip: '617092' },
  { city: 'Moreni (Neamţ)', zip: '617093' },
  { city: 'Munteni (Neamţ)', zip: '617094' },
  { city: 'Nisiporeşti (Neamţ)', zip: '617096' },
  { city: 'Văleni (Neamţ)', zip: '617097' },
  { city: 'Bozieni (Neamţ)', zip: '617100' },
  { city: 'Băneasa (Neamţ)', zip: '617101' },
  { city: 'Crăieşti (Neamţ)', zip: '617102' },
  { city: 'Cuci (Neamţ)', zip: '617103' },
  { city: 'Iucşa (Neamţ)', zip: '617104' },
  { city: 'Brusturi (Neamţ)', zip: '617106' },
  { city: 'Drăgăneşti (Neamţ)', zip: '617107' },
  { city: 'Groşi (Neamţ)', zip: '617108' },
  { city: 'Orţăşti (Neamţ)', zip: '617109' },
  { city: 'Poiana (Brusturi) (Neamţ)', zip: '617111' },
  { city: 'Râşca (Neamţ)', zip: '617112' },
  { city: 'Şoimăreşti (Neamţ)', zip: '617113' },
  { city: 'Târzia (Neamţ)', zip: '617114' },
  { city: 'Cândeşti (Neamţ)', zip: '617115' },
  { city: 'Bărcăneşti (Neamţ)', zip: '617116' },
  { city: 'Dragova (Neamţ)', zip: '617117' },
  { city: 'Pădureni (Neamţ)', zip: '617118' },
  { city: 'Ţârdenii Mici (Neamţ)', zip: '617119' },
  { city: 'Vădurele (Cândeşti) (Neamţ)', zip: '617121' },
  { city: 'Ceahlău (Neamţ)', zip: '617125' },
  { city: 'Bistricioara (Neamţ)', zip: '617127' },
  { city: 'Pârâul Mare (Neamţ)', zip: '617128' },
  { city: 'Durău (Neamţ)', zip: '617130' },
  { city: 'Cordun (Neamţ)', zip: '617135' },
  { city: 'Pildeşti (Neamţ)', zip: '617136' },
  { city: 'Simioneşti (Neamţ)', zip: '617137' },
  { city: 'Costişa (Neamţ)', zip: '617140' },
  { city: 'Dorneşti (Neamţ)', zip: '617141' },
  { city: 'Frunzeni (Neamţ)', zip: '617142' },
  { city: 'Mănoaia (Neamţ)', zip: '617143' },
  { city: 'Crăcăoani (Neamţ)', zip: '617145' },
  { city: 'Cracăul Negru (Neamţ)', zip: '617146' },
  { city: 'Magazia (Neamţ)', zip: '617147' },
  { city: 'Mitocu Bălan (Neamţ)', zip: '617148' },
  { city: 'Poiana Crăcăoani (Neamţ)', zip: '617149' },
  { city: 'Dămuc (Neamţ)', zip: '617150' },
  { city: 'Huisurez (Neamţ)', zip: '617151' },
  { city: 'Trei Fântâni (Neamţ)', zip: '617152' },
  { city: 'Dobreni (Neamţ)', zip: '617155' },
  { city: 'Căşăria (Neamţ)', zip: '617156' },
  { city: 'Negreşti (Neamţ)', zip: '617157' },
  { city: 'Poiana (Negreşti) (Neamţ)', zip: '617158' },
  { city: 'Sărata (Neamţ)', zip: '617159' },
  { city: 'Doljeşti (Neamţ)', zip: '617160' },
  { city: 'Buhonca (Neamţ)', zip: '617161' },
  { city: 'Buruieneşti (Neamţ)', zip: '617162' },
  { city: 'Rotunda (Neamţ)', zip: '617163' },
  { city: 'Dragomireşti (Neamţ)', zip: '617165' },
  { city: 'Borniş (Neamţ)', zip: '617166' },
  { city: 'Hlăpeşti (Neamţ)', zip: '617167' },
  { city: 'Mastacăn (Dragomireşti) (Neamţ)', zip: '617168' },
  { city: 'Unghi (Neamţ)', zip: '617169' },
  { city: 'Vad (Neamţ)', zip: '617171' },
  { city: 'Dulceşti (Neamţ)', zip: '617175' },
  { city: 'Bozienii de Sus (Neamţ)', zip: '617176' },
  { city: 'Briţcani (Neamţ)', zip: '617177' },
  { city: 'Cârlig (Neamţ)', zip: '617178' },
  { city: 'Corhana (Neamţ)', zip: '617179' },
  { city: 'Poiana (Dulceşti) (Neamţ)', zip: '617181' },
  { city: 'Roşiori (Neamţ)', zip: '617182' },
  { city: 'Ruginoasa (Neamţ)', zip: '617183' },
  { city: 'Dumbrava Roşie (Neamţ)', zip: '617185' },
  { city: 'Brăşăuţi (Neamţ)', zip: '617186' },
  { city: 'Cut (Neamţ)', zip: '617187' },
  { city: 'Izvoare (Dumbrava Roşie) (Neamţ)', zip: '617188' },
  { city: 'Farcaşa (Neamţ)', zip: '617190' },
  { city: 'Buşmei (Neamţ)', zip: '617191' },
  { city: 'Frumosu (Neamţ)', zip: '617192' },
  { city: 'Popeşti (Farcaşa) (Neamţ)', zip: '617193' },
  { city: 'Stejaru (Farcaşa) (Neamţ)', zip: '617194' },
  { city: 'Făurei (Neamţ)', zip: '617195' },
  { city: 'Budeşti (Neamţ)', zip: '617196' },
  { city: 'Climeşti (Neamţ)', zip: '617197' },
  { city: 'Micşuneşti (Neamţ)', zip: '617198' },
  { city: 'Gârcina (Neamţ)', zip: '617200' },
  { city: 'Almaş (Neamţ)', zip: '617201' },
  { city: 'Cuejdiu (Neamţ)', zip: '617202' },
  { city: 'Gherăeşti (Neamţ)', zip: '617205' },
  { city: 'Gherăeştii Noi (Neamţ)', zip: '617206' },
  { city: 'Teţcani (Neamţ)', zip: '617207' },
  { city: 'Girov (Neamţ)', zip: '617210' },
  { city: 'Băluşeşti (Dochia) (Neamţ)', zip: '617211' },
  { city: 'Boţeşti (Neamţ)', zip: '617212' },
  { city: 'Căciuleşti (Neamţ)', zip: '617213' },
  { city: 'Dăneşti (Neamţ)', zip: '617214' },
  { city: 'Dochia (Neamţ)', zip: '617216' },
  { city: 'Doina (Neamţ)', zip: '617217' },
  { city: 'Gura Văii (Neamţ)', zip: '617218' },
  { city: 'Popeşti (Girov) (Neamţ)', zip: '617219' },
  { city: 'Turtureşti (Neamţ)', zip: '617221' },
  { city: 'Verşeşti (Neamţ)', zip: '617222' },
  { city: 'Grinţieş (Neamţ)', zip: '617230' },
  { city: 'Bradu (Neamţ)', zip: '617231' },
  { city: 'Poiana (Grinţieş) (Neamţ)', zip: '617232' },
  { city: 'Grumăzeşti (Neamţ)', zip: '617235' },
  { city: 'Curechiştea (Neamţ)', zip: '617236' },
  { city: 'Netezi (Neamţ)', zip: '617237' },
  { city: 'Topoliţa (Neamţ)', zip: '617238' },
  { city: 'Hangu (Neamţ)', zip: '617240' },
  { city: 'Buhalniţa (Neamţ)', zip: '617241' },
  { city: 'Chiriţeni (Neamţ)', zip: '617242' },
  { city: 'Grozăveşti (Neamţ)', zip: '617243' },
  { city: 'Rugineşti (Neamţ)', zip: '617244' },
  { city: 'Horia (Neamţ)', zip: '617245' },
  { city: 'Cotu Vameş (Neamţ)', zip: '617246' },
  { city: 'Icuşeşti (Neamţ)', zip: '617250' },
  { city: 'Băluşeşti (Icuşeşti) (Neamţ)', zip: '617251' },
  { city: 'Bătrâneşti (Neamţ)', zip: '617252' },
  { city: 'Mesteacăn (Neamţ)', zip: '617253' },
  { city: 'Rocna (Neamţ)', zip: '617254' },
  { city: 'Spiridoneşti (Neamţ)', zip: '617256' },
  { city: 'Tabăra (Neamţ)', zip: '617257' },
  { city: 'Ion Creangă (Neamţ)', zip: '617260' },
  { city: 'Avereşti (Neamţ)', zip: '617261' },
  { city: 'Izvoru (Neamţ)', zip: '617262' },
  { city: 'Muncelu (Neamţ)', zip: '617263' },
  { city: 'Recea (Neamţ)', zip: '617264' },
  { city: 'Stejaru (Ion Creangă) (Neamţ)', zip: '617266' },
  { city: 'Mărgineni (Neamţ)', zip: '617270' },
  { city: 'Hârţeşti (Neamţ)', zip: '617271' },
  { city: 'Hoiseşti (Neamţ)', zip: '617272' },
  { city: 'Itrineşti (Neamţ)', zip: '617273' },
  { city: 'Moldoveni (Neamţ)', zip: '617275' },
  { city: 'Hociungi (Neamţ)', zip: '617276' },
  { city: 'Oniceni (Neamţ)', zip: '617280' },
  { city: 'Ciornei (Neamţ)', zip: '617281' },
  { city: 'Gorun (Neamţ)', zip: '617282' },
  { city: 'Linseşti (Neamţ)', zip: '617283' },
  { city: 'Lunca (Oniceni) (Neamţ)', zip: '617284' },
  { city: 'Mărmureni (Neamţ)', zip: '617286' },
  { city: 'Pietrosu (Neamţ)', zip: '617287' },
  { city: 'Poiana Humei (Neamţ)', zip: '617288' },
  { city: 'Pustieta (Neamţ)', zip: '617289' },
  { city: 'Solca (Neamţ)', zip: '617291' },
  { city: 'Valea Enei (Neamţ)', zip: '617292' },
  { city: 'Păstrăveni (Neamţ)', zip: '617300' },
  { city: 'Lunca Moldovei (Neamţ)', zip: '617301' },
  { city: 'Rădeni (Neamţ)', zip: '617302' },
  { city: 'Spieşti (Neamţ)', zip: '617303' },
  { city: 'Pângăraţi (Neamţ)', zip: '617305' },
  { city: 'Oanţu (Neamţ)', zip: '617306' },
  { city: 'Pângărăcior (Neamţ)', zip: '617307' },
  { city: 'Poiana (Pângăraţi) (Neamţ)', zip: '617308' },
  { city: 'Preluca (Neamţ)', zip: '617309' },
  { city: 'Stejaru (Pângăraţi) (Neamţ)', zip: '617311' },
  { city: 'Petricani (Neamţ)', zip: '617315' },
  { city: 'Boiştea (Neamţ)', zip: '617316' },
  { city: 'Târpeşti (Neamţ)', zip: '617317' },
  { city: 'Ţolici (Neamţ)', zip: '617318' },
  { city: 'Piatra Şoimului (Neamţ)', zip: '617320' },
  { city: 'Luminiş (Neamţ)', zip: '617321' },
  { city: 'Neguleşti (Neamţ)', zip: '617322' },
  { city: 'Poieni (Neamţ)', zip: '617323' },
  { city: 'Pipirig (Neamţ)', zip: '617325' },
  { city: 'Boboieşti (Neamţ)', zip: '617326' },
  { city: 'Dolheşti (Neamţ)', zip: '617327' },
  { city: 'Leghin (Neamţ)', zip: '617328' },
  { city: 'Pâţâligeni (Neamţ)', zip: '617329' },
  { city: 'Pluton (Neamţ)', zip: '617331' },
  { city: 'Stânca (Neamţ)', zip: '617332' },
  { city: 'Podoleni (Neamţ)', zip: '617335' },
  { city: 'Negriteşti (Neamţ)', zip: '617336' },
  { city: 'Poiana Teiului (Neamţ)', zip: '617340' },
  { city: 'Călugăreni (Neamţ)', zip: '617341' },
  { city: 'Dreptu (Neamţ)', zip: '617342' },
  { city: 'Galu (Neamţ)', zip: '617343' },
  { city: 'Pârâul Fagului (Neamţ)', zip: '617344' },
  { city: 'Petru Vodă (Neamţ)', zip: '617346' },
  { city: 'Poiana Largului (Neamţ)', zip: '617347' },
  { city: 'Roşeni (Neamţ)', zip: '617348' },
  { city: 'Ruseni (Poiana Teiului) (Neamţ)', zip: '617349' },
  { city: 'Săvineşti (Poiana Teiului) (Neamţ)', zip: '617351' },
  { city: 'Topoliceni (Neamţ)', zip: '617352' },
  { city: 'Poienari (Neamţ)', zip: '617360' },
  { city: 'Bunghi (Neamţ)', zip: '617361' },
  { city: 'Ciurea (Neamţ)', zip: '617362' },
  { city: 'Holm (Neamţ)', zip: '617363' },
  { city: 'Patricheni (Neamţ)', zip: '617364' },
  { city: 'Pânceşti (Neamţ)', zip: '617366' },
  { city: 'Săcăleni (Neamţ)', zip: '617367' },
  { city: 'Tălpălăi (Neamţ)', zip: '617368' },
  { city: 'Răuceşti (Neamţ)', zip: '617370' },
  { city: 'Oglinzi (Neamţ)', zip: '617371' },
  { city: 'Săveşti (Neamţ)', zip: '617372' },
  { city: 'Ungheni (Neamţ)', zip: '617373' },
  { city: 'Războieni (Neamţ)', zip: '617375' },
  { city: 'Borşeni (Neamţ)', zip: '617376' },
  { city: 'Războienii de Jos (Neamţ)', zip: '617377' },
  { city: 'Valea Albă (Neamţ)', zip: '617378' },
  { city: 'Valea Mare (Neamţ)', zip: '617379' },
  { city: 'Rediu (Neamţ)', zip: '617380' },
  { city: 'Beţeşti (Neamţ)', zip: '617381' },
  { city: 'Poloboc (Neamţ)', zip: '617382' },
  { city: 'Socea (Neamţ)', zip: '617383' },
  { city: 'Români (Neamţ)', zip: '617385' },
  { city: 'Goşmani (Neamţ)', zip: '617386' },
  { city: 'Siliştea (Neamţ)', zip: '617387' },
  { city: 'Roznov (Neamţ)', zip: '617390' },
  { city: 'Chintinici (Neamţ)', zip: '617391' },
  { city: 'Slobozia (Roznov) (Neamţ)', zip: '617392' },
  { city: 'Sagna (Neamţ)', zip: '617395' },
  { city: 'Gâdinţi (Neamţ)', zip: '617396' },
  { city: 'Luţca (Neamţ)', zip: '617397' },
  { city: 'Traian (Săbăoani) (Neamţ)', zip: '617398' },
  { city: 'Vulpăşeşti (Neamţ)', zip: '617399' },
  { city: 'Săbăoani (Neamţ)', zip: '617400' },
  { city: 'Săvineşti (Neamţ)', zip: '617410' },
  { city: 'Dumbrava-Deal (Neamţ)', zip: '617411' },
  { city: 'Secuieni (Neamţ)', zip: '617415' },
  { city: 'Başta (Neamţ)', zip: '617416' },
  { city: 'Bârjoveni (Neamţ)', zip: '617417' },
  { city: 'Bogzeşti (Neamţ)', zip: '617418' },
  { city: 'Butnăreşti (Neamţ)', zip: '617419' },
  { city: 'Giuleşti (Neamţ)', zip: '617421' },
  { city: 'Prăjeşti (Neamţ)', zip: '617422' },
  { city: 'Secuienii Noi (Neamţ)', zip: '617423' },
  { city: 'Unceşti (Neamţ)', zip: '617424' },
  { city: 'Stăniţa (Neamţ)', zip: '617425' },
  { city: 'Chicerea (Neamţ)', zip: '617426' },
  { city: 'Ghidion (Neamţ)', zip: '617427' },
  { city: 'Poienile Oancei (Neamţ)', zip: '617428' },
  { city: 'Todireni (Neamţ)', zip: '617429' },
  { city: 'Veja (Neamţ)', zip: '617431' },
  { city: 'Vlădnicele (Neamţ)', zip: '617432' },
  { city: 'Ştefan cel Mare (Neamţ)', zip: '617435' },
  { city: 'Bordea (Neamţ)', zip: '617436' },
  { city: 'Cârligi (Neamţ)', zip: '617437' },
  { city: 'Deleni (Neamţ)', zip: '617438' },
  { city: 'Duşeşti (Neamţ)', zip: '617439' },
  { city: 'Ghigoieşti (Neamţ)', zip: '617441' },
  { city: 'Soci (Ştefan cel Mare) (Neamţ)', zip: '617442' },
  { city: 'Tarcău (Neamţ)', zip: '617445' },
  { city: 'Ardeluţa (Neamţ)', zip: '617446' },
  { city: 'Brateş (Neamţ)', zip: '617447' },
  { city: 'Cazaci (Neamţ)', zip: '617448' },
  { city: 'Schitu Tarcău (Neamţ)', zip: '617449' },
  { city: 'Straja (Neamţ)', zip: '617451' },
  { city: 'Taşca (Neamţ)', zip: '617455' },
  { city: 'Hamzoaia (Neamţ)', zip: '617456' },
  { city: 'Neagra (Neamţ)', zip: '617457' },
  { city: 'Ticoş-Floarea (Neamţ)', zip: '617458' },
  { city: 'Tazlău (Neamţ)', zip: '617460' },
  { city: 'Tămăşeni (Neamţ)', zip: '617465' },
  { city: 'Adjudeni (Neamţ)', zip: '617466' },
  { city: 'Timişeşti (Neamţ)', zip: '617470' },
  { city: 'Dumbrava (Neamţ)', zip: '617471' },
  { city: 'Plăieşu (Neamţ)', zip: '617472' },
  { city: 'Preuteşti (Neamţ)', zip: '617473' },
  { city: 'Zvorăneşti (Neamţ)', zip: '617474' },
  { city: 'Trifeşti (Neamţ)', zip: '617475' },
  { city: 'Miron Costin (Neamţ)', zip: '617476' },
  { city: 'Tupilaţi (Neamţ)', zip: '617480' },
  { city: 'Arămoaia (Neamţ)', zip: '617481' },
  { city: 'Hanul Ancuţei (Neamţ)', zip: '617482' },
  { city: 'Totoieşti (Neamţ)', zip: '617483' },
  { city: 'Ţibucani (Neamţ)', zip: '617485' },
  { city: 'Davideni (Neamţ)', zip: '617486' },
  { city: 'Ţibucanii de Jos (Neamţ)', zip: '617487' },
  { city: 'Urecheni (Neamţ)', zip: '617490' },
  { city: 'Ingăreşti (Neamţ)', zip: '617491' },
  { city: 'Plugari (Neamţ)', zip: '617492' },
  { city: 'Valea Ursului (Neamţ)', zip: '617495' },
  { city: 'Bucium (Neamţ)', zip: '617496' },
  { city: 'Chilii (Neamţ)', zip: '617497' },
  { city: 'Giurgeni (Neamţ)', zip: '617498' },
  { city: 'Muncelu de Jos (Neamţ)', zip: '617499' },
  { city: 'Vânători-Neamţ (Neamţ)', zip: '617500' },
  { city: 'Lunca (Vânători-Neamţ) (Neamţ)', zip: '617501' },
  { city: 'Mânăstirea Neamţ (Neamţ)', zip: '617502' },
  { city: 'Nemţişor (Neamţ)', zip: '617503' },
  { city: 'Alexandru cel Bun (Neamţ)', zip: '617505' },
  { city: 'Agârcia (Neamţ)', zip: '617506' },
  { city: 'Bisericani (Neamţ)', zip: '617507' },
  { city: 'Bistriţa (Neamţ)', zip: '617508' },
  { city: 'Scăricica (Neamţ)', zip: '617509' },
  { city: 'Vaduri (Neamţ)', zip: '617511' },
  { city: 'Vădurele (Alexandru cel Bun) (Neamţ)', zip: '617512' },
  { city: 'Viişoara (Neamţ)', zip: '617513' },
  { city: 'Zăneşti (Neamţ)', zip: '617515' },
  { city: 'Traian (Zăneşti) (Neamţ)', zip: '617516' },
  { city: 'Cireaşov (Olt)', zip: '230001' },
  { city: 'Slatina (Olt)', zip: '230002' },
  { city: 'Balş (Olt)', zip: '235100' },
  { city: 'Corbeni (Olt)', zip: '235101' },
  { city: 'Româna (Olt)', zip: '235102' },
  { city: 'Teiş (Olt)', zip: '235103' },
  { city: 'Caracal (Olt)', zip: '235200' },
  { city: 'Corabia (Olt)', zip: '235300' },
  { city: 'Tudor Vladimirescu (Olt)', zip: '235301' },
  { city: 'Vârtopu (Olt)', zip: '235302' },
  { city: 'Drăgăneşti-Olt (Olt)', zip: '235400' },
  { city: 'Comani (Olt)', zip: '235401' },
  { city: 'Piatra-Olt (Olt)', zip: '235500' },
  { city: 'Bistriţa Nouă (Olt)', zip: '235501' },
  { city: 'Criva de Jos (Olt)', zip: '235502' },
  { city: 'Criva de Sus (Olt)', zip: '235503' },
  { city: 'Enoşeşti (Olt)', zip: '235504' },
  { city: 'Piatra (Olt)', zip: '235505' },
  { city: 'Scorniceşti (Olt)', zip: '235600' },
  { city: 'Bălţaţi (Olt)', zip: '235601' },
  { city: 'Bircii (Olt)', zip: '235602' },
  { city: 'Chiţeasca (Olt)', zip: '235603' },
  { city: 'Constantineşti (Olt)', zip: '235604' },
  { city: 'Jitaru (Olt)', zip: '235605' },
  { city: 'Mărgineni-Slobozia (Olt)', zip: '235606' },
  { city: 'Mihăileşti-Popeşti (Olt)', zip: '235607' },
  { city: 'Mogoşeşti (Olt)', zip: '235608' },
  { city: 'Negreni (Olt)', zip: '235609' },
  { city: 'Piscani (Olt)', zip: '235610' },
  { city: 'Rusciori (Olt)', zip: '235611' },
  { city: 'Şuica (Olt)', zip: '235612' },
  { city: 'Teiuş (Olt)', zip: '235613' },
  { city: 'Baldovineşti (Olt)', zip: '237005' },
  { city: 'Băleasa (Olt)', zip: '237006' },
  { city: 'Broşteni (Olt)', zip: '237007' },
  { city: 'Dâmburile (Olt)', zip: '237008' },
  { city: 'Găvăneşti (Olt)', zip: '237009' },
  { city: 'Gubandru (Olt)', zip: '237011' },
  { city: 'Pietriş (Olt)', zip: '237012' },
  { city: 'Băbiciu (Olt)', zip: '237015' },
  { city: 'Bărăşti (Olt)', zip: '237020' },
  { city: 'Bărăştii de Cepturi (Olt)', zip: '237021' },
  { city: 'Bărăştii de Vede (Olt)', zip: '237022' },
  { city: 'Boroeşti (Olt)', zip: '237023' },
  { city: 'Ciocăneşti (Olt)', zip: '237024' },
  { city: 'Lăzăreşti (Olt)', zip: '237026' },
  { city: 'Mereni (Olt)', zip: '237027' },
  { city: 'Moţoeşti (Olt)', zip: '237028' },
  { city: 'Popeşti (Bărăşti) (Olt)', zip: '237029' },
  { city: 'Bârza (Olt)', zip: '237030' },
  { city: 'Braneţ (Olt)', zip: '237031' },
  { city: 'Bobiceşti (Olt)', zip: '237035' },
  { city: 'Bechet (Olt)', zip: '237036' },
  { city: 'Belgun (Olt)', zip: '237037' },
  { city: 'Chinteşti (Olt)', zip: '237038' },
  { city: 'Comăneşti (Olt)', zip: '237039' },
  { city: 'Govora (Olt)', zip: '237041' },
  { city: 'Leoteşti (Olt)', zip: '237042' },
  { city: 'Mirila (Olt)', zip: '237043' },
  { city: 'Brastavăţu (Olt)', zip: '237045' },
  { city: 'Cruşovu (Olt)', zip: '237046' },
  { city: 'Brâncoveni (Olt)', zip: '237050' },
  { city: 'Mărgheni (Olt)', zip: '237051' },
  { city: 'Ociogi (Olt)', zip: '237052' },
  { city: 'Văleni (Brâncoveni) (Olt)', zip: '237053' },
  { city: 'Brebeni (Olt)', zip: '237055' },
  { city: 'Teiuşu (Olt)', zip: '237056' },
  { city: 'Bucinişu (Olt)', zip: '237060' },
  { city: 'Bucinişu Mic (Olt)', zip: '237061' },
  { city: 'Cârlogani (Olt)', zip: '237065' },
  { city: 'Beculeşti (Olt)', zip: '237066' },
  { city: 'Cepari (Olt)', zip: '237067' },
  { city: 'Scorbura (Olt)', zip: '237068' },
  { city: 'Stupina (Olt)', zip: '237069' },
  { city: 'Cezieni (Olt)', zip: '237070' },
  { city: 'Bondrea (Olt)', zip: '237071' },
  { city: 'Corlăteşti (Olt)', zip: '237072' },
  { city: 'Cilieni (Olt)', zip: '237075' },
  { city: 'Coloneşti (Olt)', zip: '237080' },
  { city: 'Bărăşti (Coloneşti) (Olt)', zip: '237081' },
  { city: 'Bătăreni (Olt)', zip: '237082' },
  { city: 'Cârstani (Olt)', zip: '237083' },
  { city: 'Chelbeşti (Olt)', zip: '237084' },
  { city: 'Gueşti (Olt)', zip: '237086' },
  { city: 'Mărunţei (Coloneşti) (Olt)', zip: '237087' },
  { city: 'Năvârgeni (Olt)', zip: '237088' },
  { city: 'Vlaici (Olt)', zip: '237089' },
  { city: 'Corbu (Olt)', zip: '237090' },
  { city: 'Burduleşti (Olt)', zip: '237091' },
  { city: 'Buzeşti (Olt)', zip: '237092' },
  { city: 'Ciureşti (Olt)', zip: '237093' },
  { city: 'Milcoveni (Olt)', zip: '237094' },
  { city: 'Coteana (Olt)', zip: '237095' },
  { city: 'Crâmpoia (Olt)', zip: '237100' },
  { city: 'Buta (Olt)', zip: '237101' },
  { city: 'Cungrea (Olt)', zip: '237105' },
  { city: 'Cepeşti (Olt)', zip: '237106' },
  { city: 'Ibăneşti (Olt)', zip: '237107' },
  { city: 'Mieşti (Olt)', zip: '237108' },
  { city: 'Oteştii de Jos (Olt)', zip: '237109' },
  { city: 'Oteştii de Sus (Olt)', zip: '237111' },
  { city: 'Spătaru (Olt)', zip: '237112' },
  { city: 'Curtişoara (Olt)', zip: '237115' },
  { city: 'Dobrotinet (Olt)', zip: '237116' },
  { city: 'Linia din Vale (Olt)', zip: '237117' },
  { city: 'Pietrişu (Olt)', zip: '237118' },
  { city: 'Proaspeţi (Olt)', zip: '237119' },
  { city: 'Raiţiu (Olt)', zip: '237121' },
  { city: 'Dăneasa (Olt)', zip: '237125' },
  { city: 'Berindei (Olt)', zip: '237126' },
  { city: 'Cioflanu (Olt)', zip: '237127' },
  { city: 'Pestra (Olt)', zip: '237128' },
  { city: 'Zănoaga (Olt)', zip: '237129' },
  { city: 'Deveselu (Olt)', zip: '237130' },
  { city: 'Comanca (Olt)', zip: '237131' },
  { city: 'Dobreţu (Olt)', zip: '237135' },
  { city: 'Curtişoara (Dobreţu) (Olt)', zip: '237136' },
  { city: 'Horezu (Olt)', zip: '237137' },
  { city: 'Dobrosloveni (Olt)', zip: '237140' },
  { city: 'Frăsinetu (Olt)', zip: '237141' },
  { city: 'Potopinu (Olt)', zip: '237142' },
  { city: 'Reşca (Olt)', zip: '237143' },
  { city: 'Reşcuţa (Olt)', zip: '237144' },
  { city: 'Dobroteasa (Olt)', zip: '237145' },
  { city: 'Batia (Olt)', zip: '237146' },
  { city: 'Câmpu Mare (Olt)', zip: '237147' },
  { city: 'Vulpeşti (Olt)', zip: '237148' },
  { city: 'Dobrun (Olt)', zip: '237150' },
  { city: 'Bobu (Olt)', zip: '237151' },
  { city: 'Chilii (Olt)', zip: '237152' },
  { city: 'Osica de Jos (Olt)', zip: '237153' },
  { city: 'Roşienii Mari (Olt)', zip: '237154' },
  { city: 'Roşienii Mici (Olt)', zip: '237156' },
  { city: 'Ulmet (Olt)', zip: '237157' },
  { city: 'Drăghiceni (Olt)', zip: '237160' },
  { city: 'Grozăveşti (Olt)', zip: '237161' },
  { city: 'Liiceni (Olt)', zip: '237162' },
  { city: 'Făgeţelu (Olt)', zip: '237165' },
  { city: 'Bâgeşti (Olt)', zip: '237166' },
  { city: 'Chilia (Olt)', zip: '237167' },
  { city: 'Gruiu (Olt)', zip: '237168' },
  { city: 'Isaci (Olt)', zip: '237169' },
  { city: 'Pielcani (Olt)', zip: '237171' },
  { city: 'Fălcoiu (Olt)', zip: '237175' },
  { city: 'Cioroiaşu (Olt)', zip: '237176' },
  { city: 'Cioroiu (Olt)', zip: '237177' },
  { city: 'Fărcaşele (Olt)', zip: '237180' },
  { city: 'Fărcaşu de Jos (Olt)', zip: '237181' },
  { city: 'Ghimpaţi (Olt)', zip: '237182' },
  { city: 'Hotărani (Olt)', zip: '237183' },
  { city: 'Găneasa (Olt)', zip: '237185' },
  { city: 'Dranovăţu (Olt)', zip: '237186' },
  { city: 'Grădiştea (Olt)', zip: '237187' },
  { city: 'Izvoru (Olt)', zip: '237188' },
  { city: 'Oltişoru (Olt)', zip: '237189' },
  { city: 'Gârcov (Olt)', zip: '237190' },
  { city: 'Ursa (Olt)', zip: '237191' },
  { city: 'Giuvărăşti (Olt)', zip: '237195' },
  { city: 'Gostavăţu (Olt)', zip: '237200' },
  { city: 'Slăveni (Olt)', zip: '237201' },
  { city: 'Grădinari (Olt)', zip: '237205' },
  { city: 'Petculeşti (Olt)', zip: '237206' },
  { city: 'Runcu Mare (Olt)', zip: '237207' },
  { city: 'Satu Nou (Grădinari) (Olt)', zip: '237208' },
  { city: 'Grojdibodu (Olt)', zip: '237210' },
  { city: 'Hotaru (Olt)', zip: '237211' },
  { city: 'Ianca (Olt)', zip: '237215' },
  { city: 'Potelu (Olt)', zip: '237216' },
  { city: 'Iancu Jianu (Olt)', zip: '237220' },
  { city: 'Dobriceni (Olt)', zip: '237221' },
  { city: 'Preoteşti (Olt)', zip: '237222' },
  { city: 'Icoana (Olt)', zip: '237225' },
  { city: 'Floru (Olt)', zip: '237226' },
  { city: 'Ursoaia (Olt)', zip: '237227' },
  { city: 'Izbiceni (Olt)', zip: '237230' },
  { city: 'Izvoarele (Olt)', zip: '237235' },
  { city: 'Alimăneşti (Olt)', zip: '237236' },
  { city: 'Leleasca (Olt)', zip: '237240' },
  { city: 'Afumaţi (Olt)', zip: '237241' },
  { city: 'Greereşti (Olt)', zip: '237242' },
  { city: 'Mierliceşti (Olt)', zip: '237243' },
  { city: 'Toneşti (Leleasca) (Olt)', zip: '237244' },
  { city: 'Tufaru (Olt)', zip: '237246' },
  { city: 'Urşi (Olt)', zip: '237247' },
  { city: 'Mărunţei (Olt)', zip: '237250' },
  { city: 'Bălăneşti (Olt)', zip: '237251' },
  { city: 'Malu Roşu (Olt)', zip: '237252' },
  { city: 'Mihăeşti (Olt)', zip: '237255' },
  { city: 'Buşca (Olt)', zip: '237256' },
  { city: 'Milcov (Olt)', zip: '237260' },
  { city: 'Ipoteşti (Olt)', zip: '237261' },
  { city: 'Milcovu din Deal (Olt)', zip: '237262' },
  { city: 'Milcovu din Vale (Olt)', zip: '237263' },
  { city: 'Stejaru (Olt)', zip: '237264' },
  { city: 'Ulmi (Olt)', zip: '237266' },
  { city: 'Morunglav (Olt)', zip: '237270' },
  { city: 'Bărăşti (Morunglav) (Olt)', zip: '237271' },
  { city: 'Ghioşani (Olt)', zip: '237272' },
  { city: 'Moruneşti (Olt)', zip: '237273' },
  { city: 'Poiana Mare (Olt)', zip: '237274' },
  { city: 'Movileni (Olt)', zip: '237275' },
  { city: 'Bacea (Olt)', zip: '237276' },
  { city: 'Nicolae Titulescu (Olt)', zip: '237280' },
  { city: 'Ghimpeţeni (Olt)', zip: '237281' },
  { city: 'Ghimpeţenii Noi (Olt)', zip: '237282' },
  { city: 'Obârşia (Olt)', zip: '237285' },
  { city: 'Câmpu Părului (Olt)', zip: '237286' },
  { city: 'Coteni (Olt)', zip: '237287' },
  { city: 'Obârşia Nouă (Olt)', zip: '237288' },
  { city: 'Tabonu (Olt)', zip: '237289' },
  { city: 'Oboga (Olt)', zip: '237290' },
  { city: 'Călui (Olt)', zip: '237291' },
  { city: 'Gura Căluiu (Olt)', zip: '237292' },
  { city: 'Oporelu (Olt)', zip: '237295' },
  { city: 'Beria de Jos (Olt)', zip: '237296' },
  { city: 'Beria de Sus (Olt)', zip: '237297' },
  { city: 'Rădeşti (Olt)', zip: '237298' },
  { city: 'Optaşi-Măgura (Olt)', zip: '237300' },
  { city: 'Optaşi (Olt)', zip: '237301' },
  { city: 'Vităneşti (Olt)', zip: '237302' },
  { city: 'Sârbii-Măgura (Olt)', zip: '237303' },
  { city: 'Orlea (Olt)', zip: '237305' },
  { city: 'Gura Padinii (Olt)', zip: '237306' },
  { city: 'Orlea Nouă (Olt)', zip: '237307' },
  { city: 'Satu Nou (Gura Padinii) (Olt)', zip: '237308' },
  { city: 'Osica de Sus (Olt)', zip: '237310' },
  { city: 'Greci (Osica de Sus) (Olt)', zip: '237311' },
  { city: 'Ostrov (Olt)', zip: '237312' },
  { city: 'Peretu (Olt)', zip: '237313' },
  { city: 'Tomeni (Olt)', zip: '237314' },
  { city: 'Vlăduleni (Olt)', zip: '237315' },
  { city: 'Pârşcoveni (Olt)', zip: '237325' },
  { city: 'Butoi (Olt)', zip: '237326' },
  { city: 'Olari (Olt)', zip: '237327' },
  { city: 'Şopârliţa (Olt)', zip: '237328' },
  { city: 'Perieţi (Olt)', zip: '237330' },
  { city: 'Bălteni (Olt)', zip: '237331' },
  { city: 'Măgura (Perieţi) (Olt)', zip: '237332' },
  { city: 'Mierleştii de Sus (Olt)', zip: '237333' },
  { city: 'Pleşoiu (Olt)', zip: '237335' },
  { city: 'Arceşti (Olt)', zip: '237336' },
  { city: 'Arceşti-Cot (Olt)', zip: '237337' },
  { city: 'Cocorăşti (Olt)', zip: '237338' },
  { city: 'Doba (Olt)', zip: '237339' },
  { city: 'Schitu din Deal (Olt)', zip: '237341' },
  { city: 'Schitu din Vale (Olt)', zip: '237342' },
  { city: 'Poboru (Olt)', zip: '237345' },
  { city: 'Albeşti (Olt)', zip: '237346' },
  { city: 'Cornăţelu (Olt)', zip: '237347' },
  { city: 'Creţi (Olt)', zip: '237348' },
  { city: 'Seaca (Poboru) (Olt)', zip: '237349' },
  { city: 'Surpeni (Olt)', zip: '237351' },
  { city: 'Potcoava (Olt)', zip: '237355' },
  { city: 'Potcoava-Fălcoeni (Olt)', zip: '237356' },
  { city: 'Sineşti (Olt)', zip: '237357' },
  { city: 'Trufineşti (Olt)', zip: '237358' },
  { city: 'Valea Merilor (Olt)', zip: '237359' },
  { city: 'Priseaca (Olt)', zip: '237360' },
  { city: 'Buiceşti (Olt)', zip: '237361' },
  { city: 'Săltăneşti (Olt)', zip: '237362' },
  { city: 'Radomireşti (Olt)', zip: '237365' },
  { city: 'Călineşti (Olt)', zip: '237366' },
  { city: 'Crăciunei (Olt)', zip: '237367' },
  { city: 'Poiana (Olt)', zip: '237368' },
  { city: 'Redea (Olt)', zip: '237370' },
  { city: 'Redişoara (Olt)', zip: '237371' },
  { city: 'Valea Soarelui (Olt)', zip: '237372' },
  { city: 'Rotunda (Olt)', zip: '237375' },
  { city: 'Rusăneşti (Olt)', zip: '237380' },
  { city: 'Jieni (Olt)', zip: '237381' },
  { city: 'Sâmbureşti (Olt)', zip: '237385' },
  { city: 'Cerbeni (Olt)', zip: '237386' },
  { city: 'Ioniceşti (Olt)', zip: '237387' },
  { city: 'Lăunele (Olt)', zip: '237388' },
  { city: 'Mănuleşti (Olt)', zip: '237389' },
  { city: 'Stănuleasa (Sâmbureşti) (Olt)', zip: '237391' },
  { city: 'Toneşti (Sâmbureşti) (Olt)', zip: '237392' },
  { city: 'Scărişoara (Olt)', zip: '237395' },
  { city: 'Plăviceni (Olt)', zip: '237396' },
  { city: 'Rudari (Olt)', zip: '237397' },
  { city: 'Schitu (Olt)', zip: '237400' },
  { city: 'Catanele (Olt)', zip: '237401' },
  { city: 'Greci (Schitu) (Olt)', zip: '237402' },
  { city: 'Lisa (Olt)', zip: '237403' },
  { city: 'Moşteni (Olt)', zip: '237404' },
  { city: 'Seaca (Olt)', zip: '237405' },
  { city: 'Slătioara (Olt)', zip: '237410' },
  { city: 'Salcia (Olt)', zip: '237411' },
  { city: 'Spineni (Olt)', zip: '237415' },
  { city: 'Alunişu (Olt)', zip: '237416' },
  { city: 'Cuza Vodă (Olt)', zip: '237417' },
  { city: 'Davideşti (Olt)', zip: '237418' },
  { city: 'Optăşani (Olt)', zip: '237419' },
  { city: 'Profa (Olt)', zip: '237421' },
  { city: 'Vineţi (Olt)', zip: '237422' },
  { city: 'Sprâncenata (Olt)', zip: '237425' },
  { city: 'Bârseştii de Sus (Olt)', zip: '237426' },
  { city: 'Frunzaru (Olt)', zip: '237427' },
  { city: 'Uria (Olt)', zip: '237428' },
  { city: 'Stoeneşti (Olt)', zip: '237430' },
  { city: 'Stoicăneşti (Olt)', zip: '237435' },
  { city: 'Strejeşti (Olt)', zip: '237440' },
  { city: 'Colibaşi (Olt)', zip: '237441' },
  { city: 'Mamura (Olt)', zip: '237442' },
  { city: 'Strejeştii de Sus (Olt)', zip: '237443' },
  { city: 'Studina (Olt)', zip: '237445' },
  { city: 'Arvăteasca (Olt)', zip: '237446' },
  { city: 'Grădinile (Olt)', zip: '237447' },
  { city: 'Plăviceanca (Olt)', zip: '237448' },
  { city: 'Studiniţa (Olt)', zip: '237449' },
  { city: 'Şerbăneşti (Olt)', zip: '237450' },
  { city: 'Strugurelu (Olt)', zip: '237451' },
  { city: 'Şerbăneştii de Sus (Olt)', zip: '237452' },
  { city: 'Ştefan cel Mare (Olt)', zip: '237455' },
  { city: 'Ianca Nouă (Olt)', zip: '237456' },
  { city: 'Tătuleşti (Olt)', zip: '237460' },
  { city: 'Bărbălăi (Olt)', zip: '237461' },
  { city: 'Lunca (Olt)', zip: '237462' },
  { city: 'Măgura (Tătuleşti) (Olt)', zip: '237463' },
  { city: 'Mirceşti (Olt)', zip: '237464' },
  { city: 'Momaiu (Olt)', zip: '237466' },
  { city: 'Teslui (Olt)', zip: '237470' },
  { city: 'Cherleştii Moşteni (Olt)', zip: '237471' },
  { city: 'Cherleştii din Deal (Olt)', zip: '237472' },
  { city: 'Comăniţa (Olt)', zip: '237473' },
  { city: 'Corbu (Teslui) (Olt)', zip: '237474' },
  { city: 'Deleni (Olt)', zip: '237476' },
  { city: 'Schitu Deleni (Olt)', zip: '237477' },
  { city: 'Tia Mare (Olt)', zip: '237480' },
  { city: 'Doanca (Olt)', zip: '237481' },
  { city: 'Potlogeni (Olt)', zip: '237482' },
  { city: 'Topana (Olt)', zip: '237485' },
  { city: 'Cândeleşti (Olt)', zip: '237486' },
  { city: 'Ciorâca (Olt)', zip: '237487' },
  { city: 'Cojgărei (Olt)', zip: '237488' },
  { city: 'Ungureni (Olt)', zip: '237489' },
  { city: 'Traian (Olt)', zip: '237490' },
  { city: 'Tufeni (Olt)', zip: '237495' },
  { city: 'Barza (Olt)', zip: '237496' },
  { city: 'Stoborăşti (Olt)', zip: '237497' },
  { city: 'Urzica (Olt)', zip: '237500' },
  { city: 'Stăvaru (Olt)', zip: '237501' },
  { city: 'Valea Mare (Olt)', zip: '237505' },
  { city: 'Bârca (Olt)', zip: '237506' },
  { city: 'Recea (Olt)', zip: '237507' },
  { city: 'Turia (Olt)', zip: '237508' },
  { city: 'Zorleasca (Olt)', zip: '237509' },
  { city: 'Vădastra (Olt)', zip: '237510' },
  { city: 'Vişina Nouă (Olt)', zip: '237511' },
  { city: 'Vădăstriţa (Olt)', zip: '237515' },
  { city: 'Văleni (Olt)', zip: '237520' },
  { city: 'Mandra (Olt)', zip: '237521' },
  { city: 'Popeşti (Văleni) (Olt)', zip: '237522' },
  { city: 'Tirişneag (Olt)', zip: '237523' },
  { city: 'Vâlcele (Olt)', zip: '237525' },
  { city: 'Bărcăneşti (Olt)', zip: '237526' },
  { city: 'Vâlcelele de Sus (Olt)', zip: '237527' },
  { city: 'Verguleasa (Olt)', zip: '237530' },
  { city: 'Căzăneşti (Olt)', zip: '237531' },
  { city: 'Cucueţi (Olt)', zip: '237532' },
  { city: 'Dumitreşti (Olt)', zip: '237533' },
  { city: 'Poganu (Olt)', zip: '237534' },
  { city: 'Valea Fetei (Olt)', zip: '237536' },
  { city: 'Vâneşti (Olt)', zip: '237537' },
  { city: 'Vişina (Olt)', zip: '237540' },
  { city: 'Vitomireşti (Olt)', zip: '237545' },
  { city: 'Bulimanu (Olt)', zip: '237546' },
  { city: 'Dejeşti (Olt)', zip: '237547' },
  { city: 'Doneşti (Olt)', zip: '237548' },
  { city: 'Stănuleasa (Vitomireşti) (Olt)', zip: '237549' },
  { city: 'Trepteni (Olt)', zip: '237551' },
  { city: 'Vlădila (Olt)', zip: '237555' },
  { city: 'Frăsinet-Gară (Olt)', zip: '237556' },
  { city: 'Vlădila Nouă (Olt)', zip: '237557' },
  { city: 'Voineasa (Olt)', zip: '237560' },
  { city: 'Blaj (Olt)', zip: '237561' },
  { city: 'Mărgăriteşti (Olt)', zip: '237562' },
  { city: 'Racoviţa (Olt)', zip: '237563' },
  { city: 'Rusăneştii de Sus (Olt)', zip: '237564' },
  { city: 'Vulpeni (Olt)', zip: '237565' },
  { city: 'Cotorbeşti (Olt)', zip: '237566' },
  { city: 'Gropşani (Olt)', zip: '237567' },
  { city: 'Mardale (Olt)', zip: '237568' },
  { city: 'Pescăreşti (Olt)', zip: '237569' },
  { city: 'Plopşorelu (Olt)', zip: '237571' },
  { city: 'Prisaca (Olt)', zip: '237572' },
  { city: 'Simniceni (Olt)', zip: '237573' },
  { city: 'Tabaci (Olt)', zip: '237574' },
  { city: 'Valea Satului (Olt)', zip: '237576' },
  { city: 'Vultureşti (Olt)', zip: '237580' },
  { city: 'Dienci (Olt)', zip: '237581' },
  { city: 'Valea lui Alb (Olt)', zip: '237582' },
  { city: 'Vlăngăreşti (Olt)', zip: '237583' },
  { city: 'Ploieşti (Prahova)', zip: '100001' },
  { city: 'Azuga (Prahova)', zip: '105100' },
  { city: 'Băicoi (Prahova)', zip: '105200' },
  { city: 'Dâmbu (Prahova)', zip: '105201' },
  { city: 'Lilieşti (Prahova)', zip: '105202' },
  { city: 'Schela (Prahova)', zip: '105203' },
  { city: 'Tufeni (Prahova)', zip: '105204' },
  { city: 'Ţintea (Prahova)', zip: '105250' },
  { city: 'Boldeşti-Scăeni (Prahova)', zip: '105300' },
  { city: 'Seciu (Prahova)', zip: '105301' },
  { city: 'Breaza (Prahova)', zip: '105400' },
  { city: 'Breaza de Jos (Prahova)', zip: '105401' },
  { city: 'Breaza de Sus (Prahova)', zip: '105402' },
  { city: 'Frăsinet (Prahova)', zip: '105403' },
  { city: 'Gura Beliei (Prahova)', zip: '105404' },
  { city: 'Irimeşti (Prahova)', zip: '105405' },
  { city: 'Nistoreşti (Prahova)', zip: '105406' },
  { city: 'Podu Corbului (Prahova)', zip: '105407' },
  { city: 'Podu Vadului (Prahova)', zip: '105408' },
  { city: 'Surdeşti (Prahova)', zip: '105409' },
  { city: 'Valea Târsei (Prahova)', zip: '105410' },
  { city: 'Buşteni (Prahova)', zip: '105500' },
  { city: 'Poiana Ţapului (Prahova)', zip: '105550' },
  { city: 'Câmpina (Prahova)', zip: '105600' },
  { city: 'Comarnic (Prahova)', zip: '105700' },
  { city: 'Ghioşeşti (Prahova)', zip: '105701' },
  { city: 'Podu Lung (Prahova)', zip: '105702' },
  { city: 'Poiana (Prahova)', zip: '105703' },
  { city: 'Posada (Prahova)', zip: '105704' },
  { city: 'Mizil (Prahova)', zip: '105800' },
  { city: 'Fefelei (Prahova)', zip: '105801' },
  { city: 'Plopeni (Prahova)', zip: '105900' },
  { city: 'Sinaia (Prahova)', zip: '106100' },
  { city: 'Slănic (Prahova)', zip: '106200' },
  { city: 'Groşani (Prahova)', zip: '106201' },
  { city: 'Prăjani (Prahova)', zip: '106202' },
  { city: 'Urlaţi (Prahova)', zip: '106300' },
  { city: 'Arioneştii Noi (Prahova)', zip: '106301' },
  { city: 'Arioneştii Vechi (Prahova)', zip: '106302' },
  { city: 'Cherba (Prahova)', zip: '106303' },
  { city: 'Jercălăi (Prahova)', zip: '106304' },
  { city: 'Mărunţiş (Prahova)', zip: '106305' },
  { city: 'Orzoaia de Jos (Prahova)', zip: '106306' },
  { city: 'Orzoaia de Sus (Prahova)', zip: '106307' },
  { city: 'Schiau (Urlaţi) (Prahova)', zip: '106308' },
  { city: 'Ulmi (Prahova)', zip: '106309' },
  { city: 'Valea Bobului (Prahova)', zip: '106310' },
  { city: 'Valea Crângului (Prahova)', zip: '106311' },
  { city: 'Valea Mieilor (Prahova)', zip: '106312' },
  { city: 'Valea Nucetului (Prahova)', zip: '106313' },
  { city: 'Valea Pietrei (Prahova)', zip: '106314' },
  { city: 'Valea Seman (Prahova)', zip: '106315' },
  { city: 'Valea Urloii (Prahova)', zip: '106316' },
  { city: 'Vălenii de Munte (Prahova)', zip: '106400' },
  { city: 'Adunaţi (Prahova)', zip: '107005' },
  { city: 'Ocina de Jos (Prahova)', zip: '107006' },
  { city: 'Ocina de Sus (Prahova)', zip: '107007' },
  { city: 'Albeşti-Paleologu (Prahova)', zip: '107010' },
  { city: 'Albeşti-Muru (Prahova)', zip: '107011' },
  { city: 'Cioceni (Prahova)', zip: '107012' },
  { city: 'Vadu Părului (Prahova)', zip: '107013' },
  { city: 'Aluniş (Prahova)', zip: '107015' },
  { city: 'Ostrovu (Prahova)', zip: '107016' },
  { city: 'Apostolache (Prahova)', zip: '107020' },
  { city: 'Buzota (Prahova)', zip: '107021' },
  { city: 'Mârlogea (Prahova)', zip: '107022' },
  { city: 'Udreşti (Prahova)', zip: '107023' },
  { city: 'Valea Cricovului (Prahova)', zip: '107024' },
  { city: 'Ariceştii Rahtivani (Prahova)', zip: '107025' },
  { city: 'Buda (Ariceştii Rahtivani) (Prahova)', zip: '107026' },
  { city: 'Nedelea (Prahova)', zip: '107027' },
  { city: 'Stoeneşti (Prahova)', zip: '107028' },
  { city: 'Târgşoru Nou (Prahova)', zip: '107029' },
  { city: 'Ariceştii Zeletin (Prahova)', zip: '107030' },
  { city: 'Albinari (Prahova)', zip: '107031' },
  { city: 'Baba Ana (Prahova)', zip: '107035' },
  { city: 'Cireşanu (Prahova)', zip: '107036' },
  { city: 'Conduratu (Prahova)', zip: '107037' },
  { city: 'Crângurile (Prahova)', zip: '107038' },
  { city: 'Satu Nou (Baba Ana) (Prahova)', zip: '107039' },
  { city: 'Balta Doamnei (Prahova)', zip: '107040' },
  { city: 'Bâra (Prahova)', zip: '107041' },
  { city: 'Curcubeu (Prahova)', zip: '107042' },
  { city: 'Lacu Turcului (Prahova)', zip: '107043' },
  { city: 'Bălţeşti (Prahova)', zip: '107045' },
  { city: 'Izeşti (Prahova)', zip: '107046' },
  { city: 'Podenii Vechi (Prahova)', zip: '107047' },
  { city: 'Băneşti (Prahova)', zip: '107050' },
  { city: 'Urleta (Prahova)', zip: '107051' },
  { city: 'Bărcăneşti (Prahova)', zip: '107055' },
  { city: 'Ghighiu (Prahova)', zip: '107056' },
  { city: 'Puşcaşi (Prahova)', zip: '107057' },
  { city: 'Româneşti (Prahova)', zip: '107058' },
  { city: 'Tătărani (Prahova)', zip: '107059' },
  { city: 'Berceni (Prahova)', zip: '107060' },
  { city: 'Cartierul Dâmbu (Prahova)', zip: '107061' },
  { city: 'Cătunu (Berceni) (Prahova)', zip: '107062' },
  { city: 'Corlăteşti (Prahova)', zip: '107063' },
  { city: 'Moara Nouă (Prahova)', zip: '107064' },
  { city: 'Bertea (Prahova)', zip: '107065' },
  { city: 'Lutu Roşu (Prahova)', zip: '107066' },
  { city: 'Blejoi (Prahova)', zip: '107070' },
  { city: 'Ploieştiori (Prahova)', zip: '107071' },
  { city: 'Ţânţăreni (Prahova)', zip: '107072' },
  { city: 'Boldeşti-Grădiştea (Prahova)', zip: '107075' },
  { city: 'Boldeşti (Prahova)', zip: '107076' },
  { city: 'Grădiştea (Prahova)', zip: '107077' },
  { city: 'Brazi (Prahova)', zip: '107080' },
  { city: 'Băteşti (Prahova)', zip: '107082' },
  { city: 'Brazii de Jos (Prahova)', zip: '107083' },
  { city: 'Brazii de Sus (Prahova)', zip: '107084' },
  { city: 'Negoieşti (Prahova)', zip: '107086' },
  { city: 'Popeşti (Brazi) (Prahova)', zip: '107087' },
  { city: 'Stejaru (Prahova)', zip: '107088' },
  { city: 'Colonia Brazi (Prahova)', zip: '107090' },
  { city: 'Brebu (Prahova)', zip: '107100' },
  { city: 'Brebu Megieşesc (Prahova)', zip: '107101' },
  { city: 'Pietriceaua (Prahova)', zip: '107102' },
  { city: 'Podu Cheii (Prahova)', zip: '107103' },
  { city: 'Brebu Mânăstirei (Prahova)', zip: '107105' },
  { city: 'Bucov (Prahova)', zip: '107110' },
  { city: 'Bighilin (Prahova)', zip: '107111' },
  { city: 'Chiţorani (Prahova)', zip: '107112' },
  { city: 'Pleaşa (Prahova)', zip: '107113' },
  { city: 'Valea Orlei (Prahova)', zip: '107114' },
  { city: 'Călugăreni (Prahova)', zip: '107115' },
  { city: 'Valea Scheilor (Prahova)', zip: '107116' },
  { city: 'Cărbuneşti (Prahova)', zip: '107120' },
  { city: 'Gogeasca (Prahova)', zip: '107121' },
  { city: 'Ceptura (Prahova)', zip: '107125' },
  { city: 'Ceptura de Jos (Prahova)', zip: '107126' },
  { city: 'Malu Roşu (Prahova)', zip: '107127' },
  { city: 'Rotari (Prahova)', zip: '107128' },
  { city: 'Şoimeşti (Prahova)', zip: '107129' },
  { city: 'Ceptura de Sus (Prahova)', zip: '107130' },
  { city: 'Ceraşu (Prahova)', zip: '107140' },
  { city: 'Slon (Prahova)', zip: '107141' },
  { city: 'Valea Borului (Prahova)', zip: '107142' },
  { city: 'Valea Brădetului (Prahova)', zip: '107143' },
  { city: 'Valea Lespezii (Prahova)', zip: '107144' },
  { city: 'Valea Tocii (Prahova)', zip: '107146' },
  { city: 'Chiojdeanca (Prahova)', zip: '107150' },
  { city: 'Nucet (Chiojdeanca) (Prahova)', zip: '107151' },
  { city: 'Trenu (Prahova)', zip: '107152' },
  { city: 'Ciorani (Prahova)', zip: '107155' },
  { city: 'Cioranii de Sus (Prahova)', zip: '107156' },
  { city: 'Cioranii de Jos (Prahova)', zip: '107160' },
  { city: 'Cocorăştii Mislii (Prahova)', zip: '107165' },
  { city: 'Goruna (Prahova)', zip: '107166' },
  { city: 'Ţipăreşti (Prahova)', zip: '107167' },
  { city: 'Colceag (Prahova)', zip: '107170' },
  { city: 'Inoteşti (Prahova)', zip: '107171' },
  { city: 'Parepa-Ruşani (Prahova)', zip: '107172' },
  { city: 'Vâlcelele (Prahova)', zip: '107173' },
  { city: 'Cornu (Prahova)', zip: '107175' },
  { city: 'Cornu de Sus (Cornu) (Prahova)', zip: '107176' },
  { city: 'Valea Oprii (Prahova)', zip: '107177' },
  { city: 'Cornu de Jos (Cornu) (Prahova)', zip: '107180' },
  { city: 'Cosminele (Prahova)', zip: '107185' },
  { city: 'Cosmina de Jos (Prahova)', zip: '107186' },
  { city: 'Cosmina de Sus (Prahova)', zip: '107187' },
  { city: 'Drăghiceşti (Prahova)', zip: '107188' },
  { city: 'Poiana Trestiei (Prahova)', zip: '107189' },
  { city: 'Drajna (Prahova)', zip: '107190' },
  { city: 'Cătunu (Drajna) (Prahova)', zip: '107191' },
  { city: 'Ciocrac (Prahova)', zip: '107192' },
  { city: 'Drajna de Jos (Prahova)', zip: '107193' },
  { city: 'Drajna de Sus (Prahova)', zip: '107194' },
  { city: 'Făget (Prahova)', zip: '107196' },
  { city: 'Ogretin (Prahova)', zip: '107197' },
  { city: 'Piatra (Drajna) (Prahova)', zip: '107198' },
  { city: 'Piţigoi (Prahova)', zip: '107199' },
  { city: 'Plai (Prahova)', zip: '107201' },
  { city: 'Podurile (Prahova)', zip: '107202' },
  { city: 'Poiana Mierlei (Prahova)', zip: '107203' },
  { city: 'Drăgăneşti (Prahova)', zip: '107210' },
  { city: 'Bărăitaru (Prahova)', zip: '107211' },
  { city: 'Belciug (Prahova)', zip: '107212' },
  { city: 'Cornu de Jos (Drăgăneşti) (Prahova)', zip: '107213' },
  { city: 'Hătcărău (Prahova)', zip: '107214' },
  { city: 'Meri (Prahova)', zip: '107216' },
  { city: 'Tufani (Prahova)', zip: '107217' },
  { city: 'Dumbrava (Prahova)', zip: '107220' },
  { city: 'Ciupelniţa (Prahova)', zip: '107221' },
  { city: 'Cornu de Sus (Dumbrava) (Prahova)', zip: '107222' },
  { city: 'Trestienii de Jos (Prahova)', zip: '107223' },
  { city: 'Trestienii de Sus (Prahova)', zip: '107224' },
  { city: 'Zănoaga (Prahova)', zip: '107226' },
  { city: 'Dumbrăveşti (Prahova)', zip: '107230' },
  { city: 'Găvănel (Prahova)', zip: '107231' },
  { city: 'Mălăeştii de Jos (Prahova)', zip: '107232' },
  { city: 'Mălăeştii de Sus (Prahova)', zip: '107233' },
  { city: 'Plopeni (Dumbrăveşti) (Prahova)', zip: '107234' },
  { city: 'Sfârleanca (Prahova)', zip: '107236' },
  { city: 'Fântânele (Prahova)', zip: '107240' },
  { city: 'Bozieni (Prahova)', zip: '107241' },
  { city: 'Ghinoaica (Prahova)', zip: '107242' },
  { city: 'Ungureni (Vadu Săpat) (Prahova)', zip: '107243' },
  { city: 'Vadu Săpat (Prahova)', zip: '107244' },
  { city: 'Filipeştii de Pădure (Prahova)', zip: '107245' },
  { city: 'Diţeşti (Prahova)', zip: '107246' },
  { city: 'Minieri (Prahova)', zip: '107247' },
  { city: 'Siliştea Dealului (Prahova)', zip: '107248' },
  { city: 'Filipeştii de Târg (Prahova)', zip: '107250' },
  { city: 'Brătăşanca (Prahova)', zip: '107251' },
  { city: 'Ezeni (Prahova)', zip: '107252' },
  { city: 'Mărginenii de Jos (Prahova)', zip: '107253' },
  { city: 'Ungureni (Filipeştii de Târg) (Prahova)', zip: '107254' },
  { city: 'Floreşti (Prahova)', zip: '107255' },
  { city: 'Cap Roşu (Prahova)', zip: '107256' },
  { city: 'Călineşti (Prahova)', zip: '107257' },
  { city: 'Cătina (Prahova)', zip: '107258' },
  { city: 'Novăceşti (Prahova)', zip: '107259' },
  { city: 'Fulga (Prahova)', zip: '107260' },
  { city: 'Fulga de Jos (Prahova)', zip: '107261' },
  { city: 'Fulga de Sus (Prahova)', zip: '107262' },
  { city: 'Gherghiţa (Prahova)', zip: '107265' },
  { city: 'Fânari (Olari) (Prahova)', zip: '107266' },
  { city: 'Independenţa (Prahova)', zip: '107267' },
  { city: 'Malamuc (Prahova)', zip: '107268' },
  { city: 'Olari (Prahova)', zip: '107269' },
  { city: 'Olarii Vechi (Prahova)', zip: '107271' },
  { city: 'Ungureni (Gherghiţa) (Prahova)', zip: '107272' },
  { city: 'Gorgota (Prahova)', zip: '107275' },
  { city: 'Crivina (Prahova)', zip: '107276' },
  { city: 'Fânari (Gorgota) (Prahova)', zip: '107277' },
  { city: 'Poienarii Apostoli (Prahova)', zip: '107278' },
  { city: 'Potigrafu (Prahova)', zip: '107280' },
  { city: 'Gornet (Prahova)', zip: '107285' },
  { city: 'Bogdăneşti (Prahova)', zip: '107286' },
  { city: 'Cuib (Prahova)', zip: '107287' },
  { city: 'Nucet (Gornet) (Prahova)', zip: '107288' },
  { city: 'Gornet-Cricov (Prahova)', zip: '107290' },
  { city: 'Coşerele (Prahova)', zip: '107291' },
  { city: 'Dobrota (Prahova)', zip: '107292' },
  { city: 'Priseaca (Prahova)', zip: '107293' },
  { city: 'Ţărculeşti (Prahova)', zip: '107294' },
  { city: 'Valea Seacă (Prahova)', zip: '107296' },
  { city: 'Gura Vadului (Prahova)', zip: '107300' },
  { city: 'Perşunari (Gura Vadului) (Prahova)', zip: '107301' },
  { city: 'Tohani (Prahova)', zip: '107302' },
  { city: 'Gura Vitioarei (Prahova)', zip: '107305' },
  { city: 'Bughea de Jos (Prahova)', zip: '107306' },
  { city: 'Făgetu (Prahova)', zip: '107307' },
  { city: 'Fundeni (Prahova)', zip: '107308' },
  { city: 'Poiana Copăceni (Prahova)', zip: '107309' },
  { city: 'Iordăcheanu (Prahova)', zip: '107310' },
  { city: 'Moceşti (Prahova)', zip: '107311' },
  { city: 'Plavia (Prahova)', zip: '107312' },
  { city: 'Străoşti (Prahova)', zip: '107313' },
  { city: 'Valea Cucului (Prahova)', zip: '107314' },
  { city: 'Vărbila (Prahova)', zip: '107316' },
  { city: 'Izvoarele (Prahova)', zip: '107320' },
  { city: 'Cerneşti (Prahova)', zip: '107321' },
  { city: 'Chiriţeşti (Prahova)', zip: '107322' },
  { city: 'Homorâciu (Prahova)', zip: '107323' },
  { city: 'Malu Vânăt (Prahova)', zip: '107324' },
  { city: 'Schiuleşti (Prahova)', zip: '107326' },
  { city: 'Jugureni (Prahova)', zip: '107330' },
  { city: 'Boboci (Prahova)', zip: '107331' },
  { city: 'Marginea Pădurii (Prahova)', zip: '107332' },
  { city: 'Valea Unghiului (Prahova)', zip: '107333' },
  { city: 'Lapoş (Prahova)', zip: '107335' },
  { city: 'Glod (Prahova)', zip: '107336' },
  { city: 'Lăpoşel (Prahova)', zip: '107337' },
  { city: 'Pietricica (Prahova)', zip: '107338' },
  { city: 'Lipăneşti (Prahova)', zip: '107340' },
  { city: 'Satu Nou (Lipăneşti) (Prahova)', zip: '107341' },
  { city: 'Şipotu (Prahova)', zip: '107342' },
  { city: 'Zamfira (Prahova)', zip: '107343' },
  { city: 'Măgurele (Prahova)', zip: '107345' },
  { city: 'Coada Malului (Prahova)', zip: '107346' },
  { city: 'Iazu (Prahova)', zip: '107347' },
  { city: 'Măgureni (Prahova)', zip: '107350' },
  { city: 'Cocorăştii Caplii (Prahova)', zip: '107351' },
  { city: 'Lunca Prahovei (Prahova)', zip: '107352' },
  { city: 'Măneciu (Prahova)', zip: '107355' },
  { city: 'Cheia (Prahova)', zip: '107356' },
  { city: 'Chiciureni (Prahova)', zip: '107357' },
  { city: 'Costeni (Prahova)', zip: '107358' },
  { city: 'Făcăieni (Prahova)', zip: '107359' },
  { city: 'Gheaba (Prahova)', zip: '107361' },
  { city: 'Măneciu-Pământeni (Prahova)', zip: '107362' },
  { city: 'Mânăstirea Suzana (Prahova)', zip: '107363' },
  { city: 'Plăieţu (Prahova)', zip: '107364' },
  { city: 'Măneciu-Ungureni (Prahova)', zip: '107365' },
  { city: 'Măneşti (Prahova)', zip: '107375' },
  { city: 'Băltiţa (Prahova)', zip: '107376' },
  { city: 'Cheşnoiu (Prahova)', zip: '107377' },
  { city: 'Coada Izvorului (Prahova)', zip: '107378' },
  { city: 'Cocorăştii Colţ (Prahova)', zip: '107379' },
  { city: 'Cocorăştii Grind (Prahova)', zip: '107381' },
  { city: 'Colţu de Jos (Prahova)', zip: '107382' },
  { city: 'Ghioldum (Prahova)', zip: '107383' },
  { city: 'Gura Crivăţului (Prahova)', zip: '107384' },
  { city: 'Perşunari (Cocorăştii Colţ) (Prahova)', zip: '107386' },
  { city: 'Piatra (Cocorăştii Colţ) (Prahova)', zip: '107387' },
  { city: 'Satu de Sus (Prahova)', zip: '107388' },
  { city: 'Zalhanaua (Prahova)', zip: '107389' },
  { city: 'Păcureţi (Prahova)', zip: '107395' },
  { city: 'Bărzila (Prahova)', zip: '107396' },
  { city: 'Curmătura (Prahova)', zip: '107397' },
  { city: 'Matiţa (Prahova)', zip: '107398' },
  { city: 'Slavu (Prahova)', zip: '107399' },
  { city: 'Păuleşti (Prahova)', zip: '107400' },
  { city: 'Cocoşeşti (Prahova)', zip: '107401' },
  { city: 'Găgeni (Prahova)', zip: '107402' },
  { city: 'Păuleştii Noi (Prahova)', zip: '107403' },
  { city: 'Plopu (Prahova)', zip: '107405' },
  { city: 'Gâlmeia (Prahova)', zip: '107406' },
  { city: 'Hârsa (Prahova)', zip: '107407' },
  { city: 'Nisipoasa (Prahova)', zip: '107408' },
  { city: 'Podenii Noi (Prahova)', zip: '107410' },
  { city: 'Ghiocel (Prahova)', zip: '107411' },
  { city: 'Mehedinţa (Prahova)', zip: '107412' },
  { city: 'Nevesteasca (Prahova)', zip: '107413' },
  { city: 'Podu lui Galben (Prahova)', zip: '107414' },
  { city: 'Popeşti (Podenii Noi) (Prahova)', zip: '107416' },
  { city: 'Rahova (Prahova)', zip: '107417' },
  { city: 'Sălcioara (Prahova)', zip: '107418' },
  { city: 'Sfăcăru (Prahova)', zip: '107419' },
  { city: 'Valea Dulce (Prahova)', zip: '107421' },
  { city: 'Poiana Câmpina (Prahova)', zip: '107425' },
  { city: 'Bobolia (Prahova)', zip: '107426' },
  { city: 'Pietrişu (Prahova)', zip: '107427' },
  { city: 'Răgman (Prahova)', zip: '107428' },
  { city: 'Poienarii Burchii (Prahova)', zip: '107430' },
  { city: 'Cărbunari (Prahova)', zip: '107431' },
  { city: 'Ologeni (Prahova)', zip: '107432' },
  { city: 'Pioreşti (Prahova)', zip: '107433' },
  { city: 'Podu Văleni (Prahova)', zip: '107434' },
  { city: 'Poienarii Vechi (Prahova)', zip: '107436' },
  { city: 'Poienarii-Rali (Prahova)', zip: '107437' },
  { city: 'Tătărăi (Prahova)', zip: '107438' },
  { city: 'Poseşti (Prahova)', zip: '107440' },
  { city: 'Bodeşti (Prahova)', zip: '107441' },
  { city: 'Merdeala (Prahova)', zip: '107442' },
  { city: 'Nucşoara de Jos (Prahova)', zip: '107443' },
  { city: 'Nucşoara de Sus (Prahova)', zip: '107444' },
  { city: 'Poseştii-Pământeni (Prahova)', zip: '107446' },
  { city: 'Poseştii-Ungureni (Prahova)', zip: '107447' },
  { city: 'Târleşti (Prahova)', zip: '107448' },
  { city: 'Valea Plopului (Prahova)', zip: '107449' },
  { city: 'Valea Screzii (Prahova)', zip: '107451' },
  { city: 'Valea Stupinii (Prahova)', zip: '107452' },
  { city: 'Predeal-Sărari (Prahova)', zip: '107460' },
  { city: 'Bobiceşti (Prahova)', zip: '107461' },
  { city: 'Poienile (Prahova)', zip: '107462' },
  { city: 'Predeal (Prahova)', zip: '107463' },
  { city: 'Sărari (Prahova)', zip: '107464' },
  { city: 'Sărăţel (Prahova)', zip: '107466' },
  { city: 'Tulburea (Prahova)', zip: '107467' },
  { city: 'Tulburea-Văleni (Prahova)', zip: '107468' },
  { city: 'Vitioara de Sus (Prahova)', zip: '107469' },
  { city: 'Zâmbroaia (Prahova)', zip: '107471' },
  { city: 'Proviţa de Jos (Prahova)', zip: '107475' },
  { city: 'Drăgăneasa (Prahova)', zip: '107476' },
  { city: 'Piatra (Proviţa de Jos) (Prahova)', zip: '107477' },
  { city: 'Proviţa de Sus (Prahova)', zip: '107480' },
  { city: 'Izvoru (Prahova)', zip: '107481' },
  { city: 'Plaiu (Proviţa de Sus) (Prahova)', zip: '107482' },
  { city: 'Valea Bradului (Prahova)', zip: '107483' },
  { city: 'Puchenii Mari (Prahova)', zip: '107485' },
  { city: 'Miroslăveşti (Prahova)', zip: '107486' },
  { city: 'Moara (Prahova)', zip: '107487' },
  { city: 'Odăile (Prahova)', zip: '107488' },
  { city: 'Pietroşani (Prahova)', zip: '107489' },
  { city: 'Puchenii Mici (Prahova)', zip: '107491' },
  { city: 'Puchenii-Moşneni (Prahova)', zip: '107492' },
  { city: 'Râfov (Prahova)', zip: '107495' },
  { city: 'Antofiloaia (Prahova)', zip: '107496' },
  { city: 'Buchilaşi (Prahova)', zip: '107497' },
  { city: 'Buda (Râfov) (Prahova)', zip: '107498' },
  { city: 'Goga (Prahova)', zip: '107499' },
  { city: 'Mălăieşti (Prahova)', zip: '107501' },
  { city: 'Moara Domnească (Prahova)', zip: '107502' },
  { city: 'Palanca (Prahova)', zip: '107503' },
  { city: 'Sicrita (Prahova)', zip: '107504' },
  { city: 'Salcia (Prahova)', zip: '107505' },
  { city: 'Sălciile (Prahova)', zip: '107510' },
  { city: 'Sângeru (Prahova)', zip: '107515' },
  { city: 'Butuci (Prahova)', zip: '107516' },
  { city: 'Mireşu Mare (Prahova)', zip: '107517' },
  { city: 'Mireşu Mic (Prahova)', zip: '107518' },
  { city: 'Piatra Mică (Prahova)', zip: '107519' },
  { city: 'Tisa (Prahova)', zip: '107521' },
  { city: 'Scorţeni (Prahova)', zip: '107525' },
  { city: 'Bordenii Mari (Prahova)', zip: '107526' },
  { city: 'Bordenii Mici (Prahova)', zip: '107527' },
  { city: 'Mislea (Prahova)', zip: '107528' },
  { city: 'Sârca (Prahova)', zip: '107529' },
  { city: 'Secăria (Prahova)', zip: '107530' },
  { city: 'Starchiojd (Prahova)', zip: '107535' },
  { city: 'Bătrâni (Prahova)', zip: '107536' },
  { city: 'Brădet (Prahova)', zip: '107537' },
  { city: 'Gresia (Prahova)', zip: '107538' },
  { city: 'Poiana Mare (Prahova)', zip: '107539' },
  { city: 'Rotarea (Prahova)', zip: '107541' },
  { city: 'Valea Anei (Prahova)', zip: '107542' },
  { city: 'Zmeuret (Prahova)', zip: '107543' },
  { city: 'Surani (Prahova)', zip: '107545' },
  { city: 'Păcuri (Prahova)', zip: '107546' },
  { city: 'Şirna (Prahova)', zip: '107550' },
  { city: 'Brăteşti (Prahova)', zip: '107551' },
  { city: 'Coceana (Prahova)', zip: '107552' },
  { city: 'Hăbud (Prahova)', zip: '107553' },
  { city: 'Tăriceni (Prahova)', zip: '107554' },
  { city: 'Varniţa (Prahova)', zip: '107556' },
  { city: 'Şoimari (Prahova)', zip: '107560' },
  { city: 'Lopatniţa (Prahova)', zip: '107561' },
  { city: 'Măgura (Prahova)', zip: '107562' },
  { city: 'Şotrile (Prahova)', zip: '107565' },
  { city: 'Lunca Mare (Prahova)', zip: '107566' },
  { city: 'Plaiu Câmpinei (Prahova)', zip: '107567' },
  { city: 'Plaiu Cornului (Prahova)', zip: '107568' },
  { city: 'Seciuri (Prahova)', zip: '107569' },
  { city: 'Vistieru (Prahova)', zip: '107571' },
  { city: 'Ştefeşti (Prahova)', zip: '107575' },
  { city: 'Scurteşti (Prahova)', zip: '107576' },
  { city: 'Târşoreni (Prahova)', zip: '107577' },
  { city: 'Talea (Prahova)', zip: '107580' },
  { city: 'Plaiu (Talea) (Prahova)', zip: '107581' },
  { city: 'Tătaru (Prahova)', zip: '107585' },
  { city: 'Podgoria (Prahova)', zip: '107586' },
  { city: 'Siliştea (Prahova)', zip: '107587' },
  { city: 'Târgşoru Vechi (Prahova)', zip: '107590' },
  { city: 'Stănceşti (Prahova)', zip: '107591' },
  { city: 'Strejnicu (Prahova)', zip: '107592' },
  { city: 'Zahanaua (Prahova)', zip: '107593' },
  { city: 'Teişani (Prahova)', zip: '107595' },
  { city: 'Bughea de Sus (Prahova)', zip: '107596' },
  { city: 'Olteni (Prahova)', zip: '107597' },
  { city: 'Ştubeiu (Prahova)', zip: '107598' },
  { city: 'Valea Stâlpului (Prahova)', zip: '107599' },
  { city: 'Telega (Prahova)', zip: '107600' },
  { city: 'Boşilceşti (Prahova)', zip: '107601' },
  { city: 'Buştenari (Prahova)', zip: '107602' },
  { city: 'Doftana (Prahova)', zip: '107603' },
  { city: 'Meliceşti (Prahova)', zip: '107604' },
  { city: 'Ţonţeşti (Prahova)', zip: '107606' },
  { city: 'Tinosu (Prahova)', zip: '107610' },
  { city: 'Pisculeşti (Prahova)', zip: '107611' },
  { city: 'Predeşti (Prahova)', zip: '107612' },
  { city: 'Tomşani (Prahova)', zip: '107615' },
  { city: 'Loloiasca (Prahova)', zip: '107616' },
  { city: 'Magula (Prahova)', zip: '107617' },
  { city: 'Sătucu (Prahova)', zip: '107618' },
  { city: 'Valea Călugărească (Prahova)', zip: '107620' },
  { city: 'Arva (Prahova)', zip: '107621' },
  { city: 'Coslegi (Prahova)', zip: '107622' },
  { city: 'Dârvari (Prahova)', zip: '107623' },
  { city: 'Pantazi (Prahova)', zip: '107624' },
  { city: 'Rachieri (Prahova)', zip: '107626' },
  { city: 'Radila (Prahova)', zip: '107627' },
  { city: 'Schiau (Valea Călugărească) (Prahova)', zip: '107628' },
  { city: 'Valea Largă (Prahova)', zip: '107629' },
  { city: 'Valea Mantei (Prahova)', zip: '107631' },
  { city: 'Valea Nicovani (Prahova)', zip: '107632' },
  { city: 'Valea Poienii (Prahova)', zip: '107633' },
  { city: 'Valea Popii (Prahova)', zip: '107634' },
  { city: 'Valea Ursoii (Prahova)', zip: '107636' },
  { city: 'Vârfurile (Prahova)', zip: '107637' },
  { city: 'Valea Doftanei (Prahova)', zip: '107640' },
  { city: 'Trăisteni (Prahova)', zip: '107641' },
  { city: 'Teşila (Prahova)', zip: '107645' },
  { city: 'Vărbilău (Prahova)', zip: '107650' },
  { city: 'Coţofeneşti (Prahova)', zip: '107651' },
  { city: 'Livadea (Prahova)', zip: '107652' },
  { city: 'Podu Ursului (Prahova)', zip: '107653' },
  { city: 'Poiana Vărbilău (Prahova)', zip: '107654' },
  { city: 'Vâlcăneşti (Prahova)', zip: '107655' },
  { city: 'Cârjari (Prahova)', zip: '107656' },
  { city: 'Trestioara (Prahova)', zip: '107657' },
  { city: 'Ortelec (Sălaj)', zip: '450001' },
  { city: 'Stâna (Sălaj)', zip: '450002' },
  { city: 'Zalău (Sălaj)', zip: '450006' },
  { city: 'Cehu Silvaniei (Sălaj)', zip: '455100' },
  { city: 'Horoatu Cehului (Sălaj)', zip: '455101' },
  { city: 'Motiş (Sălaj)', zip: '455102' },
  { city: 'Nadiş (Sălaj)', zip: '455103' },
  { city: 'Ulciug (Sălaj)', zip: '455104' },
  { city: 'Jibou (Sălaj)', zip: '455200' },
  { city: 'Cuceu (Sălaj)', zip: '455201' },
  { city: 'Husia (Sălaj)', zip: '455202' },
  { city: 'Rona (Sălaj)', zip: '455203' },
  { city: 'Var (Sălaj)', zip: '455204' },
  { city: 'Şimleu Silvaniei (Sălaj)', zip: '455300' },
  { city: 'Bic (Sălaj)', zip: '455301' },
  { city: 'Cehei (Sălaj)', zip: '455302' },
  { city: 'Pusta (Sălaj)', zip: '455303' },
  { city: 'Agrij (Sălaj)', zip: '457005' },
  { city: 'Răstolţu Deşert (Sălaj)', zip: '457006' },
  { city: 'Almaşu (Sălaj)', zip: '457010' },
  { city: 'Băbiu (Sălaj)', zip: '457011' },
  { city: 'Cutiş (Sălaj)', zip: '457012' },
  { city: 'Jebucu (Sălaj)', zip: '457013' },
  { city: 'Mesteacănu (Sălaj)', zip: '457014' },
  { city: 'Petrinzel (Sălaj)', zip: '457016' },
  { city: 'Sfăraş (Sălaj)', zip: '457017' },
  { city: 'Stana (Sălaj)', zip: '457018' },
  { city: 'Ţăudu (Sălaj)', zip: '457019' },
  { city: 'Băbeni (Sălaj)', zip: '457020' },
  { city: 'Ciocmani (Sălaj)', zip: '457021' },
  { city: 'Cliţ (Sălaj)', zip: '457022' },
  { city: 'Piroşa (Sălaj)', zip: '457023' },
  { city: 'Poieniţa (Sălaj)', zip: '457024' },
  { city: 'Bălan (Sălaj)', zip: '457025' },
  { city: 'Chechiş (Sălaj)', zip: '457026' },
  { city: 'Chendrea (Sălaj)', zip: '457027' },
  { city: 'Gălpâia (Sălaj)', zip: '457028' },
  { city: 'Gâlgău Almaşului (Sălaj)', zip: '457029' },
  { city: 'Bănişor (Sălaj)', zip: '457030' },
  { city: 'Ban (Sălaj)', zip: '457031' },
  { city: 'Peceiu (Sălaj)', zip: '457032' },
  { city: 'Benesat (Sălaj)', zip: '457035' },
  { city: 'Aluniş (Sălaj)', zip: '457036' },
  { city: 'Biuşa (Sălaj)', zip: '457037' },
  { city: 'Bobota (Sălaj)', zip: '457040' },
  { city: 'Derşida (Sălaj)', zip: '457041' },
  { city: 'Zalnoc (Sălaj)', zip: '457042' },
  { city: 'Bocşa (Sălaj)', zip: '457045' },
  { city: 'Borla (Sălaj)', zip: '457046' },
  { city: 'Câmpia (Sălaj)', zip: '457047' },
  { city: 'Sălăjeni (Sălaj)', zip: '457048' },
  { city: 'Buciumi (Sălaj)', zip: '457050' },
  { city: 'Bodia (Sălaj)', zip: '457051' },
  { city: 'Bogdana (Sălaj)', zip: '457052' },
  { city: 'Huta (Sălaj)', zip: '457053' },
  { city: 'Răstolţ (Sălaj)', zip: '457054' },
  { city: 'Sângeorgiu de Meseş (Sălaj)', zip: '457056' },
  { city: 'Camăr (Sălaj)', zip: '457060' },
  { city: 'Pădureni (Sălaj)', zip: '457061' },
  { city: 'Carastelec (Sălaj)', zip: '457065' },
  { city: 'Dumuslău (Sălaj)', zip: '457066' },
  { city: 'Chieşd (Sălaj)', zip: '457070' },
  { city: 'Colonia Sighetu Silvaniei (Sălaj)', zip: '457071' },
  { city: 'Sighetu Silvaniei (Sălaj)', zip: '457072' },
  { city: 'Cizer (Sălaj)', zip: '457075' },
  { city: 'Plesca (Sălaj)', zip: '457076' },
  { city: 'Pria (Sălaj)', zip: '457077' },
  { city: 'Coşeiu (Sălaj)', zip: '457080' },
  { city: 'Archid (Sălaj)', zip: '457081' },
  { city: 'Chilioara (Sălaj)', zip: '457082' },
  { city: 'Crasna (Sălaj)', zip: '457085' },
  { city: 'Huseni (Sălaj)', zip: '457086' },
  { city: 'Marin (Sălaj)', zip: '457087' },
  { city: 'Ratin (Sălaj)', zip: '457088' },
  { city: 'Creaca (Sălaj)', zip: '457090' },
  { city: 'Borza (Sălaj)', zip: '457091' },
  { city: 'Brebi (Sălaj)', zip: '457092' },
  { city: 'Brusturi (Sălaj)', zip: '457093' },
  { city: 'Ciglean (Sălaj)', zip: '457094' },
  { city: 'Jac (Sălaj)', zip: '457096' },
  { city: 'Lupoaia (Sălaj)', zip: '457097' },
  { city: 'Prodăneşti (Sălaj)', zip: '457098' },
  { city: 'Viile Jacului (Sălaj)', zip: '457099' },
  { city: 'Cristolţ (Sălaj)', zip: '457100' },
  { city: 'Muncel (Sălaj)', zip: '457101' },
  { city: 'Poiana Onţii (Sălaj)', zip: '457102' },
  { city: 'Văleni (Sălaj)', zip: '457103' },
  { city: 'Crişeni (Sălaj)', zip: '457105' },
  { city: 'Cristur-Crişeni (Sălaj)', zip: '457106' },
  { city: 'Gârceiu (Sălaj)', zip: '457107' },
  { city: 'Cuzăplac (Sălaj)', zip: '457110' },
  { city: 'Cubleşu (Sălaj)', zip: '457111' },
  { city: 'Gălăşeni (Sălaj)', zip: '457112' },
  { city: 'Mierţa (Sălaj)', zip: '457113' },
  { city: 'Petrindu (Sălaj)', zip: '457114' },
  { city: 'Ruginoasa (Sălaj)', zip: '457116' },
  { city: 'Stoboru (Sălaj)', zip: '457117' },
  { city: 'Tămaşa (Sălaj)', zip: '457118' },
  { city: 'Dobrin (Sălaj)', zip: '457120' },
  { city: 'Deleni (Sălaj)', zip: '457121' },
  { city: 'Doba (Sălaj)', zip: '457122' },
  { city: 'Naimon (Sălaj)', zip: '457123' },
  { city: 'Sâncraiu Silvaniei (Sălaj)', zip: '457124' },
  { city: 'Verveghiu (Sălaj)', zip: '457126' },
  { city: 'Dragu (Sălaj)', zip: '457130' },
  { city: 'Adalin (Sălaj)', zip: '457131' },
  { city: 'Fântânele (Sălaj)', zip: '457132' },
  { city: 'Ugruţiu (Sălaj)', zip: '457133' },
  { city: 'Voivodeni (Sălaj)', zip: '457134' },
  { city: 'Fildu de Jos (Sălaj)', zip: '457135' },
  { city: 'Fildu de Mijloc (Sălaj)', zip: '457136' },
  { city: 'Fildu de Sus (Sălaj)', zip: '457137' },
  { city: 'Tetişu (Sălaj)', zip: '457138' },
  { city: 'Gâlgău (Sălaj)', zip: '457140' },
  { city: 'Bârsău Mare (Sălaj)', zip: '457141' },
  { city: 'Căpâlna (Sălaj)', zip: '457142' },
  { city: 'Chizeni (Sălaj)', zip: '457143' },
  { city: 'Dobrocina (Sălaj)', zip: '457144' },
  { city: 'Fodora (Sălaj)', zip: '457146' },
  { city: 'Frâncenii de Piatră (Sălaj)', zip: '457147' },
  { city: 'Glod (Sălaj)', zip: '457148' },
  { city: 'Gura Vlădesei (Sălaj)', zip: '457149' },
  { city: 'Gârbou (Sălaj)', zip: '457150' },
  { city: 'Bezded (Sălaj)', zip: '457151' },
  { city: 'Călacea (Sălaj)', zip: '457152' },
  { city: 'Cernuc (Sălaj)', zip: '457153' },
  { city: 'Fabrica (Sălaj)', zip: '457154' },
  { city: 'Popteleac (Sălaj)', zip: '457156' },
  { city: 'Solomon (Sălaj)', zip: '457157' },
  { city: 'Halmăşd (Sălaj)', zip: '457160' },
  { city: 'Aleuş (Sălaj)', zip: '457161' },
  { city: 'Cerişa (Sălaj)', zip: '457162' },
  { city: 'Drighiu (Sălaj)', zip: '457163' },
  { city: 'Fufez (Sălaj)', zip: '457164' },
  { city: 'Hereclean (Sălaj)', zip: '457165' },
  { city: 'Badon (Sălaj)', zip: '457166' },
  { city: 'Bocşiţa (Sălaj)', zip: '457167' },
  { city: 'Dioşod (Sălaj)', zip: '457168' },
  { city: 'Guruslău (Sălaj)', zip: '457169' },
  { city: 'Panic (Sălaj)', zip: '457171' },
  { city: 'Hida (Sălaj)', zip: '457175' },
  { city: 'Baica (Sălaj)', zip: '457176' },
  { city: 'Miluani (Sălaj)', zip: '457177' },
  { city: 'Păduriş (Sălaj)', zip: '457178' },
  { city: 'Racâş (Sălaj)', zip: '457179' },
  { city: 'Sânpetru Almaşului (Sălaj)', zip: '457181' },
  { city: 'Stupini (Sălaj)', zip: '457182' },
  { city: 'Trestia (Sălaj)', zip: '457183' },
  { city: 'Horoatu Crasnei (Sălaj)', zip: '457185' },
  { city: 'Hurez (Sălaj)', zip: '457186' },
  { city: 'Stârciu (Sălaj)', zip: '457187' },
  { city: 'Şeredeiu (Sălaj)', zip: '457188' },
  { city: 'Ileanda (Sălaj)', zip: '457190' },
  { city: 'Bârsăuţa (Sălaj)', zip: '457191' },
  { city: 'Bizuşa-Băi (Sălaj)', zip: '457192' },
  { city: 'Dăbiceni (Sălaj)', zip: '457193' },
  { city: 'Dolheni (Sălaj)', zip: '457194' },
  { city: 'Luminişu (Sălaj)', zip: '457196' },
  { city: 'Măleni (Sălaj)', zip: '457197' },
  { city: 'Negreni (Sălaj)', zip: '457198' },
  { city: 'Perii Vadului (Sălaj)', zip: '457199' },
  { city: 'Podişu (Sălaj)', zip: '457201' },
  { city: 'Răstoci (Sălaj)', zip: '457202' },
  { city: 'Rogna (Sălaj)', zip: '457203' },
  { city: 'Şasa (Sălaj)', zip: '457204' },
  { city: 'Ip (Sălaj)', zip: '457210' },
  { city: 'Cosniciu de Jos (Sălaj)', zip: '457211' },
  { city: 'Cosniciu de Sus (Sălaj)', zip: '457212' },
  { city: 'Zăuan (Sălaj)', zip: '457213' },
  { city: 'Zăuan-Băi (Sălaj)', zip: '457214' },
  { city: 'Letca (Sălaj)', zip: '457215' },
  { city: 'Ciula (Sălaj)', zip: '457216' },
  { city: 'Cozla (Sălaj)', zip: '457217' },
  { city: 'Cuciulat (Sălaj)', zip: '457218' },
  { city: 'Lemniu (Sălaj)', zip: '457219' },
  { city: 'Purcăreţ (Sălaj)', zip: '457221' },
  { city: 'Şoimuşeni (Sălaj)', zip: '457222' },
  { city: 'Topliţa (Sălaj)', zip: '457223' },
  { city: 'Vălişoara (Sălaj)', zip: '457224' },
  { city: 'Lozna (Sălaj)', zip: '457225' },
  { city: 'Cormeniş (Sălaj)', zip: '457226' },
  { city: 'Preluci (Sălaj)', zip: '457227' },
  { city: 'Valea Leşului (Sălaj)', zip: '457228' },
  { city: 'Valea Loznei (Sălaj)', zip: '457229' },
  { city: 'Marca (Sălaj)', zip: '457230' },
  { city: 'Leşmir (Sălaj)', zip: '457231' },
  { city: 'Marca-Huta (Sălaj)', zip: '457232' },
  { city: 'Porţ (Sălaj)', zip: '457233' },
  { city: 'Şumal (Sălaj)', zip: '457234' },
  { city: 'Măerişte (Sălaj)', zip: '457235' },
  { city: 'Criştelec (Sălaj)', zip: '457236' },
  { city: 'Doh (Sălaj)', zip: '457237' },
  { city: 'Giurtelecu Şimleului (Sălaj)', zip: '457238' },
  { city: 'Mălădia (Sălaj)', zip: '457239' },
  { city: 'Uileacu Şimleului (Sălaj)', zip: '457241' },
  { city: 'Meseşenii de Jos (Sălaj)', zip: '457245' },
  { city: 'Aghireş (Sălaj)', zip: '457246' },
  { city: 'Fetindia (Sălaj)', zip: '457247' },
  { city: 'Meseşenii de Sus (Sălaj)', zip: '457248' },
  { city: 'Mirşid (Sălaj)', zip: '457250' },
  { city: 'Firminiş (Sălaj)', zip: '457251' },
  { city: 'Moigrad-Porolissum (Sălaj)', zip: '457252' },
  { city: 'Popeni (Sălaj)', zip: '457253' },
  { city: 'Năpradea (Sălaj)', zip: '457255' },
  { city: 'Cheud (Sălaj)', zip: '457256' },
  { city: 'Someş-Guruslău (Sălaj)', zip: '457257' },
  { city: 'Traniş (Sălaj)', zip: '457258' },
  { city: 'Vădurele (Sălaj)', zip: '457259' },
  { city: 'Nuşfalău (Sălaj)', zip: '457260' },
  { city: 'Bilghez (Sălaj)', zip: '457261' },
  { city: 'Boghiş (Sălaj)', zip: '457262' },
  { city: 'Bozieş (Sălaj)', zip: '457263' },
  { city: 'Pericei (Sălaj)', zip: '457265' },
  { city: 'Bădăcin (Sălaj)', zip: '457266' },
  { city: 'Periceiu Mic (Sălaj)', zip: '457267' },
  { city: 'Sici (Sălaj)', zip: '457268' },
  { city: 'Plopiş (Sălaj)', zip: '457270' },
  { city: 'Făgetu (Sălaj)', zip: '457271' },
  { city: 'Iaz (Sălaj)', zip: '457272' },
  { city: 'Poiana Blenchii (Sălaj)', zip: '457275' },
  { city: 'Fălcuşa (Sălaj)', zip: '457276' },
  { city: 'Gostila (Sălaj)', zip: '457277' },
  { city: 'Măgura (Sălaj)', zip: '457278' },
  { city: 'Românaşi (Sălaj)', zip: '457280' },
  { city: 'Chichişa (Sălaj)', zip: '457281' },
  { city: 'Ciumărna (Sălaj)', zip: '457282' },
  { city: 'Păuşa (Sălaj)', zip: '457283' },
  { city: 'Poarta Sălajului (Sălaj)', zip: '457284' },
  { city: 'Romita (Sălaj)', zip: '457286' },
  { city: 'Rus (Sălaj)', zip: '457290' },
  { city: 'Buzaş (Sălaj)', zip: '457291' },
  { city: 'Fântânele-Rus (Sălaj)', zip: '457292' },
  { city: 'Hăşmaş (Sălaj)', zip: '457293' },
  { city: 'Şimişna (Sălaj)', zip: '457294' },
  { city: 'Sălăţig (Sălaj)', zip: '457295' },
  { city: 'Bulgari (Sălaj)', zip: '457296' },
  { city: 'Deja (Sălaj)', zip: '457297' },
  { city: 'Mineu (Sălaj)', zip: '457298' },
  { city: 'Noţig (Sălaj)', zip: '457299' },
  { city: 'Sâg (Sălaj)', zip: '457300' },
  { city: 'Fizeş (Sălaj)', zip: '457301' },
  { city: 'Mal (Sălaj)', zip: '457302' },
  { city: 'Sârbi (Sălaj)', zip: '457303' },
  { city: 'Tusa (Sălaj)', zip: '457304' },
  { city: 'Sânmihaiu Almaşului (Sălaj)', zip: '457305' },
  { city: 'Bercea (Sălaj)', zip: '457306' },
  { city: 'Sântă Măria (Sălaj)', zip: '457307' },
  { city: 'Someş-Odorhei (Sălaj)', zip: '457310' },
  { city: 'Bârsa (Sălaj)', zip: '457311' },
  { city: 'Domnin (Sălaj)', zip: '457312' },
  { city: 'Inău (Sălaj)', zip: '457313' },
  { city: 'Şoimuş (Sălaj)', zip: '457314' },
  { city: 'Surduc (Sălaj)', zip: '457315' },
  { city: 'Brâglez (Sălaj)', zip: '457316' },
  { city: 'Cristolţel (Sălaj)', zip: '457317' },
  { city: 'Solona (Sălaj)', zip: '457318' },
  { city: 'Teştioara (Sălaj)', zip: '457319' },
  { city: 'Tihău (Sălaj)', zip: '457321' },
  { city: 'Turbuţa (Sălaj)', zip: '457322' },
  { city: 'Şamşud (Sălaj)', zip: '457325' },
  { city: 'Valea Pomilor (Sălaj)', zip: '457326' },
  { city: 'Şărmăşag (Sălaj)', zip: '457330' },
  { city: 'Ilişua (Sălaj)', zip: '457331' },
  { city: 'Lompirt (Sălaj)', zip: '457332' },
  { city: 'Moiad (Sălaj)', zip: '457333' },
  { city: 'Poiana Măgura (Sălaj)', zip: '457334' },
  { city: 'Ţărmure (Sălaj)', zip: '457336' },
  { city: 'Treznea (Sălaj)', zip: '457340' },
  { city: 'Bozna (Sălaj)', zip: '457341' },
  { city: 'Valcău de Jos (Sălaj)', zip: '457345' },
  { city: 'Lazuri (Sălaj)', zip: '457346' },
  { city: 'Preoteasa (Sălaj)', zip: '457347' },
  { city: 'Ratovei (Sălaj)', zip: '457348' },
  { city: 'Sub Cetate (Sălaj)', zip: '457349' },
  { city: 'Valcău de Sus (Sălaj)', zip: '457351' },
  { city: 'Vârşolţ (Sălaj)', zip: '457355' },
  { city: 'Recea (Sălaj)', zip: '457356' },
  { city: 'Recea Mică (Sălaj)', zip: '457357' },
  { city: 'Zalha (Sălaj)', zip: '457360' },
  { city: 'Ceaca (Sălaj)', zip: '457361' },
  { city: 'Ciureni (Sălaj)', zip: '457362' },
  { city: 'Valea Ciurenilor (Sălaj)', zip: '457363' },
  { city: 'Valea Hranei (Sălaj)', zip: '457364' },
  { city: 'Valea Lungă (Sălaj)', zip: '457366' },
  { city: 'Vârteşca (Sălaj)', zip: '457367' },
  { city: 'Zimbor (Sălaj)', zip: '457370' },
  { city: 'Chendremal (Sălaj)', zip: '457371' },
  { city: 'Dolu (Sălaj)', zip: '457372' },
  { city: 'Sâncraiu Almaşului (Sălaj)', zip: '457373' },
  { city: 'Sutoru (Sălaj)', zip: '457374' },
  { city: 'Sătmărel (Satu Mare)', zip: '440001' },
  { city: 'Satu Mare (Satu Mare)', zip: '440004' },
  { city: 'Carei (Satu Mare)', zip: '445100' },
  { city: 'Ianculeşti (Satu Mare)', zip: '445101' },
  { city: 'Negreşti-Oaş (Satu Mare)', zip: '445200' },
  { city: 'Luna (Satu Mare)', zip: '445201' },
  { city: 'Tur (Satu Mare)', zip: '445202' },
  { city: 'Tăşnad (Satu Mare)', zip: '445300' },
  { city: 'Blaja (Satu Mare)', zip: '445301' },
  { city: 'Cig (Satu Mare)', zip: '445302' },
  { city: 'Raţiu (Satu Mare)', zip: '445303' },
  { city: 'Sărăuad (Satu Mare)', zip: '445304' },
  { city: 'Valea Morii (Satu Mare)', zip: '445305' },
  { city: 'Acâş (Satu Mare)', zip: '447005' },
  { city: 'Ganaş (Satu Mare)', zip: '447006' },
  { city: 'Mihăieni (Satu Mare)', zip: '447007' },
  { city: 'Unimăt (Satu Mare)', zip: '447008' },
  { city: 'Andrid (Satu Mare)', zip: '447010' },
  { city: 'Dindeşti (Satu Mare)', zip: '447011' },
  { city: 'Irina (Satu Mare)', zip: '447012' },
  { city: 'Apa (Satu Mare)', zip: '447015' },
  { city: 'Lunca Apei (Satu Mare)', zip: '447016' },
  { city: 'Someşeni (Satu Mare)', zip: '447017' },
  { city: 'Ardud (Satu Mare)', zip: '447020' },
  { city: 'Ardud-Vii (Satu Mare)', zip: '447021' },
  { city: 'Baba Novac (Satu Mare)', zip: '447022' },
  { city: 'Gerăuşa (Satu Mare)', zip: '447023' },
  { city: 'Mădăras (Satu Mare)', zip: '447024' },
  { city: 'Sărătura (Satu Mare)', zip: '447026' },
  { city: 'Bătarci (Satu Mare)', zip: '447030' },
  { city: 'Comlăuşa (Satu Mare)', zip: '447031' },
  { city: 'Şirlău (Satu Mare)', zip: '447032' },
  { city: 'Tămăşeni (Satu Mare)', zip: '447033' },
  { city: 'Bârsău (Satu Mare)', zip: '447035' },
  { city: 'Bârsău de Jos (Satu Mare)', zip: '447036' },
  { city: 'Bârsău de Sus (Satu Mare)', zip: '447037' },
  { city: 'Beltiug (Satu Mare)', zip: '447040' },
  { city: 'Bolda (Satu Mare)', zip: '447041' },
  { city: 'Ghirişa (Satu Mare)', zip: '447042' },
  { city: 'Giungi (Satu Mare)', zip: '447043' },
  { city: 'Răteşti (Satu Mare)', zip: '447044' },
  { city: 'Şandra (Satu Mare)', zip: '447046' },
  { city: 'Berveni (Satu Mare)', zip: '447050' },
  { city: 'Lucăceni (Satu Mare)', zip: '447051' },
  { city: 'Bixad (Satu Mare)', zip: '447055' },
  { city: 'Boineşti (Satu Mare)', zip: '447056' },
  { city: 'Trip (Satu Mare)', zip: '447057' },
  { city: 'Bogdand (Satu Mare)', zip: '447060' },
  { city: 'Babţa (Satu Mare)', zip: '447061' },
  { city: 'Corund (Satu Mare)', zip: '447062' },
  { city: 'Ser (Satu Mare)', zip: '447063' },
  { city: 'Botiz (Satu Mare)', zip: '447065' },
  { city: 'Agriş (Satu Mare)', zip: '447066' },
  { city: 'Ciuperceni (Satu Mare)', zip: '447067' },
  { city: 'Călineşti-Oaş (Satu Mare)', zip: '447070' },
  { city: 'Coca (Satu Mare)', zip: '447071' },
  { city: 'Lechinţa (Satu Mare)', zip: '447072' },
  { city: 'Păşunea Mare (Satu Mare)', zip: '447073' },
  { city: 'Cămărzana (Satu Mare)', zip: '447075' },
  { city: 'Căpleni (Satu Mare)', zip: '447080' },
  { city: 'Cămin (Satu Mare)', zip: '447081' },
  { city: 'Căuaş (Satu Mare)', zip: '447085' },
  { city: 'Ady Endre (Satu Mare)', zip: '447086' },
  { city: 'Ghenci (Satu Mare)', zip: '447087' },
  { city: 'Ghileşti (Satu Mare)', zip: '447088' },
  { city: 'Hotoan (Satu Mare)', zip: '447089' },
  { city: 'Răduleşti (Satu Mare)', zip: '447091' },
  { city: 'Cehal (Satu Mare)', zip: '447095' },
  { city: 'Cehăluţ (Satu Mare)', zip: '447096' },
  { city: 'Orbău (Satu Mare)', zip: '447097' },
  { city: 'Certeze (Satu Mare)', zip: '447100' },
  { city: 'Huta-Certeze (Satu Mare)', zip: '447101' },
  { city: 'Moişeni (Satu Mare)', zip: '447102' },
  { city: 'Craidorolţ (Satu Mare)', zip: '447105' },
  { city: 'Crişeni (Satu Mare)', zip: '447106' },
  { city: 'Eriu-Sâncrai (Satu Mare)', zip: '447107' },
  { city: 'Satu Mic (Satu Mare)', zip: '447108' },
  { city: 'Ţeghea (Satu Mare)', zip: '447109' },
  { city: 'Crucişor (Satu Mare)', zip: '447110' },
  { city: 'Iegherişte (Satu Mare)', zip: '447111' },
  { city: 'Poiana Codrului (Satu Mare)', zip: '447112' },
  { city: 'Culciu (Satu Mare)', zip: '447115' },
  { city: 'Apateu (Satu Mare)', zip: '447116' },
  { city: 'Cărăşeu (Satu Mare)', zip: '447117' },
  { city: 'Corod (Satu Mare)', zip: '447118' },
  { city: 'Culciu Mare (Satu Mare)', zip: '447119' },
  { city: 'Culciu Mic (Satu Mare)', zip: '447121' },
  { city: 'Lipău (Satu Mare)', zip: '447122' },
  { city: 'Doba (Satu Mare)', zip: '447125' },
  { city: 'Boghiş (Satu Mare)', zip: '447126' },
  { city: 'Dacia (Satu Mare)', zip: '447127' },
  { city: 'Paulian (Satu Mare)', zip: '447128' },
  { city: 'Traian (Satu Mare)', zip: '447129' },
  { city: 'Dorolţ (Satu Mare)', zip: '447130' },
  { city: 'Atea (Satu Mare)', zip: '447131' },
  { city: 'Dara (Satu Mare)', zip: '447132' },
  { city: 'Petea (Satu Mare)', zip: '447133' },
  { city: 'Foieni (Satu Mare)', zip: '447135' },
  { city: 'Gherţa Mică (Satu Mare)', zip: '447140' },
  { city: 'Halmeu (Satu Mare)', zip: '447145' },
  { city: 'Băbeşti (Satu Mare)', zip: '447146' },
  { city: 'Cidreag (Satu Mare)', zip: '447147' },
  { city: 'Dobolţ (Satu Mare)', zip: '447148' },
  { city: 'Halmeu-Vii (Satu Mare)', zip: '447149' },
  { city: 'Mesteacăn (Satu Mare)', zip: '447151' },
  { city: 'Porumbeşti (Satu Mare)', zip: '447152' },
  { city: 'Hodod (Satu Mare)', zip: '447155' },
  { city: 'Giurtelecu Hododului (Satu Mare)', zip: '447156' },
  { city: 'Lelei (Satu Mare)', zip: '447157' },
  { city: 'Nadişu Hododului (Satu Mare)', zip: '447158' },
  { city: 'Homoroade (Satu Mare)', zip: '447160' },
  { city: 'Chilia (Satu Mare)', zip: '447161' },
  { city: 'Homorodu de Jos (Satu Mare)', zip: '447162' },
  { city: 'Homorodu de Mijloc (Satu Mare)', zip: '447163' },
  { city: 'Homorodu de Sus (Satu Mare)', zip: '447164' },
  { city: 'Necopoi (Satu Mare)', zip: '447166' },
  { city: 'Solduba (Satu Mare)', zip: '447167' },
  { city: 'Lazuri (Satu Mare)', zip: '447170' },
  { city: 'Bercu (Satu Mare)', zip: '447171' },
  { city: 'Nisipeni (Satu Mare)', zip: '447172' },
  { city: 'Noroieni (Satu Mare)', zip: '447173' },
  { city: 'Peleş (Satu Mare)', zip: '447174' },
  { city: 'Pelişor (Satu Mare)', zip: '447176' },
  { city: 'Livada (Satu Mare)', zip: '447180' },
  { city: 'Adrian (Satu Mare)', zip: '447181' },
  { city: 'Dumbrava (Satu Mare)', zip: '447182' },
  { city: 'Livada Mică (Satu Mare)', zip: '447183' },
  { city: 'Medieşu Aurit (Satu Mare)', zip: '447185' },
  { city: 'Băbăşeşti (Satu Mare)', zip: '447186' },
  { city: 'Iojib (Satu Mare)', zip: '447187' },
  { city: 'Medieş-Râturi (Satu Mare)', zip: '447188' },
  { city: 'Medieş-Vii (Satu Mare)', zip: '447189' },
  { city: 'Potău (Satu Mare)', zip: '447191' },
  { city: 'Româneşti (Satu Mare)', zip: '447192' },
  { city: 'Micula (Satu Mare)', zip: '447195' },
  { city: 'Bercu Nou (Satu Mare)', zip: '447196' },
  { city: 'Micula Nouă (Satu Mare)', zip: '447197' },
  { city: 'Moftin (Satu Mare)', zip: '447200' },
  { city: 'Domăneşti (Satu Mare)', zip: '447201' },
  { city: 'Ghilvaci (Satu Mare)', zip: '447202' },
  { city: 'Ghirolt (Satu Mare)', zip: '447203' },
  { city: 'Istrău (Satu Mare)', zip: '447204' },
  { city: 'Moftinu Mare (Satu Mare)', zip: '447206' },
  { city: 'Moftinu Mic (Satu Mare)', zip: '447207' },
  { city: 'Sânmiclăuş (Satu Mare)', zip: '447208' },
  { city: 'Odoreu (Satu Mare)', zip: '447210' },
  { city: 'Berindan (Satu Mare)', zip: '447211' },
  { city: 'Cucu (Satu Mare)', zip: '447212' },
  { city: 'Eteni (Satu Mare)', zip: '447213' },
  { city: 'Mărtineşti (Satu Mare)', zip: '447214' },
  { city: 'Vânătoreşti (Satu Mare)', zip: '447216' },
  { city: 'Oraşu Nou (Satu Mare)', zip: '447220' },
  { city: 'Oraşu Nou-Vii (Satu Mare)', zip: '447221' },
  { city: 'Prilog (Satu Mare)', zip: '447222' },
  { city: 'Prilog-Vii (Satu Mare)', zip: '447223' },
  { city: 'Racşa (Satu Mare)', zip: '447224' },
  { city: 'Racşa-Vii (Satu Mare)', zip: '447226' },
  { city: 'Remetea Oaşului (Satu Mare)', zip: '447227' },
  { city: 'Păuleşti (Satu Mare)', zip: '447230' },
  { city: 'Amaţi (Satu Mare)', zip: '447231' },
  { city: 'Ambud (Satu Mare)', zip: '447232' },
  { city: 'Hrip (Satu Mare)', zip: '447233' },
  { city: 'Petin (Satu Mare)', zip: '447234' },
  { city: 'Ruşeni (Satu Mare)', zip: '447236' },
  { city: 'Petreşti (Satu Mare)', zip: '447240' },
  { city: 'Dindeştiu Mic (Satu Mare)', zip: '447241' },
  { city: 'Pir (Satu Mare)', zip: '447245' },
  { city: 'Piru Nou (Satu Mare)', zip: '447246' },
  { city: 'Sărvăzel (Satu Mare)', zip: '447247' },
  { city: 'Pişcolt (Satu Mare)', zip: '447250' },
  { city: 'Resighea (Satu Mare)', zip: '447251' },
  { city: 'Scărişoara Nouă (Satu Mare)', zip: '447252' },
  { city: 'Pomi (Satu Mare)', zip: '447255' },
  { city: 'Aciua (Satu Mare)', zip: '447256' },
  { city: 'Bicău (Satu Mare)', zip: '447257' },
  { city: 'Borleşti (Satu Mare)', zip: '447258' },
  { city: 'Sanislău (Satu Mare)', zip: '447260' },
  { city: 'Berea (Satu Mare)', zip: '447261' },
  { city: 'Ciumeşti (Satu Mare)', zip: '447262' },
  { city: 'Horea (Satu Mare)', zip: '447263' },
  { city: 'Marna Nouă (Satu Mare)', zip: '447264' },
  { city: 'Viişoara (Satu Mare)', zip: '447266' },
  { city: 'Santău (Satu Mare)', zip: '447270' },
  { city: 'Chereuşa (Satu Mare)', zip: '447271' },
  { city: 'Sudurău (Satu Mare)', zip: '447272' },
  { city: 'Săcăşeni (Satu Mare)', zip: '447275' },
  { city: 'Chegea (Satu Mare)', zip: '447276' },
  { city: 'Săuca (Satu Mare)', zip: '447280' },
  { city: 'Becheni (Satu Mare)', zip: '447281' },
  { city: 'Cean (Satu Mare)', zip: '447282' },
  { city: 'Chisău (Satu Mare)', zip: '447283' },
  { city: 'Silvaş (Satu Mare)', zip: '447284' },
  { city: 'Socond (Satu Mare)', zip: '447285' },
  { city: 'Cuţa (Satu Mare)', zip: '447286' },
  { city: 'Hodişa (Satu Mare)', zip: '447287' },
  { city: 'Soconzel (Satu Mare)', zip: '447288' },
  { city: 'Stâna (Satu Mare)', zip: '447289' },
  { city: 'Supur (Satu Mare)', zip: '447290' },
  { city: 'Dobra (Satu Mare)', zip: '447291' },
  { city: 'Giorocuta (Satu Mare)', zip: '447292' },
  { city: 'Hurezu Mare (Satu Mare)', zip: '447293' },
  { city: 'Racova (Satu Mare)', zip: '447294' },
  { city: 'Sechereşa (Satu Mare)', zip: '447296' },
  { city: 'Supuru de Sus (Satu Mare)', zip: '447297' },
  { city: 'Supuru de Jos (Satu Mare)', zip: '447300' },
  { city: 'Tarna Mare (Satu Mare)', zip: '447310' },
  { city: 'Bocicău (Satu Mare)', zip: '447311' },
  { city: 'Valea Seacă (Satu Mare)', zip: '447312' },
  { city: 'Văgaş (Satu Mare)', zip: '447313' },
  { city: 'Târşolţ (Satu Mare)', zip: '447315' },
  { city: 'Aliceni (Satu Mare)', zip: '447316' },
  { city: 'Terebeşti (Satu Mare)', zip: '447320' },
  { city: 'Aliza (Satu Mare)', zip: '447321' },
  { city: 'Gelu (Satu Mare)', zip: '447322' },
  { city: 'Pişcari (Satu Mare)', zip: '447323' },
  { city: 'Tiream (Satu Mare)', zip: '447325' },
  { city: 'Portiţa (Satu Mare)', zip: '447326' },
  { city: 'Vezendiu (Satu Mare)', zip: '447327' },
  { city: 'Turţ (Satu Mare)', zip: '447330' },
  { city: 'Gherţa Mare (Satu Mare)', zip: '447331' },
  { city: 'Turţ-Băi (Satu Mare)', zip: '447332' },
  { city: 'Turulung (Satu Mare)', zip: '447335' },
  { city: 'Drăguşeni (Satu Mare)', zip: '447336' },
  { city: 'Turulung-Vii (Satu Mare)', zip: '447337' },
  { city: 'Urziceni (Satu Mare)', zip: '447340' },
  { city: 'Urziceni-Pădure (Satu Mare)', zip: '447341' },
  { city: 'Valea Vinului (Satu Mare)', zip: '447345' },
  { city: 'Măriuş (Satu Mare)', zip: '447346' },
  { city: 'Roşiori (Satu Mare)', zip: '447347' },
  { city: 'Sâi (Satu Mare)', zip: '447348' },
  { city: 'Vama (Satu Mare)', zip: '447350' },
  { city: 'Vetiş (Satu Mare)', zip: '447355' },
  { city: 'Decebal (Satu Mare)', zip: '447356' },
  { city: 'Oar (Satu Mare)', zip: '447357' },
  { city: 'Viile Satu Mare (Satu Mare)', zip: '447360' },
  { city: 'Cioncheşti (Satu Mare)', zip: '447361' },
  { city: 'Medişa (Satu Mare)', zip: '447362' },
  { city: 'Tătăreşti (Satu Mare)', zip: '447363' },
  { city: 'Tireac (Satu Mare)', zip: '447364' },
  { city: 'Păltiniş (Sibiu)', zip: '550001' },
  { city: 'Sibiu (Sibiu)', zip: '550003' },
  { city: 'Ighişu Nou (Sibiu)', zip: '551001' },
  { city: 'Mediaş (Sibiu)', zip: '551002' },
  { city: 'Agnita (Sibiu)', zip: '555100' },
  { city: 'Coveş (Sibiu)', zip: '555101' },
  { city: 'Ruja (Sibiu)', zip: '555102' },
  { city: 'Avrig (Sibiu)', zip: '555200' },
  { city: 'Bradu (Sibiu)', zip: '555201' },
  { city: 'Glâmboaca (Sibiu)', zip: '555202' },
  { city: 'Săcădate (Sibiu)', zip: '555203' },
  { city: 'Mârşa (Sibiu)', zip: '555250' },
  { city: 'Cisnădie (Sibiu)', zip: '555300' },
  { city: 'Cisnădioara (Sibiu)', zip: '555301' },
  { city: 'Copşa Mică (Sibiu)', zip: '555400' },
  { city: 'Dumbrăveni (Sibiu)', zip: '555500' },
  { city: 'Ernea (Sibiu)', zip: '555501' },
  { city: 'Şaroş pe Târnave (Sibiu)', zip: '555502' },
  { city: 'Ocna Sibiului (Sibiu)', zip: '555600' },
  { city: 'Topârcea (Sibiu)', zip: '555601' },
  { city: 'Tălmaciu (Sibiu)', zip: '555700' },
  { city: 'Boiţa (Sibiu)', zip: '555701' },
  { city: 'Colonia Tălmaciu (Sibiu)', zip: '555702' },
  { city: 'Lazaret (Sibiu)', zip: '555703' },
  { city: 'Lotrioara (Sibiu)', zip: '555704' },
  { city: 'Paltin (Sibiu)', zip: '555705' },
  { city: 'Tălmăcel (Sibiu)', zip: '555706' },
  { city: 'Alţina (Sibiu)', zip: '557005' },
  { city: 'Beneşti (Sibiu)', zip: '557006' },
  { city: 'Ghijasa de Sus (Sibiu)', zip: '557007' },
  { city: 'Apoldu de Jos (Sibiu)', zip: '557010' },
  { city: 'Sângătin (Sibiu)', zip: '557011' },
  { city: 'Arpaşu de Jos (Sibiu)', zip: '557015' },
  { city: 'Arpaşu de Sus (Sibiu)', zip: '557016' },
  { city: 'Nou Român (Sibiu)', zip: '557017' },
  { city: 'Aţel (Sibiu)', zip: '557020' },
  { city: 'Alma (Sibiu)', zip: '557021' },
  { city: 'Dupuş (Sibiu)', zip: '557022' },
  { city: 'Giacăş (Sibiu)', zip: '557023' },
  { city: 'Şmig (Sibiu)', zip: '557024' },
  { city: 'Axente Sever (Sibiu)', zip: '557025' },
  { city: 'Agârbiciu (Sibiu)', zip: '557026' },
  { city: 'Şoala (Sibiu)', zip: '557027' },
  { city: 'Bazna (Sibiu)', zip: '557030' },
  { city: 'Boian (Sibiu)', zip: '557031' },
  { city: 'Velţ (Sibiu)', zip: '557032' },
  { city: 'Bârghiş (Sibiu)', zip: '557035' },
  { city: 'Apoş (Sibiu)', zip: '557036' },
  { city: 'Ighişu Vechi (Sibiu)', zip: '557037' },
  { city: 'Pelişor (Sibiu)', zip: '557038' },
  { city: 'Vecerd (Sibiu)', zip: '557039' },
  { city: 'Zlagna (Sibiu)', zip: '557041' },
  { city: 'Biertan (Sibiu)', zip: '557045' },
  { city: 'Copşa Mare (Sibiu)', zip: '557046' },
  { city: 'Richiş (Sibiu)', zip: '557047' },
  { city: 'Blăjel (Sibiu)', zip: '557050' },
  { city: 'Păucea (Sibiu)', zip: '557051' },
  { city: 'Romaneşti (Sibiu)', zip: '557052' },
  { city: 'Brateiu (Sibiu)', zip: '557055' },
  { city: 'Buzd (Sibiu)', zip: '557056' },
  { city: 'Brădeni (Sibiu)', zip: '557060' },
  { city: 'Retiş (Sibiu)', zip: '557061' },
  { city: 'Ţeline (Sibiu)', zip: '557062' },
  { city: 'Bruiu (Sibiu)', zip: '557065' },
  { city: 'Gherdeal (Sibiu)', zip: '557066' },
  { city: 'Şomartin (Sibiu)', zip: '557067' },
  { city: 'Cârţa (Sibiu)', zip: '557070' },
  { city: 'Poieniţa (Sibiu)', zip: '557071' },
  { city: 'Cârţişoara (Sibiu)', zip: '557075' },
  { city: 'Chirpăr (Sibiu)', zip: '557080' },
  { city: 'Săsăuş (Sibiu)', zip: '557081' },
  { city: 'Vărd (Sibiu)', zip: '557082' },
  { city: 'Veseud (Chirpăr) (Sibiu)', zip: '557083' },
  { city: 'Cristian (Sibiu)', zip: '557085' },
  { city: 'Dârlos (Sibiu)', zip: '557090' },
  { city: 'Curciu (Sibiu)', zip: '557091' },
  { city: 'Valea Lungă (Sibiu)', zip: '557092' },
  { city: 'Gura Râului (Sibiu)', zip: '557095' },
  { city: 'Hoghilag (Sibiu)', zip: '557100' },
  { city: 'Prod (Sibiu)', zip: '557101' },
  { city: 'Valchid (Sibiu)', zip: '557102' },
  { city: 'Iacobeni (Sibiu)', zip: '557105' },
  { city: 'Movile (Sibiu)', zip: '557106' },
  { city: 'Netuş (Sibiu)', zip: '557107' },
  { city: 'Noiştat (Sibiu)', zip: '557108' },
  { city: 'Stejărişu (Sibiu)', zip: '557109' },
  { city: 'Jina (Sibiu)', zip: '557110' },
  { city: 'Laslea (Sibiu)', zip: '557115' },
  { city: 'Floreşti (Sibiu)', zip: '557116' },
  { city: 'Mălâncrav (Sibiu)', zip: '557117' },
  { city: 'Nou Săsesc (Sibiu)', zip: '557118' },
  { city: 'Roandola (Sibiu)', zip: '557119' },
  { city: 'Loamneş (Sibiu)', zip: '557120' },
  { city: 'Alămor (Sibiu)', zip: '557121' },
  { city: 'Armeni (Sibiu)', zip: '557122' },
  { city: 'Haşag (Sibiu)', zip: '557123' },
  { city: 'Mândra (Sibiu)', zip: '557124' },
  { city: 'Sădinca (Sibiu)', zip: '557126' },
  { city: 'Ludoş (Sibiu)', zip: '557130' },
  { city: 'Gusu (Sibiu)', zip: '557131' },
  { city: 'Marpod (Sibiu)', zip: '557135' },
  { city: 'Ilimbav (Sibiu)', zip: '557136' },
  { city: 'Merghindeal (Sibiu)', zip: '557140' },
  { city: 'Dealu Frumos (Sibiu)', zip: '557141' },
  { city: 'Micăsasa (Sibiu)', zip: '557145' },
  { city: 'Chesler (Sibiu)', zip: '557146' },
  { city: 'Ţapu (Sibiu)', zip: '557147' },
  { city: 'Văleni (Sibiu)', zip: '557148' },
  { city: 'Miercurea Sibiului (Sibiu)', zip: '557150' },
  { city: 'Apoldu de Sus (Sibiu)', zip: '557151' },
  { city: 'Dobârca (Sibiu)', zip: '557152' },
  { city: 'Mihăileni (Sibiu)', zip: '557155' },
  { city: 'Metiş (Sibiu)', zip: '557156' },
  { city: 'Moardăş (Sibiu)', zip: '557157' },
  { city: 'Răvăşel (Sibiu)', zip: '557158' },
  { city: 'Şalcău (Sibiu)', zip: '557159' },
  { city: 'Moşna (Sibiu)', zip: '557160' },
  { city: 'Alma Vii (Sibiu)', zip: '557161' },
  { city: 'Nemşa (Sibiu)', zip: '557162' },
  { city: 'Nocrich (Sibiu)', zip: '557165' },
  { city: 'Fofeldea (Sibiu)', zip: '557166' },
  { city: 'Ghijasa de Jos (Sibiu)', zip: '557167' },
  { city: 'Hosman (Sibiu)', zip: '557168' },
  { city: 'Ţichindeal (Sibiu)', zip: '557169' },
  { city: 'Orlat (Sibiu)', zip: '557170' },
  { city: 'Păuca (Sibiu)', zip: '557175' },
  { city: 'Bogatu Român (Sibiu)', zip: '557176' },
  { city: 'Broşteni (Sibiu)', zip: '557177' },
  { city: 'Presaca (Sibiu)', zip: '557178' },
  { city: 'Poiana Sibiului (Sibiu)', zip: '557180' },
  { city: 'Poplaca (Sibiu)', zip: '557185' },
  { city: 'Porumbacu de Jos (Sibiu)', zip: '557190' },
  { city: 'Colun (Sibiu)', zip: '557191' },
  { city: 'Porumbacu de Sus (Sibiu)', zip: '557192' },
  { city: 'Sărata (Sibiu)', zip: '557193' },
  { city: 'Scoreiu (Sibiu)', zip: '557194' },
  { city: 'Racoviţa (Sibiu)', zip: '557195' },
  { city: 'Sebeşu de Sus (Sibiu)', zip: '557196' },
  { city: 'Răşinari (Sibiu)', zip: '557200' },
  { city: 'Prislop (Sibiu)', zip: '557201' },
  { city: 'Râu Sadului (Sibiu)', zip: '557205' },
  { city: 'Roşia (Sibiu)', zip: '557210' },
  { city: 'Caşolţ (Sibiu)', zip: '557211' },
  { city: 'Cornăţel (Sibiu)', zip: '557212' },
  { city: 'Daia (Sibiu)', zip: '557213' },
  { city: 'Nou (Sibiu)', zip: '557214' },
  { city: 'Nucet (Sibiu)', zip: '557216' },
  { city: 'Sadu (Sibiu)', zip: '557220' },
  { city: 'Sălişte (Sibiu)', zip: '557225' },
  { city: 'Aciliu (Sibiu)', zip: '557226' },
  { city: 'Amnaş (Sibiu)', zip: '557227' },
  { city: 'Crinţ (Sibiu)', zip: '557228' },
  { city: 'Fântânele (Sibiu)', zip: '557229' },
  { city: 'Galeş (Sibiu)', zip: '557231' },
  { city: 'Mag (Sibiu)', zip: '557232' },
  { city: 'Săcel (Sibiu)', zip: '557233' },
  { city: 'Sibiel (Sibiu)', zip: '557234' },
  { city: 'Vale (Sibiu)', zip: '557236' },
  { city: 'Slimnic (Sibiu)', zip: '557240' },
  { city: 'Albi (Sibiu)', zip: '557241' },
  { city: 'Pădureni (Sibiu)', zip: '557242' },
  { city: 'Ruşi (Sibiu)', zip: '557243' },
  { city: 'Veseud (Slimnic) (Sibiu)', zip: '557244' },
  { city: 'Şeica Mare (Sibiu)', zip: '557245' },
  { city: 'Boarta (Sibiu)', zip: '557246' },
  { city: 'Buia (Sibiu)', zip: '557247' },
  { city: 'Mighindoala (Sibiu)', zip: '557248' },
  { city: 'Petiş (Sibiu)', zip: '557249' },
  { city: 'Ştenea (Sibiu)', zip: '557251' },
  { city: 'Şeica Mică (Sibiu)', zip: '557255' },
  { city: 'Soroştin (Sibiu)', zip: '557256' },
  { city: 'Şelimbăr (Sibiu)', zip: '557260' },
  { city: 'Bungard (Sibiu)', zip: '557261' },
  { city: 'Mohu (Sibiu)', zip: '557262' },
  { city: 'Veştem (Sibiu)', zip: '557263' },
  { city: 'Şura Mare (Sibiu)', zip: '557265' },
  { city: 'Hamba (Sibiu)', zip: '557266' },
  { city: 'Şura Mică (Sibiu)', zip: '557270' },
  { city: 'Rusciori (Sibiu)', zip: '557271' },
  { city: 'Târnava (Sibiu)', zip: '557275' },
  { city: 'Colonia Târnava (Sibiu)', zip: '557276' },
  { city: 'Tilişca (Sibiu)', zip: '557280' },
  { city: 'Rod (Sibiu)', zip: '557281' },
  { city: 'Turnu Roşu (Sibiu)', zip: '557285' },
  { city: 'Sebeşu de Jos (Sibiu)', zip: '557286' },
  { city: 'Valea Viilor (Sibiu)', zip: '557290' },
  { city: 'Motiş (Sibiu)', zip: '557291' },
  { city: 'Vurpăr (Sibiu)', zip: '557295' },
  { city: 'Suceava (Suceava)', zip: '720001' },
  { city: 'Câmpulung Moldovenesc (Suceava)', zip: '725100' },
  { city: 'Fălticeni (Suceava)', zip: '725200' },
  { city: 'Şoldăneşti (Suceava)', zip: '725201' },
  { city: 'Ţarna Mare (Suceava)', zip: '725202' },
  { city: 'Gura Humorului (Suceava)', zip: '725300' },
  { city: 'Voroneţ (Suceava)', zip: '725301' },
  { city: 'Rădăuţi (Suceava)', zip: '725400' },
  { city: 'Siret (Suceava)', zip: '725500' },
  { city: 'Mănăstioara (Siret) (Suceava)', zip: '725501' },
  { city: 'Pădureni (Suceava)', zip: '725502' },
  { city: 'Solca (Suceava)', zip: '725600' },
  { city: 'Poieni-Solca (Suceava)', zip: '725601' },
  { city: 'Vatra Dornei (Suceava)', zip: '725700' },
  { city: 'Argestru (Suceava)', zip: '725701' },
  { city: 'Roşu (Suceava)', zip: '725702' },
  { city: 'Todireni (Suceava)', zip: '725703' },
  { city: 'Adâncata (Suceava)', zip: '727005' },
  { city: 'Arţari (Suceava)', zip: '727006' },
  { city: 'Bereşti (Suceava)', zip: '727007' },
  { city: 'Călugăreni (Suceava)', zip: '727008' },
  { city: 'Feteşti (Suceava)', zip: '727009' },
  { city: 'Hănţeşti (Suceava)', zip: '727011' },
  { city: 'Arbore (Suceava)', zip: '727015' },
  { city: 'Bodnăreni (Suceava)', zip: '727016' },
  { city: 'Clit (Suceava)', zip: '727017' },
  { city: 'Baia (Suceava)', zip: '727020' },
  { city: 'Bogata (Suceava)', zip: '727021' },
  { city: 'Bălcăuţi (Suceava)', zip: '727025' },
  { city: 'Gropeni (Suceava)', zip: '727026' },
  { city: 'Negostina (Suceava)', zip: '727027' },
  { city: 'Bilca (Suceava)', zip: '727030' },
  { city: 'Bogdăneşti (Suceava)', zip: '727035' },
  { city: 'Boroaia (Suceava)', zip: '727040' },
  { city: 'Bărăşti (Suceava)', zip: '727041' },
  { city: 'Giuleşti (Suceava)', zip: '727042' },
  { city: 'Moişa (Suceava)', zip: '727043' },
  { city: 'Săcuţa (Suceava)', zip: '727044' },
  { city: 'Bosanci (Suceava)', zip: '727045' },
  { city: 'Cumpărătura (Suceava)', zip: '727046' },
  { city: 'Botoşana (Suceava)', zip: '727050' },
  { city: 'Breaza (Suceava)', zip: '727055' },
  { city: 'Breaza de Sus (Suceava)', zip: '727056' },
  { city: 'Pârâu Negrei (Suceava)', zip: '727057' },
  { city: 'Brodina (Suceava)', zip: '727060' },
  { city: 'Brodina de Jos (Suceava)', zip: '727061' },
  { city: 'Cununschi (Suceava)', zip: '727062' },
  { city: 'Dubiusca (Suceava)', zip: '727063' },
  { city: 'Ehreşte (Suceava)', zip: '727064' },
  { city: 'Falcău (Suceava)', zip: '727066' },
  { city: 'Norocu (Suceava)', zip: '727067' },
  { city: 'Paltin (Suceava)', zip: '727068' },
  { city: 'Sadău (Suceava)', zip: '727069' },
  { city: 'Zalomestra (Suceava)', zip: '727071' },
  { city: 'Broşteni (Suceava)', zip: '727075' },
  { city: 'Cotârgaşi (Suceava)', zip: '727076' },
  { city: 'Dârmoxa (Suceava)', zip: '727077' },
  { city: 'Frasin (Broşteni) (Suceava)', zip: '727078' },
  { city: 'Hăleasa (Suceava)', zip: '727079' },
  { city: 'Holda (Suceava)', zip: '727081' },
  { city: 'Holdiţa (Suceava)', zip: '727082' },
  { city: 'Lungeni (Suceava)', zip: '727083' },
  { city: 'Neagra (Suceava)', zip: '727084' },
  { city: 'Pietroasa (Suceava)', zip: '727086' },
  { city: 'Buneşti (Suceava)', zip: '727090' },
  { city: 'Petia (Suceava)', zip: '727091' },
  { city: 'Podeni (Suceava)', zip: '727092' },
  { city: 'Şes (Suceava)', zip: '727093' },
  { city: 'Unceşti (Suceava)', zip: '727094' },
  { city: 'Cacica (Suceava)', zip: '727095' },
  { city: 'Maidan (Suceava)', zip: '727096' },
  { city: 'Pârteştii de Sus (Suceava)', zip: '727097' },
  { city: 'Runcu (Suceava)', zip: '727098' },
  { city: 'Soloneţu Nou (Suceava)', zip: '727099' },
  { city: 'Cajvana (Suceava)', zip: '727100' },
  { city: 'Codru (Suceava)', zip: '727101' },
  { city: 'Calafindeşti (Suceava)', zip: '727105' },
  { city: 'Botoşaniţa Mare (Suceava)', zip: '727106' },
  { city: 'Călineşti (Şerbăuţi) (Suceava)', zip: '727107' },
  { city: 'Şerbăuţi (Suceava)', zip: '727108' },
  { city: 'Cârlibaba (Suceava)', zip: '727110' },
  { city: 'Cârlibaba Nouă (Suceava)', zip: '727111' },
  { city: 'Iedu (Suceava)', zip: '727112' },
  { city: 'Şesuri (Suceava)', zip: '727113' },
  { city: 'Ţibău (Suceava)', zip: '727114' },
  { city: 'Valea Stânei (Suceava)', zip: '727116' },
  { city: 'Ciocăneşti (Suceava)', zip: '727120' },
  { city: 'Botoş (Suceava)', zip: '727121' },
  { city: 'Ciprian Porumbescu (Suceava)', zip: '727125' },
  { city: 'Bălăceana (Suceava)', zip: '727126' },
  { city: 'Braşca (Suceava)', zip: '727127' },
  { city: 'Ilişeşti (Suceava)', zip: '727130' },
  { city: 'Comăneşti (Suceava)', zip: '727135' },
  { city: 'Humoreni (Suceava)', zip: '727136' },
  { city: 'Cornu Luncii (Suceava)', zip: '727140' },
  { city: 'Băişeşti (Suceava)', zip: '727141' },
  { city: 'Brăieşti (Suceava)', zip: '727142' },
  { city: 'Dumbrava (Cornu Luncii) (Suceava)', zip: '727143' },
  { city: 'Păiseni (Suceava)', zip: '727144' },
  { city: 'Sasca Mare (Suceava)', zip: '727146' },
  { city: 'Sasca Mică (Suceava)', zip: '727147' },
  { city: 'Sasca Nouă (Suceava)', zip: '727148' },
  { city: 'Şinca (Suceava)', zip: '727149' },
  { city: 'Crucea (Suceava)', zip: '727150' },
  { city: 'Chiril (Suceava)', zip: '727151' },
  { city: 'Cojoci (Suceava)', zip: '727152' },
  { city: 'Satu Mare (Crucea) (Suceava)', zip: '727153' },
  { city: 'Dărmăneşti (Suceava)', zip: '727155' },
  { city: 'Călineşti (Dărmăneşti) (Suceava)', zip: '727156' },
  { city: 'Călineşti-Vasilache (Suceava)', zip: '727157' },
  { city: 'Dănila (Suceava)', zip: '727158' },
  { city: 'Măriţeia Mică (Suceava)', zip: '727159' },
  { city: 'Măriţei (Suceava)', zip: '727160' },
  { city: 'Dolhasca (Suceava)', zip: '727170' },
  { city: 'Budeni (Suceava)', zip: '727171' },
  { city: 'Gulia (Suceava)', zip: '727172' },
  { city: 'Poiana (Dolhasca) (Suceava)', zip: '727173' },
  { city: 'Poienari (Suceava)', zip: '727174' },
  { city: 'Probota (Suceava)', zip: '727176' },
  { city: 'Siliştea Nouă (Suceava)', zip: '727177' },
  { city: 'Valea Poienei (Suceava)', zip: '727178' },
  { city: 'Dolheşti (Suceava)', zip: '727180' },
  { city: 'Dolheştii Mici (Suceava)', zip: '727181' },
  { city: 'Valea Bourei (Suceava)', zip: '727182' },
  { city: 'Dolheştii Mari (Suceava)', zip: '727185' },
  { city: 'Dorna Candrenilor (Suceava)', zip: '727190' },
  { city: 'Coşna (Suceava)', zip: '727191' },
  { city: 'Dealu Floreni (Suceava)', zip: '727192' },
  { city: 'Podu Coşnei (Suceava)', zip: '727193' },
  { city: 'Poiana Negrii (Suceava)', zip: '727194' },
  { city: 'Româneşti (Coşna) (Suceava)', zip: '727196' },
  { city: 'Teşna (Coşna) (Suceava)', zip: '727197' },
  { city: 'Valea Bancului (Suceava)', zip: '727198' },
  { city: 'Dorna-Arini (Suceava)', zip: '727200' },
  { city: 'Cozăneşti (Suceava)', zip: '727201' },
  { city: 'Gheorghiţeni (Suceava)', zip: '727202' },
  { city: 'Ortoaia (Suceava)', zip: '727203' },
  { city: 'Rusca (Suceava)', zip: '727204' },
  { city: 'Sunători (Suceava)', zip: '727206' },
  { city: 'Dorneşti (Suceava)', zip: '727210' },
  { city: 'Iaz (Suceava)', zip: '727211' },
  { city: 'Drăgoieşti (Suceava)', zip: '727215' },
  { city: 'Berchişeşti (Suceava)', zip: '727216' },
  { city: 'Corlata (Suceava)', zip: '727217' },
  { city: 'Lucăceşti (Suceava)', zip: '727218' },
  { city: 'Măzănăeşti (Suceava)', zip: '727219' },
  { city: 'Drăguşeni (Suceava)', zip: '727220' },
  { city: 'Broşteni (Drăguşeni) (Suceava)', zip: '727221' },
  { city: 'Gara Leu (Suceava)', zip: '727222' },
  { city: 'Dumbrăveni (Suceava)', zip: '727225' },
  { city: 'Sălăgeni (Suceava)', zip: '727226' },
  { city: 'Fântânele (Suceava)', zip: '727230' },
  { city: 'Băneşti (Suceava)', zip: '727231' },
  { city: 'Cotu Dobei (Suceava)', zip: '727232' },
  { city: 'Slobozia (Fântânele) (Suceava)', zip: '727233' },
  { city: 'Stamate (Suceava)', zip: '727234' },
  { city: 'Forăşti (Suceava)', zip: '727235' },
  { city: 'Antoceni (Suceava)', zip: '727236' },
  { city: 'Boura (Suceava)', zip: '727237' },
  { city: 'Manolea (Suceava)', zip: '727238' },
  { city: 'Oniceni (Suceava)', zip: '727239' },
  { city: 'Roşiori (Suceava)', zip: '727241' },
  { city: 'Ruşi (Suceava)', zip: '727242' },
  { city: 'Ţoleşti (Suceava)', zip: '727243' },
  { city: 'Uideşti (Suceava)', zip: '727244' },
  { city: 'Frasin (Suceava)', zip: '727245' },
  { city: 'Bucşoaia (Suceava)', zip: '727246' },
  { city: 'Doroteia (Suceava)', zip: '727247' },
  { city: 'Plutoniţa (Suceava)', zip: '727248' },
  { city: 'Frătăuţii Noi (Suceava)', zip: '727250' },
  { city: 'Costişa (Suceava)', zip: '727251' },
  { city: 'Frătăuţii Vechi (Suceava)', zip: '727255' },
  { city: 'Măneuţi (Suceava)', zip: '727256' },
  { city: 'Frumosu (Suceava)', zip: '727260' },
  { city: 'Deia (Suceava)', zip: '727261' },
  { city: 'Dragoşa (Suceava)', zip: '727262' },
  { city: 'Fundu Moldovei (Suceava)', zip: '727265' },
  { city: 'Botuş (Suceava)', zip: '727266' },
  { city: 'Botuşel (Suceava)', zip: '727267' },
  { city: 'Braniştea (Suceava)', zip: '727268' },
  { city: 'Colacu (Suceava)', zip: '727269' },
  { city: 'Delniţa (Suceava)', zip: '727271' },
  { city: 'Deluţ (Suceava)', zip: '727272' },
  { city: 'Obcina (Suceava)', zip: '727273' },
  { city: 'Plai (Suceava)', zip: '727274' },
  { city: 'Smida Ungurenilor (Suceava)', zip: '727276' },
  { city: 'Gălăneşti (Suceava)', zip: '727280' },
  { city: 'Hurjuieni (Suceava)', zip: '727281' },
  { city: 'Voitinel (Suceava)', zip: '727282' },
  { city: 'Grămeşti (Suceava)', zip: '727285' },
  { city: 'Bălineşti (Suceava)', zip: '727286' },
  { city: 'Botoşaniţa Mică (Suceava)', zip: '727287' },
  { city: 'Rudeşti (Suceava)', zip: '727288' },
  { city: 'Verbia (Suceava)', zip: '727289' },
  { city: 'Grăniceşti (Suceava)', zip: '727290' },
  { city: 'Dumbrava (Grăniceşti) (Suceava)', zip: '727291' },
  { city: 'Gura Solcii (Suceava)', zip: '727292' },
  { city: 'Iacobeşti (Suceava)', zip: '727293' },
  { city: 'Româneşti (Grăniceşti) (Suceava)', zip: '727294' },
  { city: 'Slobozia Sucevei (Suceava)', zip: '727296' },
  { city: 'Horodnic (Suceava)', zip: '727300' },
  { city: 'Horodnic de Jos (Suceava)', zip: '727301' },
  { city: 'Horodnic de Sus (Suceava)', zip: '727305' },
  { city: 'Horodniceni (Suceava)', zip: '727310' },
  { city: 'Boteşti (Suceava)', zip: '727311' },
  { city: 'Brădăţel (Suceava)', zip: '727312' },
  { city: 'Mihăieşti (Suceava)', zip: '727313' },
  { city: 'Rotopăneşti (Suceava)', zip: '727314' },
  { city: 'Iacobeni (Suceava)', zip: '727315' },
  { city: 'Mestecăniş (Suceava)', zip: '727316' },
  { city: 'Iaslovăţ (Suceava)', zip: '727320' },
  { city: 'Ipoteşti (Suceava)', zip: '727325' },
  { city: 'Lisaura (Suceava)', zip: '727326' },
  { city: 'Tişăuţi (Suceava)', zip: '727327' },
  { city: 'Izvoarele Sucevei (Suceava)', zip: '727330' },
  { city: 'Bobeica (Suceava)', zip: '727331' },
  { city: 'Brodina (Izvoarele Sucevei) (Suceava)', zip: '727332' },
  { city: 'Liteni (Suceava)', zip: '727335' },
  { city: 'Corni (Suceava)', zip: '727336' },
  { city: 'Roşcani (Suceava)', zip: '727337' },
  { city: 'Rotunda (Suceava)', zip: '727338' },
  { city: 'Siliştea (Suceava)', zip: '727339' },
  { city: 'Vercicani (Suceava)', zip: '727341' },
  { city: 'Marginea (Suceava)', zip: '727345' },
  { city: 'Mălini (Suceava)', zip: '727350' },
  { city: 'Iesle (Suceava)', zip: '727351' },
  { city: 'Pâraie (Suceava)', zip: '727352' },
  { city: 'Poiana Mărului (Suceava)', zip: '727353' },
  { city: 'Văleni-Stânişoara (Suceava)', zip: '727354' },
  { city: 'Mănăstirea Humorului (Suceava)', zip: '727355' },
  { city: 'Pleşa (Suceava)', zip: '727356' },
  { city: 'Poiana Micului (Suceava)', zip: '727357' },
  { city: 'Milişăuţi (Suceava)', zip: '727360' },
  { city: 'Bădeuţi (Suceava)', zip: '727361' },
  { city: 'Gara (Suceava)', zip: '727362' },
  { city: 'Lunca (Milişăuţi) (Suceava)', zip: '727363' },
  { city: 'Mitocu Dragomirnei (Suceava)', zip: '727365' },
  { city: 'Dragomirna (Suceava)', zip: '727366' },
  { city: 'Lipoveni (Suceava)', zip: '727367' },
  { city: 'Mitocaşi (Suceava)', zip: '727368' },
  { city: 'Moara (Suceava)', zip: '727370' },
  { city: 'Bulai (Suceava)', zip: '727371' },
  { city: 'Frumoasa (Suceava)', zip: '727372' },
  { city: 'Groapa Vlădichii (Suceava)', zip: '727373' },
  { city: 'Liteni (Moara) (Suceava)', zip: '727374' },
  { city: 'Moara Carp (Suceava)', zip: '727376' },
  { city: 'Moara Nica (Suceava)', zip: '727377' },
  { city: 'Vornicenii Mari (Suceava)', zip: '727378' },
  { city: 'Vornicenii Mici (Suceava)', zip: '727379' },
  { city: 'Moldova-Suliţa (Suceava)', zip: '727380' },
  { city: 'Benia (Suceava)', zip: '727381' },
  { city: 'Moldoviţa (Suceava)', zip: '727385' },
  { city: 'Argel (Suceava)', zip: '727386' },
  { city: 'Demacuşa (Suceava)', zip: '727387' },
  { city: 'Raşca (Suceava)', zip: '727388' },
  { city: 'Muşeniţa (Suceava)', zip: '727390' },
  { city: 'Baineţ (Suceava)', zip: '727391' },
  { city: 'Bănceşti (Suceava)', zip: '727392' },
  { city: 'Climăuţi (Suceava)', zip: '727393' },
  { city: 'Văşcăuţi (Suceava)', zip: '727394' },
  { city: 'Vicşani (Suceava)', zip: '727396' },
  { city: 'Ostra (Suceava)', zip: '727400' },
  { city: 'Tărnicioara (Suceava)', zip: '727401' },
  { city: 'Panaci (Suceava)', zip: '727405' },
  { city: 'Catrinari (Suceava)', zip: '727406' },
  { city: 'Coverca (Suceava)', zip: '727407' },
  { city: 'Drăgoiasa (Suceava)', zip: '727408' },
  { city: 'Glodu (Suceava)', zip: '727409' },
  { city: 'Păltiniş (Suceava)', zip: '727411' },
  { city: 'Păltinoasa (Suceava)', zip: '727415' },
  { city: 'Capu Codrului (Suceava)', zip: '727416' },
  { city: 'Pătrăuţi (Suceava)', zip: '727420' },
  { city: 'Pârteştii de Jos (Suceava)', zip: '727425' },
  { city: 'Deleni (Suceava)', zip: '727426' },
  { city: 'Varvata (Suceava)', zip: '727427' },
  { city: 'Vârfu Dealului (Suceava)', zip: '727428' },
  { city: 'Poiana Stampei (Suceava)', zip: '727430' },
  { city: 'Căsoi (Suceava)', zip: '727431' },
  { city: 'Dornişoara (Suceava)', zip: '727432' },
  { city: 'Pilugani (Suceava)', zip: '727433' },
  { city: 'Prăleni (Suceava)', zip: '727434' },
  { city: 'Tătaru (Suceava)', zip: '727436' },
  { city: 'Teşna (Poiana Stampei) (Suceava)', zip: '727437' },
  { city: 'Pojorâta (Suceava)', zip: '727440' },
  { city: 'Valea Putnei (Suceava)', zip: '727441' },
  { city: 'Preuteşti (Suceava)', zip: '727445' },
  { city: 'Arghira (Suceava)', zip: '727446' },
  { city: 'Bahna Arin (Suceava)', zip: '727447' },
  { city: 'Basarabi (Suceava)', zip: '727448' },
  { city: 'Hârtop (Suceava)', zip: '727449' },
  { city: 'Huşi (Suceava)', zip: '727451' },
  { city: 'Leucuşeşti (Suceava)', zip: '727452' },
  { city: 'Putna (Suceava)', zip: '727455' },
  { city: 'Gura Putnei (Suceava)', zip: '727456' },
  { city: 'Rădăşeni (Suceava)', zip: '727460' },
  { city: 'Lămăşeni (Suceava)', zip: '727461' },
  { city: 'Pocoleni (Suceava)', zip: '727462' },
  { city: 'Râşca (Suceava)', zip: '727465' },
  { city: 'Buda (Râşca) (Suceava)', zip: '727466' },
  { city: 'Dumbrăveni (Râşca) (Suceava)', zip: '727467' },
  { city: 'Jahalia (Suceava)', zip: '727468' },
  { city: 'Slătioara (Râşca) (Suceava)', zip: '727469' },
  { city: 'Sadova (Suceava)', zip: '727470' },
  { city: 'Salcea (Suceava)', zip: '727475' },
  { city: 'Mereni (Suceava)', zip: '727476' },
  { city: 'Plopeni (Suceava)', zip: '727477' },
  { city: 'Prelipca (Suceava)', zip: '727478' },
  { city: 'Văratec (Suceava)', zip: '727479' },
  { city: 'Satu Mare (Suceava)', zip: '727480' },
  { city: 'Ţibeni (Suceava)', zip: '727481' },
  { city: 'Siminicea (Suceava)', zip: '727485' },
  { city: 'Grigoreşti (Suceava)', zip: '727486' },
  { city: 'Slatina (Suceava)', zip: '727490' },
  { city: 'Găineşti (Suceava)', zip: '727491' },
  { city: 'Herla (Suceava)', zip: '727492' },
  { city: 'Straja (Suceava)', zip: '727495' },
  { city: 'Stroieşti (Suceava)', zip: '727500' },
  { city: 'Vâlcelele (Suceava)', zip: '727501' },
  { city: 'Zahareşti (Suceava)', zip: '727502' },
  { city: 'Stulpicani (Suceava)', zip: '727505' },
  { city: 'Gemenea (Suceava)', zip: '727506' },
  { city: 'Negrileasa (Suceava)', zip: '727507' },
  { city: 'Slătioara (Stulpicani) (Suceava)', zip: '727508' },
  { city: 'Vadu Negrilesei (Suceava)', zip: '727509' },
  { city: 'Suceviţa (Suceava)', zip: '727510' },
  { city: 'Voievodeasa (Suceava)', zip: '727511' },
  { city: 'Şaru Dornei (Suceava)', zip: '727515' },
  { city: 'Gura Haitii (Suceava)', zip: '727516' },
  { city: 'Neagra Şarului (Suceava)', zip: '727517' },
  { city: 'Plaiu Şarului (Suceava)', zip: '727518' },
  { city: 'Sărişor (Suceava)', zip: '727519' },
  { city: 'Sărişoru Mare (Suceava)', zip: '727521' },
  { city: 'Şaru Bucovinei (Suceava)', zip: '727522' },
  { city: 'Şcheia (Suceava)', zip: '727525' },
  { city: 'Florinta (Suceava)', zip: '727526' },
  { city: 'Mihoveni (Suceava)', zip: '727527' },
  { city: 'Sfântu Ilie (Suceava)', zip: '727528' },
  { city: 'Trei Movile (Suceava)', zip: '727529' },
  { city: 'Todireşti (Suceava)', zip: '727530' },
  { city: 'Costâna (Suceava)', zip: '727531' },
  { city: 'Părhăuţi (Suceava)', zip: '727532' },
  { city: 'Sârghieşti (Suceava)', zip: '727533' },
  { city: 'Soloneţ (Suceava)', zip: '727534' },
  { city: 'Udeşti (Suceava)', zip: '727535' },
  { city: 'Chilişeni (Suceava)', zip: '727536' },
  { city: 'Luncuşoara (Suceava)', zip: '727537' },
  { city: 'Mănăstioara (Udeşti) (Suceava)', zip: '727538' },
  { city: 'Plăvălari (Suceava)', zip: '727539' },
  { city: 'Poieni-Suceava (Suceava)', zip: '727541' },
  { city: 'Racova (Suceava)', zip: '727542' },
  { city: 'Reuseni (Suceava)', zip: '727543' },
  { city: 'Ruşii-Mănăstioara (Suceava)', zip: '727544' },
  { city: 'Securiceni (Suceava)', zip: '727546' },
  { city: 'Ştirbăţ (Suceava)', zip: '727547' },
  { city: 'Ulma (Suceava)', zip: '727555' },
  { city: 'Costileva (Suceava)', zip: '727556' },
  { city: 'Lupcina (Suceava)', zip: '727557' },
  { city: 'Măgura (Suceava)', zip: '727558' },
  { city: 'Nisipitu (Suceava)', zip: '727559' },
  { city: 'Vadu Moldovei (Suceava)', zip: '727560' },
  { city: 'Cămârzani (Suceava)', zip: '727561' },
  { city: 'Ciumuleşti (Suceava)', zip: '727562' },
  { city: 'Cotu Băii (Suceava)', zip: '727563' },
  { city: 'Dumbrăviţa (Suceava)', zip: '727564' },
  { city: 'Fântâna Mare (Suceava)', zip: '727566' },
  { city: 'Ioneasa (Suceava)', zip: '727567' },
  { city: 'Mesteceni (Suceava)', zip: '727568' },
  { city: 'Movileni (Suceava)', zip: '727569' },
  { city: 'Nigoteşti (Suceava)', zip: '727571' },
  { city: 'Praxia (Suceava)', zip: '727572' },
  { city: 'Spătăreşti (Suceava)', zip: '727573' },
  { city: 'Valea Moldovei (Suceava)', zip: '727580' },
  { city: 'Mironu (Suceava)', zip: '727581' },
  { city: 'Capu Câmpului (Suceava)', zip: '727585' },
  { city: 'Vama (Suceava)', zip: '727590' },
  { city: 'Molid (Suceava)', zip: '727591' },
  { city: 'Prisaca Dornei (Suceava)', zip: '727592' },
  { city: 'Strâmtura (Suceava)', zip: '727593' },
  { city: 'Vatra Moldoviţei (Suceava)', zip: '727595' },
  { city: 'Ciumârna (Suceava)', zip: '727596' },
  { city: 'Paltinu (Suceava)', zip: '727597' },
  { city: 'Vereşti (Suceava)', zip: '727600' },
  { city: 'Bursuceni (Suceava)', zip: '727601' },
  { city: 'Corocăieşti (Suceava)', zip: '727602' },
  { city: 'Hancea (Suceava)', zip: '727603' },
  { city: 'Vicovu de Jos (Suceava)', zip: '727605' },
  { city: 'Vicovu de Sus (Suceava)', zip: '727610' },
  { city: 'Bivolăria (Suceava)', zip: '727611' },
  { city: 'Volovăţ (Suceava)', zip: '727615' },
  { city: 'Burla (Suceava)', zip: '727616' },
  { city: 'Vultureşti (Suceava)', zip: '727620' },
  { city: 'Giurgeşti (Suceava)', zip: '727621' },
  { city: 'Hreaţca (Suceava)', zip: '727622' },
  { city: 'Jacota (Suceava)', zip: '727623' },
  { city: 'Mereşti (Suceava)', zip: '727624' },
  { city: 'Osoi (Suceava)', zip: '727626' },
  { city: 'Pleşeşti (Suceava)', zip: '727627' },
  { city: 'Valea Glodului (Suceava)', zip: '727628' },
  { city: 'Zamostea (Suceava)', zip: '727630' },
  { city: 'Badragi (Suceava)', zip: '727631' },
  { city: 'Ciomârtan (Suceava)', zip: '727632' },
  { city: 'Cojocăreni (Suceava)', zip: '727633' },
  { city: 'Corpaci (Suceava)', zip: '727634' },
  { city: 'Lunca (Zamostea) (Suceava)', zip: '727636' },
  { city: 'Nicani (Suceava)', zip: '727637' },
  { city: 'Răuţeni (Suceava)', zip: '727638' },
  { city: 'Tăuteşti (Suceava)', zip: '727639' },
  { city: 'Zvoriştea (Suceava)', zip: '727640' },
  { city: 'Buda (Zvoriştea) (Suceava)', zip: '727641' },
  { city: 'Dealu (Suceava)', zip: '727642' },
  { city: 'Poiana (Zvoriştea) (Suceava)', zip: '727643' },
  { city: 'Slobozia (Zvoriştea) (Suceava)', zip: '727644' },
  { city: 'Stânca (Suceava)', zip: '727646' },
  { city: 'Stâncuţa (Suceava)', zip: '727647' },
  { city: 'Şerbăneşti (Suceava)', zip: '727648' },
  { city: 'Alexandria (Teleorman)', zip: '140001' },
  { city: 'Roşiori de Vede (Teleorman)', zip: '145100' },
  { city: 'Turnu Măgurele (Teleorman)', zip: '145200' },
  { city: 'Videle (Teleorman)', zip: '145300' },
  { city: 'Coşoaia (Teleorman)', zip: '145301' },
  { city: 'Zimnicea (Teleorman)', zip: '145400' },
  { city: 'Balaci (Teleorman)', zip: '147005' },
  { city: 'Burdeni (Teleorman)', zip: '147006' },
  { city: 'Tecuci (Teleorman)', zip: '147007' },
  { city: 'Băbăiţa (Teleorman)', zip: '147010' },
  { city: 'Clăniţa (Teleorman)', zip: '147011' },
  { city: 'Frăsinet (Teleorman)', zip: '147012' },
  { city: 'Merişani (Băbăiţa) (Teleorman)', zip: '147013' },
  { city: 'Blejeşti (Teleorman)', zip: '147015' },
  { city: 'Baciu (Teleorman)', zip: '147016' },
  { city: 'Sericu (Teleorman)', zip: '147017' },
  { city: 'Bogdana (Teleorman)', zip: '147020' },
  { city: 'Broşteanca (Teleorman)', zip: '147021' },
  { city: 'Ulmeni (Teleorman)', zip: '147022' },
  { city: 'Urluiu (Teleorman)', zip: '147023' },
  { city: 'Botoroaga (Teleorman)', zip: '147025' },
  { city: 'Călugăru (Teleorman)', zip: '147026' },
  { city: 'Târnava (Teleorman)', zip: '147027' },
  { city: 'Tunari (Teleorman)', zip: '147028' },
  { city: 'Valea Cireşului (Teleorman)', zip: '147029' },
  { city: 'Bragadiru (Teleorman)', zip: '147030' },
  { city: 'Brânceni (Teleorman)', zip: '147035' },
  { city: 'Bujoreni (Teleorman)', zip: '147040' },
  { city: 'Dărvaş (Teleorman)', zip: '147041' },
  { city: 'Prunaru (Teleorman)', zip: '147042' },
  { city: 'Bujoru (Teleorman)', zip: '147045' },
  { city: 'Buzescu (Teleorman)', zip: '147050' },
  { city: 'Călineşti (Teleorman)', zip: '147055' },
  { city: 'Antoneşti (Teleorman)', zip: '147056' },
  { city: 'Copăceanca (Teleorman)', zip: '147057' },
  { city: 'Licuriciu (Teleorman)', zip: '147058' },
  { city: 'Mariţa (Teleorman)', zip: '147059' },
  { city: 'Călmăţuiu (Teleorman)', zip: '147060' },
  { city: 'Bujoru (Călmăţuiu) (Teleorman)', zip: '147061' },
  { city: 'Caravaneţi (Teleorman)', zip: '147062' },
  { city: 'Nicolae Bălcescu (Teleorman)', zip: '147063' },
  { city: 'Călmăţuiu de Sus (Teleorman)', zip: '147065' },
  { city: 'Băcăleşti (Teleorman)', zip: '147066' },
  { city: 'Ionaşcu (Teleorman)', zip: '147067' },
  { city: 'Cervenia (Teleorman)', zip: '147070' },
  { city: 'Ciolăneşti (Teleorman)', zip: '147075' },
  { city: 'Baldovineşti (Teleorman)', zip: '147076' },
  { city: 'Ciolăneştii din Deal (Teleorman)', zip: '147077' },
  { city: 'Ciolăneştii din Vale (Teleorman)', zip: '147078' },
  { city: 'Ciuperceni (Teleorman)', zip: '147080' },
  { city: 'Poiana (Teleorman)', zip: '147081' },
  { city: 'Conţeşti (Teleorman)', zip: '147085' },
  { city: 'Cosmeşti (Teleorman)', zip: '147090' },
  { city: 'Ciuperceni (Cosmeşti) (Teleorman)', zip: '147091' },
  { city: 'Crângeni (Teleorman)', zip: '147095' },
  { city: 'Balta Sărată (Teleorman)', zip: '147096' },
  { city: 'Dorobanţu (Teleorman)', zip: '147097' },
  { city: 'Stejaru (Crângeni) (Teleorman)', zip: '147098' },
  { city: 'Crângu (Teleorman)', zip: '147100' },
  { city: 'Dracea (Teleorman)', zip: '147101' },
  { city: 'Florica (Teleorman)', zip: '147102' },
  { city: 'Secara (Teleorman)', zip: '147103' },
  { city: 'Zlata (Teleorman)', zip: '147104' },
  { city: 'Crevenicu (Teleorman)', zip: '147105' },
  { city: 'Răduleşti (Teleorman)', zip: '147106' },
  { city: 'Dideşti (Teleorman)', zip: '147110' },
  { city: 'Însurăţei (Teleorman)', zip: '147111' },
  { city: 'Satu Nou (Teleorman)', zip: '147112' },
  { city: 'Dobroteşti (Teleorman)', zip: '147115' },
  { city: 'Merişani (Dobroteşti) (Teleorman)', zip: '147116' },
  { city: 'Drăcşenei (Teleorman)', zip: '147120' },
  { city: 'Beuca (Teleorman)', zip: '147121' },
  { city: 'Drăcşani (Teleorman)', zip: '147122' },
  { city: 'Odobeasca (Teleorman)', zip: '147123' },
  { city: 'Plopi (Teleorman)', zip: '147124' },
  { city: 'Satul Vechi (Teleorman)', zip: '147126' },
  { city: 'Drăgăneşti de Vede (Teleorman)', zip: '147130' },
  { city: 'Măgura cu Liliac (Teleorman)', zip: '147131' },
  { city: 'Văcăreşti (Teleorman)', zip: '147132' },
  { city: 'Drăgăneşti-Vlaşca (Teleorman)', zip: '147135' },
  { city: 'Comoara (Teleorman)', zip: '147136' },
  { city: 'Văceni (Teleorman)', zip: '147137' },
  { city: 'Frumoasa (Teleorman)', zip: '147140' },
  { city: 'Păuleasca (Teleorman)', zip: '147141' },
  { city: 'Furculeşti (Teleorman)', zip: '147145' },
  { city: 'Moşteni (Furculeşti) (Teleorman)', zip: '147146' },
  { city: 'Spătărei (Teleorman)', zip: '147147' },
  { city: 'Voievoda (Teleorman)', zip: '147148' },
  { city: 'Gălăteni (Teleorman)', zip: '147150' },
  { city: 'Bâscoveni (Teleorman)', zip: '147151' },
  { city: 'Grădişteanca (Teleorman)', zip: '147152' },
  { city: 'Gratia (Teleorman)', zip: '147155' },
  { city: 'Ciurari-Deal (Teleorman)', zip: '147156' },
  { city: 'Drăghineşti (Teleorman)', zip: '147157' },
  { city: 'Islaz (Teleorman)', zip: '147160' },
  { city: 'Moldoveni (Teleorman)', zip: '147161' },
  { city: 'Izvoarele (Teleorman)', zip: '147165' },
  { city: 'Lisa (Teleorman)', zip: '147170' },
  { city: 'Vânători (Teleorman)', zip: '147171' },
  { city: 'Liţa (Teleorman)', zip: '147175' },
  { city: 'Lunca (Teleorman)', zip: '147180' },
  { city: 'Pleaşov (Teleorman)', zip: '147181' },
  { city: 'Prundu (Teleorman)', zip: '147182' },
  { city: 'Saelele (Teleorman)', zip: '147183' },
  { city: 'Mavrodin (Teleorman)', zip: '147185' },
  { city: 'Nenciuleşti (Teleorman)', zip: '147186' },
  { city: 'Păru Rotund (Teleorman)', zip: '147187' },
  { city: 'Măgura (Teleorman)', zip: '147190' },
  { city: 'Guruieni (Teleorman)', zip: '147191' },
  { city: 'Măldăeni (Teleorman)', zip: '147195' },
  { city: 'Mârzăneşti (Teleorman)', zip: '147200' },
  { city: 'Cernetu (Teleorman)', zip: '147201' },
  { city: 'Teleormanu (Teleorman)', zip: '147202' },
  { city: 'Valea Părului (Teleorman)', zip: '147203' },
  { city: 'Mereni (Teleorman)', zip: '147205' },
  { city: 'Merenii de Jos (Teleorman)', zip: '147206' },
  { city: 'Merenii de Sus (Teleorman)', zip: '147207' },
  { city: 'Ştefeni (Teleorman)', zip: '147208' },
  { city: 'Moşteni (Teleorman)', zip: '147210' },
  { city: 'Nanov (Teleorman)', zip: '147215' },
  { city: 'Năsturelu (Teleorman)', zip: '147220' },
  { city: 'Zimnicele (Teleorman)', zip: '147221' },
  { city: 'Necşeşti (Teleorman)', zip: '147225' },
  { city: 'Belciug (Teleorman)', zip: '147226' },
  { city: 'Gârdeşti (Teleorman)', zip: '147227' },
  { city: 'Olteni (Teleorman)', zip: '147230' },
  { city: 'Perii Broşteni (Teleorman)', zip: '147231' },
  { city: 'Orbeasca (Teleorman)', zip: '147235' },
  { city: 'Lăceni (Teleorman)', zip: '147236' },
  { city: 'Orbeasca de Jos (Teleorman)', zip: '147237' },
  { city: 'Orbeasca de Sus (Teleorman)', zip: '147238' },
  { city: 'Peretu (Teleorman)', zip: '147240' },
  { city: 'Piatra (Teleorman)', zip: '147245' },
  { city: 'Pietroşani (Teleorman)', zip: '147250' },
  { city: 'Plopii-Slăviteşti (Teleorman)', zip: '147255' },
  { city: 'Bârseştii de Jos (Teleorman)', zip: '147256' },
  { city: 'Beciu (Teleorman)', zip: '147257' },
  { city: 'Brâncoveanca (Teleorman)', zip: '147258' },
  { city: 'Dudu (Teleorman)', zip: '147259' },
  { city: 'Smârdan (Teleorman)', zip: '147261' },
  { city: 'Plosca (Teleorman)', zip: '147265' },
  { city: 'Poeni (Teleorman)', zip: '147270' },
  { city: 'Banov (Teleorman)', zip: '147271' },
  { city: 'Brăteşti (Teleorman)', zip: '147272' },
  { city: 'Cătunu (Teleorman)', zip: '147273' },
  { city: 'Preajba (Teleorman)', zip: '147274' },
  { city: 'Ţăvârlău (Teleorman)', zip: '147276' },
  { city: 'Vătaşi (Teleorman)', zip: '147277' },
  { city: 'Poroschia (Teleorman)', zip: '147280' },
  { city: 'Calomfireşti (Teleorman)', zip: '147281' },
  { city: 'Putineiu (Teleorman)', zip: '147285' },
  { city: 'Băduleasa (Teleorman)', zip: '147286' },
  { city: 'Cârlomanu (Teleorman)', zip: '147287' },
  { city: 'Rădoieşti (Teleorman)', zip: '147290' },
  { city: 'Cetatea (Teleorman)', zip: '147291' },
  { city: 'Rădoieşti-Deal (Teleorman)', zip: '147292' },
  { city: 'Rădoieşti-Vale (Teleorman)', zip: '147293' },
  { city: 'Răsmireşti (Teleorman)', zip: '147295' },
  { city: 'Ludăneasca (Teleorman)', zip: '147296' },
  { city: 'Salcia (Teleorman)', zip: '147300' },
  { city: 'Băneasa (Teleorman)', zip: '147301' },
  { city: 'Tudor Vladimirescu (Teleorman)', zip: '147302' },
  { city: 'Săceni (Teleorman)', zip: '147305' },
  { city: 'Butculeşti (Teleorman)', zip: '147306' },
  { city: 'Ciurari (Teleorman)', zip: '147307' },
  { city: 'Sârbeni (Teleorman)', zip: '147310' },
  { city: 'Sârbenii de Jos (Teleorman)', zip: '147311' },
  { city: 'Udeni (Teleorman)', zip: '147312' },
  { city: 'Scrioaştea (Teleorman)', zip: '147315' },
  { city: 'Brebina (Teleorman)', zip: '147316' },
  { city: 'Cucueţi (Teleorman)', zip: '147317' },
  { city: 'Viile (Teleorman)', zip: '147318' },
  { city: 'Scurtu Mare (Teleorman)', zip: '147320' },
  { city: 'Albeni (Teleorman)', zip: '147321' },
  { city: 'Drăceşti (Teleorman)', zip: '147322' },
  { city: 'Negrileşti (Teleorman)', zip: '147323' },
  { city: 'Scurtu-Slăveşti (Teleorman)', zip: '147324' },
  { city: 'Valea Poştei (Teleorman)', zip: '147326' },
  { city: 'Seaca (Teleorman)', zip: '147330' },
  { city: 'Năvodari (Teleorman)', zip: '147331' },
  { city: 'Segarcea-Vale (Teleorman)', zip: '147335' },
  { city: 'Olteanca (Teleorman)', zip: '147336' },
  { city: 'Segarcea-Deal (Teleorman)', zip: '147337' },
  { city: 'Sfinţeşti (Teleorman)', zip: '147340' },
  { city: 'Siliştea (Teleorman)', zip: '147345' },
  { city: 'Buteşti (Teleorman)', zip: '147346' },
  { city: 'Purani (Teleorman)', zip: '147347' },
  { city: 'Puranii de Sus (Teleorman)', zip: '147348' },
  { city: 'Siliştea Mică (Teleorman)', zip: '147349' },
  { city: 'Siliştea Gumeşti (Teleorman)', zip: '147350' },
  { city: 'Slobozia Mândra (Teleorman)', zip: '147355' },
  { city: 'Uda-Clocociov (Teleorman)', zip: '147356' },
  { city: 'Uda-Paciurea (Teleorman)', zip: '147357' },
  { city: 'Smârdioasa (Teleorman)', zip: '147360' },
  { city: 'Şoimu (Teleorman)', zip: '147361' },
  { city: 'Stejaru (Teleorman)', zip: '147365' },
  { city: 'Bratcovu (Teleorman)', zip: '147366' },
  { city: 'Gresia (Teleorman)', zip: '147367' },
  { city: 'Socetu (Teleorman)', zip: '147368' },
  { city: 'Suhaia (Teleorman)', zip: '147370' },
  { city: 'Fântânele (Teleorman)', zip: '147371' },
  { city: 'Ştorobăneasa (Teleorman)', zip: '147375' },
  { city: 'Beiu (Teleorman)', zip: '147376' },
  { city: 'Talpa (Teleorman)', zip: '147380' },
  { city: 'Linia Costii (Teleorman)', zip: '147381' },
  { city: 'Rotăreşti (Teleorman)', zip: '147382' },
  { city: 'Talpa Poştei (Teleorman)', zip: '147383' },
  { city: 'Talpa-Bâscoveni (Teleorman)', zip: '147384' },
  { city: 'Talpa-Ogrăzile (Teleorman)', zip: '147386' },
  { city: 'Tătărăştii de Jos (Teleorman)', zip: '147390' },
  { city: 'Lada (Teleorman)', zip: '147391' },
  { city: 'Negreni (Teleorman)', zip: '147392' },
  { city: 'Negrenii de Sus (Teleorman)', zip: '147393' },
  { city: 'Negrenii-Osebiţi (Teleorman)', zip: '147394' },
  { city: 'Obârtu (Teleorman)', zip: '147396' },
  { city: 'Slăveşti (Teleorman)', zip: '147397' },
  { city: 'Tătărăştii de Sus (Teleorman)', zip: '147400' },
  { city: 'Dobreni (Teleorman)', zip: '147401' },
  { city: 'Udupu (Teleorman)', zip: '147402' },
  { city: 'Traian (Teleorman)', zip: '147405' },
  { city: 'Trivalea-Moşteni (Teleorman)', zip: '147410' },
  { city: 'Brătăşani (Teleorman)', zip: '147411' },
  { city: 'Deparaţi (Teleorman)', zip: '147412' },
  { city: 'Troianul (Teleorman)', zip: '147415' },
  { city: 'Dulceni (Teleorman)', zip: '147416' },
  { city: 'Vatra (Teleorman)', zip: '147417' },
  { city: 'Ţigăneşti (Teleorman)', zip: '147420' },
  { city: 'Vârtoape (Teleorman)', zip: '147425' },
  { city: 'Gărăgău (Teleorman)', zip: '147426' },
  { city: 'Vârtoapele de Jos (Teleorman)', zip: '147427' },
  { city: 'Vârtoapele de Sus (Teleorman)', zip: '147428' },
  { city: 'Vedea (Teleorman)', zip: '147430' },
  { city: 'Albeşti (Teleorman)', zip: '147431' },
  { city: 'Coşoteni (Teleorman)', zip: '147432' },
  { city: 'Dulceanca (Teleorman)', zip: '147433' },
  { city: 'Meri (Teleorman)', zip: '147434' },
  { city: 'Viişoara (Teleorman)', zip: '147435' },
  { city: 'Vităneşti (Teleorman)', zip: '147440' },
  { city: 'Purani (Vităneşti) (Teleorman)', zip: '147441' },
  { city: 'Schitu Poienari (Teleorman)', zip: '147442' },
  { city: 'Siliştea (Vităneşti) (Teleorman)', zip: '147443' },
  { city: 'Zâmbreasca (Teleorman)', zip: '147445' },
  { city: 'Timişoara (Timiş)', zip: '300001' },
  { city: 'Buziaş (Timiş)', zip: '305100' },
  { city: 'Bacova (Timiş)', zip: '305101' },
  { city: 'Silagiu (Timiş)', zip: '305102' },
  { city: 'Deta (Timiş)', zip: '305200' },
  { city: 'Opatiţa (Timiş)', zip: '305201' },
  { city: 'Făget (Timiş)', zip: '305300' },
  { city: 'Băteşti (Timiş)', zip: '305301' },
  { city: 'Begheiu Mic (Timiş)', zip: '305302' },
  { city: 'Bichigi (Timiş)', zip: '305303' },
  { city: 'Brăneşti (Timiş)', zip: '305304' },
  { city: 'Bunea Mare (Timiş)', zip: '305305' },
  { city: 'Bunea Mică (Timiş)', zip: '305306' },
  { city: 'Colonia Mică (Timiş)', zip: '305307' },
  { city: 'Jupâneşti (Timiş)', zip: '305308' },
  { city: 'Povârgina (Timiş)', zip: '305309' },
  { city: 'Temereşti (Timiş)', zip: '305310' },
  { city: 'Jimbolia (Timiş)', zip: '305400' },
  { city: 'Lugoj (Timiş)', zip: '305500' },
  { city: 'Măguri (Timiş)', zip: '305501' },
  { city: 'Tapia (Timiş)', zip: '305502' },
  { city: 'Sânnicolau Mare (Timiş)', zip: '305600' },
  { city: 'Balinţ (Timiş)', zip: '307005' },
  { city: 'Bodo (Timiş)', zip: '307006' },
  { city: 'Fădimac (Timiş)', zip: '307007' },
  { city: 'Târgovişte (Timiş)', zip: '307008' },
  { city: 'Banloc (Timiş)', zip: '307010' },
  { city: 'Dolaţ (Timiş)', zip: '307011' },
  { city: 'Livezile (Timiş)', zip: '307012' },
  { city: 'Ofseniţa (Timiş)', zip: '307013' },
  { city: 'Partoş (Timiş)', zip: '307014' },
  { city: 'Soca (Timiş)', zip: '307016' },
  { city: 'Bara (Timiş)', zip: '307020' },
  { city: 'Dobreşti (Timiş)', zip: '307021' },
  { city: 'Lăpuşnic (Timiş)', zip: '307022' },
  { city: 'Rădmăneşti (Timiş)', zip: '307023' },
  { city: 'Spata (Timiş)', zip: '307024' },
  { city: 'Bârna (Timiş)', zip: '307025' },
  { city: 'Boteşti (Timiş)', zip: '307026' },
  { city: 'Botineşti (Timiş)', zip: '307027' },
  { city: 'Drinova (Timiş)', zip: '307028' },
  { city: 'Jureşti (Timiş)', zip: '307029' },
  { city: 'Pogăneşti (Timiş)', zip: '307031' },
  { city: 'Sărăzani (Timiş)', zip: '307032' },
  { city: 'Beba Veche (Timiş)', zip: '307035' },
  { city: 'Cherestur (Timiş)', zip: '307036' },
  { city: 'Pordeanu (Timiş)', zip: '307037' },
  { city: 'Becicherecu Mic (Timiş)', zip: '307040' },
  { city: 'Dudeştii Noi (Timiş)', zip: '307041' },
  { city: 'Belinţ (Timiş)', zip: '307045' },
  { city: 'Babşa (Timiş)', zip: '307046' },
  { city: 'Chizătău (Timiş)', zip: '307047' },
  { city: 'Gruni (Timiş)', zip: '307048' },
  { city: 'Bethausen (Timiş)', zip: '307050' },
  { city: 'Cladova (Timiş)', zip: '307051' },
  { city: 'Cliciova (Timiş)', zip: '307052' },
  { city: 'Cutina (Timiş)', zip: '307053' },
  { city: 'Leucuşeşti (Timiş)', zip: '307054' },
  { city: 'Nevrincea (Timiş)', zip: '307056' },
  { city: 'Biled (Timiş)', zip: '307060' },
  { city: 'Uihei (Timiş)', zip: '307061' },
  { city: 'Şandra (Timiş)', zip: '307065' },
  { city: 'Bogda (Timiş)', zip: '307070' },
  { city: 'Altringen (Timiş)', zip: '307071' },
  { city: 'Buzad (Timiş)', zip: '307072' },
  { city: 'Charlotenburg (Timiş)', zip: '307073' },
  { city: 'Comeat (Timiş)', zip: '307074' },
  { city: 'Sintar (Timiş)', zip: '307076' },
  { city: 'Boldur (Timiş)', zip: '307080' },
  { city: 'Jabăr (Timiş)', zip: '307081' },
  { city: 'Ohaba-Forgaci (Timiş)', zip: '307082' },
  { city: 'Sinersig (Timiş)', zip: '307083' },
  { city: 'Brestovăţ (Timiş)', zip: '307085' },
  { city: 'Coşarii (Timiş)', zip: '307086' },
  { city: 'Hodoş (Brestovăţ) (Timiş)', zip: '307087' },
  { city: 'Lucareţ (Timiş)', zip: '307088' },
  { city: 'Teş (Timiş)', zip: '307089' },
  { city: 'Cărpiniş (Timiş)', zip: '307090' },
  { city: 'Iecea Mare (Timiş)', zip: '307091' },
  { city: 'Iecea Mică (Timiş)', zip: '307092' },
  { city: 'Cenad (Timiş)', zip: '307095' },
  { city: 'Cenei (Timiş)', zip: '307100' },
  { city: 'Bobda (Timiş)', zip: '307101' },
  { city: 'Checea (Timiş)', zip: '307102' },
  { city: 'Chevereşu Mare (Timiş)', zip: '307105' },
  { city: 'Dragşina (Timiş)', zip: '307106' },
  { city: 'Vucova (Timiş)', zip: '307107' },
  { city: 'Ciacova (Timiş)', zip: '307110' },
  { city: 'Cebza (Timiş)', zip: '307111' },
  { city: 'Gad (Timiş)', zip: '307112' },
  { city: 'Ghilad (Timiş)', zip: '307113' },
  { city: 'Macedonia (Timiş)', zip: '307114' },
  { city: 'Obad (Timiş)', zip: '307116' },
  { city: 'Petroman (Timiş)', zip: '307117' },
  { city: 'Comloşu Mare (Timiş)', zip: '307120' },
  { city: 'Comloşu Mic (Timiş)', zip: '307121' },
  { city: 'Lunga (Timiş)', zip: '307122' },
  { city: 'Coşteiu (Timiş)', zip: '307125' },
  { city: 'Hezeriş (Timiş)', zip: '307126' },
  { city: 'Păru (Timiş)', zip: '307127' },
  { city: 'Ţipari (Timiş)', zip: '307128' },
  { city: 'Valea Lungă Română (Timiş)', zip: '307129' },
  { city: 'Criciova (Timiş)', zip: '307130' },
  { city: 'Cireşu (Timiş)', zip: '307131' },
  { city: 'Cireşu Mic (Timiş)', zip: '307132' },
  { city: 'Jdioara (Timiş)', zip: '307133' },
  { city: 'Curtea (Timiş)', zip: '307135' },
  { city: 'Coşava (Timiş)', zip: '307136' },
  { city: 'Homojdia (Timiş)', zip: '307137' },
  { city: 'Darova (Timiş)', zip: '307140' },
  { city: 'Hodoş (Darova) (Timiş)', zip: '307141' },
  { city: 'Sacoşu Mare (Timiş)', zip: '307142' },
  { city: 'Denta (Timiş)', zip: '307145' },
  { city: 'Breştea (Timiş)', zip: '307146' },
  { city: 'Roviniţa Mare (Timiş)', zip: '307147' },
  { city: 'Roviniţa Mică (Timiş)', zip: '307148' },
  { city: 'Dudeştii Vechi (Timiş)', zip: '307150' },
  { city: 'Cheglevici (Timiş)', zip: '307151' },
  { city: 'Colonia Bulgară (Timiş)', zip: '307152' },
  { city: 'Vălcani (Timiş)', zip: '307153' },
  { city: 'Dumbrava (Timiş)', zip: '307155' },
  { city: 'Bucovăţ (Dumbrava) (Timiş)', zip: '307156' },
  { city: 'Răchita (Timiş)', zip: '307157' },
  { city: 'Dumbrăviţa (Timiş)', zip: '307160' },
  { city: 'Fârdea (Timiş)', zip: '307165' },
  { city: 'Drăgsineşti (Timiş)', zip: '307166' },
  { city: 'Gladna Montană (Timiş)', zip: '307167' },
  { city: 'Gladna Română (Timiş)', zip: '307168' },
  { city: 'Hăuzeşti (Timiş)', zip: '307169' },
  { city: 'Mâtnicu Mic (Timiş)', zip: '307171' },
  { city: 'Zolt (Timiş)', zip: '307172' },
  { city: 'Foeni (Timiş)', zip: '307175' },
  { city: 'Cruceni (Timiş)', zip: '307176' },
  { city: 'Gavojdia (Timiş)', zip: '307180' },
  { city: 'Jena (Timiş)', zip: '307181' },
  { city: 'Lugojel (Timiş)', zip: '307182' },
  { city: 'Sălbăgel (Timiş)', zip: '307183' },
  { city: 'Gătaia (Timiş)', zip: '307185' },
  { city: 'Berecuţa (Timiş)', zip: '307186' },
  { city: 'Birda (Timiş)', zip: '307187' },
  { city: 'Butin (Timiş)', zip: '307188' },
  { city: 'Mânăstire (Timiş)', zip: '307189' },
  { city: 'Percosova (Timiş)', zip: '307191' },
  { city: 'Sângeorge (Timiş)', zip: '307192' },
  { city: 'Sculia (Timiş)', zip: '307193' },
  { city: 'Şemlacu Mare (Timiş)', zip: '307194' },
  { city: 'Şemlacu Mic (Timiş)', zip: '307196' },
  { city: 'Ghiroda (Timiş)', zip: '307200' },
  { city: 'Giarmata-Vii (Timiş)', zip: '307201' },
  { city: 'Ghizela (Timiş)', zip: '307205' },
  { city: 'Hisiaş (Timiş)', zip: '307206' },
  { city: 'Paniova (Timiş)', zip: '307207' },
  { city: 'Şanoviţa (Timiş)', zip: '307208' },
  { city: 'Giarmata (Timiş)', zip: '307210' },
  { city: 'Cerneteaz (Timiş)', zip: '307211' },
  { city: 'Giera (Timiş)', zip: '307215' },
  { city: 'Grănicerii (Timiş)', zip: '307216' },
  { city: 'Toager (Timiş)', zip: '307217' },
  { city: 'Giroc (Timiş)', zip: '307220' },
  { city: 'Chişoda (Timiş)', zip: '307221' },
  { city: 'Giulvăz (Timiş)', zip: '307225' },
  { city: 'Crai Nou (Timiş)', zip: '307226' },
  { city: 'Ivanda (Timiş)', zip: '307227' },
  { city: 'Rudna (Timiş)', zip: '307228' },
  { city: 'Jamu Mare (Timiş)', zip: '307230' },
  { city: 'Clopodia (Timiş)', zip: '307231' },
  { city: 'Ferendia (Timiş)', zip: '307232' },
  { city: 'Gherman (Timiş)', zip: '307233' },
  { city: 'Lăţunaş (Timiş)', zip: '307234' },
  { city: 'Jebel (Timiş)', zip: '307235' },
  { city: 'Pădureni (Timiş)', zip: '307236' },
  { city: 'Lenauheim (Timiş)', zip: '307240' },
  { city: 'Bulgăruş (Timiş)', zip: '307241' },
  { city: 'Grabaţ (Timiş)', zip: '307242' },
  { city: 'Liebling (Timiş)', zip: '307245' },
  { city: 'Cerna (Timiş)', zip: '307246' },
  { city: 'Iosif (Timiş)', zip: '307247' },
  { city: 'Lovrin (Timiş)', zip: '307250' },
  { city: 'Gottlob (Timiş)', zip: '307251' },
  { city: 'Vizejdia (Timiş)', zip: '307252' },
  { city: 'Tomnatic (Timiş)', zip: '307255' },
  { city: 'Margina (Timiş)', zip: '307260' },
  { city: 'Breazova (Timiş)', zip: '307261' },
  { city: 'Bulza (Timiş)', zip: '307262' },
  { city: 'Coşeviţa (Timiş)', zip: '307263' },
  { city: 'Coşteiu de Sus (Timiş)', zip: '307264' },
  { city: 'Groşi (Timiş)', zip: '307266' },
  { city: 'Nemeşeşti (Timiş)', zip: '307267' },
  { city: 'Sinteşti (Timiş)', zip: '307268' },
  { city: 'Zorani (Timiş)', zip: '307269' },
  { city: 'Maşloc (Timiş)', zip: '307270' },
  { city: 'Alioş (Timiş)', zip: '307271' },
  { city: 'Fibiş (Timiş)', zip: '307272' },
  { city: 'Remetea Mică (Timiş)', zip: '307273' },
  { city: 'Mănăştiur (Timiş)', zip: '307275' },
  { city: 'Pădurani (Timiş)', zip: '307276' },
  { city: 'Remetea-Luncă (Timiş)', zip: '307277' },
  { city: 'Topla (Timiş)', zip: '307278' },
  { city: 'Moraviţa (Timiş)', zip: '307280' },
  { city: 'Dejan (Timiş)', zip: '307281' },
  { city: 'Gaiu Mic (Timiş)', zip: '307282' },
  { city: 'Stamora Germană (Timiş)', zip: '307283' },
  { city: 'Moşniţa Nouă (Timiş)', zip: '307285' },
  { city: 'Albina (Timiş)', zip: '307286' },
  { city: 'Moşniţa Veche (Timiş)', zip: '307287' },
  { city: 'Rudicica (Timiş)', zip: '307288' },
  { city: 'Urseni (Timiş)', zip: '307289' },
  { city: 'Nădrag (Timiş)', zip: '307290' },
  { city: 'Crivina (Timiş)', zip: '307291' },
  { city: 'Niţchidorf (Timiş)', zip: '307295' },
  { city: 'Blajova (Timiş)', zip: '307296' },
  { city: 'Duboz (Timiş)', zip: '307297' },
  { city: 'Ohaba Lungă (Timiş)', zip: '307300' },
  { city: 'Dubeşti (Timiş)', zip: '307301' },
  { city: 'Ierşnic (Timiş)', zip: '307302' },
  { city: 'Ohaba Română (Timiş)', zip: '307303' },
  { city: 'Orţişoara (Timiş)', zip: '307305' },
  { city: 'Călacea (Timiş)', zip: '307306' },
  { city: 'Corneşti (Timiş)', zip: '307307' },
  { city: 'Seceani (Timiş)', zip: '307308' },
  { city: 'Peciu Nou (Timiş)', zip: '307310' },
  { city: 'Diniaş (Timiş)', zip: '307311' },
  { city: 'Sânmartinu Sârbesc (Timiş)', zip: '307312' },
  { city: 'Periam (Timiş)', zip: '307315' },
  { city: 'Pesac (Timiş)', zip: '307316' },
  { city: 'Pietroasa (Timiş)', zip: '307320' },
  { city: 'Crivina de Sus (Timiş)', zip: '307321' },
  { city: 'Fărăşeşti (Timiş)', zip: '307322' },
  { city: 'Poieni (Timiş)', zip: '307323' },
  { city: 'Pişchia (Timiş)', zip: '307325' },
  { city: 'Bencecu de Jos (Timiş)', zip: '307326' },
  { city: 'Bencecu de Sus (Timiş)', zip: '307327' },
  { city: 'Murani (Timiş)', zip: '307328' },
  { city: 'Sălciua Nouă (Timiş)', zip: '307329' },
  { city: 'Racoviţa (Timiş)', zip: '307330' },
  { city: 'Căpăt (Timiş)', zip: '307331' },
  { city: 'Drăgoieşti (Timiş)', zip: '307332' },
  { city: 'Ficătar (Timiş)', zip: '307333' },
  { city: 'Hitiaş (Timiş)', zip: '307334' },
  { city: 'Sârbova (Timiş)', zip: '307336' },
  { city: 'Recaş (Timiş)', zip: '307340' },
  { city: 'Bazoş (Timiş)', zip: '307341' },
  { city: 'Herneacova (Timiş)', zip: '307342' },
  { city: 'Izvin (Timiş)', zip: '307343' },
  { city: 'Nadăş (Timiş)', zip: '307344' },
  { city: 'Petrovaselo (Timiş)', zip: '307346' },
  { city: 'Stanciova (Timiş)', zip: '307347' },
  { city: 'Remetea Mare (Timiş)', zip: '307350' },
  { city: 'Bazoşu Nou (Timiş)', zip: '307351' },
  { city: 'Bucovăţ (Remetea Mare) (Timiş)', zip: '307352' },
  { city: 'Ianova (Timiş)', zip: '307353' },
  { city: 'Sacoşu Turcesc (Timiş)', zip: '307355' },
  { city: 'Berini (Timiş)', zip: '307356' },
  { city: 'Icloda (Timiş)', zip: '307357' },
  { city: 'Otveşti (Timiş)', zip: '307358' },
  { city: 'Stamora Română (Timiş)', zip: '307359' },
  { city: 'Uliuc (Timiş)', zip: '307361' },
  { city: 'Unip (Timiş)', zip: '307362' },
  { city: 'Satchinez (Timiş)', zip: '307365' },
  { city: 'Bărăteaz (Timiş)', zip: '307366' },
  { city: 'Hodoni (Timiş)', zip: '307367' },
  { city: 'Săcălaz (Timiş)', zip: '307370' },
  { city: 'Beregsău Mare (Timiş)', zip: '307371' },
  { city: 'Beregsău Mic (Timiş)', zip: '307372' },
  { city: 'Sânandrei (Timiş)', zip: '307375' },
  { city: 'Carani (Timiş)', zip: '307376' },
  { city: 'Covaci (Timiş)', zip: '307377' },
  { city: 'Sânmihaiu Român (Timiş)', zip: '307380' },
  { city: 'Sânmihaiu German (Timiş)', zip: '307381' },
  { city: 'Utvin (Timiş)', zip: '307382' },
  { city: 'Sânpetru Mare (Timiş)', zip: '307385' },
  { city: 'Igriş (Timiş)', zip: '307386' },
  { city: 'Saravale (Timiş)', zip: '307387' },
  { city: 'Secaş (Timiş)', zip: '307390' },
  { city: 'Checheş (Timiş)', zip: '307391' },
  { city: 'Crivobara (Timiş)', zip: '307392' },
  { city: 'Vizma (Timiş)', zip: '307393' },
  { city: 'Şag (Timiş)', zip: '307395' },
  { city: 'Parţa (Timiş)', zip: '307396' },
  { city: 'Ştiuca (Timiş)', zip: '307400' },
  { city: 'Dragomireşti (Timiş)', zip: '307401' },
  { city: 'Oloşag (Timiş)', zip: '307402' },
  { city: 'Zgribeşti (Timiş)', zip: '307403' },
  { city: 'Teremia Mare (Timiş)', zip: '307405' },
  { city: 'Nerău (Timiş)', zip: '307406' },
  { city: 'Teremia Mică (Timiş)', zip: '307407' },
  { city: 'Tomeşti (Timiş)', zip: '307410' },
  { city: 'Baloşeşti (Timiş)', zip: '307411' },
  { city: 'Colonia Fabricii (Timiş)', zip: '307412' },
  { city: 'Luncanii de Jos (Timiş)', zip: '307413' },
  { city: 'Luncanii de Sus (Timiş)', zip: '307414' },
  { city: 'Româneşti (Timiş)', zip: '307416' },
  { city: 'Topolovăţu Mare (Timiş)', zip: '307420' },
  { city: 'Cralovăţ (Timiş)', zip: '307421' },
  { city: 'Ictar-Budinţi (Timiş)', zip: '307422' },
  { city: 'Iosifalău (Timiş)', zip: '307423' },
  { city: 'Suştra (Timiş)', zip: '307424' },
  { city: 'Topolovăţu Mic (Timiş)', zip: '307426' },
  { city: 'Tormac (Timiş)', zip: '307430' },
  { city: 'Cadăr (Timiş)', zip: '307431' },
  { city: 'Şipet (Timiş)', zip: '307432' },
  { city: 'Traian Vuia (Timiş)', zip: '307435' },
  { city: 'Jupani (Timiş)', zip: '307436' },
  { city: 'Săceni (Timiş)', zip: '307437' },
  { city: 'Sudriaş (Timiş)', zip: '307438' },
  { city: 'Surducu Mic (Timiş)', zip: '307439' },
  { city: 'Susani (Timiş)', zip: '307441' },
  { city: 'Uivar (Timiş)', zip: '307445' },
  { city: 'Iohanisfeld (Timiş)', zip: '307446' },
  { city: 'Otelec (Timiş)', zip: '307447' },
  { city: 'Pustiniş (Timiş)', zip: '307448' },
  { city: 'Răuţi (Timiş)', zip: '307449' },
  { city: 'Sânmartinu Maghiar (Timiş)', zip: '307451' },
  { city: 'Variaş (Timiş)', zip: '307455' },
  { city: 'Gelu (Timiş)', zip: '307456' },
  { city: 'Sânpetru Mic (Timiş)', zip: '307457' },
  { city: 'Victor Vlad Delamarina (Timiş)', zip: '307460' },
  { city: 'Herendeşti (Timiş)', zip: '307461' },
  { city: 'Honorici (Timiş)', zip: '307462' },
  { city: 'Pădureni (Victor Vlad Delamarina) (Timiş)', zip: '307463' },
  { city: 'Petroasa Mare (Timiş)', zip: '307464' },
  { city: 'Pini (Timiş)', zip: '307466' },
  { city: 'Visag (Timiş)', zip: '307467' },
  { city: 'Voiteg (Timiş)', zip: '307470' },
  { city: 'Folea (Timiş)', zip: '307471' },
  { city: 'Tudor Vladimirescu (Tulcea)', zip: '820001' },
  { city: 'Tulcea (Tulcea)', zip: '820002' },
  { city: 'Babadag (Tulcea)', zip: '825100' },
  { city: 'Isaccea (Tulcea)', zip: '825200' },
  { city: 'Revărsarea (Tulcea)', zip: '825201' },
  { city: 'Tichileşti (Tulcea)', zip: '825202' },
  { city: 'Măcin (Tulcea)', zip: '825300' },
  { city: 'Sulina (Tulcea)', zip: '825400' },
  { city: 'Baia (Tulcea)', zip: '827005' },
  { city: 'Camena (Tulcea)', zip: '827006' },
  { city: 'Caugagia (Tulcea)', zip: '827007' },
  { city: 'Ceamurlia de Sus (Tulcea)', zip: '827008' },
  { city: 'Panduru (Tulcea)', zip: '827009' },
  { city: 'Beidaud (Tulcea)', zip: '827010' },
  { city: 'Neatârnarea (Tulcea)', zip: '827011' },
  { city: 'Sarighiol de Deal (Tulcea)', zip: '827012' },
  { city: 'C.A. Rosetti (Tulcea)', zip: '827015' },
  { city: 'Cardon (Tulcea)', zip: '827016' },
  { city: 'Letea (Tulcea)', zip: '827017' },
  { city: 'Periprava (Tulcea)', zip: '827018' },
  { city: 'Sfiştofca (Tulcea)', zip: '827019' },
  { city: 'Carcaliu (Tulcea)', zip: '827020' },
  { city: 'Casimcea (Tulcea)', zip: '827025' },
  { city: 'Cişmeaua Nouă (Tulcea)', zip: '827026' },
  { city: 'Corugea (Tulcea)', zip: '827027' },
  { city: 'Haidar (Tulcea)', zip: '827028' },
  { city: 'Rahman (Tulcea)', zip: '827029' },
  { city: 'Războieni (Tulcea)', zip: '827031' },
  { city: 'Stânca (Tulcea)', zip: '827032' },
  { city: 'Ceamurlia de Jos (Tulcea)', zip: '827035' },
  { city: 'Lunca (Tulcea)', zip: '827036' },
  { city: 'Ceatalchioi (Tulcea)', zip: '827040' },
  { city: 'Pătlăgeanca (Tulcea)', zip: '827041' },
  { city: 'Plauru (Tulcea)', zip: '827042' },
  { city: 'Sălceni (Tulcea)', zip: '827043' },
  { city: 'Cerna (Tulcea)', zip: '827045' },
  { city: 'General Praporgescu (Tulcea)', zip: '827046' },
  { city: 'Mircea Vodă (Tulcea)', zip: '827047' },
  { city: 'Traian (Tulcea)', zip: '827048' },
  { city: 'Chilia Veche (Tulcea)', zip: '827050' },
  { city: 'Câşliţa (Tulcea)', zip: '827051' },
  { city: 'Ostrov Tătaru (Tulcea)', zip: '827052' },
  { city: 'Tatanir (Tulcea)', zip: '827053' },
  { city: 'Ciucurova (Tulcea)', zip: '827055' },
  { city: 'Atmagea (Tulcea)', zip: '827056' },
  { city: 'Fântâna Mare (Tulcea)', zip: '827057' },
  { city: 'Crişan (Tulcea)', zip: '827060' },
  { city: 'Caraorman (Tulcea)', zip: '827061' },
  { city: 'Mila 23 (Tulcea)', zip: '827062' },
  { city: 'Dăeni (Tulcea)', zip: '827065' },
  { city: 'Dorobanţu (Tulcea)', zip: '827070' },
  { city: 'Ardealu (Tulcea)', zip: '827071' },
  { city: 'Cârjelari (Tulcea)', zip: '827072' },
  { city: 'Fântâna Oilor (Tulcea)', zip: '827073' },
  { city: 'Meşteru (Tulcea)', zip: '827074' },
  { city: 'Frecăţei (Tulcea)', zip: '827075' },
  { city: 'Cataloi (Tulcea)', zip: '827076' },
  { city: 'Poşta (Tulcea)', zip: '827077' },
  { city: 'Teliţa (Tulcea)', zip: '827078' },
  { city: 'Greci (Tulcea)', zip: '827080' },
  { city: 'Grindu (Tulcea)', zip: '827085' },
  { city: 'Hamcearca (Tulcea)', zip: '827090' },
  { city: 'Balabancea (Tulcea)', zip: '827091' },
  { city: 'Căprioara (Tulcea)', zip: '827092' },
  { city: 'Nifon (Tulcea)', zip: '827093' },
  { city: 'Horia (Tulcea)', zip: '827095' },
  { city: 'Cloşca (Tulcea)', zip: '827096' },
  { city: 'Floreşti (Tulcea)', zip: '827097' },
  { city: 'I.C. Brătianu (Tulcea)', zip: '827100' },
  { city: 'Izvoarele (Tulcea)', zip: '827105' },
  { city: 'Alba (Tulcea)', zip: '827106' },
  { city: 'Iulia (Tulcea)', zip: '827107' },
  { city: 'Valea Teilor (Tulcea)', zip: '827108' },
  { city: 'Jijila (Tulcea)', zip: '827110' },
  { city: 'Garvăn (Tulcea)', zip: '827111' },
  { city: 'Jurilovca (Tulcea)', zip: '827115' },
  { city: 'Sălcioara (Tulcea)', zip: '827116' },
  { city: 'Vişina (Tulcea)', zip: '827117' },
  { city: 'Luncaviţa (Tulcea)', zip: '827120' },
  { city: 'Rachelu (Tulcea)', zip: '827121' },
  { city: 'Văcăreni (Tulcea)', zip: '827125' },
  { city: 'Mahmudia (Tulcea)', zip: '827130' },
  { city: 'Băltenii de Jos (Tulcea)', zip: '827131' },
  { city: 'Băltenii de Sus (Tulcea)', zip: '827132' },
  { city: 'Beştepe (Tulcea)', zip: '827133' },
  { city: 'Maliuc (Tulcea)', zip: '827135' },
  { city: 'Gorgova (Tulcea)', zip: '827136' },
  { city: 'Ilganii de Sus (Tulcea)', zip: '827137' },
  { city: 'Partizani (Tulcea)', zip: '827138' },
  { city: 'Vulturu (Tulcea)', zip: '827139' },
  { city: 'Mihai Bravu (Tulcea)', zip: '827140' },
  { city: 'Satu Nou (Tulcea)', zip: '827141' },
  { city: 'Turda (Tulcea)', zip: '827142' },
  { city: 'Mihail Kogălniceanu (Tulcea)', zip: '827145' },
  { city: 'Lăstuni (Tulcea)', zip: '827146' },
  { city: 'Rândunica (Tulcea)', zip: '827147' },
  { city: 'Murighiol (Tulcea)', zip: '827150' },
  { city: 'Colina (Tulcea)', zip: '827151' },
  { city: 'Dunavăţu de Jos (Tulcea)', zip: '827152' },
  { city: 'Dunavăţu de Sus (Tulcea)', zip: '827153' },
  { city: 'Plopul (Tulcea)', zip: '827154' },
  { city: 'Sarinasuf (Tulcea)', zip: '827156' },
  { city: 'Uzlina (Tulcea)', zip: '827157' },
  { city: 'Nalbant (Tulcea)', zip: '827160' },
  { city: 'Nicolae Bălcescu (Tulcea)', zip: '827161' },
  { city: 'Trestenic (Tulcea)', zip: '827162' },
  { city: 'Niculiţel (Tulcea)', zip: '827165' },
  { city: 'Nufăru (Tulcea)', zip: '827170' },
  { city: 'Ilganii de Jos (Tulcea)', zip: '827171' },
  { city: 'Malcoci (Tulcea)', zip: '827172' },
  { city: 'Victoria (Tulcea)', zip: '827173' },
  { city: 'Ostrov (Tulcea)', zip: '827175' },
  { city: 'Piatra (Tulcea)', zip: '827176' },
  { city: 'Pardina (Tulcea)', zip: '827180' },
  { city: 'Peceneaga (Tulcea)', zip: '827185' },
  { city: 'Sarichioi (Tulcea)', zip: '827190' },
  { city: 'Enisala (Tulcea)', zip: '827191' },
  { city: 'Sabangia (Tulcea)', zip: '827192' },
  { city: 'Visterna (Tulcea)', zip: '827193' },
  { city: 'Zebil (Tulcea)', zip: '827194' },
  { city: 'Sfântu Gheorghe (Tulcea)', zip: '827195' },
  { city: 'Slava Cercheză (Tulcea)', zip: '827200' },
  { city: 'Slava Rusă (Tulcea)', zip: '827201' },
  { city: 'Smârdan (Tulcea)', zip: '827205' },
  { city: 'Somova (Tulcea)', zip: '827210' },
  { city: 'Mineri (Tulcea)', zip: '827211' },
  { city: 'Parcheş (Tulcea)', zip: '827212' },
  { city: 'Stejaru (Tulcea)', zip: '827215' },
  { city: 'Mina Altân Tepe (Tulcea)', zip: '827216' },
  { city: 'Vasile Alecsandri (Tulcea)', zip: '827217' },
  { city: 'Topolog (Tulcea)', zip: '827220' },
  { city: 'Calfa (Tulcea)', zip: '827221' },
  { city: 'Cerbu (Tulcea)', zip: '827222' },
  { city: 'Făgăraşu Nou (Tulcea)', zip: '827223' },
  { city: 'Luminiţa (Tulcea)', zip: '827224' },
  { city: 'Măgurele (Tulcea)', zip: '827226' },
  { city: 'Sâmbăta Nouă (Tulcea)', zip: '827227' },
  { city: 'Turcoaia (Tulcea)', zip: '827230' },
  { city: 'Valea Nucarilor (Tulcea)', zip: '827235' },
  { city: 'Agighiol (Tulcea)', zip: '827236' },
  { city: 'Iazurile (Tulcea)', zip: '827237' },
  { city: 'Bahnari (Vaslui)', zip: '730001' },
  { city: 'Brodoc (Vaslui)', zip: '730002' },
  { city: 'Moara Grecilor (Vaslui)', zip: '730003' },
  { city: 'Rediu (Vaslui) (Vaslui)', zip: '730004' },
  { city: 'Viişoara (Vaslui) (Vaslui)', zip: '730005' },
  { city: 'Vaslui (Vaslui)', zip: '730006' },
  { city: 'Bârlad (Vaslui)', zip: '731001' },
  { city: 'Huşi (Vaslui)', zip: '735100' },
  { city: 'Negreşti (Vaslui)', zip: '735200' },
  { city: 'Căzăneşti (Vaslui)', zip: '735201' },
  { city: 'Cioatele (Vaslui)', zip: '735202' },
  { city: 'Glodeni (Vaslui)', zip: '735203' },
  { city: 'Parpaniţa (Vaslui)', zip: '735204' },
  { city: 'Poiana (Vaslui)', zip: '735205' },
  { city: 'Valea Mare (Negreşti) (Vaslui)', zip: '735206' },
  { city: 'Albeşti (Vaslui)', zip: '737005' },
  { city: 'Corni-Albeşti (Vaslui)', zip: '737006' },
  { city: 'Crasna (Vaslui)', zip: '737007' },
  { city: 'Gura Albeşti (Vaslui)', zip: '737008' },
  { city: 'Alexandru Vlahuţă (Vaslui)', zip: '737010' },
  { city: 'Buda (Alexandru Vlahuţă) (Vaslui)', zip: '737011' },
  { city: 'Ghicani (Vaslui)', zip: '737012' },
  { city: 'Ibăneşti (Vaslui)', zip: '737013' },
  { city: 'Mânzaţi (Vaslui)', zip: '737014' },
  { city: 'Morăreni (Vaslui)', zip: '737016' },
  { city: 'Puţu Olarului (Vaslui)', zip: '737017' },
  { city: 'Arsura (Vaslui)', zip: '737020' },
  { city: 'Fundătura (Arsura) (Vaslui)', zip: '737021' },
  { city: 'Mihail Kogălniceanu (Vaslui)', zip: '737022' },
  { city: 'Pâhneşti (Vaslui)', zip: '737023' },
  { city: 'Banca (Vaslui)', zip: '737025' },
  { city: '1 Decembrie (Vaslui)', zip: '737026' },
  { city: 'Gara Banca (Vaslui)', zip: '737027' },
  { city: 'Ghermăneşti (Banca) (Vaslui)', zip: '737028' },
  { city: 'Micleşti (Banca) (Vaslui)', zip: '737029' },
  { city: 'Mitoc (Vaslui)', zip: '737031' },
  { city: 'Satu Nou (Banca) (Vaslui)', zip: '737032' },
  { city: 'Sălcioara (Vaslui)', zip: '737033' },
  { city: 'Sârbi (Vaslui)', zip: '737034' },
  { city: 'Stoişeşti (Vaslui)', zip: '737036' },
  { city: 'Strâmtura-Mitoc (Vaslui)', zip: '737037' },
  { city: 'Ţifu (Vaslui)', zip: '737038' },
  { city: 'Băcani (Vaslui)', zip: '737045' },
  { city: 'Băltăţeni (Vaslui)', zip: '737046' },
  { city: 'Drujeşti (Vaslui)', zip: '737047' },
  { city: 'Suseni (Vaslui)', zip: '737048' },
  { city: 'Vulpăşeni (Vaslui)', zip: '737049' },
  { city: 'Băceşti (Vaslui)', zip: '737050' },
  { city: 'Armăşeni (Băceşti) (Vaslui)', zip: '737051' },
  { city: 'Băbuşa (Vaslui)', zip: '737052' },
  { city: 'Păltiniş (Vaslui)', zip: '737053' },
  { city: 'Ţibăneştii Buhlii (Vaslui)', zip: '737054' },
  { city: 'Vovrieşti (Vaslui)', zip: '737056' },
  { city: 'Bălteni (Vaslui)', zip: '737060' },
  { city: 'Bălteni-Deal (Vaslui)', zip: '737061' },
  { city: 'Chetreşti (Vaslui)', zip: '737062' },
  { city: 'Berezeni (Vaslui)', zip: '737065' },
  { city: 'Muşata (Vaslui)', zip: '737066' },
  { city: 'Rânceni (Vaslui)', zip: '737067' },
  { city: 'Satu Nou (Berezeni) (Vaslui)', zip: '737068' },
  { city: 'Stuhuleţ (Vaslui)', zip: '737069' },
  { city: 'Blăgeşti (Vaslui)', zip: '737070' },
  { city: 'Igeşti (Vaslui)', zip: '737071' },
  { city: 'Sipeni (Vaslui)', zip: '737072' },
  { city: 'Bogdana (Vaslui)', zip: '737075' },
  { city: 'Arşiţa (Vaslui)', zip: '737076' },
  { city: 'Fântâna Blănarului (Vaslui)', zip: '737077' },
  { city: 'Găvanu (Vaslui)', zip: '737078' },
  { city: 'Lacu Babei (Vaslui)', zip: '737079' },
  { city: 'Plopeni (Vaslui)', zip: '737081' },
  { city: 'Similişoara (Vaslui)', zip: '737082' },
  { city: 'Suceveni (Vaslui)', zip: '737083' },
  { city: 'Verdeş (Vaslui)', zip: '737084' },
  { city: 'Bogdăneşti (Vaslui)', zip: '737085' },
  { city: 'Buda (Bogdăneşti) (Vaslui)', zip: '737086' },
  { city: 'Horoiata (Vaslui)', zip: '737087' },
  { city: 'Hupca (Vaslui)', zip: '737088' },
  { city: 'Orgoieşti (Vaslui)', zip: '737089' },
  { city: 'Ulea (Vaslui)', zip: '737091' },
  { city: 'Unţeşti (Vaslui)', zip: '737092' },
  { city: 'Vişinari (Vaslui)', zip: '737093' },
  { city: 'Vlădeşti (Vaslui)', zip: '737094' },
  { city: 'Bogdăniţa (Vaslui)', zip: '737095' },
  { city: 'Cârţibaşi (Vaslui)', zip: '737096' },
  { city: 'Cepeşti (Vaslui)', zip: '737097' },
  { city: 'Coroieşti (Bogdăniţa) (Vaslui)', zip: '737098' },
  { city: 'Rădăeşti (Vaslui)', zip: '737099' },
  { city: 'Schitu (Vaslui)', zip: '737101' },
  { city: 'Tunseşti (Vaslui)', zip: '737102' },
  { city: 'Boţeşti (Vaslui)', zip: '737105' },
  { city: 'Găneşti (Vaslui)', zip: '737106' },
  { city: 'Gugeşti (Vaslui)', zip: '737107' },
  { city: 'Tălpigeni (Vaslui)', zip: '737108' },
  { city: 'Buneşti-Avereşti (Vaslui)', zip: '737110' },
  { city: 'Armăşeni (Buneşti-Avereşti) (Vaslui)', zip: '737111' },
  { city: 'Buneşti (Vaslui)', zip: '737112' },
  { city: 'Plopi (Vaslui)', zip: '737113' },
  { city: 'Podu Oprii (Vaslui)', zip: '737114' },
  { city: 'Avereşti (Vaslui)', zip: '737115' },
  { city: 'Roşiori (Vaslui)', zip: '737116' },
  { city: 'Tăbălăieşti (Vaslui)', zip: '737117' },
  { city: 'Codăeşti (Vaslui)', zip: '737130' },
  { city: 'Ghergheleu (Vaslui)', zip: '737131' },
  { city: 'Pribeşti (Vaslui)', zip: '737132' },
  { city: 'Rediu Galian (Vaslui)', zip: '737133' },
  { city: 'Coroieşti (Vaslui)', zip: '737135' },
  { city: 'Chilieni (Vaslui)', zip: '737136' },
  { city: 'Coroieştii de Sus (Vaslui)', zip: '737137' },
  { city: 'Hreasca (Vaslui)', zip: '737138' },
  { city: 'Mireni (Vaslui)', zip: '737139' },
  { city: 'Movileni (Vaslui)', zip: '737141' },
  { city: 'Păcurăreşti (Vaslui)', zip: '737142' },
  { city: 'Costeşti (Vaslui)', zip: '737145' },
  { city: 'Chiţcani (Vaslui)', zip: '737146' },
  { city: 'Dinga (Vaslui)', zip: '737147' },
  { city: 'Pârveşti (Vaslui)', zip: '737148' },
  { city: 'Puntişeni (Vaslui)', zip: '737149' },
  { city: 'Rădeşti (Vaslui)', zip: '737151' },
  { city: 'Creţeşti (Vaslui)', zip: '737155' },
  { city: 'Budeşti (Vaslui)', zip: '737156' },
  { city: 'Creţeştii de Sus (Vaslui)', zip: '737157' },
  { city: 'Satu Nou (Creţeşti) (Vaslui)', zip: '737158' },
  { city: 'Dăneşti (Vaslui)', zip: '737160' },
  { city: 'Bereasa (Vaslui)', zip: '737161' },
  { city: 'Boţoaia (Vaslui)', zip: '737162' },
  { city: 'Emil Racoviţă (Vaslui)', zip: '737163' },
  { city: 'Răşcani (Dăneşti) (Vaslui)', zip: '737164' },
  { city: 'Tătărăni (Dăneşti) (Vaslui)', zip: '737166' },
  { city: 'Deleni (Vaslui)', zip: '737170' },
  { city: 'Bulboaca (Vaslui)', zip: '737171' },
  { city: 'Moreni (Vaslui)', zip: '737172' },
  { city: 'Zizinca (Vaslui)', zip: '737173' },
  { city: 'Deleşti (Vaslui)', zip: '737175' },
  { city: 'Albeşti (Deleşti) (Vaslui)', zip: '737176' },
  { city: 'Băleşti (Vaslui)', zip: '737177' },
  { city: 'Cozmeşti (Vaslui)', zip: '737178' },
  { city: 'Fâstâci (Vaslui)', zip: '737179' },
  { city: 'Fundătura (Deleşti) (Vaslui)', zip: '737181' },
  { city: 'Hârsova (Vaslui)', zip: '737182' },
  { city: 'Hordileşti (Vaslui)', zip: '737183' },
  { city: 'Mânăstirea (Deleşti) (Vaslui)', zip: '737184' },
  { city: 'Răduieşti (Vaslui)', zip: '737186' },
  { city: 'Dimitrie Cantemir (Vaslui)', zip: '737190' },
  { city: 'Grumezoaia (Vaslui)', zip: '737191' },
  { city: 'Guşiţei (Vaslui)', zip: '737192' },
  { city: 'Hurdugi (Vaslui)', zip: '737193' },
  { city: 'Plotoneşti (Vaslui)', zip: '737194' },
  { city: 'Urlaţi (Vaslui)', zip: '737196' },
  { city: 'Dragomireşti (Vaslui)', zip: '737200' },
  { city: 'Băbuţa (Vaslui)', zip: '737201' },
  { city: 'Belzeni (Vaslui)', zip: '737202' },
  { city: 'Botoi (Vaslui)', zip: '737203' },
  { city: 'Ciuperca (Vaslui)', zip: '737204' },
  { city: 'Doagele (Vaslui)', zip: '737206' },
  { city: 'Poiana Pietrei (Vaslui)', zip: '737207' },
  { city: 'Popeşti (Dragomireşti) (Vaslui)', zip: '737208' },
  { city: 'Rădeni (Vaslui)', zip: '737209' },
  { city: 'Semenea (Vaslui)', zip: '737211' },
  { city: 'Tuleşti (Vaslui)', zip: '737212' },
  { city: 'Vladia (Vaslui)', zip: '737213' },
  { city: 'Drânceni (Vaslui)', zip: '737220' },
  { city: 'Albiţa (Vaslui)', zip: '737221' },
  { city: 'Băile Drânceni (Vaslui)', zip: '737222' },
  { city: 'Ghermăneşti (Drânceni) (Vaslui)', zip: '737223' },
  { city: 'Râşeşti (Vaslui)', zip: '737224' },
  { city: 'Şopârleni (Vaslui)', zip: '737226' },
  { city: 'Duda-Epureni (Vaslui)', zip: '737230' },
  { city: 'Bobeşti (Vaslui)', zip: '737231' },
  { city: 'Duda (Vaslui)', zip: '737232' },
  { city: 'Epureni (Duda-Epureni) (Vaslui)', zip: '737233' },
  { city: 'Valea Grecului (Vaslui)', zip: '737234' },
  { city: 'Dumeşti (Vaslui)', zip: '737235' },
  { city: 'Dumeştii Vechi (Vaslui)', zip: '737236' },
  { city: 'Schinetea (Vaslui)', zip: '737237' },
  { city: 'Valea Mare (Dumeşti) (Vaslui)', zip: '737238' },
  { city: 'Epureni (Vaslui)', zip: '737240' },
  { city: 'Bârlăleşti (Vaslui)', zip: '737241' },
  { city: 'Bursuci (Vaslui)', zip: '737242' },
  { city: 'Horga (Vaslui)', zip: '737243' },
  { city: 'Fălciu (Vaslui)', zip: '737245' },
  { city: 'Bogdăneşti (Fălciu) (Vaslui)', zip: '737246' },
  { city: 'Bozia (Vaslui)', zip: '737247' },
  { city: 'Copăceana (Vaslui)', zip: '737248' },
  { city: 'Odaia Bogdana (Vaslui)', zip: '737249' },
  { city: 'Rânzeşti (Vaslui)', zip: '737251' },
  { city: 'Găgeşti (Vaslui)', zip: '737255' },
  { city: 'Giurcani (Vaslui)', zip: '737256' },
  { city: 'Peicani (Vaslui)', zip: '737257' },
  { city: 'Popeni (Găgeşti) (Vaslui)', zip: '737258' },
  { city: 'Tupilaţi (Vaslui)', zip: '737259' },
  { city: 'Gârceni (Vaslui)', zip: '737260' },
  { city: 'Dumbrăveni (Vaslui)', zip: '737261' },
  { city: 'Racova (Vaslui)', zip: '737262' },
  { city: 'Racoviţa (Vaslui)', zip: '737263' },
  { city: 'Slobozia (Vaslui)', zip: '737264' },
  { city: 'Trohan (Vaslui)', zip: '737266' },
  { city: 'Ghergheşti (Vaslui)', zip: '737270' },
  { city: 'Chetrosu (Vaslui)', zip: '737271' },
  { city: 'Corodeşti (Vaslui)', zip: '737272' },
  { city: 'Dragomăneşti (Vaslui)', zip: '737273' },
  { city: 'Drăxeni (Vaslui)', zip: '737274' },
  { city: 'Lazu (Vaslui)', zip: '737276' },
  { city: 'Lunca (Vaslui)', zip: '737277' },
  { city: 'Soci (Vaslui)', zip: '737278' },
  { city: 'Valea Lupului (Vaslui)', zip: '737279' },
  { city: 'Griviţa (Vaslui)', zip: '737280' },
  { city: 'Fruntişeni (Vaslui)', zip: '737281' },
  { city: 'Grăjdeni (Vaslui)', zip: '737282' },
  { city: 'Odaia Bursucani (Vaslui)', zip: '737283' },
  { city: 'Trestiana (Vaslui)', zip: '737284' },
  { city: 'Hoceni (Vaslui)', zip: '737285' },
  { city: 'Barboşi (Vaslui)', zip: '737286' },
  { city: 'Deleni (Hoceni) (Vaslui)', zip: '737287' },
  { city: 'Oţeleni (Vaslui)', zip: '737288' },
  { city: 'Rediu (Hoceni) (Vaslui)', zip: '737289' },
  { city: 'Şişcani (Vaslui)', zip: '737291' },
  { city: 'Tomşa (Vaslui)', zip: '737292' },
  { city: 'Iana (Vaslui)', zip: '737295' },
  { city: 'Hălăreşti (Vaslui)', zip: '737296' },
  { city: 'Recea (Vaslui)', zip: '737297' },
  { city: 'Siliştea (Iana) (Vaslui)', zip: '737298' },
  { city: 'Vadurile (Vaslui)', zip: '737299' },
  { city: 'Ivăneşti (Vaslui)', zip: '737300' },
  { city: 'Albina (Vaslui)', zip: '737301' },
  { city: 'Bleşca (Vaslui)', zip: '737302' },
  { city: 'Broşteni (Vaslui)', zip: '737303' },
  { city: 'Buscata (Vaslui)', zip: '737304' },
  { city: 'Coşca (Vaslui)', zip: '737306' },
  { city: 'Coşeşti (Vaslui)', zip: '737307' },
  { city: 'Fundătura Mare (Vaslui)', zip: '737308' },
  { city: 'Fundătura Mică (Vaslui)', zip: '737309' },
  { city: 'Hârşoveni (Vaslui)', zip: '737311' },
  { city: 'Iezerel (Vaslui)', zip: '737312' },
  { city: 'Ursoaia (Vaslui)', zip: '737313' },
  { city: 'Valea Mare (Ivăneşti) (Vaslui)', zip: '737314' },
  { city: 'Valea Oanei (Vaslui)', zip: '737316' },
  { city: 'Iveşti (Vaslui)', zip: '737320' },
  { city: 'Belceşti (Vaslui)', zip: '737321' },
  { city: 'Pogoneşti (Vaslui)', zip: '737322' },
  { city: 'Polocin (Vaslui)', zip: '737323' },
  { city: 'Laza (Vaslui)', zip: '737325' },
  { city: 'Bejeneşti (Vaslui)', zip: '737326' },
  { city: 'Poiana lui Alexa (Vaslui)', zip: '737327' },
  { city: 'Puşcaşi (Vaslui)', zip: '737328' },
  { city: 'Râşniţa (Vaslui)', zip: '737329' },
  { city: 'Sauca (Vaslui)', zip: '737331' },
  { city: 'Teişoru (Vaslui)', zip: '737332' },
  { city: 'Valea Târgului (Vaslui)', zip: '737333' },
  { city: 'Lipovăţ (Vaslui)', zip: '737335' },
  { city: 'Căpuşneni (Vaslui)', zip: '737336' },
  { city: 'Chiţoc (Vaslui)', zip: '737337' },
  { city: 'Corbu (Vaslui)', zip: '737338' },
  { city: 'Fundu Văii (Lipovăţ) (Vaslui)', zip: '737339' },
  { city: 'Lunca Banului (Vaslui)', zip: '737340' },
  { city: 'Broscoşeşti (Vaslui)', zip: '737341' },
  { city: 'Condrea (Vaslui)', zip: '737342' },
  { city: 'Focşa (Vaslui)', zip: '737343' },
  { city: 'Lunca Veche (Vaslui)', zip: '737344' },
  { city: 'Oţetoaia (Vaslui)', zip: '737346' },
  { city: 'Răducani (Vaslui)', zip: '737347' },
  { city: 'Măluşteni (Vaslui)', zip: '737350' },
  { city: 'Ghireasca (Vaslui)', zip: '737351' },
  { city: 'Lupeşti (Vaslui)', zip: '737352' },
  { city: 'Mânăstirea (Măluşteni) (Vaslui)', zip: '737353' },
  { city: 'Mânzăteşti (Vaslui)', zip: '737354' },
  { city: 'Ţuţcani (Vaslui)', zip: '737356' },
  { city: 'Micleşti (Vaslui)', zip: '737360' },
  { city: 'Chirceşti (Vaslui)', zip: '737361' },
  { city: 'Popeşti (Micleşti) (Vaslui)', zip: '737362' },
  { city: 'Muntenii de Jos (Vaslui)', zip: '737365' },
  { city: 'Băcăoani (Vaslui)', zip: '737366' },
  { city: 'Mânjeşti (Vaslui)', zip: '737367' },
  { city: 'Secuia (Vaslui)', zip: '737368' },
  { city: 'Murgeni (Vaslui)', zip: '737370' },
  { city: 'Cârja (Vaslui)', zip: '737371' },
  { city: 'Floreni (Vaslui)', zip: '737372' },
  { city: 'Lăţeşti (Vaslui)', zip: '737373' },
  { city: 'Raiu (Vaslui)', zip: '737374' },
  { city: 'Sărăţeni (Vaslui)', zip: '737376' },
  { city: 'Schineni (Vaslui)', zip: '737377' },
  { city: 'Olteneşti (Vaslui)', zip: '737380' },
  { city: 'Curteni (Vaslui)', zip: '737381' },
  { city: 'Pâhna (Vaslui)', zip: '737382' },
  { city: 'Târzii (Vaslui)', zip: '737383' },
  { city: 'Vineţeşti (Vaslui)', zip: '737384' },
  { city: 'Zgura (Vaslui)', zip: '737386' },
  { city: 'Oşeşti (Vaslui)', zip: '737390' },
  { city: 'Buda (Oşeşti) (Vaslui)', zip: '737391' },
  { city: 'Pădureni (Oşeşti) (Vaslui)', zip: '737392' },
  { city: 'Vâlcele (Vaslui)', zip: '737393' },
  { city: 'Pădureni (Vaslui)', zip: '737395' },
  { city: 'Căpoteşti (Vaslui)', zip: '737396' },
  { city: 'Davideşti (Vaslui)', zip: '737397' },
  { city: 'Ivăneşti (Pădureni) (Vaslui)', zip: '737398' },
  { city: 'Leoşti (Pădureni) (Vaslui)', zip: '737399' },
  { city: 'Rusca (Vaslui)', zip: '737401' },
  { city: 'Todireni (Vaslui)', zip: '737402' },
  { city: 'Văleni (Pădureni) (Vaslui)', zip: '737403' },
  { city: 'Perieni (Vaslui)', zip: '737405' },
  { city: 'Ciocani (Vaslui)', zip: '737406' },
  { city: 'Crâng (Vaslui)', zip: '737407' },
  { city: 'Crângu Nou (Vaslui)', zip: '737408' },
  { city: 'Podu Petriş (Vaslui)', zip: '737409' },
  { city: 'Pogana (Vaslui)', zip: '737410' },
  { city: 'Bogeşti (Vaslui)', zip: '737411' },
  { city: 'Cârjoani (Vaslui)', zip: '737412' },
  { city: 'Măscurei (Vaslui)', zip: '737413' },
  { city: 'Tomeşti (Vaslui)', zip: '737414' },
  { city: 'Poieneşti (Vaslui)', zip: '737415' },
  { city: 'Dealu Secării (Vaslui)', zip: '737416' },
  { city: 'Floreşti (Vaslui)', zip: '737417' },
  { city: 'Frasinu (Vaslui)', zip: '737418' },
  { city: 'Fundu Văii (Poieneşti) (Vaslui)', zip: '737419' },
  { city: 'Oprişiţa (Vaslui)', zip: '737421' },
  { city: 'Poieneşti-Deal (Vaslui)', zip: '737422' },
  { city: 'Puieşti (Vaslui)', zip: '737425' },
  { city: 'Bărtăluş-Mocani (Vaslui)', zip: '737426' },
  { city: 'Bărtăluş-Răzeşi (Vaslui)', zip: '737427' },
  { city: 'Călimăneşti (Vaslui)', zip: '737428' },
  { city: 'Cetăţuia (Vaslui)', zip: '737429' },
  { city: 'Cristeşti (Vaslui)', zip: '737431' },
  { city: 'Fântânele (Vaslui)', zip: '737432' },
  { city: 'Fulgu (Vaslui)', zip: '737433' },
  { city: 'Gâlţeşti (Vaslui)', zip: '737434' },
  { city: 'Iezer (Vaslui)', zip: '737436' },
  { city: 'Lăleşti (Vaslui)', zip: '737437' },
  { city: 'Rotari (Vaslui)', zip: '737438' },
  { city: 'Ruşi (Vaslui)', zip: '737439' },
  { city: 'Pungeşti (Vaslui)', zip: '737445' },
  { city: 'Armăşoaia (Vaslui)', zip: '737446' },
  { city: 'Curseşti-Deal (Vaslui)', zip: '737447' },
  { city: 'Curseşti-Vale (Vaslui)', zip: '737448' },
  { city: 'Hordila (Vaslui)', zip: '737449' },
  { city: 'Rapşa (Vaslui)', zip: '737451' },
  { city: 'Siliştea (Pungeşti) (Vaslui)', zip: '737452' },
  { city: 'Stejaru (Vaslui)', zip: '737453' },
  { city: 'Toporăşti (Vaslui)', zip: '737454' },
  { city: 'Rebricea (Vaslui)', zip: '737455' },
  { city: 'Bolaţi (Vaslui)', zip: '737456' },
  { city: 'Crăciuneşti (Vaslui)', zip: '737457' },
  { city: 'Draxeni (Vaslui)', zip: '737458' },
  { city: 'Măcreşti (Rebricea) (Vaslui)', zip: '737459' },
  { city: 'Rateşu Cuzei (Vaslui)', zip: '737461' },
  { city: 'Sasova (Vaslui)', zip: '737462' },
  { city: 'Tatomireşti (Vaslui)', zip: '737463' },
  { city: 'Tufeştii de Jos (Vaslui)', zip: '737464' },
  { city: 'Roşieşti (Vaslui)', zip: '737465' },
  { city: 'Codreni (Vaslui)', zip: '737466' },
  { city: 'Gara Roşieşti (Vaslui)', zip: '737467' },
  { city: 'Gura Idrici (Vaslui)', zip: '737468' },
  { city: 'Idrici (Vaslui)', zip: '737469' },
  { city: 'Rediu (Roşieşti) (Vaslui)', zip: '737471' },
  { city: 'Valea lui Darie (Vaslui)', zip: '737472' },
  { city: 'Soleşti (Vaslui)', zip: '737475' },
  { city: 'Bouşori (Vaslui)', zip: '737476' },
  { city: 'Iaz (Vaslui)', zip: '737477' },
  { city: 'Satu Nou (Soleşti) (Vaslui)', zip: '737478' },
  { city: 'Şerboteşti (Vaslui)', zip: '737479' },
  { city: 'Ştioborăni (Vaslui)', zip: '737481' },
  { city: 'Valea Siliştei (Vaslui)', zip: '737482' },
  { city: 'Stănileşti (Vaslui)', zip: '737485' },
  { city: 'Bogdana-Voloseni (Vaslui)', zip: '737486' },
  { city: 'Budu Cantemir (Vaslui)', zip: '737487' },
  { city: 'Chersăcosu (Vaslui)', zip: '737488' },
  { city: 'Gura Văii (Vaslui)', zip: '737489' },
  { city: 'Pogăneşti (Vaslui)', zip: '737491' },
  { city: 'Săratu (Vaslui)', zip: '737492' },
  { city: 'Ştefan cel Mare (Vaslui)', zip: '737495' },
  { city: 'Bârzeşti (Vaslui)', zip: '737496' },
  { city: 'Brăhăşoaia (Vaslui)', zip: '737497' },
  { city: 'Călugăreni (Vaslui)', zip: '737498' },
  { city: 'Cănţălăreşti (Vaslui)', zip: '737499' },
  { city: 'Mărăşeni (Vaslui)', zip: '737501' },
  { city: 'Munteneşti (Vaslui)', zip: '737502' },
  { city: 'Şuletea (Vaslui)', zip: '737505' },
  { city: 'Fedeşti (Vaslui)', zip: '737506' },
  { city: 'Jigălia (Vaslui)', zip: '737507' },
  { city: 'Răşcani (Şuletea) (Vaslui)', zip: '737508' },
  { city: 'Tanacu (Vaslui)', zip: '737510' },
  { city: 'Beneşti (Vaslui)', zip: '737511' },
  { city: 'Muntenii de Sus (Vaslui)', zip: '737512' },
  { city: 'Satu Nou (Muntenii de Sus) (Vaslui)', zip: '737513' },
  { city: 'Tăcuta (Vaslui)', zip: '737515' },
  { city: 'Cujba (Vaslui)', zip: '737516' },
  { city: 'Dumasca (Vaslui)', zip: '737517' },
  { city: 'Focşeasca (Vaslui)', zip: '737518' },
  { city: 'Mirceşti (Vaslui)', zip: '737519' },
  { city: 'Protopopeşti (Vaslui)', zip: '737521' },
  { city: 'Sofieni (Vaslui)', zip: '737522' },
  { city: 'Tătărăni (Vaslui)', zip: '737525' },
  { city: 'Bălţaţi (Vaslui)', zip: '737526' },
  { city: 'Crăsnăşeni (Vaslui)', zip: '737527' },
  { city: 'Giurgeşti (Vaslui)', zip: '737528' },
  { city: 'Leoşti (Tătărăni) (Vaslui)', zip: '737529' },
  { city: 'Manţu (Vaslui)', zip: '737531' },
  { city: 'Stroieşti (Vaslui)', zip: '737532' },
  { city: 'Valea Seacă (Vaslui)', zip: '737533' },
  { city: 'Valea lui Bosie (Vaslui)', zip: '737534' },
  { city: 'Todireşti (Vaslui)', zip: '737535' },
  { city: 'Cotic (Vaslui)', zip: '737536' },
  { city: 'Drăgeşti (Vaslui)', zip: '737537' },
  { city: 'Huc (Vaslui)', zip: '737538' },
  { city: 'Plopoasa (Vaslui)', zip: '737539' },
  { city: 'Rafaila (Vaslui)', zip: '737541' },
  { city: 'Siliştea (Todireşti) (Vaslui)', zip: '737542' },
  { city: 'Sofroneşti (Vaslui)', zip: '737543' },
  { city: 'Valea Popii (Vaslui)', zip: '737544' },
  { city: 'Viişoara (Todireşti) (Vaslui)', zip: '737546' },
  { city: 'Tutova (Vaslui)', zip: '737550' },
  { city: 'Bădeana (Vaslui)', zip: '737551' },
  { city: 'Borodeşti (Vaslui)', zip: '737552' },
  { city: 'Ciortolom (Vaslui)', zip: '737553' },
  { city: 'Coroiu (Vaslui)', zip: '737554' },
  { city: 'Criveşti (Vaslui)', zip: '737556' },
  { city: 'Pochidia (Vaslui)', zip: '737557' },
  { city: 'Satu Nou (Pochidia) (Vaslui)', zip: '737558' },
  { city: 'Sălceni (Vaslui)', zip: '737559' },
  { city: 'Vizureni (Vaslui)', zip: '737561' },
  { city: 'Văleni (Vaslui)', zip: '737565' },
  { city: 'Fereşti (Vaslui)', zip: '737566' },
  { city: 'Moara Domnească (Vaslui)', zip: '737567' },
  { city: 'Vetrişoaia (Vaslui)', zip: '737570' },
  { city: 'Bumbăta (Vaslui)', zip: '737571' },
  { city: 'Viişoara (Vaslui)', zip: '737575' },
  { city: 'Dodeşti (Vaslui)', zip: '737576' },
  { city: 'Halta Dodeşti (Vaslui)', zip: '737577' },
  { city: 'Urdeşti (Vaslui)', zip: '737578' },
  { city: 'Văleni (Viişoara) (Vaslui)', zip: '737579' },
  { city: 'Viltoteşti (Vaslui)', zip: '737581' },
  { city: 'Vinderei (Vaslui)', zip: '737585' },
  { city: 'Brădeşti (Vaslui)', zip: '737586' },
  { city: 'Docani (Vaslui)', zip: '737587' },
  { city: 'Docăneasa (Vaslui)', zip: '737588' },
  { city: 'Gara Docăneasa (Vaslui)', zip: '737589' },
  { city: 'Gara Tălăşman (Vaslui)', zip: '737591' },
  { city: 'Obârşeni (Vinderei) (Vaslui)', zip: '737592' },
  { city: 'Valea Lungă (Vaslui)', zip: '737593' },
  { city: 'Voineşti (Vaslui)', zip: '737595' },
  { city: 'Avrămeşti (Vaslui)', zip: '737596' },
  { city: 'Bănceşti (Vaslui)', zip: '737597' },
  { city: 'Corobăneşti (Vaslui)', zip: '737598' },
  { city: 'Gârdeşti (Vaslui)', zip: '737599' },
  { city: 'Mărăşeşti (Vaslui)', zip: '737601' },
  { city: 'Obârşeni (Voineşti) (Vaslui)', zip: '737602' },
  { city: 'Obârşenii Lingurari (Vaslui)', zip: '737603' },
  { city: 'Rugăria (Vaslui)', zip: '737604' },
  { city: 'Stâncăşeni (Vaslui)', zip: '737606' },
  { city: 'Uricari (Vaslui)', zip: '737607' },
  { city: 'Vultureşti (Vaslui)', zip: '737615' },
  { city: 'Buhăieşti (Vaslui)', zip: '737616' },
  { city: 'Podeni (Vaslui)', zip: '737617' },
  { city: 'Voineşti (Vultureşti) (Vaslui)', zip: '737618' },
  { city: 'Vutcani (Vaslui)', zip: '737620' },
  { city: 'Mălăieşti (Vaslui)', zip: '737621' },
  { city: 'Poşta Elan (Vaslui)', zip: '737622' },
  { city: 'Zăpodeni (Vaslui)', zip: '737625' },
  { city: 'Butucăria (Vaslui)', zip: '737626' },
  { city: 'Ciofeni (Vaslui)', zip: '737627' },
  { city: 'Delea (Vaslui)', zip: '737628' },
  { city: 'Dobrosloveşti (Vaslui)', zip: '737629' },
  { city: 'Măcreşti (Zăpodeni) (Vaslui)', zip: '737631' },
  { city: 'Portari (Vaslui)', zip: '737632' },
  { city: 'Telejna (Vaslui)', zip: '737633' },
  { city: 'Unceşti (Vaslui)', zip: '737634' },
  { city: 'Zorleni (Vaslui)', zip: '737635' },
  { city: 'Dealu Mare (Vaslui)', zip: '737636' },
  { city: 'Popeni (Zorleni) (Vaslui)', zip: '737637' },
  { city: 'Simila (Vaslui)', zip: '737638' },
  { city: 'Aranghel (Vâlcea)', zip: '240001' },
  { city: 'Căzăneşti (Râmnicu Vâlcea) (Vâlcea)', zip: '240002' },
  { city: 'Copăcelu (Vâlcea)', zip: '240003' },
  { city: 'Dealu Malului (Vâlcea)', zip: '240004' },
  { city: 'Poenari (Vâlcea)', zip: '240005' },
  { city: 'Priba (Vâlcea)', zip: '240006' },
  { city: 'Stolniceni (Vâlcea)', zip: '240007' },
  { city: 'Troian (Vâlcea)', zip: '240008' },
  { city: 'Râmnicu Vâlcea (Vâlcea)', zip: '240011' },
  { city: 'Râureni (Vâlcea)', zip: '240050' },
  { city: 'Băbeni (Vâlcea)', zip: '245100' },
  { city: 'Bonciu (Vâlcea)', zip: '245101' },
  { city: 'Capu Dealului (Vâlcea)', zip: '245102' },
  { city: 'Pădureţu (Vâlcea)', zip: '245103' },
  { city: 'Români (Vâlcea)', zip: '245104' },
  { city: 'Tătărani (Vâlcea)', zip: '245105' },
  { city: 'Valea Mare (Băbeni) (Vâlcea)', zip: '245106' },
  { city: 'Băile Govora (Vâlcea)', zip: '245200' },
  { city: 'Curăturile (Vâlcea)', zip: '245201' },
  { city: 'Gătejeşti (Vâlcea)', zip: '245202' },
  { city: 'Prajila (Vâlcea)', zip: '245203' },
  { city: 'Băile Olăneşti (Vâlcea)', zip: '245300' },
  { city: 'Cheia (Vâlcea)', zip: '245301' },
  { city: 'Comanca (Vâlcea)', zip: '245302' },
  { city: 'Gurguiata (Vâlcea)', zip: '245303' },
  { city: 'Livadia (Vâlcea)', zip: '245304' },
  { city: 'Mosoroasa (Vâlcea)', zip: '245305' },
  { city: 'Olăneşti (Vâlcea)', zip: '245306' },
  { city: 'Pietrişu (Vâlcea)', zip: '245307' },
  { city: 'Tisa (Vâlcea)', zip: '245308' },
  { city: 'Bălceşti (Vâlcea)', zip: '245400' },
  { city: 'Beneşti (Vâlcea)', zip: '245401' },
  { city: 'Cârlogani (Vâlcea)', zip: '245402' },
  { city: 'Chirculeşti (Vâlcea)', zip: '245403' },
  { city: 'Goruneşti (Bălceşti) (Vâlcea)', zip: '245404' },
  { city: 'Irimeşti (Vâlcea)', zip: '245405' },
  { city: 'Otetelişu (Vâlcea)', zip: '245406' },
  { city: 'Preoteşti (Vâlcea)', zip: '245407' },
  { city: 'Satu Poieni (Vâlcea)', zip: '245408' },
  { city: 'Brezoi (Vâlcea)', zip: '245500' },
  { city: 'Călineşti (Vâlcea)', zip: '245501' },
  { city: 'Corbu (Vâlcea)', zip: '245502' },
  { city: 'Drăgăneşti (Brezoi) (Vâlcea)', zip: '245503' },
  { city: 'Golotreni (Vâlcea)', zip: '245504' },
  { city: 'Păscoaia (Vâlcea)', zip: '245505' },
  { city: 'Proieni (Vâlcea)', zip: '245506' },
  { city: 'Valea lui Stan (Vâlcea)', zip: '245507' },
  { city: 'Văratica (Vâlcea)', zip: '245508' },
  { city: 'Călimăneşti (Vâlcea)', zip: '245600' },
  { city: 'Căciulata (Vâlcea)', zip: '245601' },
  { city: 'Jiblea Nouă (Vâlcea)', zip: '245602' },
  { city: 'Jiblea Veche (Vâlcea)', zip: '245603' },
  { city: 'Păuşa (Vâlcea)', zip: '245604' },
  { city: 'Seaca (Călimăneşti) (Vâlcea)', zip: '245605' },
  { city: 'Drăgăşani (Vâlcea)', zip: '245700' },
  { city: 'Valea Caselor (Drăgăşani) (Vâlcea)', zip: '245701' },
  { city: 'Zărneni (Vâlcea)', zip: '245702' },
  { city: 'Zlătărei (Vâlcea)', zip: '245703' },
  { city: 'Horezu (Vâlcea)', zip: '245800' },
  { city: 'Ifrimeşti (Vâlcea)', zip: '245801' },
  { city: 'Râmeşti (Horezu) (Vâlcea)', zip: '245802' },
  { city: 'Romanii de Jos (Vâlcea)', zip: '245803' },
  { city: 'Romanii de Sus (Vâlcea)', zip: '245804' },
  { city: 'Tănăseşti (Vâlcea)', zip: '245805' },
  { city: 'Urşani (Vâlcea)', zip: '245806' },
  { city: 'Ocnele Mari (Vâlcea)', zip: '245900' },
  { city: 'Buda (Vâlcea)', zip: '245901' },
  { city: 'Cosota (Vâlcea)', zip: '245902' },
  { city: 'Făcăi (Vâlcea)', zip: '245903' },
  { city: 'Gura Suhaşului (Vâlcea)', zip: '245904' },
  { city: 'Lunca (Ocnele Mari) (Vâlcea)', zip: '245905' },
  { city: 'Ocniţa (Vâlcea)', zip: '245906' },
  { city: 'Slătioarele (Vâlcea)', zip: '245907' },
  { city: 'Ţeica (Vâlcea)', zip: '245908' },
  { city: 'Alunu (Vâlcea)', zip: '247005' },
  { city: 'Bodeşti (Alunu) (Vâlcea)', zip: '247006' },
  { city: 'Colţeşti (Vâlcea)', zip: '247007' },
  { city: 'Igoiu (Vâlcea)', zip: '247008' },
  { city: 'Ilaciu (Vâlcea)', zip: '247009' },
  { city: 'Ocracu (Vâlcea)', zip: '247011' },
  { city: 'Roşia (Vâlcea)', zip: '247012' },
  { city: 'Amărăşti (Vâlcea)', zip: '247015' },
  { city: 'Mereşeşti (Vâlcea)', zip: '247016' },
  { city: 'Nemoiu (Vâlcea)', zip: '247017' },
  { city: 'Padina (Vâlcea)', zip: '247018' },
  { city: 'Palanga (Vâlcea)', zip: '247019' },
  { city: 'Teiul (Vâlcea)', zip: '247021' },
  { city: 'Bărbăteşti (Vâlcea)', zip: '247025' },
  { city: 'Bârzeşti (Vâlcea)', zip: '247026' },
  { city: 'Bodeşti (Bărbăteşti) (Vâlcea)', zip: '247027' },
  { city: 'Negruleşti (Vâlcea)', zip: '247028' },
  { city: 'Berbeşti (Vâlcea)', zip: '247030' },
  { city: 'Dămţeni (Vâlcea)', zip: '247031' },
  { city: 'Dealu Aluniş (Vâlcea)', zip: '247032' },
  { city: 'Roşioara (Vâlcea)', zip: '247033' },
  { city: 'Târgu Gânguleşti (Vâlcea)', zip: '247034' },
  { city: 'Valea Mare (Berbeşti) (Vâlcea)', zip: '247036' },
  { city: 'Berislăveşti (Vâlcea)', zip: '247040' },
  { city: 'Brădişor (Vâlcea)', zip: '247041' },
  { city: 'Dângeşti (Vâlcea)', zip: '247042' },
  { city: 'Rădăcineşti (Vâlcea)', zip: '247043' },
  { city: 'Robaia (Vâlcea)', zip: '247044' },
  { city: 'Scăueni (Vâlcea)', zip: '247046' },
  { city: 'Stoeneşti (Berislăveşti) (Vâlcea)', zip: '247047' },
  { city: 'Boişoara (Vâlcea)', zip: '247050' },
  { city: 'Bumbueşti (Vâlcea)', zip: '247051' },
  { city: 'Găujani (Vâlcea)', zip: '247052' },
  { city: 'Budeşti (Vâlcea)', zip: '247055' },
  { city: 'Barza (Vâlcea)', zip: '247056' },
  { city: 'Bârseşti (Budeşti) (Vâlcea)', zip: '247057' },
  { city: 'Bercioiu (Vâlcea)', zip: '247058' },
  { city: 'Linia (Budeşti) (Vâlcea)', zip: '247059' },
  { city: 'Piscu Pietrei (Vâlcea)', zip: '247061' },
  { city: 'Racoviţa (Budeşti) (Vâlcea)', zip: '247062' },
  { city: 'Ruda (Vâlcea)', zip: '247063' },
  { city: 'Bujoreni (Vâlcea)', zip: '247065' },
  { city: 'Bogdăneşti (Bujoreni) (Vâlcea)', zip: '247066' },
  { city: 'Gura Văii (Vâlcea)', zip: '247067' },
  { city: 'Lunca (Bujoreni) (Vâlcea)', zip: '247068' },
  { city: 'Malu Alb (Vâlcea)', zip: '247069' },
  { city: 'Malu Vârtop (Vâlcea)', zip: '247071' },
  { city: 'Olteni (Vâlcea)', zip: '247072' },
  { city: 'Buneşti (Vâlcea)', zip: '247075' },
  { city: 'Coasta Mare (Vâlcea)', zip: '247076' },
  { city: 'Fireşti (Vâlcea)', zip: '247077' },
  { city: 'Râpăneşti (Vâlcea)', zip: '247078' },
  { city: 'Teiuşu (Vâlcea)', zip: '247079' },
  { city: 'Titireci (Vâlcea)', zip: '247081' },
  { city: 'Câineni (Vâlcea)', zip: '247085' },
  { city: 'Câinenii Mari (Vâlcea)', zip: '247086' },
  { city: 'Câinenii Mici (Vâlcea)', zip: '247087' },
  { city: 'Grebleşti (Vâlcea)', zip: '247088' },
  { city: 'Priloage (Vâlcea)', zip: '247089' },
  { city: 'Râu Vadului (Vâlcea)', zip: '247091' },
  { city: 'Robeşti (Vâlcea)', zip: '247092' },
  { city: 'Cernişoara (Vâlcea)', zip: '247095' },
  { city: 'Armăşeşti (Vâlcea)', zip: '247096' },
  { city: 'Groşi (Vâlcea)', zip: '247097' },
  { city: 'Mădulari (Cernişoara) (Vâlcea)', zip: '247098' },
  { city: 'Modoia (Vâlcea)', zip: '247099' },
  { city: 'Obârşia (Vâlcea)', zip: '247101' },
  { city: 'Sărsăneşti (Vâlcea)', zip: '247102' },
  { city: 'Copăceni (Vâlcea)', zip: '247105' },
  { city: 'Bălteni (Vâlcea)', zip: '247106' },
  { city: 'Bondoci (Vâlcea)', zip: '247107' },
  { city: 'Hotărasa (Vâlcea)', zip: '247108' },
  { city: 'Ulmetu (Vâlcea)', zip: '247109' },
  { city: 'Veţelu (Vâlcea)', zip: '247111' },
  { city: 'Costeşti (Vâlcea)', zip: '247115' },
  { city: 'Bistriţa (Vâlcea)', zip: '247116' },
  { city: 'Pietreni (Vâlcea)', zip: '247117' },
  { city: 'Văratici (Vâlcea)', zip: '247118' },
  { city: 'Creţeni (Vâlcea)', zip: '247120' },
  { city: 'Izvoru (Vâlcea)', zip: '247121' },
  { city: 'Mreneşti (Vâlcea)', zip: '247122' },
  { city: 'Streminoasa (Vâlcea)', zip: '247123' },
  { city: 'Dăeşti (Vâlcea)', zip: '247125' },
  { city: 'Băbueşti (Vâlcea)', zip: '247126' },
  { city: 'Fedeleşoiu (Vâlcea)', zip: '247127' },
  { city: 'Sânbotin (Vâlcea)', zip: '247128' },
  { city: 'Dănicei (Vâlcea)', zip: '247130' },
  { city: 'Bădeni (Vâlcea)', zip: '247131' },
  { city: 'Ceretu (Vâlcea)', zip: '247132' },
  { city: 'Cireşul (Vâlcea)', zip: '247133' },
  { city: 'Dealu Lăunele (Vâlcea)', zip: '247134' },
  { city: 'Dealu Scheiului (Vâlcea)', zip: '247136' },
  { city: 'Dobreşti (Vâlcea)', zip: '247137' },
  { city: 'Drăguleşti (Vâlcea)', zip: '247138' },
  { city: 'Glodu (Vâlcea)', zip: '247139' },
  { city: 'Gura Crucilor (Vâlcea)', zip: '247141' },
  { city: 'Lăunele de Jos (Vâlcea)', zip: '247142' },
  { city: 'Linia pe Vale (Vâlcea)', zip: '247143' },
  { city: 'Udreşti (Vâlcea)', zip: '247144' },
  { city: 'Valea Scheiului (Vâlcea)', zip: '247146' },
  { city: 'Drăgoeşti (Vâlcea)', zip: '247150' },
  { city: 'Buciumeni (Vâlcea)', zip: '247151' },
  { city: 'Geamăna (Drăgoeşti) (Vâlcea)', zip: '247152' },
  { city: 'Făureşti (Vâlcea)', zip: '247155' },
  { city: 'Băbeni-Olteţu (Vâlcea)', zip: '247156' },
  { city: 'Budeşti (Diculeşti) (Vâlcea)', zip: '247157' },
  { city: 'Bungeţani (Vâlcea)', zip: '247158' },
  { city: 'Colelia (Vâlcea)', zip: '247159' },
  { city: 'Diculeşti (Vâlcea)', zip: '247161' },
  { city: 'Găineşti (Vâlcea)', zip: '247162' },
  { city: 'Mărcuşu (Vâlcea)', zip: '247163' },
  { city: 'Mileşti (Vâlcea)', zip: '247164' },
  { city: 'Fârtăţeşti (Vâlcea)', zip: '247165' },
  { city: 'Afânata (Vâlcea)', zip: '247166' },
  { city: 'Becşani (Vâlcea)', zip: '247167' },
  { city: 'Căţetu (Vâlcea)', zip: '247168' },
  { city: 'Cuci (Vâlcea)', zip: '247169' },
  { city: 'Dăncăi (Vâlcea)', zip: '247171' },
  { city: 'Dejoi (Vâlcea)', zip: '247172' },
  { city: 'Dozeşti (Vâlcea)', zip: '247173' },
  { city: 'Gârnicet (Vâlcea)', zip: '247174' },
  { city: 'Giuleşti (Vâlcea)', zip: '247176' },
  { city: 'Giuleştii de Sus (Vâlcea)', zip: '247177' },
  { city: 'Măriceşti (Vâlcea)', zip: '247178' },
  { city: 'Nisipi (Vâlcea)', zip: '247179' },
  { city: 'Popeşti (Fârtăţeşti) (Vâlcea)', zip: '247181' },
  { city: 'Rusăneşti (Vâlcea)', zip: '247182' },
  { city: 'Seciu (Vâlcea)', zip: '247183' },
  { city: 'Stănculeşti (Vâlcea)', zip: '247184' },
  { city: 'Şotani (Vâlcea)', zip: '247186' },
  { city: 'Tanislavi (Vâlcea)', zip: '247187' },
  { city: 'Valea Ursului (Vâlcea)', zip: '247188' },
  { city: 'Frânceşti (Vâlcea)', zip: '247195' },
  { city: 'Băluţoaia (Vâlcea)', zip: '247196' },
  { city: 'Coşani (Vâlcea)', zip: '247197' },
  { city: 'Dezrobiţi (Vâlcea)', zip: '247198' },
  { city: 'Genuneni (Vâlcea)', zip: '247199' },
  { city: 'Mănăileşti (Vâlcea)', zip: '247201' },
  { city: 'Moşteni (Vâlcea)', zip: '247202' },
  { city: 'Surpatele (Vâlcea)', zip: '247203' },
  { city: 'Viişoara (Vâlcea)', zip: '247204' },
  { city: 'Galicea (Vâlcea)', zip: '247205' },
  { city: 'Bratia din Deal (Vâlcea)', zip: '247206' },
  { city: 'Bratia din Vale (Vâlcea)', zip: '247207' },
  { city: 'Cocoru (Vâlcea)', zip: '247208' },
  { city: 'Cremenari (Vâlcea)', zip: '247209' },
  { city: 'Dealu Mare (Galicea) (Vâlcea)', zip: '247211' },
  { city: 'Ostroveni (Vâlcea)', zip: '247212' },
  { city: 'Teiu (Vâlcea)', zip: '247213' },
  { city: 'Valea Râului (Vâlcea)', zip: '247214' },
  { city: 'Ghioroiu (Vâlcea)', zip: '247215' },
  { city: 'Căzăneşti (Ghioroiu) (Vâlcea)', zip: '247216' },
  { city: 'Herăşti (Vâlcea)', zip: '247217' },
  { city: 'Mierea (Vâlcea)', zip: '247218' },
  { city: 'Poienari (Vâlcea)', zip: '247219' },
  { city: 'Ştirbeşti (Vâlcea)', zip: '247221' },
  { city: 'Glăvile (Vâlcea)', zip: '247225' },
  { city: 'Aninoasa (Vâlcea)', zip: '247226' },
  { city: 'Jaroştea (Vâlcea)', zip: '247227' },
  { city: 'Olteanca (Glăvile) (Vâlcea)', zip: '247228' },
  { city: 'Voiculeasa (Vâlcea)', zip: '247229' },
  { city: 'Goleşti (Vâlcea)', zip: '247230' },
  { city: 'Aldeşti (Vâlcea)', zip: '247231' },
  { city: 'Blidari (Vâlcea)', zip: '247232' },
  { city: 'Coasta (Goleşti) (Vâlcea)', zip: '247233' },
  { city: 'Drăgăneşti (Goleşti) (Vâlcea)', zip: '247234' },
  { city: 'Gibeşti (Vâlcea)', zip: '247236' },
  { city: 'Giurgiuveni (Vâlcea)', zip: '247237' },
  { city: 'Opăteşti (Vâlcea)', zip: '247238' },
  { city: 'Poeniţa (Vâlcea)', zip: '247239' },
  { city: 'Popeşti (Goleşti) (Vâlcea)', zip: '247241' },
  { city: 'Tulei-Câmpeni (Vâlcea)', zip: '247242' },
  { city: 'Vătăşeşti (Vâlcea)', zip: '247243' },
  { city: 'Grădiştea (Vâlcea)', zip: '247250' },
  { city: 'Diaconeşti (Vâlcea)', zip: '247251' },
  { city: 'Dobricea (Vâlcea)', zip: '247252' },
  { city: 'Linia (Grădiştea) (Vâlcea)', zip: '247253' },
  { city: 'Obislavu (Vâlcea)', zip: '247254' },
  { city: 'Străchineşti (Vâlcea)', zip: '247256' },
  { city: 'Turburea (Vâlcea)', zip: '247257' },
  { city: 'Ţuţuru (Vâlcea)', zip: '247258' },
  { city: 'Valea Grădiştei (Vâlcea)', zip: '247259' },
  { city: 'Guşoeni (Vâlcea)', zip: '247260' },
  { city: 'Burdăleşti (Vâlcea)', zip: '247261' },
  { city: 'Dealu Mare (Guşoeni) (Vâlcea)', zip: '247262' },
  { city: 'Guşoianca (Vâlcea)', zip: '247263' },
  { city: 'Măgureni (Vâlcea)', zip: '247264' },
  { city: 'Spârleni (Vâlcea)', zip: '247266' },
  { city: 'Ioneşti (Vâlcea)', zip: '247270' },
  { city: 'Bucşani (Vâlcea)', zip: '247271' },
  { city: 'Dealu Mare (Ioneşti) (Vâlcea)', zip: '247272' },
  { city: 'Delureni (Ioneşti) (Vâlcea)', zip: '247273' },
  { city: 'Fişcălia (Vâlcea)', zip: '247274' },
  { city: 'Foteşti (Vâlcea)', zip: '247276' },
  { city: 'Guguianca (Vâlcea)', zip: '247277' },
  { city: 'Marcea (Vâlcea)', zip: '247278' },
  { city: 'Prodăneşti (Vâlcea)', zip: '247279' },
  { city: 'Laloşu (Vâlcea)', zip: '247280' },
  { city: 'Berbeşti (Laloşu) (Vâlcea)', zip: '247281' },
  { city: 'Ghindari (Vâlcea)', zip: '247282' },
  { city: 'Mologeşti (Vâlcea)', zip: '247283' },
  { city: 'Olteţani (Vâlcea)', zip: '247284' },
  { city: 'Portăreşti (Vâlcea)', zip: '247286' },
  { city: 'Lădeşti (Vâlcea)', zip: '247290' },
  { city: 'Cermegeşti (Lădeşti) (Vâlcea)', zip: '247291' },
  { city: 'Chiriceşti (Vâlcea)', zip: '247292' },
  { city: 'Ciumagi (Vâlcea)', zip: '247293' },
  { city: 'Dealu Corni (Vâlcea)', zip: '247294' },
  { city: 'Găgeni (Vâlcea)', zip: '247296' },
  { city: 'Măldăreşti (Lădeşti) (Vâlcea)', zip: '247297' },
  { city: 'Olteanca (Lădeşti) (Vâlcea)', zip: '247298' },
  { city: 'Păsculeşti (Vâlcea)', zip: '247299' },
  { city: 'Popeşti (Lădeşti) (Vâlcea)', zip: '247301' },
  { city: 'Lăpuşata (Vâlcea)', zip: '247305' },
  { city: 'Bereşti (Vâlcea)', zip: '247306' },
  { city: 'Broşteni (Vâlcea)', zip: '247307' },
  { city: 'Mijaţi (Vâlcea)', zip: '247308' },
  { city: 'Săruleşti (Vâlcea)', zip: '247309' },
  { city: 'Scoruşu (Vâlcea)', zip: '247311' },
  { city: 'Şerbăneşti (Lăpuşata) (Vâlcea)', zip: '247312' },
  { city: 'Zărneşti (Vâlcea)', zip: '247313' },
  { city: 'Livezi (Vâlcea)', zip: '247315' },
  { city: 'Părăuşani (Vâlcea)', zip: '247316' },
  { city: 'Pârâienii de Jos (Vâlcea)', zip: '247317' },
  { city: 'Pârâienii de Mijloc (Vâlcea)', zip: '247318' },
  { city: 'Pârâienii de Sus (Vâlcea)', zip: '247319' },
  { city: 'Pleşoiu (Livezi) (Vâlcea)', zip: '247321' },
  { city: 'Tina (Vâlcea)', zip: '247322' },
  { city: 'Lungeşti (Vâlcea)', zip: '247325' },
  { city: 'Carcadieşti (Vâlcea)', zip: '247326' },
  { city: 'Dumbrava (Vâlcea)', zip: '247327' },
  { city: 'Fumureni (Vâlcea)', zip: '247328' },
  { city: 'Gănţulei (Vâlcea)', zip: '247329' },
  { city: 'Stăneşti-Lunca (Vâlcea)', zip: '247331' },
  { city: 'Malaia (Vâlcea)', zip: '247335' },
  { city: 'Ciungetu (Vâlcea)', zip: '247336' },
  { city: 'Săliştea (Vâlcea)', zip: '247337' },
  { city: 'Mateeşti (Vâlcea)', zip: '247340' },
  { city: 'Greci (Vâlcea)', zip: '247341' },
  { city: 'Turceşti (Vâlcea)', zip: '247342' },
  { city: 'Măciuca (Vâlcea)', zip: '247345' },
  { city: 'Bocşa (Vâlcea)', zip: '247346' },
  { city: 'Botorani (Vâlcea)', zip: '247347' },
  { city: 'Ciocănari (Vâlcea)', zip: '247348' },
  { city: 'Măciuceni (Vâlcea)', zip: '247349' },
  { city: 'Măldăreşti (Măciuca) (Vâlcea)', zip: '247351' },
  { city: 'Oveselu (Vâlcea)', zip: '247352' },
  { city: 'Popeşti (Măciuca) (Vâlcea)', zip: '247353' },
  { city: 'Ştefăneşti (Măciuca) (Vâlcea)', zip: '247354' },
  { city: 'Zăvoieni (Vâlcea)', zip: '247356' },
  { city: 'Mădulari (Vâlcea)', zip: '247360' },
  { city: 'Bălşoara (Vâlcea)', zip: '247361' },
  { city: 'Bănţeşti (Vâlcea)', zip: '247362' },
  { city: 'Dimuleşti (Vâlcea)', zip: '247363' },
  { city: 'Iacovile (Vâlcea)', zip: '247364' },
  { city: 'Mamu (Vâlcea)', zip: '247366' },
  { city: 'Măldăreşti (Vâlcea)', zip: '247370' },
  { city: 'Măldăreştii de Jos (Vâlcea)', zip: '247371' },
  { city: 'Roşoveni (Vâlcea)', zip: '247372' },
  { city: 'Telecheşti (Vâlcea)', zip: '247373' },
  { city: 'Mihăeşti (Vâlcea)', zip: '247375' },
  { city: 'Arsanca (Vâlcea)', zip: '247376' },
  { city: 'Bârseşti (Mihăeşti) (Vâlcea)', zip: '247377' },
  { city: 'Buleta (Vâlcea)', zip: '247378' },
  { city: 'Govora (Vâlcea)', zip: '247379' },
  { city: 'Gurişoara (Vâlcea)', zip: '247381' },
  { city: 'Măgura (Vâlcea)', zip: '247382' },
  { city: 'Munteni (Vâlcea)', zip: '247383' },
  { city: 'Negreni (Vâlcea)', zip: '247384' },
  { city: 'Rugetu (Mihăeşti) (Vâlcea)', zip: '247386' },
  { city: 'Scărişoara (Vâlcea)', zip: '247387' },
  { city: 'Stupărei (Vâlcea)', zip: '247388' },
  { city: 'Vulpueşti (Vâlcea)', zip: '247389' },
  { city: 'Milcoiu (Vâlcea)', zip: '247395' },
  { city: 'Căzăneşti (Milcoiu) (Vâlcea)', zip: '247396' },
  { city: 'Ciuteşti (Vâlcea)', zip: '247397' },
  { city: 'Izbăşeşti (Vâlcea)', zip: '247398' },
  { city: 'Şuricaru (Vâlcea)', zip: '247399' },
  { city: 'Tepşenari (Vâlcea)', zip: '247401' },
  { city: 'Muereasca (Vâlcea)', zip: '247405' },
  { city: 'Andreieşti (Vâlcea)', zip: '247406' },
  { city: 'Frânceşti-Coasta (Vâlcea)', zip: '247407' },
  { city: 'Găvăneşti (Vâlcea)', zip: '247408' },
  { city: 'Hotarele (Vâlcea)', zip: '247409' },
  { city: 'Muereasca de Sus (Vâlcea)', zip: '247411' },
  { city: 'Pripoara (Vâlcea)', zip: '247412' },
  { city: 'Şuta (Vâlcea)', zip: '247413' },
  { city: 'Nicolae Bălcescu (Vâlcea)', zip: '247415' },
  { city: 'Băneşti (Vâlcea)', zip: '247416' },
  { city: 'Corbii din Vale (Vâlcea)', zip: '247417' },
  { city: 'Dosu Râului (Vâlcea)', zip: '247418' },
  { city: 'Gâltofani (Vâlcea)', zip: '247419' },
  { city: 'Ginerica (Vâlcea)', zip: '247421' },
  { city: 'Linia Hanului (Vâlcea)', zip: '247422' },
  { city: 'Măzăraru (Vâlcea)', zip: '247423' },
  { city: 'Mângureni (Vâlcea)', zip: '247424' },
  { city: 'Pleşoiu (Nicolae Bălcescu) (Vâlcea)', zip: '247426' },
  { city: 'Popeşti (Nicolae Bălcescu) (Vâlcea)', zip: '247427' },
  { city: 'Predeşti (Vâlcea)', zip: '247428' },
  { city: 'Rotărăşti (Vâlcea)', zip: '247429' },
  { city: 'Schitu (Vâlcea)', zip: '247431' },
  { city: 'Şerbăneasa (Vâlcea)', zip: '247432' },
  { city: 'Tufanii (Vâlcea)', zip: '247433' },
  { city: 'Valea Bălcească (Vâlcea)', zip: '247434' },
  { city: 'Valea Viei (Vâlcea)', zip: '247436' },
  { city: 'Olanu (Vâlcea)', zip: '247440' },
  { city: 'Casa Veche (Vâlcea)', zip: '247441' },
  { city: 'Cioboţi (Vâlcea)', zip: '247442' },
  { city: 'Drăgioiu (Vâlcea)', zip: '247443' },
  { city: 'Nicoleşti (Vâlcea)', zip: '247444' },
  { city: 'Stoicăneşti (Vâlcea)', zip: '247446' },
  { city: 'Orleşti (Vâlcea)', zip: '247450' },
  { city: 'Aureşti (Vâlcea)', zip: '247451' },
  { city: 'Procopoaia (Vâlcea)', zip: '247452' },
  { city: 'Scaioşi (Vâlcea)', zip: '247453' },
  { city: 'Silea (Vâlcea)', zip: '247454' },
  { city: 'Oteşani (Vâlcea)', zip: '247455' },
  { city: 'Bogdăneşti (Oteşani) (Vâlcea)', zip: '247456' },
  { city: 'Cârstăneşti (Vâlcea)', zip: '247457' },
  { city: 'Cuceşti (Vâlcea)', zip: '247458' },
  { city: 'Sub Deal (Vâlcea)', zip: '247459' },
  { city: 'Păuşeşti (Vâlcea)', zip: '247460' },
  { city: 'Barcanele (Vâlcea)', zip: '247461' },
  { city: 'Buzdugan (Vâlcea)', zip: '247462' },
  { city: 'Cernelele (Vâlcea)', zip: '247463' },
  { city: 'Păuşeşti-Otăsău (Vâlcea)', zip: '247464' },
  { city: 'Şerbăneşti (Păuşeşti) (Vâlcea)', zip: '247466' },
  { city: 'Şoliceşti (Vâlcea)', zip: '247467' },
  { city: 'Văleni (Păuşeşti) (Vâlcea)', zip: '247468' },
  { city: 'Păuşeşti-Măglaşi (Vâlcea)', zip: '247470' },
  { city: 'Coasta (Păuşeşti-Măglaşi) (Vâlcea)', zip: '247471' },
  { city: 'Pietrari (Păuşeşti-Măglaşi) (Vâlcea)', zip: '247472' },
  { city: 'Ulmeţel (Vâlcea)', zip: '247473' },
  { city: 'Valea Cheii (Vâlcea)', zip: '247474' },
  { city: 'Vlăduceni (Vâlcea)', zip: '247476' },
  { city: 'Perişani (Vâlcea)', zip: '247480' },
  { city: 'Băiaşu (Vâlcea)', zip: '247481' },
  { city: 'Bratoveşti (Vâlcea)', zip: '247482' },
  { city: 'Cucoiu (Vâlcea)', zip: '247483' },
  { city: 'Mlăceni (Vâlcea)', zip: '247484' },
  { city: 'Podeni (Vâlcea)', zip: '247486' },
  { city: 'Poiana (Vâlcea)', zip: '247487' },
  { city: 'Pripoare (Vâlcea)', zip: '247488' },
  { city: 'Spinu (Vâlcea)', zip: '247489' },
  { city: 'Surdoiu (Vâlcea)', zip: '247491' },
  { city: 'Titeşti (Vâlcea)', zip: '247492' },
  { city: 'Pesceana (Vâlcea)', zip: '247500' },
  { city: 'Cermegeşti (Pesceana) (Vâlcea)', zip: '247501' },
  { city: 'Lupoaia (Vâlcea)', zip: '247502' },
  { city: 'Negraia (Vâlcea)', zip: '247503' },
  { city: 'Roeşti (Pesceana) (Vâlcea)', zip: '247504' },
  { city: 'Ursoaia (Vâlcea)', zip: '247506' },
  { city: 'Pietrari (Vâlcea)', zip: '247510' },
  { city: 'Pietrarii de Sus (Vâlcea)', zip: '247511' },
  { city: 'Popeşti (Vâlcea)', zip: '247515' },
  { city: 'Curtea (Vâlcea)', zip: '247516' },
  { city: 'Dăeşti (Popeşti) (Vâlcea)', zip: '247517' },
  { city: 'Firijba (Vâlcea)', zip: '247518' },
  { city: 'Meieni (Vâlcea)', zip: '247519' },
  { city: 'Urşi (Popeşti) (Vâlcea)', zip: '247521' },
  { city: 'Valea Caselor (Popeşti) (Vâlcea)', zip: '247522' },
  { city: 'Prundeni (Vâlcea)', zip: '247525' },
  { city: 'Bărbuceni (Vâlcea)', zip: '247526' },
  { city: 'Călina (Vâlcea)', zip: '247527' },
  { city: 'Zăvideni (Vâlcea)', zip: '247528' },
  { city: 'Racoviţa (Vâlcea)', zip: '247530' },
  { city: 'Balota (Vâlcea)', zip: '247531' },
  { city: 'Blănoiu (Vâlcea)', zip: '247532' },
  { city: 'Bradu-Clocotici (Vâlcea)', zip: '247533' },
  { city: 'Copăceni (Racoviţa) (Vâlcea)', zip: '247534' },
  { city: 'Gruiu Lupului (Vâlcea)', zip: '247536' },
  { city: 'Tuţuleşti (Vâlcea)', zip: '247537' },
  { city: 'Roeşti (Vâlcea)', zip: '247540' },
  { city: 'Băiaşa (Vâlcea)', zip: '247541' },
  { city: 'Băjenari (Vâlcea)', zip: '247542' },
  { city: 'Bărbărigeni (Vâlcea)', zip: '247543' },
  { city: 'Ciocâltei (Vâlcea)', zip: '247544' },
  { city: 'Cueni (Vâlcea)', zip: '247546' },
  { city: 'Frasina (Vâlcea)', zip: '247547' },
  { city: 'Piscu Scoarţei (Vâlcea)', zip: '247548' },
  { city: 'Râpa Cărămizii (Vâlcea)', zip: '247549' },
  { city: 'Saioci (Vâlcea)', zip: '247551' },
  { city: 'Roşiile (Vâlcea)', zip: '247555' },
  { city: 'Balaciu (Vâlcea)', zip: '247556' },
  { city: 'Cherăşti (Vâlcea)', zip: '247557' },
  { city: 'Hotăroaia (Vâlcea)', zip: '247558' },
  { city: 'Lupuieşti (Vâlcea)', zip: '247559' },
  { city: 'Păsărei (Vâlcea)', zip: '247561' },
  { city: 'Perteşti (Vâlcea)', zip: '247562' },
  { city: 'Pleşeşti (Vâlcea)', zip: '247563' },
  { city: 'Răţăleşti (Vâlcea)', zip: '247564' },
  { city: 'Romaneşti (Vâlcea)', zip: '247566' },
  { city: 'Zgubea (Vâlcea)', zip: '247567' },
  { city: 'Runcu (Vâlcea)', zip: '247575' },
  { city: 'Căligi (Vâlcea)', zip: '247576' },
  { city: 'Gropeni (Vâlcea)', zip: '247577' },
  { city: 'Snamăna (Vâlcea)', zip: '247578' },
  { city: 'Surpaţi (Vâlcea)', zip: '247579' },
  { city: 'Valea Babei (Vâlcea)', zip: '247581' },
  { city: 'Vărateci (Vâlcea)', zip: '247582' },
  { city: 'Sălătrucel (Vâlcea)', zip: '247585' },
  { city: 'Păteşti (Vâlcea)', zip: '247586' },
  { city: 'Seaca (Sălătrucel) (Vâlcea)', zip: '247587' },
  { city: 'Şerbăneşti (Sălătrucel) (Vâlcea)', zip: '247588' },
  { city: 'Scundu (Vâlcea)', zip: '247590' },
  { city: 'Avrămeşti (Vâlcea)', zip: '247591' },
  { city: 'Blejani (Vâlcea)', zip: '247592' },
  { city: 'Crângu (Vâlcea)', zip: '247593' },
  { city: 'Sineşti (Vâlcea)', zip: '247595' },
  { city: 'Ciucheţi (Vâlcea)', zip: '247596' },
  { city: 'Dealu Bisericii (Vâlcea)', zip: '247597' },
  { city: 'Mijlocu (Vâlcea)', zip: '247598' },
  { city: 'Popeşti (Sineşti) (Vâlcea)', zip: '247599' },
  { city: 'Urzica (Vâlcea)', zip: '247601' },
  { city: 'Slătioara (Vâlcea)', zip: '247605' },
  { city: 'Coasta Cerbului (Vâlcea)', zip: '247606' },
  { city: 'Goruneşti (Slătioara) (Vâlcea)', zip: '247607' },
  { city: 'Milostea (Vâlcea)', zip: '247608' },
  { city: 'Mogeşti (Vâlcea)', zip: '247609' },
  { city: 'Rugetu (Slătioara) (Vâlcea)', zip: '247611' },
  { city: 'Stăneşti (Vâlcea)', zip: '247615' },
  { city: 'Bărcăneşti (Vâlcea)', zip: '247616' },
  { city: 'Cioponeşti (Vâlcea)', zip: '247617' },
  { city: 'Cuculeşti (Vâlcea)', zip: '247618' },
  { city: 'Gârnicetu (Vâlcea)', zip: '247619' },
  { city: 'Linia Dealului (Vâlcea)', zip: '247621' },
  { city: 'Suieşti (Vâlcea)', zip: '247622' },
  { city: 'Valea Lungă (Vâlcea)', zip: '247623' },
  { city: 'Vârleni (Vâlcea)', zip: '247624' },
  { city: 'Stoeneşti (Vâlcea)', zip: '247625' },
  { city: 'Bârlogu (Vâlcea)', zip: '247626' },
  { city: 'Budurăşti (Vâlcea)', zip: '247627' },
  { city: 'Deleni (Vâlcea)', zip: '247628' },
  { city: 'Dobriceni (Vâlcea)', zip: '247629' },
  { city: 'Gruieri (Vâlcea)', zip: '247631' },
  { city: 'Gruiu (Vâlcea)', zip: '247632' },
  { city: 'Mogoşeşti (Vâlcea)', zip: '247633' },
  { city: 'Neghineşti (Vâlcea)', zip: '247634' },
  { city: 'Piscu Mare (Vâlcea)', zip: '247636' },
  { city: 'Popeşti (Stoeneşti) (Vâlcea)', zip: '247637' },
  { city: 'Suseni (Vâlcea)', zip: '247638' },
  { city: 'Zmeurătu (Vâlcea)', zip: '247639' },
  { city: 'Stoileşti (Vâlcea)', zip: '247645' },
  { city: 'Balomireasa (Vâlcea)', zip: '247646' },
  { city: 'Bârsoiu (Vâlcea)', zip: '247647' },
  { city: 'Bulagei (Vâlcea)', zip: '247648' },
  { city: 'Delureni (Stoileşti) (Vâlcea)', zip: '247649' },
  { city: 'Geamăna (Stoileşti) (Vâlcea)', zip: '247651' },
  { city: 'Ghiobeşti (Vâlcea)', zip: '247652' },
  { city: 'Giuroiu (Vâlcea)', zip: '247653' },
  { city: 'Izvoru Rece (Stoileşti) (Vâlcea)', zip: '247654' },
  { city: 'Malu (Vâlcea)', zip: '247656' },
  { city: 'Neţeşti (Vâlcea)', zip: '247657' },
  { city: 'Obogeni (Vâlcea)', zip: '247658' },
  { city: 'Stăneşti (Stoileşti) (Vâlcea)', zip: '247659' },
  { city: 'Urşi (Stoileşti) (Vâlcea)', zip: '247661' },
  { city: 'Vlăduleşti (Vâlcea)', zip: '247662' },
  { city: 'Stroeşti (Vâlcea)', zip: '247665' },
  { city: 'Cireşu (Vâlcea)', zip: '247666' },
  { city: 'Dianu (Vâlcea)', zip: '247667' },
  { city: 'Obroceşti (Vâlcea)', zip: '247668' },
  { city: 'Pojogi-Cerna (Vâlcea)', zip: '247669' },
  { city: 'Suteşti (Vâlcea)', zip: '247670' },
  { city: 'Boroşeşti (Vâlcea)', zip: '247671' },
  { city: 'Cetăţeaua (Vâlcea)', zip: '247672' },
  { city: 'Izvoraşu (Vâlcea)', zip: '247673' },
  { city: 'Măzili (Vâlcea)', zip: '247674' },
  { city: 'Mitrofani (Vâlcea)', zip: '247676' },
  { city: 'Racu (Vâlcea)', zip: '247677' },
  { city: 'Verdea (Vâlcea)', zip: '247678' },
  { city: 'Şirineasa (Vâlcea)', zip: '247680' },
  { city: 'Aricioaia (Vâlcea)', zip: '247681' },
  { city: 'Ciorăşti (Vâlcea)', zip: '247682' },
  { city: 'Slăviteşti (Vâlcea)', zip: '247683' },
  { city: 'Valea Alunişului (Vâlcea)', zip: '247684' },
  { city: 'Ştefăneşti (Vâlcea)', zip: '247685' },
  { city: 'Condoieşti (Vâlcea)', zip: '247686' },
  { city: 'Dobruşa (Vâlcea)', zip: '247687' },
  { city: 'Şerbăneşti (Ştefăneşti) (Vâlcea)', zip: '247688' },
  { city: 'Şuşani (Vâlcea)', zip: '247690' },
  { city: 'Râmeşti (Şuşani) (Vâlcea)', zip: '247691' },
  { city: 'Sârbi (Vâlcea)', zip: '247692' },
  { city: 'Stoiculeşti (Vâlcea)', zip: '247693' },
  { city: 'Uşurei (Vâlcea)', zip: '247694' },
  { city: 'Tetoiu (Vâlcea)', zip: '247695' },
  { city: 'Băroiu (Vâlcea)', zip: '247696' },
  { city: 'Budele (Vâlcea)', zip: '247697' },
  { city: 'Măneasa (Vâlcea)', zip: '247698' },
  { city: 'Nenciuleşti (Vâlcea)', zip: '247699' },
  { city: 'Popeşti (Tetoiu) (Vâlcea)', zip: '247701' },
  { city: 'Ţepeşti (Vâlcea)', zip: '247702' },
  { city: 'Tomşani (Vâlcea)', zip: '247705' },
  { city: 'Bălţăţeni (Vâlcea)', zip: '247706' },
  { city: 'Bogdăneşti (Tomşani) (Vâlcea)', zip: '247707' },
  { city: 'Chiceni (Vâlcea)', zip: '247708' },
  { city: 'Dumbrăveşti (Vâlcea)', zip: '247709' },
  { city: 'Foleştii de Jos (Vâlcea)', zip: '247711' },
  { city: 'Mireşti (Vâlcea)', zip: '247712' },
  { city: 'Foleştii de Sus (Vâlcea)', zip: '247715' },
  { city: 'Vaideeni (Vâlcea)', zip: '247725' },
  { city: 'Cerna (Vâlcea)', zip: '247726' },
  { city: 'Cornet (Vâlcea)', zip: '247727' },
  { city: 'Izvoru Rece (Vaideeni) (Vâlcea)', zip: '247728' },
  { city: 'Mariţa (Vâlcea)', zip: '247729' },
  { city: 'Valea Mare (Vâlcea)', zip: '247730' },
  { city: 'Bătăşani (Vâlcea)', zip: '247731' },
  { city: 'Delureni (Valea Mare) (Vâlcea)', zip: '247732' },
  { city: 'Drăganu (Vâlcea)', zip: '247733' },
  { city: 'Mărgineni (Vâlcea)', zip: '247734' },
  { city: 'Pietroasa (Vâlcea)', zip: '247736' },
  { city: 'Vlădeşti (Vâlcea)', zip: '247740' },
  { city: 'Fundătura (Vâlcea)', zip: '247741' },
  { city: 'Pleaşa (Vâlcea)', zip: '247742' },
  { city: 'Priporu (Vâlcea)', zip: '247743' },
  { city: 'Trundin (Vâlcea)', zip: '247744' },
  { city: 'Voiceşti (Vâlcea)', zip: '247745' },
  { city: 'Tighina (Vâlcea)', zip: '247746' },
  { city: 'Voiceştii din Vale (Vâlcea)', zip: '247747' },
  { city: 'Voineasa (Vâlcea)', zip: '247750' },
  { city: 'Valea Măceşului (Vâlcea)', zip: '247751' },
  { city: 'Voineşiţa (Vâlcea)', zip: '247752' },
  { city: 'Zătreni (Vâlcea)', zip: '247755' },
  { city: 'Butanu (Vâlcea)', zip: '247756' },
  { city: 'Ciorteşti (Vâlcea)', zip: '247757' },
  { city: 'Contea (Vâlcea)', zip: '247758' },
  { city: 'Dealu Glămeia (Vâlcea)', zip: '247759' },
  { city: 'Dealu Văleni (Vâlcea)', zip: '247761' },
  { city: 'Făureşti (Zătreni) (Vâlcea)', zip: '247762' },
  { city: 'Găneşti (Vâlcea)', zip: '247763' },
  { city: 'Lăcusteni (Vâlcea)', zip: '247764' },
  { city: 'Lăcustenii de Jos (Vâlcea)', zip: '247766' },
  { city: 'Lăcustenii de Sus (Vâlcea)', zip: '247767' },
  { city: 'Mănicea (Vâlcea)', zip: '247768' },
  { city: 'Mecea (Vâlcea)', zip: '247769' },
  { city: 'Olteţu (Vâlcea)', zip: '247771' },
  { city: 'Săşcioara (Vâlcea)', zip: '247772' },
  { city: 'Stanomiru (Vâlcea)', zip: '247773' },
  { city: 'Valea Văleni (Vâlcea)', zip: '247774' },
  { city: 'Văleni (Zătreni) (Vâlcea)', zip: '247776' },
  { city: 'Zătrenii de Sus (Vâlcea)', zip: '247777' },
  { city: 'Mândreşti-Moldova (Vrancea)', zip: '620001' },
  { city: 'Mândreşti-Munteni (Vrancea)', zip: '620002' },
  { city: 'Focşani (Vrancea)', zip: '620003' },
  { city: 'Adjud (Vrancea)', zip: '625100' },
  { city: 'Adjudu Vechi (Vrancea)', zip: '625101' },
  { city: 'Burcioaia (Vrancea)', zip: '625102' },
  { city: 'Şişcani (Vrancea)', zip: '625103' },
  { city: 'Mărăşeşti (Vrancea)', zip: '625200' },
  { city: 'Călimăneşti (Vrancea)', zip: '625201' },
  { city: 'Haret (Vrancea)', zip: '625202' },
  { city: 'Modruzeni (Vrancea)', zip: '625203' },
  { city: 'Pădureni (Mărăşeşti) (Vrancea)', zip: '625204' },
  { city: 'Siretu (Vrancea)', zip: '625205' },
  { city: 'Tişiţa (Vrancea)', zip: '625206' },
  { city: 'Odobeşti (Vrancea)', zip: '625300' },
  { city: 'Unirea (Vrancea)', zip: '625301' },
  { city: 'Panciu (Vrancea)', zip: '625400' },
  { city: 'Crucea de Jos (Vrancea)', zip: '625401' },
  { city: 'Crucea de Sus (Vrancea)', zip: '625402' },
  { city: 'Dumbrava (Panciu) (Vrancea)', zip: '625403' },
  { city: 'Neicu (Vrancea)', zip: '625404' },
  { city: 'Satu Nou (Panciu) (Vrancea)', zip: '625405' },
  { city: 'Andreiaşu de Jos (Vrancea)', zip: '627005' },
  { city: 'Andreiaşu de Sus (Vrancea)', zip: '627006' },
  { city: 'Arşiţa (Vrancea)', zip: '627007' },
  { city: 'Fetig (Vrancea)', zip: '627008' },
  { city: 'Hotaru (Vrancea)', zip: '627009' },
  { city: 'Răchitaşu (Vrancea)', zip: '627011' },
  { city: 'Titila (Vrancea)', zip: '627012' },
  { city: 'Băleşti (Vrancea)', zip: '627015' },
  { city: 'Bârseşti (Vrancea)', zip: '627020' },
  { city: 'Negrileşti (Vrancea)', zip: '627021' },
  { city: 'Topeşti (Vrancea)', zip: '627022' },
  { city: 'Bogheşti (Vrancea)', zip: '627025' },
  { city: 'Bicheşti (Vrancea)', zip: '627026' },
  { city: 'Bogheştii de Sus (Vrancea)', zip: '627027' },
  { city: 'Chiţcani (Vrancea)', zip: '627028' },
  { city: 'Iugani (Vrancea)', zip: '627029' },
  { city: 'Plăcinţeni (Vrancea)', zip: '627031' },
  { city: 'Pleşeşti (Vrancea)', zip: '627032' },
  { city: 'Prisecani (Vrancea)', zip: '627033' },
  { city: 'Tăbuceşti (Vrancea)', zip: '627034' },
  { city: 'Boloteşti (Vrancea)', zip: '627035' },
  { city: 'Găgeşti (Vrancea)', zip: '627036' },
  { city: 'Ivănceşti (Vrancea)', zip: '627037' },
  { city: 'Pietroasa (Boloteşti) (Vrancea)', zip: '627038' },
  { city: 'Putna (Vrancea)', zip: '627039' },
  { city: 'Vităneştii de sub Măgură (Vrancea)', zip: '627041' },
  { city: 'Bordeşti (Vrancea)', zip: '627045' },
  { city: 'Bordeştii de Jos (Vrancea)', zip: '627046' },
  { city: 'Broşteni (Vrancea)', zip: '627050' },
  { city: 'Arva (Vrancea)', zip: '627051' },
  { city: 'Pituluşa (Vrancea)', zip: '627052' },
  { city: 'Câmpineanca (Vrancea)', zip: '627055' },
  { city: 'Pietroasa (Câmpineanca) (Vrancea)', zip: '627056' },
  { city: 'Vâlcele (Vrancea)', zip: '627057' },
  { city: 'Câmpuri (Vrancea)', zip: '627060' },
  { city: 'Feteşti (Vrancea)', zip: '627061' },
  { city: 'Gura Văii (Vrancea)', zip: '627062' },
  { city: 'Rotileştii Mari (Vrancea)', zip: '627063' },
  { city: 'Rotileştii Mici (Vrancea)', zip: '627064' },
  { city: 'Cârligele (Vrancea)', zip: '627065' },
  { city: 'Blidari (Cârligele) (Vrancea)', zip: '627066' },
  { city: 'Bonţeşti (Vrancea)', zip: '627067' },
  { city: 'Dălhăuţi (Vrancea)', zip: '627068' },
  { city: 'Chiojdeni (Vrancea)', zip: '627070' },
  { city: 'Cătăuţi (Vrancea)', zip: '627071' },
  { city: 'Lojniţa (Vrancea)', zip: '627072' },
  { city: 'Luncile (Vrancea)', zip: '627073' },
  { city: 'Mărăcini (Vrancea)', zip: '627074' },
  { city: 'Podurile (Vrancea)', zip: '627076' },
  { city: 'Seciu (Vrancea)', zip: '627077' },
  { city: 'Tulburea (Vrancea)', zip: '627078' },
  { city: 'Ciorăşti (Vrancea)', zip: '627080' },
  { city: 'Codreşti (Vrancea)', zip: '627081' },
  { city: 'Mihălceni (Vrancea)', zip: '627082' },
  { city: 'Salcia Nouă (Vrancea)', zip: '627083' },
  { city: 'Salcia Veche (Vrancea)', zip: '627084' },
  { city: 'Satu Nou (Ciorăşti) (Vrancea)', zip: '627086' },
  { city: 'Spătăreasa (Vrancea)', zip: '627087' },
  { city: 'Corbiţa (Vrancea)', zip: '627090' },
  { city: 'Buda (Vrancea)', zip: '627091' },
  { city: 'Izvoarele (Vrancea)', zip: '627092' },
  { city: 'Lărgăşeni (Vrancea)', zip: '627093' },
  { city: 'Ocheşeşti (Vrancea)', zip: '627094' },
  { city: 'Rădăcineşti (Vrancea)', zip: '627096' },
  { city: 'Şerbăneşti (Vrancea)', zip: '627097' },
  { city: 'Tuţu (Vrancea)', zip: '627098' },
  { city: 'Vâlcelele (Vrancea)', zip: '627099' },
  { city: 'Coteşti (Vrancea)', zip: '627100' },
  { city: 'Budeşti (Vrancea)', zip: '627101' },
  { city: 'Goleştii de Sus (Vrancea)', zip: '627102' },
  { city: 'Valea Coteşti (Vrancea)', zip: '627103' },
  { city: 'Dumbrăveni (Vrancea)', zip: '627105' },
  { city: 'Alexandru Vlahuţă (Vrancea)', zip: '627106' },
  { city: 'Cândeşti (Vrancea)', zip: '627107' },
  { city: 'Dragosloveni (Dumbrăveni) (Vrancea)', zip: '627108' },
  { city: 'Dumitreşti (Vrancea)', zip: '627110' },
  { city: 'Biceştii de Jos (Vrancea)', zip: '627111' },
  { city: 'Biceştii de Sus (Vrancea)', zip: '627112' },
  { city: 'Blidari (Dumitreşti) (Vrancea)', zip: '627113' },
  { city: 'Dumitreştii de Sus (Vrancea)', zip: '627114' },
  { city: 'Dumitreştii-Faţă (Vrancea)', zip: '627116' },
  { city: 'Găloieşti (Vrancea)', zip: '627117' },
  { city: 'Lăstuni (Vrancea)', zip: '627118' },
  { city: 'Lupoaia (Vrancea)', zip: '627119' },
  { city: 'Motnău (Vrancea)', zip: '627121' },
  { city: 'Poieniţa (Vrancea)', zip: '627122' },
  { city: 'Roşcari (Vrancea)', zip: '627123' },
  { city: 'Siminoc (Vrancea)', zip: '627124' },
  { city: 'Tinoasa (Vrancea)', zip: '627126' },
  { city: 'Trestia (Vrancea)', zip: '627127' },
  { city: 'Valea Mică (Vrancea)', zip: '627128' },
  { city: 'Fitioneşti (Vrancea)', zip: '627135' },
  { city: 'Ciolăneşti (Vrancea)', zip: '627136' },
  { city: 'Ghimiceşti (Vrancea)', zip: '627137' },
  { city: 'Holbăneşti (Vrancea)', zip: '627138' },
  { city: 'Mănăstioara (Vrancea)', zip: '627139' },
  { city: 'Garoafa (Vrancea)', zip: '627140' },
  { city: 'Bizigheşti (Vrancea)', zip: '627141' },
  { city: 'Ciuşlea (Vrancea)', zip: '627142' },
  { city: 'Doaga (Vrancea)', zip: '627143' },
  { city: 'Făurei (Vrancea)', zip: '627144' },
  { city: 'Precistanu (Vrancea)', zip: '627146' },
  { city: 'Răchitosu (Vrancea)', zip: '627147' },
  { city: 'Străjescu (Vrancea)', zip: '627148' },
  { city: 'Goleşti (Vrancea)', zip: '627150' },
  { city: 'Ceardac (Vrancea)', zip: '627151' },
  { city: 'Gugeşti (Vrancea)', zip: '627155' },
  { city: 'Oreavu (Vrancea)', zip: '627156' },
  { city: 'Gura Caliţei (Vrancea)', zip: '627160' },
  { city: 'Bălăneşti (Vrancea)', zip: '627161' },
  { city: 'Cocoşari (Vrancea)', zip: '627162' },
  { city: 'Dealu Lung (Vrancea)', zip: '627163' },
  { city: 'Groapa Tufei (Vrancea)', zip: '627164' },
  { city: 'Lacu lui Baban (Vrancea)', zip: '627166' },
  { city: 'Plopu (Vrancea)', zip: '627167' },
  { city: 'Poenile (Vrancea)', zip: '627168' },
  { city: 'Raşca (Vrancea)', zip: '627169' },
  { city: 'Şotârcari (Vrancea)', zip: '627171' },
  { city: 'Homocea (Vrancea)', zip: '627175' },
  { city: 'Argea (Vrancea)', zip: '627176' },
  { city: 'Costişa (Homocea) (Vrancea)', zip: '627177' },
  { city: 'Lespezi (Vrancea)', zip: '627178' },
  { city: 'Ploscuţeni (Vrancea)', zip: '627179' },
  { city: 'Jariştea (Vrancea)', zip: '627180' },
  { city: 'Pădureni (Jariştea) (Vrancea)', zip: '627181' },
  { city: 'Scânteia (Vrancea)', zip: '627182' },
  { city: 'Vărsătura (Vrancea)', zip: '627183' },
  { city: 'Jitia (Vrancea)', zip: '627185' },
  { city: 'Cerbu (Vrancea)', zip: '627186' },
  { city: 'Dealu Sării (Vrancea)', zip: '627187' },
  { city: 'Jitia de Jos (Vrancea)', zip: '627188' },
  { city: 'Măgura (Vrancea)', zip: '627189' },
  { city: 'Măicăneşti (Vrancea)', zip: '627190' },
  { city: 'Belciugele (Vrancea)', zip: '627191' },
  { city: 'Râmniceni (Vrancea)', zip: '627192' },
  { city: 'Slobozia Boteşti (Vrancea)', zip: '627193' },
  { city: 'Stupina (Vrancea)', zip: '627194' },
  { city: 'Tătaru (Vrancea)', zip: '627196' },
  { city: 'Mera (Vrancea)', zip: '627200' },
  { city: 'Livada (Vrancea)', zip: '627201' },
  { city: 'Milcovel (Vrancea)', zip: '627202' },
  { city: 'Roşioara (Vrancea)', zip: '627203' },
  { city: 'Vulcăneasa (Vrancea)', zip: '627204' },
  { city: 'Milcovul (Vrancea)', zip: '627205' },
  { city: 'Gologanu (Vrancea)', zip: '627206' },
  { city: 'Lămoteşti (Vrancea)', zip: '627207' },
  { city: 'Răstoaca (Vrancea)', zip: '627208' },
  { city: 'Moviliţa (Vrancea)', zip: '627210' },
  { city: 'Diocheţi-Rediu (Vrancea)', zip: '627211' },
  { city: 'Frecăţei (Vrancea)', zip: '627212' },
  { city: 'Trotuşanu (Vrancea)', zip: '627213' },
  { city: 'Văleni (Moviliţa) (Vrancea)', zip: '627214' },
  { city: 'Năneşti (Vrancea)', zip: '627215' },
  { city: 'Călienii Noi (Vrancea)', zip: '627216' },
  { city: 'Călienii Vechi (Vrancea)', zip: '627217' },
  { city: 'Năruja (Vrancea)', zip: '627220' },
  { city: 'Podu Nărujei (Vrancea)', zip: '627221' },
  { city: 'Podu Stoica (Vrancea)', zip: '627222' },
  { city: 'Rebegari (Vrancea)', zip: '627223' },
  { city: 'Nereju (Vrancea)', zip: '627225' },
  { city: 'Brădăceşti (Vrancea)', zip: '627226' },
  { city: 'Chiricani (Vrancea)', zip: '627227' },
  { city: 'Nereju Mic (Vrancea)', zip: '627228' },
  { city: 'Sahastru (Vrancea)', zip: '627229' },
  { city: 'Nistoreşti (Vrancea)', zip: '627230' },
  { city: 'Bâtcari (Vrancea)', zip: '627231' },
  { city: 'Brădetu (Vrancea)', zip: '627232' },
  { city: 'Făgetu (Vrancea)', zip: '627233' },
  { city: 'Podu Şchiopului (Vrancea)', zip: '627234' },
  { city: 'Româneşti (Vrancea)', zip: '627236' },
  { city: 'Ungureni (Vrancea)', zip: '627237' },
  { city: 'Valea Neagră (Vrancea)', zip: '627238' },
  { city: 'Vetreşti-Herăstrău (Vrancea)', zip: '627239' },
  { city: 'Paltin (Vrancea)', zip: '627240' },
  { city: 'Carşocheşti-Corăbiţa (Vrancea)', zip: '627241' },
  { city: 'Ghebari (Vrancea)', zip: '627242' },
  { city: 'Morăreşti (Vrancea)', zip: '627243' },
  { city: 'Păvălari (Vrancea)', zip: '627244' },
  { city: 'Prahuda (Vrancea)', zip: '627246' },
  { city: 'Spulber (Vrancea)', zip: '627247' },
  { city: 'Tojanii de Jos (Vrancea)', zip: '627248' },
  { city: 'Tojanii de Sus (Vrancea)', zip: '627249' },
  { city: 'Ţepa (Vrancea)', zip: '627251' },
  { city: 'Ţipău (Vrancea)', zip: '627252' },
  { city: 'Vâlcani (Vrancea)', zip: '627253' },
  { city: 'Păuneşti (Vrancea)', zip: '627260' },
  { city: 'Viişoara (Păuneşti) (Vrancea)', zip: '627261' },
  { city: 'Poiana Cristei (Vrancea)', zip: '627265' },
  { city: 'Dealu Cucului (Vrancea)', zip: '627266' },
  { city: 'Dumbrava (Poiana Cristei) (Vrancea)', zip: '627267' },
  { city: 'Mahriu (Vrancea)', zip: '627268' },
  { city: 'Odobasca (Vrancea)', zip: '627269' },
  { city: 'Petreanu (Vrancea)', zip: '627271' },
  { city: 'Podu Lacului (Vrancea)', zip: '627272' },
  { city: 'Târâtu (Vrancea)', zip: '627273' },
  { city: 'Pufeşti (Vrancea)', zip: '627275' },
  { city: 'Ciorani (Vrancea)', zip: '627276' },
  { city: 'Domneşti-Sat (Vrancea)', zip: '627277' },
  { city: 'Domneşti-Târg (Vrancea)', zip: '627278' },
  { city: 'Răcoasa (Vrancea)', zip: '627280' },
  { city: 'Gogoiu (Vrancea)', zip: '627281' },
  { city: 'Mărăşti (Vrancea)', zip: '627282' },
  { city: 'Varniţa (Vrancea)', zip: '627283' },
  { city: 'Verdea (Vrancea)', zip: '627284' },
  { city: 'Reghiu (Vrancea)', zip: '627285' },
  { city: 'Farcaş (Vrancea)', zip: '627286' },
  { city: 'Jgheaburi (Vrancea)', zip: '627287' },
  { city: 'Piscu Reghiului (Vrancea)', zip: '627288' },
  { city: 'Răiuţi (Vrancea)', zip: '627289' },
  { city: 'Şindrilari (Vrancea)', zip: '627291' },
  { city: 'Ursoaia (Vrancea)', zip: '627292' },
  { city: 'Valea Milcovului (Vrancea)', zip: '627293' },
  { city: 'Rugineşti (Vrancea)', zip: '627295' },
  { city: 'Angheleşti (Vrancea)', zip: '627296' },
  { city: 'Copăceşti (Vrancea)', zip: '627297' },
  { city: 'Văleni (Rugineşti) (Vrancea)', zip: '627298' },
  { city: 'Sihlea (Vrancea)', zip: '627300' },
  { city: 'Bogza (Vrancea)', zip: '627301' },
  { city: 'Căiata (Vrancea)', zip: '627302' },
  { city: 'Voetin (Vrancea)', zip: '627303' },
  { city: 'Slobozia Bradului (Vrancea)', zip: '627305' },
  { city: 'Cornetu (Vrancea)', zip: '627306' },
  { city: 'Coroteni (Vrancea)', zip: '627307' },
  { city: 'Lieşti (Vrancea)', zip: '627308' },
  { city: 'Olăreni (Vrancea)', zip: '627309' },
  { city: 'Valea Beciului (Vrancea)', zip: '627311' },
  { city: 'Slobozia Ciorăşti (Vrancea)', zip: '627315' },
  { city: 'Armeni (Vrancea)', zip: '627316' },
  { city: 'Jilişte (Vrancea)', zip: '627317' },
  { city: 'Soveja (Vrancea)', zip: '627320' },
  { city: 'Dragosloveni (Soveja) (Vrancea)', zip: '627321' },
  { city: 'Rucăreni (Vrancea)', zip: '627322' },
  { city: 'Străoane (Vrancea)', zip: '627325' },
  { city: 'Muncelu (Vrancea)', zip: '627326' },
  { city: 'Repedea (Vrancea)', zip: '627327' },
  { city: 'Văleni (Străoane) (Vrancea)', zip: '627328' },
  { city: 'Suraia (Vrancea)', zip: '627330' },
  { city: 'Bilieşti (Vrancea)', zip: '627331' },
  { city: 'Tănăsoaia (Vrancea)', zip: '627335' },
  { city: 'Călimăneasa (Vrancea)', zip: '627336' },
  { city: 'Costişa (Tănăsoaia) (Vrancea)', zip: '627337' },
  { city: 'Costişa de Sus (Vrancea)', zip: '627338' },
  { city: 'Covrag (Vrancea)', zip: '627339' },
  { city: 'Feldioara (Vrancea)', zip: '627341' },
  { city: 'Galbeni (Vrancea)', zip: '627342' },
  { city: 'Năneşti (Tănăsoaia) (Vrancea)', zip: '627343' },
  { city: 'Vladnicu de Jos (Vrancea)', zip: '627344' },
  { city: 'Vladnicu de Sus (Vrancea)', zip: '627346' },
  { city: 'Tătăranu (Vrancea)', zip: '627350' },
  { city: 'Bordeasca Nouă (Vrancea)', zip: '627351' },
  { city: 'Bordeasca Veche (Vrancea)', zip: '627352' },
  { city: 'Mărtineşti (Vrancea)', zip: '627353' },
  { city: 'Vâjâitoarea (Vrancea)', zip: '627354' },
  { city: 'Tâmboeşti (Vrancea)', zip: '627355' },
  { city: 'Obrejiţa (Vrancea)', zip: '627356' },
  { city: 'Pădureni (Tâmboeşti) (Vrancea)', zip: '627357' },
  { city: 'Pietroasa (Tâmboeşti) (Vrancea)', zip: '627358' },
  { city: 'Slimnic (Vrancea)', zip: '627359' },
  { city: 'Trestieni (Vrancea)', zip: '627361' },
  { city: 'Tulnici (Vrancea)', zip: '627365' },
  { city: 'Coza (Vrancea)', zip: '627366' },
  { city: 'Greşu (Vrancea)', zip: '627367' },
  { city: 'Hăulişca (Vrancea)', zip: '627368' },
  { city: 'Lepşa (Vrancea)', zip: '627369' },
  { city: 'Păuleşti (Vrancea)', zip: '627371' },
  { city: 'Ţifeşti (Vrancea)', zip: '627375' },
  { city: 'Bătineşti (Vrancea)', zip: '627376' },
  { city: 'Clipiceşti (Vrancea)', zip: '627377' },
  { city: 'Igeşti (Vrancea)', zip: '627378' },
  { city: 'Oleşeşti (Vrancea)', zip: '627379' },
  { city: 'Pătrăşcani (Vrancea)', zip: '627381' },
  { city: 'Sârbi (Vrancea)', zip: '627382' },
  { city: 'Vităneşti (Vrancea)', zip: '627383' },
  { city: 'Urecheşti (Vrancea)', zip: '627385' },
  { city: 'Popeşti (Vrancea)', zip: '627386' },
  { city: 'Tercheşti (Vrancea)', zip: '627387' },
  { city: 'Valea Sării (Vrancea)', zip: '627390' },
  { city: 'Colacu (Vrancea)', zip: '627391' },
  { city: 'Mătăcina (Vrancea)', zip: '627392' },
  { city: 'Poduri (Vrancea)', zip: '627393' },
  { city: 'Prisaca (Vrancea)', zip: '627394' },
  { city: 'Vânători (Vrancea)', zip: '627395' },
  { city: 'Balta Raţei (Vrancea)', zip: '627396' },
  { city: 'Jorăşti (Vrancea)', zip: '627397' },
  { city: 'Mirceştii Noi (Vrancea)', zip: '627398' },
  { city: 'Mirceştii Vechi (Vrancea)', zip: '627399' },
  { city: 'Petreşti (Vrancea)', zip: '627401' },
  { city: 'Răduleşti (Vrancea)', zip: '627402' },
  { city: 'Vârteşcoiu (Vrancea)', zip: '627405' },
  { city: 'Beciu (Vrancea)', zip: '627406' },
  { city: 'Faraoanele (Vrancea)', zip: '627407' },
  { city: 'Olteni (Vrancea)', zip: '627408' },
  { city: 'Pietroasa (Vârteşcoiu) (Vrancea)', zip: '627409' },
  { city: 'Râmniceanca (Vrancea)', zip: '627411' },
  { city: 'Vidra (Vrancea)', zip: '627415' },
  { city: 'Burca (Vrancea)', zip: '627416' },
  { city: 'Ireşti (Vrancea)', zip: '627417' },
  { city: 'Ruget (Vrancea)', zip: '627418' },
  { city: 'Scafari (Vrancea)', zip: '627419' },
  { city: 'Şerbeşti (Vrancea)', zip: '627421' },
  { city: 'Tichiriş (Vrancea)', zip: '627422' },
  { city: 'Viişoara (Vidra) (Vrancea)', zip: '627423' },
  { city: 'Voloşcani (Vrancea)', zip: '627424' },
  { city: 'Vintileasca (Vrancea)', zip: '627425' },
  { city: 'Bahnele (Vrancea)', zip: '627426' },
  { city: 'După Măgura (Vrancea)', zip: '627427' },
  { city: 'Neculele (Vrancea)', zip: '627428' },
  { city: 'Poiana Stoichii (Vrancea)', zip: '627429' },
  { city: 'Tănăsari (Vrancea)', zip: '627431' },
  { city: 'Vizantea-Livezi (Vrancea)', zip: '627435' },
  { city: 'Livezile (Vrancea)', zip: '627436' },
  { city: 'Mesteacănu (Vrancea)', zip: '627437' },
  { city: 'Piscu Radului (Vrancea)', zip: '627438' },
  { city: 'Vizantea Mănăstirească (Vrancea)', zip: '627439' },
  { city: 'Vizantea Răzăşească (Vrancea)', zip: '627441' },
  { city: 'Vrâncioaia (Vrancea)', zip: '627445' },
  { city: 'Bodeşti (Vrancea)', zip: '627446' },
  { city: 'Muncei (Vrancea)', zip: '627447' },
  { city: 'Ploştina (Vrancea)', zip: '627448' },
  { city: 'Poiana (Vrancea)', zip: '627449' },
  { city: 'Spineşti (Vrancea)', zip: '627451' },
  { city: 'Vulturu (Vrancea)', zip: '627455' },
  { city: 'Boţârlău (Vrancea)', zip: '627456' },
  { city: 'Hânguleşti (Vrancea)', zip: '627457' },
  { city: 'Maluri (Vrancea)', zip: '627458' },
  { city: 'Vadu Roşca (Vrancea)', zip: '627459' },
  { city: 'Călăraşi (Călăraşi)', zip: '910001' },
  { city: 'Budeşti (Călăraşi)', zip: '915100' },
  { city: 'Aprozi (Călăraşi)', zip: '915101' },
  { city: 'Buciumeni (Călăraşi)', zip: '915102' },
  { city: 'Crivăţ (Călăraşi)', zip: '915103' },
  { city: 'Gruiu (Călăraşi)', zip: '915104' },
  { city: 'Fundulea (Călăraşi)', zip: '915200' },
  { city: 'Alexandru I. Cuza (Călăraşi)', zip: '915201' },
  { city: 'Gostilele (Călăraşi)', zip: '915202' },
  { city: 'Lehliu-Gară (Călăraşi)', zip: '915300' },
  { city: 'Buzoeni (Călăraşi)', zip: '915301' },
  { city: 'Răzvani (Călăraşi)', zip: '915302' },
  { city: 'Valea Seacă (Călăraşi)', zip: '915303' },
  { city: 'Olteniţa (Călăraşi)', zip: '915400' },
  { city: 'Alexandru Odobescu (Călăraşi)', zip: '917005' },
  { city: 'Gălăţui (Călăraşi)', zip: '917006' },
  { city: 'Nicolae Bălcescu (Alexandru Odobescu) (Călăraşi)', zip: '917007' },
  { city: 'Belciugatele (Călăraşi)', zip: '917010' },
  { city: 'Cândeasca (Călăraşi)', zip: '917011' },
  { city: 'Cojeşti (Călăraşi)', zip: '917012' },
  { city: 'Mataraua (Călăraşi)', zip: '917013' },
  { city: 'Măriuţa (Călăraşi)', zip: '917014' },
  { city: 'Borcea (Călăraşi)', zip: '917015' },
  { city: 'Căscioarele (Călăraşi)', zip: '917020' },
  { city: 'Chirnogi (Călăraşi)', zip: '917025' },
  { city: 'Chiselet (Călăraşi)', zip: '917030' },
  { city: 'Ciocăneşti (Călăraşi)', zip: '917035' },
  { city: 'Curcani (Călăraşi)', zip: '917040' },
  { city: 'Sălcioara (Călăraşi)', zip: '917041' },
  { city: 'Cuza Vodă (Călăraşi)', zip: '917045' },
  { city: 'Călăraşii Vechi (Călăraşi)', zip: '917046' },
  { city: 'Ceacu (Călăraşi)', zip: '917047' },
  { city: 'Dichiseni (Călăraşi)', zip: '917050' },
  { city: 'Coslogeni (Călăraşi)', zip: '917051' },
  { city: 'Libertatea (Călăraşi)', zip: '917052' },
  { city: 'Satnoeni (Călăraşi)', zip: '917053' },
  { city: 'Dor Mărunt (Călăraşi)', zip: '917055' },
  { city: 'Dâlga (Călăraşi)', zip: '917056' },
  { city: 'Dâlga-Gară (Călăraşi)', zip: '917057' },
  { city: 'Înfrăţirea (Călăraşi)', zip: '917058' },
  { city: 'Ogoru (Călăraşi)', zip: '917059' },
  { city: 'Pelinu (Călăraşi)', zip: '917061' },
  { city: 'Dorobanţu (Călăraşi)', zip: '917065' },
  { city: 'Boşneagu (Călăraşi)', zip: '917066' },
  { city: 'Vărăşti (Călăraşi)', zip: '917067' },
  { city: 'Dragalina (Călăraşi)', zip: '917080' },
  { city: 'Ciulniţa-Gară (Călăraşi)', zip: '917081' },
  { city: 'Constantin Brâncoveanu (Călăraşi)', zip: '917082' },
  { city: 'Drajna Nouă (Călăraşi)', zip: '917083' },
  { city: 'Dragoş Vodă (Călăraşi)', zip: '917085' },
  { city: 'Bogdana (Călăraşi)', zip: '917086' },
  { city: 'Socoalele (Călăraşi)', zip: '917087' },
  { city: 'Frăsinet (Călăraşi)', zip: '917090' },
  { city: 'Curăteşti (Călăraşi)', zip: '917091' },
  { city: 'Dăneşti (Călăraşi)', zip: '917092' },
  { city: 'Frăsinetu de Jos (Călăraşi)', zip: '917093' },
  { city: 'Luptători (Călăraşi)', zip: '917094' },
  { city: 'Tăriceni (Călăraşi)', zip: '917096' },
  { city: 'Frumuşani (Călăraşi)', zip: '917100' },
  { city: 'Orăşti (Călăraşi)', zip: '917101' },
  { city: 'Pasărea (Călăraşi)', zip: '917102' },
  { city: 'Pădurişu (Călăraşi)', zip: '917103' },
  { city: 'Piţigaia (Călăraşi)', zip: '917104' },
  { city: 'Postăvari (Călăraşi)', zip: '917106' },
  { city: 'Fundeni (Călăraşi)', zip: '917110' },
  { city: 'Grădiştea (Călăraşi)', zip: '917115' },
  { city: 'Bogata (Călăraşi)', zip: '917116' },
  { city: 'Cuneşti (Călăraşi)', zip: '917117' },
  { city: 'Rasa (Călăraşi)', zip: '917118' },
  { city: 'Gurbăneşti (Călăraşi)', zip: '917120' },
  { city: 'Codreni (Călăraşi)', zip: '917121' },
  { city: 'Coţofanca (Călăraşi)', zip: '917122' },
  { city: 'Preasna (Călăraşi)', zip: '917123' },
  { city: 'Preasna Veche (Călăraşi)', zip: '917124' },
  { city: 'Valea Presnei (Călăraşi)', zip: '917126' },
  { city: 'Ileana (Călăraşi)', zip: '917130' },
  { city: 'Arţari (Călăraşi)', zip: '917131' },
  { city: 'Florica (Călăraşi)', zip: '917132' },
  { city: 'Podari (Călăraşi)', zip: '917133' },
  { city: 'Răsurile (Călăraşi)', zip: '917134' },
  { city: 'Răzoarele (Călăraşi)', zip: '917136' },
  { city: 'Satu Nou (Călăraşi)', zip: '917137' },
  { city: 'Ştefăneşti (Călăraşi)', zip: '917138' },
  { city: 'Vlăiculeşti (Călăraşi)', zip: '917139' },
  { city: 'Independenţa (Călăraşi)', zip: '917140' },
  { city: 'Potcoava (Călăraşi)', zip: '917141' },
  { city: 'Vişinii (Călăraşi)', zip: '917142' },
  { city: 'Jegălia (Călăraşi)', zip: '917145' },
  { city: 'Gâldău (Călăraşi)', zip: '917146' },
  { city: 'Iezeru (Călăraşi)', zip: '917147' },
  { city: 'Lehliu (Călăraşi)', zip: '917150' },
  { city: 'Săpunari (Călăraşi)', zip: '917151' },
  { city: 'Luica (Călăraşi)', zip: '917155' },
  { city: 'Valea Stânii (Călăraşi)', zip: '917156' },
  { city: 'Lupşanu (Călăraşi)', zip: '917160' },
  { city: 'Nucetu (Călăraşi)', zip: '917161' },
  { city: 'Plevna (Călăraşi)', zip: '917162' },
  { city: 'Valea Rusului (Călăraşi)', zip: '917163' },
  { city: 'Radu Vodă (Călăraşi)', zip: '917165' },
  { city: 'Mânăstirea (Călăraşi)', zip: '917170' },
  { city: 'Coconi (Călăraşi)', zip: '917171' },
  { city: 'Sultana (Călăraşi)', zip: '917172' },
  { city: 'Mitreni (Călăraşi)', zip: '917175' },
  { city: 'Clăteşti (Călăraşi)', zip: '917176' },
  { city: 'Valea Roşie (Călăraşi)', zip: '917177' },
  { city: 'Modelu (Călăraşi)', zip: '917180' },
  { city: 'Radu Negru (Călăraşi)', zip: '917181' },
  { city: 'Stoeneşti (Călăraşi)', zip: '917182' },
  { city: 'Tonea (Călăraşi)', zip: '917183' },
  { city: 'Nana (Călăraşi)', zip: '917185' },
  { city: 'Nicolae Bălcescu (Călăraşi)', zip: '917190' },
  { city: 'Fântâna Doamnei (Călăraşi)', zip: '917191' },
  { city: 'Paicu (Călăraşi)', zip: '917192' },
  { city: 'Perişoru (Călăraşi)', zip: '917195' },
  { city: 'Mărculeşti-Gară (Călăraşi)', zip: '917196' },
  { city: 'Tudor Vladimirescu (Călăraşi)', zip: '917197' },
  { city: 'Plătăreşti (Călăraşi)', zip: '917200' },
  { city: 'Cucuieţi (Călăraşi)', zip: '917201' },
  { city: 'Dorobanţu (Plătăreşti) (Călăraşi)', zip: '917202' },
  { city: 'Podu Pitarului (Călăraşi)', zip: '917203' },
  { city: 'Radovanu (Călăraşi)', zip: '917205' },
  { city: 'Valea Popii (Călăraşi)', zip: '917206' },
  { city: 'Roseţi (Călăraşi)', zip: '917210' },
  { city: 'Săruleşti (Călăraşi)', zip: '917215' },
  { city: 'Măgureni (Călăraşi)', zip: '917216' },
  { city: 'Polceşti (Călăraşi)', zip: '917217' },
  { city: 'Sănduliţa (Călăraşi)', zip: '917218' },
  { city: 'Săruleşti-Gară (Călăraşi)', zip: '917219' },
  { city: 'Sătucu (Călăraşi)', zip: '917221' },
  { city: 'Solacolu (Călăraşi)', zip: '917222' },
  { city: 'Sohatu (Călăraşi)', zip: '917225' },
  { city: 'Progresu (Călăraşi)', zip: '917226' },
  { city: 'Spanţov (Călăraşi)', zip: '917230' },
  { city: 'Cetatea Veche (Călăraşi)', zip: '917231' },
  { city: 'Stancea (Călăraşi)', zip: '917232' },
  { city: 'Şoldanu (Călăraşi)', zip: '917235' },
  { city: 'Negoeşti (Călăraşi)', zip: '917236' },
  { city: 'Ştefan Vodă (Călăraşi)', zip: '917240' },
  { city: 'Ştefan cel Mare (Călăraşi)', zip: '917245' },
  { city: 'Tămădău Mare (Călăraşi)', zip: '917250' },
  { city: 'Călăreţi (Călăraşi)', zip: '917251' },
  { city: 'Dârvari (Călăraşi)', zip: '917252' },
  { city: 'Plumbuita (Călăraşi)', zip: '917253' },
  { city: 'Săcele (Călăraşi)', zip: '917254' },
  { city: 'Şeinoiu (Călăraşi)', zip: '917256' },
  { city: 'Tămădău Mic (Călăraşi)', zip: '917257' },
  { city: 'Ulmeni (Călăraşi)', zip: '917260' },
  { city: 'Ulmu (Călăraşi)', zip: '917265' },
  { city: 'Chirnogi (Ulmu) (Călăraşi)', zip: '917266' },
  { city: 'Făurei (Călăraşi)', zip: '917267' },
  { city: 'Zimbru (Călăraşi)', zip: '917268' },
  { city: 'Unirea (Călăraşi)', zip: '917270' },
  { city: 'Oltina (Călăraşi)', zip: '917271' },
  { city: 'Valea Argovei (Călăraşi)', zip: '917275' },
  { city: 'Lunca (Călăraşi)', zip: '917276' },
  { city: 'Ostrovu (Călăraşi)', zip: '917277' },
  { city: 'Siliştea (Călăraşi)', zip: '917278' },
  { city: 'Vlădiceasca (Călăraşi)', zip: '917279' },
  { city: 'Vasilaţi (Călăraşi)', zip: '917280' },
  { city: 'Nuci (Călăraşi)', zip: '917281' },
  { city: 'Popeşti (Călăraşi)', zip: '917282' },
  { city: 'Gălbinaşi (Călăraşi)', zip: '917285' },
  { city: 'Vâlcelele (Călăraşi)', zip: '917290' },
  { city: 'Floroaica (Călăraşi)', zip: '917291' },
  { city: 'Vlad Ţepeş (Călăraşi)', zip: '917295' },
  { city: 'Mihai Viteazu (Călăraşi)', zip: '917296' },
  { city: 'Giurgiu (Giurgiu)', zip: '80011' },
  { city: 'Bolintin-Vale (Giurgiu)', zip: '85100' },
  { city: 'Crivina (Giurgiu)', zip: '85101' },
  { city: 'Malu Spart (Giurgiu)', zip: '85102' },
  { city: 'Suseni (Giurgiu)', zip: '85103' },
  { city: 'Mihăileşti (Giurgiu)', zip: '85200' },
  { city: 'Drăgănescu (Giurgiu)', zip: '85201' },
  { city: 'Novaci (Giurgiu)', zip: '85202' },
  { city: 'Popeşti (Giurgiu)', zip: '85203' },
  { city: 'Adunaţii-Copăceni (Giurgiu)', zip: '87005' },
  { city: 'Dărăşti-Vlaşca (Giurgiu)', zip: '87006' },
  { city: 'Mogoşeşti (Giurgiu)', zip: '87007' },
  { city: 'Varlaam (Giurgiu)', zip: '87008' },
  { city: 'Băneasa (Giurgiu)', zip: '87010' },
  { city: 'Frasinu (Giurgiu)', zip: '87011' },
  { city: 'Pietrele (Giurgiu)', zip: '87012' },
  { city: 'Sfântu Gheorghe (Băneasa) (Giurgiu)', zip: '87013' },
  { city: 'Bolintin-Deal (Giurgiu)', zip: '87015' },
  { city: 'Mihai Vodă (Giurgiu)', zip: '87016' },
  { city: 'Bucşani (Giurgiu)', zip: '87020' },
  { city: 'Angheleşti (Giurgiu)', zip: '87021' },
  { city: 'Goleasca (Giurgiu)', zip: '87022' },
  { city: 'Obedeni (Giurgiu)', zip: '87023' },
  { city: 'Podişor (Giurgiu)', zip: '87024' },
  { city: 'Uieşti (Giurgiu)', zip: '87026' },
  { city: 'Vadu Lat (Giurgiu)', zip: '87027' },
  { city: 'Bulbucata (Giurgiu)', zip: '87030' },
  { city: 'Coteni (Giurgiu)', zip: '87031' },
  { city: 'Făcău (Giurgiu)', zip: '87032' },
  { city: 'Teişori (Giurgiu)', zip: '87033' },
  { city: 'Buturugeni (Giurgiu)', zip: '87035' },
  { city: 'Pădureni (Giurgiu)', zip: '87036' },
  { city: 'Podu Ilfovăţului (Giurgiu)', zip: '87037' },
  { city: 'Poşta (Giurgiu)', zip: '87038' },
  { city: 'Călugăreni (Giurgiu)', zip: '87040' },
  { city: 'Brăniştari (Giurgiu)', zip: '87041' },
  { city: 'Crucea de Piatră (Giurgiu)', zip: '87042' },
  { city: 'Hulubeşti (Giurgiu)', zip: '87043' },
  { city: 'Uzunu (Giurgiu)', zip: '87044' },
  { city: 'Clejani (Giurgiu)', zip: '87045' },
  { city: 'Neajlovu (Giurgiu)', zip: '87046' },
  { city: 'Podu Doamnei (Giurgiu)', zip: '87047' },
  { city: 'Sterea (Giurgiu)', zip: '87048' },
  { city: 'Colibaşi (Giurgiu)', zip: '87050' },
  { city: 'Câmpurelu (Giurgiu)', zip: '87051' },
  { city: 'Comana (Giurgiu)', zip: '87055' },
  { city: 'Budeni (Giurgiu)', zip: '87056' },
  { city: 'Falaştoaca (Giurgiu)', zip: '87057' },
  { city: 'Grădiştea (Giurgiu)', zip: '87058' },
  { city: 'Vlad Ţepeş (Giurgiu)', zip: '87059' },
  { city: 'Crevedia Mare (Giurgiu)', zip: '87060' },
  { city: 'Crevedia Mică (Giurgiu)', zip: '87061' },
  { city: 'Dealu (Giurgiu)', zip: '87062' },
  { city: 'Găiseanca (Giurgiu)', zip: '87063' },
  { city: 'Priboiu (Giurgiu)', zip: '87064' },
  { city: 'Sfântu Gheorghe (Crevedia Mare) (Giurgiu)', zip: '87066' },
  { city: 'Daia (Giurgiu)', zip: '87070' },
  { city: 'Plopşoru (Giurgiu)', zip: '87071' },
  { city: 'Floreşti-Stoeneşti (Giurgiu)', zip: '87075' },
  { city: 'Floreşti (Giurgiu)', zip: '87076' },
  { city: 'Palanca (Giurgiu)', zip: '87077' },
  { city: 'Stoeneşti (Floreşti-Stoeneşti) (Giurgiu)', zip: '87078' },
  { city: 'Frăteşti (Giurgiu)', zip: '87080' },
  { city: 'Cetatea (Giurgiu)', zip: '87081' },
  { city: 'Remuş (Giurgiu)', zip: '87082' },
  { city: 'Găiseni (Giurgiu)', zip: '87085' },
  { city: 'Cărpenişu (Giurgiu)', zip: '87086' },
  { city: 'Căscioarele (Găiseni) (Giurgiu)', zip: '87087' },
  { city: 'Podu Popa Nae (Giurgiu)', zip: '87088' },
  { city: 'Găujani (Giurgiu)', zip: '87090' },
  { city: 'Cetăţuia (Giurgiu)', zip: '87091' },
  { city: 'Pietrişu (Giurgiu)', zip: '87092' },
  { city: 'Ghimpaţi (Giurgiu)', zip: '87095' },
  { city: 'Copaciu (Giurgiu)', zip: '87096' },
  { city: 'Naipu (Giurgiu)', zip: '87097' },
  { city: 'Valea Plopilor (Giurgiu)', zip: '87098' },
  { city: 'Gogoşari (Giurgiu)', zip: '87100' },
  { city: 'Drăghiceanu (Giurgiu)', zip: '87101' },
  { city: 'Izvoru (Gogoşari) (Giurgiu)', zip: '87102' },
  { city: 'Răleşti (Giurgiu)', zip: '87103' },
  { city: 'Gostinari (Giurgiu)', zip: '87105' },
  { city: 'Mironeşti (Giurgiu)', zip: '87106' },
  { city: 'Gostinu (Giurgiu)', zip: '87110' },
  { city: 'Grădinari (Giurgiu)', zip: '87115' },
  { city: 'Tântava (Giurgiu)', zip: '87116' },
  { city: 'Zorile (Giurgiu)', zip: '87117' },
  { city: 'Greaca (Giurgiu)', zip: '87120' },
  { city: 'Puţu Greci (Giurgiu)', zip: '87121' },
  { city: 'Zboiu (Giurgiu)', zip: '87122' },
  { city: 'Hotarele (Giurgiu)', zip: '87125' },
  { city: 'Herăşti (Giurgiu)', zip: '87126' },
  { city: 'Isvoarele (Giurgiu)', zip: '87127' },
  { city: 'Miloşeşti (Giurgiu)', zip: '87128' },
  { city: 'Teiuşu (Giurgiu)', zip: '87129' },
  { city: 'Iepureşti (Giurgiu)', zip: '87130' },
  { city: 'Băneşti (Giurgiu)', zip: '87131' },
  { city: 'Chirculeşti (Giurgiu)', zip: '87132' },
  { city: 'Gorneni (Giurgiu)', zip: '87133' },
  { city: 'Stâlpu (Giurgiu)', zip: '87134' },
  { city: 'Valter Mărăcineanu (Giurgiu)', zip: '87136' },
  { city: 'Izvoarele (Giurgiu)', zip: '87140' },
  { city: 'Chiriacu (Giurgiu)', zip: '87141' },
  { city: 'Dimitrie Cantemir (Giurgiu)', zip: '87142' },
  { city: 'Petru Rareş (Giurgiu)', zip: '87143' },
  { city: 'Radu Vodă (Giurgiu)', zip: '87144' },
  { city: 'Valea Bujorului (Giurgiu)', zip: '87146' },
  { city: 'Joiţa (Giurgiu)', zip: '87150' },
  { city: 'Bâcu (Giurgiu)', zip: '87151' },
  { city: 'Cosoba (Giurgiu)', zip: '87152' },
  { city: 'Săbăreni (Giurgiu)', zip: '87153' },
  { city: 'Letca Nouă (Giurgiu)', zip: '87155' },
  { city: 'Letca Veche (Giurgiu)', zip: '87156' },
  { city: 'Milcovăţu (Giurgiu)', zip: '87157' },
  { city: 'Mârşa (Giurgiu)', zip: '87160' },
  { city: 'Mihai Bravu (Giurgiu)', zip: '87165' },
  { city: 'Ogrezeni (Giurgiu)', zip: '87170' },
  { city: 'Hobaia (Giurgiu)', zip: '87171' },
  { city: 'Oinacu (Giurgiu)', zip: '87175' },
  { city: 'Braniştea (Giurgiu)', zip: '87176' },
  { city: 'Comasca (Giurgiu)', zip: '87177' },
  { city: 'Prundu (Giurgiu)', zip: '87180' },
  { city: 'Puieni (Giurgiu)', zip: '87181' },
  { city: 'Putineiu (Giurgiu)', zip: '87185' },
  { city: 'Hodivoaia (Giurgiu)', zip: '87186' },
  { city: 'Vieru (Giurgiu)', zip: '87187' },
  { city: 'Răsuceni (Giurgiu)', zip: '87190' },
  { city: 'Carapancea (Giurgiu)', zip: '87191' },
  { city: 'Cucuruzu (Giurgiu)', zip: '87192' },
  { city: 'Satu Nou (Giurgiu)', zip: '87193' },
  { city: 'Roata de Jos (Giurgiu)', zip: '87195' },
  { city: 'Cartojani (Giurgiu)', zip: '87196' },
  { city: 'Roata Mică (Giurgiu)', zip: '87197' },
  { city: 'Sadina (Giurgiu)', zip: '87198' },
  { city: 'Schitu (Giurgiu)', zip: '87200' },
  { city: 'Bila (Giurgiu)', zip: '87201' },
  { city: 'Cămineasca (Giurgiu)', zip: '87202' },
  { city: 'Vlaşin (Giurgiu)', zip: '87203' },
  { city: 'Singureni (Giurgiu)', zip: '87205' },
  { city: 'Crânguri (Giurgiu)', zip: '87206' },
  { city: 'Stejaru (Giurgiu)', zip: '87207' },
  { city: 'Slobozia (Giurgiu)', zip: '87210' },
  { city: 'Stăneşti (Giurgiu)', zip: '87215' },
  { city: 'Bălanu (Giurgiu)', zip: '87216' },
  { city: 'Ghizdaru (Giurgiu)', zip: '87217' },
  { city: 'Onceşti (Giurgiu)', zip: '87218' },
  { city: 'Stoeneşti (Giurgiu)', zip: '87220' },
  { city: 'Ianculeşti (Giurgiu)', zip: '87221' },
  { city: 'Mirău (Giurgiu)', zip: '87222' },
  { city: 'Toporu (Giurgiu)', zip: '87225' },
  { city: 'Tomuleşti (Giurgiu)', zip: '87226' },
  { city: 'Ulmi (Giurgiu)', zip: '87230' },
  { city: 'Căscioarele (Ulmi) (Giurgiu)', zip: '87231' },
  { city: 'Drăgăneasca (Giurgiu)', zip: '87232' },
  { city: 'Ghionea (Giurgiu)', zip: '87233' },
  { city: 'Icoana (Giurgiu)', zip: '87234' },
  { city: 'Moşteni (Giurgiu)', zip: '87236' },
  { city: 'Poenari (Giurgiu)', zip: '87237' },
  { city: 'Trestieni (Giurgiu)', zip: '87238' },
  { city: 'Valea Dragului (Giurgiu)', zip: '87240' },
  { city: 'Vărăşti (Giurgiu)', zip: '87245' },
  { city: 'Dobreni (Giurgiu)', zip: '87246' },
  { city: 'Vânătorii Mici (Giurgiu)', zip: '87250' },
  { city: 'Corbeanca (Giurgiu)', zip: '87251' },
  { city: 'Cupele (Giurgiu)', zip: '87252' },
  { city: 'Izvoru (Vânătorii Mici) (Giurgiu)', zip: '87253' },
  { city: 'Poiana lui Stângă (Giurgiu)', zip: '87254' },
  { city: 'Vâlcelele (Giurgiu)', zip: '87256' },
  { city: 'Vânătorii Mari (Giurgiu)', zip: '87257' },
  { city: 'Zădăriciu (Giurgiu)', zip: '87258' },
  { city: 'Vedea (Giurgiu)', zip: '87260' },
  { city: 'Malu (Giurgiu)', zip: '87261' },
  { city: 'Buftea (Ilfov)', zip: '70000' },
  { city: 'Buciumeni (Ilfov)', zip: '70001' },
  { city: 'Otopeni (Ilfov)', zip: '75100' },
  { city: 'Odăile (Ilfov)', zip: '75101' },
  { city: '1 Decembrie (Ilfov)', zip: '77005' },
  { city: 'Copăceni (Ilfov)', zip: '77006' },
  { city: 'Afumaţi (Ilfov)', zip: '77010' },
  { city: 'Baloteşti (Ilfov)', zip: '77015' },
  { city: 'Dumbrăveni (Ilfov)', zip: '77016' },
  { city: 'Săftica (Ilfov)', zip: '77017' },
  { city: 'Berceni (Ilfov)', zip: '77020' },
  { city: 'Bragadiru (Ilfov)', zip: '77025' },
  { city: 'Brăneşti (Ilfov)', zip: '77030' },
  { city: 'Islaz (Ilfov)', zip: '77031' },
  { city: 'Pasărea (Ilfov)', zip: '77032' },
  { city: 'Vadu Anei (Ilfov)', zip: '77033' },
  { city: 'Cernica (Ilfov)', zip: '77035' },
  { city: 'Bălăceanca (Ilfov)', zip: '77036' },
  { city: 'Căldăraru (Ilfov)', zip: '77037' },
  { city: 'Poşta (Ilfov)', zip: '77038' },
  { city: 'Tânganu (Ilfov)', zip: '77039' },
  { city: 'Chiajna (Ilfov)', zip: '77040' },
  { city: 'Dudu (Ilfov)', zip: '77041' },
  { city: 'Roşu (Ilfov)', zip: '77042' },
  { city: 'Chitila (Ilfov)', zip: '77045' },
  { city: 'Rudeni (Ilfov)', zip: '77046' },
  { city: 'Ciolpani (Ilfov)', zip: '77050' },
  { city: 'Izvorani (Ilfov)', zip: '77051' },
  { city: 'Lupăria (Ilfov)', zip: '77052' },
  { city: 'Piscu (Ilfov)', zip: '77053' },
  { city: 'Ciorogârla (Ilfov)', zip: '77055' },
  { city: 'Dârvari (Ilfov)', zip: '77056' },
  { city: 'Clinceni (Ilfov)', zip: '77060' },
  { city: 'Olteni (Ilfov)', zip: '77061' },
  { city: 'Ordoreanu (Ilfov)', zip: '77062' },
  { city: 'Corbeanca (Ilfov)', zip: '77065' },
  { city: 'Ostratu (Ilfov)', zip: '77066' },
  { city: 'Petreşti (Ilfov)', zip: '77067' },
  { city: 'Tamaşi (Ilfov)', zip: '77068' },
  { city: 'Cornetu (Ilfov)', zip: '77070' },
  { city: 'Buda (Ilfov)', zip: '77071' },
  { city: 'Dascălu (Ilfov)', zip: '77075' },
  { city: 'Creaţa (Ilfov)', zip: '77076' },
  { city: 'Gagu (Ilfov)', zip: '77077' },
  { city: 'Runcu (Ilfov)', zip: '77078' },
  { city: 'Dărăşti-Ilfov (Ilfov)', zip: '77080' },
  { city: 'Dobroeşti (Ilfov)', zip: '77085' },
  { city: 'Fundeni (Ilfov)', zip: '77086' },
  { city: 'Domneşti (Ilfov)', zip: '77090' },
  { city: 'Ţegheş (Ilfov)', zip: '77091' },
  { city: 'Dragomireşti-Vale (Ilfov)', zip: '77095' },
  { city: 'Dragomireşti-Deal (Ilfov)', zip: '77096' },
  { city: 'Zurbaua (Ilfov)', zip: '77097' },
  { city: 'Găneasa (Ilfov)', zip: '77100' },
  { city: 'Cozieni (Ilfov)', zip: '77101' },
  { city: 'Moara Domnească (Ilfov)', zip: '77102' },
  { city: 'Piteasca (Ilfov)', zip: '77103' },
  { city: 'Şindriliţa (Ilfov)', zip: '77104' },
  { city: 'Glina (Ilfov)', zip: '77105' },
  { city: 'Căţelu (Ilfov)', zip: '77106' },
  { city: 'Manolache (Ilfov)', zip: '77107' },
  { city: 'Grădiştea (Ilfov)', zip: '77110' },
  { city: 'Sitaru (Ilfov)', zip: '77111' },
  { city: 'Gruiu (Ilfov)', zip: '77115' },
  { city: 'Lipia (Ilfov)', zip: '77116' },
  { city: 'Siliştea Snagovului (Ilfov)', zip: '77117' },
  { city: 'Şanţu-Floreşti (Ilfov)', zip: '77118' },
  { city: 'Jilava (Ilfov)', zip: '77120' },
  { city: 'Măgurele (Ilfov)', zip: '77125' },
  { city: 'Alunişu (Ilfov)', zip: '77126' },
  { city: 'Dumitrana (Ilfov)', zip: '77127' },
  { city: 'Pruni (Ilfov)', zip: '77128' },
  { city: 'Vârteju (Ilfov)', zip: '77129' },
  { city: 'Moara Vlăsiei (Ilfov)', zip: '77130' },
  { city: 'Căciulaţi (Ilfov)', zip: '77131' },
  { city: 'Mogoşoaia (Ilfov)', zip: '77135' },
  { city: 'Nuci (Ilfov)', zip: '77140' },
  { city: 'Balta Neagră (Ilfov)', zip: '77141' },
  { city: 'Merii Petchii (Ilfov)', zip: '77142' },
  { city: 'Micşuneşti-Moară (Ilfov)', zip: '77143' },
  { city: 'Micşuneştii Mari (Ilfov)', zip: '77144' },
  { city: 'Pantelimon (Ilfov)', zip: '77145' },
  { city: 'Periş (Ilfov)', zip: '77150' },
  { city: 'Bălteni (Ilfov)', zip: '77151' },
  { city: 'Buriaş (Ilfov)', zip: '77152' },
  { city: 'Petrăchioaia (Ilfov)', zip: '77155' },
  { city: 'Măineasca (Ilfov)', zip: '77156' },
  { city: 'Surlari (Ilfov)', zip: '77157' },
  { city: 'Vânători (Ilfov)', zip: '77158' },
  { city: 'Popeşti-Leordeni (Ilfov)', zip: '77160' },
  { city: 'Snagov (Ilfov)', zip: '77165' },
  { city: 'Ciofliceni (Ilfov)', zip: '77166' },
  { city: 'Tâncăbeşti (Ilfov)', zip: '77167' },
  { city: 'Vlădiceasca (Ilfov)', zip: '77168' },
  { city: 'Ghermăneşti (Ilfov)', zip: '77170' },
  { city: 'Ştefăneştii de Jos (Ilfov)', zip: '77175' },
  { city: 'Creţuleasca (Ilfov)', zip: '77176' },
  { city: 'Ştefăneştii de Sus (Ilfov)', zip: '77177' },
  { city: 'Tunari (Ilfov)', zip: '77180' },
  { city: 'Dimieni (Ilfov)', zip: '77181' },
  { city: 'Vidra (Ilfov)', zip: '77185' },
  { city: 'Creţeşti (Ilfov)', zip: '77186' },
  { city: 'Sinteşti (Ilfov)', zip: '77187' },
  { city: 'Voluntari (Ilfov)', zip: '77190' },
  { city: 'Pipera (Voluntari) (Ilfov)', zip: '77191' },
];
